
// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\core\dev\node_modules\js-libs-web\js\js-libs.js
const jsLibs_Class = (() => { 'use strict';


class JSLibs
{

    get Require()
    { let self = this;
        return Require;
    }


    constructor()
    { let self = this;
        self._packages = {};
    }

    exists(packageName)
    {
        return packageName in self._packages;
    }

    exportModule(packageName, modulePath, moduleInitFn)
    { let self = this;
        if (!(packageName in self._packages))
            self._packages[packageName] = new Package(self, packageName);

        self._packages[packageName].addModule(modulePath, moduleInitFn);
    }

    importModule(packageName, modulePath)
    { let self = this;
        if (!(packageName in self._packages)) {
            throw new Error('Package `' + packageName + '` does not exist.');
        }

        return self._packages[packageName].importModule(modulePath);
    }

    require(packageName)
    { let self = this;
        let module = self.importModule(packageName, 'index');
        if (module === Module.DoesNotExist) {
            throw new Error('Module `' + packageName + '` (`' +
                    packageName + ':' + 'index' +
                    '`) does not exist.');
        }

        return module;
    }


    _parsePackagePath(package_path)
    { let self = this;
        return package_path;
    }

}


class Module
{

    get instanceModule()
    { let self = this;
        if (self._instanceModule === null) {
            let require = new Require(self._package.jsLibs, self._package.name,
                    self._path);
            self._instanceModule = {
                exports: {}, // Module.ExportNotImplemented,
            };

            self._initFn(require.fn, self._instanceModule, self._instanceModule.exports);

            if (self._instanceModule.exports === Module.ExportNotImplemented) {
                console.log(self._instanceModule);
                throw new Error('No `exports` found in module `' +
                        self._package.name + '/' + self._path + '`.');
            }
        }

        return self._instanceModule;
    }


    constructor(js_lib_package, modulePath, init_fn)
    { let self = this;
        self._package = js_lib_package;
        self._path = modulePath;
        self._initFn = init_fn;

        self._instanceModule = null;
    }

}
Object.defineProperties(Module, {

    DoesNotExists: { value:
    new class Module_DoesNotExist {

    }()},

    ExportNotImplemented: { value: {}, },

});


class Package
{

    constructor(jsLibs, packageName)
    { let self = this;
        self.jsLibs = jsLibs;
        self.name = packageName;

        self._modules = {};
    }

    addModule(modulePath, moduleInitFn)
    { let self = this;
        self._modules[modulePath] = new Module(self, modulePath, moduleInitFn);
    }

    importModule(modulePath)
    { let self = this;
        if (modulePath in self._modules)
            return self._modules[modulePath].instanceModule.exports;

        modulePath += '/index';
        if (modulePath in self._modules)
            return self._modules[modulePath].instanceModule.exports;

        return Module.DoesNotExist;
    }

}


class Require
{

    get fn()
    { let self = this;
        return self._fn;
    }


    constructor(jsLibs, packageName = null, current_path = null)
    { let self = this;
        self._packageName = packageName;
        self._currentPath_Array = null;

        self._fn = (import_path) => {
            let import_info = self._resolveImportInfo(import_path);

            let module = jsLibs.importModule(import_info.packageName,
                    import_info.modulePath);
            if (module === Module.DoesNotExist) {
                throw new Error('Module `' + import_path + '` (`' +
                        import_info.packageName + ':' + import_info.modulePath +
                        '`) does not exist.');
            }

            return module;
        };

        if (current_path !== null) {
            self._currentPath_Array = current_path.split('/');
            self._currentPath_Array.pop();
        }
    }


    _resolveImportInfo(import_path)
    { let self = this;
        let import_path_array = import_path.split('/');

        /* Import Package */
        if (import_path_array[0] !== '.' && import_path_array[0] !== '..') {
            return {
                packageName: import_path_array[0],
                modulePath: 'index',
            };
        }

        if (self._packageName === null)
            throw new Error('Cannot import module outside of package.');

        /* Import Module */
        let modulePath_array = self._currentPath_Array.slice();

        for (let i = 0; i < import_path_array.length; i++) {
            if (import_path_array[i] === '.')
                continue;

            if (import_path_array[i] === '..') {
                modulePath_array.pop();
                continue;
            }

            modulePath_array.push(import_path_array[i]);
        }

        if (modulePath_array.length === 0)
            modulePath_array.push('index');
        else if (modulePath_array[modulePath_array.length - 1] === '')
            modulePath_array[modulePath_array.length - 1] = 'index';

        return {
            packageName: self._packageName,
            modulePath: modulePath_array.join('/'),
        };
    }

}


return JSLibs;

})();

const jsLibs = new jsLibs_Class();
// const require = (new jsLibs.Require(jsLibs)).fn;


// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\core\Actions.js
jsLibs.exportModule('core', 'Actions', (require, module, exports) => { 'use strict';

const
    js0 = require('js0')
;

class Actions {

    async init_Async() {
        return js0.rtn(js0.Preset({
            appInfo: [ js0.RawObject, js0.Null ],
            appVersion: 'string',
            fields: js0.RawObject,
            user: js0.RawObject,
            deviceInfo: js0.RawObject,
        }), await this.__init_Async());
    }

    async logIn_Async(login, password) {
        js0.args(arguments, 'string', 'string');

        return js0.rtn(js0.Preset({
            data: [ js0.Preset({
                appInfo: [ js0.RawObject, js0.Null ],
                user: [ js0.Preset({
                    info: [ js0.RawObject, js0.Null ],
                    info_Client: [ js0.RawObject, js0.Null ],
                    permissions: Array,
                }) ],
            }), js0.Null ],
            error: [ 'string', js0.Null ],
        }), await this.__logIn_Async(login, password));
    }

    async logOut_Async() {
        js0.args(arguments);

        return js0.rtn(js0.Preset({
            success: 'boolean',
            error: [ 'string', js0.Null ],
        }), await this.__logOut_Async());
    }


    async __init_Async() { js0.virtual(this); }
    async __logIn_Async(login, password) { js0.virtual(this); }
    async __logOut_Async() { js0.virtual(this); }

}

module.exports = Actions;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\core\App.js
jsLibs.exportModule('core', 'App', (require, module, exports) => { 'use strict';

const
    abData = require('ab-data'),
    abDate = require('ab-date'),
    abText = require('ab-text'),
    js0 = require('js0'),
    spkTables = require('spk-tables'),
    webABApi = require('web-ab-api')
;

class App {

    static get ApiVersion() {
        return 3;
    }

    static get Base() {
        return abNative_Base;
    }

    static get ConnectionTestTimeout() {
        return 5000;
    }

    static get ConnectionTimeout() {
        return 60000;
    }

    static get Platform() {
        if (abNative_Platform === 'web')  
            return 'web';

        if (abNative_Platform === 'android' || abNative_Platform === 'android_dev')
            return 'native';

        if (abNative_Platform === 'ios' || abNative_Platform === 'ios_dev')
            return 'native';
    }

    static GetInstance() {
        if (App._Instance === null)
            throw new Error('App instance not created.');
        
        return App._Instance;
    }


    get appInfo() {
        if (this._appInfo === null)
            throw new Error('App not initialized.');

        return this._appInfo;
    }

    get ds() {
        return this.dataStore;
    }

    get fields() {
        if (this._fields === null)
            throw new Error('App not initialized.');

        return this._fields;
    }

    get isLocked() {
        return this._locked;
    }

    get isOfflineModeActive() {
        return this._offlineMode;
    }

    get mMain() { 
        if (this._mMain === null)
            throw new Error('App not initialized.');

        return this._mMain;
    }

    constructor(mMain) {
        js0.args(arguments, require('./Main'));

        if (App._Instance !== null)
            throw new Error('App instance already created.');
        
        App._Instance = this;

        this.appVersion = '-';

        this.apiVersion = 1;
        this.apiUri = abNative_ApiUri + 'api/v1/';

        this.dataScheme = null;
        this.dataStore = null;
        this.native = null;

        this._mMain = mMain;
        this._appInfo = null;
        this._fields = null;

        this._offlineMode = false;
        this._testConnectionResult = null;

        this._locked = false;

        this.loadTexts();

        this._create_DataScheme();

        if (App.Platform === 'web')
            this.native = require('web-app');
        else if (App.Platform === 'native')
            this.native = require('native-app');
    }

    async clearData_Async(syncDB = true, clearDataStore = true, 
            transactionId = null) {
        js0.args(arguments, [ 'boolean', js0.Default ], [ 'boolean', 
                js0.Default ], [ 'int', js0.Null, js0.Default ]);

        let db = this.native.db;

        let localTransaction = false;
        if (transactionId === null) {
            transactionId = await db.transaction_Start_Async();
            localTransaction = true;
        }

        if (clearDataStore)
            await this.ds.clearData_Async(transactionId);

        await this.dataScheme.getTable('Sys_Bulls').delete_Async(db, {},
                transactionId);
        await this.dataScheme.getTable('Sys_ClientBulls').delete_Async(db, {},
                transactionId);
        await this.dataScheme.getTable('Sys_Clients').delete_Async(db, {},
                transactionId);
        await this.dataScheme.getTable('Sys_Cows').delete_Async(db, {},
                transactionId);
        await this.dataScheme.getTable('Sys_Farmers').delete_Async(db, {},
                transactionId);
        await this.dataScheme.getTable('Sys_Receipts').delete_Async(db, {},
                transactionId);
        
        if (syncDB && this.dataStore !== null) {
            let rAppInfo = await this.dataScheme.getT('_Native_Settings')
                    .row_Async(db, {
                where: [ 'Name', '=', 'appInfo' ],
            }, transactionId);

            let syncDB_Response = await this.dataStore.syncDB_Async({
                apiVersion: App.ApiVersion,
                appInfo: rAppInfo === null ? null : rAppInfo.Data.value,
            }, async () => {
                await this.clearData_Async(false, false, transactionId);
            }, transactionId);

            if (syncDB_Response.type !== abData.Response.Types_Success) {
                await db.transaction_Finish_Async(false, transactionId);

                throw new Error(abText.$('Sys:Errors_CannotSynchronizeData', { 
                            error: syncDB_Response.errorMessage }));
            }
        }

        if (localTransaction)
            await db.transaction_Finish_Async(true, transactionId);
    }

    createDataStore(deviceInfo) {
        js0.args(arguments, js0.RawObject);

        this.dataStore = null;

        let rp = null;
        if (App.Platform === 'web') {
            let device = new abData.Device(deviceInfo.deviceId, 
                    deviceInfo.deviceHash, deviceInfo.lastUpdate, 
                    deviceInfo.lastItemId, []);
            rp = new abData.RequestProcessor_Web(this.dataScheme, device, 
                    abNative_ApiUri + 'api/v1/ab-data/');

            this.dataStore = new abData.DataStore(rp);
        } else if (App.Platform === 'native') {
            let device = new abData.native.NativeDevice(deviceInfo.deviceId, 
                    deviceInfo.deviceHash, deviceInfo.lastUpdate, 
                    deviceInfo.lastItemId, []);
            rp = new abData.RequestProcessor_Native(this.dataScheme, 
                    device, this.native.db);

            this.dataStore = new this.native.NativeAppDataStore(rp, 
                    abNative_ApiUri + 'api/v1/ab-data/');
        } else
            throw new Error('Unknown platform.');

        if (App.Platform === 'web') {
            let refreshDevice = () => {
                setTimeout(() => {
                    this.dataStore.requestB_Async([])
                        .catch((err) => {
                            console.error(err);
                            this.mMain.msgs.showMessage_Failure(err.toString(), '', 
                                    () => {
                                location.reload();
                            });
                        });
                    refreshDevice();
                }, 60 * 1000);
            };
            refreshDevice();
        }
    }

    getAppInfo() {
        return this._appInfo;
    }

    loadTexts() {
        let texts = null;

        texts = require('./texts/pl');
        let Text_Sys = {};
        for (let text in texts)
            Text_Sys['Sys:' + text] = texts[text];
        abText.add('pl', Text_Sys);

        texts = require('./texts/pl.ab-data');
        let Text_ABData = {};
        for (let text in texts)
            Text_ABData['abData.' + text] = texts[text];
        abText.add('pl', Text_ABData);

        abText.setLang('pl');

        spkTables.setTextFn((text) => {
            return {
                Error: abText.$('Sys:Errors_Error'),
                LoadMore: abText.$('Sys:LoadMore'),
                Search_Placeholder: abText.$('Sys:Search_Placeholder'),
                TableEmpty: abText.$('Sys:TableEmpty'),
            }[text];
        });
    }

    lock() {
        this._locked = true;
        this.mMain.lb.lock();
        console.log('Lock -> Lock', new Error());
    }

    async logOut_Async() {
        let db = this.native.db;

        let transactionId = await db.transaction_Start_Async();

        await this.clearData_Async(false, true, transactionId);

        await this.dataScheme.getTable('_ABData_DBRequests').delete_Async(db, {}, 
                transactionId);
        await this.dataScheme.getTable('_ABData_Settings').delete_Async(db, {},
                transactionId);
        await this.dataScheme.getTable('_Native_Settings').delete_Async(db, {},
                transactionId);

        await db.transaction_Finish_Async(true, transactionId);

        // console.log(
        //     'Native Settings 2',
        //     await this.dataScheme.getTable('_Native_Settings').select_Async(db));

        this.setUser(null);
        this.mMain.lb.setUser({
            loggedIn: false,
            login: '',
            permissions: [],
        });
        this.mMain.lb.setPanels(require('./panels').create(this.mMain));
    }

    async isConnectedToInternet_Async() {
        return (await this.native.nativeActions.callNative_Async(
                'IsConnectedToInternet')).result;
    }

    refreshPanels() {
        this._mMain.lb.setPanels(require('./panels').create());
    }

    setAppInfo(appInfo) {
        this._appInfo = appInfo;
    }

    setFields(fields) {
        this._fields = fields;
    }

    setOfflineMode(active) {
        js0.args(arguments, 'boolean');

        this._offlineMode = active;
    }

    setUser(user) {
        this.user = {
            info: user === null ? null : user.info,
            info_Client: user === null ? null : user.info_Client,
            permissions: user === null ? [] : user.permissions,

            isClient: user === null ? 
                    false : (user.info === null ? false : user.info.Client__Id !== null), 
            isClinic: user === null ? 
                    false : (user.info === null ? false : user.info.Clinic__Id !== null),
            isClinicInseminator: user === null ?
                    false: (user.info === null ? false : user.info.Inseminator_Clinic__Id !== null),
            isEmployee: false,
            isFarmer: user === null ? 
                    false : (user.info === null ? false : user.info.Farmer__Id !== null),
            isInseminator: user === null ? 
                    false : (user.info === null ? false : user.info.Inseminator__Id !== null),
            isAdministrator: user === null ? 
                    false : (user.info === null ? false : user.info.Administrator__Id !== null),
        };

        this.user.isEmployee = this.user.isAdministrator;
    }

    async syncDB_Async() {
        let app = App.GetInstance();

        app.mMain.msgs.showLoading(abText.$('Sys:Loadings_DBSync'));

        try {
            // let oldDBVersion = await abData.native.NativeDataStore
            //         .GetDBSchemeVersion_Async(app.native.db);
            // if (oldDBVersion !== app.dataScheme.version) {
            //     let dbChangeActions = await abData.native.NativeDataStore
            //             .UpdateDBScheme_Async(app.native.db, app.dataScheme);
            //     await app.clearData_Async(false, false);
            //     await abData.native.NativeDataStore.ResetDeviceLastUpdate_Async(
            //             app.native.db);
            // }

            let response = await app.dataStore.syncDB_Async({
                apiVersion: App.ApiVersion,
                appInfo: app.appInfo,
            }, async (transactionId) => {
                await this.clearData_Async(false, false, transactionId);
            });

            if (response.type !== abData.Response.Types_Success) {
                let errorInfo = require('./sys').getResponseErrorInfo(response);

                app.mMain.msgs.showMessage_Failure(abText.$(
                        'Sys:Errors_CannotSynchronizeData_Title'),
                        errorInfo.title +  ' -> ' + errorInfo.message);

                app.mMain.msgs.hideLoading();
                return;
            }

            let warnings = [];
            for (let requestId of response.requestIds) {
                if ('data' in response.results[requestId]) {
                    if ('warnings' in response.results[requestId].data) {
                        warnings = warnings.concat(
                                response.results[requestId].data.warnings);
                    }
                }
            }

            if (warnings.length > 0) {
                await app.mMain.msgs.showMessage_Failure_Async(abText.$(
                        'Sys:Errors_DBSync_HasWarnings'),
                        warnings.join(' '));
            }

            await app.native.actions.refreshLastUpdate();

            app.mMain.msgs.hideLoading();
        } catch (e) {
            console.error(e);

            // app.mMain.msgs.showMessage_Failure(abText.$(
            //         'Sys:Errors_CannotSynchronizeData_Title'),
            //         e.toString());

            app.mMain.showAssertionMessage(abText.$(
                    'Sys:Errors_CannotSynchronizeData_Title'),
                    e.toString());
            app.mMain.msgs.hideLoading();
        }
    }

    async syncDB_Helper_Async(forceOnline = false) {
        js0.args(arguments, [ 'boolean', js0.Default ]);

        if (this.isOfflineModeActive) {
            if (forceOnline) {
                let result_GoOnline = await this.mMain.msgs.showConfirmation_Async(
                    abText.$(
                    'Sys:Confirmations_GoOnline_Title'),
                    abText.$(
                    'Sys:Confirmations_GoOnline_Message'), 
                    abText.$('Sys:Text_Yes'), abText.$('Sys:Text_No'));
                if (result_GoOnline) {
                    this._testConnectionResult = -1;
                    this.setOfflineMode(false);
                } else
                    return false;
            } else
                return false;
        }

        let result_IsConnectedToInternet = await this.isConnectedToInternet_Async();
        if (!result_IsConnectedToInternet) {
            if (forceOnline) {
                await this.mMain.msgs.showMessage_Failure_Async(
                        abText.$(
                        'Sys:Errors_CannotSynchronizeData_Title'),
                        abText.$(
                        'Sys:Messages_NoInternetConnection'));
            }

            return false;
        }

        let result_TestConnection = await this.testConnection_Async();

        if (result_TestConnection === 0) {
            this._testConnectionResult = 0;
        } else if (result_TestConnection === 1) {
            let result_GoOffline = await this.mMain.msgs.showConfirmation_Async(
                    abText.$(
                    'Sys:Errors_TestConnectionTimeout_Title'),
                    abText.$(
                    'Sys:Errors_TestConnectionTimeout_Message'), 
                    abText.$('Sys:Text_Yes'), abText.$('Sys:Text_No'));
            if (result_GoOffline) {
                this.setOfflineMode(true);
                return false;
            } else
                this._testConnectionResult = -1;
        } else if (result_TestConnection === 2) {
            let result_GoOffline = await this.mMain.msgs.showConfirmation_Async(
                    abText.$(
                    'Sys:Errors_TestConnectionError_Title'),
                    abText.$(
                    'Sys:Errors_TestConnectionError_Message'), 
                    abText.$('Sys:Text_Yes'), abText.$('Sys:Text_No'));
            if (result_GoOffline) {
                this.setOfflineMode(true);
                return false;
            } else
                this._testConnectionResult = -1;
        }
         
        try {
            await this.syncDB_Async();
        } catch (e) {
            await this.mMain.msgs.showMessage_Failure_Async(abText.$(
                    'Sys:Errors_CannotSynchronizeData_Title'), e.toString());
        }

        return true;
    }

    /* 
        0 - good 
        1 - timeout
        2 - connection error
    */
    async testConnection_Async() {
        if (this._testConnectionResult === 0 || 
                this._testConnectionResult === -1)
            return this._testConnectionResult;

        let t0 = new Date().getTime();
        let result = await webABApi.json_Async(this.apiUri + 
                'app/test-connection', {}, 
                App.ConnectionTestTimeout);
        
        if (result.isSuccess()) {
            let ts = new Date().getTime() - t0;
            console.log('Connection test result time:', ts);
            return 0;
        }

        if (result.getResult() === webABApi
                .Result.ErrorResults_HttpTimeoutError) {
            console.log('Connection test result timeout:', 
                    App.ConnectionTestTimeout);
            return 1;
        }

        console.log('Test Connection Error result', result);
        return 2;
    }

    unlock() {
        this._locked = false;
        this.mMain.lb.unlock();
        console.log('Lock -> Unlock', new Error());
    }


    _create_DataScheme() {
        let abData_Types = [];
        if (App.Platform === 'web')
            abData_Types.push('db');
        if (App.Platform === 'native')
            abData_Types.push('native');

        this.dataScheme = require('./$ab-data')(abData_Types);
    }

}
App._Instance = null;

module.exports = App;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\core\Select.js
jsLibs.exportModule('core', 'Select', (require, module, exports) => { 'use strict';

const
    js0 = require('js0'),

    sys = require('./sys'),

    $layouts = require('./$layouts')
;

class Select extends sys.Module {

    constructor(lb, table, viewInfo = null, onActiveFn = null) {
        super(lb);

        this._active = false;

        this.t = table;
        this.l = sys.createLayout($layouts.Select);

        this.l.$elems.select.addEventListener('click', (evt) => {
            evt.preventDefault();
            this._active = !this._active
            this.t.setSelectable(this._active);
            this.l.$fields.active = this._active;

            if (viewInfo !== null) {
                viewInfo[0].$view = this._active ? 
                        viewInfo[2] : viewInfo[1];
            }

            if (onActiveFn !== null)
                onActiveFn(this._active);
        });

        this.$view = this.l;
    }

}

module.exports = Select;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\core\helper.js
jsLibs.exportModule('core', 'helper', (require, module, exports) => { 'use strict';

const
    abData = require('ab-data'),
    abText = require('ab-text'),
    js0 = require('js0'),
    abWebApi = require('web-ab-api'),

    App = require('./App')
;

async function api_Delete_Async(panelTitle, fields) {
    let app = App.GetInstance();

    let response = await app.ds.request_Async(`Sys_${panelTitle}`, 'delete', {
        args: fields,
    });

    return response;
}


async function api_DeleteSelected_Async(panelTitle, fields) {
    let app = App.GetInstance();

    let response = await app.ds.request_Async(`Sys_${panelTitle}`, 'deleteSelected', {
        args: fields,
    });

    return response;
}


async function api_Row_Async(panelTitle, fields) {
    let app = App.GetInstance();

    let response = await app.ds.request_Async(`Sys_${panelTitle}`, 'row', {
        args: fields,
    });

    return response;
}

// export async function api_Select_Async(panelTitle, fields)
// {
//     let app = App.GetInstance();

//     let response = await app.ds.request_Async(`Sys_${panelTitle}`, 'select', {
//         args: fields,
//     });

//     return response;
// }

async function api_RequestUpdate_Async(panelTitle, fields) {
    let app = App.GetInstance();

    let response = await app.ds.request_Async(`Sys_${panelTitle}`, 
            'requestUpdate', {
        args: fields,
    });

    return response;
}

async function api_Request_Async(panelTitle, fields) {
    let app = App.GetInstance();

    let response = await app.ds.request_Async(`Sys_${panelTitle}`, 'request', {
        args: fields,
    });

    return response;
}

async function api_Update_Async(panelTitle, fields) {
    let app = App.GetInstance();

    let response = await app.ds.request_Async(`Sys_${panelTitle}`, 'update', {
        args: fields,
    });

    return response;
}





module.exports.api_Delete_Async = api_Delete_Async;
module.exports.api_DeleteSelected_Async = api_DeleteSelected_Async;
module.exports.api_Row_Async = api_Row_Async;
module.exports.api_RequestUpdate_Async = api_RequestUpdate_Async;
module.exports.api_Request_Async = api_Request_Async;
module.exports.api_Update_Async = api_Update_Async;
 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\core\Main.js
jsLibs.exportModule('core', 'Main', (require, module, exports) => { 'use strict';

const
    abCookies = require('ab-cookies'),
    abDate = require('ab-date'),
    abNative = require('ab-native'),
    abPager = require('ab-pager'),
    abText = require('ab-text'),
    js0 = require('js0'),
    spkLemonBee = require('spk-lemon-bee'),
    spkMessages = require('spk-messages'),
    spocky = require('spocky'),
    webABApi = require('web-ab-api'),

    App = require('./App'),
    
    panels = require('./panels'),
    sys = require('./sys'),

    $layouts = require('./$layouts')
;

class Main extends spocky.Module {
    constructor() {
        super();

        let app = new App(this);

        // this.na_Core = abNative.addActionsSet('Core', new NativeActionsDef_Core());
        // if (abNative_Platform === 'android' || abNative_Platform)
        //     this.na_App = abNative.addActionsSet('App', new NativeActionsSet_App());
        
        this.pager = new abPager.Pager(abNative_Base, 
                abNative_Platform === 'web');
        this.pager_Setup();

        this.msgs = new spkMessages.Messages({
            modulePath: abNative_Base + 'dev/node_modules/spk-messages/',
        }, new $layouts.Messages());
        this.lb = new spkLemonBee.System(this.pager, this.msgs);

        this.l = new $layouts.Main();
        this.l.$fields.Status = '...';

        this.l.$holders.messages.$view = this.msgs;
        this.msgs.showLoading();

        this.$view = this.l;

        // this.l.$fields.Status = 'Initializing...';
        // this.l.$elems.SyncDB.addEventListener('click', (evt) => {
        //     evt.preventDefault();
        //     this.l.$fields.Status = 'Syncing DB...';
        //     app.ds.syncDB_Async()
        //         .then(() => {
        //             this.l.$fields.Status = 'Done Syncing DB.';
        //         })
        //         .catch((e) => {
        //             console.error(e);
        //         });
        // });

        this.setup();

        app.native.actions.init_Async()
            .then((result) => {
                abDate.setTimezone('Europe/Warsaw');

                app.appVersion = result.appVersion;

                app.setAppInfo(result.appInfo);
                app.setFields(result.fields);
                app.setUser(result.user);

                if (result.deviceInfo !== null)
                    app.createDataStore(result.deviceInfo);

                // app.ds.requestB_Async([
                //     [ 'rows', 'Sys_Bulls', 'select', {
                //         join: [
                //             {
                //                 prefix: 'Client_',
                //                 table: app.dataScheme.getTable('Sys_Clients'),
                //                 on: [ 
                //                     [ '_Id', 'Client__Id' ],
                //                 ],
                //                 // where: [
                //                 //     [ '_Id', '=', 's_b.Client__Id' ],
                //                 // ],
                //             },
                //         ],
                //     }],
                //         ])
                //     .then((r) => {
                //         console.log(r.rows.rows);
                //     })
                //     .catch((e) => {
                //         console.error(e);
                //     });

                this.lb.setPanels(panels.create(this));

                if (App.Platform === 'native') {
                    if (app.user.info !== null) {
                        (async () => {
                            if (await app.isConnectedToInternet_Async()) {
                                let dbSynced = await app.syncDB_Helper_Async();
                                if (!dbSynced) {
                                    if (!await app.native.actions.isUpToDate()) {
                                        this.msgs.showMessage_Failure(abText.$(
                                                'Sys:Warnings_UpdateApp'), abText.$(
                                                    'Sys:Warnings_UpdateApp_Message'));
                                        // this.msgs.hideLoading();
                                    }
                                }

                                this.init({
                                    loggedIn: app.user.info !== null,
                                    login: app.user.info === null ? '' : app.user.info.Email,
                                    permissions: app.user.permissions,
                                });
                            } else {
                                if (await app.native.actions.isUpToDate()) {
                                    // this.msgs.hideLoading();
                                } else {
                                    this.msgs.showMessage_Failure(abText.$(
                                            'Sys:Warnings_UpdateApp'), abText.$(
                                                'Sys:Warnings_UpdateApp_Message'));
                                    // this.msgs.hideLoading();
                                }

                                this.init({
                                    loggedIn: app.user.info !== null,
                                    login: app.user.info === null ? '' : app.user.info.Email,
                                    permissions: app.user.permissions,
                                });
                            }
                                })()
                            .catch((e) => {
                                this.init({
                                    loggedIn: app.user.info !== null,
                                    login: app.user.info === null ? '' : app.user.info.Email,
                                    permissions: app.user.permissions,
                                });

                                console.error(e);

                                this.msgs.showMessage_Failure(e.toString());
                                this.msgs.hideLoading();
                            });
                    } else {
                        this.init({
                            loggedIn: app.user.info !== null,
                            login: app.user.info === null ? '' : app.user.info.Email,
                            permissions: app.user.permissions,
                        });

                        // this.msgs.hideLoading();    
                    }
                } else {
                    this.init({
                        loggedIn: app.user.info !== null,
                        login: app.user.info === null ? '' : app.user.info.Email,
                        permissions: app.user.permissions,
                    });
                 
                    // this.msgs.hideLoading();
                }
            })
            .catch((err) => {
                console.error(err.stack);
                this.msgs.showMessage_Failure(err.toString());
                this.msgs.hideLoading();
            });
    }

    init(user) {
        this.lb.setUser(user);

        this.pager_Setup();
        this.lb.setPanels(panels.create(this));

        let lb_Initialized = false;
        this.lb.addListener_BeforePage((page, source, pageArgs) => {
            if (abNative_Platform === 'web' && source !== null) {
                if (source.name in panels.cache)
                    panels.cache[source.name].scrollY = window.scrollY;
            }

            if (!lb_Initialized) {
                lb_Initialized = true;
                this.l.$holders.content.$view = this.lb.module;
            }
        });

        this.lb.addListener_AfterPage((page, source, pageArgs) => {
            if (this.lb.body === null)
                return;

            if (abNative_Platform === 'web') {
                let menuCollapsed = abCookies.get('eSys_MenuCollapsed', false);
                this._setMenuCollapsed(menuCollapsed);

                this.lb.body.lMenu.$elems.ToggleButton.addEventListener('click', 
                        (evt) => {
                    evt.preventDefault;
                    this._setMenuCollapsed(!this.lb.body.lMenu.$fields.HideTitles);
                });
            }
        });

        this.lb.init();
        this.pager.init();
    }

    pager_Setup() {
        this.pager
            .clearPages()
            // .page('register', 'rejestracja', (page) => {
            //     this.msgs.hideLoading();

            //     let mPage = new (require('./pages/Register'))(this);
            //     this.l.$holders.content.$view = mPage;
            // })
            // .page('home', '', (page) => {
            //     this.pager.setPage('lb.panels.receipts');
            // })
            .page('deleteAccount', 'usun-konto', (page) => {
                this.msgs.hideLoading();

                let mPage = new (require('./pages/DeleteAccount'))(this);
                this.l.$holders.content.$view = mPage;
            })
            .page('privacyPolicy', 'polityka-prywatnosci', (page) => {
                this.msgs.hideLoading();

                let mPage = new (require('./pages/PrivacyPolicy'))(this);
                this.l.$holders.content.$view = mPage;
            })
            .page('statement', 'oswiadczenie', (page) => {
                this.msgs.hideLoading();

                let mPage = new (require('./pages/Statement'))(this);
                this.l.$holders.content.$view = mPage;
            })
            .notFound(() => {
                this.pager.setPage('lb.main');
            });
    }

    setup(user) {
        let app = App.GetInstance();

        this.lb.setup({
            actions: {
                changePassword_Async: async(oldPassword, newPassword) => {
                    let result = await webABApi.json_Async(
                            sys.uris.pages['ecore.api.user'] + 'change-password', 
                            { password: oldPassword, newPassword: newPassword });

                    if (result.isSuccess()) {
                        return {
                            success: true,
                            message: result.data.message,
                        }
                    } else {
                        return {
                            success: false,
                            message: result.data.message,
                        };
                    }
                },
                logIn_Async: async (login, password) => {
                    if (App.Platform === 'web') {
                        let result = await app.native.actions.logIn_Async(login,
                                password);

                        if (result.data !== null) {
                            app.setAppInfo(result.data.appInfo);
                            app.setUser(result.data.user);

                            this.lb.setPanels(panels.create(this));
                        }

                        return {
                            user: {
                                loggedIn: app.user.info !== null,
                                login: app.user.info === null ? '' : app.user.info.Email,
                                permissions: app.user.permissions,
                            },
                            error: result.error,
                        };
                    } else if (App.Platform === 'native') {
                        let result = await app.native.actions.logIn_Async(login, password);

                        if (result.data !== null) {
                            app.setAppInfo(result.data.appInfo);
                            app.setUser(result.data.user);

                            this.lb.setPanels(panels.create(this));
                        }

                        return {
                            user: {
                                loggedIn: app.user.info !== null,
                                login: app.user.info === null ? '' : app.user.info.Email,
                                permissions: app.user.permissions,
                            },
                            error: result.error,
                        };
                    }
                },
                logOut_Async: async () => {
                    if (App.Platform === 'web') {
                        let result = await app.native.actions.logOut_Async();

                        if (result.success) {
                            app.setUser(null);
                            this.lb.setPanels(panels.create(this));
                        }

                        return result;
                    }
                },
                remindPassword_Async: async(login) => {
                    let result = await webABApi.json_Async(
                            sys.uris.pages['ecore.api.user'] + 'remind-password', 
                            { login: login, email: login });

                    if (result.isSuccess()) {
                        return {
                            success: true,
                            message: result.data.message,
                        }
                    } else {
                        return {
                            success: false,
                            message: result.data.message,
                        };
                    }
                },
                resetPassword_Async: async(resetPasswordHash, newPassword) => {
                    let result = await webABApi.json_Async(
                            sys.uris.pages['ecore.api.user'] + 'reset-password', 
                            { resetPasswordHash: resetPasswordHash, 
                            newPassword: newPassword, });

                    if (result.isSuccess()) {
                        return {
                            success: true,
                            message: result.data.message,
                        }
                    } else {
                        return {
                            success: false,
                            message: result.data.message,
                        };
                    }
                },
            },

            aliases: {
                account: abText.$('Sys:Aliases_Account'),
                main: abText.$('Sys:Aliases_Home'),
                logIn: abText.$('Sys:Aliases_LogIn'),
                remindPassword: abText.$('Sys:Aliases_RemindPassword'),
                resetPassword: abText.$('Sys:Aliases_ResetPassword'),
            },
            dev: {
                login: abWeb_BuildType === 'dev' ? 'farmer' : '',
                password: abWeb_BuildType === 'dev' ? 'test' : '',
            },
            setDefaultPageFn: () => {
                if (this.pager.hasPage('lb.panels.receipts'))
                    this.pager.setPage('lb.panels.receipts');
                else
                    this.pager.setPage('lb.main');
            },
            images: {
                logo: App.Base + 'res/images/logo.png',
                logo_Main: App.Base + 'res/images/logo_main.png',
            },
            layouts: {
                Body: $layouts.LemonBee_Body,
                Main: $layouts.LemonBee_Main,
                TopMenu: $layouts.LemonBee_TopMenu,
            },
            panels: [],
            shows: {
                home: false,
                userInfo: abNative_Platform === 'web',
            },
            textFn: (text) => {
                return abText.$('Sys:' + text);
            },
            title: abText.$('Sys:Titles_Sys'),
            uris: {
                package: '',
            },

            settings: {
                hasRemindPassword: abNative_Platform === 'web',
            }
        });
    }

    showAssertionMessage(title, message) {
        this.msgs.showMessage(this.msgs.getImageUri_Failure(), 
                title, message, null, abText.$('Sys:Buttons_RestartApp'), 
                'btn-danger', () => {
            this.msgs.showConfirmation(abText.$(
                    'Sys:Confirmations_RestartApp_Title'), abText.$(
                    'Sys:Confirmations_RestartApp_Message'), abText.$(
                    'Sys:Text_Yes'), abText.$('Sys:Text_No'), (result) => {
                if (result)
                    abNative.callNative_Async('Native', 'RestartApp');
            });
        });
    }

    _setMenuCollapsed(menuCollapsed) {
        js0.args(arguments, 'boolean');

        abCookies.set('eSys_MenuCollapsed', menuCollapsed);

        this.lb.body.lMenu.$fields.HideTitles = menuCollapsed;
        this.lb.body.lMenu.$fields.MenuCollapsed_TitlesClass = menuCollapsed ?
                'menu-collapsed-titles' : '';

        this.lb.body.lMenu.$fields.CollapseButton_HolderClass = menuCollapsed ? 
                'collapsed' : '';
        this.lb.body.lMenu.$fields.CollapseButton_FaIcon = menuCollapsed ? 
                'fa-chevron-right' : 'fa-chevron-left';
        this.lb.body.layout.$fields.MenuCollapsed_MenuClass = menuCollapsed ?
                'menu-collapsed-menu-narrow' : 'menu-collapsed-menu-wide';
        this.lb.body.layout.$fields.MenuCollapsed_ContentClass = menuCollapsed ?
                'menu-collapsed-content-narrow' : 'menu-collapsed-content-wide';
    }

}

module.exports = Main;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\core\modules.js
jsLibs.exportModule('core', 'modules', (require, module, exports) => { 'use strict';

const
    abText = require('ab-text'),
    spkForms = require('spk-forms'),
    spkTables = require('spk-tables'),
    spocky = require('spocky'),
    webABApi = require('web-ab-api'),

    farmers = require('./panels/farmers'),

    helper = require('./helper'),
    sys = require('./sys'),
    tables = require('./tables'),

    App = require('./App'),

    $layouts = require('./$layouts')
;

class Add extends sys.Module {
    constructor(lb, panelName, panelTitle, formClass) { super(lb);
        this.fm = new formClass(lb, true);
        this.fm.m.lContent.$fields = {
            isNew: true,
        };
        this.fm.m.l.$fields = {
            // shows: {
            //     delete: false,
            // },
            texts: {
                Buttons_Submit: sys.eText('Sys:Buttons_Create'),
                title: sys.eText(`Sys:Titles_${panelTitle}_Create`),
            },
        };

        this.fm.m.onSubmit = (result) => {
            this.unlock();
            this.pager.setPage(`lb.subpanels.${panelName}.list`);
        }

        this.fm.m.refresh();

        this.$view = this.fm;
    }
}


class Edit extends sys.Module {

    constructor(lb, panelName, panelTitle, formClass) { super(lb);
        this.fm = new formClass(lb, false);
        this.fm.m.l.$fields = {
            texts: {
                Buttons_Submit: sys.eText('Sys:Buttons_Save'),
                title: sys.eText(`Sys:Titles_${panelTitle}_Save`),
            },
        };

        this.$view = this.fm;
    }

}


class Form extends sys.Module {

    get id() {
        if (this.data !== null)
            return this.data.row._Id;

        return 'id' in this.pager.current.args ? Number(this.pager.current.args.id) : null;
    }


    constructor(lb, panelName, panelTitle, create = false) { super(lb);
        this.panelName = panelName;
        this.panelTitle = panelTitle;

        this.create = create;
        this.data = null;

        this.refresh_OnSetApiFields = (fields) => { return fields; };
        this.refresh_OnParseApiResult = () => {};
        this.submit_OnSetApiFields = (fields) => { return fields; };
        this.submit_OnValidator = (validator) => {};

        this.listeners_Back = () => {
            this.pager.setPage(`lb.subpanels.${panelName}.list`);
        };

        /* Edit */
        this.l = sys.createLayout($layouts.Form);
        this.l.$fields = {
            texts: {
                title: sys.eText(`Sys:Titles_${panelTitle}_Edit`),
            },
            shows: {
                submit: true,
            },
            uris: {
                back: this.pager.getPageUri(`lb.subpanels.${panelName}.list`),
            },
        };

        lb.setBackButton(true);
        lb.setListener_OnBack(() => {
            this.listeners_Back();
            return true;
        });

        this.l.$elems.back.addEventListener('click', (evt) => {
            evt.preventDefault();
            if (this.isLocked)
                return;
            this.listeners_Back();
        });

        this.l.$elems.submit.addEventListener('click', (evt) => {
            evt.preventDefault();
            this.submit((result) => {
                this.onSubmit(result);
            });
        });
        this.l.$elems.submit2.addEventListener('click', (evt) => {
            evt.preventDefault();
            this.submit((result) => {
                this.onSubmit(result);
            })
        });
        this.l.$elems.delete.addEventListener('click', (evt) => {
            evt.preventDefault();
            this.delete((result) => {
                this.onDelete();
            });
        });

        this.lInfos_Clinic = sys.createLayout($layouts.Clinics_Info);
        this.l.$holders.infos_Clinic.$view = this.lInfos_Clinic;
        this.lInfos_Inseminator = sys.createLayout($layouts.Inseminators_Info);
        this.l.$holders.infos_Inseminator.$view = this.lInfos_Inseminator;
        this.lInfos_Farmer = sys.createLayout($layouts.Farmers_Info);
        this.l.$holders.infos_Farmer.$view = this.lInfos_Farmer;
        this.lInfos_Cow = sys.createLayout($layouts.Cows_Info);
        this.l.$holders.infos_Cow.$view = this.lInfos_Cow;
        this.lInfos_Bull = sys.createLayout($layouts.Bulls_Info);
        this.l.$holders.infos_Bull.$view = this.lInfos_Bull;

        /* Submit */
        this.onSubmit = (result) => {
            this.msgs.showMessage_Success(abText.$('Sys:Successes_Success'), '', () => {
                this.refresh();
            });
            this.unlock();
            this.msgs.hideLoading();
        };
        this.onDelete = (result) => {
            this.unlock();
            this.pager.setPage(`lb.subpanels.${panelName}.list`);
        }

        /* Content */
        this.lContent = sys.createLayout($layouts[`${panelTitle}_Form`]);

        this.f = new spkForms.Form(this.lContent, 'Form');

        this.l.$holders.content.$view = this.lContent;
        /* / Content */

        setTimeout(() => {
            window.scrollTo(0,0);
        }, 100)

        this.$view = this.l;
    }

    delete(onDeleteFn) {
        if (this.isLocked)
            return;

        this.msgs.showConfirmation(
                sys.eText('Sys:Confirmations_Delete'), '',
                sys.eText('Sys:Text_Yes'),
                sys.eText('Sys:Text_No'), (result) => {
            if (!result)
                return;

            this.lock();
            this.msgs.showLoading();

            let fields = { 
                id: Number(this.pager.current.args.id), 
            };
    
            helper.api_Delete_Async(this.panelTitle, fields)
                .then((response) => {
                    if (!sys.parseRequestResponse(this, response, (result) => {
                        if (result.success)
                            onDeleteFn(result);
                        else {
                            this.msgs.showMessage_Failure(result.message);
                            this.unlock();
                            this.msgs.hideLoading();
                        }
                            })) {
                        this.unlock();
                        this.msgs.hideLoading();
                    }
                })
                .catch((e) => {
                    this.unlock();

                    console.error(e);

                    this.msgs.showMessage_Failure(e.toString());
                    this.msgs.hideLoading();
                });
        });
    }

    refresh() {
        this.lock();
        this.msgs.showLoading();

        let fields = {
            id: 'id' in this.pager.current.args ?
                    Number(this.pager.current.args.id) : '0',
        };

        this.refresh_OnSetApiFields(fields);

        helper.api_Row_Async(this.panelTitle, fields)
            .then((response) => {
                if (!sys.parseRequestResponse(this, response, (result) => {
                    this.data = result.data;

                    this._submit_OnParseApiResult_Info(result.data, 'Clinic');
                    this._submit_OnParseApiResult_Info(result.data, 'Inseminator');
                    this._submit_OnParseApiResult_Info(result.data, 'Farmer');
                    this._submit_OnParseApiResult_Info(result.data, 'Cow');
                    this._submit_OnParseApiResult_Info(result.data, 'Bull');

                    this.refresh_OnParseApiResult(result.data);

                    if (this.data.row !== null)
                        this.f.setValues(this.data.row, true);
                    else {
                        if (fields.id !== '0') {
                            this.msgs.showMessage_Failure(abText.$('Sys:Errors_ItemDoesNotExist'),
                                    '', () => {
                                this.pager.setPage('lb.main');
                            });
                        }
                    }

                    this.unlock();
                    this.msgs.hideLoading();
                        })) {
                    this.unlock();
                    this.msgs.hideLoading();
                }
            })
            .catch((e) => {
                this.unlock();

                console.error(e);

                this.msgs.showMessage_Failure(e.toString());
                this.msgs.hideLoading();
            });
    }

    submit(onSubmitFn) {
        if (this.isLocked)
            return;

        this.lock();
        this.msgs.showLoading();

        let row = this.f.getValues();
        let fields = {
            id: this.data === null ? 
                    App.GetInstance().ds.nextId() : 
                    (this.data.row === null ? App.GetInstance().ds.nextId() : this.data.row._Id),
            row: row,
        };
        fields = this.submit_OnSetApiFields(fields);

        helper.api_Update_Async(this.panelTitle, fields)
            .then((response) => {
                if (!sys.parseRequestResponse(this, response, (result) => {
                    if (result.success) {
                        onSubmitFn(result);
                    } else {
                        if ('data' in result) {
                            if (result.data !== null) {
                                if ('validator' in result.data) {
                                    this.f.setValidator(result.data.validator);
                                    this.submit_OnValidator(result.data.validator);
    
                                    this.unlock();
                                    this.msgs.hideLoading();
    
                                    return;
                                }
                            }
                        }
            
                        this.msgs.showMessage_Failure(abText.$('Sys:Titles_Error'), 
                                result.error);

                        this.unlock();
                        this.msgs.hideLoading();
                    }
                        })) {
                    this.unlock();
                    this.msgs.hideLoading();
                }
            })
            .catch((e) => {
                console.error(e);

                this.msgs.showMessage_Failure(abText.$('Sys:Titles_Error'), 
                        e.toString());

                this.unlock();
                this.msgs.hideLoading();
            });
    }


    _submit_OnParseApiResult_Info(data, title) {
        if (`r${title}` in data) {
            if (data[`r${title}`] !== null) {
                this[`lInfos_${title}`].$fields.row = data[`r${title}`];
                this.l.$fields[`shows_Infos_${title}`] = true;
            }
        }
    }

}


class List extends sys.Module {
    
    constructor(lb, panelName, panelTitle) { super(lb);
        this.panelName = panelName;
        this.panelTitle = panelTitle;

        this.l = sys.createLayout($layouts.List);

        this.lInfos_Clinic = sys.createLayout($layouts.Clinics_Info);
        this.l.$holders.infos_Clinic.$view = this.lInfos_Clinic;
        this.lInfos_Inseminator = sys.createLayout($layouts.Inseminators_Info);
        this.l.$holders.infos_Inseminator.$view = this.lInfos_Inseminator;
        this.lInfos_Farmer = sys.createLayout($layouts.Farmers_Info);
        this.l.$holders.infos_Farmer.$view = this.lInfos_Farmer;
        this.lInfos_Cow = sys.createLayout($layouts.Cows_Info);
        this.l.$holders.infos_Cow.$view = this.lInfos_Cow;
        this.lInfos_Bull = sys.createLayout($layouts.Bulls_Info);
        this.l.$holders.infos_Bull.$view = this.lInfos_Bull;

        this.refresh_SetApiFields = (fields) => { return fields; };
        this.refresh_SetOnRefresh = (rows, colRefs) => {};
        this.refresh_OnApiResult = (data) => { };

        this.listeners_Add = () => {
            if (!this.isLocked)
                this.pager.setPage(`lb.subpanels.${panelName}.add`);
        };
        this.listeners_Back = () => {
            if (!this.isLocked)
                this.pager.setPage('lb.main');
        };

        this.l.$fields = {
            title: abText.$(`Sys:Titles_${panelTitle}`),
            texts: {
                Buttons_Add: abText.$('Sys:Buttons_Add'),
            },
            shows: {
                add: this.pager.hasPage(`lb.subpanels.${panelName}.add`) ?
                        true : false,
            },
            uris: {
                add: this.pager.hasPage(`lb.subpanels.${panelName}.add`) ?
                        this.pager.getPageUri(`lb.subpanels.${panelName}.add`) :
                        '#',
                back: this.pager.getPageUri('lb.main'),
            },
        };

        this.l.$elems.back.addEventListener('click', (evt) => {
            evt.preventDefault();
            this.listeners_Back();
        });
        this.l.$elems.add.addEventListener('click', (evt) => {
            evt.preventDefault();
            this.listeners_Add();
        });

        this.t = new spkTables.Table(this.msgs, tables[`tables_${panelTitle}`]())
            .setApiFields(() => {
                let fields = {};

                fields = this.refresh_SetApiFields(fields);

                return fields;
            })
            .setShowSearch(true)
            .setOnApiResult((data) => {
                this._table_SetOnApiResult_Info(data, 'Clinic');
                this._table_SetOnApiResult_Info(data, 'Inseminator');
                this._table_SetOnApiResult_Info(data, 'Farmer');
                this._table_SetOnApiResult_Info(data, 'Cow');
                this._table_SetOnApiResult_Info(data, 'Bull');

                this.refresh_OnApiResult(data);
            })
            .setOnRefresh((rows, colRefs) => {
                this.refresh_SetOnRefresh(rows, colRefs);
            })
            .setOnRowClick((row, colRefs) => {
                this.pager.setUri(row.href);
            }, (row, colRefs) => {
                if (!('_Id' in colRefs))
                    return '#';

                return this.pager.getPageUri(`lb.subpanels.${panelName}.edit`,
                        { id: row.cols[colRefs._Id].value, });
            });

        this.l.$holders.table.$view = this.t;

        setTimeout(() => {
            window.scrollTo(0,0);
        }, 100);

        this.$view = this.l;
    }

    deleteSelected(ids, onDeleteFn) {
        if (ids.length === 0) {
            this.msgs.showMessage_Failure(sys.eText('Sys:Errors_NoRowsSelected'));
            return;
        }

        this.msgs.showConfirmation(
                sys.eText('Sys:Confirmations_DeleteSelected'), '',
                sys.eText('Sys:Text_Yes'),
                sys.eText('Sys:Text_No'), (result) => {
            if (!result)
                return;

            this.lock();
            this.msgs.showLoading();

            let fields = {
                ids: [],
            };
            for (let id of ids) {
                fields.ids.push(Number(id));
            }
    
            helper.api_DeleteSelected_Async(this.panelTitle, fields)
                .then((response) => {
                    if (!sys.parseRequestResponse(this, response, (result) => {
                        if (result.success)
                            onDeleteFn(result);
                        else {
                            this.msgs.showMessage_Failure(result.message);
                            this.unlock();
                            this.msgs.hideLoading();
                        }
                            })) {
                        this.unlock();
                        this.msgs.hideLoading();
                    }
                })
                .catch((e) => {
                    console.error(e);

                    this.msgs.showMessage_Failure(e.toString());
                    this.msgs.hideLoading();
                });
        });
    }


    _table_SetOnApiResult_Info(data, title) {
        if (`r${title}` in data) {
            if (data[`r${title}`] !== null) {
                this[`lInfos_${title}`].$fields.row = data[`r${title}`];
                this.l.$fields[`shows_Infos_${title}`] = true;
            } else
                this.l.$fields[`shows_Infos_${title}`] = false;
        } else {
            this[`lInfos_${title}`].$fields.row = null;
            this.l.$fields[`shows_Infos_${title}`] = false;
        }
    }

}





module.exports.Add = Add;
module.exports.Edit = Edit;
module.exports.Form = Form;
module.exports.List = List;
 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\core\native.js
jsLibs.exportModule('core', 'native', (require, module, exports) => { 'use strict';

const
    abData = require('ab-data'),
    js0 = require('js0'),

    webABApi = require('web-ab-api')
;

class native_Class {

    constructor() {
        this.db = new abData.native.Database();
    }

    async logIn_Async(login, password) {
        js0.args(arguments, 'string', 'string');

        let result = webABApi.json_Async(this._apiUri + 'app/authenticate', {
            login: login,
            password: password,
        });

        if (result.isSuccess()) {
            let app = App.GetInstance();

            let tSettings = app.ds.scheme.getTable('Settings');

            let result_Update = tSettings.update([
                {
                    Name: 'AppInfo',
                    Data: {
                        appInfo: result.data.appInfo,
                        deviceInfo: result.data.deviceInfo,
                    },
                },
            ]);

            
        } else {
            console.error('Cannot authenticate', result);
            throw new Error('To do.');
        }
    }

}
const native = new native_Class();



module.exports = native;


 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\core\sys.js
jsLibs.exportModule('core', 'sys', (require, module, exports) => { 'use strict';

const
    abData = require('ab-data'),
    abDate = require('ab-date'),
    abStrings = require('ab-strings'),
    abText = require('ab-text'),
    js0 = require('js0'),
    spkLemonBee = require('spk-lemon-bee'),
    spkTables = require('spk-tables'),
    spocky = require('spocky'),
    webABApi = require('web-ab-api'),

    App = require('./App'),
        
    $layouts = require('./$layouts')
;

class sys_Class {
    get receipts_DateDaysLimit() {
        return 180;
    }

    get receipts_TreatmentDaysLimit() {
        return 180;
    }

    get uris() {    
        return App.GetInstance().fields.uris;
    }

    get user() {
        return App.GetInstance().user;
    }


    constructor() {
        this.langs = [ 'PL' ];

        this.tables = new tables_Class();
    }

    createLayout(layoutClass) {
        js0.args(arguments, 'function');

        let l = new layoutClass();

        l.$fields.base = abNative_Base;

        l.$fields.eField = (fieldName) => {
            return '###NOT IMPLEMENTED###'; //this._getField(fieldName);
        };
        l.$fields.eText = (text) => {
            return abText.$(text);
        };

        l.$fields.eSys = {
            user: this.user,
        }

        return l;
    }

    delete(module, apiUri, successFn) {
        js0.args(arguments, Module, 'string', 'function');

        module.msgs.showConfirmation(abText.$('Adm:Confirmations_Delete'), '',
                abText.$('Adm:Text_Yes'), abText.$('Adm:Text_No'), (result) => {
            if (!result)
                return;

            module.msgs.showLoading();
            webABApi.json(apiUri, { id: module.pager.current.args.id }, (result) => {
                this.parseApiResult(module, result, () => {
                    successFn();
                });
            });
        });
    }

    eText(text) {
        return abText.$(text);
    }

    formatReceiptForPrint(row) {
        let dateStr = abDate.format_Date(row.Date);
        let fileNr = row.FileNr + dateStr[dateStr.length - 1];

        let row_Print = {
            Nr_Formatted: sys.formatReceiptNr(row.Nr),
            Date: dateStr,
            FileNr: fileNr,

            LastCalving: abDate.format_Date(row.LastCalving),
            SemenProduction: abDate.format_Date(row.SemenProduction),
            Sexed: row.Sexed,

            Cow_Name: row.Cow_Name,
            Cow_CowshedNr: row.Cow_CowshedNr,
            Cow_Race: row.Cow_Race,
            Cow_Nr: row.Cow_Nr,
            Cow_Birth: abDate.format_Date(row.Cow_Birth),

            Farmer_Client_Name: row.Farmer_Client_Name,
            Farmer_Client_Address: row.Farmer_Client_Address + 
                    `, ${row.Farmer_Client_City}`,

            Farmer_HerdNr: row.Farmer_HerdNr,
            Farmer_HerdUnderGradeNr: row.Farmer_HerdUnderGradeNr,
            TreatmentNr: row.TreatmentNr,
            ReinseminationsCount: row.ReinseminationsCount,
            SemenProduction: abDate.format_Date(row.SemenProduction),

            Bull_Name: row.Bull_Name,
            Bull_ManufacturerNr: row.Bull_ManufacturerNr,
            Bull_Nr: row.Bull_Nr,
            Bull_Race: row.Bull_Race,

            Farmer_Client_Name: row.Farmer_Client_Name,
            InseminatorName: row.InseminatorName,
        };

        return row_Print;
    }

    formatReceiptNr(nr) {
        if (nr === 0)
            return '-';

        return 'MY' + abStrings.pad(String(nr), '0', 7);
    }

    getUriArg(module, argName) {
        js0.args(arguments, Module, 'string');

        return argName in module.pager.current.args ? 
                module.pager.current.args[argName] : null;
    }

    getResponseErrorInfo(response) {
        if ('webResult' in response.info) {
            let webResult = response.info.webResult;

            let webResultError = this.getWebResultErrorInfo(webResult);

            if (webResultError !== null)
                return webResultError;
        }

        if (response.type > abData.Response.Types_ResultFailure) {
            return {
                title: abText.$('Sys:Errors_Response_Other'),
                message: response.errorMessage,
            };
        } else if (response.type == abData.Response.Types_ResultFailure) {
            let resultError = abData.debug ? response.errorMessage : ''; 
            for (let requestId of response.requestIds) {
                let result = response.results[requestId];

                if (result.data !== null) {
                    if ('validator' in result.data) {
                        if (!result.data.validator.valid)
                            return null;
                    }
                }

                if (result.error !== null) {
                    if (resultError !== '')
                        resultError += ' ';
                    resultError += ' -> ' + response.results[requestId].error;
                }
            }

            return {
                title: abText.$('Sys:Errors_Response_ResultError'),
                message: resultError,
            };
        }

        return null;
    }

    getWebResultErrorInfo(webResult) {
        if (webResult.result === webABApi.Result.ErrorResults_Other) {
            return {
                title: abText.$('Sys:Errors_Response_Other'),
                message: webResult.message,
            }
        } else if (webResult.result === webABApi.Result.ErrorResults_HttpRequestError) {
            return {
                title: abText.$('Errors_Response_HttpRequestError'),
                message: '',
            };
        } else if (webResult.result === webABApi.Result.ErrorResults_CannotParseJSON) {
            return {
                title: abText.$('Sys:Errors_Response_CannotParseJSON'),
                message: webResult.data.data,
            };
        } else if (webResult.result === webABApi.Result.ErrorResults_WrongResultFormat) {
            return {
                title: abText.$('Errors_Response_WrongResultFormat'),
                message: '',
            };
        }

        return null;
    }

    parseApiResult(module, result, fn) {
        js0.args(arguments, Module, webABApi.Result, 'function');

        if (result.isSuccess())
            fn();
        else if (result.isFailure()) {
            if (module.f !== null) {
                if ('validator' in result.data) {
                    module.f.setValidator(result.data.validator);
                    module.msgs.hideLoading();
                    return;
                }
            }

            module.msgs.showMessage_Failure(abText.$('Sys:Errors_Error'), 
                    result.message);
            module.msgs.hideLoading();
        } else {
            let errorInfo = this.getWebResultErrorInfo(result);

            module.msgs.showMessage_Failure(errorInfo.title, errorInfo.message);
            module.msgs.hideLoading();
        }
    }

    parseRequestResponse(module, response, fn) {
        js0.args(arguments, Module, abData.Response, 
                'function');

        if (spocky.Debug)
            console.log('Api Result', module, response);

        let errorInfo = this.getResponseErrorInfo(response);

        if (errorInfo !== null) {
            module.msgs.showMessage_Failure(errorInfo.title, errorInfo.message);
            return false;
        }
        
        let actionError = response.actionErrors.request;
        let result = response.results.request;

        if (actionError !== null) {
            if (spocky.Debug)
                console.error(actionError);

            module.msgs.showMessage_Failure(abText.$(
                    'Sys:Errors_Response_ResultError'), actionError.message);
            return false;
        }

        fn(result);
        return true;
    }

    parseTableRequestResponse(tables, columns, response) {
        js0.args(arguments, Object, Array, abData.Response);

        if (spocky.Debug)
            console.log('Api Result',response);

        let errorInfo = this.getResponseErrorInfo(response);

        if (errorInfo !== null) {
            return {
                error: errorInfo.message,
                table: null,
            };
        }

        let result = response.results.request;

        if (result.error === null)
            result.data.table = tables.parseRows(columns, result.data.rows);

        return result;
    }

    setLayoutFields_List(module, panelTitle, panelName) {
        js0.args(arguments, Module, 'string', 'string');

        module.l.$fields = {
            title: abText.$(`Adm:Titles_${panelTitle}`),
            show: {
                add: true,
            },
            uris: {
                add: module.pager.getPageUri(`lb.subpanels.${panelName}.add`),
                back: module.pager.getPageUri('lb.main'),
            },
        };

        module.t = new spkTables.Table(this.msgs, eLibs.eField('tables').Routers)
            .setShowSearch(true)
            .setOnRefresh((rows, colRefs) => {
                
            })
            .setOnRowClick((row, colRefs) => {
                this.pager.setUri(row.href);
            }, (row, colRefs) => {
                return this.pager.getPageUri('lb.subpanels.routers.edit',
                        { id: row.cols[colRefs._Id].value, });
            });
        this.t.refresh();
    }
}


class tables_Class {

    format(rows, colRefs, colName, formatFn) {
        js0.args(arguments, Array, 'object', 'string', 'function');

        if (!(colName in colRefs))
            throw new Error(`Column '${colName}' does not exist in table`);

        for (let i = 0; i < rows.length; i++) {
            let col = rows[i].cols[colRefs[colName]];

            formatFn(col, rows[i]);
        }
    }

    formatBool(table, rows, colRefs, colName, onlyCheck = false) {
        js0.args(arguments, spkTables.Table, Array, 'object', 'string', 
                [ 'boolean', js0.Default ]);

        let colRef = colRefs[colName];

        table.l.$fields.table.headers(colRef).class = 'text-center';

        for (let i = 0; i < rows.length; i++) {
            let col = rows[i].cols[colRef];

            col.class = 'text-center';
            col.html = col.value ? 
                    '<i class="fa fa-check" />' : 
                    (onlyCheck ? '' : '<i class="fa fa-times" />');
        }
    }

    formatDate(rows, colRefs, colName) {
        js0.args(arguments, Array, 'object', 'string');

        this.format(rows, colRefs, colName, (col) => {
            col.html = col.value === null ? '-' : abDate.format_Date(col.value);
        });
    }

    formatDate_UTC(rows, colRefs, colName) {
        js0.args(arguments, Array, 'object', 'string');

        this.format(rows, colRefs, colName, (col) => {
            col.html = col.value === null ? '-' : abDate.format_Date_UTC(col.value);
        });
    }

    formatDateTime(rows, colRefs, colName) {
        js0.args(arguments, Array, 'object', 'string');

        let colRef = colRefs[colName];

        for (var i = 0; i < rows.length; i++) {
            var col = rows[i].cols[colRef];
            col.html = col.value === null ? '-' : abDate.format_DateTime(col.value);
        }
    }

}


class User_ManageAccount {

    constructor(module) {
        this.module = module;
        this.l = sys.createLayout($layouts.Users_ManageAccount);

        this.l.$elems.activate_Activate.addEventListener('click', (evt) => {
            evt.preventDefault();
            this._activate(true);
        });
        this.l.$elems.activate_Deactivate.addEventListener('click', (evt) => {
            evt.preventDefault();
            this._activate(false);
        });

        this.l.$elems.resetPassword.addEventListener('click', (evt) => {
            evt.preventDefault();
            this._resetPassword();
        });

        module.m.fm.m.lContent.$holders.user_ManageAccount.$view = this.l;
    }

    refresh_OnParseApiResult(data) {
        if (data.rUser === null) {
            this.l.$fields.show = false;
            return;
        }
        
        this.l.$fields.show = true;

        this.l.$fields.shows.activate = true;
        this.l.$fields.shows.deactivate = true;

        if (data.rUser.User_Active) {
            this.l.$fields.shows.activate = false;
            this.l.$fields.shows.deactivate = true;
        } else {
            this.l.$fields.shows.activate = true;
            this.l.$fields.shows.deactivate = false;
        }
    }


    _activate(active) {
        this.module.msgs.showLoading();

        webABApi.json(sys.uris.pages[`api.users`] + 'activate', 
                { id: this.module.m.fm.m.data.row.User__Id, 
                active: active, }, 
                (result) => {
            if (result.isSuccess())
                this.module.m.fm.m.refresh();
            else {
                this.module.msgs.showMessage_Failure(abText.$('Sys:Errors_Error'),
                        result.message);
                this.module.msgs.hideLoading();
            }
        });
    }

    _resetPassword() {
        this.module.msgs.showLoading();

        webABApi.json(sys.uris.pages[`api.users`] + 'reset-password', 
                { id: this.module.m.fm.m.data.row.User__Id, }, 
                (result) => {
            if (result.isSuccess()) {
                this.module.msgs.showMessage_Success(abText.$('Sys:Successes_Success'));
                this.module.msgs.hideLoading();
            } else {
                this.module.msgs.showMessage_Failure(result.message);
                this.module.msgs.hideLoading();
            }
        });
    }

}


class Module extends spocky.Module {

    get isLocked() {
        return App.GetInstance().isLocked;
    }

    constructor(lb) { super();
        js0.args(arguments, spkLemonBee.System);

        this.lb = lb;
        this.msgs = lb.msgs;
        this.pager = lb.pager;
        this.l = null;
        this.f = null;

        lb.setListener_OnBack(() => {
            if (this.pager.current.name === 'lb.main')
                return false;

            this.pager.setPage('lb.main');
            return true;
        });
    }

    eText(text, args = {}) {
        js0.args(arguments, 'string', [ Array, js0.Default ]);

        return abText.$(text, args);
    }

    lock() {
        App.GetInstance().lock();
    }

    unlock() {
        App.GetInstance().unlock();
    }

}


const sys = new sys_Class();



module.exports = sys;


module.exports.User_ManageAccount = User_ManageAccount;
module.exports.Module = Module;
 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\core\panels.js
jsLibs.exportModule('core', 'panels', (require, module, exports) => { 'use strict';

const
    abText = require('ab-text'),
    js0 = require('js0'),

    App = require('./App')
;   

class panels_Class {

    constructor() {
        this.cache = {};
    }

    create(mMain) {
        js0.args(arguments, require('./Main'));

        this.cache = {};

        let panels = [];
        let user = App.GetInstance().user;

        if (user.isFarmer) {
            panels.push(this.panels_NewReceipt(user));
            // panels.push(this.panels_NewReceipt_Shortcut(user));
            panels.push(this.panels_Receipts(user));
            panels.push(this.panels_Cows(user));
            panels.push(this.panels_Bulls(user));

            // let pAssociations = this.panels_Associations();
            // pAssociations['shortcut'] = false;
            // pAssociations['menu']['shortcut'] = false;
            // panels.push(pAssociations);

            panels.push(this.panels_About(user));
        } else if (user.isInseminator) {
            panels.push(this.panels_NewReceipt(user));
            panels.push(this.panels_Receipts(user));
            panels.push(this.panels_Farmers(user));

            let pCows = this.panels_Cows(user);
            pCows['shortcut'] = false;
            pCows['menu']['shortcut'] = false;
            panels.push(pCows);

            panels.push(this.panels_Bulls(user));

            // let pAssociations = this.panels_Associations();
            // pAssociations['shortcut'] = false;
            // pAssociations['menu']['shortcut'] = false;
            // panels.push(pAssociations);

            panels.push(this.panels_About(user));
        } else if (user.isClinic) {
            panels.push(this.panels_Receipts(user));
            panels.push(this.panels_Inseminators(user));
            panels.push(this.panels_Farmers(user));
            panels.push(this.panels_Cows(user));

            let pCows = this.panels_Cows(user);
            pCows['shortcut'] = false;
            pCows['menu']['shortcut'] = false;
            panels.push(pCows);

            panels.push(this.panels_Bulls(user));

            // let pAssociations = this.panels_Associations();
            // pAssociations['shortcut'] = false;
            // pAssociations['menu']['shortcut'] = false;
            // panels.push(pAssociations);

            panels.push(this.panels_About(user));
        } else if (user.isAdministrator) {
            panels.push(this.panels_Receipts(user));
            panels.push(this.panels_Farmers(user));
            panels.push(this.panels_Inseminators(user));
            panels.push(this.panels_Clinics(user));
            panels.push(this.panels_Bulls(user));
            panels.push(this.panels_Administrators(user));
            // panels.push(this.panels_Registrations(user));

            // panels.push(this.panels_Backups(user));

            let pCows = this.panels_Cows(user);
            pCows['shortcut'] = false;
            pCows['menu']['shortcut'] = false;
            panels.push(pCows);

            // let pAssociations = this.panels_Associations();
            // pAssociations['shortcut'] = false;
            // pAssociations['menu']['shortcut'] = false;
            // panels.push(pAssociations);
        }

        // if (App.Platform === 'web')
        // panels.push(this.panels_About(user));

        if (App.Platform === 'native') {
            // panels.push(this.panels_SetPrinter_Shortcut(user));
            // panels.push(this.panels_LogOut_Shortcut(user));
            // panels.push(this.panels_ClearData_Shortcut(user));
            panels.push(this.panels_Refresh_Shortcut(user));
        }

        return panels;
    }

    // createAll()
    // {
    //     let panels = [];

    //     panels.push(this.panels_Administrators(null));
    //     panels.push(this.panels_Associations(null));
    //     // panels.push(this.panels_Backups(null));
    //     panels.push(this.panels_Bulls(null));
    //     panels.push(this.panels_Cows(null));
    //     panels.push(this.panels_Farmers(null));
    //     panels.push(this.panels_Inseminators(null));
    //     panels.push(this.panels_NewReceipt(null));
    //     panels.push(this.panels_Receipts(null));
    //     // panels.push(this.panels_Registrations(null));

    //     // if (App.Platform === 'web')
    //     panels.push(this.panels_About(null));

    //     if (App.Platform === 'native') {
    //         panels.push(this.panels_ClearData_Shortcut(null));
    //         panels.push(this.panels_Refresh_Shortcut(null));
    //         panels.push(this.panels_LogOut_Shortcut(null));
    //     }

    //     return panels;
    // }

    panels_About(user) {
        let panel = this.createPanel_Basic('about', 'About');

        let subpanel = this.createSubpanel_Basic('spk-e-sys', 'about', 
                'About', 'basic', 'Basic', 'fas fa-cog');
        subpanel['shortcut'] = false;

        panel.subpanels.push(subpanel);

        return panel;
    }

    panels_Administrators() {
        let panel = this.createPanel_Basic('administrators', 'Administrators');
        this.addSubpanels_Table(panel, 'administrators', 'Administrators');

        return panel;
    }

    // panels_Associations()
    // {
    //     let panel = this.createPanel_Basic('associations', 'Associations');
    //     this.addSubpanels_Table(panel, 'associations', 'Associations');

    //     panel.subpanels[0].alias += '/:farmerId=0';
    //     panel.subpanels[1].alias += '/:farmerId=0';
    //     panel.subpanels[1]['shortcut'] = false;

    //     return panel;
    // }

    // panels_Backups()
    // {
    //     let panel = this.createPanel_Basic('backups', 'Backups');
    //     panel.faIcon = "fas fa-toolbox";

    //     let subpanel = this.createSubpanel_Basic('spk-e-sys', 'backups', 
    //             'Backups', 'basic', 'Basic', 'fas fa-toolbox');
    //     panel.subpanels.push(subpanel);

    //     return panel;
    // }

    panels_Bulls(user) {
        let panel = this.createPanel_Basic('bulls', 'Bulls');
        this.addSubpanels_Table(panel, 'bulls', 'Bulls');

        panel.subpanels[0].alias += '/:clientId=0';
        panel.subpanels[1].alias += '/:clientId=0/:newReceipt_CowId=0';
        panel.subpanels[2].alias += '/:clientId=0';

        // if (user !== null) {
        //     if (user.isInseminator || user.isFarmer) {
        //         panel.subpanels.splice(1, 1);

        //         let requestSubpanel = this.createSubpanel_Basic('spk-e-sys', 
        //                 'bulls', 'Bulls', 'request', 'Request', 'fas fa-edit');
        //         requestSubpanel.alias += '/:newReceipt_CowId=0';
        //         panel.subpanels.push(requestSubpanel);
        //     }
        // }

        return panel;
    }

    panels_ClearData_Shortcut() {
        let panel = this.createPanel_Basic('clearData_Shortcut', 'ClearData_Shortcut');

        panel['permissions'] = [];
        panel['faIcon'] = 'fas fa-trash',
        panel['shortcut'] = false;
        panel['menu']['action'] = () => {
            let app = App.GetInstance();

            app.mMain.msgs.showConfirmation(abText.$(
                    'Sys:Confirmations_ClearData'), '', abText.$(
                    'Sys:Text_Yes'), abText.$('Sys:Text_No'), 
                    (result) => {
                if (!result)
                    return;

                app.mMain.msgs.showLoading();

                console.log('Clearing data...');
                app.clearData_Async()
                    .then(() => {
                        console.log('Data cleared.');
                        
                        app.mMain.msgs.hideLoading();
                        app.mMain.pager.setPage(app.mMain.pager.current.name, 
                                app.mMain.pager.current.args);
                    })
                    .catch((e) => {
                        console.error(e);
    
                        app.mMain.msgs.showMessage_Failure(e.toString());
                        app.mMain.msgs.hideLoading();
                    });
            });
        }
        
        return panel;
    }

    panels_Clinics() {
        let panel = this.createPanel_Basic('clinics', 'Clinics');
        this.addSubpanels_Table(panel, 'clinics', 'Clinics');

        return panel;
    }

    panels_Cows() {
        let panel = this.createPanel_Basic('cows', 'Cows');
        this.addSubpanels_Table(panel, 'cows', 'Cows');

        panel.subpanels[0].alias += '/:farmerId=0';
        panel.subpanels[1].alias += '/:farmerId=0/:newReceipt=0';

        return panel;
    }

    panels_Farmers() {
        let panel = this.createPanel_Basic('farmers', 'Farmers');
        this.addSubpanels_Table(panel, 'farmers', 'Farmers');

        panel.subpanels[1].alias += '/:farmerId=0/:newReceipt=0';

        return panel;
    }

    panels_LogOut_Shortcut() {
        let panel = this.createPanel_Basic('logOut_Shortcut', 'LogOut_Shortcut');

        panel['permissions'] = [];
        panel['faIcon'] = 'fas fa-sign-out-alt',
        panel['shortcut'] = false;
        panel['menu']['action'] = () => {
            let app = App.GetInstance();

            app.mMain.msgs.showConfirmation(abText.$(
                    'Sys:Confirmations_LogOut'), '',
                    abText.$('Sys:Text_Yes'), abText.$('Sys:Text_No'), 
                    (result) => {
                if (!result)
                    return;

                app.mMain.msgs.showLoading();

                app.logOut_Async()
                    .then(() => {
                        console.log('Logged out.');
                        
                        app.mMain.msgs.hideLoading();
                        app.mMain.pager.setPage('lb.main');
                    })
                    .catch((e) => {
                        console.error(e);

                        app.mMain.msgs.showMessage_Failure(e.toString());
                        app.mMain.msgs.hideLoading();
                    });
            });
        }
        
        return panel;
    }

    panels_Inseminators() {
        let panel = this.createPanel_Basic('inseminators', 'Inseminators');
        this.addSubpanels_Table(panel, 'inseminators', 'Inseminators');

        return panel;
    }

    panels_NewReceipt() {
        let panel = this.createPanel_Basic('newReceipt', 'NewReceipt');

        let panelName = 'newReceipt';
        let panelTitle = 'NewReceipt';

        panel.subpanels.push(this.createSubpanel_Basic('spk-e-sys', 
                panelName, panelTitle, 'farmer', 'Farmer', 'fas fa-list'));
        
        let subpanel = null;
        
        subpanel = this.createSubpanel_Basic('spk-e-sys', panelName, 
                panelTitle, 'cow', 'Cow', 'fas fa-list');
        subpanel['alias'] += '/:farmerId=0';
        panel.subpanels.push(subpanel);

        subpanel = this.createSubpanel_Basic('spk-e-sys', panelName, panelTitle, 
                'bull', 'Bull', 'fas fa-list');
        subpanel['alias'] += '/:cowId/:clientId=0';
        subpanel['shortcut'] = false;
        panel.subpanels.push(subpanel);        

        subpanel = this.createSubpanel_Basic('spk-e-sys', panelName, 
                panelTitle, 'details', 'Details', 'fas fa-file');
        subpanel['alias'] += '/:cowId/:bullId';
        subpanel['shortcut'] = false;
        panel.subpanels.push(subpanel);

        return panel;
    }

    panels_NewReceipt_Shortcut(user) {
        let panel = this.createPanel_Basic('newReceipt_Shortcut', 'NewReceipt_Shortcut');

        // panel['shortcut'] = false;
        panel['alias'] = abText.$('Sys:Aliases_NewReceipt') + '/' +
                (user.isFarmer ? 
                (abText.$('Sys:Aliases_Cow') + '/0') :
                (abText.$('Sys:Aliases_Farmer')));

        panel['alias'] = panel['alias'].replace(/#/g, '');
        
        return panel;
    }

    panels_Receipts(user) {
        let panel = this.createPanel_Basic('receipts', 'Receipts');
        this.addSubpanels_Table(panel, 'receipts', 'Receipts');

        let isFarmer = user === null ? false : user.isFarmer;

        panel.subpanels[1]['moduleFn'] = null;        
        panel.subpanels[1]['uri'] = abNative_Base + 
                abText.$('Sys:Aliases_NewReceipt') + '/' +
                (isFarmer ? 
                (abText.$('Sys:Aliases_Cow') + '/0') :
                (abText.$('Sys:Aliases_Farmer')));

        if (user !== null) {
            if (user.isAdministrator || user.isClinic)
                panel.subpanels.splice(1, 1);
        }

        return panel;
    }

    // panels_Registrations()
    // {
    //     let panel = this.createPanel_Basic('registrations', 'Registrations');
    //     this.addSubpanels_Table(panel, 'registrations', 'Registrations');

    //     panel.subpanels.splice(1, 1);

    //     return panel;
    // }

    panels_SetPrinter_Shortcut(user) {
        let panel = this.createPanel_Basic('setPrinter_Shortcut', 'SetPrinter_Shortcut');

        panel['permissions'] = [];
        panel['faIcon'] = 'fas fa-print',
        panel['shortcut'] = false;
        panel['menu']['action'] = () => {
            let app = App.GetInstance();

            app.native.nativeActions.callNative_Async('SetPrinter', {})
                .then((result) => {
                    console.log('Setting Printer', result.success);
                })
                .catch((e) => {
                    
                });
        }
        
        return panel;
    }

    panels_Refresh_Shortcut(user) {
        let panel = this.createPanel_Basic('refresh_Shortcut', 'Refresh_Shortcut');

        panel['permissions'] = [];
        // panel['faIcon'] = 'fas fa-sync',
        panel['image'] = `${App.Base}res/images/panels/refresh.png`;
        panel['shortcut'] = false;
        panel['menu']['action'] = () => {
            let app = App.GetInstance();
            if (app.isLocked)
                return;

            app.lock();
            app.mMain.msgs.showLoading();
            app.syncDB_Helper_Async(true)
                .catch((e) => {
                    console.error(e);
                    return app.mMain.msgs.showMessage_Failure_Async(
                            abText.$('Sys:Errors_DBSync_Title'),
                            e.toString());
                })
                .finally(() => {
                    app.unlock();
                    app.mMain.pager.setPage(app.mMain.pager.current.name, 
                            app.mMain.pager.current.args);
                });
        }
        
        return panel;
    }


    /* Panels */
    createPanel_Basic(panelName, panelTitle) {
        js0.args(arguments, 'string', 'string');

        let panel = {
            'name': panelName,
            'permissions': [ `Sys_${panelTitle}` ],
            'alias': abText.$(`Sys:Aliases_${panelTitle}`).replace(/#/g, ''),
            'title': abText.$(`Sys:Titles_${panelTitle}`),
            'image': `${App.Base}res/images/panels/${panelName}.png`,

            'shortcut': true,

            'menu': {
                'shortcut': true,
                'uri': null,
                'action': null,
            },

            'subpanels': []
        };

        return panel;
    }

    createSubpanel_Basic(packageName, panelName, panelTitle, subpanelName, 
            subpanelTitle, faIcon) {
        js0.args(arguments, 'string', 'string', 'string', 'string', 'string', 
                'string');

        let subpanel = {
            'name': subpanelName,
            'moduleFn': (lb, page, source, pageArgs) => {
                if (abNative_Platform === 'web' && subpanelName === 'list') { 
                    if (page.name in this.cache) {
                        setTimeout(() => {
                            window.scrollTo(0, this.cache[page.name].scrollY);
                        }, 100);
                        this.cache[page.name].module.m.t.refresh();
                        return this.cache[page.name].module;
                    }
                }

                let module = new (require(`./panels/${panelName}`)
                        [subpanelTitle])(lb);

                if (abNative_Platform === 'web' && subpanelName === 'list') {
                    this.cache[page.name] = {
                        module: module,
                        scrollY: 0,
                    };
                }

                return module; 
            },
            'alias': abText.$(`Sys:Aliases_${subpanelTitle}`).replace(/#/g, ''),
            'title': abText.$(`Sys:Titles_${subpanelTitle}`),
            'faIcon': faIcon,
            'image': `${App.Base}res/images/panels/${subpanelName}.png`,
            
            'shortcut': true,
        };

        return subpanel;
    }

    addSubpanels_Table(panel, panelName, panelTitle) {
        panel.subpanels.push(this.createSubpanel_Basic('spk-e-sys', panelName, 
                panelTitle, 'list', 'List', 'fas fa-list'));
        panel.subpanels.push(this.createSubpanel_Basic('spk-e-sys', panelName, 
                panelTitle, 'add', 'Add', 'fas fa-plus'));
        panel.subpanels.push(this.createSubpanel_Basic('spk-e-sys', panelName, 
                panelTitle, 'edit', 'Edit', 'fas fa-edit'));
        panel.subpanels[0]['shortcut'] = false;
        panel.subpanels[1]['shortcut'] = false;
        panel.subpanels[2].alias += '/:id';
        panel.subpanels[2]['shortcut'] = false;
    }
    /* / Panels */

}
const panels = new panels_Class();



module.exports = panels;


 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\core\index.js
jsLibs.exportModule('core', 'index', (require, module, exports) => { 'use strict';

const
    abData = require('ab-data'),
    abDate = require('ab-date'),
    abText = require('ab-text'),
    js0 = require('js0'),
    spkForms = require('spk-forms'),
    spkMessages = require('spk-messages'),
    spkTables = require('spk-tables'),
    spocky = require('spocky'),
    webABApi = require('web-ab-api')
;

class core_Class {

    get sys() {
        return require('./sys');
    }

    get Actions() {
        return require('./Actions');
    }

    get App() {
        return require('./App');
    }

    get Component() {
        return require('./index.Component');
    }

    get PView() {
        return require('./index.PView');
    }


    constructor(viewName) {
        this._spk = null;
    }

    init(viewName, debug) {
        js0.args(arguments, 'string', 'boolean');

        // let test = [
        //     {

        //     }, {

        //     }
        // ];

        // let errors = [];
        // if (!js0.type(test, js0.Iterable(js0.Preset({
        //     test: [ 'string', js0.Null, js0.Default('Hello there') ],
        // })), errors)) {
        //     console.error('args errors', errors);
        // }

        // console.log(test);

        this._spk = new spocky.App()
            .config(($app, $cfg) => {
                $cfg
                    .container('_html_App', require(`./Main`));
            });

        spocky.ext(new spkForms.Ext());

        spocky.setDebug(debug);
        abData.setDebug(debug);
        spkForms.setDebug(debug); 
        webABApi.setDebug(debug);
        if (abNative_Platform !== 'web')
            webABApi.setRequestTimeout(this.App.ConnectionTimeout);
            
        abDate.formats_Date = 'DD.MM.YYYY';
        abDate.formats_DateTime = 'DD.MM.YYYY HH:mm';
        abDate.formats_Time = 'HH:mm';

        spkForms.setLang('pl');
        spkMessages.setTextFn((text) => {
            return abText.$('Sys:SPKMessages_' + text);
        });

        this._spk.init(debug);
    }

}
const core = new core_Class();



module.exports = core;


 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\core\tables.js
jsLibs.exportModule('core', 'tables', (require, module, exports) => { 'use strict';

const
    abStrings = require('ab-strings'),
    abText = require('ab-text'),
    js0 = require('js0'),

    helper = require('./helper'),
    sys = require('./sys'),

    App = require('./App')
;   

class tables_Class {

    tables_Administrators() {
        let app = App.GetInstance();

        let columns = [
            {
                name: '_Id',
                header: abText.$('Sys:TableHeaders_Id'),
                filter: false,
            }, {
                name: 'Name',
                header: abText.$('Sys:TableHeaders_FirstName'),
                orderBy: {
                    priority: 1,
                    reverse: false,
                },
            }, {
                name: 'User_Email',
                header: abText.$('Sys:TableHeaders_Email'),
            }
        ];

        return {
            hiddenColumnNames: [ '_Id' ],
            columns: columns,
            apiUri: null,
            fn: async (fields) => {
                let response = await app.ds.request_Async('Sys_Administrators', 
                        'select', {
                    args: fields,
                });

                return sys.parseTableRequestResponse(this, columns, response);
            },
            orderBy: { 
                columnName: 'Name', 
                reverse: false,
            },
            showInstantLoading: abNative_Platform !== 'web',
        };
    }

    tables_AssociatedBulls() {
        let app = App.GetInstance();

        let tableInfo = {
            columns: [
                {
                    name: 'Bull__Id',
                    header: abText.$('Sys:TableHeaders_Id'),
                }, {
                    name: 'Bull_Name',
                    header: abText.$('Sys:TableHeaders_Name'),
                }, {
                    name: 'Bull_Nr',
                    header: abText.$('Sys:TableHeaders_Nr'),
                }, {
                    name: 'Bull_Race',
                    header: abText.$('Sys:TableHeaders_Race'),
                }, {
                    name: 'ClientBull_StrawsConvCount_Client',
                    header: abText.$('Sys:TableHeaders_StrawsConvCount'),
                }, {
                    name: 'Inb',
                    header: abText.$('Sys:TableHeaders_Inb'),
                }
            ],
            orderBy: {
                columnName: 'Bull_Name', 
                reverse: true,
            },
        };

        return {
            hiddenColumnNames: [ 'Bull__Id' ],
            columns: tableInfo.columns,
            orderBy: tableInfo.orderBy,

            apiUri: null,
            fn: null,

            showInstantLoading: abNative_Platform !== 'web',
        };
    }

    tables_Associations() {
        let app = App.GetInstance();

        let columns = [
            {
                name: 'Cow_Nr',
                header: abText.$('Sys:TableHeaders_Cow'),
            }, {
                name: 'Cow_Name',
                header: abText.$('Sys:TableHeaders_Cow_FirstName'),
            }, {
                name: 'Bull_Name',
                header: abText.$('Sys:TableHeaders_Bull'),
            }, {
                name: 'Inb',
                header: abText.$('Sys:TableHeaders_Inb'),
            }
        ];

        return {
            columns: columns,
            apiUri: null,
            fn: async (fields) => {
                let response  = await app.ds.request_Async(`Sys_Associations`, 'select', {
                    args: fields,
                });
                
                return sys.parseTableRequestResponse(this, columns, response);
            },
            orderBy: {
                columnName: 'Bull_Name', 
                reverse: true,
            },

            showInstantLoading: abNative_Platform !== 'web',
        };
    }

    tables_Bulls() {
        let app = App.GetInstance();

        let columns = [
            {
                name: '_Id',
                header: abText.$('Sys:TableHeaders_Id'),
                filter: false,
            }, {
                name: '_Modified_DateTime',
                header: abText.$('Sys:TableHeaders_Modified_Datetime'),
            }, {
                name: 'ClientBull__Id',
                header: abText.$('Sys:TableHeaders_Id'),
            }, {
                name: 'ClientBull__Modified_DateTime',
                header: abText.$('Sys:TableHeaders_Modified_Datetime'),
            }, {
                name: 'Name',
                header: abText.$('Sys:TableHeaders_Name'),
                orderBy: {
                    priority: 2,
                    reverse: false,
                },
            }, {
                name: 'Nr',
                header: abText.$('Sys:TableHeaders_Nr'),
            }, {
                name: 'Race',
                header: abText.$('Sys:TableHeaders_Race'),
            }, {
                name: 'Client__Id',
                header: abText.$('Sys:TableHeaders_CustomBull'),
            }, {
                name: 'Client_Name',
                header: abText.$('Sys:TableHeaders_Client'),
            // }, {
            //     name: 'Added_Date',
            //     header: abText.$('Sys:TableHeaders_Added'),
            }
        ];

        return {
            hiddenColumnNames: [ '_Id', '_Modified_DateTime',  
                    'ClientBull__Id', 'ClientBull__Modified_DateTime', ],
            columns: columns,
            apiUri: null,
            fn: async (fields) => {
                let response = await app.ds.request_Async(`Sys_Bulls`, 'select', {
                    args: fields,
                });

                return sys.parseTableRequestResponse(this, columns, response);
            },
            orderBy: { 
                columnName: 'Name',
                reverse: false,
            },
            
            showInstantLoading: abNative_Platform !== 'web',
        };
    }
    
    tables_Clinics() {
        let app = App.GetInstance();

        let columns = [
            {
                name: '_Id',
                header: abText.$('Sys:TableHeaders_Id'),
                filter: false,
            }, {
                name: 'Client_Name',
                header: abText.$('Sys:TableHeaders_FirstName'),
                orderBy: {
                    priority: 1, 
                    reverse: false, 
                },
            }, {
                name: 'User_Email',
                header: abText.$('Sys:TableHeaders_Email'),
            },
        ];

        return {
            hiddenColumnNames: [ '_Id' ],
            columns: columns,
            apiUri: null,
            fn: async (fields) => {
                let response = await app.ds.request_Async('Sys_Clinics', 
                        'select', {
                    args: fields,
                });
                
                return sys.parseTableRequestResponse(this, columns, response);
            },
            orderBy: { 
                columnName: 'Client_Name', 
                reverse: false,
            },
            showInstantLoading: abNative_Platform !== 'web',
        };
    }

    tables_CowHistory() {
        let app = App.GetInstance();

        let columns = [
            {
                name: 'Date',
                header: abText.$('Sys:TableHeaders_Date'),
            }, {
                name: 'Nr_Formatted',
                header: abText.$('Sys:TableHeaders_Nr'),
            }, {
                name: 'Bull_Name',
                header: abText.$('Sys:TableHeaders_BullName'),
            }, {
                name: 'TreatmentNr',
                header: abText.$('Sys:TableHeaders_TreatmentNr'),
            },
        ];

        return {
            columns: columns,
            apiUri: null,
            fn: async (fields) => {
                let response = await app.ds.request_Async('Sys_CowHistory', 
                        'select', {
                    args: fields,
                });

                return sys.parseTableRequestResponse(this, columns, response);
            },
            orderBy: { 
                columnName: 'Date', 
                reverse: false,
            },
            
            showInstantLoading: abNative_Platform !== 'web',
        };
    }

    tables_Cows() {
        let app = App.GetInstance();

        let columns = [
            {
                name: '_Id',
                header: abText.$('Sys:TableHeaders_Id'),
                filter: false,
            }, {
                name: '_Modified_DateTime',
                header: abText.$('Sys:TableHeaders_Modified_DateTime'),
            }, {
                name: 'Name',
                header: abText.$('Sys:TableHeaders_FirstName'),
            }, {    
                name: 'Nr',
                header: abText.$('Sys:TableHeaders_Nr'),
            }, {
                name: 'CowshedNr',
                header: abText.$('Sys:TableHeaders_CowshedNr'),
            }, {
                name: 'Added_Date',
                header: abText.$('Sys:TableHeaders_Added'),
            }, {
                name: 'LastReceipt_Date',
                header: abText.$('Sys:TableHeaders_LastInsemination'),
            }
        ];

        // let cowHistory_TableInfo = this.tables_CowHistory();

        return {
            hiddenColumnNames: [ '_Id', '_Modified_DateTime', 'Added_Date' ],
            columns: columns,
            apiUri: null,
            fn: async (fields) => {
                let response = await app.ds.request_Async('Sys_Cows', 'select', {
                    args: fields,
                });
                
                return sys.parseTableRequestResponse(this, columns, response);
            },
            orderBy: { 
                columnName: 'Nr', 
                reverse: false,
            },
            
            showInstantLoading: abNative_Platform !== 'web',
        };
    }

    tables_Farmers() {
        let app = App.GetInstance();

        let columns = [
            {
            //     name: 'OrdinalNumber',
            //     'refColumnName': null,
            //     header: abText.$('Sys:TableHeaders_OrdinalNumber'),
            // }, {
                name: '_Id',
                header: abText.$('Sys:TableHeaders_Id'),
                filter: false,
            }, {
                name: '_Modified_DateTime',
                header: abText.$('Sys:TableHeaders_Modified_Datetime'),
            }, {
                name: 'Client__Modified_DateTime',
                header: abText.$('Sys:TableHeaders_Modified_Datetime'),
            }, {
                name: 'Client_Name',
                header: abText.$('Sys:TableHeaders_FirstName'),
                orderBy: {
                    priority: 1,
                    reverse: false,
                },
            }, {
                name: 'Client_City',
                header: abText.$('Sys:TableHeaders_City'),
            }, {
                name: 'HerdUnderGradeNr',
                header: abText.$('Sys:TableHeaders_HerdUnderGradeNr'),
            }, {
                name: 'User_Email',
                header: abText.$('Sys:TableHeaders_Email'),
            }, {
                name: 'Inseminator_Client_Name',
                header: abText.$('Sys:TableHeaders_Inseminator'),
                filter: false,
            }, {
                name: 'Clinic_Client_Name',
                header: abText.$('Sys:TableHeaders_Clinic'),
                filter: false,
            }, 
        ];

        return {
            hiddenColumnNames: [ '_Id', '_Modified_DateTime',
                    'Client__Modified_DateTime' ],
            columns: columns,
            apiUri: null,
            fn: async (fields) => {
                let response = await app.ds.request_Async('Sys_Farmers', 'select', {
                    args: fields,
                });
                
                return sys.parseTableRequestResponse(this, columns, response);
            },
            orderBy: { 
                columnName: 'Client_Name', 
                reverse: false,
            },
            
            showInstantLoading: abNative_Platform !== 'web',
        };
    }

    tables_Inseminators() {
        let app = App.GetInstance();

        let columns = [
            {
            //     name: 'OrdinalNumber',
            //     'refColumnName': null,
            //     header: abText.$('Sys:TableHeaders_OrdinalNumber'),
            // }, {
                name: '_Id',
                header: abText.$('Sys:TableHeaders_Id'),
                filter: false,
            }, {
                name: 'Client_Name',
                header: abText.$('Sys:TableHeaders_FirstName'),
                orderBy: {
                    priority: 1,
                    reverse: false,
                },
            }, {
                name: 'Client_SymlekId',
                header: abText.$('Sys:TableHeaders_SymlekId'),
            }, {
                name: 'User_Email',
                header: abText.$('Sys:TableHeaders_Email'),
            }, {
                name: 'Clinic_Client_Name',
                header: abText.$('Sys:TableHeaders_Clinic'),
                filter: false,
            },
        ];

        return {
            hiddenColumnNames: [ '_Id' ],
            columns: columns,
            apiUri: null,
            fn: async (fields) => {
                let response = await app.ds.request_Async('Sys_Inseminators', 
                        'select', {
                    args: fields,
                });

                return sys.parseTableRequestResponse(this, columns, response);
            },
            orderBy: { 
                columnName: 'Client_Name', 
                reverse: false,
            },
            
            showInstantLoading: abNative_Platform !== 'web',
        };
    }

    tables_Receipts() {
        let app = App.GetInstance();

        let tableInfo = {
            columns: [
                {
                    name: '_Id',
                    header: abText.$('Sys:TableHeaders_Id'),
                    filter: false,
                    orderBy: {
                        priority: 10, 
                        reverse: true,
                    },
                }, {
                    name: '_Modified_DateTime',
                    header: abText.$('Sys:TableHeaders_Modified_Datetime'),
                    filter: false,
                }, {
                    name: 'Nr',
                    header: abText.$('Sys:TableHeaders_Nr'),
                }, {
                    name: 'Date',
                    header: abText.$('Sys:TableHeaders_InseminationDate'),
                    filter: false,
                    orderBy: {
                        priority: 101, 
                        reverse: true,
                    },
                }, {
                    name: 'Added',
                    header: abText.$('Sys:TableHeaders_Added'),
                    orderBy: {
                        priority: 100,
                        reverse: true,
                    },
                    filter: false,
                }, {
                    name: 'Farmer_Client_Name',
                    header: abText.$('Sys:TableHeaders_Farmer'),
                }, {
                    name: 'Farmer_HerdUnderGradeNr',
                    header: abText.$('Sys:TableHeaders_HerdUnderGradeNr'),
                    filter: false,
                }, {
                    name: 'InseminatorName',
                    header: abText.$('Sys:TableHeaders_Inseminator'),
                }, {
                    name: 'Cow_Nr',
                    header: abText.$('Sys:TableHeaders_Cow'),
                }, {
                    name: 'Cow_Name',
                    header: abText.$('Sys:TableHeaders_Name'),
                }, {
                    name: 'Bull_Name',
                    header: abText.$('Sys:TableHeaders_Bull'),
                }, {
                    name: 'Clinic_Client_Name',
                    header: abText.$('Sys:TableHeaders_Clinic'),
                }, {
                    name: 'Downloaded',
                    header: abText.$('Sys:TableHeaders_Symlek'),
                }, {
                    name: 'Downloaded_Client',
                    header: abText.$('Sys:TableHeaders_Downloaded'),
                }, {
                    name: 'Error',
                    header: abText.$('Sys:TableHeaders_Error'),
                },
            ],
            orderBy: { 
                columnName: 'Error', 
                reverse: true,
            },
        };

        return {
            hiddenColumnNames: [ '_Id', '_Modified_DateTime', 
                    'Farmer_HerdUnderGradeNr', 'Cow_Name', 'Error', ],

            columns: tableInfo.columns,
            orderBy: tableInfo.orderBy,

            apiUri: null,
            fn: async (fields) => {
                fields.tableInfo = tableInfo;
                let response = await app.ds.request_Async('Sys_Receipts', 
                        'select', {
                    args: fields,
                });

                return sys.parseTableRequestResponse(this, tableInfo.columns, 
                        response);
            },
            
            showInstantLoading: abNative_Platform !== 'web',
        };
    }

    tables_Registrations() {
        let app = App.GetInstance();

        let columns = [
            {
                name: 'Id',
                header: abText.$('Sys:TableHeaders_Id'),
                filter: false,
            }, {
                name: 'Name',
                header: abText.$('Sys:TableHeaders_Name'),
            }, {
                name: 'Type',
                header: abText.$('Sys:TableHeaders_RegistrationType'),
            }, {
                name: 'DateTime',
                header: abText.$('Sys:TableHeaders_Date'),
            },
        ];

        return {
            hiddenColumnNames: [ '_Id' ],
            columns: columns,
            apiUri: null,
            fn: async (fields) => {
                let response = await app.ds.request_Async('Sys_Registrations', 
                        'select', {
                    args: fields,
                });

                return sys.parseTableRequestResponse(this, columns, response);
            },
            orderBy: { 
                columnName: 'DateTime', 
                reverse: true,
            },
            
            showInstantLoading: abNative_Platform !== 'web',
        };
    }


    parseRows(columns, rows) {
        let rows_Parsed = [];

        for (let row of rows) {
            let row_Parsed = [];
            for (let column of columns) {
                let columnName = column.name;
                if ('refColumnName' in column) {
                    if (column.refColumnName === null) {
                        row_Parsed.push(null);
                        continue;
                    }

                    columnName = column.refColumnName;
                }

                if (!(columnName in row))
                    throw new Error(`No column '${columnName}' in row.`);

                row_Parsed.push(row[columnName]);
            }

            rows_Parsed.push(row_Parsed);
        }

        return rows_Parsed;
    }

}
const tables = new tables_Class();



module.exports = tables;


 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\core\panels\administrators.js
jsLibs.exportModule('core', 'panels/administrators', (require, module, exports) => { 'use strict';
'use strict';

const
    spkForms = require('spk-forms'),

    modules = require('../modules'),
    sys = require('../sys'),

    $layouts = require('../$layouts')
;


let panelName = 'administrators';
let panelTitle = 'Administrators';


class Add extends sys.Module {

    constructor(lb) { super(lb);
        this.m = new modules.Add(lb, panelName, panelTitle, Form);

        this.$view = this.m;
    }

}


class Edit extends sys.Module {

    constructor(lb) { super(lb);
        this.m = new modules.Edit(lb, panelName, panelTitle, Form);

        this.user_ManageAccount = new sys.User_ManageAccount(this);

        let refresh_OnParseApiResult = this.m.fm.m.refresh_OnParseApiResult;
        this.m.fm.m.refresh_OnParseApiResult = (data) => {
            refresh_OnParseApiResult(data);

            this.user_ManageAccount.refresh_OnParseApiResult(data);

            if (data.row !== null) {
                this.m.fm.m.l.$fields.shows.delete = true;
            }
        };

        this.m.fm.m.refresh();

        this.$view = this.m;
    }

}


class Form extends sys.Module {

    get id() {
        if (this.data !== null)
            return this.data.row._Id;

        return 'id' in this.pager.current.args ? this.pager.current.args.id : null;
    }


    constructor(lb, create = false) { super(lb);
        this.m = new modules.Form(lb, panelName, panelTitle, create);

        this.lButtons = this.lButtons = sys.createLayout($layouts[
                `${panelTitle}_Form_Buttons`]);

        this.lUser = sys.createLayout($layouts.Users_Form);
        this.lUser.$fields.isNew = create;
        this.m.f.l.$holders.userForm.$view = this.lUser;
        this.fUser = new spkForms.Form(this.lUser, 'Form');

        this.m.refresh_OnParseApiResult = (data) => {
            if (this.m.data.rUser !== null)
                this.fUser.setValues(this.m.data.rUser);
        };
        this.m.submit_OnSetApiFields = (fields) => {
            fields.user = this.fUser.getValues();

            return fields;
        };
        this.m.submit_OnValidator = (validator) => {
            this.fUser.setValidator(validator);
        };


        this.m.l.$holders.Buttons_After.$view = this.lButtons;
        this.$view = this.m;
    }

}


class List extends sys.Module {
    constructor(lb) { super(lb);
        this.m = new modules.List(lb, panelName, panelTitle)

        this.m.t.refresh();

        this.$view = this.m;
    }

}





module.exports.Add = Add;
module.exports.Edit = Edit;
module.exports.Form = Form;
module.exports.List = List;
 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\core\panels\associations.js
jsLibs.exportModule('core', 'panels/associations', (require, module, exports) => { 'use strict';

const
    abText = require('ab-text'),
    spkFileUpload = require('spk-file-upload'),
    spkForms = require('spk-forms'),
    spkTables = require('spk-tables'),
    webABApi = require('web-ab-api'),

    // farmers = require('./farmers'),
    
    App = require('../App'),

    modules = require('../modules'),
    sys = require('../sys'),
    tables = require('../tables'),

    $layouts = require('../$layouts')
;


let panelName = 'associations';
let panelTitle = 'Associations';


class Add extends sys.Module {

    constructor(lb) { super(lb);
        this.m = new modules.Add(lb, panelName, panelTitle, Form);

        this.m.fm.m.l.$fields = {
            shows: {
                delete: false,
            },
        };

        if (this.pager.current.args.newReceipt !== '0') {
            this.m.fm.m.l.$fields = {
                texts: {
                    title: abText.$(`Sys:Titles_NewReceipt_Cow`),
                },
            },

            this.m.fm.m.onSubmit = (result) => {
                this.unlock();
                this.pager.setPage(`lb.subpanels.newReceipt.bull`, 
                        { associationId: result.data.row._Id, });
            }
        } else {
            this.m.fm.m.onSubmit = (result) => {
                this.unlock();
                this.pager.setPage(`lb.subpanels.${panelName}.list`, 
                        { farmerId: this.pager.current.args.farmerId });
            }
        }

        this.$view = this.m;
    }

}


class Edit extends sys.Module {

    constructor(lb) { super(lb);
        this.m = new modules.Edit(lb, panelName, panelTitle, Form);

        this.$view = this.m;
    }

}


class Form extends sys.Module {

    get id() {
        if (this.data !== null)
            return this.data.row._Id;

        return 'id' in this.pager.current.args ? this.pager.current.args.id : null;
    }


    constructor(lb, create = false) { super(lb);
        this.m = new modules.Form(lb, panelName, panelTitle, create);

        this.associationHistory_Table = new spkTables.Table(this.msgs, 
                tables.tables_CowHistory())
            .setOnRefresh((rows, colRefs) => {
                sys.tables.formatDate(rows, colRefs, 'Date');
            });
        this.m.lContent.$holders.associationHistory.$view = this.associationHistory_Table;

        this.m.onDelete = () => {
            this.unlock();
            this.pager.setPage(`lb.subpanels.${panelName}.list`, 
                    { farmerId: this.m.data.row.Farmer__Id, });
        }

        this.m.refresh_OnSetApiFields = (fields) => {
            fields.farmerId = this.pager.current.args.farmerId;

            return fields;
        };
        this.m.refresh_OnParseApiResult = (data) => {
            let farmerId = data.rFarmer === null ? 0 : data.rFarmer._Id;

            if (create && this.pager.current.args.newReceipt !== '0') {
                this.m.l.$fields = {
                    uris: {
                        back: sys.user.info.Farmer__Id !== null ?
                                this.pager.getPageUri(`lb.subpanels.newReceipt.association`) :
                                this.pager.getPageUri(`lb.subpanels.newReceipt.association`, 
                                { farmerId: farmerId, }),
                    },
                };
            } else {
                this.m.l.$fields = {
                    uris: {
                        back: this.pager.getPageUri(`lb.subpanels.${panelName}.list`, 
                                { farmerId: farmerId, }),
                    },
                };
            }

            if (data.associationHistory_Rows !== null) {
                this.m.lContent.$fields.shows.associationHistory = true;
                this.associationHistory_Table.update(tables.parseRows(
                        tables.tables_CowHistory().columns, data.associationHistory_Rows));
            } else
                this.m.lContent.$fields.shows.associationHistory = false;
        }
        this.m.submit_OnSetApiFields = (fields) => {
            fields.farmerId = this.pager.current.args.farmerId;

            return fields;
        };

        this.$view = this.m;
    }

}


class List extends sys.Module {
    constructor(lb) { super(lb);
        this.m = new modules.List(lb, panelName, panelTitle)

        lb.setBackButton(true);
        lb.setListener_OnBack(() => {
            this.m.listeners_Back();
            return true;
        });

        this.m.l.$fields.shows.add = false;

        this.m.l.$fields = {
            uris: {
                back: sys.user.info.Farmer__Id !== null ?
                        this.pager.getPageUri(`lb.subpanels.cows.list`) :
                        this.pager.getPageUri(`lb.subpanels.cows.list`, 
                        { farmerId: this.pager.current.args.farmerId, }),
            },
        };
        this.m.listeners_Back = () => { 
            this.pager.setPage(sys.user.info.Farmer__Id !== null ?
                    'lb.subpanels.cows.list' :
                    'lb.subpanels.cows.list', 
                    { farmerId: this.pager.current.args.farmerId, });
        };

        /* Buttons */
        if (App.Platform === 'web') {
            this.lButtons = sys.createLayout($layouts[`${panelTitle}_List_Buttons`]);

            this.upload_FileUpload = new spkFileUpload.FileUpload((files) => {
                this._upload(files);
            }, '.pdf');
            this.lButtons.$elems.upload.addEventListener('click', (evt) => {
                evt.preventDefault();
                this.upload_FileUpload.upload();
            });

            this.lButtons.$elems.deleteAll.addEventListener('click', (evt) => {
                evt.preventDefault();
                this._deleteAll();
            });

            this.m.l.$holders.Buttons_Before.$view = this.lButtons;
        }
        /* / Buttons */

        this.m.refresh_SetOnRefresh = (rows, colRefs) => {
            
        };

        this.m.t.setApiFields((fields) => {
            return {
                farmerId: this.pager.current.args.farmerId,
            };
        });
        this.m.t.setOnRowClick(null);

        this.m.t.refresh();

        this.$view = this.m;
    }


    _deleteAll() {
        this.msgs.showConfirmation(abText.$(
                'Sys:Confirmations_DeleteAssociations'), '', abText.$(
                'Sys:Text_Yes'), abText.$('Sys:Text_No'), (result) => {
            if (!result)
                return;

            this.msgs.showLoading();
            webABApi.json(sys.uris.pages['api.associations'] + 'delete-all',
                    { farmer_Id: this.pager.current.args.farmerId, },
                    (result) => {
                sys.parseApiResult(this, result, () => {
                    if ('warningMessage' in result.data) {
                        this.msgs.showMessage_Failure(result.data.warningMessage, () => {
                            this.m.t.refresh();
                        });
                        this.msgs.hideLoading();
                    } else
                        this.m.t.refresh();
                });
            });
        });
    }

    _upload(files) {
        this.msgs.showLoading();
        webABApi.upload(sys.uris.pages['api.associations'] + 'upload', {},
                { farmer_Id: this.pager.current.args.farmerId, file: files[0] },
                (result) => {
            sys.parseApiResult(this, result, () => {
                if ('warningMessage' in result.data) {
                    this.msgs.showMessage_Failure(abText.$('Sys:Warnings_Warning'), result.data.warningMessage, 
                            () => {
                        this.m.t.refresh();
                    });
                    this.msgs.hideLoading();
                } else
                    this.m.t.refresh();
            });
        });
    }

}






module.exports.Add = Add;
module.exports.Edit = Edit;
module.exports.Form = Form;
module.exports.List = List;
 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\core\panels\about.js
jsLibs.exportModule('core', 'panels/about', (require, module, exports) => { 'use strict';

const 
    abText = require('ab-text'),
    spkForms = require('spk-forms'),
    webABApi = require('web-ab-api'),

    sys = require('../sys'),

    App = require('../App'),
    
    $layouts = require('../$layouts')
;


class Basic extends sys.Module {

    constructor(lb) { super(lb);
        let app = App.GetInstance();

        this.l = sys.createLayout($layouts.About_Basic);
        this.l.$fields.AppId = '-';
        this.l.$fields.AppVersion = '-';
        this.l.$fields.DeviceId = '-';
        this.l.$fields.IsNative = App.Platform === 'native';
        this.l.$fields.PrinterSet = false;
        this.l.$fields.UserName = sys.user.info_Client.Name;

        this.l.$fields = {
            uris: {
                back: this.pager.getPageUri('lb.main'),
            },
        };

        // this.l.$elems.back.addEventListener('click', (evt) => {
        //     evt.preventDefault();
        //     this.pager.setPage('lb.main');
        // });

        if (App.Platform === 'native') {
            this.l.$fields.AppId = App.GetInstance().getAppInfo().appId;
            this.l.$fields.AppVersion = App.GetInstance().appVersion;
            this.l.$fields.DeviceId = app.ds.device.id;
            this.l.$fields.PrinterSet = App.GetInstance().native.printer !== null;

            this.l.$elems.SetPrinter.addEventListener('click', (evt) => {
                evt.preventDefault();
                this.setPrinter();
            });
            this.l.$elems.RemovePrinter.addEventListener('click', (evt) => {
                evt.preventDefault();
                this.removePrinter_Async();
            });
            this.l.$elems.ReportProblem.addEventListener('click', (evt) => {
                evt.preventDefault();
                this.reportProblem_Async();
            });
            this.l.$elems.ClearData.addEventListener('click', (evt) => {
                evt.preventDefault();
                this.clearData_Async();
            });
            this.l.$elems.LogOut.addEventListener('click', (evt) => {
                evt.preventDefault();
                this.logOut_Async();
            });

            this.l.$elems.OfflineMode.addEventListener('change', (evt) => {
                app.setOfflineMode(this.l.$elems.OfflineMode.checked);
            });
            this.l.$elems.OfflineMode.checked = app.isOfflineModeActive;

            app.native.setListener_OnPrinterSet((printer) => {
                this.l.$fields.PrinterSet = printer !== null;
            });
        }

        // if (App.Platform === 'web') {
        //     this.f = new spkForms.Form(this.l, 'Form');
        //     this.l.$elems.SendContactForm.addEventListener('click', (evt) => {
        //         evt.preventDefault();
        //         this.sendContactForm();
        //     });
        // }

        app.mMain.msgs.hideLoading();

        this.$view = this.l;
    }
    
    async clearData_Async() {
        let app = App.GetInstance();

        if (app.isOfflineModeActive) {
            let result_GoOnline = await this.msgs.showConfirmation_Async(
                    abText.$(
                    'Sys:Confirmations_GoOnline_Title'),
                    abText.$(
                    'Sys:Confirmations_GoOnline_Message'), 
                    abText.$('Sys:Text_Yes'), abText.$('Sys:Text_No'));
            if (result_GoOnline) {
                this._testConnectionResult = -1;
                app.setOfflineMode(false);
            } else
                return;
        }

        if (!(await app.mMain.msgs.showConfirmation_Async(
                abText.$('Sys:Confirmations_ClearData'), '', 
                abText.$('Sys:Text_Yes'), abText.$('Sys:Text_No'))))
            return;

        if (await app.isConnectedToInternet_Async())
            this._clearData_SendUnsyncedData_Async();
        else
            this._clearData_CannotSendUnsyncedData_Async();
    }

    logOut_Async() {
        let app = App.GetInstance();

        app.mMain.msgs.showConfirmation(abText.$('Sys:Confirmations_LogOut'), '',
                abText.$('Sys:Text_Yes'), abText.$('Sys:Text_No'), (result) => {
            if (!result)
                return;

            app.mMain.msgs.showLoading();

            app.logOut_Async()
                .then(() => {
                    app.mMain.msgs.hideLoading();
                    app.mMain.pager.setPage('lb.main');
                })
                .catch((e) => {
                    console.error(e);

                    app.mMain.msgs.showMessage_Failure(e.toString());
                    app.mMain.msgs.hideLoading();
                });
        });
    }

    async removePrinter_Async() {
        let app = App.GetInstance();
        await app.native.removePrinter_Async();
        this.l.$fields.PrinterSet = App.GetInstance().native.printer !== null;
    }

    async reportProblem_Async() {
        let app = App.GetInstance();

        app.mMain.msgs.showConfirmation(abText.$('Sys:Confirmations_ReportProblem'), '',
                abText.$('Sys:Text_Yes'), abText.$('Sys:Text_No'), async (confirmed) => {
            if (!confirmed)
                return;

            app.mMain.msgs.showLoading();

            let data = await this._getUnsyncedData_Async();

            let result = await webABApi.json_Async(app.apiUri + 'app/report-problem', {
                appId: app.getAppInfo().appId,
                authenticationHash: app.getAppInfo().authenticationHash,
                data: data,
            });

            if (result.isSuccess()) {
                app.mMain.msgs.showMessage_Success(abText.$(
                        'Sys:Successes_ProblemReportSent'));
            } else {
                app.mMain.msgs.showMessage_Failure(abText.$(
                    'Sys:Errors_CannotSendProblemReport'), result.message);
            }

            app.mMain.msgs.hideLoading();
        });
    }

    sendContactForm() {
        this.msgs.showLoading();

        let fields = this.f.getValues();
        webABApi.json(sys.uris.pages['api.about'] + 'send-contact-form',
                fields, (result) => {
            sys.parseApiResult(this, result, () => {
                this.f.setValues({
                    Message: '',
                });

                this.msgs.hideLoading();
                this.msgs.showMessage_Success(abText.$('Sys:Successes_Success'));
            });
        });
    }

    setPrinter() {
        let app = App.GetInstance();
        app.native.nativeActions.callNative_Async('SetPrinter');
    }


    async _clearData_CannotSendUnsyncedData_Async() {
        let app = App.GetInstance();

        if (!(await app.mMain.msgs.showConfirmation_Async(abText.$(
                'Sys:Confirmations_ClearData_CannotSendUnsyncedData'), 
                '', abText.$('Sys:Text_Yes'), abText.$('Sys:Text_No')))) {
            app.mMain.msgs.hideLoading();
            return;
        }

        this._clearData_ClearData_Async();
    }

    async _clearData_ClearData_Async() {
        let app = App.GetInstance();

        app.mMain.msgs.showLoading();

        try {
            await app.clearData_Async();

            app.mMain.msgs.hideLoading();
            app.mMain.pager.setPage(app.mMain.pager.current.name, 
                    app.mMain.pager.current.args);
        } catch (e) {
            console.error(e);

            app.mMain.msgs.showMessage_Failure(abText.$(
                    'Sys:Errors_ClearDataFailed'), e.toString());
            app.mMain.msgs.hideLoading();
        }
    }

    async _clearData_SendUnsyncedData_Async() {
        let app = App.GetInstance();

        app.mMain.msgs.showLoading();

        let result = await webABApi.json_Async(app.apiUri + 'app/clear-data', {
            appId: app.getAppInfo().appId,
            authenticationHash: app.getAppInfo().authenticationHash,
            data: await this._getUnsyncedData_Async(),
        });

        if (result.isSuccess())
            this._clearData_ClearData_Async();
        else
            this._clearData_CannotSendUnsyncedData_Async();
    }

    async _getUnsyncedData_Async() {
        let app = App.GetInstance();

        let data = {};
        data.updateData = await app.ds.getDBRequests_ForSync_Async();
        data.receipts_Unsynced = await app.dataScheme.getT('Sys_Receipts')
                .select_Async(app.native.db, {
            where: [
                [ '_Modified_DateTime', null, 'IS NULL' ],
            ],
        });

        return data;
    }

}





module.exports.Basic = Basic;
 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\core\panels\backups.js
jsLibs.exportModule('core', 'panels/backups', (require, module, exports) => { 'use strict';

const 
    webABApi = require('web-ab-api'),

    sys = require('../sys'),
    
    $layouts = require('../$layouts')
;


class Basic extends sys.Module {

    constructor(lb) { super(lb);
        this.l = sys.createLayout($layouts.Backups_Basic);

        this.l.$elems.downloadLast.addEventListener('click', (evt) => {
            this.clear(this.l.$fields.files(0).url);
        });

        this.refresh();

        this.$view = this.l;
    }

    clear(backupFileUrl) {
        this.msgs.showLoading('');
        webABApi.json(sys.uris.pages['api.backups'] + 'backups-clear', {}, 
                (result) => {
            sys.parseApiResult(this, result, () => {
                this.refresh(() => {
                    window.location = backupFileUrl;
                    this.msgs.hideLoading();
                });
            });
        });
    }

    refresh(callbackFn) {
        callbackFn = typeof callbackFn === 'undefined' ? null : callbackFn;

        this.msgs.showLoading('');
        webABApi.json(sys.uris.pages['api.backups'] + 'backups-list', {}, 
                (result) => {
            sys.parseApiResult(this, result, () => {
                this.l.$fields.files = result.data.backupFileInfos;

                if (callbackFn === null)
                    this.msgs.hideLoading();
                else
                    callbackFn();
            });
        });
    }
    
}





module.exports.Basic = Basic;
 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\core\panels\bulls.js
jsLibs.exportModule('core', 'panels/bulls', (require, module, exports) => { 'use strict';

const
    abText = require('ab-text'),
    webABApi = require('web-ab-api'),

    helper = require('../helper'),
    modules = require('../modules'),
    spkFileUpload = require('spk-file-upload'),
    spkForms = require('spk-forms'),
    sys = require('../sys'),

    App = require('../App'),

    $layouts = require('../$layouts')
;

let panelName = 'bulls';
let panelTitle = 'Bulls';

class Add extends sys.Module {

    constructor(lb) { super(lb);
        this.m = new modules.Add(lb, panelName, panelTitle, Form);

        if (this.pager.current.args.newReceipt_CowId !== '0') {
            this.m.fm.m.l.$fields = {
                uris: {
                    back: this.pager.getPageUri(`lb.subpanels.newReceipt.bull`, 
                            { cowId: this.pager.current.args.newReceipt_CowId, }),
                },
            }

            this.m.fm.m.listeners_Back = () => {
                this.pager.setPage(`lb.subpanels.newReceipt.bull`, 
                        { cowId: this.pager.current.args.newReceipt_CowId, });
            };

            this.m.fm.m.onSubmit = (result) => {
                this.unlock();
                this.pager.setPage(`lb.subpanels.newReceipt.details`, 
                        { cowId: this.pager.current.args.newReceipt_CowId, 
                        bullId: result.data.row._Id });
            }
        } else {
            this.m.fm.m.onSubmit = (result) => {
                this.unlock();
                this.pager.setPage(`lb.subpanels.bulls.list`, 
                        { clientId: this.pager.current.args.clientId, });
            }
        }

        this.$view = this.m;
    }

}


class Edit extends sys.Module {

    constructor(lb) { super(lb);
        this.m = new modules.Edit(lb, panelName, panelTitle, Form);

        this.m.fm.m.refresh();

        this.$view = this.m;
    }

}


class Form extends sys.Module {

    get id() {
        if (this.data !== null)
            return this.data.row._Id;

        return 'id' in this.pager.current.args ? this.pager.current.args.id : null;
    }


    constructor(lb, create = false) { super(lb);
        this.m = new modules.Form(lb, panelName, panelTitle, create);
        this.farmerId = null;

        this.m.l.$fields = {
            uris: {
                back: this.pager.getPageUri(`lb.subpanels.bulls.list`, 
                        { clientId: this.pager.current.args.clientId, }),
            },
        };
        this.m.listeners_Back = () => {
            this.pager.setPage(`lb.subpanels.bulls.list`, 
                    { clientId: this.pager.current.args.clientId, });
        };

        if (sys.user.info.Administrator__Id === null)
            this.m.f.layout.$fields.shows_StrawsCount = true;
        else {
            this.m.f.layout.$fields.shows_StrawsCount = 
                    this.pager.current.args.clientId !== '0';
        }

        this.m.refresh_OnParseApiResult = (data) => {
            if (data.row !== null) {
                let shows = {
                    submit: true,
                    delete: true,
                }

                if (sys.user.info.Administrator__Id === null && 
                        data.row['Client__Id'] === null) {
                    // this.m.l.$fields.shows.submit = false;
                    shows.delete = false;

                    this.m.f.setDisabled(true);
                }

                this.m.l.$fields.shows = shows;
            }  

            // this.m.f.fields.ClientBull_StrawsConvCount_Client.setDisabled(
            //         sys.user.isClinicInseminator);
            this.m.f.fields.ClientBull_Note.setDisabled(false);
        };
        this.m.refresh_OnSetApiFields = (fields) => {
            fields.clientId = Number(this.pager.current.args.clientId);

            return fields;
        };
        this.m.submit_OnSetApiFields = (fields) => {
            fields.clientId = Number(this.pager.current.args.clientId);

            return fields;
        };

        this.m.onDelete = () => {
            this.unlock();

            let clientId = Number(this.pager.current.args.clientId);
            if (clientId === 0)
                this.pager.setPage(`lb.subpanels.bulls.list`);
            else {
                this.pager.setPage(`lb.subpanels.bulls.list`,
                        { clientId: clientId, });
            }
        };

        this.$view = this.m;
    }

}


class List extends sys.Module {
    constructor(lb, refresh = true) { super(lb);
        if (sys.user.isAdministrator || sys.user.isInseminator) {
            if (this.pager.current.args.clientId !== '0') {
                lb.setBackButton(true);
                lb.setListener_OnBack(() => {
                    this.m.listeners_Back();
                    return true;
                });
            }
        }

        this.m = new modules.List(lb, panelName, panelTitle);
        this.lButtons = sys.createLayout($layouts[`${panelTitle}_List_Buttons`]);

        this.cowId = null;

        if (this.pager.hasPage(`lb.subpanels.${panelName}.add`)) {
            this.m.l.$fields = {
                shows: {
                    add: true,
                },
                uris: {
                    add: this.pager.getPageUri(`lb.subpanels.${panelName}.add`, 
                            { clientId: this.pager.current.args.clientId, }),
                },
            };

            this.m.listeners_Add = () => {
                this.pager.setPage(`lb.subpanels.${panelName}.add`, 
                        { clientId: this.pager.current.args.clientId, });
            };
        }

        // this.listeners_OnRequest = () => {
        //     this.pager.setPage(`lb.subpanels.${panelName}.request`);
        // };
        // if (this.pager.hasPage(`lb.subpanels.${panelName}.request`)) {
        //     this.lButtons.$fields = {
        //         shows: {
        //             request: this.pager.hasPage(
        //                     `lb.subpanels.${panelName}.request`),
        //         },
        //         uris: {
        //             request: this.pager.getPageUri(
        //                     `lb.subpanels.${panelName}.request`),
        //         },
        //     };

        //     this.lButtons.$elems.request.addEventListener('click', (evt) => {
        //         evt.preventDefault();
        //         this.listeners_OnRequest();
        //     });
        // }
        /* Buttons */
        
        this.m.l.$holders.Buttons_After.$view = this.lButtons;

        // if (sys.user.isAdministrator && this.pager.current.args.clientId === '0') {
        //     this.upload_FileUpload = new spkFileUpload.FileUpload((files) => {
        //         this._upload(files);
        //     }, '.csv');
        //     this.lButtons.$elems.upload.addEventListener('click', (evt) => {
        //         evt.preventDefault();
        //         this.upload_FileUpload.upload();
        //     });
        // }

        // if (sys.user.isAdministrator) {
        //     this.lButtons.$fields.shows.upload = 
        //             this.pager.current.args.clientId === '0';
        // } else {
        //     this.lButtons.$fields.shows.upload = false;
        // }
        /* / Buttons */

        this.m.refresh_OnApiResult = (data) => {
            if (data.rFarmer !== null) {
                // if (data.rFarmer.Clinic__Id !== null)
                //     this.lButtons.$fields.shows.uploadStrawsCount = false;

                this.m.l.$fields.uris.back = this.pager.getPageUri(
                        'lb.subpanels.farmers.edit', 
                        { id: data.rFarmer._Id });
                this.m.listeners_Back = () => {
                    this.pager.setPage('lb.subpanels.farmers.edit', 
                            { id: data.rFarmer._Id });
                }
            }

            if (data.rInseminator !== null) {
                // if (data.rInseminator.Clinic__Id !== null)
                //     this.lButtons.$fields.shows.uploadStrawsCount = false;

                this.m.l.$fields.uris.back = this.pager.getPageUri(
                        'lb.subpanels.inseminators.edit', 
                        { id: data.rInseminator._Id });
                this.m.listeners_Back = () => {
                    this.pager.setPage('lb.subpanels.inseminators.edit', 
                            { id: data.rInseminator._Id });
                }
            }

            if (data.rClinic !== null) {
                this.m.l.$fields.uris.back = this.pager.getPageUri(
                        'lb.subpanels.clinics.edit', 
                        { id: data.rClinic._Id });
                this.m.listeners_Back = () => {
                    this.pager.setPage('lb.subpanels.clinics.edit', 
                            { id: data.rClinic._Id });
                }
            }
        };

        this.m.refresh_SetOnRefresh = (rows, colRefs) => {
            sys.tables.formatBool(this.m.t, rows, colRefs, 'Client__Id', true);

            // sys.tables.formatBool(this.m.t, rows, colRefs, 'External', true);

            // sys.tables.formatDate(rows, colRefs, 'Added_Date');

            for (let row of rows) {
                //  console.log(row.cols[colRefs._Modified_DateTime].value, 
                //         row.cols[colRefs.ClientBull__Modified_DateTime].value,
                //         row.cols[colRefs.ClientBull__Id].value);

                if (row.cols[colRefs._Modified_DateTime].value === null ||
                        (row.cols[colRefs.ClientBull__Modified_DateTime].value === null &&
                        row.cols[colRefs.ClientBull__Id].value !== null))
                    row.class = 'data-offline';
            }
        };

        this.m.refresh_SetApiFields = (fields) => {
            fields.cowId = this.cowId;

            return fields;
        };

        if (sys.user.isEmployee) {
            this.m.t.addHiddenColumns([
                'Client__Id',
            ]);
            // if (this.pager.current.args.clientId === '0') {
            //     this.m.t.addHiddenColumns([
            //         'ClientBull_StrawsConvCount_Client',
            //     ]);
            // }
        } else {
            this.m.t.addHiddenColumns([ 
                'Client_Name',
                'ClientBull__Modified_DateTime',
            ]); 
        }

        this.m.t.setApiFields(() => {
            let fields = {};

            fields = this.m.refresh_SetApiFields(fields);
            fields.clientId = this.pager.current.args.clientId;

            return fields;  
        });
        this.m.t.setOnRowClick((row, colRefs) => {
            this.pager.setUri(row.href);
        }, (row, colRefs) => {
            return this.pager.getPageUri(`lb.subpanels.bulls.edit`,
                    { id: row.cols[colRefs._Id].value, 
                    clientId: this.pager.current.args.clientId, });
        });

        if (refresh)
            this.m.t.refresh();

        this.$view = this.m;
    }


    // _upload(files)
    // {
    //     this.msgs.showLoading();
    //     webABApi.upload(sys.uris.pages['api.bulls'] + 'upload', {},
    //             { file: files[0] },
    //             (result) => {
    //         sys.parseApiResult(this, result, () => {
    //             this.msgs.hideLoading();
    //             this.msgs.showMessage_Success(abText.$(
    //                 'Sys:Successes_Success'), '', () => {
    //                 this.m.t.refresh();
    //             });
    //         });
    //     });
    // }

}





module.exports.Add = Add;
module.exports.Edit = Edit;
module.exports.Form = Form;
module.exports.List = List;
 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\core\panels\cows.js
jsLibs.exportModule('core', 'panels/cows', (require, module, exports) => { 'use strict';

const
    abDate = require('ab-date'),
    abText = require('ab-text'),
    spkFileUpload = require('spk-file-upload'),
    spkForms = require('spk-forms'),
    spkTables = require('spk-tables'),
    webABApi = require('web-ab-api'),

    // farmers = require('./farmers'),
    
    helper = require('../helper'),
    modules = require('../modules'),
    sys = require('../sys'),
    tables = require('../tables'),

    App = require('../App'),
    Select = require('../Select'),

    $layouts = require('../$layouts')
;


let panelName = 'cows';
let panelTitle = 'Cows';


class Add extends sys.Module {

    constructor(lb) { super(lb);
        this.m = new modules.Add(lb, panelName, panelTitle, Form);

        this.m.fm.m.f.setValues({
            Race: 'HO',
        });

        if (this.pager.current.args.newReceipt === '1') {
            this.m.fm.m.l.$fields = {
                texts: {
                    title: abText.$(`Sys:Titles_NewReceipt_Cow`),
                },
            },

            this.m.fm.m.onSubmit = (result) => {
                this.unlock();
                this.pager.setPage(`lb.subpanels.newReceipt.bull`, 
                        { cowId: result.data.row._Id, });
            }
        } else {
            this.m.fm.m.onSubmit = (result) => {
                this.unlock();
                this.pager.setPage(`lb.subpanels.${panelName}.list`, 
                        { farmerId: this.pager.current.args.farmerId });
            }
        }

        this.$view = this.m;
    }

}


class Edit extends sys.Module {

    constructor(lb) { super(lb);
        this.m = new modules.Edit(lb, panelName, panelTitle, Form);

        this.m.fm.m.l.$fields = {
            shows: {
                delete: true,
            },
        };

        this.m.fm.m.refresh();

        this.$view = this.m;
    }

}


class Form extends sys.Module {

    get id() {
        if (this.data !== null)
            return this.data.row._Id;

        return 'id' in this.pager.current.args ? this.pager.current.args.id : null;
    }


    constructor(lb, create = false) { super(lb);
        this.m = new modules.Form(lb, panelName, panelTitle, create);

        this.cowHistory_Table = new spkTables.Table(this.msgs, 
                tables.tables_CowHistory())
            .setOnRefresh((rows, colRefs) => {
                sys.tables.formatDate(rows, colRefs, 'Date');
            })
            .setOrderBy('Date', true);
        this.m.lContent.$holders.cowHistory.$view = this.cowHistory_Table;

        this.m.onDelete = () => {
            this.unlock();
            this.pager.setPage(`lb.subpanels.${panelName}.list`, 
                    { farmerId: this.m.data.row.Farmer__Id, });
        }

        this.m.refresh_OnSetApiFields = (fields) => {
            fields.farmerId = this.pager.current.args.farmerId;

            return fields;
        };
        this.m.refresh_OnParseApiResult = (data) => {
            let farmerId = data.rFarmer === null ? 0 : data.rFarmer._Id;

            if (create && this.pager.current.args.newReceipt !== '0') {
                this.m.l.$fields = {
                    uris: {
                        back: sys.user.info.Farmer__Id !== null ?
                                this.pager.getPageUri(`lb.subpanels.newReceipt.cow`) :
                                this.pager.getPageUri(`lb.subpanels.newReceipt.cow`, 
                                { farmerId: farmerId, }),
                    },
                };

                this.m.listeners_Back = () => {
                    if (sys.user.info.Farmer__Id !== null)
                        this.pager.setPage(`lb.subpanels.newReceipt.cow`);
                    else {
                        this.pager.setPage(`lb.subpanels.newReceipt.cow`, 
                           { farmerId: farmerId, });
                    }
                };
            } else {
                this.m.l.$fields = {
                    uris: {
                        back: this.pager.getPageUri(`lb.subpanels.${panelName}.list`, 
                                { farmerId: farmerId, }),
                    },
                };

                this.m.listeners_Back = () => {
                    if (sys.user.info.Farmer__Id !== null)
                        this.pager.setPage(`lb.subpanels.${panelName}.list`);
                    else {
                        this.pager.setPage(`lb.subpanels.${panelName}.list`, 
                                { farmerId: farmerId, });
                    }
                };
            }

            if (data.cowHistory_Rows !== null) {
                this.m.lContent.$fields.shows.cowHistory = true;
                this.cowHistory_Table.update(tables.parseRows(
                        tables.tables_CowHistory().columns, data.cowHistory_Rows));
            } else
                this.m.lContent.$fields.shows.cowHistory = false;
        }
        this.m.submit_OnSetApiFields = (fields) => {
            fields.farmerId = 'farmerId' in this.pager.current.args ?
                    this.pager.current.args.farmerId : null;

            return fields;
        };

        this.$view = this.m;
    }

}


class List extends sys.Module {
    constructor(lb, refresh = true, multiSelect = true) { super(lb);
        this.m = new modules.List(lb, panelName, panelTitle)

        if (sys.user.info.Inseminator__Id !== null) {
            lb.setBackButton(true);
            lb.setListener_OnBack(() => {
                this.m.listeners_Back();
                return true;
            });
        }

        this.m.l.$fields = {
            uris: {
                add: this.pager.getPageUri(`lb.subpanels.${panelName}.add`, 
                        { farmerId: this.pager.current.args.farmerId, }),
                back: sys.user.info.Farmer__Id !== null ?
                        this.pager.getPageUri(`lb.main`) :
                        this.pager.getPageUri(`lb.subpanels.farmers.edit`, 
                        { id: this.pager.current.args.farmerId, }),
            },
        };
        this.m.listeners_Add = () => {
            this.pager.setPage(`lb.subpanels.${panelName}.add`, 
                    { farmerId: this.pager.current.args.farmerId, });
        };
        this.m.listeners_Back = () => {
            this.pager.setPage(sys.user.info.Farmer__Id !== null ?
                    'lb.main' :
                    'lb.subpanels.farmers.edit', 
                    { id: this.pager.current.args.farmerId, });
        };

        /* Buttons */
        this.lButtons = sys.createLayout($layouts[`${panelTitle}_List_Buttons`]);
        // this.upload_FileUpload = new spkFileUpload.FileUpload((files) => {
        //     this._upload(files);
        // }, '.txt');
        // /* Upload */
        // this.lButtons.$fields.shows.upload = sys.user.isAdministrator;
        // this.lButtons.$elems.upload.addEventListener('click', (evt) => {
        //     evt.preventDefault();
        //     this.upload_FileUpload.upload();
        // });
        
        // /* Associations */
        // this.lButtons.$fields.shows.associations = true;
        // this.lButtons.$fields.uris.associations = this.pager.getPageUri(
        //         `lb.subpanels.associations.list`, 
        //         { farmerId: this.pager.current.args.farmerId });
        // this.lButtons.$elems.associations.addEventListener('click', (evt) => {
        //     evt.preventDefault();
        //     this.pager.setPage(`lb.subpanels.associations.list`, 
        //             { farmerId: this.pager.current.args.farmerId });
        // });

        this.m.l.$holders.Buttons_After.$view = this.lButtons;
        /* / Buttons */

        /* Select */
        if (multiSelect) {
            this.lButtons_Select = sys.createLayout($layouts.Buttons_Delete);
            this.lButtons_Select.$elems.delete.addEventListener('click', (evt) => {
                evt.preventDefault();
                let ids = [];
                let rows = this.m.t.getSelectedRows();
                for (let row of rows)
                    ids.push(row['_Id']);
                this.m.deleteSelected(ids, () => {
                    this.unlock();
                    this.m.t.layout.$elems.selectable_TableCheckbox.checked = 
                            false;
                    this.m.t.refresh();
                });
            });

            this.mSelect = new Select(this.lb, this.m.t, 
                [ this.m.l.$holders.Buttons_After, this.lButtons, this.lButtons_Select ],
                    (active) => {
                this.m.l.$fields.shows.add = !active;
            });
            this.m.t.layout.$holders.afterSearch.$view = this.mSelect;
        }
        /* / Select */
        
        this.m.refresh_SetOnRefresh = (rows, colRefs) => {
            for (let row of rows) {
                if (row.cols[colRefs._Modified_DateTime].value === null)
                    row.class = 'data-offline';
            }

            sys.tables.formatDate(rows, colRefs, 'LastReceipt_Date');
            sys.tables.formatDate(rows, colRefs, 'Added_Date');
            // sys.tables.formatDate(rows, colRefs, 'Birth');
        };

        this.m.t.setApiFields((fields) => {
            return {
                farmerId: this.pager.current.args.farmerId,
            };
        });

        if (refresh)
            this.m.t.refresh();

        this.$view = this.m;
    }


    // _upload(files)
    // {
    //     this.msgs.showLoading();
    //     webABApi.upload(sys.uris.pages['api.cows'] + 'upload', {},
    //             { farmer_Id: this.pager.current.args.farmerId, file: files[0] },
    //             (result) => {
    //         sys.parseApiResult(this, result, () => {
    //             this.msgs.hideLoading();
    //             this.msgs.showMessage_Success(abText.$('Sys:Successes_Success'), '', () => {
    //                 this.m.t.refresh();
    //             });
    //         });
    //     });
    // }

}






module.exports.Add = Add;
module.exports.Edit = Edit;
module.exports.Form = Form;
module.exports.List = List;
 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\core\panels\clinics.js
jsLibs.exportModule('core', 'panels/clinics', (require, module, exports) => { 'use strict';

const
    abText = require('ab-text'),
    spkForms = require('spk-forms'),

    modules = require('../modules'),
    sys = require('../sys'),

    App = require('../App'),

    $layouts = require('../$layouts')
;


let panelName = 'clinics';
let panelTitle = 'Clinics';


class Add extends sys.Module {

    constructor(lb) { super(lb);
        this.m = new modules.Add(lb, panelName, panelTitle, Form);

        this.$view = this.m;
    }

}


class Edit extends sys.Module {

    constructor(lb) { super(lb);
        this.m = new modules.Edit(lb, panelName, panelTitle, Form);

        this.user_ManageAccount = new sys.User_ManageAccount(this);

        this.lButtons = sys.createLayout($layouts[`${panelTitle}_Form_Buttons`]);
        this.m.fm.m.l.$holders.Buttons_Before.$view = this.lButtons;
        
        let refresh_OnParseApiResult =this.m.fm.m.refresh_OnParseApiResult;
        this.m.fm.m.refresh_OnParseApiResult = (data) => {
            refresh_OnParseApiResult(data);

            this.user_ManageAccount.refresh_OnParseApiResult(data);

            if (data.row !== null) {
                this.lButtons.$fields.hrefs.bulls = this.pager.getPageUri(
                        `lb.subpanels.bulls.list`,
                        { clientId: data.row.Client__Id, });

                this.lButtons.$elems.bulls.addEventListener('click', (evt) => {
                    evt.preventDefault();
                    this.pager.setPage(`lb.subpanels.bulls.list`,
                            { clientId: data.row.Client__Id });
                });

                this.m.fm.m.l.$fields.shows.delete = true;
            }
        }

        this.m.fm.m.refresh();

        this.$view = this.m;
    }

}


class Form extends sys.Module {

    get id() {
        if (this.data !== null)
            return this.data.row._Id;

        return 'id' in this.pager.current.args ? this.pager.current.args.id : null;
    }


    constructor(lb, create = false) { super(lb);
        this.m = new modules.Form(lb, panelName, panelTitle, create);

        this.lClient = sys.createLayout($layouts.Clients_Form);
        this.m.f.l.$holders.clientForm.$view = this.lClient;
        this.fClient = new spkForms.Form(this.lClient, 'Form');

        // this.lClient.$fields.shows.CustomBull = sys.user.isAdministrator;
        this.lClient.$fields.isUser = true;
        this.lClient.$fields.isUnderGrade = false;
        this.lClient.$fields.showTrader__Id = sys.user.info.Administrator__Id !== null;

        this.lUser = sys.createLayout($layouts.Users_Form);
        this.lUser.$fields.isNew = true;
        this.lClient.$holders.userForm.$view = this.lUser;
        this.fUser = new spkForms.Form(this.lUser, 'Form');

        this.m.refresh_OnParseApiResult = (data) => {
            this._initSelects(data);

            if (this.m.data.rClient !== null)
                this.fClient.setValues(this.m.data.rClient);
            if (this.m.data.rUser !== null)
                this.fUser.setValues(this.m.data.rUser);
        };
        this.m.submit_OnSetApiFields = (fields) => {
            fields.client = this.fClient.getValues();
            fields.user = this.fUser.getValues();

            delete fields.client.UnderGrade;

            if (fields.client.Trader__Id === '0')
                fields.client.Trader__Id = null;

            console.log(fields);

            return fields;
        }
        this.m.submit_OnValidator = (validator) => {
            this.fClient.setValidator(validator);
            this.fUser.setValidator(validator);
        };

        this.$view = this.m;
    }


    _initSelects(data) {
        // let traderOptions = [];
        // if (sys.user.isAdministrator) {
        //     traderOptions.push({
        //         title: abText.$('Sys:Options_None'),
        //         value: '0',
        //     });
        // }
        // for (let rTrader of data.rTraders) {
        //     traderOptions.push({
        //         title: rTrader.Name,
        //         value: rTrader._Id,
        //     });
        // }
        // this.fClient.fields.Trader__Id.field('Options', traderOptions);
    }

}


class List extends sys.Module {
    constructor(lb) { super(lb);
        this.m = new modules.List(lb, panelName, panelTitle)

        /* Buttons */
        this.lButtons = sys.createLayout($layouts[`${panelTitle}_List_Buttons`]);
        this.lButtons.$fields = {
            hrefs: {
                report: sys.uris.pages.download + 'clinics-report', 
            },
            shows: {
                report: App.Platform === 'web' ? sys.user.isAdministrator : false,
            },
        }
        // this.lButtons.$elems.register.addEventListener('click', (evt) => {
        //     evt.preventDefault();
        //     window.location = sys.uris.pages.download + 'inseminators-register';
        // });
        this.m.l.$holders.Buttons_Before.$view = this.lButtons;
        /* / Buttons */

        this.m.t.refresh();

        this.$view = this.m;
    }

}





module.exports.Add = Add;
module.exports.Edit = Edit;
module.exports.Form = Form;
module.exports.List = List;
 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\core\panels\farmers.js
jsLibs.exportModule('core', 'panels/farmers', (require, module, exports) => { 'use strict';

const
    abText = require('ab-text'),
    spkForms = require('spk-forms'),

    modules = require('../modules'),
    sys = require('../sys'),

    App = require('../App'),

    $layouts = require('../$layouts')
;


let panelName = 'farmers';
let panelTitle = 'Farmers';


class Add extends sys.Module {

    constructor(lb) { super(lb);
        this.m = new modules.Add(lb, panelName, panelTitle, Form);

        if (this.pager.current.args.newReceipt !== '0') {
            this.m.fm.m.l.$fields = {
                title: abText.$(`Sys:Titles_NewReceipt_Farmer`),
                uris: {
                    back: this.pager.getPageUri('lb.subpanels.newReceipt.farmer'),
                },
            },

            this.m.fm.m.listeners_Back = () => {
                this.pager.setPage('lb.subpanels.newReceipt.farmer');
            }

            this.m.fm.m.onSubmit = (result) => {
                this.unlock();
                this.pager.setPage(`lb.subpanels.newReceipt.cow`, 
                        { farmerId: result.data.row._Id, });
            }
        }
        

        this.$view = this.m;
    }

}


class Edit extends sys.Module {

    constructor(lb) { super(lb);
        this.m = new modules.Edit(lb, panelName, panelTitle, Form);

        this.user_ManageAccount = new sys.User_ManageAccount(this);

        this.lButtons = sys.createLayout($layouts[`${panelTitle}_Form_Buttons`]);
        
        this.lButtons.$fields = {
            hrefs: {
                bulls: '#',
                cows: this.pager.getPageUri(`lb.subpanels.cows.list`,
                    { farmerId: this.pager.current.args.id }),
                // associations: this.pager.getPageUri(`lb.subpanels.associations.list`,
                //     { farmerId: this.pager.current.args.id }),
            },
            shows: {
                bulls: sys.user.isAdministrator,
            }
        };

        this.lButtons.$elems.cows.addEventListener('click', (evt) => {
            evt.preventDefault();
            this.pager.setPage(`lb.subpanels.cows.list`,
                    { farmerId: this.pager.current.args.id });
        });
        // this.lButtons.$elems.associations.addEventListener('click', (evt) => {
        //     evt.preventDefault();
        //     this.pager.setPage(`lb.subpanels.associations.list`,
        //             { farmerId: this.pager.current.args.id });
        // });

        let refresh_OnParseApiResult = this.m.fm.m.refresh_OnParseApiResult;
        this.m.fm.m.refresh_OnParseApiResult = (data) => {
            refresh_OnParseApiResult(data);

            this.user_ManageAccount.refresh_OnParseApiResult(data);

            if (data.row !== null) {
                this.m.fm.m.l.$fields.shows.delete = true;
                
                this.lButtons.$fields.hrefs.bulls = this.pager.getPageUri(
                        `lb.subpanels.bulls.list`,
                        { clientId: data.row.Client__Id, });
                this.lButtons.$elems.bulls.addEventListener('click', (evt) => {
                    evt.preventDefault();
                    this.pager.setPage(`lb.subpanels.bulls.list`,
                            { clientId: data.row.Client__Id });
                });

                this.lButtons.$fields.shows.bulls =
                        data.row.Clinic__Id === null &&
                        data.row.Inseminator__Id === null;
            }
        }

        this.m.fm.m.refresh();

        this.m.fm.m.l.$holders.Buttons_Before.$view = this.lButtons;
        
        this.$view = this.m;
    }

}


class Form extends sys.Module {

    get id() {
        if (this.data !== null)
            return this.data.row._Id;

        return 'id' in this.pager.current.args ? this.pager.current.args.id : null;
    }


    constructor(lb, create = false) { super(lb);
        this.m = new modules.Form(lb, panelName, panelTitle, create);

        this.m.lContent.$fields.shows.Clinic__Id =
                !(sys.user.isInseminator || sys.user.isClinic);
        this.m.lContent.$fields.shows.Inseminator__Id =
                !(sys.user.isInseminator || sys.user.isClinic);

        this.lClient = sys.createLayout($layouts.Clients_Form);
        this.m.f.layout.$holders.clientForm.$view = this.lClient;
        this.fClient = new spkForms.Form(this.lClient, 'Form');        

        this.lUser = sys.createLayout($layouts.Users_Form);
        this.lUser.$fields.isNew = true;
        this.lClient.$holders.userForm.$view = this.lUser;
        this.fUser = new spkForms.Form(this.lUser, 'Form');

        this._initForm();

        this.m.refresh_OnParseApiResult = (data) => {
            this._initSelects(data);

            if (this.m.data.rClient !== null)
                this.fClient.setValues(this.m.data.rClient, true);
            if (this.m.data.rUser !== null)
                this.fUser.setValues(this.m.data.rUser, true);

            let isUser = sys.user.isAdministrator;
            if (sys.user.isClinic || sys.user.isInseminator)
                isUser = false;
            else if (data.row !== null)
                isUser = data.rUser !== null;

            this.m.lContent.$fields.isUser = isUser;
            this.lClient.$fields.isUser = isUser;

            if (data.row !== null) {
                this.m.f.setValues({
                    'HasNotificationsEmail': data.row.NotificationsEmail !== null,
                });
                this.fClient.setValues({
                    'UnderGrade': data.row.HerdUnderGradeNr !== null,
                });
            }

            if (data.row !== null) {
                this.m.f.fields.Clinic__Id.setDisabled(true); 
                this.m.f.fields.Inseminator__Id.setDisabled(true);
            }
        };
        this.m.submit_OnSetApiFields = (fields) => {
            /* Row */
            if (sys.user.isInseminator || sys.user.isClinic) {
                fields.row.Clinic__Id = null;
                fields.row.Inseminator__Id = null;
            } else {
                fields.row.Clinic__Id = fields.row.Clinic__Id === '0' ?
                        null : parseInt(fields.row.Clinic__Id);
                fields.row.Inseminator__Id = fields.row.Inseminator__Id === '0' ?
                        null : parseInt(fields.row.Inseminator__Id);
            }
            
            fields.row.NotificationsEmail = fields.row.HasNotificationsEmail ? 
                    fields.row.NotificationsEmail : null;
            delete fields.row.HasNotificationsEmail;

            /* Client */
            fields.client = this.fClient.getValues();
            fields.client._Id = App.GetInstance().ds.nextId();
            
            fields.client.SymlekId = fields.client.UnderGrade ? 
                    fields.client.SymlekId : null;

            fields.row.HerdUnderGradeNr = fields.client.UnderGrade ? 
                    fields.row.HerdUnderGradeNr : null;
            delete fields.client.UnderGrade;

            /* User */
            fields.user = fields.row.Inseminator__Id === null ?
                    this.fUser.getValues() : null;

            return fields;
        }
        this.m.submit_OnValidator = (validator) => {
            this.fClient.setValidator(validator);
            this.fUser.setValidator(validator);
        };

        this.$view = this.m;
    }


    _initForm() {
        /* Clients */
        this.lClient.$fields.showUnderGrade = true;

        let fUnderGrade_Elem = this.fClient.fields.UnderGrade.elem;
        fUnderGrade_Elem.addEventListener('change', (evt) => {
            this.lClient.$fields.isUnderGrade = fUnderGrade_Elem.checked;
            this.m.f.layout.$fields.isUnderGrade = fUnderGrade_Elem.checked;
        });

        this.fClient.setValues({
            UnderGrade: true,
        });

        /* Farmer */ 
        this.m.f.fields.Clinic__Id.field('Options', [
            {
                title: sys.eText('Sys:Options_None'),
                value: 0,
            },
        ]);
        this.m.f.fields.Clinic__Id.elem.addEventListener('change', (evt) => {
            this.m.f.l.$fields.shows.Inseminator__Id = 
                    this.m.f.fields.Clinic__Id.value === '0';
            this.lClient.$fields.isUser = this.m.f.fields.Clinic__Id.value === '0';
        });

        this.m.f.fields.Inseminator__Id.field('Options', [
            {
                title: sys.eText('Sys:Options_None'),
                value: 0,
            },
        ]);
        let fInseminator__Id_Elem = this.m.f.fields.Inseminator__Id.elem;
        fInseminator__Id_Elem.addEventListener('change', (evt) => {
            this.lClient.$fields.isUser = fInseminator__Id_Elem.value === '0';
        });        

        let fHasNotificationsEmail_Elem = this.m.f.fields.HasNotificationsEmail.elem;
        fHasNotificationsEmail_Elem.addEventListener('change', (evt) => {
            this.m.f.layout.$fields.shows.NotificationsEmail = fHasNotificationsEmail_Elem.checked;
        });        

        this.m.f.setValues({
            'Inseminator__Id': '0',
            'HasNotificationsEmail': false,
        });
    }

    _initSelects(data) {
        let clinicOptions = [
            {
                title: sys.eText('Sys:Options_None'),
                value: 0,
            },
        ];
        for (let rClinic of data.rClinics) {
            clinicOptions.push({
                title: rClinic.Client_Name,
                value: rClinic._Id,
            });
        }
        this.m.f.fields.Clinic__Id.field('Options', clinicOptions);

        let inseminatorOptions = [
            {
                title: sys.eText('Sys:Options_None'),
                value: 0,
            },
        ];
        for (let rInseminator of data.rInseminators) {
            inseminatorOptions.push({
                title: rInseminator.Client_Name,
                value: rInseminator._Id,
            });
        }
        this.m.f.fields.Inseminator__Id.field('Options', inseminatorOptions);
    }

}


class List extends sys.Module {
    constructor(lb, refresh = true) { super(lb);
        this.m = new modules.List(lb, panelName, panelTitle)

        if (sys.user.isClinic)  {
            this.m.t.addHiddenColumns([ 'Clinic_Client_Name',
                    'Inseminator_Client_Name' ]);
        } else if (sys.user.isInseminator) {
            this.m.t.addHiddenColumns([ 'Clinic_Client_Name',
                    'Inseminator_Client_Name' ]);
        }

        /* Buttons */
        this.lButtons = sys.createLayout($layouts[`${panelTitle}_List_Buttons`]);
        this.lButtons.$fields = {
            hrefs: {
                report: sys.uris.pages.download + 'farmers-report', 
            },
            shows: {
                report: App.Platform === 'web' ? sys.user.isAdministrator : false,
            },
        };
        this.m.l.$holders.Buttons_After.$view = this.lButtons;
        /* / Buttons */

        if (!sys.user.isAdministrator) {
            this.m.t.addHiddenColumns([ 'User_Email' ]);
        };

        this.m.refresh_SetOnRefresh = (rows, colRefs) => {
            if (App.Platform === 'native') {
                for (let i = 0; i < rows.length; i++) {
                    let row = rows[i];
                    if (row.cols[colRefs._Modified_DateTime].value === null)
                        row.class += ' data-offline';
                }
            }
        }

        this.m.t.setOnSort((rows, colRefs) => {
            // for (let i = 0; i < rows.length; i++) {
            //     rows[i].cols[colRefs.OrdinalNumber].value = i + 1;
            //     rows[i].cols[colRefs.OrdinalNumber].html = i + 1;

            //     if (rows[i].cols[colRefs._Modified_DateTime].value === null ||
            //             rows[i].cols[colRefs.Client__Modified_DateTime].value === null)
            //         rows[i].class = 'data-offline';
            // }

            // this.m.t.l.$fields.table.headers(colRefs.Client_Test).class = 
            //         'text-center';
            // sys.tables.format(rows, colRefs, 'Client_Test', (col, row) => {
            //     col.class = 'text-center';
            //     col.html = col.value ? 
            //             '<i class="fa fa-check" />' : 
            //             '';
            // });
        });

        if (refresh)
            this.m.t.refresh();

        this.$view = this.m;
    }

}





module.exports.Add = Add;
module.exports.Edit = Edit;
module.exports.Form = Form;
module.exports.List = List;
 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\core\panels\inseminators.js
jsLibs.exportModule('core', 'panels/inseminators', (require, module, exports) => { 'use strict';

const
    abText = require('ab-text'),
    spkForms = require('spk-forms'),

    modules = require('../modules'),
    sys = require('../sys'),

    App = require('../App'),

    $layouts = require('../$layouts')
;


let panelName = 'inseminators';
let panelTitle = 'Inseminators';


class Add extends sys.Module {

    constructor(lb) { super(lb);
        this.m = new modules.Add(lb, panelName, panelTitle, Form);

        this.$view = this.m;
    }

}


class Edit extends sys.Module {

    constructor(lb) { super(lb);
        this.m = new modules.Edit(lb, panelName, panelTitle, Form);

        this.user_ManageAccount = new sys.User_ManageAccount(this);

        let refresh_OnParseApiResult = this.m.fm.m.refresh_OnParseApiResult;
        this.m.fm.m.refresh_OnParseApiResult = (data) => {
            refresh_OnParseApiResult(data);

            this.user_ManageAccount.refresh_OnParseApiResult(data);

            if (data.row !== null) {
                this.m.fm.m.l.$fields.shows.delete = true;
            }
        };

        this.m.fm.m.refresh();

        this.$view = this.m;
    }

}


class Form extends sys.Module {

    constructor(lb, create = false) { super(lb);
        this.m = new modules.Form(lb, panelName, panelTitle, create);

        this.m.f.l.$fields.shows.Clinic__Id = !sys.user.isClinic;

        this.lButtons = sys.createLayout($layouts[`${panelTitle}_Form_Buttons`]);

        this.lClient = sys.createLayout($layouts.Clients_Form);
        this.m.f.l.$holders.clientForm.$view = this.lClient;
        this.fClient = new spkForms.Form(this.lClient, 'Form');

        this.lClient.$fields.isUser = true;
        this.lClient.$fields.isUnderGrade = true;

        this.lUser = sys.createLayout($layouts.Users_Form);
        this.lUser.$fields.isNew = true;
        this.lClient.$holders.userForm.$view = this.lUser;
        this.fUser = new spkForms.Form(this.lUser, 'Form');

        this._initForm();

        this.m.refresh_OnParseApiResult = (data) => {
            this._initSelects(data);

            if (this.m.data.rClient !== null)
                this.fClient.setValues(this.m.data.rClient);
            if (this.m.data.rUser !== null)
                this.fUser.setValues(this.m.data.rUser);

            if (data.row !== null) {
                this.lButtons.$fields.hrefs.bulls = this.pager.getPageUri(
                        `lb.subpanels.bulls.list`,
                        { clientId: data.row.Client__Id, });

                this.lButtons.$elems.bulls.addEventListener('click', (evt) => {
                    evt.preventDefault();
                    console.log(this.pager);
                    this.pager.setPage(`lb.subpanels.bulls.list`,
                            { clientId: data.row.Client__Id });
                });

                this.lButtons.$fields.shows.bulls = 
                        data.row.Clinic_Client__Id === null;
                this.m.f.fields.Clinic__Id.setDisabled(true); 
            }
        };
        this.m.submit_OnSetApiFields = (fields) => {
            if (sys.user.isClinic)
                fields.row.Clinic__Id = null;
            else {
                fields.row.Clinic__Id = fields.row.Clinic__Id === '0' ?
                        null : parseInt(fields.row.Clinic__Id);
            }

            fields.client = this.fClient.getValues();
            fields.user = this.fUser.getValues();

            delete fields.client.UnderGrade; 
            
            if (fields.row.Clinic__Id === '0')
                fields.row.Clinic__Id = null;

            return fields;
        }
        this.m.submit_OnValidator = (validator) => {
            this.fClient.setValidator(validator);
            this.fUser.setValidator(validator);
        };

        this.m.l.$holders.Buttons_Before.$view = this.lButtons;
        this.$view = this.m;
    }


    _initForm() {
        this.m.f.fields.Clinic__Id.field('Options', [
            {
                title: sys.eText('Sys:Options_None'),
                value: 0,
            },
        ]);
        this.m.f.fields.Clinic__Id.elem.addEventListener('change', (evt) => {
            this.m.f.l.$fields.shows.Inseminator__Id = 
                    this.m.f.fields.Clinic__Id.value === '0';
        });
    }

    _initSelects(data) {
        let clinicOptions = [];
        clinicOptions.push({
            title: abText.$('Sys:Options_None'),
            value: '0',
        });
        for (let rClinic of data.rClinics) {
            clinicOptions.push({
                title: rClinic.Client_Name,
                value: rClinic._Id,
            });
        }
        this.m.f.fields.Clinic__Id.field('Options', clinicOptions);
    }

}


class List extends sys.Module {
    constructor(lb) { super(lb);
        this.m = new modules.List(lb, panelName, panelTitle)

        if (sys.user.isClinic)
            this.m.t.addHiddenColumns([  'Clinic_Client_Name' ]);

        /* Buttons */
        this.lButtons = sys.createLayout($layouts[`${panelTitle}_List_Buttons`]);
        this.lButtons.$fields = {
            hrefs: {
                report: sys.uris.pages.download + 'inseminators-report', 
            },
            shows: {
                report: App.Platform === 'web',
            },
        }
        this.m.l.$holders.Buttons_After.$view = this.lButtons;
        /* / Buttons */

        this.m.refresh_SetOnRefresh = (rows, colRefs) => {
            // for (let i = 0; i < rows.length; i++) {
            //     rows[i].cols[colRefs.OrdinalNumber].value = i + 1;
            //     rows[i].cols[colRefs.OrdinalNumber].html = i + 1;
            // }

            // this.m.t.l.$fields.table.headers(colRefs.Client_Test).class = 
            //         'text-center';
            // sys.tables.format(rows, colRefs, 'Client_Test', (col, row) => {
            //     col.class = 'text-center';
            //     col.html = col.value ? 
            //             '<i class="fa fa-check" />' : 
            //             '';
            // });
        }

        this.m.t.refresh();

        this.$view = this.m;
    }

}





module.exports.Add = Add;
module.exports.Edit = Edit;
module.exports.Form = Form;
module.exports.List = List;
 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\core\panels\receipts.js
jsLibs.exportModule('core', 'panels/receipts', (require, module, exports) => { 'use strict';

const
    abDate = require('ab-date'),
    abText = require('ab-text'),
    eTasks = require('e-tasks'),
    spkFileUpload = require('spk-file-upload'),
    spkForms = require('spk-forms'),
    webABApi = require('web-ab-api'),

    modules = require('../modules'),
    sys = require('../sys'),
    tables = require('../tables'),

    App = require('../App'),

    $layouts = require('../$layouts')
;


let panelName = 'receipts';
let panelTitle = 'Receipts';

// export class Add extends sys.Module
// {

//     constructor(lb)
//     { super(lb);
//         this.pager.setPage(sys.user.info.Farmer__Id === null ? 
//                 'lb.subpanels.newReceipt.farmer' :
//                 'lb.subpanels.newReceipt.cow', {}, false);
//     }

// }

class Edit extends sys.Module {

    constructor(lb) { super(lb);
        this.m = new modules.Edit(lb, panelName, panelTitle, Form, false);

        this.m.fm.m.lContent.$fields = {
            shows: {
                bull: true,
                cow: true,
            },
        };

        this.m.fm.m.refresh_OnSetApiFields = (fields) => {
            fields.cowId = null;
            fields.bullId = null;

            return fields;
        }
        this.m.fm.m.submit_OnSetApiFields = (fields) => {
            fields.cowId = null;
            fields.bullId = null;

            return fields;
        }

        this.m.fm.m.refresh(0);

        this.$view = this.m;
    }

}


class Form extends sys.Module {

    get id() {
        if (this.data !== null)
            return this.data.row._Id;

        return 'id' in this.pager.current.args ? this.pager.current.args.id : null;
    }


    constructor(lb, create = false) { super(lb);
        this.m = new modules.Form(lb, panelName, panelTitle, create);

        let app = App.GetInstance();

        this.m.l.$fields.shows = {
            submit: false,
            delete: false,
        };
        this.m.f.layout.$fields = {
            shows: {
                nr: true,
            },
        };

        this.m.onDelete = () => {
            if (App.Platform === 'native') {
                let app = App.GetInstance();
                (async () => {
                    await app.syncDB_Helper_Async();
                    this.unlock();
                    this.pager.setPage(`lb.subpanels.receipts.list`);
                })();
            } else {
                this.unlock();
                this.pager.setPage(`lb.subpanels.receipts.list`);
            }
        };

        this.m.onSubmit = () => {
            if (App.Platform === 'native') {
                this.msgs.showMessage_Success(abText.$('Sys:Successes_Success'), '', () => {
                    let app = App.GetInstance();
                    (async () => {
                        await app.syncDB_Helper_Async();
                        this.unlock();
                        this.m.refresh();
                    })();
                });
            } else {
                this.msgs.showMessage_Success(abText.$('Sys:Successes_Success'), '', () => {
                    this.m.refresh();
                });
                this.unlock();
                this.msgs.hideLoading();
            }
        };

        /* Buttons */
        if (!create) {
            this.lButtons = sys.createLayout($layouts[`${panelTitle}_Form_Buttons`]);
            this.lButtons.$fields = {
                hrefs: {
                    download: sys.uris.pages.download + 'receipt-image?id=' +
                            this.pager.current.args.id, 
                    downloadSymlek: sys.uris.pages.download + 'receipt-symlek?id=' +
                            this.pager.current.args.id, 
                },
                shows: {
                    download: App.Platform === 'web',
                    downloadSymlek: sys.user.isAdministrator,
                    print: App.Platform === 'native' ? app.native.printer !== null : false,
                }
            };

            this.lButtons.$elems.print.addEventListener('click', (evt) => {
                evt.preventDefault();

                this.msgs.showLoading('');
                setTimeout(() => {
                    this.msgs.hideLoading();
                }, 5000);

                (async () => {
                    await app.dataScheme.getTable('Sys_Receipts').update_Async(app.native.db,
                            [{
                        _Id: this.m.data.row._Id,
                        Printed: true,
                    }]);
                    await app.ds.addDBRequest_Async(
                            'Sys_PrintReceipt_DBSync', 'print', {
                        _Id: this.m.data.row._Id,
                    });

                    this.m.l.$fields.shows.submit = false;
                    this.m.f.setDisabled(true);
                    this.m.l.$fields.shows.delete = false;

                    await app.native.nativeActions.callNative_Async('PrintReceipt',
                            { printerAddress: app.native.printer.address,
                            row: sys.formatReceiptForPrint(this.m.data.row), });
                })();
            });

            this.m.l.$holders.Buttons_Before.$view = this.lButtons;
        }
        /* / Buttons */

        this.m.refresh_OnParseApiResult = (data) => {
            let shows = {
                submit: true,
                delete: true,
            };
            
            if (data.row !== null) {
                this.m.lContent.$fields.Error = data.row.Error === null ?
                        '' : data.row.Error;
                this.m.lContent.$fields.shows.error = data.row.Error !== null;

                if (sys.user.info.Administrator__Id === null) {
                    if (data.row.Downloaded !== null && data.row.Error === null) {
                        shows.submit = false;
                        this.m.f.setDisabled(true);
                        shows.delete = false;
                    }
                    
                    // if (App.Platform === 'web') {
                        // if (data.row.Downloaded !== null && data.row.Error === null) {
                        //     shows.submit = false;
                        //     this.m.f.setDisabled(true);
                        //     shows.delete = false;
                        // }
                    // } else if (App.Platform === 'native') {
                    //     if (data.row._Modified_DateTime !== null) {
                    //         if (data.row.Error === null) {
                    //             shows.submit = false;
                    //             this.m.f.setDisabled(true);

                    //             if (data.row.Downloaded !== null)
                    //                 shows.delete = false;   
                    //             else if (data.row.Printed)
                    //                 shows.delete = false;
                    //         }
                    //     }
                    // }
                }
            }

            this.m.l.$fields.shows = shows;
        };

        this.$view = this.m;
    }

}


class List extends sys.Module {
    constructor(lb) { super(lb);
        this.m = new modules.List(lb, panelName, panelTitle, false)

        if (App.Platform === 'native') {
            this.m.t.addHiddenColumns([
                'Added',
            ]);
        }

        if (!sys.user.isAdministrator) {
            this.m.t.addHiddenColumns([
                'Clinic_Client_Name',
            ]);
        }

        if (sys.user.isFarmer) {
            this.m.t.addHiddenColumns([
                'Farmer_Client_Name',
                'Farmer_HerdUnderGradeNr', 
                'InseminatorName',
            ]);
        } else if (sys.user.isInseminator) {
            this.m.t.addHiddenColumns([
                'InseminatorName',
            ]);
        }

        /* Buttons */
        this.lButtons = sys.createLayout($layouts[`${panelTitle}_List_Buttons`]);
        this.lButtons.$fields.shows.download = App.Platform === 'web' ?
                !sys.user.isClinicInseminator : false;
        // this.lButtons.$fields.shows.printSelected = App.Platform === 'web';
        this.lButtons.$fields.shows.downloadRegister = 
                App.Platform === 'web';
        this.lButtons.$fields.shows.report = App.Platform === 'web' ?
                (sys.user.isAdministrator ? true : false) : false;
        
        this.lButtons.$elems.download.addEventListener('click', 
                (evt) => {
            evt.preventDefault();
            this.downloadNew();
        });
        this.lButtons.$elems.downloadRegister.addEventListener('click', (evt) => {
            evt.preventDefault();
            this.downloadRegister();
        });
        // this.lButtons.$elems.printSelected.addEventListener('click', (evt) => {
        //     evt.preventDefault();
        //     this.printSelected();
        // });
        

        // this.uploadInvalid_FileUpload = null;
        // if (App.Platform === 'web') {
        //     if (sys.user.isAdministrator) {
        //         this.uploadInvalid_FileUpload = new spkFileUpload.FileUpload((files) => {
        //             this._uploadInvalid(files);
        //         }, '.txt.html');
        //         this.lButtons.$fields.shows.uploadInvalid = true;
        //         this.lButtons.$elems.uploadInvalid.addEventListener('click', (evt) => {
        //             evt.preventDefault();
        //             this.uploadInvalid_FileUpload.upload();
        //         });
        //     }
        // }

        this.m.l.$holders.Buttons_After.$view = this.lButtons;
        /* / Buttons */

        /* Header */
        // this.lHeader = sys.createLayout($layouts[`${panelTitle}_List_Header`]);
        // this.fHeader = new spkForms.Form(this.lHeader, 'Form');

        // this._init_Header();

        // this.m.l.$holders.header.$view = this.lHeader;
        /* / Header */

        /* Before Table */
        this.lBeforeTable = sys.createLayout($layouts[
                `${panelTitle}_List_BeforeTable`]);
        this.fBeforeTable = new spkForms.Form(this.lBeforeTable, 'Form');
        
        this._init_BeforeTable();
        
        this.m.t.l.$holders.beforeTable.$view = this.lBeforeTable;

        /* Fields */
        if (sys.user.isFarmer || sys.user.isInseminator) {
            this.m.l.$fields = {
                uris: {
                    add: sys.user.info.Farmer__Id === null ?
                            this.pager.getPageUri(`lb.subpanels.newReceipt.farmer`) :
                            this.pager.getPageUri(`lb.subpanels.newReceipt.cow`),
                },
            };

            this.m.listeners_Add = () => {
                this.pager.setPage(sys.user.info.Farmer__Id === null ?
                        `lb.subpanels.newReceipt.farmer` :
                        `lb.subpanels.newReceipt.cow`);
            }
        } else
            this.m.l.$fields.shows.add = false;
        /* / Fields */

        /* Filters */
        this._filter_Select('currentMonth', false);

        this.lBeforeTable.$elems.Filters_CurrentMonth.addEventListener('click', (evt) => {
            evt.preventDefault();
            this._filter_Select('currentMonth');
        });
        this.lBeforeTable.$elems.Filters_PreviousMonth.addEventListener('click', (evt) => {
            evt.preventDefault();
            this._filter_Select('previousMonth');
        });
        this.lBeforeTable.$elems.Filters_CurrentYear.addEventListener('click', (evt) => {
            evt.preventDefault();
            this._filter_Select('currentYear');
        });
        this.lBeforeTable.$elems.Filters_DatesRange.addEventListener('click', (evt) => {
            evt.preventDefault();
            this._filter_Select('datesRange');
        });
        /* / Filters */

        this.m.refresh_SetApiFields = (fields) => {
            fields.filterType = this._filter;

            let datesRange = this._filter_GetDatesRange();
            fields.date = datesRange;

            return fields;
        }

        this.m.refresh_SetOnRefresh = (rows, colRefs) => {
            for (let i = 0; i < rows.length; i++) {
                let row = rows[i];

                if (App.Platform === 'native') {
                    if (row.cols[colRefs._Modified_DateTime].value === null)
                        row.class += ' data-offline';
                    else
                        row.class += ' data-online';
                }

                // if (row.cols[colRefs.Farmer_HerdUnderGradeNr].value === null)
                //     row.class += ' not-downloaded';
                // else if (row.cols[colRefs.Downloaded].value === null)
                //     row.class += ' not-downloaded';
                // else
                //     row.class += ' downloaded';

                if (row.cols[colRefs.Error].value !== null)
                    row.class += ' with-error';

                row.cols[colRefs.Cow_Nr].html = row.cols[colRefs.Cow_Nr].value +
                        '<br/><span class="table-hint">' + 
                        (row.cols[colRefs.Cow_Name].value === '' ? 
                        '-' : row.cols[colRefs.Cow_Name].value) + '</span>';
            }

            sys.tables.format(rows, colRefs, 'Nr', (col, row) => {
                col.html = sys.formatReceiptNr(col.value);
            });

            sys.tables.formatDate_UTC(rows, colRefs, 'Date');
            sys.tables.formatDate(rows, colRefs, 'Added');

            sys.tables.formatDate(rows, colRefs, 'Downloaded');
            sys.tables.formatDate(rows, colRefs, 'Downloaded_Client');

            // sys.tables.format(rows, colRefs, 'Downloaded', (col, row) => {
            //     col.class = 'text-center';
            //     if (row.cols[colRefs.Farmer_HerdUnderGradeNr].value === null) {
            //         col.class = 'text-center';
            //         col.html = '<i class="far fa-circle" />';
            //     } else {
            //         col.class = 'text-center';
            //         col.html = col.value !== null ? 
            //                 '<i class="fa fa-check" />' : 
            //                 '<i class="fa fa-times" />';
            //     }
            // });
            
        };
        if (App.Platform === 'native') {
            this.m.t.setOnApiResult((data, apiFields) => {
                let colRefs = this.m.t.columnRefs;
                let table = data.table;
                let table_New = [];

                let dateFrom = apiFields.date.from;
                let dateTo = apiFields.date.to;

                for (let row of table) {
                    // if (apiFields.filterType === 'underGrade') {
                    //     if (row[colRefs.Farmer_HerdUnderGradeNr] === null)
                    //         continue;
                    // } else if (apiFields.filterType === 'notUnderGrade') {
                    //     if (row[colRefs.Farmer_HerdUnderGradeNr] !== null)
                    //         continue;
                    // }

                    if (dateFrom !== null) {
                        if (row[colRefs.Date] < dateFrom)
                            continue;
                    }

                    if (dateTo !== null) {
                        if (row[colRefs.Date] > dateTo)
                            continue;
                    }
                    
                    table_New.push(row);
                }

                data.table = table_New;
            });
        }
        // this.m.t.setOnSearch((text) => {
        //     if (text.match(/^[a-zA-Z]{2}[0-9]{7}$/))
        //         text = parseInt(text.substr(2));

        //     return text;
        // });
        this.m.t.setDynamic(App.Platform === 'web');
        // this.m.t.setSelectable(App.Platform === 'web');
        this.m.t.refresh();

        this.$view = this.m;
    }

    downloadNew() {
        this.downloadZip('receipts-new', {}, true);
    }

    downloadRegister() {
        let datesRange = this._filter_GetDatesRange();
        if (datesRange.from === null || datesRange.to === null) {
            this.msgs.showMessage_Failure('Musisz wybrać zakres dat.');
            return;
        }

        let tableInfo = tables.tables_Receipts();
        tableInfo = {
            columns: tableInfo.columns,
            orderBy: tableInfo.orderBy,
        };

        let downloadUri = sys.uris.pages[`download`] + 'receipts-register' + 
                '?tableInfo=' + encodeURIComponent(JSON.stringify(tableInfo)) + 
                '&dateFrom=' + datesRange.from + '&dateTo=' + datesRange.to;

        window.location = downloadUri;
    }

    downloadReport() {
        this.msgs.showLoading('');

        let apiUri = sys.uris.pages[`api.downloads`] + 'report';
        let tableInfo = this.m.t.getTableInfo();
        let tableArgs = this.m.t.getTableArgs();

        let downloading = false;
        eTasks.start(apiUri, { tableInfo: tableInfo, tableArgs: tableArgs }, 
                true, (task, result) => {
            if (!result.isSuccess())
                this.msgs.showMessage_Failure(result.message);

            if (!downloading) {
                window.location = sys.uris.pages['download'] + 'report' +
                        '?taskHash=' + task.hash;
                downloading = true;
            }

            this.msgs.hideLoading();
            
            return !task.finished;
        });
    }

    downloadZip(type, api_args, refreshTable) {
        this.msgs.showLoading();

        let apiUri = sys.uris.pages[`api.downloads`] + type;

        let downloading = false;
        eTasks.start(apiUri, api_args, true, (task, result) => {
            if (!result.isSuccess()) {
                let errorInfo = sys.getWebResultErrorInfo(result);
                this.msgs.showMessage_Failure(errorInfo.title, 
                        errorInfo.message);
                this.msgs.hideLoading();
            }

            if ('noReceipts' in result.data) {
                this.msgs.showMessage_Success(
                    sys.eText('Sys:Notifications_NoReceiptsToDownload'));
                this.msgs.hideLoading();

                return false;
            }

            if (task.info.zip_Ready && !downloading) {
                window.location = sys.uris.pages['download'] +
                        'receipts-zip' + '?taskHash=' + task.hash;
                downloading = true;
            }

            if (!task.finished) {
                if (task.info.zip_Ready) {
                    this.msgs.showLoading(
                            sys.eText('Sys:Text_DownloadingFile'));
                } else {
                    this.msgs.showLoading(
                            sys.eText('Sys:Text_PreparingFile') +
                            (task.info.progress * 100).toFixed(2) + '%');
                }

                return true;
            }

            if (refreshTable)
                this.m.t.refresh();
            else
                this.msgs.hideLoading();

            return false;
        });
    }

    printSelected() {
        let ids = [];
        let rows = this.m.t.getSelectedRows();
        for (let row of rows)
            ids.push(row['_Id']);
        if (ids.length === 0) {
            this.msgs.showMessage_Failure(abText.$(
                    'Sys:Notifications_NoReceiptsSelected'), '');
            return;
        }
        window.location = sys.uris.pages.download + 'receipt-images?ids=' +
                ids.join(','); 
    }


    _filter_GetDatesRange() {
        let datesRange = null;
        let date = new Date();

        let fBeforeTable_Values = this.fBeforeTable.getValues();

        if (this._filter === 'datesRange') {
            datesRange = {
                from: fBeforeTable_Values.Date_From,
                to: fBeforeTable_Values.Date_To,
            };
        } else if (this._filter === 'currentMonth') {
            datesRange = {
                from: abDate.getDay_UTC((new Date(Date.UTC(date.getFullYear(),
                        date.getMonth(), 1))).getTime() / 1000),
                to: abDate.getDay_UTC((new Date(Date.UTC(date.getFullYear(),
                        date.getMonth() + 1, 0))).getTime() / 1000),
            };
        } else if (this._filter === 'previousMonth') {
            datesRange = {
                from: abDate.getDay_UTC((new Date(Date.UTC(date.getFullYear(),
                        date.getMonth() - 1, 1))).getTime() / 1000),
                to: abDate.getDay_UTC((new Date(Date.UTC(date.getFullYear(),
                        date.getMonth(), 0))).getTime() / 1000),

            };
        } else if (this._filter === 'currentYear') {
            datesRange = {
                from: abDate.getDay_UTC((new Date(Date.UTC(date.getFullYear(),
                        0, 1))).getTime() / 1000),
                to: abDate.getDay_UTC((new Date(Date.UTC(date.getFullYear(),
                        12, 0))).getTime() / 1000),
            };
        } else
            throw new Error('Unknown filter.');

        // console.log(abDate.format_DateTime(datesRange.from), abDate.format_DateTime(datesRange.to));

        return datesRange;
    }

    _filter_Select(filter, refresh = true) {
        if (this._filter === filter)
            return;

        this._filter = filter;
        this.lBeforeTable.$fields.filter = filter;

        this.lBeforeTable.$fields.ShowDatesRange = this._filter === 'datesRange';

        if (refresh)
            this.m.t.refresh();
    }

    _init_BeforeTable() {
        $(this.fBeforeTable.fields.Date_From.elem).on('dp.hide', (evt) => {
            this.m.t.refresh();
        });
        $(this.fBeforeTable.fields.Date_To.elem).on('dp.hide', (evt) => {
            this.m.t.refresh();
        });
    }

    _uploadInvalid(files) {
        this.msgs.showLoading();
        webABApi.upload(sys.uris.pages['api.receipts'] + 'upload-invalid', {},
                { file: files[0] }, (result) => {
            sys.parseApiResult(this, result, () => {
                this.msgs.hideLoading();
                this.msgs.showMessage_Success(abText.$('Sys:Successes_Success'),
                    result.data.errorMessage, () => {
                    this.m.t.refresh();
                });
            });
        });
    }

}





module.exports.Edit = Edit;
module.exports.Form = Form;
module.exports.List = List;
 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\core\api\bullsApi.js
jsLibs.exportModule('core', 'api/bullsApi', (require, module, exports) => { 'use strict';

const
    App = require('../App')
;

let app = App.GetInstance();

async function select_Async(fields) {
    let r = await app.ds.requestB_Async([
        [ 'rows', 'Sys_Bulls', 'select', {
            join: [
                {
                    prefix: 'Client_',
                    table: app.dataScheme.getTable('Sys_Clients'),
                    on: [ 
                        [ '_Id', 'Client__Id' ],
                    ],
                    // where: [
                    //     [ '_Id', '=', app.user.info.Client__Id ],
                    // ],
                }, {
                    prefix: 'ClientBull_',
                    table: app.dataScheme.getTable('Sys_ClientBulls'),
                    on: [ 
                        [ 'Bull__Id', '_Id' ],
                    ],
                    // where: [
                    //     [ '_Id', '=', app.user.info.Client__Id ],
                    // ],
                },
            ],
        } ],
    ]);

    return {
        success: r.success,
        error: r.error,
        data: {
            rows: r.rows.rows,
            rFarmer: null,
            rInseminator: null,
        },
    }
}





module.exports.select_Async = select_Async;
 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\core\panels\registrations.js
jsLibs.exportModule('core', 'panels/registrations', (require, module, exports) => { 'use strict';

const
    abDate = require('ab-date'),
    abText = require('ab-text'),
    spkForms = require('spk-forms'),

    helper = require('../helper'),
    modules = require('../modules'),
    sys = require('../sys'),

    App = require('../App'),

    $layouts = require('../$layouts')
;


let panelName = 'registrations';
let panelTitle = 'Registrations';


class Add extends sys.Module {

    constructor(lb) { super(lb);
    }

}


class Edit extends sys.Module {

    constructor(lb) { super(lb);
        this.data = null;

        this.listeners_Back = () => {
            lb.pager.setPage('lb.subpanels.registrations.list');
        }

        lb.setBackButton(true);
        lb.setListener_OnBack(() => {
            this.listeners_Back();
            return true;
        });

        this.l = sys.createLayout($layouts.Register_Edit);

        this.lForm = null;
        this.lForm_Client = null;
        this.lForm_User = null;

        this.f = null;
        this.fClient = null;
        this.fUser = null;

        this.l.$fields = {
            uris: {
                back: lb.pager.getPageUri('lb.subpanels.registrations.list'),
            },
        };
        this.l.$elems.back.addEventListener('click', (evt) => {
            evt.preventDefault();
            this.listeners_Back();
        });

        this.l.$elems.Submit.addEventListener('click', (evt) => {
            evt.preventDefault();
            this._submit();
        });
        this.l.$elems.Reject.addEventListener('click', (evt) => {
            evt.preventDefault();
            this.msgs.showConfirmation(abText.$('Sys:Confirmations_Delete'), '',
                    abText.$('Sys:Text_Yes'), abText.$('Sys:Text_No'), 
                    (result) => {
                if (result)
                    this._reject();
            });
        });
        
        this.refresh();

        this.$view = this.l;
    }

    refresh() {
        this.msgs.showLoading();

        helper.api_Row_Async(panelTitle, { id: Number(this.pager.current.args.id) })
            .then((response) => {
                let result = response.results.request;

                if (!result.success) {
                    this.msgs.showMessage_Failure('', result.message);
                    this.msgs.hideLoading();
                    return;
                }

                let data = result.data;
                this.data = data;
                let row = data.row;

                this._createLayout(row);

                if (row.rFarmer !== null)
                    this.f.setValues(row.rFarmer, true);
                else if (row.rInseminator !== null)
                    this.f.setValues(row.rInseminator, true);
                this.fClient.setValues(row.rClient, true);
                this.fUser.setValues(row.rUser, true);

                this.msgs.hideLoading();
            })
            .catch((e) => {
                console.error(e);

                this.msgs.showMessage_Failure('', e.toString());
                this.msgs.hideLoading();
            });
    }


    _createLayout(rows) {
        if (rows.rFarmer !== null)
            this.lForm = sys.createLayout($layouts.Farmers_Form);
        else if (rows.rInseminator !== null)
            this.lForm = sys.createLayout($layouts.Inseminators_Form);
        this.lForm_Client = sys.createLayout($layouts.Clients_Form);
        this.lForm_User = sys.createLayout($layouts.Users_Form)

        this.l.$fields = {
            type_Farmer: rows.rFarmer !== null,
            type_Inseminator: rows.rInseminator !== null,
        };

        this.lForm.$fields = {
            isNew: true,
            isUnderGrade: true,
        };
        this.lForm_Client.$fields = {
            showUnderGrade: rows.rFarmer !== null,
            isUnderGrade: rows.rClient.SymlekId !== null,

            isUser: true,
        };
        this.lForm_User.$fields = {
            isNew: true,
        };

        this.lForm.$holders.clientForm.$view = this.lForm_Client;
        this.lForm_Client.$holders.userForm.$view = this.lForm_User;

        this.f = new spkForms.Form(this.lForm, 'Form');
        this.fClient = new spkForms.Form(this.lForm_Client, 'Form');
        this.fUser = new spkForms.Form(this.lForm_User, 'Form');

        this.lForm_Client.$holders.userForm.$view = this.lForm_User;

        this.fClient.fields.UnderGrade.elem.addEventListener('change', (evt) => {
            this.lForm_Client.$fields.isUnderGrade = 
                    this.fClient.fields.UnderGrade.value; 
            this.lForm.$fields.isUnderGrade = 
                    this.fClient.fields.UnderGrade.value; 
        });
        this.fClient.setValues({
            UnderGrade: rows.rClient.SymlekId !== null,
        });

        this.l.$holders.form.$view = this.lForm;
    }

    _reject() {
        this.lock();
        this.msgs.showLoading();

        let fields = {
            id: this.pager.current.args.id,
        };

        helper.api_Delete_Async('Registrations', fields)
            .then((response) => {
                if (!sys.parseRequestResponse(this, response, (result) => {
                    this.unlock();

                    if (result.success)
                        this.pager.setPage(`lb.subpanels.${panelName}.list`);
                    else {
                        this.msgs.showMessage_Failure(
                                abText.$('Sys:Titles_Error'), result.message);
                        this.msgs.hideLoading();
                    } 
                        })) {
                    this.unlock();
                }
            })
            .catch((e) => {
                console.error(e);

                this.msgs.showMessage_Failure(abText.$('Sys:Titles_Error'), 
                        e.toString());
                this.msgs.hideLoading();
                });
    }

    _submit() {
        this.lock();
        this.msgs.showLoading();

        let fields = {
            id: App.GetInstance().ds.nextId(),
            registrationId: this.pager.current.args.id,
            registrationType: this.data.type,
            row: this.f.getValues(),
            client: this.fClient.getValues(),
            user: this.fUser.getValues(),       
        };

        if (this.data.type === 'Farmer') {
            /* Row */
            fields.row.Clinic__Id = null;

            fields.row.Inseminator__Id = null;

            fields.row.NotificationsEmail = fields.row.HasNotificationsEmail ? 
                    fields.row.NotificationsEmail : null;
            delete fields.row.HasNotificationsEmail;

            /* Client */
            fields.client = this.fClient.getValues();
            fields.client._Id = App.GetInstance().ds.nextId();
            
            fields.client.SymlekId = fields.client.UnderGrade ? 
                    fields.client.SymlekId : null;

            fields.row.HerdUnderGradeNr = fields.client.UnderGrade ? 
                    fields.row.HerdUnderGradeNr : null;
            delete fields.client.UnderGrade;

            /* User */
            fields.user = this.fUser.getValues();
        } else if (this.data.type === 'Inseminator') {
            fields.row.Clinic__Id = null;

            fields.client = this.fClient.getValues();
            fields.user = this.fUser.getValues();

            delete fields.client.UnderGrade;         
        } else
            throw new Error('Unknown registration type.');

        helper.api_Update_Async('Registrations', fields)
            .then((response) => {
                if (!sys.parseRequestResponse(this, response, (result) => {
                    this.unlock();
                    if (result.success) {
                        this.msgs.showMessage_Success(abText.$(
                                'Sys:Successes_ClientCreated'), '', () => {
                            this.lb.pager.setPage('lb.subpanels.registrations.list');
                        });
                    } else {
                        if ('data' in result) {
                            if (result.data !== null) {
                                if ('validator' in result.data) {
                                    this.f.setValidator(result.data.validator);
                                    this.msgs.hideLoading();
                                    return;
                                }
                            }
                        }
            
                        this.msgs.showMessage_Failure(abText.$('Sys:Titles_Error'), 
                                result.error);
                        this.msgs.hideLoading();
                    }
                        })) {
                    this.unlock();
                    this.msgs.hideLoading();
                }
            })
            .catch((e) => {
                console.error(e);

                this.msgs.showMessage_Failure('', e.toString());
                this.msgs.hideLoading();
            });
    }

}


class List extends sys.Module {
    constructor(lb) { super(lb);
        this.m = new modules.List(lb, panelName, panelTitle)

        this.m.l.$fields = {
            shows: {
                add: false,
            },
        };

        this.m.refresh_SetOnRefresh = (rows, colRefs) => {
            sys.tables.formatDateTime(rows, colRefs, 'DateTime');

            sys.tables.format(rows, colRefs, 'Type', (col, row) => {
                if (col.value === 'Farmer')
                    col.html = abText.$('Sys:Titles_Farmer');
                if (col.value === 'Inseminator')
                    col.html = abText.$('Sys:Titles_Inseminator');
            });
        }

        this.m.t
            .setOnRowClick((row, colRefs) => {
                this.pager.setUri(row.href);
            }, (row, colRefs) => {
                return this.pager.getPageUri(`lb.subpanels.${panelName}.edit`,
                        { id: row.cols[colRefs.Id].value, });
            });
        this.m.t.refresh();

        this.$view = this.m;
    }

}





module.exports.Add = Add;
module.exports.Edit = Edit;
module.exports.List = List;
 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\core\panels\newReceipt.js
jsLibs.exportModule('core', 'panels/newReceipt', (require, module, exports) => { 'use strict';

const
    abDate = require('ab-date'),
    abText = require('ab-text'),
    spkTables = require('spk-tables'),

    modules = require('../modules'),
    sys = require('../sys'),
    tables = require('../tables'),
    $layouts = require('../$layouts'),

    App = require('../App'),

    bulls = require('./bulls'),
    cows = require('./cows'),
    farmers = require('./farmers')
;

let panelName = 'newReceipts';
let panelTitle = 'NewReceipts';

class Bull extends sys.Module {

    constructor(lb) { super(lb);
        this.bulls_List = new bulls.List(lb, false);

        lb.setBackButton(true);
        lb.setListener_OnBack(() => {
            this.bulls_List.m.listeners_Back();
            return true;
        });

        // this.bulls_List.lButtons.$fields.shows.register = false;

        /* Associations */
        // this.lAssociations = sys.createLayout($layouts.NewReceipt_AssociatedBulls);        
        // this.tAssociatedBulls = new spkTables.Table(this.msgs, 
        //     tables.tables_AssociatedBulls())
        //     .setNoSort(true)
        //     .setShowSearch(false)
        //     .setOnRefresh((rows, colRefs) => {
        //     })
        //     .setOnRowClick((row, colRefs) => {
        //         this.pager.setUri(row.href);
        //     }, (row, colRefs) => {
        //         return this.pager.getPageUri(`lb.subpanels.newReceipt.details`,
        //                 { cowId: this.pager.current.args.cowId,
        //                 bullId: row.cols[colRefs.Bull__Id].value });
        //     });
        // this.lAssociations.$holders.table.$view = this.tAssociatedBulls;
        // this.bulls_List.m.l.$holders.beforeTable.$view = this.lAssociations;
        /* / Associations */

        this.bulls_List.m.l.$fields = {
            title: abText.$(`Sys:Titles_NewReceipt_Bull`),
            texts: {
                Buttons_Add: abText.$('Sys:Buttons_AddBull'),
            },
            uris: {
                // add: this.pager.getPageUri(`lb.subpanels.bulls.add`, 
                //         { newReceipt_CowId: this.pager.current.args.cowId }),
                back: this.pager.getPageUri('lb.subpanels.newReceipt.cow',
                        { newReceipt_CowId: this.pager.current.args.cowId, }),
            },
        },
        this.bulls_List.lButtons.$fields = {
            uris: {
                add: this.pager.getPageUri(`lb.subpanels.bulls.add`, 
                        { newReceipt_CowId: this.pager.current.args.cowId }),
                back: this.pager.getPageUri('lb.subpanels.newReceipt.cow',
                        { newReceipt_FarmerId: this.pager.current.args.farmerId, }),
            },
        };

        this.bulls_List.m.listeners_Add = () => {
            this.pager.setPage(`lb.subpanels.bulls.add`, 
                    { newReceipt_CowId: this.pager.current.args.cowId });
        };
        this.bulls_List.m.listeners_Back = () => {
            this.pager.setPage('lb.subpanels.newReceipt.cow',
                    { newReceipt_FarmerId: this.pager.current.args.farmerId, });
        };
        // this.bulls_List.listeners_OnRequest = () => {
        //     this.pager.setPage(`lb.subpanels.bulls.request`, {
        //         newReceipt_CowId: this.pager.current.args.cowId,
        //     });
        // }

        this.bulls_List.cowId = this.pager.current.args.cowId;

        this.bulls_List.m.t
            .setNoSort(true)
            // .setOrderBy('Name', false)
            .setOnRowClick((row, colRefs) => {
                this.pager.setUri(row.href);
            }, (row, colRefs) => {
                return this.pager.getPageUri(`lb.subpanels.newReceipt.details`,
                        { cowId: this.pager.current.args.cowId,
                        bullId: row.cols[colRefs._Id].value });
            });
        this.bulls_List.m.t.refresh();

        this.bulls_List.m.refresh_OnApiResult = (data) => {
            if (sys.user.isInseminator) {
                this.bulls_List.m.l.$fields.uris.back = 
                        this.pager.getPageUri('lb.subpanels.newReceipt.cow',
                        { farmerId: data.rFarmer._Id, });
                this.bulls_List.m.listeners_Back = () => {
                    this.pager.setPage('lb.subpanels.newReceipt.cow',
                            { farmerId: data.rFarmer._Id, });
                };
            } 

            // this.lAssociations.$fields.show = data.rAssociatedBulls.length > 0;
            // this.tAssociatedBulls.update(tables.parseRows(
            //         tables.tables_AssociatedBulls().columns, 
            //         data.rAssociatedBulls));
        }

        this.$view = this.bulls_List;
    }   

}


class Cow extends sys.Module {

    constructor(lb) { super(lb);
        this.cows_List = new cows.List(lb, false, false);

        lb.setBackButton(true);
        lb.setListener_OnBack(() => {
            this.cows_List.m.listeners_Back();
            return true;
        });

        // this.cows_List.lButtons.$fields.shows.associations = false;

        this.cows_List.m.l.$fields = {
            title: abText.$(`Sys:Titles_NewReceipt_Cow`),
            texts: {
                Buttons_Add: abText.$('Sys:Buttons_AddCow'),
            },
            uris: {
                add: this.pager.getPageUri(`lb.subpanels.cows.add`, 
                        { farmerId: this.pager.current.args.farmerId, newReceipt: '1' }),
                back: sys.user.info.Farmer__Id !== null ? 
                        this.pager.getPageUri('lb.subpanels.receipts.list') : 
                        this.pager.getPageUri('lb.subpanels.newReceipt.farmer')
            },
        },

        this.cows_List.m.listeners_Add = () => {
            this.pager.setPage(`lb.subpanels.cows.add`, 
                    { farmerId: this.pager.current.args.farmerId, newReceipt: '1' });
        };
        this.cows_List.m.listeners_Back = () => {
            this.pager.setPage(sys.user.info.Farmer__Id !== null ?
                    'lb.subpanels.receipts.list' : 
                    'lb.subpanels.newReceipt.farmer');
        };

        this.cows_List.m.t
            .setApiFields(() => {
                return {
                    farmerId: this.pager.current.args.farmerId,
                };
            })
            .setOnRowClick((row, colRefs) => {
                this.pager.setUri(row.href);
            }, (row, colRefs) => {
                return this.pager.getPageUri(`lb.subpanels.newReceipt.bull`,
                        { cowId: row.cols[colRefs._Id].value, });
            });
        this.cows_List.m.t.refresh();

        this.cows_List.m.refresh_OnApiResult = (data) => {
            if (this.pager.current.args.farmerId !== '0' && 
                    data.rFarmer === null)
                this.pager.setPage( 'lb.subpanels.newReceipt.farmer');
        };

        this.$view = this.cows_List;
    }   

}


class Details extends sys.Module {

    constructor(lb) { super(lb);
        this.data = null;
        this.m = new modules.Form(lb, 'receipts', 'Receipts');

        lb.setBackButton(true);
        lb.setListener_OnBack(() => {
            this.m.listeners_Back();
            return true;
        });

        this.m.onSubmit = (result) => {
            if (result.success) {
                if (App.Platform === 'native') {
                    let app = App.GetInstance();

                    if (app.native.printer !== null) {
                        this.msgs.showConfirmation(
                                abText.$('Sys:Confirmations_PrintReceipt_Title'),
                                abText.$('Sys:Confirmations_PrintReceipt_Text'),
                                abText.$('Sys:Text_Yes'), abText.$('Sys:Text_No'), 
                                (cResult) => {
                            (async () => {
                                if (cResult) {
                                    await app.dataScheme.getTable('Sys_Receipts').update_Async(app.native.db,
                                            [{
                                        _Id: result.data.row._Id,
                                        Printed: true,
                                    }]);
                                    await app.ds.addDBRequest_Async(
                                            'Sys_PrintReceipt_DBSync', 'print', {
                                        _Id: result.data.row._Id,
                                    });

                                    await app.native.nativeActions.callNative_Async('PrintReceipt',
                                            { printerAddress: app.native.printer.address,
                                            row: sys.formatReceiptForPrint(result.data.row), });
                                }

                                await app.syncDB_Helper_Async();
                                this.unlock();
                                    
                                if (sys.user.isInseminator) {
                                    this.pager.setPage('lb.subpanels.newReceipt.cow',
                                            { farmerId: this.data.rCow.Farmer__Id, });
                                } else
                                    this.pager.setPage(`lb.subpanels.receipts.list`);
                            })();
                        });
                    } else {
                        (async () => {
                            await app.syncDB_Helper_Async();
                            this.unlock();
                                
                            if (sys.user.isInseminator) {
                                this.pager.setPage('lb.subpanels.newReceipt.cow',
                                        { farmerId: this.data.rCow.Farmer__Id, });
                            } else
                                this.pager.setPage(`lb.subpanels.receipts.list`);
                        })();
                    }
                } else {
                    this.unlock();

                    if (sys.user.isInseminator) {
                        this.pager.setPage('lb.subpanels.newReceipt.cow',
                                { farmerId: this.data.rCow.Farmer__Id, });
                    } else
                        this.pager.setPage(`lb.subpanels.receipts.list`);
                }
            }
        }

        this.m.l.$fields.shows.delete = false;

        this.m.l.$fields = {
            shows: {
                nr: false,
            },
            texts: {
                Buttons_Submit: sys.eText(`Sys:Buttons_Create`),
                title: sys.eText(`Sys:Titles_NewReceipt_Details`),
            },
            uris: {
                back: this.pager.getPageUri(`lb.subpanels.newReceipt.bull`, 
                        { cowId: this.pager.current.args.cowId, }),
            },
        };

        this.m.lContent.$fields = {
            isNew: true,
        };

        this.m.listeners_Back = () => {
            this.pager.setPage(`lb.subpanels.newReceipt.bull`, 
                    { cowId: this.pager.current.args.cowId, });
        };

        this.m.refresh_OnParseApiResult = (data) => {
            this.data = data;

            if (data.row === null) {
                this.m.f.setValues({
                    Date: abDate.getTime(),
                    FileNr: '0001',
                    TreatmentNr: data.treatmentNr_Next,
                    ReinseminationsCount: '00',
                });
            }

            if (data.rCow !== null) {
                this.m.f.setValues({
                    LastCalving: data.rCow.LastCalving,
                });
            }
        };
        this.m.refresh_OnSetApiFields = (fields) => {
            fields.cow = null;
            fields.cowId = 'cowId' in this.pager.current.args ?
                    this.pager.current.args.cowId : null;
            fields.bull = null;
            fields.bullId = 'bullId' in this.pager.current.args ?
                    this.pager.current.args.bullId : null;

            return fields;
        };
        this.m.submit_OnSetApiFields = (fields) => {
            fields.cow = null;
            fields.cowId = 'cowId' in this.pager.current.args ?
                    this.pager.current.args.cowId : null;
            fields.bull = null;
            fields.bullId = 'bullId' in this.pager.current.args ?
                    this.pager.current.args.bullId : null;

            return fields;
        };

        /* Last Calving */
        $(this.m.f.getField('LastCalving').elem).datetimepicker()
                .on('dp.hide', (evt) => {
            if (this.m.f.getField('LastCalving').value === 
                    this.data.rCow.LastCalving) {
                this.m.f.setValues({
                    TreatmentNr: this.data.treatmentNr_Next,
                });
            } else {
                this.m.f.setValues({
                    TreatmentNr: 1,
                });
            }
        });

        this.m.refresh();

        this.$view = this.m;
    }

}


class Farmer extends sys.Module {

    constructor(lb) { super(lb);
        this.farmers_List = new farmers.List(lb, false);

        lb.setBackButton(true);
        lb.setListener_OnBack(() => {
            this.farmers_List.m.listeners_Back();
            return true;
        });

        // this.farmers_List.lButtons.$fields = {
        //     shows: {
        //         register: false,
        //     },
        // };
        this.farmers_List.m.l.$fields = {
            title: abText.$(`Sys:Titles_NewReceipt_Farmer`),
            uris: {
                add: this.pager.getPageUri(`lb.subpanels.farmers.add`, 
                        { newReceipt: '1' }),
                back: this.pager.getPageUri('lb.subpanels.receipts.list'),
            },
        };

        this.farmers_List.m.listeners_Add = () => {
            this.pager.setPage(`lb.subpanels.farmers.add`, { newReceipt: '1' });
        };
        this.farmers_List.m.listeners_Back = () => {
            this.pager.setPage(`lb.subpanels.receipts.list`);
        };

        this.farmers_List.m.t
            .setOnRowClick((row, colRefs) => {
                this.pager.setUri(row.href);
            }, (row, colRefs) => {
                return this.pager.getPageUri(`lb.subpanels.newReceipt.cow`,
                        { farmerId: row.cols[colRefs._Id].value, });
            });
        this.farmers_List.m.t.refresh();

        this.$view = this.farmers_List;
    }   

}





module.exports.Bull = Bull;
module.exports.Cow = Cow;
module.exports.Details = Details;
module.exports.Farmer = Farmer;
 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\core\texts\pl.ab-data.js
jsLibs.exportModule('core', 'texts/pl.ab-data', (require, module, exports) => { 'use strict';

module.exports = {
    NotChecked: 'To pole musi zostać zaznaczone.',
    NotSet: 'To pole musi zostać wypełnione.',
    NotNull: 'To pole nie może mieć wartości "null".',

    Date_WrongFormat: 'Nieprawidłowy format daty.',
    Date_BelowMinDate: 'Data nie może być wcześniejsza niż {date}.',
    Date_AboveMaxDate: 'Data nie może być późniejsza niż {date}.',

    Email_WrongFormat: 'Nieprawidłowy adres email.',

    Errors_AboveMaxLength: 'Zbyt długi ciąg znaków. Maksymalna długość: {maxLength}.',
    Errors_BelowMinLength: 'Minimalna ilość znaków w tym polu to: {minLength}.',
    Errors_NotAllowedCharacters: 'Pole zawiera niedozwolone znaki: {notAllowedChars}',
    Errors_WrongFormat: 'Nieprawidłowy ciąg znaków. Poprawny format to: {format}',

    Int_NotANumber: 'W tym polu powinna znaleźć się wartość numeryczna.',
    Int_NotAnInt: 'W tym polu powinna znaleźć się liczba całkowita.',
    Int_BelowMin: 'Wartość w tym polu nie może być mniejsza niż {minValue}.',
    Int_AboveMax: 'Wartość w tym polu nie być większa niż {maxValue}.',

    Long_NotANumber: 'W tym polu powinna znaleźć się wartość numeryczna.',
    Long_NotAnInt: 'W tym polu powinna znaleźć się liczba całkowita.',
    Long_BelowMin: 'Wartość w tym polu nie może być mniejsza niż {minValue}.',
    Long_AboveMax: 'Wartość w tym polu nie być większa niż {maxValue}.',

    Radio_WrongValue: 'Nieprawidłowa wartość pola.',    
};





 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\core\texts\pl.js
jsLibs.exportModule('core', 'texts/pl', (require, module, exports) => { 'use strict';

module.exports = {
    
    Aliases_About: 'system',
    Aliases_Account: 'konto',
    Aliases_Add: 'dodaj',
    Aliases_Administrators: 'administratorzy',
    Aliases_Associations: 'kojarzenia',
    Aliases_Backups: 'kopie-zapasowe',
    Aliases_Basic: 'podstawowe',
    Aliases_Bull: 'buhaj',
    Aliases_Bulls: 'buhaje',
    Aliases_Clinics: 'kliniki',
    Aliases_Cow: 'krowa',
    Aliases_Cows: 'krowy',
    Aliases_Details: 'szczegoly',
    Aliases_Edit: 'edytuj',
    Aliases_Farmer: 'hodowca',
    Aliases_Farmers: 'hodowcy',
    Aliases_Home: 'menu',
    Aliases_Inseminators: 'inseminatorzy',
    Aliases_List: 'lista',
    Aliases_LogIn: 'logowanie',
    Aliases_NewReceipt: 'nowe-zaswiadczenie',
    Aliases_Receipts: 'zaswiadczenia',
    Aliases_Registrations: 'rejestracje',
    Aliases_RemindPassword: 'przypomnij-haslo',
    Aliases_ResetPassword: 'reset-hasla',
    Aliases_Request: 'zglos',

    Associations: 'Kojarzenia',

    Buttons_Activate: 'Aktywuj',
    Buttons_Add: 'Dodaj',
    Buttons_AddBull: 'Dodaj Buhaja',
    Buttons_AddCow: 'Dodaj',
    Buttons_All: 'Wszystkie',
    Buttons_Associations: 'Kojarzenia',
    Buttons_Bulls: 'Buhaje',
    Buttons_Cows: 'Krowy',
    Buttons_Create: 'Dodaj',
    Buttons_CurrentMonth: 'Bieżący miesiąc',
    Buttons_CurrentYear: 'Bieżący rok',
    Buttons_DatesRange: 'Zakres dat',
    Buttons_Deactivate: 'Dezaktywuj',
    Buttons_Delete: 'Usuń',
    Buttons_DeleteAll: 'Usuń',
    Buttons_Download: 'Pobierz',
    Buttons_Downloaded: 'Pobrane',
    Buttons_DownloadLastBackup: 'Pobierz najnowszy backup',
    Buttons_DownloadRegister: 'Rejestr',
    Buttons_DownloadReport: 'Pobierz raport',
    Buttons_DownloadSymlek: 'FedInfo',
    Buttons_DownloadUnderGrade: 'Pod oceną',
    Buttons_DownloadNotUnderGrade: 'Poza oceną',
    Buttons_MonthCurrent: 'Bieżący miesiąc',
    Buttons_MonthPrevious: 'Poprzedni miesiąc',
    Buttons_NotUnderGrade:'Poza oceną',
    Buttons_Print: 'Drukuj',  
    Buttons_PreviousMonth: 'Poprzedni miesiąc',  
    Buttons_Register: 'Zarejestruj się',
    Buttons_Reject: 'Odrzuć',
    Buttons_Send: 'Wyślij',
    Buttons_ResetPassword: 'Reset hasła',
    Buttons_RestartApp: 'Restart aplikacji',
    Buttons_Request: "Zgłoś",
    Buttons_RequestUpdate: 'Stado',
    Buttons_RequestBull: 'Zgłoś buhaja',
    Buttons_Save: 'Zapisz',
    Buttons_Test: 'Testowe',
    Buttons_UnderGrade: 'Pod oceną',
    Buttons_Upload: 'Załaduj',
    Buttons_UploadErrors: 'Błędne',
    Buttons_UploadStrawsCount: 'Załaduj słomki',
    Buttons_YearCurrent: 'Bieżący rok',

    Confirmations_ClearData: 'Wyczyścić dane?',
    Confirmations_ClearData_CannotSendUnsyncedData: 'Nie można wysłać niezsynchronizowanych danych. Czy mimo to chcesz wyczyścić dane?',
    Confirmations_CowsRequestUpdate_Title: 'Aktualizacja stada',
    Confirmations_CowsRequestUpdate_Message: 'Czy na pewno chcesz wysłać prośbę o aktualizację stada?',
    Confirmations_Delete: 'Czy na pewno chcesz usunąć?',
    Confirmations_DeleteAssociations: 'Czy na pewno chcesz usunąć wszystkie kojarzenia?',
    Confirmations_DeleteSelected: 'Usunąć zaznaczone?',
    Confirmations_GoOnline_Title: 'Jesteś w trybie offline',
    Confirmations_GoOnline_Message: 'Czy chcesz wyłączyć tryb offline?',
    Confirmations_LogOut: 'Czy na pewno chcesz się wylogować?',
    Confirmations_PrintReceipt_Text: 'Czy chcesz wydrukować zaświadczenie?',
    Confirmations_PrintReceipt_Title: 'Drukowanie',
    Confirmations_ReportProblem: 'Wyślij dane aplikacji, które pozwolą na analizę problemu, a następnie skontaktuj się z przedstawicielem MilkyGen.',
    Confirmations_RestartApp_Title: 'Restart Aplikacji',
    Confirmations_RestartApp_Message: 'Czy na pewno chcesz uruchomić ponownnie aplikację?',

    Errors_Error: 'Wystąpił błąd',
    Errors_ClearDataFailed: 'Nie udało się wyczyścić danych',
    Errors_CannotFindStrawsBull: 'Nie można znaleźć buhaja',
    Errors_CannotLogIn: 'Nie udało się zalogować',
    Errors_CannotSynchronizeData_Title: 'Nie można zsynchronizować danych',
    Errors_CannotSynchronizeData: '{error}',
    Errors_CannotSendProblemReport: 'Nie udało się wysłać raportu dotyczącego błędów.',
    Errors_DBSync_HasWarnings: 'Uwaga!',
    Errors_DBSync_Title: 'Nie udało się zsynchronizować danych',
    Errors_DateTooEarly: 'Data nie może być wcześniejsza niż {date}',
    Errors_DateTooLate: 'Data nie może być późniejsza niż {date}',
    Errors_NoMoreReceiptNrs: 'Brak dostępnych nowych numerów zaświadczeń w trybie offline. Zsynchronizuj aplikację, żeby móc dodać kolejne zaświadczenia.',
    Errors_NoRowsSelected: 'Nie wybrano żadnego wiersza',
    Errors_PasswordCannotBeEmpty: 'Hasło nie może być puste',
    Errors_PasswordsDoNotMatch: 'Podane hasła nie są takie same',
    Errors_Response_CannotParseJSON: 'Błędna odpowiedź serwera',
    Errors_Response_HttpRequestError: 'Błąd połączenia',
    Errors_Response_Other: 'Błąd',
    Errors_Response_ResultError: 'Błąd zapytania',
    Errors_Response_WrongResultFormat: 'Błędny format odpowiedzi serwera',
    Errors_TestConnectionError_Title: 'Błąd połączenia',
    Errors_TestConnectionError_Message: 'Czy chcesz włączyć tryb offline?',
    Errors_TestConnectionTimeout_Title: 'Wykryto słabe połączenie z internetem',
    Errors_TestConnectionTimeout_Message: 'Czy chcesz włączyć tryb offline?',

    Forms_Added_Date_Label: 'Dodano do systemu',
    Forms_Added_Label: 'Data dodania',
    Forms_Added_Identificator_Label: 'Utworzono przez',
    Forms_Address_Label: 'Adres',
    Forms_Address_Placeholder: 'Adres',
    Forms_Birth_Label: 'Data urodzenia',
    Forms_Birth_Placeholder: 'Data',
    Forms_City_Label: 'Miejscowość',
    Forms_City_Placeholder: 'Miejscowość',
    Forms_Clinic_Label: 'Klinika',
    Forms_Company_Label: 'Firma',
    Forms_Company_Placeholder: 'Firma',
    Forms_Confirmation_Label: 'Zapoznałam/em się z informacją dotyczącą przetwarzania danych osobowych i wyrażam zgodę na przetwarzanie moich danych osobowych przez firmę MilkyGen.',
    Forms_ContactForm_Label: 'Formularz kontaktowy:',
    Forms_ContactForm_Placeholder: 'Treść wiadomości...',
    Forms_Count_Placeholder: 'Liczba',
    Forms_CowshedNr_Label: 'Numer oborowy',
    Forms_CowshedNr_Placeholder: 'Numer oborowy',
    Forms_Downloaded_Label: 'Pobrane do FedInfo',
    Forms_Genealogy_Nr: 'Numer',
    Forms_Genealogy_Name: 'Nazwa',
    Forms_Id_Label: 'ID',
    Forms_LastActivity_Label: 'Ostatnia aktywność',
    Forms_Date_Label: 'Data',
    Forms_Date_Placeholder: 'Data',
    Forms_DateFrom_Label: 'Data od',
    Forms_DateFrom_Placeholder: 'od',
    Forms_DateRange_Label: 'Wybierz zakres dat',
    Forms_DateTo_Label: 'Data do',
    Forms_DateTo_Placeholder: 'do',
    Forms_District_Label: 'Powiat',
    Forms_District_Placeholder: 'Powiat',
    Forms_Email_Label: 'Email',
    Forms_Email_Placeholder: 'Email',
    Forms_External_Label: 'Zewnętrzny',
    Forms_FileNr_Label: 'Nr kartoteki',
    Forms_FileNr_Placeholder: 'Nr kartoteki',
    Forms_FirstName_Label: 'Imię',
    Forms_FirstName_Placeholder: 'Imię',
    Forms_HerdNr_Label: 'Nr siedziby stada',
    Forms_HerdNr_Placeholder: 'Nr siedziby stada',
    Forms_HerdUnderGradeNr_Label: 'Nr stada pod oceną',
    Forms_HerdUnderGradeNr_Placeholder: 'Nr stada pod oceną',
    Forms_IdentificationNr_Label: 'Numer',
    Forms_IdentificationNr_Placeholder: 'Numer',
    Forms_Inseminator_Label: 'Inseminator',
    Forms_LastCalving_Label: 'Ostatnie wycielenie',
    Forms_LastCalving_Placeholder: 'Data',
    Forms_ManufacturerNr_Label: 'Numer wet. producenta',
    Forms_ManufacturerNr_Placeholder: 'Numer wet. producenta',
    Forms_Mobile_Label: 'Tel. komórkowy',
    Forms_Mobile_Placeholder: 'Numer telefonu...',
    Forms_NIP_Label: 'NIP',
    Forms_NIP_Placeholder: 'NIP',
    Forms_Name_Label: 'Nazwa',
    Forms_Name_Placeholder: 'Nazwa',
    Forms_Note_Label: 'Notatka',
    Forms_Note_Placeholder: 'Notatka',
    Forms_NotificationsEmail_Label: 'Powiadomienia o wystawieniu zaświadczenia',
    Forms_NotificationsEmail_Placeholder: 'Email do powiadomień',
    Forms_Nr_Label: 'Nr',
    Forms_Number_Placeholder: 'Numer',
    Forms_PESEL_Label: 'PESEL',
    Forms_PESEL_Placeholder: 'PESEL',
    Forms_Phone_Label: 'Telefon',
    Forms_Phone_Placeholder: 'Numer telefonu...',
    Forms_PostCity_Label: 'Poczta',
    Forms_PostCity_Placeholder: 'Poczta',
    Forms_Race_Label: 'Rasa',
    Forms_Race_Placeholder: 'Rasa',
    Forms_ReasonForDeletingAccount_Label: 'Powód usunięcia konta',
    Forms_ReasonForDeletingAccount_Placeholder: '...',
    Forms_ReceiptNotifications_Label: 'Powiadomienia o ponownym kryciu',
    Forms_ReinseminationsCount_Label: 'Liczba reinseminacji',
    Forms_ReinseminationsCount_Placeholder: 'Liczba reinseminacji',
    Forms_SemenProduction_Label: 'Data produkcji nasienia',
    Forms_SemenProduction_Placeholder: 'Data',
    Forms_Sexed_Label: 'Seksowane',
    Forms_ShipTo_Label: 'Ship to',
    Forms_ShipTo_Placeholder: 'Ship to',
    Forms_StrawsCount_Label: 'Liczba słomek',
    Forms_StrawsCount_Placeholder: 'Liczba słomek',
    Forms_StrawsConvCount_Label: 'Liczba słomek KONW.',
    Forms_StrawsConvCount_Placeholder: 'Liczba słomek',
    Forms_SymlekId_Label: 'FedInfo ID',
    Forms_SymlekId_Placeholder: 'FedInfo ID',
    Forms_TestClient_Label: 'Klient testowy',
    Forms_TreatmentDate_Label: 'Data pokrycia',
    Forms_TreatmentNr_Label: 'Nr zabiegu',
    Forms_TreatmentNr_Placeholder: 'Nr zabiegu',
    Forms_UnderGrade_Label: 'Pod oceną',
    Forms_UnderGrade_Placeholder: 'Pod oceną',
    Forms_ZipCode_Label: 'Kod pocztowy',
    Forms_ZipCode_Placeholder: 'Kod pocztowy',

    Labels_Deleted: 'Usunięte',
    Labels_Password: 'Hasło',
    Labels_NewPassword: 'Nowe hasło',
    Labels_NewPassword_Confirmation: 'Powtórz nowe hasło',

    LoadMore: 'Załaduj więcej',

    Loadings_DBSync: 'Synchronizowanie danych',

    LogIn_LogIn: 'Zaloguj',
    LogIn_Login_Placeholder: 'login',
    LogIn_Password_Placeholder: 'hasło',

    Messages_NoInternetConnection: 'Brak połączenia z internetem.',

    NewPassword_Placeholder: 'Nowe hasło',
    NewPassword_Confirmation_Placeholder: 'Powtórz nowe hasło',

    Notifications_NoReceiptsSelected: 'Nie wybrano żadnych zaświadczeń',
    Notifications_NoReceiptsToDownload: 'Brak zaświadczeń do pobrania',

    Options_None: 'Brak',

    Printer_PrinterSet: 'Ustawiono drukarkę',

    RemindPassword: 'Zresetuj hasło',
    RemindPassword_RemindPassword: 'Zresetuj hasło',
    RemindPassword_RemindPassword_Placeholder: 'mail',

    SPKMessages_Close: 'Zamknij',

    Successes_ClientCreated: 'Użytkownik został dodany',
    Successes_ProblemReportSent: 'Wysłano raport dotyczący błędów.',
    Successes_RequestedBull_Title: 'Sukces',
    Successes_RequestedBull_Message: 'Zgłoszono buhaja. Buhaj zostanie dodany do listy w ciągu jednego dnia roboczego od synchronizacji aplikacji.',
    Successes_RequestedUpdate_Title: 'Sukces',
    Successes_RequestedUpdate_Message: 'Zgłoszenie zostało wysłane. Stado zostanie zaktualizowane w ciągu jednego dnia roboczego od synchronizacji aplikacji.',
    Successes_Success: 'Sukces',
    Successes_SuccessMessage: 'Zmiany zostały zapisane.',

    TableEmpty: 'Tabela jest pusta',

    TableHeaders_Added: 'Dodano',
    TableHeaders_Address: 'Adres',
    TableHeaders_Birth: 'Data urodzenia',
    TableHeaders_Bull: 'Buhaj',
    TableHeaders_BullName: 'Buhaj',
    TableHeaders_City: 'Miejscowość',
    TableHeaders_Client: 'Klient',
    TableHeaders_Clinic: 'Klinika',
    TableHeaders_Company: 'Firma',
    TableHeaders_Cow: 'Krowa',
    TableHeaders_Cow_FirstName: 'Nazwa',
    TableHeaders_CowshedNr: 'Nr ob.',
    TableHeaders_CustomBull: 'Własny',
    TableHeaders_Date: 'Data',
    TableHeaders_Downloaded: 'Pobrano',
    TableHeaders_Email: 'Email',
    TableHeaders_External: 'Zewnętrzny',
    TableHeaders_Farmer: 'Hodowca',
    TableHeaders_FirstName: 'Nazwa',
    TableHeaders_HerdUnderGradeNr: 'Nr st. pod oc.',
    TableHeaders_Id: 'ID',
    TableHeaders_Inb: 'Inb',
    TableHeaders_InseminationDate: 'Data',
    TableHeaders_Inseminator: 'Inseminator',
    TableHeaders_LastInsemination: 'Ostatnie krycie',
    TableHeaders_Name: 'Nazwa',
    TableHeaders_Nr: 'Numer',
    TableHeaders_OrdinalNumber: 'Lp.',
    TableHeaders_Race: 'Rasa',
    TableHeaders_RegistrationType: 'Typ użytkownika',
    TableHeaders_Sexed: 'SEX',
    TableHeaders_StrawsConvCount: 'Słomki',
    TableHeaders_StrawsConvCount_Client: 'Słomki',
    TableHeaders_Symlek: 'FedInfo',
    TableHeaders_SymlekId: 'FedInfo ID',
    TableHeaders_TestUser: 'Testowy',
    TableHeaders_TreatmentNr: 'Nr zabiegu',

    Text_Bulls: 'Buhaje',
    Text_Bull: 'Buhaj',
    Text_Clinic: 'Klinika',
    Text_Company: 'Firma',
    Text_Cow: 'Krowa',
    Text_DownloadingFile: 'Trwa pobieranie',
    Text_Farmers: 'Hodowcy',
    Text_Farmer: 'Hodowca',
    Text_Filter: 'Filtruj',
    Text_Inseminator: 'Inseminator',
    Text_LogInMessage: 'Zaloguj się do systemu',
    Text_ManageAccount: 'Zarządzaj kontem',
    Text_No: 'Nie',
    Text_PreparingFile: 'Trwa przygotowywanie pliku: ',
    Text_Receipts: 'Zaświadczenia',
    Text_SelectedClinic: 'Klinika',
    Text_SelectedUserType: 'Wybrany typ użytkownika',
    Text_Users: 'Użytkownicy',
    Text_Yes: 'Tak',

    Titles_About: 'System',
    Titles_Account: 'Moje Konto',
    Titles_Add: 'Dodaj',
    Titles_Administrators_Create: 'Utwórz pracownika',
    Titles_Administrators_Save: 'Edycja',
    Titles_AppId: 'ID aplikacji',
    Titles_AppVersion: 'Wersja aplikacji',
    Titles_Associations: 'Kojarzenia',
    Titles_BackupFiles: 'Backupy',
    Titles_Bull: 'Buhaj',
    Titles_Cow: 'Krowa',
    Titles_Details: 'Szczegóły zaświadczenia',
    Titles_Error: 'Błąd',
    Titles_Farmers_Create: 'Dodaj Hodowcę',
    Titles_Administrators: 'Pracownicy',
    Titles_Backups: 'Backupy',
    Titles_Basic: 'Podstawowy',
    Titles_Bulls: 'Buhaje',
    Titles_Bulls_Create: 'Dodaj buhaja',
    Titles_Bulls_Save: 'Buhaj',
    Titles_ClearData_Caption: 'UWAGA!',
    Titles_ClearData_Message: 'Przy wylogowaniu lub wyczyszczeniu danych wszystkie nieprzesłane do systemu dane zostaną usunięte.',
    Titles_ClearData_Shortcut: 'Wyczyść dane',
    Titles_Clinics: 'Kliniki',
    Titles_Clinics_Create: 'Dodaj klinikę',
    Titles_Clinics_Save: 'Edycja',
    Titles_Cows: 'Krowy',
    Titles_Cows_Create: 'Dodaj krowę',
    Titles_CowHistory: 'Zaświadczenia',
    Titles_Cows_Save: 'Krowa',
    Titles_DeviceId: 'ID urządzenia',
    Titles_Edit: 'Edycja',
    Titles_Farmer: 'Hodowca',
    Titles_Farmers: 'Hodowcy',
    Titles_Farmers_Save: 'Hodowca',
    Titles_Genealogy: 'Rodowód',
    Titles_Genealogy_F: 'Ojciec',
    Titles_Genealogy_M: 'Matka',
    Titles_Home: 'Home',
    Titles_Inseminator: 'Inseminator',
    Titles_Inseminators: 'Inseminatorzy',
    Titles_Inseminators_Create: 'Dodaj Inseminatora',
    Titles_Inseminators_Save: 'Inseminator',
    Titles_List: 'Lista',
    Titles_LogIn: 'Zaloguj się',
    Titles_MyApp: 'Moja aplikacja',
    Titles_LogOut_Shortcut: 'Wyloguj się',
    Titles_NewReceipt: 'Nowe zaświadczenie',
    Titles_NewReceipt_Bull: 'Wybierz buhaja',
    Titles_NewReceipt_Cow: 'Wybierz krowę',
    Titles_NewReceipt_Details: 'Wypełnij szczegóły',
    Titles_NewReceipt_Farmer: 'Wybierz hodowcę',
    Titles_NewReceipt_Shortcut: 'Dodaj zaświadczenie',
    Titles_OfflineMode: 'Tryb Offline',
    Titles_Receipts: 'Zaświadczenia',
    Titles_Receipts_Save: 'Zaświadczenie',
    Titles_Registrations: 'Rejestracja',
    Titles_Registrations_Edit: 'Edycja',
    Titles_Refresh_Shortcut: 'Odśwież',
    Titles_RemindPassword: 'Przypominanie hasła',
    Titles_RemovePrinter_Shortcut: 'Usuń drukarkę', 
    Titles_ReportProblem_Shortcut: 'Zgłoś Problem',
    Titles_ResetPassword: 'Zmiana hasła',
    Titles_SetPrinter_Shortcut: 'Ustaw drukarkę',
    Titles_RequestBull: 'Zgłoś buhaja',
    Titles_Sys: 'e-MilkyGen',
    Titles_UserName: 'Użytkownik',

    Search_Placeholder: 'szukaj',

    UserInfo_LogOut: 'Wyloguj się',

    Warnings_Warning: 'Uwaga',
    Warnings_UpdateApp: 'Zsynchronizuj aplikację',
    Warnings_UpdateApp_Message: 'Twoja aplikacja nie była synchornizowana od dłuższego czasu. Pamiętaj o połączeniu z internetem w celu przesłania danych do systemu. ',

    Validator_CowNr_Invalid: 'Niepoprawny numer',
    Validator_CowNr_WrongFormat: 'Nieprawidłowy format numeru',
    Validator_CowNr_WrongLength: 'Nieprawidłowa długość numeru',
};






 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\core\$ab-data\PrintReceiptRequestDef.js
jsLibs.exportModule('core', '$ab-data/PrintReceiptRequestDef', (require, module, exports) => { 'use strict';

const
    abData = require('ab-data'),
    js0 = require('js0')
;

class PrintReceiptRequestDef extends abData.scheme.RequestDef {

    constructor() {
        super();

        this
            .defA('print', 'r', {
                id: 'int',
            }, {
                success: 'boolean',
                error: [ 'string', js0.Null ],
            });
    }

}
module.exports = PrintReceiptRequestDef;





 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\core\$ab-data\TableRequestDef_Core.js
jsLibs.exportModule('core', '$ab-data/TableRequestDef_Core', (require, module, exports) => { 'use strict';

const
    abData = require('ab-data'),
    js0 = require('js0')
;

class TableRequestDef_Core extends abData.scheme.RequestDef {

    constructor() {
        super();

        this
            .defA('delete', 'r', {
                args: js0.RawObject,
            }, {
                data: js0.RawObject,
                success: 'boolean',
                error: [ 'string', js0.Null ],
                debug: [ null, js0.Default(null) ],
            })
            .defA('deleteSelected', 'r', {
                args: js0.RawObject,
            }, {
                data: js0.RawObject,
                success: 'boolean',
                error: [ 'string', js0.Null ],
                debug: [ null, js0.Default(null) ],
            })
            .defA('row', 'r', {
                args: js0.RawObject,
            }, {
                data: js0.RawObject,
                success: 'boolean',
                error: [ 'string', js0.Null ],
                debug: [ null, js0.Default(null) ],
            })
            .defA('select', 'r', {
                args: js0.RawObject,
            }, {
                data: js0.RawObject,
                success: 'boolean',
                error: [ 'string', js0.Null ],
                debug: [ null, js0.Default(null) ],
            })
            .defA('update', 'r', {
                args: js0.RawObject,
            }, {
                data: js0.RawObject,
                success: 'boolean',
                error: [ 'string', js0.Null ],
                debug: [ null, js0.Default(null) ],
            });
    }

}
module.exports = TableRequestDef_Core;





 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\core\$ab-data\index.js
jsLibs.exportModule('core', '$ab-data/index', (require, module, exports) => { 'use strict';

const 
    abData = require('ab-data'),
    abStrings = require('ab-strings'),
    js0 = require('js0'),
    
    f = abData.fields,
    s = abData.scheme,
    v = abData.validators,

    PrintReceiptRequestDef = require('./PrintReceiptRequestDef'),
    TableRequestDef_Core = require('./TableRequestDef_Core')
;

module.exports = function (types) {
    js0.args(arguments, js0.Iterable(js0.Enum([ 'db', 'native' ])));

    let ds = new s.DataScheme(2);

    ds
        // .defT(tSys_Associations)
        .defT(tSys_Bulls)
        .defT(tSys_ClientBulls)
        .defT(tSys_Clients)
        .defT(tSys_Cows)
        .defT(tSys_Farmers)
        .defT(tSys_Inseminators)
        .defT(tSys_Receipts)
        .defT(tSys_Users)

    if (types.includes('db')) {
        ds
            .ignoreT([ '_ABData_DeletedRows', '_ABData_DeviceRequests',
                '_ABData_DeviceRows', '_ABData_Devices',
                
                'App_Infos', 'Cache_Files', 'Config_Settings', 
                'Log_Logs', 'Session_Sessions', 'Sys_Registrations', 'Tasks_Tasks', 
                'Users_Users', 'Users_ResetPasswordHashes' ])

            .defT(tSys_Administrators)
            .defT(tSys_Clinics)
    }

    /* Request Defs */
    /* Bulls */
    let rBullsDef = new TableRequestDef_Core();
    rBullsDef.defA('request', 'r', {
        args: js0.RawObject,
    }, {
        data: js0.RawObject,
        success: 'boolean',
        error: [ 'string', js0.Null ],
        debug: [ null, js0.Default(null) ],
    });
    /* Cows */
    let rCowsDef = new TableRequestDef_Core();
    rCowsDef.defA('requestUpdate', 'r', {
        args: js0.RawObject,
    }, {
        data: js0.RawObject,
        success: 'boolean',
        error: [ 'string', js0.Null ],
        debug: [ null, js0.Default(null) ],
    });

    if (types.includes('native')) {
        ds.ignoreT([ 'Sys_Clinics' ]);

        ds
            // .defT('_ABData_DeviceInfos', tABData_DeviceInfos)
            .defT(tABData_DBRequests)
            .defT(tABData_Settings)
            .defT(tABData_DeviceDeletedRows)

            .defT(tNative_Settings)

        ds
            .defR('Sys_Associations', new TableRequestDef_Core())
            .defR('Sys_Bulls', rBullsDef)
            .defR('Sys_Cows', rCowsDef)
            .defR('Sys_Farmers', new TableRequestDef_Core())
            .defR('Sys_Receipts', new TableRequestDef_Core())

            .defR('Sys_ClientBulls', new s.TableRequestDef())

            .defR('Sys_PrintReceipt', new PrintReceiptRequestDef())
    } else {
        ds
            .defR('Sys_Administrators', new TableRequestDef_Core())
            .defR('Sys_Inseminators', new TableRequestDef_Core())

            .defR('Sys_Associations', new TableRequestDef_Core())
            .defR('Sys_Bulls', rBullsDef)
            .defR('Sys_ClientBulls', new TableRequestDef_Core())
            .defR('Sys_Clinics', new TableRequestDef_Core())
            .defR('Sys_Cows', rCowsDef)
            .defR('Sys_Farmers', new TableRequestDef_Core())
            .defR('Sys_Receipts', new TableRequestDef_Core())

            .defR('Sys_Registrations', new TableRequestDef_Core());
    }

    return ds;
};

/* Tables */
/* System */
// let tABData_DeviceInfos = new abData.Table(101, '_ABData_DeviceInfos', 'abd_di', [
//     [ 'Id',             f.String(16, { notNull: true }) ],
//     [ 'RequestName',    f.String(16, { notNull: true }) ],
//     [ 'ActionName',     f.String(16, { notNull: true }) ],
//     [ 'ActionArgs',     f.JSON({ notNull: true }) ],
//         ])
//     .setPKs([ 'Id' ]);

let tABData_DeviceDeletedRows = new abData.Table(102, '_ABData_DeviceDeletedRows', 
        'abd_ddr', [
    [ 'TableId',    f.Int({ notNull: true }) ],
    [ 'RowId',      f.Long({ notNull: true }) ],
        ])
    .setPKs([ 'TableId', 'RowId' ]);

let tABData_DBRequests = new abData.Table(103, '_ABData_DBRequests', 'abd_dbr', [
    [ 'Id',             f.String(16, { notNull: true }) ],
    [ 'RequestName',    f.String(16, { notNull: true }) ],
    [ 'ActionName',     f.String(16, { notNull: true }) ],
    [ 'ActionArgs',     f.JSON({ notNull: true }) ],
    [ 'SchemeVersion',  f.Int({ notNull: false }) ],
        ])
    .setPKs([ 'Id' ]);

let tABData_Settings = new abData.Table(104, '_ABData_Settings', 'abd_s', [
    [ 'Name', f.String(16, { notNull: true, }) ],
    [ 'Data', f.JSON({ notNull: true}) ],
        ])
    .setPKs([ 'Name' ]);

/* Native */
let tNative_Settings = new abData.Table(201, '_Native_Settings', 'n_s', [
    [ 'Name', f.String(16, { notNull: true, }) ],
    [ 'Data', f.JSON({ notNull: true}) ],
        ])
    .setPKs([ 'Name' ]);

// let tTableIds = new abData.Table('_ABData_TableIds', 'abd_r', [
//     [ 'TableName',             f.String(16, { notNull: true }) ],
//     [ 'NextId',    f.String(16, { notNull: true }) ],
//         ])
//     .setPKs('TableName, NextId');


let tSys_Administrators = new abData.RTable(1001, 'Sys_Administrators', 's_adm', [
    [ 'User__Id', f.Id({ notNull: false, }) ],
    [ 'Name', f.String(64, { notNull: true, }) ],
]);

let tSys_Associations = new abData.RTable(1002, 'Sys_Associations', 's_a', [
    [ 'Cow__Id', f.Id({ notNull: true, }), ],
    [ 'Bull__Id', f.Id({ notNull: true, }), ],
    [ 'Inb', f.Float({ notNull: false, }) ],
]);

let tSys_Bulls = new abData.RTable(1003, 'Sys_Bulls', 's_b', [
    [ 'Client__Id', f.Id({ notNull: false, }) ],

    [ 'Name', f.String(64, { notNull: true, }), {
        required: false,
    }],
    [ 'Nr', f.String(20, { notNull: true, }), {
        required: true,
        regexp: [ '^[A-Z0-9]{0,14}$', 'AB123456789012' ],
    }],
    [ 'ManufacturerNr', f.String(20, { notNull: true, }), {
        required: false,
    }],
    [ 'Race', f.String(64, { notNull: true, }), {
        required: false,
    }],

    [ 'Added_Date', f.Time({ notNull: true, }) ],
    [ 'Added_User__Id', f.Long({ notNull: true, }) ],
    [ 'Added_Identificator', f.String(256, { notNull: true, }), {
        required: false,
    }],
]);

let tSys_ClientBulls = new abData.RTable(1004, 'Sys_ClientBulls', 's_cb', [
    [ 'Client__Id', f.Id({ notNull: false, }) ],
    [ 'Bull__Id', f.Id({ notNull: false, }) ],
    [ 'StrawsConvCount_Client', f.Int({ notNull: false, }) ],
    [ 'Note', f.String(256, { notNull: true, }), {
        required: false,
        chars: abStrings.getCharsRegExp_Basic('\r\n'),
    }],
]);

let tSys_Clients = new abData.RTable(1005, 'Sys_Clients', 's_cl', [
    [ 'User__Id', f.Id({ notNull: false, }) ],

    [ 'SymlekId', f.String(6, { notNull: false, }), {
        'regexp': [ '^[0-9]{6}$', '123456' ],
    }],
    [ 'Name', f.String(64, { notNull: true, }) ],
    // [ 'ShipTo', f.String(32, { notNull: true, }), {
    //     required: false,
    // }],
    [ 'Address', f.String(256, { notNull: true, }), {
        required: false,
    }],
    [ 'City', f.String(64, { notNull: true, }), {
        required: false,
    }],
    [ 'Phone', f.String(9, { notNull: true, }), {
        required: false,
        regexp: [ '^[0-9]{9}$', '123456789' ],
    }],
    [ 'Test', f.Bool({ notNull: true, }), {
        required: false,
    }],

    [ 'Added_Date', f.Time({ notNull: true, }) ],
    [ 'Added_User__Id', f.Long({ notNull: true, }) ],
    [ 'Added_Identificator', f.String(256, { notNull: true, }), {
        required: false,
    }],]);

let tSys_Clinics = new abData.RTable(1013, 'Sys_Clinics', 's_cl', [
    [ 'Client__Id', f.Id({ notNull: true, }) ],
]);

let tSys_Cows = new abData.RTable(1006, 'Sys_Cows', 's_c', [
    [ 'Farmer__Id', f.Id({ notNull: false, }) ],

    [ 'Nr', f.String(14, { notNull: true, }), {
        regexp: [ '^[A-Z0-9]{0,14}$', 'AB123456789012' ],
    }],
    [ 'CowshedNr', f.String(14, { notNull: true, }), {
        required: false,
        regexp: [ '^[0-9]{0,5}$', '12345' ],
    }],
    [ 'Name', f.String(64, { notNull: true, }), {
        required: false,
    }],
    [ 'Race', f.String(2, { notNull: true, }), {
        required: false,
        minLength: 2,
        chars: abStrings.getCharsRegExp([ 'letters' ]),
    }],
    [ 'Birth', f.Time({ notNull: false, }, {
        type: 'date',
    })],
    [ 'LastCalving', f.Time({ notNull: false, }, {
        type: 'date',
    })],
    [ 'Note', f.String(256, { notNull: true, }), {
        required: false,
        chars: abStrings.getCharsRegExp_Basic('\r\n'),
    }],

    [ 'Added_Date', f.Time({ notNull: true, }) ],
    [ 'Added_User__Id', f.Long({ notNull: true, }) ],
    [ 'Added_Identificator', f.String(256, { notNull: true, }), {
        required: false,
    }],
]);

let tSys_Farmers = new abData.RTable(1008, 'Sys_Farmers', 's_f', [
    [ 'Client__Id', f.Id({ notNull: false, }) ],
    [ 'Inseminator__Id', f.Id({ notNull: false, }) ],
    [ 'Clinic__Id', f.Id({ notNull: false, }) ],

    [ 'HerdNr', f.String(14, { notNull: true }), {
        required: true,
        regexp: [ '^[a-zA-Z]{2}[0-9]{12}$', 'AB123456789012' ],
    }],
    [ 'HerdUnderGradeNr', f.String(7, { notNull: false }), {
        regexp: [ '^[0-9]{7}$', '1234567' ],
    }],
    [ 'NotificationsEmail', f.String(128, { notNull: false }), {
        required: false,
    }],
        ])
    .addColumnValidator('NotificationsEmail', v.Email({
        notNull: false,
        required: false,
}));

let tSys_Inseminators = new abData.RTable(1009, 'Sys_Inseminators', 's_i', [
    [ 'Client__Id', f.Id({ notNull: false, }) ],
    [ 'Clinic__Id', f.Id({ notNull: false, }) ],
]);

let tSys_Receipts = new abData.RTable(1010, 'Sys_Receipts', 's_r', [
    [ 'Farmer__Id', f.Id({ notNull: false }) ],
    [ 'Inseminator__Id', f.Id({ notNull: false }) ],
    [ 'Clinic__Id', f.Id({ notNull: false, }) ],

    [ 'Deleted', f.Bool({ notNull: true, }), {
        required: false,
    }],
    [ 'Error', f.String(512, { notNull: false, }) ],
    
    [ 'Added', f.Time({ notNull: true, }) ],
    [ 'Downloaded', f.Time({ notNull: false, }) ],
    [ 'Downloaded_Client', f.Time({ notNull: false, }) ],
    [ 'Nr', f.Int({ notNull: true, }) ],
    // [ 'Nr_Formatted', f.Expr('IFNULL(s_r.Nr, CONCAT("' +
    //         abConfig.getRequired('Sys', 'receiptPrefix') +
    //         '", LPAD(s_r.Id, 7, 0)))'),
    //         f.String(9, { notNull: false }) ],
    [ 'Date', f.Time({ notNull: true }) ],
    [ 'FileNr', f.String(6, { notNull: true }), {
        chars: abStrings.getCharsRegExp([ 'digits' ]),
    }],
    [ 'TreatmentNr', f.String(2, { notNull: true }), {
        regexp: [ '^[0-9]{1,2}$', '1' ],
    }],
    [ 'ReinseminationsCount', f.String(2, { notNull: true }), {
        regexp: [ '^[0-9]{2}$', '01' ],
    }],
    [ 'LastCalving', f.Time({ notNull: false }) ],
    [ 'SemenProduction', f.Time({ notNull: false }), {
        required: false,
    }],
    [ 'Note', f.String(512, { notNull: true }), {
        required: false,
        chars: abStrings.getCharsRegExp_Basic('\r\n'),
    }],
    
    [ 'InseminatorSymlekId', f.String(6, { notNull: false }) ],
    [ 'InseminatorName', f.String(64, { notNull: true }) ],

    [ 'Farmer_Client_Name', f.String(64, { notNull: true, }) ],
    [ 'Farmer_Client_Address', f.String(256, { notNull: true, }), {
        required: false,
    }],
    [ 'Farmer_Client_City', f.String(64, { notNull: true, }), {
        required: false,
    }],

    [ 'Farmer_HerdNr', f.String(14, { notNull: true }), {
        regexp: [ '^[a-zA-Z]{2}[0-9]{12}$', 'AB123456789012' ],
    }],
    [ 'Farmer_HerdUnderGradeNr', f.String(7, { notNull: false }), {
        regexp: [ '^[0-9]{7}$', '1234567' ],
    }],

    [ 'Cow_Nr', f.String(14, { notNull: true, }), {
        regexp: [ '^[A-Z0-9]{0,14}$', 'AB123456789012' ],
    }],
    [ 'Cow_CowshedNr', f.String(14, { notNull: true, }), {
        required: false,
        regexp: [ '^[0-9]{0,5}$', '12345' ],
    }],
    [ 'Cow_Name', f.String(64, { notNull: true, }), {
        required: false,
    }],
    [ 'Cow_Race', f.String(2, { notNull: true, }), {
        required: false,
        minLength: 2,
        chars: abStrings.getCharsRegExp([ 'letters' ]),
    }],
    [ 'Cow_Birth', f.Time({ notNull: false, }) ],

    [ 'Bull_Name', f.String(64, { notNull: true, }), {
        required: false,
    }],
    [ 'Bull_Nr', f.String(20, { notNull: true, }), {
        required: true,
        regexp: [ '^[A-Z0-9]{0,14}$', 'AB123456789012' ],
    }],
    [ 'Bull_ManufacturerNr', f.String(20, { notNull: true, }), {
        required: false,
    }],
    [ 'Bull_Race', f.String(64, { notNull: true, }), {
        required: false,
    }],

    [ 'Test', f.Bool({ notNull: true, }), {
        required: false,
    }],

    [ 'Printed', f.Bool({ notNull: true }), {
        required: false,
    }],

    [ 'Added_Date', f.Time({ notNull: true }) ],
    [ 'Added_User__Id', f.Long({ notNull: true }) ],
    [ 'Added_Identificator', f.String(256, { notNull: true, }), {
        required: false,
    }],
]);

let tSys_Users = new abData.RTable(1012, 'Sys_Users', 's_u', [
    [ 'Email', f.String(128, { notNull: true }) ],
    [ 'LastActivity', f.Time({ notNull: false }) ],
    [ 'Added_Date', f.Time({ notNull: true }) ],
    [ 'Added_User__Id', f.Long({ notNull: true }) ],
    [ 'Added_Identificator', f.String(256, { notNull: true, }), {
        required: false,
    }],
        ])
    .addColumnValidator('Email', v.Email());





 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\core\pages\PrivacyPolicy.js
jsLibs.exportModule('core', 'pages/PrivacyPolicy', (require, module, exports) => { 'use strict';

const
    abText = require('ab-text'),
    spkForms = require('spk-forms'),
    spocky = require('spocky'),
    webABApi = require('web-ab-api'),

    sys = require('../sys'),

    $layouts = require('../$layouts')
;

class PrivacyPolicy extends spocky.Module {

    constructor(mMain) {
        super();

        // this.mMain = mMain;
        // this.msgs = mMain.msgs;

        this.l = sys.createLayout($layouts.PrivacyPolicy);   

        this.$view = this.l;
    }

}

module.exports = PrivacyPolicy;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\core\pages\DeleteAccount.js
jsLibs.exportModule('core', 'pages/DeleteAccount', (require, module, exports) => { 'use strict';

const
    abText = require('ab-text'),
    spkForms = require('spk-forms'),
    spocky = require('spocky'),
    webABApi = require('web-ab-api'),

    sys = require('../sys'),

    $layouts = require('../$layouts')
;

class DeleteAccount extends spocky.Module {

    constructor(mMain) {
        super();

        this.mMain = mMain;
        this.msgs = mMain.msgs;

        this.l = sys.createLayout($layouts.DeleteAccount);   

        this.f = new spkForms.Form(this.l, 'Form');
        this.l.$elems.SendDeleteAccountRequest.addEventListener('click', 
                (evt) => {
            evt.preventDefault();
            this.sendDeleteAccountRequest();
        });

        this.$view = this.l;
    }

    sendDeleteAccountRequest() {
        this.msgs.showLoading();

        let fields = this.f.getValues();
        webABApi.json(sys.uris.pages['api.deleteAccount'] + 'send-delete-account-request',
                fields, (result) => {
            if (result.isSuccess()) {
                this.f.setValues({
                    Name: '',
                    Email: '',
                    Reason: '',
                });

                this.msgs.showMessage_Success(abText.$('Sys:Successes_Success'));
                this.msgs.hideLoading();
            } else if (result.isFailure()) {
                if ('validator' in result.data) {
                    this.f.setValidator(result.data.validator);
                    this.msgs.hideLoading();
                    return;
                }
    
                this.msgs.showMessage_Failure(abText.$('Sys:Errors_Error'), 
                        result.message);
                this.msgs.hideLoading();
            } else {
                let errorInfo = this.getWebResultErrorInfo(result);
    
                this.msgs.showMessage_Failure(errorInfo.title, errorInfo.message);
                this.msgs.hideLoading();
            }
        });
    }

}

module.exports = DeleteAccount;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\core\$layouts\Administrators_Form.js
jsLibs.exportModule('core', '$layouts/Administrators_Form', (require, module, exports) => { 'use strict';

const
    js0 = require('js0'),
    spocky = require('spocky')
;

class Administrators_Form extends spocky.Layout {

    static get Content() {
        return [["div",{"class":["form form-horizontal"]},["form",{},["spk-form-field",{"form":["Form"],"name":["Name"],"type":["Input"],"input-type":["Text"],"label":["$eText('Sys:Forms_Name_Label')"],"placeholder":["$eText('Sys:Forms_Name_Placeholder')"],"div-class":["row g-0 mt-3"],"label-class":["col-xl-2 col-lg-4 control-label"],"field-class":["col-xl-10 col-lg-8"]}],["div",{"_holder":["userForm"]}]],["$",{"_holder":["user_ManageAccount"]}]]];
    }


    constructor(defaultFieldValues = {})
    {
        js0.args(arguments, [ js0.RawObject, js0.Default ]);

        super(Administrators_Form.Content, defaultFieldValues);
    }

}


module.exports = Administrators_Form;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\core\$layouts\Administrators_Form_Buttons.js
jsLibs.exportModule('core', '$layouts/Administrators_Form_Buttons', (require, module, exports) => { 'use strict';

const
    js0 = require('js0'),
    spocky = require('spocky')
;

class Administrators_Form_Buttons extends spocky.Layout {

    static get Content() {
        return [];
    }


    constructor(defaultFieldValues = {})
    {
        js0.args(arguments, [ js0.RawObject, js0.Default ]);

        super(Administrators_Form_Buttons.Content, defaultFieldValues);
    }

}


module.exports = Administrators_Form_Buttons;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\core\$layouts\Bulls_List_Buttons.js
jsLibs.exportModule('core', '$layouts/Bulls_List_Buttons', (require, module, exports) => { 'use strict';

const
    js0 = require('js0'),
    spocky = require('spocky')
;

class Bulls_List_Buttons extends spocky.Layout {

    static get Content() {
        return [];
    }


    constructor(defaultFieldValues = {})
    {
        js0.args(arguments, [ js0.RawObject, js0.Default ]);

        super(Bulls_List_Buttons.Content, defaultFieldValues);
    }

}


module.exports = Bulls_List_Buttons;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\core\$layouts\About_Basic.js
jsLibs.exportModule('core', '$layouts/About_Basic', (require, module, exports) => { 'use strict';

const
    js0 = require('js0'),
    spocky = require('spocky')
;

class About_Basic extends spocky.Layout {

    static get Content() {
        return [["$",{"_hide":["IsNative"]},["div",{"class":["card my-3"]},["div",{"class":["col-xl-8 text-justify"]},["div",{"class":["card-body system-info"]},["h4",{"class":["mb-3"]},"Skontaktuj się z nami"],["p",{},"W razie jakichkolwiek problemów lub wątpliwości związanych z obsługą programu zapraszamy do kontaktu telefonicznego lub mailowego."],["div",{"class":["row"]},["div",{"class":["col-md mb-2"]},["a",{"href":["tel:570129594"],"class":["btn btn-theme-primary btn-lg w-100"]},["i",{"class":["fa fa-phone pe-2"],"aria-hidden":["true"]}],"570 129 594"]],["div",{"class":["col-md mb-2"]},["a",{"href":["mailto:biuro@milkygen.pl"],"target":["_blank"],"class":["btn btn-theme-primary btn-lg w-100"]},["i",{"class":["fa fa-envelope pe-2"],"aria-hidden":["true"]}],"biuro@milkygen.pl"]]]]]]],["$",{"_show":["IsNative"]},["div",{"class":["card my-3"]},["div",{"class":["card-body"]},["h5",{"class":["mt-2"]},["div",{"class":["form-check form-switch ms-2"]},["input",{"_elem":["OfflineMode"],"class":["form-check-input"],"type":["checkbox"],"role":["switch"],"id":["_html_OfflineMode"]}],["label",{"class":["form-check-label"],"for":["_html_OfflineMode"]},"$eText('Sys:Titles_OfflineMode')"]]]]],["button",{"_elem":["SetPrinter"],"_hide":["PrinterSet"],"class":["btn btn-theme-primary py-3 w-100 mt-2 my-3 mx-2 mobile-button-solo"]},["img",{"src":["${base}","res/images/panels/print.png"]}],["i",{"class":["fa fa-print pe-2"]}],"$eText('Sys:Titles_SetPrinter_Shortcut')"],["button",{"_elem":["RemovePrinter"],"_show":["PrinterSet"],"class":["btn btn-danger py-3 w-100 my-3 mobile-button-solo"]},["img",{"src":["${base}","res/images/panels/print.png"]}],["i",{"class":["fa fa-print pe-2"]}],"$eText('Sys:Titles_RemovePrinter_Shortcut')"],["div",{"class":["card my-3"]},["div",{"class":["card-body"]},["img",{"style":["display: block; max-width: 80%; margin: auto;"],"src":["${base}","res/images/panels/logo_main.png"]}],["p",{"class":["mt-3"]},"W razie jakichkolwiek problemów lub wątpliwości związanych z obsługą aplikacji zapraszamy do kontaktu telefonicznego lub mailowego."],["p",{},["a",{"href":["tel:570129594"],"class":["btn btn-theme-primary w-100"]},["i",{"class":["fa fa-phone pe-2"],"aria-hidden":["true"]}],"570 129 594"]],["p",{},["a",{"href":["mailto:biuro@milkygen.pl"],"class":["btn btn-theme-primary w-100"]},["i",{"class":["fa fa-envelope pe-2"],"aria-hidden":["true"]}],"biuro@milkygen.pl"]],["h5",{"class":["alert system-alert mt-4 mb-2"]},["i",{"class":["fa-solid fa-gear pe-2"]}],"$eText('Sys:Titles_MyApp')"],["div",{"class":["small"]},"$eText('Sys:Titles_UserName')",": ","$UserName"],["div",{"class":["small"]},"$eText('Sys:Titles_AppVersion')",": ","$AppVersion"],["div",{"class":["small"]},"$eText('Sys:Titles_AppId')",": ","$AppId"],["div",{"class":["small"]},"$eText('Sys:Titles_DeviceId')",": ","$DeviceId"],["button",{"_elem":["ReportProblem"],"class":["btn btn-outline-secondary w-100 py-3 mt-3 mb-2"]},"$eText('Sys:Titles_ReportProblem_Shortcut')"],["button",{"_elem":["ClearData"],"class":["btn btn-secondary w-100 py-3 my-2"]},"$eText('Sys:Titles_ClearData_Shortcut')"],["button",{"_elem":["LogOut"],"class":["btn btn-danger w-100 py-3 my-2 mb-2"]},"$eText('Sys:Titles_LogOut_Shortcut')"],["div",{"class":["alert alert-danger text-danger"]},["i",{"class":["fas fa-exclamation-triangle pe-1"]}],"$eText('Sys:Titles_ClearData_Caption')",["p",{"class":["lb-alert-hint"]},"$eText('Sys:Titles_ClearData_Message')"]]]]]];
    }


    constructor(defaultFieldValues = {})
    {
        js0.args(arguments, [ js0.RawObject, js0.Default ]);

        super(About_Basic.Content, defaultFieldValues);
    }

}


module.exports = About_Basic;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\core\$layouts\Bulls_Info.js
jsLibs.exportModule('core', '$layouts/Bulls_Info', (require, module, exports) => { 'use strict';

const
    js0 = require('js0'),
    spocky = require('spocky')
;

class Bulls_Info extends spocky.Layout {

    static get Content() {
        return [["h4",{"class":["alert system-alert"]},["img",{"class":["me-2"],"src":["${base}","res/images/panels/icon-bull.png"]}],"$row.Name"]];
    }


    constructor(defaultFieldValues = {})
    {
        js0.args(arguments, [ js0.RawObject, js0.Default ]);

        super(Bulls_Info.Content, defaultFieldValues);
    }

}


module.exports = Bulls_Info;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\core\$layouts\Associations_List_Buttons.js
jsLibs.exportModule('core', '$layouts/Associations_List_Buttons', (require, module, exports) => { 'use strict';

const
    js0 = require('js0'),
    spocky = require('spocky')
;

class Associations_List_Buttons extends spocky.Layout {

    static get Content() {
        return [["a",{"_elem":["upload"],"href":["#"],"class":["btn btn-theme-primary mobile-button"]},["img",{"src":["${base}","res/images/panels/upload.png"]}],["i",{"class":["fa fa-upload me-2"]}],"$eText('Sys:Buttons_Upload')"],["a",{"_elem":["deleteAll"],"href":["#"],"class":["btn btn-danger mobile-button"]},["img",{"src":["${base}","res/images/panels/delete.png"]}],["i",{"class":["fa fa-times me-2"]}],"$eText('Sys:Buttons_DeleteAll')"]];
    }


    constructor(defaultFieldValues = {})
    {
        js0.args(arguments, [ js0.RawObject, js0.Default ]);

        super(Associations_List_Buttons.Content, defaultFieldValues);
    }

}


module.exports = Associations_List_Buttons;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\core\$layouts\Bulls_Form.js
jsLibs.exportModule('core', '$layouts/Bulls_Form', (require, module, exports) => { 'use strict';

const
    js0 = require('js0'),
    spocky = require('spocky')
;

class Bulls_Form extends spocky.Layout {

    static get Content() {
        return [["div",{"class":["form form-horizontal"]},["form",{},["spk-form-field",{"form":["Form"],"name":["Name"],"type":["Input"],"input-type":["Text"],"label":["$eText('Sys:Forms_Name_Label')"],"placeholder":["$eText('Sys:Forms_Name_Placeholder')"],"div-class":["row g-0 mt-3 system-form-highlight"],"label-class":["col-xl-2 col-lg-4 control-label"],"field-class":["col-xl-10 col-lg-8"]}],["spk-form-field",{"form":["Form"],"name":["Nr"],"type":["Input"],"input-type":["Text"],"label":["$eText('Sys:Forms_IdentificationNr_Label')"],"placeholder":["$eText('Sys:Forms_IdentificationNr_Placeholder')"],"div-class":["row g-0 mt-3"],"label-class":["col-xl-2 col-lg-4 control-label"],"field-class":["col-xl-10 col-lg-8"]}],["spk-form-field",{"form":["Form"],"name":["ManufacturerNr"],"type":["Input"],"input-type":["Text"],"label":["$eText('Sys:Forms_ManufacturerNr_Label')"],"placeholder":["$eText('Sys:Forms_ManufacturerNr_Placeholder')"],"div-class":["row g-0 mt-3"],"label-class":["col-xl-2 col-lg-4 control-label"],"field-class":["col-xl-10 col-lg-8"]}],["spk-form-field",{"form":["Form"],"name":["Race"],"type":["Input"],"input-type":["Text"],"label":["$eText('Sys:Forms_Race_Label')"],"placeholder":["$eText('Sys:Forms_Race_Placeholder')"],"div-class":["row g-0 mt-3"],"label-class":["col-xl-2 col-lg-4 control-label"],"field-class":["col-xl-10 col-lg-8"]}],["$",{"_show":["shows_StrawsCount"]},["spk-form-field",{"form":["Form"],"name":["ClientBull_Note"],"type":["TextArea"],"label":["$eText('Sys:Forms_Note_Label')"],"placeholder":["$eText('Sys:Forms_Note_Placeholder')"],"div-class":["row g-0 mt-3"],"label-class":["col-xl-2 col-lg-4 control-label"],"field-class":["col-xl-10 col-lg-8"]}]],["spk-form-field",{"_hide":["isNew"],"form":["Form"],"name":["_Id"],"type":["Text"],"label":["$eText('Sys:Forms_Id_Label')"],"div-class":["row g-0 mt-3"],"label-class":["col-xl-2 col-lg-4 control-label"],"field-class":["col-xl-10 col-lg-8"]}],["$",{"_hide":["isNew"]},["div",{"_show":["eSys.user.isAdministrator"],"class":["small mt-4 alert system-alert"]},["spk-form-field",{"form":["Form"],"name":["Added_Date_Formatted"],"type":["Text"],"label":["$eText('Sys:Forms_Added_Date_Label')"],"div-class":["text-desaturated row mb-2"],"label-class":["col-4 control-label"],"field-class":["col-8 "]}],["spk-form-field",{"form":["Form"],"name":["Added_Identificator"],"type":["Text"],"label":["$eText('Sys:Forms_Added_Identificator_Label')"],"div-class":["text-desaturated row"],"label-class":["col-4 control-label"],"field-class":["col-8 "]}]]]]]];
    }


    constructor(defaultFieldValues = {})
    {
        js0.args(arguments, [ js0.RawObject, js0.Default ]);

        super(Bulls_Form.Content, defaultFieldValues);
    }

}


module.exports = Bulls_Form;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\core\$layouts\Clinics_Form.js
jsLibs.exportModule('core', '$layouts/Clinics_Form', (require, module, exports) => { 'use strict';

const
    js0 = require('js0'),
    spocky = require('spocky')
;

class Clinics_Form extends spocky.Layout {

    static get Content() {
        return [["div",{"class":["form form-horizontal"]},["form",{},["div",{"_holder":["clientForm"]}],["div",{"_holder":["userForm"]}]],["$",{"_holder":["user_ManageAccount"]}]]];
    }


    constructor(defaultFieldValues = {})
    {
        js0.args(arguments, [ js0.RawObject, js0.Default ]);

        super(Clinics_Form.Content, defaultFieldValues);
    }

}


module.exports = Clinics_Form;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\core\$layouts\Backups_Basic.js
jsLibs.exportModule('core', '$layouts/Backups_Basic', (require, module, exports) => { 'use strict';

const
    js0 = require('js0'),
    spocky = require('spocky')
;

class Backups_Basic extends spocky.Layout {

    static get Content() {
        return [["div",{"class":["lb-main-header"]},["div",{"class":["row g-0"]},["div",{"class":["col-sm-6 d-none d-md-block"]},["div",{"class":["row g-0"]},["div",{"class":["col-auto"]},["a",{"_elem":["back"],"href":["$uris.back"],"class":["btn btn-theme-light mr-2"]},["i",{"class":["fa fa-chevron-left"]}]]],["div",{"class":["col"]},["h1",{},"$eText('Sys:Titles_BackupFiles')"]]]],["div",{"class":["col-xl-6 col-lg-12 lb-buttons-panel "]},["div",{"class":["btn-group w-100"]},["button",{"_elem":["downloadLast"],"class":["btn btn-theme-accent"]},["i",{"class":["fa fa-download"]}," "],"$eText('Sys:Buttons_DownloadLastBackup')"]]]]],["div",{"class":["card px-2 py-4"]},["div",{"_repeat":["files:file"],"class":["col-lg-6"]},["a",{"href":["$file.url"],"class":["alert alert-info w-100 d-block"]},"$file.name"]]]];
    }


    constructor(defaultFieldValues = {})
    {
        js0.args(arguments, [ js0.RawObject, js0.Default ]);

        super(Backups_Basic.Content, defaultFieldValues);
    }

}


module.exports = Backups_Basic;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\core\$layouts\Clinics_Form_Buttons.js
jsLibs.exportModule('core', '$layouts/Clinics_Form_Buttons', (require, module, exports) => { 'use strict';

const
    js0 = require('js0'),
    spocky = require('spocky')
;

class Clinics_Form_Buttons extends spocky.Layout {

    static get Content() {
        return [["a",{"_elem":["bulls"],"href":["$hrefs.bulls"],"class":["btn btn-theme-primary mobile-button"]},["i",{"class":["far fa-file me-2"]}],"$eText('Sys:Buttons_Bulls')"]];
    }


    constructor(defaultFieldValues = {})
    {
        js0.args(arguments, [ js0.RawObject, js0.Default ]);

        super(Clinics_Form_Buttons.Content, defaultFieldValues);
    }

}


module.exports = Clinics_Form_Buttons;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\core\$layouts\Clients_Form.js
jsLibs.exportModule('core', '$layouts/Clients_Form', (require, module, exports) => { 'use strict';

const
    js0 = require('js0'),
    spocky = require('spocky')
;

class Clients_Form extends spocky.Layout {

    static get Content() {
        return [["spk-form-field",{"form":["Form"],"name":["Name"],"type":["Input"],"input-type":["Text"],"label":["$eText('Sys:Forms_Name_Label')"],"placeholder":["$eText('Sys:Forms_Name_Placeholder')"],"div-class":["row g-0 mt-3 system-form-highlight"],"label-class":["col-xl-2 col-lg-4 control-label"],"field-class":["col-xl-10 col-lg-8"]}],["div",{"_show":["isUser"],"_holder":["userForm"]}],["spk-form-field",{"form":["Form"],"name":["Address"],"type":["Input"],"input-type":["Text"],"label":["$eText('Sys:Forms_Address_Label')"],"placeholder":["$eText('Sys:Forms_Address_Placeholder')"],"div-class":["row g-0 mt-3"],"label-class":["col-xl-2 col-lg-4 control-label"],"field-class":["col-xl-10 col-lg-8"]}],["spk-form-field",{"form":["Form"],"name":["City"],"type":["Input"],"input-type":["Text"],"label":["$eText('Sys:Forms_City_Label')"],"placeholder":["$eText('Sys:Forms_City_Placeholder')"],"div-class":["row g-0 mt-3"],"label-class":["col-xl-2 col-lg-4 control-label"],"field-class":["col-xl-10 col-lg-8"]}],["spk-form-field",{"form":["Form"],"name":["Phone"],"type":["Input"],"input-type":["Text"],"label":["$eText('Sys:Forms_Phone_Label')"],"placeholder":["$eText('Sys:Forms_Phone_Placeholder')"],"div-class":["row g-0 mt-3"],"label-class":["col-xl-2 col-lg-4 control-label"],"field-class":["col-xl-10 col-lg-8"]}],["div",{"class":["mt-4"]},["spk-form-field",{"_show":["showUnderGrade"],"form":["Form"],"name":["UnderGrade"],"type":["Checkbox"],"label":["$eText('Sys:Forms_UnderGrade_Label')"]}]],["div",{"_show":["isUser"]},["spk-form-field",{"_show":["isUnderGrade"],"form":["Form"],"name":["SymlekId"],"type":["Input"],"input-type":["text"],"label":["$eText('Sys:Forms_SymlekId_Label')"],"placeholder":["$eText('Sys:Forms_SymlekId_Placeholder')"],"div-class":["row g-0 mt-3"],"label-class":["col-xl-2 col-lg-4 control-label"],"field-class":["col-xl-10 col-lg-8"]}]]];
    }


    constructor(defaultFieldValues = {})
    {
        js0.args(arguments, [ js0.RawObject, js0.Default ]);

        super(Clients_Form.Content, defaultFieldValues);
    }

}


module.exports = Clients_Form;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\core\$layouts\Buttons_Delete.js
jsLibs.exportModule('core', '$layouts/Buttons_Delete', (require, module, exports) => { 'use strict';

const
    js0 = require('js0'),
    spocky = require('spocky')
;

class Buttons_Delete extends spocky.Layout {

    static get Content() {
        return [["a",{"_elem":["delete"],"href":["#"],"class":["btn btn-danger mobile-button"]},["i",{"class":["fas fa-times me-2"]}],["img",{"src":["${base}","res/images/panels/delete.png"]}],"$eText('Sys:Buttons_Delete')"]];
    }


    constructor(defaultFieldValues = {})
    {
        js0.args(arguments, [ js0.RawObject, js0.Default ]);

        super(Buttons_Delete.Content, defaultFieldValues);
    }

}


module.exports = Buttons_Delete;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\core\$layouts\Clinics_Info.js
jsLibs.exportModule('core', '$layouts/Clinics_Info', (require, module, exports) => { 'use strict';

const
    js0 = require('js0'),
    spocky = require('spocky')
;

class Clinics_Info extends spocky.Layout {

    static get Content() {
        return [["div",{"class":["system-hint"]},["h4",{"class":["mt-0"]},["i",{"class":["fa-solid fa-house-medical pe-2"]}],"$eText('Sys:Text_Clinic')",": ","$row.Client_Name"]]];
    }


    constructor(defaultFieldValues = {})
    {
        js0.args(arguments, [ js0.RawObject, js0.Default ]);

        super(Clinics_Info.Content, defaultFieldValues);
    }

}


module.exports = Clinics_Info;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\core\$layouts\Cows_List_Buttons.js
jsLibs.exportModule('core', '$layouts/Cows_List_Buttons', (require, module, exports) => { 'use strict';

const
    js0 = require('js0'),
    spocky = require('spocky')
;

class Cows_List_Buttons extends spocky.Layout {

    static get Content() {
        return [];
    }


    constructor(defaultFieldValues = {})
    {
        js0.args(arguments, [ js0.RawObject, js0.Default ]);

        super(Cows_List_Buttons.Content, defaultFieldValues);
    }

}


module.exports = Cows_List_Buttons;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\core\$layouts\Clinics_List_Buttons.js
jsLibs.exportModule('core', '$layouts/Clinics_List_Buttons', (require, module, exports) => { 'use strict';

const
    js0 = require('js0'),
    spocky = require('spocky')
;

class Clinics_List_Buttons extends spocky.Layout {

    static get Content() {
        return [];
    }


    constructor(defaultFieldValues = {})
    {
        js0.args(arguments, [ js0.RawObject, js0.Default ]);

        super(Clinics_List_Buttons.Content, defaultFieldValues);
    }

}


module.exports = Clinics_List_Buttons;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\core\$layouts\Cows_Form.js
jsLibs.exportModule('core', '$layouts/Cows_Form', (require, module, exports) => { 'use strict';

const
    js0 = require('js0'),
    spocky = require('spocky')
;

class Cows_Form extends spocky.Layout {

    static get Content() {
        return [["div",{"class":["form form-horizontal"]},["form",{},["spk-form-field",{"form":["Form"],"name":["Nr"],"type":["Input"],"input-type":["Text"],"label":["$eText('Sys:Forms_IdentificationNr_Label')"],"placeholder":["$eText('Sys:Forms_IdentificationNr_Placeholder')"],"div-class":["row g-0 mt-3 system-form-highlight"],"label-class":["col-xl-2 col-lg-4 control-label"],"field-class":["col-xl-10 col-lg-8"]}],["spk-form-field",{"form":["Form"],"name":["Name"],"type":["Input"],"input-type":["Text"],"label":["$eText('Sys:Forms_Name_Label')"],"placeholder":["$eText('Sys:Forms_Name_Placeholder')"],"div-class":["row g-0 mt-3"],"label-class":["col-xl-2 col-lg-4 control-label"],"field-class":["col-xl-10 col-lg-8"]}],["spk-form-field",{"form":["Form"],"name":["CowshedNr"],"type":["Input"],"input-type":["Text"],"label":["$eText('Sys:Forms_CowshedNr_Label')"],"placeholder":["$eText('Sys:Forms_CowshedNr_Placeholder')"],"div-class":["row g-0 mt-3"],"label-class":["col-xl-2 col-lg-4 control-label"],"field-class":["col-xl-10 col-lg-8"]}],["spk-form-field",{"form":["Form"],"name":["Race"],"type":["Input"],"input-type":["Text"],"label":["$eText('Sys:Forms_Race_Label')"],"placeholder":["$eText('Sys:Forms_Race_Placeholder')"],"div-class":["row g-0 mt-3"],"label-class":["col-xl-2 col-lg-4 control-label"],"field-class":["col-xl-10 col-lg-8"]}],["spk-form-field",{"form":["Form"],"name":["LastCalving"],"type":["Date"],"label":["$eText('Sys:Forms_LastCalving_Label')"],"placeholder":["$eText('Sys:Forms_Date_Placeholder')"],"div-class":["row g-0 mt-3"],"label-class":["col-xl-2 col-lg-4 control-label"],"field-class":["col-xl-10 col-lg-8"]}],["spk-form-field",{"form":["Form"],"name":["Birth"],"type":["Date"],"label":["$eText('Sys:Forms_Birth_Label')"],"placeholder":["$eText('Sys:Forms_Date_Placeholder')"],"div-class":["row g-0 mt-3"],"label-class":["col-xl-2 col-lg-4 control-label"],"field-class":["col-xl-10 col-lg-8"]}],["spk-form-field",{"form":["Form"],"name":["Note"],"type":["TextArea"],"label":["$eText('Sys:Forms_Note_Label')"],"placeholder":["$eText('Sys:Forms_Note_Placeholder')"],"div-class":["row g-0 mt-3"],"label-class":["col-xl-2 col-lg-4 control-label"],"field-class":["col-xl-10 col-lg-8"]}],["$",{"_hide":["isNew"]},["div",{"_show":["eSys.user.isAdministrator"],"class":["small alert system-alert mt-3"]},["spk-form-field",{"_hide":["isNew"],"form":["Form"],"name":["_Id"],"type":["Text"],"label":["$eText('Sys:Forms_Id_Label')"],"div-class":["text-desaturated row mb-2"],"label-class":["col-4 control-label"],"field-class":["col-8"]}],["spk-form-field",{"form":["Form"],"name":["Added_Date_Formatted"],"type":["Text"],"label":["$eText('Sys:Forms_Added_Date_Label')"],"div-class":["text-desaturated row mb-2"],"label-class":["col-4 control-label"],"field-class":["col-8"]}],["spk-form-field",{"form":["Form"],"name":["Added_Identificator"],"type":["Text"],"label":["$eText('Sys:Forms_Added_Identificator_Label')"],"div-class":["text-desaturated row"],"label-class":["col-4 control-label"],"field-class":["col-8"]}]]]]],["div",{"_show":["shows.cowHistory"]},["h5",{"class":["system-header mt-4 mb-3"]},["i",{"class":["fa-solid fa-list me-2"],"aria-hidden":["true"]}],"$eText('Sys:Titles_CowHistory')"],["div",{"_holder":["cowHistory"]}]]];
    }


    constructor(defaultFieldValues = {})
    {
        js0.args(arguments, [ js0.RawObject, js0.Default ]);

        super(Cows_Form.Content, defaultFieldValues);
    }

}


module.exports = Cows_Form;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\core\$layouts\DeleteAccount.js
jsLibs.exportModule('core', '$layouts/DeleteAccount', (require, module, exports) => { 'use strict';

const
    js0 = require('js0'),
    spocky = require('spocky')
;

class DeleteAccount extends spocky.Layout {

    static get Content() {
        return [["div",{"class":["container-fluid"]},["div",{"class":["card my-3"]},["div",{"class":["col-xl-8 text-justify"]},["div",{"class":["card-body system-info"]},["h4",{"class":["my-3"]},["i",{"class":["fa fa-user pe-2"]}],"e-MilkyGen - Usuwanie Konta"],["p",{},"W razie jakichkolwiek problemów lub wątpliwości związanych z obsługą programu zapraszamy do kontaktu. Prośbę o usunięcie konta w Systemie e-MilkyGen możecie Państwo zgłosić telefonicznie, mailowo lub czy pomocy poniższego formularza."],["div",{"class":["row"]},["div",{"class":["col-md  mb-2"]},["a",{"href":["tel:570129594"],"class":["btn btn-theme-primary btn-lg w-100"]},["i",{"class":["fa fa-phone pe-2"],"aria-hidden":["true"]}],"570 129 594"]],["div",{"class":["col-md  mb-2"]},["a",{"href":["mailto:biuro@milkygen.pl"],"class":["btn btn-theme-primary btn-lg w-100"]},["i",{"class":["fa fa-envelope pe-2"],"aria-hidden":["true"]}],"biuro@milkygen.pl"]]],["hr",{"class":["my-4"]}],["spk-form-field",{"form":["Form"],"name":["Name"],"type":["Input"],"input-type":["text"],"label":["$eText('Sys:Forms_Name_Label')"],"placeholder":["$eText('Sys:Forms_Name_Placeholder')"],"div-class":["mt-3"],"label-class":["col control-label"],"field-class":["col "]}],["spk-form-field",{"form":["Form"],"name":["Email"],"type":["Input"],"input-type":["text"],"label":["$eText('Sys:Forms_Email_Label')"],"placeholder":["$eText('Sys:Forms_Email_Placeholder')"],"div-class":["mt-3"],"label-class":["col control-label"],"field-class":["col "]}],["spk-form-field",{"form":["Form"],"name":["Reason"],"type":["TextArea"],"label":["$eText('Sys:Forms_ReasonForDeletingAccount_Label')"],"placeholder":["$eText('Sys:Forms_ReasonForDeletingAccount_Placeholder')"],"div-class":["mt-3"],"label-class":["col control-label"],"field-class":["col "]}],["button",{"_elem":["SendDeleteAccountRequest"],"class":["btn btn-theme-secondary btn-lg w-100 mt-3"]},"$eText('Sys:Buttons_Send')"]]]]]];
    }


    constructor(defaultFieldValues = {})
    {
        js0.args(arguments, [ js0.RawObject, js0.Default ]);

        super(DeleteAccount.Content, defaultFieldValues);
    }

}


module.exports = DeleteAccount;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\core\$layouts\Farmers_Form_Buttons.js
jsLibs.exportModule('core', '$layouts/Farmers_Form_Buttons', (require, module, exports) => { 'use strict';

const
    js0 = require('js0'),
    spocky = require('spocky')
;

class Farmers_Form_Buttons extends spocky.Layout {

    static get Content() {
        return [["a",{"_elem":["bulls"],"_show":["shows.bulls"],"href":["$hrefs.bulls"],"class":["btn btn-theme-primary mobile-button"]},["img",{"src":["${base}","res/images/panels/bulls.png"]}],["i",{"class":["fa-solid fa-mars me-2"]}],"$eText('Sys:Buttons_Bulls')"],["a",{"_elem":["cows"],"href":["$hrefs.cows"],"class":["btn btn-theme-primary mobile-button"]},["img",{"src":["${base}","res/images/panels/cows.png"]}],["i",{"class":["fa-solid fa-cow me-2"]}],"$eText('Sys:Buttons_Cows')"]];
    }


    constructor(defaultFieldValues = {})
    {
        js0.args(arguments, [ js0.RawObject, js0.Default ]);

        super(Farmers_Form_Buttons.Content, defaultFieldValues);
    }

}


module.exports = Farmers_Form_Buttons;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\core\$layouts\Cows_Info.js
jsLibs.exportModule('core', '$layouts/Cows_Info', (require, module, exports) => { 'use strict';

const
    js0 = require('js0'),
    spocky = require('spocky')
;

class Cows_Info extends spocky.Layout {

    static get Content() {
        return [["h4",{"class":["alert system-alert"]},["img",{"class":["me-2"],"src":["${base}","res/images/panels/icon-cow.png"]}],"$row.Nr"]];
    }


    constructor(defaultFieldValues = {})
    {
        js0.args(arguments, [ js0.RawObject, js0.Default ]);

        super(Cows_Info.Content, defaultFieldValues);
    }

}


module.exports = Cows_Info;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\core\$layouts\Farmers_Form.js
jsLibs.exportModule('core', '$layouts/Farmers_Form', (require, module, exports) => { 'use strict';

const
    js0 = require('js0'),
    spocky = require('spocky')
;

class Farmers_Form extends spocky.Layout {

    static get Content() {
        return [["div",{"class":["form form-horizontal"]},["form",{},["spk-form-field",{"_show":["shows.Clinic__Id"],"form":["Form"],"name":["Clinic__Id"],"type":["Select"],"label":["$eText('Sys:Forms_Clinic_Label')"],"class":[""],"div-class":["row g-0 mt-3"],"label-class":["col-xl-2 col-lg-4 control-label"],"field-class":["col-xl-10 col-lg-8"]}],["spk-form-field",{"_show":["shows.Inseminator__Id"],"form":["Form"],"name":["Inseminator__Id"],"type":["Select"],"label":["$eText('Sys:Forms_Inseminator_Label')"],"div-class":["row g-0 mt-3"],"label-class":["col-xl-2 col-lg-4 control-label"],"field-class":["col-xl-10 col-lg-8"]}],["div",{"_holder":["clientForm"]}],["div",{"_show":["isUnderGrade"]},["spk-form-field",{"form":["Form"],"name":["HerdUnderGradeNr"],"type":["Input"],"input-type":["text"],"label":["$eText('Sys:Forms_HerdUnderGradeNr_Label')"],"placeholder":["$eText('Sys:Forms_Number_Placeholder')"],"div-class":["row g-0 mt-3"],"label-class":["col-xl-2 col-lg-4 control-label"],"field-class":["col-xl-10 col-lg-8"]}]],["spk-form-field",{"form":["Form"],"name":["HerdNr"],"type":["Input"],"input-type":["text"],"label":["$eText('Sys:Forms_HerdNr_Label')"],"placeholder":["$eText('Sys:Forms_Number_Placeholder')"],"div-class":["row g-0 mt-3"],"label-class":["col-xl-2 col-lg-4 control-label"],"field-class":["col-xl-10 col-lg-8"]}],["spk-form-field",{"form":["Form"],"name":["HasNotificationsEmail"],"type":["Checkbox"],"label":["$eText('Sys:Forms_NotificationsEmail_Label')"],"div-class":["mt-3"],"label-class":["col control-label"],"field-class":["checkboxField"]}],["spk-form-field",{"_show":["shows.NotificationsEmail"],"form":["Form"],"name":["NotificationsEmail"],"type":["Input"],"input-type":["text"],"label":["''"],"placeholder":["$eText('Sys:Forms_NotificationsEmail_Placeholder')"],"div-class":["row g-0 mt-3"],"label-class":["col-xl-2 col-lg-4 control-label"],"field-class":["col-xl-10 col-lg-8"]}],["spk-form-field",{"_hide":["isNew"],"form":["Form"],"name":["_Id"],"type":["Text"],"label":["$eText('Sys:Forms_Id_Label')"],"div-class":["row g-0 mt-3"],"label-class":["col-xl-2 col-lg-4 control-label"],"field-class":["col-xl-10 col-lg-8"]}]],["$",{"_hide":["isNew"]},["div",{"_show":["eSys.user.isAdministrator"],"class":["small mt-4 alert system-alert"]},["spk-form-field",{"_show":["isUser"],"form":["Form"],"name":["User_LastActivity_Formatted"],"type":["Text"],"label":["$eText('Sys:Forms_LastActivity_Label')"],"div-class":["text-desaturated row mb-2"],"label-class":["col-4 control-label"],"field-class":["col-8"]}],["spk-form-field",{"form":["Form"],"name":["Client_Added_Date_Formatted"],"type":["Text"],"label":["$eText('Sys:Forms_Added_Date_Label')"],"div-class":["text-desaturated row mb-2"],"label-class":["col-4 control-label"],"field-class":["col-8"]}],["spk-form-field",{"form":["Form"],"name":["Client_Added_Identificator"],"type":["Text"],"label":["$eText('Sys:Forms_Added_Identificator_Label')"],"div-class":["text-desaturated row"],"label-class":["col-4 control-label"],"field-class":["col-8"]}]]],["$",{"_holder":["user_ManageAccount"]}]]];
    }


    constructor(defaultFieldValues = {})
    {
        js0.args(arguments, [ js0.RawObject, js0.Default ]);

        super(Farmers_Form.Content, defaultFieldValues);
    }

}


module.exports = Farmers_Form;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\core\$layouts\Farmers_Info.js
jsLibs.exportModule('core', '$layouts/Farmers_Info', (require, module, exports) => { 'use strict';

const
    js0 = require('js0'),
    spocky = require('spocky')
;

class Farmers_Info extends spocky.Layout {

    static get Content() {
        return [["div",{"class":["system-hint mb-2"]},["h4",{"class":["mt-0"]},["i",{"class":["fa fa-user pe-2"]}],"$row.Client_Name"]]];
    }


    constructor(defaultFieldValues = {})
    {
        js0.args(arguments, [ js0.RawObject, js0.Default ]);

        super(Farmers_Info.Content, defaultFieldValues);
    }

}


module.exports = Farmers_Info;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\core\$layouts\Form.js
jsLibs.exportModule('core', '$layouts/Form', (require, module, exports) => { 'use strict';

const
    js0 = require('js0'),
    spocky = require('spocky')
;

class Form extends spocky.Layout {

    static get Content() {
        return [["div",{"class":["lb-main-header"]},["div",{"class":["d-md-none lb-title-sm"]},"$texts.title"],["div",{"class":["row g-0"]},["div",{"class":["col-lg-6 d-none d-md-block"]},["div",{"class":["row"]},["div",{"class":["col-auto lb-back"]},["a",{"_elem":["back"],"href":["$uris.back"],"class":["btn btn-theme-primary mr-2"]},["i",{"class":["fa fa-arrow-left"]}]]],["div",{"class":["col lb-title"]},["h1",{},"$texts.title"]]]],["div",{"class":["col-xl-6 col-lg-12 lb-buttons-panel "]},["div",{"class":["btn-group w-100"]},["a",{"_elem":["submit"],"_show":["shows.submit"],"href":["#"],"class":["btn btn-theme-primary mobile-button"]},["img",{"src":["${base}","res/images/panels/save.png"]}],["i",{"class":["fa-solid fa-check me-2"]}],"$texts.Buttons_Submit"],["$",{"_holder":["Buttons_Before"]}],["a",{"_elem":["delete"],"_show":["shows.delete"],"href":[""],"class":["btn btn-danger mobile-button"]},["img",{"src":["${base}","res/images/panels/delete.png"]}],["i",{"class":["fa fa-times me-2"]}],"$eText('Sys:Buttons_Delete')"],["$",{"_holder":["Buttons_After"]}]]]]],["div",{"class":["card my-3"]},["div",{"class":["card-body"]},["div",{"class":[""]},["$",{"_show":["shows_Infos_Clinic"],"_holder":["infos_Clinic"]}],["$",{"_show":["shows_Infos_Inseminator"],"_holder":["infos_Inseminator"]}],["$",{"_show":["shows_Infos_Farmer"],"_holder":["infos_Farmer"]}],["$",{"_show":["shows_Infos_Cow"],"_holder":["infos_Cow"]}],["$",{"_show":["shows_Infos_Bull"],"_holder":["infos_Bull"]}]],["$",{"_holder":["content"]}],["a",{"_elem":["submit2"],"_show":["shows.submit"],"href":["#"],"class":["btn btn-theme-primary mobile-button w-100 my-4"]},["img",{"src":["${base}","res/images/panels/save.png"]}],["i",{"class":["fa-solid fa-check me-2"]}],"$texts.Buttons_Submit"]]]];
    }


    constructor(defaultFieldValues = {})
    {
        js0.args(arguments, [ js0.RawObject, js0.Default ]);

        super(Form.Content, defaultFieldValues);
    }

}


module.exports = Form;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\core\$layouts\Farmers_List_Buttons.js
jsLibs.exportModule('core', '$layouts/Farmers_List_Buttons', (require, module, exports) => { 'use strict';

const
    js0 = require('js0'),
    spocky = require('spocky')
;

class Farmers_List_Buttons extends spocky.Layout {

    static get Content() {
        return [];
    }


    constructor(defaultFieldValues = {})
    {
        js0.args(arguments, [ js0.RawObject, js0.Default ]);

        super(Farmers_List_Buttons.Content, defaultFieldValues);
    }

}


module.exports = Farmers_List_Buttons;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\core\$layouts\Inseminators_List_Buttons.js
jsLibs.exportModule('core', '$layouts/Inseminators_List_Buttons', (require, module, exports) => { 'use strict';

const
    js0 = require('js0'),
    spocky = require('spocky')
;

class Inseminators_List_Buttons extends spocky.Layout {

    static get Content() {
        return [];
    }


    constructor(defaultFieldValues = {})
    {
        js0.args(arguments, [ js0.RawObject, js0.Default ]);

        super(Inseminators_List_Buttons.Content, defaultFieldValues);
    }

}


module.exports = Inseminators_List_Buttons;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\core\$layouts\Inseminators_Form.js
jsLibs.exportModule('core', '$layouts/Inseminators_Form', (require, module, exports) => { 'use strict';

const
    js0 = require('js0'),
    spocky = require('spocky')
;

class Inseminators_Form extends spocky.Layout {

    static get Content() {
        return [["div",{"class":["form form-horizontal"]},["form",{},["$",{"_show":["shows.Clinic__Id"]},["spk-form-field",{"form":["Form"],"name":["Clinic__Id"],"type":["Select"],"label":["$eText('Sys:Forms_Clinic_Label')"],"div-class":["row g-0 mt-3"],"label-class":["col-xl-2 col-lg-4 control-label"],"field-class":["col-xl-10 col-lg-8 "]}]],["div",{"_holder":["clientForm"]}],["spk-form-field",{"_hide":["isNew"],"form":["Form"],"name":["_Id"],"type":["Text"],"label":["$eText('Sys:Forms_Id_Label')"],"div-class":["row g-0 mt-3"],"label-class":["col-xl-2 col-lg-4 control-label"],"field-class":["col-xl-10 col-lg-8"]}]],["$",{"_hide":["isNew"]},["div",{"_show":["eSys.user.isAdministrator"],"class":["small mt-4 alert system-alert"]},["spk-form-field",{"form":["Form"],"name":["User_LastActivity_Formatted"],"type":["Text"],"label":["$eText('Sys:Forms_LastActivity_Label')"],"div-class":["text-desaturated row mb-2"],"label-class":["col-4 control-label"],"field-class":["col-8"]}],["spk-form-field",{"form":["Form"],"name":["Client_Added_Date_Formatted"],"type":["Text"],"label":["$eText('Sys:Forms_Added_Date_Label')"],"div-class":["text-desaturated row mb-2"],"label-class":["col-4 control-label"],"field-class":["col-8"]}],["spk-form-field",{"form":["Form"],"name":["Client_Added_Identificator"],"type":["Text"],"label":["$eText('Sys:Forms_Added_Identificator_Label')"],"div-class":["text-desaturated row"],"label-class":["col-4 control-label"],"field-class":["col-8"]}]]],["$",{"_holder":["user_ManageAccount"]}]]];
    }


    constructor(defaultFieldValues = {})
    {
        js0.args(arguments, [ js0.RawObject, js0.Default ]);

        super(Inseminators_Form.Content, defaultFieldValues);
    }

}


module.exports = Inseminators_Form;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\core\$layouts\Inseminators_Info.js
jsLibs.exportModule('core', '$layouts/Inseminators_Info', (require, module, exports) => { 'use strict';

const
    js0 = require('js0'),
    spocky = require('spocky')
;

class Inseminators_Info extends spocky.Layout {

    static get Content() {
        return [["div",{"class":["system-hint"]},["h4",{"class":["mt-0"]},["i",{"class":["fa fa-user-tie pe-2"]}],"$eText('Sys:Text_Inseminator')",": ","$row.Client_Name"]]];
    }


    constructor(defaultFieldValues = {})
    {
        js0.args(arguments, [ js0.RawObject, js0.Default ]);

        super(Inseminators_Info.Content, defaultFieldValues);
    }

}


module.exports = Inseminators_Info;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\core\$layouts\Inseminators_Form_Buttons.js
jsLibs.exportModule('core', '$layouts/Inseminators_Form_Buttons', (require, module, exports) => { 'use strict';

const
    js0 = require('js0'),
    spocky = require('spocky')
;

class Inseminators_Form_Buttons extends spocky.Layout {

    static get Content() {
        return [["a",{"_elem":["bulls"],"_show":["shows.bulls"],"href":["$hrefs.bulls"],"class":["btn btn-theme-primary mobile-button"]},["img",{"src":["${base}","res/images/panels/bulls.png"]}],["i",{"class":["far fa-file me-2"]}],"$eText('Sys:Buttons_Bulls')"]];
    }


    constructor(defaultFieldValues = {})
    {
        js0.args(arguments, [ js0.RawObject, js0.Default ]);

        super(Inseminators_Form_Buttons.Content, defaultFieldValues);
    }

}


module.exports = Inseminators_Form_Buttons;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\core\$layouts\LemonBee_Main.js
jsLibs.exportModule('core', '$layouts/LemonBee_Main', (require, module, exports) => { 'use strict';

const
    js0 = require('js0'),
    spocky = require('spocky')
;

class LemonBee_Main extends spocky.Layout {

    static get Content() {
        return [["div",{"class":["lb-menu-tiles row"]},["div",{"_repeat":["panels:panel"],"_show":["panel.shortcut"],"class":["col-xl-3 col-xl-4 col-sm-6 ","$class"]},["div",{"class":["card"]},["a",{"_elem":["Buttons_Panel"],"class":["btn btn-theme-primary lb-tile-main w-100 rounded-0"],"href":["${lb.uris.base}","${panel.alias}","/"]},["$",{"_show":["panel.image"]},["img",{"src":["$panel.image"],"alt":["$panel.title"]}]],["div",{"class":[""]},"$panel.title"]],["div",{"class":["card-body"]},["div",{"class":["row g-2"]},["div",{"_repeat":["panel.subpanels:subpanel"],"_show":["subpanel.shortcut"],"class":["col"]},["a",{"_elem":["Buttons_Subpanel"],"href":["$subpanel.uri"],"class":["btn btn-theme-light w-100"]},["i",{"class":["fa ","$subpanel.faIcon"," pe-2"]}],"$subpanel.title"]]]]]]]];
    }


    constructor(defaultFieldValues = {})
    {
        js0.args(arguments, [ js0.RawObject, js0.Default ]);

        super(LemonBee_Main.Content, defaultFieldValues);
    }

}


module.exports = LemonBee_Main;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\core\$layouts\LemonBee_Body.js
jsLibs.exportModule('core', '$layouts/LemonBee_Body', (require, module, exports) => { 'use strict';

const
    js0 = require('js0'),
    spocky = require('spocky')
;

class LemonBee_Body extends spocky.Layout {

    static get Content() {
        return [["div",{"class":["min-vh-100 ","$panelClass"," "]},["div",{"class":["lb-menu-holder-custom ","$MenuCollapsed_MenuClass"]},["$",{"_holder":["topMenu"]}]],["div",{"class":["lb-content-holder-custom ","$MenuCollapsed_ContentClass"]},["div",{"class":["lb-top-bar"]},["$",{"_holder":["userInfo"]}]],["div",{"class":["lb-main-holder"]},["$",{"_holder":["content"]}],["div",{"class":["back-to-top"]},["a",{"_elem":["backToTop"],"class":["spScrollToTop btn btn-theme-light"],"href":[""]},["i",{"class":["fa fa-chevron-up"]}]]]]]]];
    }


    constructor(defaultFieldValues = {})
    {
        js0.args(arguments, [ js0.RawObject, js0.Default ]);

        super(LemonBee_Body.Content, defaultFieldValues);
    }

}


module.exports = LemonBee_Body;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\core\$layouts\Messages.js
jsLibs.exportModule('core', '$layouts/Messages', (require, module, exports) => { 'use strict';

const
    js0 = require('js0'),
    spocky = require('spocky')
;

class Messages extends spocky.Layout {

    static get Content() {
        return [["div",{"_elem":["Message"],"class":["modal fade"],"tabindex":["-1"]},["div",{"class":["modal-dialog modal-choice modal-dialog-scrollable"]},["div",{"class":["modal-content"]},["div",{"class":["modal-header"]},["img",{"_show":["Message.Image"],"class":["modal-image"],"src":["$Message.Image"]}],["h5",{"_show":["Message.Title"],"class":["modal-title"]},"$Message.Title"],["button",{"_elem":["Message_Close"],"type":["button"],"class":["btn-close"],"aria-label":["Close"]}]],["div",{"_show":["Message.Text"],"class":["modal-body"]},["p",{},"$Message.Text"]],["div",{"class":["modal-footer"]},["div",{"class":["row"]},["div",{"_show":["Message.ExtraButton_Text"],"class":["col"]},["button",{"_elem":["Message_ExtraButton"],"type":["button"],"class":["btn ","$Message.ExtraButton_Class"," w-100 lh-sm"]},"$Message.ExtraButton_Text"]],["div",{"class":["col text-end"]},["button",{"_elem":["Message_Confirm"],"type":["button"],"class":["btn btn-primary w-100 h-100 "]},"$Text('Close')"]]]]]]],["div",{"_show":["Loading.Show"],"class":["loader-holder"]},["h3",{}],["div",{"class":["d-flex align-items-center"]},["div",{"class":["spinner-border me-3 text-primary"],"role":["status"],"aria-hidden":["true"]}],["strong",{},"$Loading.Text"]]],["div",{"_elem":["Confirmation"],"class":["modal fade"],"tabindex":["-1"]},["div",{"class":["modal-dialog modal-choice"]},["div",{"class":["modal-content"]},["div",{"class":["modal-header"]},["h5",{"_show":["Confirmation.Title"],"class":["modal-title"]},"$Confirmation.Title"],["button",{"_elem":["Confirmation_Close"],"type":["button"],"class":["btn-close"],"aria-label":["Close"]}]],["div",{"_show":["Confirmation.Text"],"class":["modal-body"]},["p",{},"$Confirmation.Text"]],["div",{"class":["modal-footer"]},["div",{"class":["row"]},["div",{"class":["col"]},["button",{"_elem":["Confirmation_Yes"],"type":["button"],"class":["btn btn-primary w-100"]},["i",{"class":["fa fa-check pe-2"]}],"$Confirmation.Yes"]],["div",{"class":["col"]},["button",{"_elem":["Confirmation_No"],"type":["button"],"class":["btn btn-secondary w-100"]},["i",{"class":["fa fa-times pe-2"]}],"$Confirmation.No"]]]]]]],["div",{"_elem":["Notification"],"class":["notification-holder"],"style":["display: none;"]},["div",{"class":["notification-bg bg-light"]},["i",{"class":["fas ","$Notification.FaIcon"]}],"  ","$Notification.Message"]]];
    }


    constructor(defaultFieldValues = {})
    {
        js0.args(arguments, [ js0.RawObject, js0.Default ]);

        super(Messages.Content, defaultFieldValues);
    }

}


module.exports = Messages;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\core\$layouts\LemonBee_TopMenu.js
jsLibs.exportModule('core', '$layouts/LemonBee_TopMenu', (require, module, exports) => { 'use strict';

const
    js0 = require('js0'),
    spocky = require('spocky')
;

class LemonBee_TopMenu extends spocky.Layout {

    static get Content() {
        return [["div",{"class":["collapse-holder ","$CollapseButton_HolderClass"]},["button",{"_elem":["ToggleButton"],"class":["btn btn-sm btn-theme-light"]},["i",{"class":["fa-solid ","$CollapseButton_FaIcon"]}," "]]],["div",{"class":["lb-logo"]},["a",{"_hide":["HideTitles"],"href":["$lb.uris.base"]},["img",{"src":["$lb.images.logo_Main"],"alt":["logo"]}]]],["div",{"class":["lb-menu-main ","$CollapseButton_HolderClass"]},["nav",{"class":["navbar navbar-expand-md navbar-light"]},["button",{"_show":["HasBackButton"],"_elem":["BackButton"],"class":["navbar-toggler lb-navbar-back"]},["i",{"class":["fas fa-arrow-left"]}," "]],["button",{"_hide":["HasBackButton"],"class":["navbar-toggler"],"type":["button"],"data-bs-toggle":["collapse"],"data-bs-target":["#collapsibleNavbar"]},["span",{"class":["navbar-toggler-icon"]}]],["div",{"_elem":["Menu"],"class":["collapse navbar-collapse"],"id":["collapsibleNavbar"]},["ul",{"class":["navbar-nav clearfix"]},["li",{"_show":["lb.shows.home"],"class":["nav-item"]},["a",{"_elem":["menuItem_Home"],"class":["nav-link"],"href":["$lb.uris.base"]},["i",{"class":["fa fa-home"],"aria-hidden":["true"]}],["span",{"class":["$MenuCollapsed_TitlesClass"]},"$lb.text('Titles_Home')"]]],["li",{"_repeat":["menuItems:item"],"class":["nav-item ","$item.activeClass"]},["a",{"_elem":["menuItems_Panel"],"class":["nav-link"],"href":["$item.uri"]},["$",{"_show":["item.faIcon"]},["i",{"class":["$item.faIcon"]}]],["$",{"_show":["item.image"]},["img",{"src":["$item.image"]}]],["span",{"class":["$MenuCollapsed_TitlesClass"]},"$item.title"]]]],["div",{"_show":["lb.shows.userInfo"],"class":["lb-user-info-sm d-md-none"]},["i",{"class":["fa fa-user pe-2"],"aria-hidden":["true"]}],["a",{"class":["w-100"],"href":["$lb.uris.account"]},"$lb.user.login"],["a",{"_elem":["LogOut"],"href":["$lb.uris.logOut"],"class":["btn btn-theme-light btn-sm w-100 mt-2"]},"$lb.text('UserInfo_LogOut')"]]]]]];
    }


    constructor(defaultFieldValues = {})
    {
        js0.args(arguments, [ js0.RawObject, js0.Default ]);

        super(LemonBee_TopMenu.Content, defaultFieldValues);
    }

}


module.exports = LemonBee_TopMenu;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\core\$layouts\Main.js
jsLibs.exportModule('core', '$layouts/Main', (require, module, exports) => { 'use strict';

const
    js0 = require('js0'),
    spocky = require('spocky')
;

class Main extends spocky.Layout {

    static get Content() {
        return [["$",{"_holder":["content"]}],["$",{"_holder":["messages"]}]];
    }


    constructor(defaultFieldValues = {})
    {
        js0.args(arguments, [ js0.RawObject, js0.Default ]);

        super(Main.Content, defaultFieldValues);
    }

}


module.exports = Main;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\core\$layouts\List.js
jsLibs.exportModule('core', '$layouts/List', (require, module, exports) => { 'use strict';

const
    js0 = require('js0'),
    spocky = require('spocky')
;

class List extends spocky.Layout {

    static get Content() {
        return [["div",{"class":["lb-main-header"]},["div",{"class":["d-md-none lb-title-sm"]},"$title"],["div",{"class":["row g-0"]},["div",{"class":["col-lg-6 d-none d-md-block"]},["div",{"class":["row"]},["div",{"class":["col-auto lb-back"]},["a",{"_elem":["back"],"href":["$uris.back"],"class":["btn btn-theme-primary mr-2"]},["i",{"class":["fa fa-arrow-left"]}]]],["div",{"class":["col lb-title"]},["h1",{},"$title"]]]],["div",{"class":["col-xl-6 col-lg-12 lb-buttons-panel "]},["div",{"class":["btn-group w-100"]},["$",{"_holder":["Buttons_Before"]}],["a",{"_elem":["add"],"_show":["shows.add"],"href":["$uris.add"],"class":["btn btn-theme-primary mobile-button"]},["img",{"src":["${base}","res/images/panels/add.png"]}],["i",{"class":["fa-solid fa-plus me-2"]}],"$texts.Buttons_Add"],["$",{"_holder":["Buttons_After"]}]]]]],["div",{"class":["card my-3"]},["$",{"_holder":["header"]}],["div",{"class":["card-body"]},["div",{"class":["lb-main-hints"]},["$",{"_show":["shows_Infos_Clinic"],"_holder":["infos_Clinic"]}],["$",{"_show":["shows_Infos_Inseminator"],"_holder":["infos_Inseminator"]}],["$",{"_show":["shows_Infos_Farmer"],"_holder":["infos_Farmer"]}],["$",{"_show":["shows_Infos_Cow"],"_holder":["infos_Cow"]}],["$",{"_show":["shows_Infos_Bull"],"_holder":["infos_Bull"]}]],["$",{"_holder":["beforeTable"]}],["$",{"_holder":["table"]}]]]];
    }


    constructor(defaultFieldValues = {})
    {
        js0.args(arguments, [ js0.RawObject, js0.Default ]);

        super(List.Content, defaultFieldValues);
    }

}


module.exports = List;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\core\$layouts\Receipts_Form.js
jsLibs.exportModule('core', '$layouts/Receipts_Form', (require, module, exports) => { 'use strict';

const
    js0 = require('js0'),
    spocky = require('spocky')
;

class Receipts_Form extends spocky.Layout {

    static get Content() {
        return [["div",{"class":["form form-horizontal"]},["form",{},["div",{"_hide":["isNew"],"class":["form-no-form"]},["div",{"_hide":["eSys.user.isFarmer"],"class":[" text-desaturated-dark mb-3"]},["spk-form-field",{"form":["Form"],"name":["Farmer_HerdNr"],"type":["Text"],"label":["$eText('Sys:Forms_HerdNr_Label')"],"placeholder":["$eText('Sys:Forms_HerdNr_Placeholder')"],"div-class":["row "],"label-class":["col-xl-2 col-lg-4 col-5 control-label"],"field-class":["col-xl-10 col-lg-8 col-7"]}],["spk-form-field",{"form":["Form"],"name":["Farmer_HerdUnderGradeNr"],"type":["Text"],"label":["$eText('Sys:Forms_HerdUnderGradeNr_Label')"],"placeholder":["$eText('Sys:Forms_HerdUnderGradeNr_Placeholder')"],"div-class":["row "],"label-class":["col-xl-2 col-lg-4 col-5 control-label"],"field-class":["col-xl-10 col-lg-8 col-7"]}],["spk-form-field",{"form":["Form"],"name":["Farmer_Client_Address"],"type":["Text"],"label":["$eText('Sys:Forms_Address_Label')"],"placeholder":["$eText('Sys:Forms_Address_Placeholder')"],"div-class":["row "],"label-class":["col-xl-2 col-lg-4 col-5 control-label"],"field-class":["col-xl-10 col-lg-8 col-7"]}],["spk-form-field",{"form":["Form"],"name":["Farmer_Client_City"],"type":["Text"],"label":["$eText('Sys:Forms_City_Label')"],"placeholder":["$eText('Sys:Forms_City_Placeholder')"],"div-class":["row "],"label-class":["col-xl-2 col-lg-4 col-5 control-label"],"field-class":["col-xl-10 col-lg-8 col-7"]}]]],["spk-form-field",{"_show":["shows.nr"],"form":["Form"],"name":["Nr_Formatted"],"type":["Text"],"label":["$eText('Sys:Forms_Nr_Label')"],"placeholder":["$eText('Sys:Forms_Nr_Placeholder')"],"div-class":["mt-2 mb-1 lb-no-label alert system-alert system-header-h3"],"label-class":["col-xl-4 control-label "],"field-class":["col-xl-6 "]}],["div",{"_show":["shows.error"],"class":["alert system-alert alert-danger"]},["i",{"class":["fa-solid fa-circle-exclamation me-2"]}],"Błędne zaświadczenie: ","$Error"],["div",{"_show":["shows.cow"],"class":[""]},["h4",{"class":["alert system-alert"]},["img",{"class":["me-2"],"src":["${base}","res/images/panels/icon-cow.png"]}],"$eText('Sys:Titles_Cow')"],["spk-form-field",{"form":["Form"],"name":["Cow_Nr"],"type":["Input"],"input-type":["Text"],"label":["$eText('Sys:Forms_IdentificationNr_Label')"],"placeholder":["$eText('Sys:Forms_IdentificationNr_Placeholder')"],"div-class":["row g-0 mt-3 system-form-highlight"],"label-class":["col-xl-2 col-lg-4 control-label"],"field-class":["col-xl-10 col-lg-8"]}],["spk-form-field",{"form":["Form"],"name":["Cow_Name"],"type":["Input"],"input-type":["Text"],"label":["$eText('Sys:Forms_Name_Label')"],"placeholder":["$eText('Sys:Forms_Name_Placeholder')"],"div-class":["row g-0 mt-3"],"label-class":["col-xl-2 col-lg-4 control-label"],"field-class":["col-xl-10 col-lg-8"]}],["spk-form-field",{"form":["Form"],"name":["Cow_CowshedNr"],"type":["Input"],"input-type":["Text"],"label":["$eText('Sys:Forms_CowshedNr_Label')"],"placeholder":["$eText('Sys:Forms_CowshedNr_Placeholder')"],"div-class":["row g-0 mt-3"],"label-class":["col-xl-2 col-lg-4 control-label"],"field-class":["col-xl-10 col-lg-8"]}],["spk-form-field",{"form":["Form"],"name":["Cow_Race"],"type":["Input"],"input-type":["Text"],"label":["$eText('Sys:Forms_Race_Label')"],"placeholder":["$eText('Sys:Forms_Race_Placeholder')"],"div-class":["row g-0 mt-3"],"label-class":["col-xl-2 col-lg-4 control-label"],"field-class":["col-xl-10 col-lg-8"]}],["spk-form-field",{"form":["Form"],"name":["Cow_Birth"],"type":["Date"],"label":["$eText('Sys:Forms_Birth_Label')"],"placeholder":["$eText('Sys:Forms_Date_Placeholder')"],"div-class":["row g-0 mt-3"],"label-class":["col-xl-2 col-lg-4 control-label"],"field-class":["col-xl-10 col-lg-8"]}]],["div",{"_show":["shows.bull"],"class":["my-4"]},["h4",{"class":["alert system-alert"]},["img",{"class":["me-2"],"src":["${base}","res/images/panels/icon-bull.png"]}],"$eText('Sys:Titles_Bull')"],["spk-form-field",{"form":["Form"],"name":["Bull_Name"],"type":["Input"],"input-type":["Text"],"label":["$eText('Sys:Forms_FirstName_Label')"],"placeholder":["$eText('Sys:Forms_FirstName_Placeholder')"],"div-class":["row g-0 mt-3 system-form-highlight"],"label-class":["col-xl-2 col-lg-4 control-label"],"field-class":["col-xl-10 col-lg-8"]}],["spk-form-field",{"form":["Form"],"name":["Bull_Nr"],"type":["Input"],"input-type":["Text"],"label":["$eText('Sys:Forms_IdentificationNr_Label')"],"placeholder":["$eText('Sys:Forms_IdentificationNr_Placeholder')"],"div-class":["row g-0 mt-3"],"label-class":["col-xl-2 col-lg-4 control-label"],"field-class":["col-xl-10 col-lg-8"]}],["spk-form-field",{"form":["Form"],"name":["Bull_ManufacturerNr"],"type":["Input"],"input-type":["Text"],"label":["$eText('Sys:Forms_ManufacturerNr_Label')"],"placeholder":["$eText('Sys:Forms_ManufacturerNr_Placeholder')"],"div-class":["row g-0 mt-3"],"label-class":["col-xl-2 col-lg-4 control-label"],"field-class":["col-xl-10 col-lg-8"]}],["spk-form-field",{"form":["Form"],"name":["Bull_Race"],"type":["Input"],"input-type":["Text"],"label":["$eText('Sys:Forms_Race_Label')"],"placeholder":["$eText('Sys:Forms_Race_Placeholder')"],"div-class":["row g-0 mt-3"],"label-class":["col-xl-2 col-lg-4 control-label"],"field-class":["col-xl-10 col-lg-8"]}]],["h5",{"class":["alert system-alert"]},["img",{"class":["me-2"],"src":["${base}","res/images/panels/icon-receipt.png"]}],"$eText('Sys:Titles_Details')"],["spk-form-field",{"form":["Form"],"name":["Date"],"type":["Date"],"label":["$eText('Sys:Forms_TreatmentDate_Label')"],"placeholder":["$eText('Sys:Forms_Date_Placeholder')"],"div-class":["row g-0 mt-3 system-form-highlight system-form-highlight-date"],"label-class":["col-xl-2 col-lg-4 control-label"],"field-class":["col-xl-10 col-lg-8"]}],["spk-form-field",{"form":["Form"],"name":["Added_Formatted"],"type":["Text"],"label":["$eText('Sys:Forms_Added_Label')"],"div-class":["row g-0 mt-3"],"label-class":["col-xl-2 col-lg-4 col control-label text-desaturated-dark"],"field-class":["col-xl-10 col-lg-8 col text-desaturated-dark"]}],["spk-form-field",{"form":["Form"],"name":["Downloaded_Formatted"],"type":["Text"],"label":["$eText('Sys:Forms_Downloaded_Label')"],"div-class":["row"],"label-class":["col-xl-2 col-lg-4 col control-label text-desaturated-dark"],"field-class":["col-xl-10 col-lg-8 col text-desaturated-dark"]}],["spk-form-field",{"form":["Form"],"name":["FileNr"],"type":["Input"],"input-type":["text"],"label":["$eText('Sys:Forms_FileNr_Label')"],"placeholder":["$eText('Sys:Forms_FileNr_Placeholder')"],"div-class":["row mt-2"],"label-class":["col-xl-2 col-lg-4 control-label"],"field-class":["col-xl-10 col-lg-8"]}],["spk-form-field",{"form":["Form"],"name":["TreatmentNr"],"type":["Input"],"input-type":["text"],"label":["$eText('Sys:Forms_TreatmentNr_Label')"],"placeholder":["$eText('Sys:Forms_TreatmentNr_Placeholder')"],"div-class":["row g-0 mt-3"],"label-class":["col-xl-2 col-lg-4 control-label"],"field-class":["col-xl-10 col-lg-8"]}],["spk-form-field",{"form":["Form"],"name":["LastCalving"],"type":["Date"],"label":["$eText('Sys:Forms_LastCalving_Label')"],"placeholder":["$eText('Sys:Forms_LastCalving_Placeholder')"],"div-class":["row g-0 mt-3"],"label-class":["col-xl-2 col-lg-4 control-label"],"field-class":["col-xl-10 col-lg-8"]}],["spk-form-field",{"form":["Form"],"name":["SemenProduction"],"type":["Date"],"label":["$eText('Sys:Forms_SemenProduction_Label')"],"placeholder":["$eText('Sys:Forms_SemenProduction_Placeholder')"],"div-class":["row g-0 mt-3"],"label-class":["col-xl-2 col-lg-4 control-label"],"field-class":["col-xl-10 col-lg-8"]}],["spk-form-field",{"form":["Form"],"name":["ReinseminationsCount"],"type":["Input"],"input-type":["text"],"label":["$eText('Sys:Forms_ReinseminationsCount_Label')"],"placeholder":["$eText('Sys:Forms_ReinseminationsCount_Placeholder')"],"div-class":["row g-0 mt-3"],"label-class":["col-xl-2 col-lg-4 control-label"],"field-class":["col-xl-10 col-lg-8"]}],["spk-form-field",{"form":["Form"],"name":["Note"],"type":["TextArea"],"label":["$eText('Sys:Forms_Note_Label')"],"placeholdrefresher":["$eText('Sys:Forms_Note_Placeholder')"],"div-class":["row g-0 mt-3"],"label-class":["col-xl-2 col-lg-4 control-label"],"field-class":["col-xl-10 col-lg-8"]}],["$",{"_hide":["isNew"]},["div",{"_show":["eSys.user.isAdministrator"],"class":["small mt-4 alert system-alert"]},["spk-form-field",{"form":["Form"],"name":["Added_Date_Formatted"],"type":["Text"],"label":["$eText('Sys:Forms_Added_Date_Label')"],"div-class":["text-desaturated row mb-2"],"label-class":["col-4 control-label"],"field-class":["col-8"]}],["spk-form-field",{"form":["Form"],"name":["Added_Identificator"],"type":["Text"],"label":["$eText('Sys:Forms_Added_Identificator_Label')"],"div-class":["text-desaturated row"],"label-class":["col-4 control-label"],"field-class":["col-8"]}]]]]]];
    }


    constructor(defaultFieldValues = {})
    {
        js0.args(arguments, [ js0.RawObject, js0.Default ]);

        super(Receipts_Form.Content, defaultFieldValues);
    }

}


module.exports = Receipts_Form;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\core\$layouts\PrivacyPolicy.js
jsLibs.exportModule('core', '$layouts/PrivacyPolicy', (require, module, exports) => { 'use strict';

const
    js0 = require('js0'),
    spocky = require('spocky')
;

class PrivacyPolicy extends spocky.Layout {

    static get Content() {
        return [["div",{"class":["container mt-2 mb-4 system-registration"]},["div",{"class":["card"]},["div",{"class":["card-header"]},["img",{"src":["/res/images/logo.png"],"alt":["e-MilkyGen"],"class":[""]}]],["div",{"class":["card-body"]},["h3",{"class":["mb-4"]},"Polityka Prywatności"],["h4",{},"1. Podstawowy"],["p",{},"..."]]]]];
    }


    constructor(defaultFieldValues = {})
    {
        js0.args(arguments, [ js0.RawObject, js0.Default ]);

        super(PrivacyPolicy.Content, defaultFieldValues);
    }

}


module.exports = PrivacyPolicy;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\core\$layouts\Receipts_Form_Buttons.js
jsLibs.exportModule('core', '$layouts/Receipts_Form_Buttons', (require, module, exports) => { 'use strict';

const
    js0 = require('js0'),
    spocky = require('spocky')
;

class Receipts_Form_Buttons extends spocky.Layout {

    static get Content() {
        return [["a",{"_elem":["download"],"_show":["shows.download"],"href":["$hrefs.download"],"class":["btn btn-theme-primary mobile-button"]},["img",{"src":["${base}","res/images/panels/print.png"]}],["i",{"class":["fa fa-print me-2"]}],"$eText('Sys:Buttons_Print')"],["a",{"_elem":["downloadSymlek"],"_show":["shows.downloadSymlek"],"href":["$hrefs.downloadSymlek"],"class":["btn btn-theme-primary mobile-button"]},["img",{"src":["${base}","res/images/panels/fedinfo.png"]}],["i",{"class":["fa fa-file me-2"]}],"$eText('Sys:Buttons_DownloadSymlek')"],["a",{"_elem":["print"],"_show":["shows.print"],"href":["#"],"class":["btn btn-theme-primary mobile-button"]},["img",{"src":["${base}","res/images/panels/print.png"]}],["i",{"class":["fa fa-file me-2"]}],"$eText('Sys:Buttons_Print')"]];
    }


    constructor(defaultFieldValues = {})
    {
        js0.args(arguments, [ js0.RawObject, js0.Default ]);

        super(Receipts_Form_Buttons.Content, defaultFieldValues);
    }

}


module.exports = Receipts_Form_Buttons;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\core\$layouts\Receipts_List_Buttons.js
jsLibs.exportModule('core', '$layouts/Receipts_List_Buttons', (require, module, exports) => { 'use strict';

const
    js0 = require('js0'),
    spocky = require('spocky')
;

class Receipts_List_Buttons extends spocky.Layout {

    static get Content() {
        return [["a",{"_show":["shows.download"],"_elem":["download"],"href":["#"],"class":["btn btn-theme-primary mobile-button"]},["img",{"src":["${base}","res/images/panels/download.png"]}],["i",{"class":["fa-solid fa-download me-2"]}],"$eText('Sys:Buttons_Download')"],["a",{"_show":["shows.downloadRegister"],"_elem":["downloadRegister"],"href":["$hrefs.downloadRegister"],"class":["btn btn-theme-primary mobile-button"]},["img",{"src":["${base}","res/images/panels/download.png"]}],["i",{"class":["fa-solid fa-list me-2"]}],"$eText('Sys:Buttons_DownloadRegister')"]];
    }


    constructor(defaultFieldValues = {})
    {
        js0.args(arguments, [ js0.RawObject, js0.Default ]);

        super(Receipts_List_Buttons.Content, defaultFieldValues);
    }

}


module.exports = Receipts_List_Buttons;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\core\$layouts\NewReceipt_AssociatedBulls.js
jsLibs.exportModule('core', '$layouts/NewReceipt_AssociatedBulls', (require, module, exports) => { 'use strict';

const
    js0 = require('js0'),
    spocky = require('spocky')
;

class NewReceipt_AssociatedBulls extends spocky.Layout {

    static get Content() {
        return [["$",{"_show":["show"]},["h5",{"class":["system-header mb-3"]},["i",{"class":["fa-solid fa-heart pe-2"]}],"$eText('Sys:Associations')"],["$",{"_holder":["table"]}]]];
    }


    constructor(defaultFieldValues = {})
    {
        js0.args(arguments, [ js0.RawObject, js0.Default ]);

        super(NewReceipt_AssociatedBulls.Content, defaultFieldValues);
    }

}


module.exports = NewReceipt_AssociatedBulls;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\core\$layouts\Receipts_List_BeforeTable.js
jsLibs.exportModule('core', '$layouts/Receipts_List_BeforeTable', (require, module, exports) => { 'use strict';

const
    js0 = require('js0'),
    spocky = require('spocky')
;

class Receipts_List_BeforeTable extends spocky.Layout {

    static get Content() {
        return [["div",{"class":["lb-filter-holder"]},["div",{"class":["row g-0"]},["div",{"class":["col-xl-6"]},["div",{"class":["btn-group w-100"]},["a",{"_elem":["Filters_CurrentMonth"],"href":["#"],"class":["col btn btn-sm btn-outline-success rounded-0 ","?($filter === 'currentMonth' ? 'active' : '')"]},"$eText('Sys:Buttons_CurrentMonth')"],["a",{"_elem":["Filters_PreviousMonth"],"href":["#"],"class":["col btn btn-sm btn-outline-success ","?($filter === 'previousMonth' ? 'active' : '')"]},"$eText('Sys:Buttons_PreviousMonth')"],["a",{"_elem":["Filters_CurrentYear"],"href":["#"],"class":["col btn btn-sm btn-outline-success ","?($filter === 'currentYear' ? 'active' : '')"]},"$eText('Sys:Buttons_CurrentYear')"],["a",{"_elem":["Filters_DatesRange"],"href":["#"],"class":["col btn btn-sm btn-outline-success rounded-0 ","?($filter === 'datesRange' ? 'active' : '')"]},"$eText('Sys:Buttons_DatesRange')"]]],["div",{"_show":["ShowDatesRange"],"class":["col-xl-6 mb-1"]},["div",{"class":["row g-0 lb-date-picker"]},["div",{"class":[" col-sm-6"]},["spk-form-field",{"form":["Form"],"name":["Date_From"],"type":["Date"],"label":[""],"placeholder":["$eText('Sys:Forms_DateFrom_Placeholder')"],"field-class":["clickable"]}]],["div",{"class":[" col-sm-6"]},["spk-form-field",{"form":["Form"],"name":["Date_To"],"type":["Date"],"label":[""],"placeholder":["$eText('Sys:Forms_DateTo_Placeholder')"]}]]]]]]];
    }


    constructor(defaultFieldValues = {})
    {
        js0.args(arguments, [ js0.RawObject, js0.Default ]);

        super(Receipts_List_BeforeTable.Content, defaultFieldValues);
    }

}


module.exports = Receipts_List_BeforeTable;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\core\$layouts\Receipts_List_Header.js
jsLibs.exportModule('core', '$layouts/Receipts_List_Header', (require, module, exports) => { 'use strict';

const
    js0 = require('js0'),
    spocky = require('spocky')
;

class Receipts_List_Header extends spocky.Layout {

    static get Content() {
        return [["div",{"class":["lb-filter-holder"]},["div",{"class":["row g-0"]},["div",{"class":["col-auto"]},["spk-form-field",{"form":["Form"],"name":["DatesRange"],"type":["Checkbox"],"label":["$eText('Sys:Forms_DateRange_Label')"],"placeholder":[""],"field-class":["clickable"]}]],["div",{"_show":["showDatesRange"],"class":["col-lg col-12"]},["div",{"class":["row g-0 lb-date-picker"]},["div",{"class":["col-sm-6"]},["spk-form-field",{"form":["Form"],"name":["Date_From"],"type":["Date"],"label":[""],"placeholder":["$eText('Sys:Forms_DateFrom_Placeholder')"],"field-class":["clickable"]}]],["div",{"class":["col-sm-6"]},["spk-form-field",{"form":["Form"],"name":["Date_To"],"type":["Date"],"label":[""],"placeholder":["$eText('Sys:Forms_DateTo_Placeholder')"]}]]]]]]];
    }


    constructor(defaultFieldValues = {})
    {
        js0.args(arguments, [ js0.RawObject, js0.Default ]);

        super(Receipts_List_Header.Content, defaultFieldValues);
    }

}


module.exports = Receipts_List_Header;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\core\$layouts\Select.js
jsLibs.exportModule('core', '$layouts/Select', (require, module, exports) => { 'use strict';

const
    js0 = require('js0'),
    spocky = require('spocky')
;

class Select extends spocky.Layout {

    static get Content() {
        return [["a",{"_elem":["select"],"href":["#"],"class":["btn btn-success ","?($active ? 'active' : '')"]},["i",{"class":["fas fa-check-double"]}]]];
    }


    constructor(defaultFieldValues = {})
    {
        js0.args(arguments, [ js0.RawObject, js0.Default ]);

        super(Select.Content, defaultFieldValues);
    }

}


module.exports = Select;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\core\$layouts\Users_Form.js
jsLibs.exportModule('core', '$layouts/Users_Form', (require, module, exports) => { 'use strict';

const
    js0 = require('js0'),
    spocky = require('spocky')
;

class Users_Form extends spocky.Layout {

    static get Content() {
        return [["spk-form-field",{"form":["Form"],"name":["Email"],"type":["Input"],"input-type":["Text"],"label":["$eText('Sys:Forms_Email_Label')"],"placeholder":["$eText('Sys:Forms_Email_Placeholder')"],"div-class":["row g-0 mt-3"],"label-class":["col-xl-2 col-lg-4 control-label"],"field-class":["col-xl-10 col-lg-8"]}],["$",{"_hide":["isNew"]},["div",{"_show":["eSys.user.isAdministrator"],"class":["small mt-4 alert system-alert"]},["spk-form-field",{"form":["Form"],"name":["LastActivity_Formatted"],"type":["Text"],"label":["$eText('Sys:Forms_LastActivity_Label')"],"div-class":["text-desaturated row mb-2"],"label-class":["col-3 control-label"],"field-class":["col-9"]}],["spk-form-field",{"form":["Form"],"name":["Added_Date_Formatted"],"type":["Text"],"label":["$eText('Sys:Forms_Added_Date_Label')"],"div-class":["text-desaturated row mb-2"],"label-class":["col-3 control-label"],"field-class":["col-9"]}],["spk-form-field",{"form":["Form"],"name":["Added_Identificator"],"type":["Text"],"label":["$eText('Sys:Forms_Added_Identificator_Label')"],"div-class":["text-desaturated row"],"label-class":["col-3 control-label"],"field-class":["col-9"]}]]]];
    }


    constructor(defaultFieldValues = {})
    {
        js0.args(arguments, [ js0.RawObject, js0.Default ]);

        super(Users_Form.Content, defaultFieldValues);
    }

}


module.exports = Users_Form;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\core\$layouts\Temp.js
jsLibs.exportModule('core', '$layouts/Temp', (require, module, exports) => { 'use strict';

const
    js0 = require('js0'),
    spocky = require('spocky')
;

class Temp extends spocky.Layout {

    static get Content() {
        return [["h1",{"id":["Title"]},"Test"],["button",{"_elem":["Test"]},"Button"]];
    }


    constructor(defaultFieldValues = {})
    {
        js0.args(arguments, [ js0.RawObject, js0.Default ]);

        super(Temp.Content, defaultFieldValues);
    }

}


module.exports = Temp;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\core\$layouts\Test.js
jsLibs.exportModule('core', '$layouts/Test', (require, module, exports) => { 'use strict';

const
    js0 = require('js0'),
    spocky = require('spocky')
;

class Test extends spocky.Layout {

    static get Content() {
        return [["h1",{},"Test"],["div",{"_repeat":["rows:row"],"style":["clear: both; border: 1px solid red;"]},["$",{"_repeat":["row:col"]},"$col","  "]]];
    }


    constructor(defaultFieldValues = {})
    {
        js0.args(arguments, [ js0.RawObject, js0.Default ]);

        super(Test.Content, defaultFieldValues);
    }

}


module.exports = Test;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\core\$layouts\index.js
jsLibs.exportModule('core', '$layouts/index', (require, module, exports) => { 'use strict';

const About_Basic = require('./About_Basic');
const Administrators_Form = require('./Administrators_Form');
const Administrators_Form_Buttons = require('./Administrators_Form_Buttons');
const Associations_List_Buttons = require('./Associations_List_Buttons');
const Backups_Basic = require('./Backups_Basic');
const Bulls_Form = require('./Bulls_Form');
const Bulls_Info = require('./Bulls_Info');
const Bulls_List_Buttons = require('./Bulls_List_Buttons');
const Buttons_Delete = require('./Buttons_Delete');
const Clients_Form = require('./Clients_Form');
const Clinics_Form = require('./Clinics_Form');
const Clinics_Form_Buttons = require('./Clinics_Form_Buttons');
const Clinics_Info = require('./Clinics_Info');
const Clinics_List_Buttons = require('./Clinics_List_Buttons');
const Cows_Form = require('./Cows_Form');
const Cows_Info = require('./Cows_Info');
const Cows_List_Buttons = require('./Cows_List_Buttons');
const DeleteAccount = require('./DeleteAccount');
const Farmers_Form = require('./Farmers_Form');
const Farmers_Form_Buttons = require('./Farmers_Form_Buttons');
const Farmers_Info = require('./Farmers_Info');
const Farmers_List_Buttons = require('./Farmers_List_Buttons');
const Form = require('./Form');
const Inseminators_Form = require('./Inseminators_Form');
const Inseminators_Form_Buttons = require('./Inseminators_Form_Buttons');
const Inseminators_Info = require('./Inseminators_Info');
const Inseminators_List_Buttons = require('./Inseminators_List_Buttons');
const LemonBee_Body = require('./LemonBee_Body');
const LemonBee_Main = require('./LemonBee_Main');
const LemonBee_TopMenu = require('./LemonBee_TopMenu');
const List = require('./List');
const Main = require('./Main');
const Messages = require('./Messages');
const NewReceipt_AssociatedBulls = require('./NewReceipt_AssociatedBulls');
const PrivacyPolicy = require('./PrivacyPolicy');
const Receipts_Form = require('./Receipts_Form');
const Receipts_Form_Buttons = require('./Receipts_Form_Buttons');
const Receipts_List_BeforeTable = require('./Receipts_List_BeforeTable');
const Receipts_List_Buttons = require('./Receipts_List_Buttons');
const Receipts_List_Header = require('./Receipts_List_Header');
const Select = require('./Select');
const Temp = require('./Temp');
const Test = require('./Test');
const Users_Form = require('./Users_Form');
const Users_ManageAccount = require('./Users_ManageAccount');
const panels_TestPanel = require('./panels_TestPanel');






module.exports.About_Basic = About_Basic;
module.exports.Administrators_Form = Administrators_Form;
module.exports.Administrators_Form_Buttons = Administrators_Form_Buttons;
module.exports.Associations_List_Buttons = Associations_List_Buttons;
module.exports.Backups_Basic = Backups_Basic;
module.exports.Bulls_Form = Bulls_Form;
module.exports.Bulls_Info = Bulls_Info;
module.exports.Bulls_List_Buttons = Bulls_List_Buttons;
module.exports.Buttons_Delete = Buttons_Delete;
module.exports.Clients_Form = Clients_Form;
module.exports.Clinics_Form = Clinics_Form;
module.exports.Clinics_Form_Buttons = Clinics_Form_Buttons;
module.exports.Clinics_Info = Clinics_Info;
module.exports.Clinics_List_Buttons = Clinics_List_Buttons;
module.exports.Cows_Form = Cows_Form;
module.exports.Cows_Info = Cows_Info;
module.exports.Cows_List_Buttons = Cows_List_Buttons;
module.exports.DeleteAccount = DeleteAccount;
module.exports.Farmers_Form = Farmers_Form;
module.exports.Farmers_Form_Buttons = Farmers_Form_Buttons;
module.exports.Farmers_Info = Farmers_Info;
module.exports.Farmers_List_Buttons = Farmers_List_Buttons;
module.exports.Form = Form;
module.exports.Inseminators_Form = Inseminators_Form;
module.exports.Inseminators_Form_Buttons = Inseminators_Form_Buttons;
module.exports.Inseminators_Info = Inseminators_Info;
module.exports.Inseminators_List_Buttons = Inseminators_List_Buttons;
module.exports.LemonBee_Body = LemonBee_Body;
module.exports.LemonBee_Main = LemonBee_Main;
module.exports.LemonBee_TopMenu = LemonBee_TopMenu;
module.exports.List = List;
module.exports.Main = Main;
module.exports.Messages = Messages;
module.exports.NewReceipt_AssociatedBulls = NewReceipt_AssociatedBulls;
module.exports.PrivacyPolicy = PrivacyPolicy;
module.exports.Receipts_Form = Receipts_Form;
module.exports.Receipts_Form_Buttons = Receipts_Form_Buttons;
module.exports.Receipts_List_BeforeTable = Receipts_List_BeforeTable;
module.exports.Receipts_List_Buttons = Receipts_List_Buttons;
module.exports.Receipts_List_Header = Receipts_List_Header;
module.exports.Select = Select;
module.exports.Temp = Temp;
module.exports.Test = Test;
module.exports.Users_Form = Users_Form;
module.exports.Users_ManageAccount = Users_ManageAccount;
module.exports.panels_TestPanel = panels_TestPanel;
 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\core\$layouts\Users_ManageAccount.js
jsLibs.exportModule('core', '$layouts/Users_ManageAccount', (require, module, exports) => { 'use strict';

const
    js0 = require('js0'),
    spocky = require('spocky')
;

class Users_ManageAccount extends spocky.Layout {

    static get Content() {
        return [["div",{"_show":["show"]},["h4",{"class":["alert system-alert mt-4"]},["i",{"class":["fa-solid fa-user-gear pe-2"]}],"$eText('Sys:Text_ManageAccount')"],["div",{"class":["btn-group w-100 mt-3"],"role":["group"]},["a",{"_elem":["activate_Activate"],"_show":["shows.activate"],"href":["#"],"class":["btn btn-theme-secondary"]},["i",{"class":["fa fa-check me-2"]}],"$eText('Sys:Buttons_Activate')"],["a",{"_elem":["activate_Deactivate"],"_show":["shows.deactivate"],"href":["#"],"class":["btn btn-secondary"]},["i",{"class":["fa fa-times me-2"]}],"$eText('Sys:Buttons_Deactivate')"],["a",{"_elem":["resetPassword"],"href":["#"],"class":["btn btn-theme-primary"]},["i",{"class":["fa fa-sync me-3"]}],"$eText('Sys:Buttons_ResetPassword')"]]]];
    }


    constructor(defaultFieldValues = {})
    {
        js0.args(arguments, [ js0.RawObject, js0.Default ]);

        super(Users_ManageAccount.Content, defaultFieldValues);
    }

}


module.exports = Users_ManageAccount;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\core\$layouts\panels_TestPanel.js
jsLibs.exportModule('core', '$layouts/panels_TestPanel', (require, module, exports) => { 'use strict';

const
    js0 = require('js0'),
    spocky = require('spocky')
;

class panels_TestPanel extends spocky.Layout {

    static get Content() {
        return [["h1",{},"Test Panel"]];
    }


    constructor(defaultFieldValues = {})
    {
        js0.args(arguments, [ js0.RawObject, js0.Default ]);

        super(panels_TestPanel.Content, defaultFieldValues);
    }

}


module.exports = panels_TestPanel;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\spk-tables\index.js
jsLibs.exportModule('spk-tables', 'index', (require, module, exports) => { 'use strict';

const
    abStrings = require('ab-strings'),
    js0 = require('js0'),
    spkMessages = require('spk-messages'),
    spocky = require('spocky'),
    webABApi = require('web-ab-api'),

    $layouts = require('./$layouts')
;

class spkTables_Class
{

    get Table() {
        return require('./Table');
    }


    constructor()
    {
        this._textFn = (text) => {
            return this._texts[text];
        };  
        this._texts = {
            Error: 'Error',
        };
    }

    setTextFn(textFn)
    {
        js0.args(arguments, 'function');

        this._textFn = textFn;
    }

    text(text)
    {
        js0.args(arguments, 'string');

        return this._textFn(text);
    }

}
const spkTables = new spkTables_Class();



module.exports = spkTables;


 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\spk-tables\Table.js
jsLibs.exportModule('spk-tables', 'Table', (require, module, exports) => { 'use strict';

const
    abStrings = require('ab-strings'),
    js0 = require('js0'),
    spkMessages = require('spk-messages'),
    spocky = require('spocky'),
    webABApi = require('web-ab-api'),

    $layouts = require('./$layouts'),
    spkTables = require('.')
;

class Table extends spocky.Module
{

    get columnRefs() {
        return this._columnRefs;
    }

    get isSelectable() {
        return this._selectable;
    }

    get layout() {
        return this.l;
    }

    constructor(msgs, tableInfo) { super();
        js0.args(arguments, spkMessages.Messages, js0.RawObject);

        tableInfo = js0.copyRawObject(tableInfo);

        js0.typeE(tableInfo, js0.Preset({
            columns: js0.Iterable(js0.Preset({
                name: 'string',
                refColumnName: [ 'string', js0.Null, 'symbol', js0.Default(Table.NotSet) ],
                header: 'string',
                class: [ 'string', js0.Default('') ],
                style: [ 'string', js0.Default('') ],
                textStyle: [ 'string', js0.Default('') ],
                orderBy: [ js0.Preset({
                    priority: [ 'number', js0.Default(0) ],
                    reverse: [ 'boolean', js0.Default(false) ],
                }), js0.Null, js0.Default(null) ],
                filter: [ 'boolean', js0.Default(true), ],
            })),
            apiUri: [ 'string', js0.Null, js0.Default(null) ],
            fn: [ 'function', js0.Null, js0.Default(null) ],
            orderBy: js0.Preset({
                columnName: [ 'string', js0.Null ],
                reverse: [ 'boolean', js0.Default(false) ],
            }),
            hiddenColumnNames: [ js0.Iterable('string'), js0.Default([]) ],
            showInstantLoading: [ 'boolean', js0.Default(false) ],
        }));

        for (let column of tableInfo.columns) {
            if (column.refColumnName === Table.NotSet)
                column.refColumnName = column.name;
        }

        this.msgs = msgs;

        this._info = tableInfo;

        this._columnNames = [];
        this._columnRefs = {};
        this._columnsOrder = [];

        this._dynamic = false;

        this._rows = [];
        this._rows_Current = [];
        this._rows_Fields = [];
        this._rows_Fields_Index = 0;

        this._rows_RefreshQueueCount = 0;

        this._noSort = false;
        this._selectable = false;
        this._selectable_ShowSelectAll = true;
        this._selectable_SelectedOnTop = false;
        this._sortable = true;

        this._filter = {
            value: '',
            current: '',
            timeoutId: null
        };
        this._limit = {
            start: 50,
            current: 50,
            step: 100,
        };
        this._rowsFilterFn = null;

        this._fns_ApiFields = null;
        this._fns_CustomFilterFns = {};
        this._fns_RowHref = null;

        this._listeners_OnApiResult = null;
        this._listeners_OnClick = null;
        this._listeners_OnColumnButtonClick = null;
        this._listeners_OnRefresh = null;
        this._listeners_OnRowSelected = null;
        this._listeners_OnSearch = null;
        this._listeners_OnSort = null;

        this.l = new $layouts.Table();

        /* Why is it needed? */
        // this.l.$onDisplay((active) => {
            // if (active) {
            //     if (this._rows_Fields.length > 0)
            //         this._rows_UpdateFields(this._rows_Fields, true);
            // } else {
            //     this._rows_Fields_Index++;
            //     this.l.$fields.table.rows = [];
            // }
        // });

        this._createFields();
        this._createElems();
        this._parseInfo();

        this.$view = this.l;
    }

    addCustomFilter(filterName, filterFieldsFn) {
        if (filterName in this._fns_CustomFilterFns)
            throw new Error(`Filter '${filterName}' already exists.`);

        this._fns_CustomFilterFns[filterName] = filterFieldsFn;
        return this;
    }

    addHiddenColumns(hiddenColumnNames) {
        js0.args(arguments, Array);

        hiddenColumnNames = this._info.hiddenColumnNames.concat(hiddenColumnNames);        
        this.setHiddenColumns(hiddenColumnNames);
    }

    getSelectedRows() {
        let rows_Selected = [];
        for (let row of this._rows_Current) {
            if (row.selected) {
                let row_Selected = {};
                for (let i = 0; i < row.cols.length; i++)
                    row_Selected[this._columnNames[i]] = row.cols[i].value;

                rows_Selected.push(row_Selected);
            }
        }

        return rows_Selected;
    }

    getTableArgs() {
        let tableArgs = {};

        tableArgs.table = {
            filter: this._filter.value,
            orderColumnName: this._info.orderBy.columnName,
            orderColumnDesc: this._info.orderBy.reverse,
        };

        tableArgs.custom = this._getCustomFilterInfos();

        return tableArgs;
    }

    getTableInfo() {
        return {
            columns: this._info.columns,
            orderBy: this._info.orderBy,
        };
    }

    refresh() {
        this._limit.current = this._limit.start;        

        this._rows_Refresh(false);
    }

    refreshRow(index) {
        js0.args(arguments, 'int');

        this._rows_Fields[index] = this._rows_UpdateFields_ParseRow(
            this._rows_Current[index]);
        this.l.$fields.table.rows(index, this._rows_Fields[index]);
    }

    refreshAllRows() {
        if (!this._noSort)
            this._rows = this._rows_Sort(this._rows);

        this._rows_Current = this._rows_Filter(this._rows);
        this._rows_Update_Async(this._rows_Current)
            .then(() => {
                this.msgs.hideLoading();
            })
            .catch((e) => {
                console.error(e);

                this.msgs.showMessage_Failure(spkTables.text('Error'), 
                        e.toString());
                this.msgs.hideLoading();
            });
    }

    removeHiddenColumns(hiddenColumnNames) {
        js0.args(arguments, Array);

        hiddenColumnNames = this._info.hiddenColumnNames.filter((el) => {
            return hiddenColumnNames.indexOf(el) < 0;
        });
        this.setHiddenColumns(hiddenColumnNames);
    }

    setApiFields(apiFieldsFn) {
        js0.args(arguments, 'function');

        this._fns_ApiFields = apiFieldsFn;

        return this;
    }

    setDynamic(dynamic) {
        js0.args(arguments, 'boolean');

        this._dynamic = dynamic;

        return this;
    }

    setFilterText(filterValue) {
        this.l.$elems.filter.value = filterValue;
        this._filter.value = filterValue;
    }

    setHiddenColumns(hiddenColumnNames) {
        js0.args(arguments, js0.Iterable('string'));

        for (let colName of hiddenColumnNames) {
            if (!this._columnNames.includes(colName))
                throw new Error(`Column '${colName}' does not exist in table.`);
        }

        this._info.hiddenColumnNames = hiddenColumnNames;

        for (let i = 0; i < this._columnNames.length; i++) {
            this.l.$fields.table.headers(i).show = 
                    !hiddenColumnNames.includes(this._columnNames[i]);
        }

        for (let i = 0; i < this._rows.length; i++) {
            for (let j = 0; j < this._columnNames.length; j++) {
                this.l.$fields.table.rows(i).cols(j).show = 
                        !hiddenColumnNames.includes(this._columnNames[j]);
            }
        }

        return this;
    }

    setLimit(start, step) {
        js0.args(arguments, 'number', 'number');

        this._limit = {
            start: start,
            current: start,
            step: step,
        };

        return this;
    }

    setNoSort(noSort) {
        js0.args(arguments, 'boolean');

        this._noSort = noSort;

        return this;
    }

    setOnApiResult(onApiResultFn) {
        js0.args(arguments, 'function');

        this._listeners_OnApiResult = onApiResultFn;

        return this;
    }    

    setOnColumnButtonClick(onColumnButtonClickFn) {
        js0.args(arguments, 'function');

        this._listeners_OnColumnButtonClick = onColumnButtonClickFn;
    }

    setOnRefresh(onRefreshFn) {
        js0.args(arguments, 'function');

        this._listeners_OnRefresh = onRefreshFn;

        return this;
    }

    setOnRowSelected(onRowSelectedFn) {
        this._listeners_OnRowSelected = onRowSelectedFn;

        return this;
    }

    setOnSearch(onSearchFn) {
        js0.args(arguments, 'function');

        this._listeners_OnSearch = onSearchFn;

        return this;
    }

    setOnSort(onSortFn) {
        js0.args(arguments, 'function');

        this._listeners_OnSort = onSortFn;

        return this;
    }

    // setOnRefreshRow(onRefreshRowFn)
    // {
    //     js0.args(arguments, 'function');

    //     this._listeners_OnRefreshRow = onRefreshRowFn;

    //     return this;
    // }

    setOnRowClick(onClickFn, rowHrefFn = null) {
        js0.args(arguments, [ 'function', js0.Null ], [ 'function', js0.Default ]);

        this._listeners_OnClick = onClickFn;        
        this._fns_RowHref = rowHrefFn;

        for (let i = 0; i < this._rows_Current.length; i++) {
            this.l.$fields.rows(i).href = rowHrefFn === null ? 
                    '' : rowHrefFn(this._rows_Current[i], this._columnRefs);
        }

        return this;
    }

    setOrderBy(columnName, reverse = false) {
        js0.args(arguments, 'string', [ 'boolean', js0.Default ]);

        this._info.orderBy.columnName = columnName
        this._info.orderBy.reverse = reverse;

        return this;
    }

    setRowsFilter(rowsFilterFn) {
        js0.args(arguments, [ 'function', js0.Null ]);

        this._rowsFilterFn = rowsFilterFn;

        return this;
    }

    setSelectable(selectable) {
        js0.args(arguments, 'boolean');

        this._selectable = selectable;
        this.l.$fields.table.selectable = selectable;

        return this;
    }

    setSelectable_SelectedOnTop(selectedOnTop) {
        js0.args(arguments, 'boolean');

        this._selectable_SelectedOnTop = selectedOnTop;

        return this;
    }

    setSelectable_ShowSelectAll(showSelectAll) {
        js0.args(arguments, 'boolean');

        this._selectable_ShowSelectAll = showSelectAll;
        this.l.$fields.table.selectable_ShowSelectAll = this._selectable && 
                showSelectAll;

        return this;
    }

    setShowSearch(showSearch) {
        this.l.$fields.table.showSearch = showSearch;

        return this;
    }
    setSortable(sortable) {
        this._sortable = sortable;

        return this;
    }

    setTitle(title) {
        js0.args(arguments, [ 'string', js0.Null ]);

        this.l.$fields.Title = title;

        return this;
    }

    update(tableData = js0.NotSet) {
        this.msgs.showLoading('', this._info.showInstantLoading);

        if (tableData === js0.NotSet) {
            tableData = [];
            for (let row of this._rows) {
                let tableData_Col = [];
                for (let col of row.cols)
                    tableData_Col.push(col.value);
                tableData.push(tableData_Col);
            }
        }

        let rows = this._parseResultRows(tableData);

        if (this._noSort) {
            this._info.orderBy.columnName = null;
            this._rows = rows;
        } else
            this._rows = this._rows_Sort(rows);

        this._rows_Current = this._rows_Filter(this._rows);
        this._rows_Update_Async(this._rows_Current)
            .then(() => {
                this.msgs.hideLoading();
            })
            .catch((e) => {
                console.error(e);

                this.msgs.showMessage_Failure(spkTables.text('Error'), 
                        e.toString());
                this.msgs.hideLoading();
            });
    }


    _createElems() {
        this._createElems_ColumnButtons();
        this._createElems_Filter();
        this._createElems_Header();
        this._createElems_LoadMore();
        this._createElems_Rows();
        this._createElems_Selectable();
        this._createElems_ColumnLayouts();
    }

    _createElems_ColumnButtons() {
        this.l.$elems.columnButton((elem, keys) => {
            elem.addEventListener('click', (evt) => {
                evt.stopPropagation();
                evt.preventDefault();

                let row = this._rows_Current[keys[0]];
                let col = row.cols[keys[1]];

                if (this._listeners_OnColumnButtonClick !== null) {
                    this._listeners_OnColumnButtonClick(row, col, 
                        keys[0], keys[1], this.columnRefs);
                }
            });
        });
    }

    _createElems_Filter() {
        let updateFilter = (evt) => {
            let filterValue = this.l.$elems.filter.value;
            if (this._listeners_OnSearch !== null)
                filterValue = this._listeners_OnSearch(filterValue);

            this._filter.value = filterValue;

            /* Cancel timeout if filter changed. */
            if (this._filter.timeoutId !== null) {
                this.msgs.hideLoading();
                clearTimeout(this._filter.timeoutId);
            }

            this._filter.timeoutId = setTimeout(() => {
                this.msgs.showLoading('', this._info.showInstantLoading);

                if (this._filter.current === this._filter.value) {
                    this.msgs.hideLoading();
                    return;
                }

                this._limit.current = this._limit.start;

                this._filter.current = this._filter.value;

                if (this._dynamic)
                    this._rows_Refresh(false);
                else {
                    this._rows_Current = this._rows_Filter(this._rows);
                    this._rows_Update_Async(this._rows_Current)
                        .then(() => {
                            this._filter.timeoutId = null;
                            this.msgs.hideLoading();
                        })
                        .catch((e) => {
                            console.error(e);

                            this.msgs.showMessage_Failure(
                                    spkTables.text('Error'), e.toString());
                            this.msgs.hideLoading();
                            console.error(e);
                        });
                }
            }, 300);
        };

        this.l.$elems.filter.addEventListener('change', updateFilter);
        this.l.$elems.filter.addEventListener('keyup', updateFilter);
        this.l.$elems.filter.addEventListener('keydown', (evt) => {
            if (evt.keyCode === 13)
                evt.preventDefault();
        });
    }

    _createElems_Header() {
        this.l.$elems.header((elem, keys) => {
            elem.addEventListener('click', (evt) => {
                evt.preventDefault();

                if (!this._sortable)
                    return;


                let columnName = this._columnNames[keys[0]];
                if (this._info.orderBy.columnName === columnName)
                    this._info.orderBy.reverse = !this._info.orderBy.reverse
                else {
                    this._info.orderBy.columnName = columnName
                    this._info.orderBy.reverse = false;
                }

                this._limit.current = this._limit.start;

                if (this._dynamic)
                    this._rows_Refresh(false);
                else {
                    this._rows = this._rows_Sort(this._rows);
                    this._rows_Current = this._rows_Filter(this._rows);

                    this.msgs.showLoading('', this._info.showInstantLoading);
                    this._rows_Update_Async(this._rows_Current)
                        .then(() => {
                            this.msgs.hideLoading();
                        })
                        .catch((e) => {
                            console.error(e);

                            this.msgs.showMessage_Failure(
                                    spkTables.text('Error'), e.toString());
                            this.msgs.hideLoading();
                        });
                }
            });
        })
    }

    _createElems_ColumnLayouts() {
        this.l.$holders.colLayout((holder, keys) => {
            let row = this._rows_Current[keys[0]];
            let col = row.cols[keys[1]];

            if (col.layout !== null) {
                holder.$view = col.layout;
            }
        });
    }

    _createElems_LoadMore() {
        this.l.$elems.loadMore.addEventListener('click', (evt) => {
            evt.preventDefault();

            this._limit.current += this._limit.step;

            if (this._dynamic)
                this._rows_Refresh(true, false);
            else {
                this.msgs.showLoading('', this._info.showInstantLoading);
                this._rows_Update_Async(this._rows_Current, false)
                    .then(() => {
                        this.msgs.hideLoading();
                    })
                    .catch((e) => {
                        console.error(e);

                        this.msgs.showMessage_Failure(spkTables.text('Error'), 
                                e.toString());
                        this.msgs.hideLoading();
                    });

            }
        });
    }

    _createElems_Rows() {
        this.l.$elems.row((elem, keys) => {
            elem.addEventListener('click', (evt) => {
                if (this._listeners_OnClick === null)
                    return;

                evt.preventDefault();

                this._listeners_OnClick(this._rows_Current[keys[0]], 
                        this.columnRefs, keys[0]);
            })
        });
    }

    _createElems_Selectable() {
        let selectAll = (val) => {
            if (!this._selectable_ShowSelectAll)
                return;

            this.l.$elems.selectable_TableCheckbox.checked = val;

            for (let i = 0; i < this.l.$fields.table.rows().$size; i++) {
                this._rows_Current[i].selected = val;
                this.l.$fields.table.rows(i).selected = val;
            }
        }

        this.l.$elems.selectable_TableCheckbox.addEventListener('click', (evt) => {
            evt.stopPropagation();

            selectAll(evt.target.checked);
        });

        this.l.$elems.selectable_TableCheckboxHolder.addEventListener('click', (evt) => {
            evt.preventDefault();
            evt.stopPropagation();

            selectAll(!this.l.$elems.selectable_TableCheckbox.checked);            
        });

        this.l.$elems.selectable_RowCheckboxHolder((elem, keys) => {
            elem.addEventListener('click', (evt) => {
                evt.preventDefault();
                evt.stopPropagation();

                let val = !this.l.$fields.table.rows(keys[0]).selected;

                let row = this._rows_Current[keys[0]];

                row.selected = val;
                this.l.$fields.table.rows(keys[0]).selected = val;
                        
                if (!val)
                    this.l.$elems.selectable_TableCheckbox.checked = false;

                if (this._listeners_OnRowSelected)
                    this._listeners_OnRowSelected(row, this.columnRefs, keys[0]);
            });
        });
    }

    _createFields() {
        this.l.$fields.table.selectable_ShowSelectAll = this._selectable_ShowSelectAll;
        this.l.$fields.table.trClass = '';
        this.l.$fields.text = (text) => {
            return spkTables.text(text);
        }
    }

    _getCustomFilterInfos() {
        let filterInfos = {};
        for (var filterName in this._fns_CustomFilterFns)
            filterInfos[filterName] = this._fns_CustomFilterFns[filterName]();

        return filterInfos;
    }

    _getFields(update = false) {
        /* Fields */
        let fields = {};

        let tableArgs = this.getTableArgs();
        if (this._dynamic) {
            tableArgs.table.offset = update ? this._rows_Current.length : 0;
            tableArgs.table.limit = this._limit.current - (update ? this._rows_Current.length : 0);
        }

        fields.tableInfo = {
            columns: this._info.columns,
            orderBy: this._info.orderBy,
        };
        fields.tableArgs = tableArgs;

        if (this._fns_ApiFields !== null) {
            let apiFields = this._fns_ApiFields();
            for (let fieldName in apiFields)
                fields[fieldName] = apiFields[fieldName];
        }

        return fields;
    }

    _parseInfo() {
        this._columnNames = this._info.columns.map((item) => { return item.name });
        this._columnRefs = {};
        for (let i = 0; i < this._columnNames.length; i++)
            this._columnRefs[this._columnNames[i]] = i;

        this._columnsOrder = [];
        for (let col of this._info.columns) {
            let orderByInfo = col.orderBy;
            if (orderByInfo === null)
                continue;

            this._columnsOrder.push({
                colRef: this._columnRefs[col.name],
                priority: orderByInfo.priority,
                reverse: orderByInfo.reverse,
            });
        }
        this._columnsOrder.sort((a, b) => {
            return b.priority - a.priority;
        });

        /* Table Fields */
        for (let col of this._info.columns) {
            this.l.$fields.table.headers().$push({
                title: col.header,
                show: !this._info.hiddenColumnNames.includes(col.name),
                caretDown: false,
                caretUp: false,
                class: col.class,
                style: col.style,
                textStyle: col.textStyle,
            });
        }
    }

    _parseResultRows(resultRows) {
        let rows = [];
        for (let i = 0; i < resultRows.length; i++) {
            let cols = [];
            for (let j = 0; j < resultRows[i].length; j++) {
                cols.push({
                    class: '',
                    show: !this._info.hiddenColumnNames.includes(this._columnNames[j]),
                    value: resultRows[i][j],
                    html: resultRows[i][j],
                    button: {
                        show: false,
                        btnClass: '',
                        iClass: '',
                        text: '',
                    },
                    layout: null,
                });
            }

            let row = {
                href: null,
                class: '',
                cols: cols,
                style: this._listeners_OnClick === null ? '' : 'cursor: pointer;',
                selected: false,
            };

            row.href = this._fns_RowHref === null ? null : this._fns_RowHref(row, 
                    this._columnRefs);

            rows.push(row);
        }

        if (this._listeners_OnRefresh !== null)
            this._listeners_OnRefresh(rows, this._columnRefs);

        return rows;
    }

    _rows_Filter(rows) {
        if (this._rowsFilterFn !== null) {
            rows = this._rowsFilterFn(rows, this.columnRefs);
            if (!js0.type(rows, Array)) {
                throw new Error(`'RowsFilterFn' must return an array.`);
            }
        }

        if (this._dynamic)
            return rows;

        if (this._filter.value === '')
            return rows;

        let filterString = abStrings.escapeRegExpChars(
                this._rows_Filter_FormatString(this._filter.value));

        let regexp = new RegExp('.*' + filterString + '.*');

        let fRows = [];
        for (let i = 0; i < rows.length; i++) {
            if (this._selectable_SelectedOnTop) {
                if (rows[i].selected) {
                    fRows.push(rows[i]);
                    continue;
                }
            }

            for (let j = 0; j < rows[i].cols.length; j++) {
                if (!this._info.columns[j].filter)
                    continue;

                let colString = this._rows_Filter_FormatString(
                        String(rows[i].cols[j].value));

                if (colString.match(regexp)) {
                    fRows.push(rows[i]);
                    break;
                }
            }
        }

        return fRows;
    }

    _rows_Filter_FormatString(str) {
        return abStrings.escapeLangChars(str.toLowerCase());
    }

    _rows_Sort(rows) {
        if (this._dynamic)
            return rows;

        if (this._info.orderBy.columnName === null)
            return rows;

        if (!(this._info.orderBy.columnName in this._columnRefs)) {
            throw new Error(`Order by column '${this._info.orderBy.columnName}'` +
                ` does not exist.`);
        }
        
        let columnIndex = this._columnRefs[this._info.orderBy.columnName];

        rows = rows.sort((a, b) => {
            let result = 0;
            if (this._selectable_SelectedOnTop) {
                if (a.selected && !b.selected)
                    result = -1;
                else if (!a.selected && b.selected)
                    result = 1;
            }
            if (result !== 0)
                return result;

            result = this._rows_Sort_Column(a, b, columnIndex,
                    this._info.orderBy.reverse);

            if (result !== 0)
                return result;

            for (let i = 0; i < this._columnsOrder.length; i++) {
                let orderBy = this._columnsOrder[i];

                if (orderBy.columnRef === columnIndex)
                    continue;

                result = this._rows_Sort_Column(a, b, orderBy.colRef, orderBy.reverse);

                if (result !== 0)
                    return result;
            }

            return 0;
        });

        if (this._listeners_OnSort !== null)
            this._listeners_OnSort(rows, this._columnRefs);

        return rows;
    }

    _rows_Sort_Column(a, b, column_index, reverse) {
        let a_value = a.cols[column_index].value;
        let b_value = b.cols[column_index].value;

        if (a_value === null)
            return b_value === null ? 0 : (!reverse ? -1 : 1);
        if (b_value === null)
            return (!reverse ? 1 : -1);

        /* BigInt */
        if (typeof(a_value) === 'bigint' || typeof(b_value) === 'bigint') {
            if (b_value > a_value)
                return -1;
            if (a_value > a_value)
                return 1;

            return 0;
        }

        /* Number */
        if (!isNaN(parseFloat(a_value)) && isFinite(a_value) &&
                !isNaN(parseFloat(b_value)) && isFinite(b_value)) {
            if (reverse)
                return b_value - a_value;
            else
                return a_value - b_value;
        }

        /* Boolean */
        if (typeof a_value === 'boolean' && typeof b_value === 'boolean') {
            if (a_value === b_value)
                return 0;

            if (reverse)
                return a_value ? 1 : -1;
            else
                return a_value ? -1 : 1;
        }

        /* String / Other */
        a_value = a_value + '';
        b_value = b_value + '';

        if (reverse)
            return -a_value.localeCompare(b_value);
        else
            return a_value.localeCompare(b_value);
    }

    _rows_Update_Async(rows, clear = true) {
        return new Promise((resolve, reject) => {
            /* Header */
            let orderBy_ColumnIndex = this._columnRefs[this._info.orderBy.columnName];
            for (let i = 0; i < this.l.$fields.table.headers().$size; i++) {
                if (i !== orderBy_ColumnIndex) {
                    this.l.$fields.table.headers(i).caretDown = false;
                    this.l.$fields.table.headers(i).caretUp = false;
                } else {
                    this.l.$fields.table.headers(i).caretDown = !this._info.orderBy.reverse;
                    this.l.$fields.table.headers(i).caretUp = this._info.orderBy.reverse;
                }
            }

            // if (clearAll)
            //     this.l.$fields.table.rows = [];
            /* / Header */

            /* Rows */
            let tRows;
            if (this._dynamic)
                tRows = rows;
            else
                tRows = rows.slice(0, this._limit.current);

            this.l.$fields.table = {
                // rows: tRows,
                isEmpty: rows.length === 0,
                showLoadMore: this._dynamic ? 
                    (tRows.length >= this._limit.current) :
                    (this._rows_Current.length > this._limit.current),
                colsLength: tRows.length === 0 ? 0 : tRows[0].cols.length,
                loading: true,
            };

            this._rows_UpdateFields(tRows, clear);

            resolve();
            
            // rows = rows.slice(0, 150);

            // let m1 = js0.TimeSpan.MarkStart('Test', 'A');
            // let rowI = 0;
            // for (let i = 0; i < tRows.length; i += 1) {
            //     setTimeout(() => {
            //         this.l.$fields.table.rows().$push(tRows[rowI]);
            //         rowI++;

            //         if (rowI >= tRows.length) {
            //             m1.end();
            //             console.log(js0.TimeSpan.GetInstance('Test').getDiffs());
            //             resolve();
            //         }

            //         // ts.markStart('Test ' + rowI);
            //         // this.l.$fields.table.rows().$add(rowI, rows[rowI]);
            //         // rowI++;
            //         // ts.markEnd('Test ' + rowI);

            //         // if (rowI === rows.length) {
            //         //     console.log(ts.getDiffs());
            //         //     console.log(js0.TimeSpan.GetInstance('ListField').getDiffs());
                        
            //         //     resolve();
            //         // }
            //     }, 0);
            // }
        });
    }

    _rows_UpdateFields(rows, clear = true) {
        if (clear)
            this.l.$fields.table.rows = [];

        let startFrom = clear ? 0 : this._rows_Fields.length;

        this._rows_Fields = this._rows_UpdateFields_ParseRows(rows);
        this._rows_Fields_Index++;

        let rowFieldsIndex = this._rows_Fields_Index;
        let rowI = startFrom;

        let updateRows = () => {
            if (this._rows_Fields_Index > rowFieldsIndex)
                return;

            // this.l.$fields.table.rows().$push(this._rows_Fields[rowI]);

            for (let i = 0; i < 10 && rowI < this._rows_Fields.length; i++) {
                this.l.$fields.table.rows().$push(this._rows_Fields[rowI]);
                rowI++;
            }

            // rowI++;
            if (rowI >= this._rows_Fields.length) {
                this.l.$fields.table.loading = false;
                return;
            }

            setTimeout(() => {
                updateRows();
            }, 100);
        };

        /* Remove 'clear' check and change 'this.l.$fields.table.rows = ' to 
         * $pushArr when it will exist. */
        if (clear) {
            rowI = Math.min(this._rows_Fields.length, 50);
            let rows_Fields_Part = this._rows_Fields.slice(0, rowI);
            this.l.$fields.table.rows = rows_Fields_Part;
        }

        // for (let i = 0; i < Math.min(this._rows_Fields.length, 50); i++) {
        //     this.l.$fields.table.rows().$push(this._rows_Fields[rowI]);
        //     rowI++;
        // }

        if (rowI >= this._rows_Fields.length) {
            this.l.$fields.table.loading = false;
            return;
        } else {
            setTimeout(() => {
                updateRows();
            }, 100);
        }
    }

    _rows_UpdateFields_ParseRow(row) {
        let fCols = [];
        for (let col of row.cols) {
            fCols.push({
                class: col.class,
                show: col.show,
                value: col.value,
                html: col.html,
                button: {
                    btnClass: col.button.btnClass,
                    iClass: col.button.iClass,
                    show: col.button.show,
                    text: col.button.text,
                },
                hasLayout: col.layout !== null,
            });
        }

        return {
            href: row.href,
            class: row.class,
            cols: fCols,
            style: row.style,
            selected: row.selected,
        };
    }

    _rows_UpdateFields_ParseRows(rows) {
        let fRows = [];
        for (let row of rows)
            fRows.push(this._rows_UpdateFields_ParseRow(row));

        return fRows;
    }

    _rows_Refresh(update = false, clearAll = true) {
        this._rows_RefreshQueueCount++;
        update = this._dynamic ? update : false;

        let fields = this._getFields(update);

        this.msgs.showLoading('', this._info.showInstantLoading);

        // setTimeout(() => {
        if (this._info.fn !== null) {
            this._info.fn(fields)
                .then((result) => {
                    this._rows_RefreshQueueCount--;
                    if (this._rows_RefreshQueueCount > 0)
                        return;

                    if (result.error === null) {
                        this._rows_Refresh_Process_Async(update, clearAll, result.data, fields)
                            .then(() => {
                                this.msgs.hideLoading();
                            })
                            .catch((e) => {
                                console.error(e);

                                this.msgs.showMessage_Failure(
                                        spkTables.text('Error'), e.toString());
                                this.msgs.hideLoading();
                            });
                    } else {
                        this.msgs.showMessage_Failure(spkTables.text('Error'),
                                result.error);
                        this.msgs.hideLoading();
                    }
                })
                .catch((e) => {
                    console.error(e);

                    this.msgs.hideLoading();
                    this.msgs.showMessage_Failure(spkTables.text('Error'),
                            e.toString());
                });
        } else if (this._info.apiUri !== null) {
            webABApi.json(this._info.apiUri, fields, (result) => {
                this._rows_RefreshQueueCount--;
                if (this._rows_RefreshQueueCount > 0)
                    return;

                if (result.isSuccess()) {
                    this._rows_Refresh_Process_Async(update, clearAll, result.data, fields)
                        .then(() => {
                            this.msgs.hideLoading();
                        })
                        .catch((e) => {
                            console.error(e);

                            this.msgs.showMessage_Failure(
                                    spkTables.text('Error'), 
                                    e.toString());
                            this.msgs.hideLoading();
                        });
                } else {
                    // this.rows_Update(this.rows);
    
                    this.msgs.showMessage_Failure(spkTables.text('Error'),
                            result.data.message);
                }
    
                // this.$layout.$elems.each('select', function(elem) {
                //     elem.checked = false;
                // });
    
                this.msgs.hideLoading();
            });
        } else
            throw new Error('No data source set.');
        // }, 5000);
    }

    async _rows_Refresh_Process_Async(update, clearAll, data, apiFields) {
        if (!('table' in data)) {
            console.error('Table refresh result:', data);
            throw new Error('No `table` in data.');
        }

        if (this._listeners_OnApiResult !== null)
            this._listeners_OnApiResult(data, apiFields);

        let rows_ApiResult = this._parseResultRows(data.table);
            
        if (update) {
            this._rows = this._rows.concat(rows_ApiResult);                    
            this._rows_Current = this._rows;
        } else {
            if (this._noSort) {
                this._info.orderBy.columnName = null;
                this._rows = rows_ApiResult;
            } else
                this._rows = this._rows_Sort(rows_ApiResult);

            this._rows_Current = this._rows_Filter(this._rows);
        }

        return await this._rows_Update_Async(this._rows_Current, clearAll);
    }

}

Table.NotSet = Symbol('spkTables_NotSet');

module.exports = Table;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\spk-tables\$layouts\Table.js
jsLibs.exportModule('spk-tables', '$layouts/Table', (require, module, exports) => { 'use strict';

const
    js0 = require('js0'),
    spocky = require('spocky')
;

class Table extends spocky.Layout {

    static get Content() {
        return [["h3",{"_show":["Title"]},"$Title"],["$",{"_holder":["beforeSearch"]}],["div",{"_show":["table.showSearch"],"class":["search"]},["div",{"class":["row g-2"]},["div",{"class":["col"]},["form",{},["div",{"class":["input-group"]},["div",{"class":["input-group-text"]},["i",{"class":["fa fa-search"]}]],["input",{"_elem":["filter"],"placeholder":["$text('Search_Placeholder')"],"type":["text"],"class":["form-control"]}]]]],["div",{"class":["col-auto"]},["$",{"_holder":["afterSearch"]}]]]],["$",{"_holder":["beforeTable"]}],["$",{"_holder":["beforeTable2"]}],["$",{"_holder":["beforeTable3"]}],["$",{"_holder":["beforeTable4"]}],["div",{"_show":["table.isEmpty"],"class":["table_empty pb-5"]},"$text('TableEmpty')"],["div",{"_hide":["table.isEmpty"],"class":["table-responsive"]},["table",{"class":["table"]},["thead",{},["tr",{"class":["header"]},["th",{"_elem":["selectable_TableCheckboxHolder"],"_show":["table.selectable"]},["input",{"_elem":["selectable_TableCheckbox"],"_show":["table.selectable_ShowSelectAll"],"type":["checkbox"]}]],["th",{"_repeat":["table.headers:header"],"_elem":["header"],"_show":["header.show"],"class":["text-nowrap ","$header.class"],"style":["$header.style"]},["a",{"href":[""]},["span",{"style":["$header.textStyle"],"_field":["header.title"]}]]," ",["i",{"_show":["header.caretDown"],"class":["fa fa-caret-down"]}],["i",{"_show":["header.caretUp"],"class":["fa fa-caret-up"]}]]]],["tbody",{},["tr",{"_repeat":["table.rows:row"],"_elem":["row"],"class":["$table.trClass"," ","$row.class"],"style":["$row.style"]},["td",{"_elem":["selectable_RowCheckboxHolder"],"_show":["table.selectable"]},["input",{"_show":["row.selected"],"type":["checkbox"],"checked":["true"]}],["input",{"_hide":["row.selected"],"type":["checkbox"]}]],["td",{"_repeat":["row.cols:col"],"_show":["col.show"],"class":["$col.class"],"style":["$col.style"]},["$",{"_show":["col.hasLayout"]},["$",{"_holder":["colLayout"]}]],["$",{"_hide":["col.hasLayout"]},["a",{"_show":["row.href"],"href":["$row.href"]},["span",{"_field":["col.html"]}]],["span",{"_hide":["row.href"],"_field":["col.html"]}],["$",{"_show":["col.button.show"]},["div",{"class":["$col.button.class"]},["a",{"_elem":["columnButton"],"href":["#"],"class":["btn ","$col.button.btnClass"," w-100"]},["i",{"class":["$col.button.iClass"]}],"$col.button.text"]]]]]],["tr",{"_show":["table.loading"],"class":["e-load-more"]},["td",{"colspan":["$table.colsLength"],"style":["text-align: center;"]},"$text('Loading')"]],["tr",{"_show":["table.showLoadMore"],"_hide":["table.loading"],"class":["e-load-more"]},["td",{"_elem":["loadMore"],"colspan":["$table.colsLength"],"class":["clickable"],"style":["text-align: center;"]},["a",{"href":["#"],"class":["btn btn-outline-secondary mt-3 w-100"]},"$text('LoadMore')","\r\n                         ",["i",{"class":["fa fa-caret-down"],"aria-hidden":["true"]}]]]]]]],["div",{"class":["clearfix"]}],["$",{"_holder":["afterTable"]}],["$",{"_holder":["afterTable2"]}],["$",{"_holder":["afterTable3"]}],["$",{"_holder":["afterTable4"]}]];
    }


    constructor(defaultFieldValues = {})
    {
        js0.args(arguments, [ js0.RawObject, js0.Default ]);

        super(Table.Content, defaultFieldValues);
    }

}


module.exports = Table;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\spk-tables\$layouts\index.js
jsLibs.exportModule('spk-tables', '$layouts/index', (require, module, exports) => { 'use strict';

const Table = require('./Table');






module.exports.Table = Table;
 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\spk-lemon-bee\index.js
jsLibs.exportModule('spk-lemon-bee', 'index', (require, module, exports) => { 'use strict';

const System = require('./System');





module.exports.System = System;
 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\spk-lemon-bee\System.js
jsLibs.exportModule('spk-lemon-bee', 'System', (require, module, exports) => { 'use strict';

const
    abPager = require('ab-pager'),
    js0 = require('js0'),
    spkMessages = require('spk-messages'),
    spocky = require('spocky'),

    $layouts = require('./$layouts'),
    modules = require('./modules')
;

class System
{

    get actions() {
        return this._actions;
    }

    get body() {
        return this._mBody;
    }

    get layouts() {
        return this._layouts;
    }

    get isLocked() {
        return this._locked;
    }

    get module() {
        if (!this._initialized)
            throw new Error('LemonBee system not initialized.');

        return this._module;
    }

    get panels() {
        if (!this._initialized)
            throw new Error('LemonBee system not initialized.');

        return this._panels;
    }

    get panels_Preset() {
        return js0.Iterable(js0.Preset({
            permissions: [ js0.Default([]), Array ],

            name: 'string',
            shortcut: [ 'boolean', js0.Default(true), ],
            
            menu: js0.Preset({
                shortcut: [ 'boolean', js0.Default(true), ],
                uri: [ 'boolean', js0.Null, js0.Default(null), ],
                action: [ 'function', js0.Null, js0.Default(null), ],
            }),

            alias: 'string',
            title: 'string',
            faIcon: [ 'string', js0.Null, js0.Default(null), ],
            image: [ 'string', js0.Null, js0.Default(null), ],
            
            subpanels: js0.Iterable(js0.Preset({
                name: 'string',
                moduleFn: [ 'function', js0.Null ],
                uri: [ 'string', js0.Null, js0.Default(null), ],

                permissions: [ js0.Default([]), Array ],

                alias: 'string',
                title: 'string',
                faIcon: [ js0.Default(null), 'string' ],
                image: [ js0.Default(null), 'string' ],    

                shortcut: [ js0.Default(true), 'boolean' ],
            })),
        }))
    }

    get setDefaultPageFn() {
        return this._setDefaultPageFn;
    }

    get uris() {
        if (!this._initialized)
            throw new Error('LemonBee system not initialized.');

        return this._uris;
    }

    get user() {
        if (!this._initialized)
            throw new Error('LemonBee system not initialized.');

        return this._user;
    }


    constructor(pager, msgs) {
        js0.args(arguments, abPager.Pager, spkMessages.Messages)

        this._initialized = false;
        this._locked = false;

        /* Presets */
        this._actions = null;
        this._aliases = null;
        this._dev = null;
        this._images = null;
        this._layouts = null;
        this._setDefaultPageFn = () => {
            this.pager.setPage('lb.main');
        };
        this._settings = null;
        this._shows = null;
        this._title = null;
        this._textFn = null;
        this._uris = null;
        /* / Presets */

        this._user = {
            loggedIn: false,
            permissions: [],
            login: '',
        };
        /* / Presets */

        this._panels = new Map();
        this._module = new spocky.Module();
        this._module_Layout = new spocky.Layout([
            [ 'div', { _holder: 'content', } ],
            [ 'div', { _holder: 'msgs', } ],
        ]);
        this._module.$view = this._module_Layout;
        
        this.pager = pager;
        this.msgs = msgs;

        this._mBody = null;

        this._listeners_AfterPage = [];
        this._listeners_BeforePage = [];
        this._listeners_OnBack = null;
    }

    addListener_AfterPage(listener) {
        js0.args(arguments, 'function');

        this._listeners_AfterPage.push(listener);
    }

    addListener_BeforePage(listener) {
        js0.args(arguments, 'function');

        this._listeners_BeforePage.push(listener);
    }

    call_OnBack() {
        if (this._locked)
            return true;

        if (this._listeners_OnBack === null)
            return false;

        if (js0.rtn('boolean', this._listeners_OnBack()))
            return true;

        return false;
    }

    clear() {
        this._mBody = null;
        // this.msgs.hide();
    }

    createLayout(layoutClass) {
        let l = new layoutClass();
        l.$fields.lb = this.getFields();

        return l;
    }

    getFields() {
        return {
            dev: this._dev,
            images: this._images,
            settings: this._settings,
            shows: this._shows,
            text: (text) => {
                return this.text(text);
            },
            uris: this._uris,
            user: this._user,
        };
    }

    getPanels() {
        let allowedPanels = [];
        for (let [ panelName, panel ] of this._panels) {
            let allowed = true;
            for (let permission of panel.permissions) {
                if (!this._user.permissions.includes(permission)) {
                    allowed = false;
                    break;
                }
            }

            if (!allowed)
                continue;
                
            allowedPanels.push(panel);
        }

        return allowedPanels;
    }

    lock() {
        this._locked = true;
    }

    logOut() {
        this.msgs.showLoading();
        this.actions.logOut_Async()
            .then((result) => {
                if (!result.success) {
                    this.msgs.showMessage_Failure(result.error);
                    this.msgs.hideLoading();

                    return;
                }

                this.setUser({
                    loggedIn: false,
                    login: '',
                    permissions: [],
                });

                this.msgs.hideLoading();

                this.pager.setPage('lb.logIn');
            })
            .catch((e) => {
                console.error(e.stack);
                this.msgs.showMessage_Failure(e.toString());
            });
    }

    setBackButton(hasBackButton) {
        js0.args(arguments, 'boolean');

        if (this._mBody === null)
            throw new Error('No active panel.');

        this._mBody.lMenu.$fields.HasBackButton = hasBackButton;
    }

    setListener_OnBack(listener) {
        js0.args(arguments, 'function');

        this._listeners_OnBack = listener;
    }

    setPanels(panels) {
        js0.args(arguments, this.panels_Preset);

        this._panels.clear();

        for (let panel of panels)
            this._addPanel(panel);

        this.setup_Pager();
    }

    setUser(user) {
        js0.args(arguments, js0.RawObject);
        js0.typeE(user, js0.Preset({
            loggedIn: 'boolean',                
            login: 'string',
            permissions: Array,
        }));

        this._user = user;
    }

    setup(presets) {
        js0.args(arguments, js0.RawObject);
        js0.typeE(presets, js0.Preset({
            actions: js0.Preset({
                changePassword_Async: 'function',
                logIn_Async: 'function',
                logOut_Async: 'function',
                remindPassword_Async: [ 'function', js0.Null, js0.Default(null) ],
                resetPassword_Async: [ 'function', js0.Null, js0.Default(null) ],
            }),
            aliases: js0.Preset({
                account: [ 'string', js0.Default('account') ],
                main: [ 'string', js0.Default('') ],
                logIn: [ 'string', js0.Default('log-in') ],
                remindPassword: [ 'string', js0.Default('remind-password') ],
                resetPassword: [ 'string', js0.Default('reset-password') ],
            }),
            dev: [ js0.Preset({
                email: [ 'string', js0.Default('') ],
                login: [ 'string', js0.Default('') ],
                password: [ 'string', js0.Default('') ],
            }), js0.Default({}), ],
            setDefaultPageFn: [ 'function', js0.Null, js0.Default(null) ],
            images: js0.Preset({
                logo: [ 'string', js0.Null, js0.Default(null), ],
                logo_Main: [ 'string', js0.Null, js0.Default(null), ],
            }),
            layouts: [ js0.Preset({
                'Account': [ 'function', js0.Default($layouts.Account), ],
                'Body': [ 'function', js0.Default($layouts.Body), ],
                'LogIn': [ 'function', js0.Default($layouts.LogIn), ],
                'LogIn_Form': [ 'function', 
                        js0.Default($layouts.LogIn_Form), ],
                'Main': [ 'function', js0.Default($layouts.Main), ],
                'RemindPassword': [ 'function', 
                        js0.Default($layouts.RemindPassword), ],
                'ResetPassword': [ 'function', 
                        js0.Default($layouts.ResetPassword), ],
                'TopMenu': [ 'function', js0.Default($layouts.TopMenu), ],
                'UserInfo': [ 'function', js0.Default($layouts.UserInfo), ],
            }), js0.Default({}), ],  
            panels: this.panels_Preset,
            shows: [ js0.Preset({
                home: [ 'boolean', js0.Default(true), ],
                userInfo: [ 'boolean', js0.Default(true), ],
            }), js0.Default({}) ],
            textFn: 'function',
            title: [ 'string', js0.Default('LemonBee') ],
            uris: js0.Preset({
                base: [ 'string', js0.Default('') ],
                package: [ 'string', js0.Null, js0.Default(null) ],
                // api: [ 'string' ],
            }),
            
            settings: [ js0.Preset({
                hasRemindPassword: [ js0.Default(true), 'boolean' ],
            }), js0.Default({}) ],
        }));

        this._actions = presets.actions;
        this._aliases = presets.aliases;
        this._dev = presets.dev;
        this._images = presets.images;
        this._layouts = presets.layouts;
        this._settings = presets.settings;
        this._shows = presets.shows;
        this._textFn = presets.textFn;
        this._title = presets.title;
        this._uris = presets.uris;

        if (presets.setDefaultPageFn !== null)
            this._setDefaultPageFn = presets.setDefaultPageFn;

        if (this._images.logo === null)
            this._images.logo = `${this._uris.package}images/logo.png`;
        if (this._images.logo_Main === null)
            this._images.logo_Main = `${this._uris.package}images/logo_main.png`;
        for (let messageType in this._images.messages) {
            if (this._images.messages[messageType] === null) {
                let ext = messageType === 'loading' ? 'gif' : 'png';
                this._images.messages[messageType] = `${this._uris.package}images/messages/${messageType}.${ext}`;
            }
        }

        this._uris.base = this.pager.base + this._uris.base;
        if (this._uris.package === null)
            this._uris.package = this._uris.base + 'dev/node_modules/spk-lemon-bee/';
        this._uris.logOut = this._uris.base;

        this.setPanels(presets.panels);

        // this.msgs = spkMessages;
        
        // this._module_Layout.$holders.msgs.$view = this.msgs;
    }

    setup_Pager() {
        this.pager.page('lb.main', this._aliases.main, 
                (page, source, pageArgs) => {
            for (let listener of this._listeners_BeforePage)
                listener(page, source, pageArgs);

            this.clear();
            this._setBodyModule(new modules.Body(this));
            this._setPanelModule(new modules.Main(this), this._title);

            for (let listener of this._listeners_AfterPage)
                listener(page, source, pageArgs);
        });
        this._uris.main = this.pager.getPageUri('lb.main');

        this.pager.page('lb.logIn', this._aliases.logIn, 
                (page, source, pageArgs) => {
            for (let listener of this._listeners_BeforePage)
                listener(page, source, pageArgs);

            this.clear();

            if (this._user.loggedIn) {               
                // this.pager.setPage('lb.main');
                this._setDefaultPageFn();
                return;
            }

            this._module_Layout.$holders.content.$view = new modules.LogIn(this);
            document.title = this._title + ' - ' + this.text('Titles_LogIn');

            for (let listener of this._listeners_AfterPage)
                listener(page, source, pageArgs);
        });

        this.pager.page('lb.remindPassword', this._aliases.remindPassword, 
                (page, source, pageArgs) => {
            for (let listener of this._listeners_BeforePage)
                listener(page, source, pageArgs);

            this.clear();

            if (this._user.loggedIn) {               
                // this.pager.setPage('lb.main');
                this._setDefaultPageFn();
                return;
            }

            this._module_Layout.$holders.content.$view = 
                    new modules.RemindPassword(this);
            document.title = this._title + ' - ' + 
                    this.text('Titles_RemindPassword');

            for (let listener of this._listeners_AfterPage)
                listener(page, source, pageArgs);
        });
        this._uris.remindPassword = this.pager.getPageUri('lb.remindPassword');

        this.pager.page('lb.resetPassword', this._aliases.resetPassword + 
                '/:resetPasswordHash', (page, source, pageArgs) => {
            for (let listener of this._listeners_BeforePage)
                listener(page, source, pageArgs);

            this.clear();

            if (this._user.loggedIn) {               
                // this.pager.setPage('lb.main');
                this._setDefaultPageFn();
                return;
            }

            this._module_Layout.$holders.content.$view = 
                    new modules.ResetPassword(this);
            document.title = this._title + ' - ' + 
                    this.text('Titles_ResetPassword');

            for (let listener of this._listeners_AfterPage)
                listener(page, source, pageArgs);
        });
        
        this.pager.page('lb.account', this._aliases.account, 
                (page, source, pageArgs) => {
            for (let listener of this._listeners_BeforePage)
                listener(page, source, pageArgs);

            this.clear();
            this._setBodyModule(new modules.Body(this));
            this._setPanelModule(new modules.Account(this), this._title + ' - ' +
                    this.text('Titles_Account'));

            for (let listener of this._listeners_AfterPage)
                listener(page, source, pageArgs);
        });
        this._uris.account = this.pager.getPageUri('lb.account');

        for (let [ panelName, panel ] of this._panels) {
            if (panel.subpanels.size === 0)
                continue;

            this.pager.page(`lb.panels.${panel.name}`, panel.alias, 
                    (page, source, pageArgs) => {

                for (let listener of this._listeners_BeforePage)
                    listener(page, source, pageArgs);

                if (panel.subpanels.size === 0)
                    throw new Error(`No subpanels in panel '${panelName}'.`);

                let defaultSubpanel = panel.subpanels.values().next().value;

                this.clear();
                this.pager.setPage(
                        `lb.subpanels.${panel.name}.${defaultSubpanel.name}`, 
                        {}, {}, false);
                // window.location = `${this._uris.base}${panel.alias}/${defaultSubpanel.alias}`;

                // No AfterPage listeners if redirected.
                // for (let listener of this._listeners_AfterPage)
                //     listener(page, source, pageArgs);
            });

            for (let [ subpanelName, subpanel ] of panel.subpanels) {
                if (subpanel.module === null)
                    continue;

                this.pager.page(`lb.subpanels.${panel.name}.${subpanel.name}`, 
                        `${panel.alias}/${subpanel.alias}`, 
                        (page, source, pageArgs) => {
                    for (let listener of this._listeners_BeforePage)
                        listener(page, source, pageArgs);

                    this.clear();

                    this._setBodyModule(new modules.Body(this));
                    let module = subpanel.moduleFn(this, page, source, pageArgs);
                    if (!js0.type(module, spocky.Module)) {
                        throw new Error(`'moduleFn' of subpanel ` + 
                                `'${panel.name}.${subpanel.name}' does not return spocky.Module`);
                    }

                    this._setPanelModule(module, panel.title + ' - ' +
                            subpanel.title);

                    for (let listener of this._listeners_AfterPage)
                        listener(page, source, pageArgs);
                });
            }
        }
    }

    init() {
        this.pager.setListener_OnBeforePopState((uri) => {
            if (this._locked) {
                window.location = uri;
                return false;
            }

            return true;
        });

        window.onbeforeunload = (evt) => {
            if (this._locked)
                return true;

            return null;
        };

        this._initialized = true;
    }

    text(text) {
        return this._textFn(text);
    }

    unlock() {
        this._locked = false;
    }


    _addPanel(panel) {
        let pPanel = {};
        for (let pKey in panel) {
            if (pKey === 'subpanels') {
                pPanel.subpanels = new Map();
                for (let subpanel of panel.subpanels) {
                    let pSubpanel = {};
                    for (let sKey in subpanel)
                        pSubpanel[sKey] = subpanel[sKey];

                    if (panel.shortcut && subpanel.shortcut) {
                        if (pSubpanel.uri === null)
                            pSubpanel.uri = this.pager.parseUri(`${panel.alias}/${subpanel.alias}`);
                    } else
                        pSubpanel.uri = null;

                    pPanel.subpanels.set(subpanel.name, pSubpanel);
                }
            } else if (pKey === 'alias')
                pPanel[pKey] = panel[pKey];
            else
                pPanel[pKey] = panel[pKey];
        }
        pPanel.uri = this.pager.parseUri(panel.alias);

        this._panels.set(panel.name, pPanel);
    }

    _setBodyModule(module) {
        this._mBody = module;
    }

    _setPanelModule(module, title = null) {
        if (this._mBody === null)
            throw new Error('Body module not set.');

        if (!this._user.loggedIn) {
            this.pager.setPage('lb.logIn', {}, {}, false);
            // window.location = this._uris.base + this._aliases.logIn;
            return;
        }

        this._mBody.setContent(module);

        document.title = title === null ? this._title : title;

        this._module_Layout.$holders.content.$view = this._mBody;
    }

}

module.exports = System;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\spk-lemon-bee\modules\Account.js
jsLibs.exportModule('spk-lemon-bee', 'modules/Account', (require, module, exports) => { 'use strict';

const
    js0 = require('js0'),
    spkForms = require('spk-forms'),
    spocky = require('spocky'),
    webABApi = require('web-ab-api')
;

class Account extends spocky.Module
{

    constructor(system) { super();
        js0.args(arguments, require('../System'));

        this.system = system;

        this.l = system.createLayout(system.layouts.Account);        
        this.f = new spkForms.Form(this.l, 'ChangePassword');        

        this.l.$elems.BackButton.addEventListener('click', (evt) => {
            evt.preventDefault();
            system.pager.setPage('lb.main');
        });
        this.l.$fields.Uris.Main = system.pager.getPageUri('lb.main');
        this.l.$elems.changePassword.addEventListener('click', (evt) => {
            evt.preventDefault();
            this.changePassword();
        });

        system.msgs.hideLoading();

        this.$view = this.l;
    }

    checkNewPassword() {
        let fields = this.f.getValues();

        if (fields.NewPassword === '') {
            this.f.setValidator({
                valid: false,
                fields: {
                    NewPassword: {
                        valid: false,
                        errors: [ this.system.text('Errors_PasswordCannotBeEmpty') ],
                    },
                },
                state: '',
                errors: [],
            });
            return false;
        }

        if (fields.NewPassword !== fields.NewPassword_Confirmation) {
            this.f.setValidator({
                valid: false,
                fields: {
                    NewPassword_Confirmation: {
                        valid: false,
                        errors: [ this.system.text('Errors_PasswordsDoNotMatch') ],
                    },
                },
                state: '',
                errors: [],
            });
            return false;
        }

        return true;
    }

    changePassword() {
        this.message_Clear();

        if (!this.checkNewPassword())
            return;

        this.system.msgs.showLoading();
        let fValues = this.f.getValues();
        this.system.actions.changePassword_Async(fValues.Password, fValues.NewPassword)
            .then((result) => {
                if (result.success) {
                    this.message_SetSuccess(result.message);
                    this.f.setValues({
                        Password: '',
                        NewPassword: '',
                        NewPassword_Confirmation: '',
                    });
                } else
                    this.message_SetError(result.message);

                this.system.msgs.hideLoading();
            })
            .catch((e) => {
                console.error(e);
            });
    }

    message_Clear() {
        this.l.$fields.message = null;
        this.l.$fields.messageType = 'dark';
    }

    message_SetError(message) {
        this.l.$fields.message = message;
        this.l.$fields.messageType = 'danger';
    }

    message_SetSuccess(message) {
        this.l.$fields.message = message;
        this.l.$fields.messageType = 'success';
    }

}

module.exports = Account;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\spk-lemon-bee\modules\Body.js
jsLibs.exportModule('spk-lemon-bee', 'modules/Body', (require, module, exports) => { 'use strict';

const
    js0 = require('js0'),
    spocky = require('spocky'),
    webABApi = require('web-ab-api')
;

class Body extends spocky.Module
{

    constructor(system) { super();
        js0.args(arguments, require('../System'));

        this.lb = system;

        let l = system.createLayout(this.lb.layouts.Body);
        this.lMenu = this._getMenuLayout();
        this.lUserInfo = this._getUserInfoLayout();

        l.$elems.backToTop.addEventListener('click', (evt) => {
            evt.preventDefault();
            $("html, body").animate({ scrollTop: 0 }, "fast");
        });

        this.lUserInfo.$elems.logOut.addEventListener('click', (evt) => {
            evt.preventDefault();
            system.logOut();
        });

        l.$holders.topMenu.$view = this.lMenu;
        l.$holders.userInfo.$view = this.lUserInfo;

        this.layout = l;

        this.$view = l;
    }

    setContent(content) {
        js0.args(arguments, [ spocky.Layout, spocky.Module ]);

        this.layout.$holders.content.$view = content;
    }


    _getMenuLayout() {
        let l = this.lb.createLayout(this.lb.layouts.TopMenu);

        l.$fields.hasBackButton = false;

        let panels = this.lb.getPanels();

        l.$elems.menuItem_Home.addEventListener('click', (evt) => {
            evt.preventDefault();
            if (this.lb.isLocked)
                return;
            this.lb.pager.setPage('lb.main');
        });
        l.$elems.menuItems_Panel((elem, keys) => {
            elem.addEventListener('click', (evt) => {
                evt.preventDefault();

                let panel = panels[keys[0]];
                if (panel.menu.action !== null) {
                    $(l.$elems.Menu).collapse('hide');
                    panel.menu.action();
                } else {
                    if (this.lb.isLocked)
                        return;
                    this.lb.pager.setUri(l.$fields.menuItems(keys[0]).uri);
                }
            });
        });
        l.$elems.BackButton.addEventListener('click', (evt) => {
            evt.preventDefault();
            this.lb.call_OnBack();
        });

        let items = new Map();
        for (let i = 0; i < panels.length; i++) {
            let panel = panels[i];
            if (!panel.menu.shortcut)
                continue;

            items.set(i, {
                uri: panel.menu.uri === null ?
                        `${this.lb.uris.base}${panel.alias}/` :
                        panel.menu.uri,
                title: panel.title,
                faIcon: panel.faIcon,
                image: panel.image,
            });
        }
        l.$fields.menuItems = items;

        /* User Info */
        l.$elems.LogOut.addEventListener('click', (evt) => {
            evt.preventDefault();
            this.lb.logOut();
        });

        return l;
    }

    _getUserInfoLayout() {
        let l = this.lb.createLayout(this.lb.layouts.UserInfo);

        l.$fields.lb = this.lb.getFields();

        return l;
    }

}

module.exports = Body;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\spk-lemon-bee\modules\LogIn.js
jsLibs.exportModule('spk-lemon-bee', 'modules/LogIn', (require, module, exports) => { 'use strict';

const
    abApi = require('web-ab-api'),
    js0 = require('js0'),
    spocky = require('spocky')
;

class LogIn extends spocky.Module
{

    constructor(system) { super();
        js0.args(arguments, require('../System'));

        this.lb = system;

        this.l = system.createLayout(this.lb.layouts.LogIn);
        this.lForm = system.createLayout(this.lb.layouts.LogIn_Form);

        this.lForm.$elems.Form.addEventListener('submit', (evt) => {
            evt.preventDefault();
            this.logIn();
        });
        this.lForm.$elems.Login.addEventListener('change', (evt) => {
            this.clearError();
        });
        this.lForm.$elems.Password.addEventListener('change', (evt) => {
            this.clearError();
        });

        this.lForm.$elems.RemindPassword.addEventListener('click', (evt) => {
            evt.preventDefault();
            this.lb.pager.setPage('lb.remindPassword');
        });

        this.l.$holders.form.$view = this.lForm;

        system.msgs.hideLoading();

        this.$view = this.l;
    }

    clearError() {
        this.lForm.$fields.error = {
            show: false,
            message: ''
        };
    }

    logIn() {
        this.lb.msgs.showLoading();

        this.lb.actions.logIn_Async(this.lForm.$elems.Login.value,
                this.lForm.$elems.Password.value)
            .then((result) => {
                js0.typeE(result, js0.Preset({
                    user: [ js0.RawObject, js0.Null, js0.Default(null) ],
                    error: [ 'string', js0.Null, js0.Default(null) ],
                    reload: [ 'boolean', js0.Default(false) ],
                }));

                let user = {
                    loggedIn: false,
                    login: '',
                    permissions: [],
                };
                if (result.user !== null) 
                    user = result.user;
                // if (result.error !== null) {
                //     this.lb.msgs.showMessage_Failure(result.error);
                //     return;
                // }

                if (user.loggedIn) {
                    this.lForm.$fields.error = {
                        show: false,
                        message: '',
                    };

                    if (result.reload) {
                        window.location.reload();
                        return;
                    } else {
                        this.lb.setUser(result.user);
                        this.lb.setDefaultPageFn();
                    }
                } else {
                    this.lForm.$fields.error = {
                        show: true,
                        message: result.error,
                    };
                }

                this.lb.msgs.hideLoading();
            })
            .catch((e) => {
                console.error(e.stack);
                this.lb.msgs.showMessage_Failure(this.lb.text('Errors_CannotLogIn'), 
                        e.toString());
                this.lb.msgs.hideLoading();
            });

        // abApi.json(`${this.lb.uris.api}log-in`, {
        //     Login: this.lForm.$elems.login.value,
        //     Password: this.lForm.$elems.password.value,
        //         }, (result) => {
        //     if (result.isSuccess())
        //         window.location = this.lb.uris.base;
        //     else if (result.isFailure()) {
        //         this.lForm.$fields.error = {
        //             show: true,
        //             message: this.lb.text('errors_LogInFailed'),
        //         };
        //         this.lb.msgs.hideLoading();
        //     } else {
        //         this.lForm.$fields.error = {
        //             show: true,
        //             message: this.lb.text('errors_LogInError'),
        //         };
        //         this.lb.msgs.hideLoading();
        //     }
        // });
    }

}

module.exports = LogIn;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\spk-lemon-bee\modules\Main.js
jsLibs.exportModule('spk-lemon-bee', 'modules/Main', (require, module, exports) => { 'use strict';

const
    js0 = require('js0'),
    spocky = require('spocky')
;

class Main extends spocky.Module 
{

    constructor(system)  { super();
        js0.args(arguments, require('../System'));

        this.panels = system.getPanels();

        let l = system.createLayout(system.layouts.Main);        
        l.$fields.panels = this.panels;

        l.$elems.Buttons_Panel((elem, keys) => {
            elem.addEventListener('click', (evt) => {
                evt.preventDefault();
                system.pager.setUri(this.panels[keys[0]].uri);
            });
        });

        l.$elems.Buttons_Subpanel((elem, keys) => {
            elem.addEventListener('click', (evt) => {
                evt.preventDefault();
                system.pager.setUri(this.panels[keys[0]].subpanels.get(keys[1]).uri);
            });
        });

        system.msgs.hideLoading();

        this.$view = l;
    }

}

module.exports = Main;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\spk-lemon-bee\modules\index.js
jsLibs.exportModule('spk-lemon-bee', 'modules/index', (require, module, exports) => { 'use strict';


const Account = require('./Account');
const Body = require('./Body');
const LogIn = require('./LogIn');
const Main = require('./Main');
const Panel = require('./Panel');
const RemindPassword = require('./RemindPassword');
const ResetPassword = require('./ResetPassword');






module.exports.Account = Account;
module.exports.Body = Body;
module.exports.LogIn = LogIn;
module.exports.Main = Main;
module.exports.Panel = Panel;
module.exports.RemindPassword = RemindPassword;
module.exports.ResetPassword = ResetPassword;
 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\spk-lemon-bee\modules\RemindPassword.js
jsLibs.exportModule('spk-lemon-bee', 'modules/RemindPassword', (require, module, exports) => { 'use strict';

const
    abApi = require('web-ab-api'),
    js0 = require('js0'),
    spocky = require('spocky')
;

class RemindPassword extends spocky.Module
{

    constructor(system) { super();
        js0.args(arguments, require('../System'));

        this.lb = system;

        this.l = system.createLayout(this.lb.layouts.RemindPassword);
        
        this.l.$elems.Form.addEventListener('submit', (evt) => {
            evt.preventDefault();
            this.remindPassword();
        });

        system.msgs.hideLoading();

        this.$view = this.l;
    }

    clearError() {
        this.lForm.$fields.error = {
            show: false,
            message: ''
        };
    }

    remindPassword() {
        this.lb.msgs.showLoading();

        this.lb.actions.remindPassword_Async(this.l.$elems.Login.value)
            .then((result) => {
                if (result.success) {
                    this.l.$fields.messageType = 'success';
                    this.l.$fields.message = result.message;

                    this.l.$elems.Login.value = '';
                } else {
                    this.l.$fields.messageType = 'danger';
                    this.l.$fields.message = result.message;
                }

                this.lb.msgs.hideLoading();
            })
            .catch((e) => {
                console.error(e.stack);
                this.lb.msgs.showMessage_Failure(e.toString());
            });
    }

}

module.exports = RemindPassword;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\spk-lemon-bee\modules\Panel.js
jsLibs.exportModule('spk-lemon-bee', 'modules/Panel', (require, module, exports) => { 'use strict';

const
    spocky = require('spocky')
;

class Panel extends spocky.Module
{

    constructor(system, panel) { super();
        js0.args(arguments, require('../System'), 'object');

        let l = system.createLayout(system.layouts.Panel);
        l.$fields.panel = panel;

        this.$view = l;
    }

}

module.exports = Panel;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\spk-lemon-bee\modules\ResetPassword.js
jsLibs.exportModule('spk-lemon-bee', 'modules/ResetPassword', (require, module, exports) => { 'use strict';

const
    abApi = require('web-ab-api'),
    js0 = require('js0'),
    spocky = require('spocky')
;

class ResetPassword extends spocky.Module
{

    constructor(system) { super();
        js0.args(arguments, require('../System'));

        this.lb = system;

        this.l = system.createLayout(this.lb.layouts.ResetPassword);
        
        this.l.$elems.Form.addEventListener('submit', (evt) => {
            evt.preventDefault();
            this.resetPassword();
        });

        this.l.$elems.NewPassword.addEventListener('input', (evt) => {
            this.clearError();
        });
        this.l.$elems.NewPassword_Confirmation.addEventListener('input', 
                (evt) => {
            this.clearError();
        });

        system.msgs.hideLoading();

        this.$view = this.l;
    }

    clearError() {
        this.l.$fields.messageType = 'primary';
        this.l.$fields.message = null;
    }

    resetPassword() {
        if (this.l.$elems.NewPassword.value === '') {
            this.l.$fields.messageType = 'danger';
            this.l.$fields.message = this.lb.text('Errors_PasswordCannotBeEmpty');

            return false;
        }

        if (this.l.$elems.NewPassword.value !== 
                this.l.$elems.NewPassword_Confirmation.value) {
            this.l.$fields.messageType = 'danger';
            this.l.$fields.message = this.lb.text('Errors_PasswordsDoNotMatch');

            return false;
        }

        let resetPasswordHash = this.lb.pager.current.args.resetPasswordHash;
        let newPassword = this.l.$elems.NewPassword.value;

        this.lb.msgs.showLoading();

        this.lb.actions.resetPassword_Async(resetPasswordHash, newPassword)
            .then((result) => {
                if (result.success) {
                    this.l.$fields.messageType = 'success';
                    this.l.$fields.message = result.message;

                    this.l.$elems.NewPassword.value = '';
                    this.l.$elems.NewPassword_Confirmation.value = '';

                    setTimeout(() => {
                        this.lb.pager.setPage('lb.logIn');
                    }, 3000);
                } else {
                    this.l.$fields.messageType = 'danger';
                    this.l.$fields.message = result.message;
                }

                this.lb.msgs.hideLoading();
            })
            .catch((e) => {
                console.error(e.stack);
                this.lb.msgs.showMessage_Failure(e.toString());
            });
    }

}

module.exports = ResetPassword;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\spk-lemon-bee\$layouts\Account.js
jsLibs.exportModule('spk-lemon-bee', '$layouts/Account', (require, module, exports) => { 'use strict';

const
    js0 = require('js0'),
    spocky = require('spocky')
;

class Account extends spocky.Layout {

    static get Content() {
        return [["div",{"class":["row"]},["div",{"class":["col"]},["h2",{},["a",{"_elem":["BackButton"],"href":["$Uris.Main"],"class":["btn btn-theme-light me-2"]},["i",{"class":["fa fa-chevron-left"]}]],"$lb.text('Titles_Account')"]]],["div",{"class":["card"]},["div",{"class":["card-body"]},["form",{},["div",{"class":["mb-2"]},["spk-form-field",{"form":["ChangePassword"],"name":["Password"],"type":["Input"],"input-type":["password"],"label":["$lb.text('Labels_Password')"],"placeholder":["$lb.text('Labels_Password')","..."]}]],["div",{"class":["mb-2"]},["spk-form-field",{"form":["ChangePassword"],"name":["NewPassword"],"type":["Input"],"input-type":["password"],"label":["$lb.text('Labels_NewPassword')"],"placeholder":["$lb.text('Labels_NewPassword')","..."]}]],["div",{"class":["mb-2"]},["spk-form-field",{"form":["ChangePassword"],"name":["NewPassword_Confirmation"],"type":["Input"],"input-type":["password"],"placeholder":["$lb.text('Labels_NewPassword_Confirmation')","..."]}]],["div",{"class":["mb-2"]},["div",{"_show":["message"],"class":["alert alert-","$messageType"]},"$message"]],["button",{"type":["submit"],"_elem":["changePassword"],"href":[""],"class":["btn btn-theme-primary w-100"]},"$lb.text('Buttons_Save')"]]]]];
    }


    constructor(defaultFieldValues = {})
    {
        js0.args(arguments, [ js0.RawObject, js0.Default ]);

        super(Account.Content, defaultFieldValues);
    }

}


module.exports = Account;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\spk-lemon-bee\$layouts\Body.js
jsLibs.exportModule('spk-lemon-bee', '$layouts/Body', (require, module, exports) => { 'use strict';

const
    js0 = require('js0'),
    spocky = require('spocky')
;

class Body extends spocky.Layout {

    static get Content() {
        return [["div",{"class":["container-fluid min-vh-100"]},["div",{"class":["row"]},["div",{"class":["col-md-3 col-lg-2 lb-menu-holder"]},["$",{"_holder":["topMenu"]}]],["div",{"class":["offset-md-3 offset-lg-2 col-md-9 col-lg-10 min-vh-100 lb-content-holder"]},["div",{"class":["lb-top-bar"]},["$",{"_holder":["userInfo"]}]],["div",{"class":["lb-main-holder"]},["$",{"_holder":["content"]}],["div",{"class":["back-to-top"]},["a",{"_elem":["backToTop"],"class":["spScrollToTop btn btn-theme-light"],"href":[""]},["i",{"class":["fa fa-chevron-up"]}]]]]]]]];
    }


    constructor(defaultFieldValues = {})
    {
        js0.args(arguments, [ js0.RawObject, js0.Default ]);

        super(Body.Content, defaultFieldValues);
    }

}


module.exports = Body;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\spk-lemon-bee\$layouts\LogIn_Form.js
jsLibs.exportModule('spk-lemon-bee', '$layouts/LogIn_Form', (require, module, exports) => { 'use strict';

const
    js0 = require('js0'),
    spocky = require('spocky')
;

class LogIn_Form extends spocky.Layout {

    static get Content() {
        return [["div",{"class":["lb-login-info"]},["form",{"_elem":["Form"],"method":["post"],"role":["form"],"name":["form"],"id":["form"]},["input",{"_elem":["Login"],"placeholder":["$lb.text('LogIn_Login_Placeholder')"],"value":["$lb.dev.login"],"type":["text"],"required":[""],"class":["form-control"]}],["input",{"_elem":["Password"],"placeholder":["$lb.text('LogIn_Password_Placeholder')"],"value":["$lb.dev.password"],"type":["password"],"required":[""],"class":["form-control"]}],["div",{"_show":["error.show"],"class":["alert alert-danger alert-narrow text-break"]},["p",{},"$error.message"]],["button",{"type":["submit"],"class":["btn btn-theme-primary w-100"]},"$lb.text('LogIn_LogIn')"],["a",{"_elem":["RemindPassword"],"_show":["lb.settings.hasRemindPassword"],"href":["$lb.uris.remindPassword"]},"$lb.text('RemindPassword')"]],["div",{"_holder":["notifications"]}]]];
    }


    constructor(defaultFieldValues = {})
    {
        js0.args(arguments, [ js0.RawObject, js0.Default ]);

        super(LogIn_Form.Content, defaultFieldValues);
    }

}


module.exports = LogIn_Form;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\spk-lemon-bee\$layouts\Main.js
jsLibs.exportModule('spk-lemon-bee', '$layouts/Main', (require, module, exports) => { 'use strict';

const
    js0 = require('js0'),
    spocky = require('spocky')
;

class Main extends spocky.Layout {

    static get Content() {
        return [["div",{"class":["lb-menu-tiles row"]},["div",{"_repeat":["panels:panel"],"_show":["panel.shortcut"],"class":["col-xxl-3 col-xl-4 col-sm-6 ","$class"]},["div",{"class":["card"]},["a",{"_elem":["Buttons_Panel"],"class":["btn btn-theme-primary lb-tile-main w-100"],"href":["${lb.uris.base}","${panel.alias}","/"]},["$",{"_show":["panel.image"]},["img",{"src":["$panel.image"],"alt":["$panel.title"]}]],["div",{"class":[""]},"$panel.title"]],["div",{"class":["card-body"]},["div",{"class":["row g-2"]},["div",{"_repeat":["panel.subpanels:subpanel"],"_show":["subpanel.shortcut"],"class":["col"]},["a",{"_elem":["Buttons_Subpanel"],"href":["$subpanel.uri"],"class":["btn btn-theme-light w-100"]},["i",{"class":["fa ","$subpanel.faIcon"," pe-2"]}],"$subpanel.title"]]]]]]]];
    }


    constructor(defaultFieldValues = {})
    {
        js0.args(arguments, [ js0.RawObject, js0.Default ]);

        super(Main.Content, defaultFieldValues);
    }

}


module.exports = Main;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\spk-lemon-bee\$layouts\RemindPassword.js
jsLibs.exportModule('spk-lemon-bee', '$layouts/RemindPassword', (require, module, exports) => { 'use strict';

const
    js0 = require('js0'),
    spocky = require('spocky')
;

class RemindPassword extends spocky.Layout {

    static get Content() {
        return [["div",{"class":["lb-bg-holder fill lb-background-login"]}],["div",{"class":["lb-login-holder"]},["div",{"class":["col-xl-4 col-sm-8 lb-login"]},["div",{"class":["lb-login-content"]},["div",{"class":["lb-login-logo"]},["img",{"src":["${lb.images.logo}"]}]],["div",{"class":["lb-login-form"]},["div",{"class":["login-info"]},["form",{"_elem":["Form"],"method":["POST"],"role":["form"],"name":["Form"]},["input",{"_elem":["Login"],"placeholder":["$lb.text('RemindPassword_RemindPassword_Placeholder')"],"value":["$lb.dev.email"],"type":["text"],"required":[""],"class":["form-control mb-3"]}],["div",{"_show":["message"],"class":["mb-2"]},["div",{"class":["alert alert-","$messageType"]},"$message"]],["button",{"type":["submit"],"class":["btn btn-theme-primary w-100"]},"$lb.text('RemindPassword_RemindPassword')"]],["div",{"_holder":["notifications"]}]]]],["div",{"class":["lb-povered-by"]},"Powered by  ",["a",{"href":["https://allblue.pl"]},"AllBlue"]]]]];
    }


    constructor(defaultFieldValues = {})
    {
        js0.args(arguments, [ js0.RawObject, js0.Default ]);

        super(RemindPassword.Content, defaultFieldValues);
    }

}


module.exports = RemindPassword;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\spk-lemon-bee\$layouts\LogIn.js
jsLibs.exportModule('spk-lemon-bee', '$layouts/LogIn', (require, module, exports) => { 'use strict';

const
    js0 = require('js0'),
    spocky = require('spocky')
;

class LogIn extends spocky.Layout {

    static get Content() {
        return [["div",{"class":["lb-bg-holder fill lb-background-login"]}],["div",{"class":["lb-login-holder"]},["div",{"class":["col-xl-4 col-sm-8 lb-login"]},["div",{"class":["lb-login-content"]},["div",{"class":["lb-login-logo"]},["img",{"src":["${lb.images.logo}"]}]],["div",{"class":["lb-login-form"]},["$",{"_holder":["form"]}]]],["div",{"class":["lb-povered-by"]},"Powered by  ",["a",{"href":["https://allblue.pl"]},"AllBlue"]]]]];
    }


    constructor(defaultFieldValues = {})
    {
        js0.args(arguments, [ js0.RawObject, js0.Default ]);

        super(LogIn.Content, defaultFieldValues);
    }

}


module.exports = LogIn;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\spk-lemon-bee\$layouts\ResetPassword.js
jsLibs.exportModule('spk-lemon-bee', '$layouts/ResetPassword', (require, module, exports) => { 'use strict';

const
    js0 = require('js0'),
    spocky = require('spocky')
;

class ResetPassword extends spocky.Layout {

    static get Content() {
        return [["div",{"class":["lb-bg-holder fill lb-background-login"]}],["div",{"class":["lb-login-holder"]},["div",{"class":["col-xl-4 col-sm-8 lb-login"]},["div",{"class":["lb-login-content"]},["div",{"class":["lb-login-logo"]},["img",{"src":["${lb.images.logo}"]}]],["div",{"class":["lb-login-form"]},["div",{"class":["login-info"]},["form",{"_elem":["Form"],"method":["POST"],"role":["form"],"name":["Form"]},["input",{"_elem":["NewPassword"],"placeholder":["$lb.text('NewPassword_Placeholder')"],"value":["$lb.dev.password"],"type":["password"],"required":[""],"class":["form-control mb-3"]}],["input",{"_elem":["NewPassword_Confirmation"],"placeholder":["$lb.text('NewPassword_Confirmation_Placeholder')"],"value":["$lb.dev.password"],"type":["password"],"required":[""],"class":["form-control mb-3"]}],["div",{"_show":["message"],"class":["mb-2"]},["div",{"class":["alert alert-","$messageType"]},"$message"]],["button",{"type":["submit"],"_elem":["changePassword"],"href":[""],"class":["btn btn-theme-primary w-100"]},"$lb.text('Buttons_Save')"]],["div",{"_holder":["notifications"]}]]]],["div",{"class":["lb-povered-by"]},"Powered by  ",["a",{"href":["https://allblue.pl"]},"AllBlue"]]]]];
    }


    constructor(defaultFieldValues = {})
    {
        js0.args(arguments, [ js0.RawObject, js0.Default ]);

        super(ResetPassword.Content, defaultFieldValues);
    }

}


module.exports = ResetPassword;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\spk-lemon-bee\$layouts\UserInfo.js
jsLibs.exportModule('spk-lemon-bee', '$layouts/UserInfo', (require, module, exports) => { 'use strict';

const
    js0 = require('js0'),
    spocky = require('spocky')
;

class UserInfo extends spocky.Layout {

    static get Content() {
        return [["div",{"_show":["lb.shows.userInfo"],"class":["lb-user-info"]},["i",{"class":["fa fa-user pe-2"],"aria-hidden":["true"]}],["a",{"href":["$lb.uris.account"]},"$lb.user.login"],["a",{"_elem":["logOut"],"href":["$lb.uris.logOut"],"class":["btn btn-theme-light btn-sm ms-3"]},"$lb.text('UserInfo_LogOut')"]]];
    }


    constructor(defaultFieldValues = {})
    {
        js0.args(arguments, [ js0.RawObject, js0.Default ]);

        super(UserInfo.Content, defaultFieldValues);
    }

}


module.exports = UserInfo;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\spk-lemon-bee\$layouts\TopMenu.js
jsLibs.exportModule('spk-lemon-bee', '$layouts/TopMenu', (require, module, exports) => { 'use strict';

const
    js0 = require('js0'),
    spocky = require('spocky')
;

class TopMenu extends spocky.Layout {

    static get Content() {
        return [["div",{"class":["lb-logo"]},["a",{"href":["$lb.uris.base"]},["img",{"src":["$lb.images.logo_Main"],"alt":["logo"]}]]],["div",{"class":["lb-menu-main"]},["nav",{"class":["navbar navbar-expand-md navbar-light"]},["button",{"_show":["HasBackButton"],"_elem":["BackButton"],"class":["navbar-toggler lb-navbar-back"]},["i",{"class":["fas fa-arrow-left"]}," "]],["button",{"_hide":["HasBackButton"],"class":["navbar-toggler"],"type":["button"],"data-bs-toggle":["collapse"],"data-bs-target":["#collapsibleNavbar"]},["span",{"class":["navbar-toggler-icon"]}]],["div",{"_elem":["Menu"],"class":["collapse navbar-collapse"],"id":["collapsibleNavbar"]},["ul",{"class":["navbar-nav clearfix"]},["li",{"_show":["lb.shows.home"],"class":["nav-item"]},["a",{"_elem":["menuItem_Home"],"class":["nav-link"],"href":["$lb.uris.base"]},["i",{"class":["fa fa-home"],"aria-hidden":["true"]}]," \r\n                        ","$lb.text('Titles_Home')"]],["li",{"_repeat":["menuItems:item"],"class":["nav-item ","$item.activeClass"]},["a",{"_elem":["menuItems_Panel"],"class":["nav-link"],"href":["$item.uri"]},["$",{"_show":["item.faIcon"]},["i",{"class":["$item.faIcon"]}]," "],["$",{"_show":["item.image"]},["i",{"class":["$item.image"]}]," "],"$item.title"]]],["div",{"_show":["lb.shows.userInfo"],"class":["lb-user-info-sm d-md-none"]},["i",{"class":["fa fa-user pe-2"],"aria-hidden":["true"]}],["a",{"class":["w-100"],"href":["$lb.uris.account"]},"$lb.user.login"],["a",{"_elem":["LogOut"],"href":["$lb.uris.logOut"],"class":["btn btn-theme-light btn-sm w-100 mt-2"]},"$lb.text('UserInfo_LogOut')"]]]]]];
    }


    constructor(defaultFieldValues = {})
    {
        js0.args(arguments, [ js0.RawObject, js0.Default ]);

        super(TopMenu.Content, defaultFieldValues);
    }

}


module.exports = TopMenu;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\spk-lemon-bee\$layouts\index.js
jsLibs.exportModule('spk-lemon-bee', '$layouts/index', (require, module, exports) => { 'use strict';

const Account = require('./Account');
const Body = require('./Body');
const LogIn = require('./LogIn');
const LogIn_Form = require('./LogIn_Form');
const Main = require('./Main');
const RemindPassword = require('./RemindPassword');
const ResetPassword = require('./ResetPassword');
const TopMenu = require('./TopMenu');
const UserInfo = require('./UserInfo');






module.exports.Account = Account;
module.exports.Body = Body;
module.exports.LogIn = LogIn;
module.exports.LogIn_Form = LogIn_Form;
module.exports.Main = Main;
module.exports.RemindPassword = RemindPassword;
module.exports.ResetPassword = ResetPassword;
module.exports.TopMenu = TopMenu;
module.exports.UserInfo = UserInfo;
 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\spk-messages\index.js
jsLibs.exportModule('spk-messages', 'index', (require, module, exports) => { 'use strict';

const
    js0 = require('js0')
;

class spkMessages_Class
{

    get Messages() {
        return require('./Messages');
    }


    get debug() {
        return this._debug;
    }


    constructor() {
        this._debug = false;
        this._textFn = (text) => {
            return this._texts[text];
        };  
        this._texts = {
            Close: 'Close',
        };
    }

    setDebug(debug) {
        js0.args(arguments, 'boolean');

        this._debug = debug;
    }

    setTextFn(textFn) {
        js0.args(arguments, 'function');

        this._textFn = textFn;
    }

    text(text) {
        js0.args(arguments, 'string');

        return this._textFn(text);
    }

}
const spkMessages = new spkMessages_Class();



module.exports = spkMessages;


 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\spk-messages\Messages.js
jsLibs.exportModule('spk-messages', 'Messages', (require, module, exports) => { 'use strict';

const
    js0 = require('js0'),
    spocky = require('spocky'),

    spkMessages = require('.'),

    $layouts = require('./$layouts')
;

class Messages extends spocky.Module
{

    constructor(presets = {}, layout = null) { super();
        js0.args(arguments, [ js0.RawObject, js0.Default ], 
                [ spocky.Layout, js0.Null, js0.Default ]);
        js0.typeE(presets, js0.Preset({
            modulePath: [ 'string', js0.Default('/dev/node_modules/spk-messages/'), ],
            images: [ js0.Preset({
                loading: [ 'string', js0.NotSet, js0.Default(js0.NotSet), ],
                success: [ 'string', js0.NotSet, js0.Default(js0.NotSet), ],
                failure: [ 'string', js0.NotSet, js0.Default(js0.NotSet), ],
            }), js0.Default({}) ],
        }));

        if (presets.images.loading === js0.NotSet)
            presets.images.loading = null;
        if (presets.images.success === js0.NotSet)
            presets.images.success = presets.modulePath + 'images/success.png';
        if (presets.images.failure === js0.NotSet)
            presets.images.failure = presets.modulePath + 'images/failure.png';

        this.loading_MinTime = 500;
        this.loading_Timeout = 500;

        this._loading = false;
        this._loading_Start = null;

        this._images = presets.images;

        this._msg = null;
        this._msg_Result_ExtraButton = false;
        this._msg_Fn = null;

        this._confirmation = null;
        this._confirmation_Fn = null;
        this._confirmation_Result = null;

        this._l = layout === null ? new $layouts.Messages() : layout;

        this._l.$fields.Loading.Image = this._images.loading;
        this._l.$fields.Text = (text) => {
            return spkMessages.text(text);
        }

        this._createElems();

        this.hide();

        this.$view = this._l;
    }

    getImageUri_Failure() {
        return this._images.success;
    }

    getImageUri_Success() {
        return this._images.failure;
    }

    hide() {
        this.hideConfirmation();
        this.hideLoading();
        this.hideMessage();
    }

    hideConfirmation() {
        this._l.$fields.Confirmation = {
            Image: null,
            Title: '',
            Text: '',
            Yes: '',
            No: '',
        };

        if (this._confirmation_Fn !== null) {
            let fn = this._confirmation_Fn;;
            this._confirmation_Fn = null;

            let result = this._confirmation_Result;
            this._confirmation_Result = false;
            fn(result);

            return;
        }

        this._confirmation_Fn = null;
        this._confirmation_Result = false;
    }

    hideLoading() {
        this._loading = false;

        // console.log('Hide', new Error());

        let loadingTimeLeft = 1;
        if (this._loading_Start !== null) {
            loadingTimeLeft = Math.max(this.loading_MinTime - 
                ((new Date()).getTime() - this._loading_Start), 1);
        }

        setTimeout(() => {
            if (this._loading)
                return;

            this._loading_Start = null;
            this._l.$fields.Loading = {
                Show: false,
                Text: '',
            };
        }, loadingTimeLeft);

    }

    hideMessage() {
        js0.args(arguments, [ 'boolean', js0.Default ]);

        this._l.$fields.Message = {
            Image: '',
            Title: '',
            Text: '',
            ExtraButton_Text: '',
            ExtraButton_Class: '',
        };

        if (this._msg_Result_ExtraButton) {
            if (this._msgs_ExtraButtonFn !== null) {
                let extraButtonFn = this._msgs_ExtraButtonFn;

                this._msg_Result_ExtraButton = false;
                this._msg_Fn = null;
                this._msgs_ExtraButtonFn = null;

                extraButtonFn();
                return;
            }
        } else if (this._msg_Fn !== null) {
            let msgFn = this._msg_Fn;

            this._msg_Result_ExtraButton = false;
            this._msg_Fn = null;
            this._msgs_ExtraButtonFn = null;

            msgFn();
            return;
        }

        this._msg_Result_ExtraButton = false;
        this._msg_Fn = null;
        this._msgs_ExtraButtonFn = null;
    }

    showConfirmation(title, text, yesText, noText, fn = null) {
        js0.args(arguments, 'string', 'string', 'string', 'string', 
                [ js0.Default, js0.Null, 'function' ])

        this._confirmation_Fn = fn;

        this._l.$fields.Confirmation = {
            Image: null,
            Title: title,
            Text: text,
            Yes: yesText,
            No: noText,
        };

        this._confirmation.show();
    }

    showConfirmationWithImage(image, title, text, yesText, noText, fn = null) {
        js0.args(arguments, [ 'string', js0.Null ], 'string', 'string', 'string', 'string', 
                [ js0.Default, js0.Null, 'function' ])

        this._confirmation_Fn = fn;

        this._l.$fields.Confirmation = {
            Image: image,
            Title: title,
            Text: text,
            Yes: yesText,
            No: noText,
        };

        this._confirmation.show();
    }

    async showConfirmation_Async(title, text, yesText, noText) {
        return await this.showConfirmationWithImage_Async(null, title, text, 
                yesText, noText);
    }

    async showConfirmationWithImage_Async(image, title, text, yesText, noText) {
        js0.args(arguments, [ 'string', js0.Null ], 'string', 'string', 'string', 'string');

        return new Promise((resolve) => {
            this.showConfirmationWithImage(image, title, text, yesText, noText, 
                    (result) => {
                resolve(result);
            });
        });
    }

    showLoading(text = '', instant = false) {
        js0.args(arguments, [ 'string', js0.Default ], [ 'boolean', js0.Default ]);

        // instant = true;

        // console.log('Show', new Error());

        this._loading = true;
        if (instant) {
            this._loading_Start = (new Date()).getTime();
            this._l.$fields.Loading = {
                Text: text,
                Show: true,
            };

            return;
        }

        let t0 = (new Date()).getTime();
        let checkShowLoading = () => {
            if (!this._loading)
                return;

            let t1 = (new Date()).getTime() - t0;
            if (t1 < this.loading_Timeout) {
                setTimeout(() => {
                    checkShowLoading();
                }, 50);
                return;
            }

            this._loading_Start = (new Date()).getTime();
            this._l.$fields.Loading = {
                Text: text,
                Show: true,
            };
        };
        setTimeout(() => {
            checkShowLoading();
        }, 50);
    }

    showMessage(imageSrc, title = '', text = '', fn = null, extraButtonText = null, 
                extraButtonClass = 'btn-secondary', extraButtonFn = null) {
        js0.args(arguments, 'string', [ 'string', js0.Default ], 
                [ 'string', js0.Default ], [ 'function', js0.Null, js0.Default ], 
                [ 'string', js0.Null, js0.Default ], [ 'string', js0.Default ], 
                [ 'function', js0.Null, js0.Default ]);

        if (spkMessages.debug)
            console.log('spkMessages.showMessage', new Error());

        this._msg_Fn = fn;
        this._enabled = false;

        this._msgs_ExtraButtonFn = extraButtonFn;

        this._l.$fields.Message = {
            Image: imageSrc,
            Title: title,
            Text: text,
            ExtraButton_Text: extraButtonText,
            ExtraButton_Class: extraButtonClass,
        };

        this._msg.show();
    }

    async showMessage_Async(imageSrc, title = '', text = '',
            extraButtonText = null, extraButtonClass = 'btn-secondary', 
            extraButtonFn = null) {
        js0.args(arguments, 'string', [ 'string', js0.Default ], 
            [ 'string', js0.Default, ], [ 'function', js0.Null ]);

        return new Promise((resolve) => {
            this.showMessage(imageSrc, title, text, () => {
                resolve();
            }, ExtraButton_Text, extraButtonClass, () => {
                extraButtonFn();
                resolve();
            });
        });
    }

    showMessage_Failure(title = '', text = '', fn = null) {
        js0.args(arguments, [ 'string', js0.Default, ], [ 'string', js0.Default, ], 
                [ 'function', js0.Null, js0.Default ]);

        this.showMessage(this._images.failure, title, text, fn);
    }

    showMessage_Failure_Async(title = '', text = '') {
        js0.args(arguments, [ 'string', js0.Default, ], 
                [ 'string', js0.Default, ]);

        return new Promise((resolve) => {
            this.showMessage_Failure(title, text, () => {
                resolve();
            });
        });
    }

    showMessage_Success(title = '', text = '', fn = null) {
        js0.args(arguments, [ 'string', js0.Default, ], [ 'string', js0.Default, ], 
                [ 'function', js0.Null, js0.Default ]);

        this.showMessage(this._images.success, title, text, fn);
    }

    showMessage_Success_Async(title = '', text = '') {
        js0.args(arguments, [ 'string', js0.Default, ], 
                [ 'string', js0.Default, ]);

        return new Promise((resolve) => {
            this.showMessage_Success(title, text, () => {
                resolve();
            });
        });
    }

    showNotification(message, faIcon = null) {
        this._l.$fields.Notification = {
            FaIcon: faIcon === null ? 'fa-info' : faIcon,
            Message: message,
        };

        $(this._l.$elems.Notification).fadeIn(() => {
            setTimeout(() => {
                $(this._l.$elems.Notification).fadeOut(() => {
                    this._l.$fields.Notification = {
                        FaIcon: '',
                        Message: '',
                    };
                });
            }, 1500);
        });
    }

    _createElems() {
        this._msg = new bootstrap.Modal(this._l.$elems.Message, {
            backdrop: 'static',
            keyboard: false,
        });
        this._l.$elems.Message.addEventListener('hidden.bs.modal', (e) => {
            this.hideMessage();
        });
        this._confirmation = new bootstrap.Modal(this._l.$elems.Confirmation, {
            backdrop: 'static',
            keyboard: false,
        });
        this._l.$elems.Confirmation.addEventListener('hidden.bs.modal', (e) => {
            this.hideConfirmation();
        });

        // this._l.$elems.msg.addEventListener('click', (evt) => {
        //     evt.preventDefault();
        //     this.hideMessage();
        // });

        this._l.$elems.Message.addEventListener('click', (evt) => {
            evt.preventDefault();

            if (evt.target !== this._l.$elems.Message)
                return;

            this.hideMessage();
        });

        this._l.$elems.Message_Close.addEventListener('click', (evt) => {
            evt.preventDefault();
            this._msg_Result_ExtraButton = false;
            this._msg.hide();
        });
        this._l.$elems.Message_Confirm.addEventListener('click', (evt) => {
            evt.preventDefault();
            this._msg_Result_ExtraButton = false;
            this._msg.hide();
        });
        this._l.$elems.Message_ExtraButton.addEventListener('click', (evt) => {
            evt.preventDefault();
            this._msg_Result_ExtraButton = true;
            this._msg.hide();
        });

        this._l.$elems.Confirmation_Close.addEventListener('click', (evt) => {
            evt.preventDefault();
            this._confirmation_Result = false;
            this._confirmation.hide();
        });
        
        this._l.$elems.Confirmation_Yes.addEventListener('click', (evt) => {
            evt.preventDefault();
            this._confirmation_Result = true;
            this._confirmation.hide();
        });

        this._l.$elems.Confirmation_No.addEventListener('click', (evt) => {
            evt.preventDefault();
            this._confirmation_Result = false;
            this._confirmation.hide();
        });
    }

}

module.exports = Messages;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\spk-messages\$layouts\index.js
jsLibs.exportModule('spk-messages', '$layouts/index', (require, module, exports) => { 'use strict';

const Messages = require('./Messages');






module.exports.Messages = Messages;
 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\spk-messages\$layouts\Messages.js
jsLibs.exportModule('spk-messages', '$layouts/Messages', (require, module, exports) => { 'use strict';

const
    js0 = require('js0'),
    spocky = require('spocky')
;

class Messages extends spocky.Layout {

    static get Content() {
        return [["div",{"_elem":["Message"],"class":["modal fade"],"tabindex":["-1"]},["div",{"class":["modal-dialog modal-choice modal-dialog-scrollable"]},["div",{"class":["modal-content"]},["div",{"class":["modal-header"]},["img",{"_show":["Message.Image"],"class":["modal-image"],"src":["$Message.Image"]}],["h5",{"_show":["Message.Title"],"class":["modal-title"]},"$Message.Title"],["button",{"_elem":["Message_Close"],"type":["button"],"class":["btn-close"],"aria-label":["Close"]}]],["div",{"_show":["Message.Text"],"class":["modal-body"]},["p",{},"$Message.Text"]],["div",{"class":["modal-footer"]},["div",{"class":["row"]},["div",{"_show":["Message.ExtraButton_Text"],"class":["col"]},["button",{"_elem":["Message_ExtraButton"],"type":["button"],"class":["btn ","$Message.ExtraButton_Class"," w-100 lh-sm"]},"$Message.ExtraButton_Text"]],["div",{"class":["col text-end"]},["button",{"_elem":["Message_Confirm"],"type":["button"],"class":["btn btn-primary w-100 h-100 "]},"$Text('Close')"]]]]]]],["div",{"_show":["Loading.Show"],"class":["loader-holder"]},["h3",{}],["div",{"class":["d-flex align-items-center"]},["div",{"class":["spinner-border me-3 text-primary"],"role":["status"],"aria-hidden":["true"]}],["strong",{},"$Loading.Text"]]],["div",{"_elem":["Confirmation"],"class":["modal fade"],"tabindex":["-1"]},["div",{"class":["modal-dialog modal-choice"]},["div",{"class":["modal-content"]},["div",{"class":["modal-header"]},["img",{"_show":["Confirmation.Image"],"class":["modal-image"],"src":["$Confirmation.Image"]}],["h5",{"_show":["Confirmation.Title"],"class":["modal-title"]},"$Confirmation.Title"],["button",{"_elem":["Confirmation_Close"],"type":["button"],"class":["btn-close"],"aria-label":["Close"]}]],["div",{"_show":["Confirmation.Text"],"class":["modal-body"]},["p",{},"$Confirmation.Text"]],["div",{"class":["modal-footer"]},["div",{"class":["row"]},["div",{"class":["col"]},["button",{"_elem":["Confirmation_Yes"],"type":["button"],"class":["btn btn-secondary w-100"]},["i",{"class":["fa fa-check pe-2"]}],"$Confirmation.Yes"]],["div",{"class":["col"]},["button",{"_elem":["Confirmation_No"],"type":["button"],"class":["btn btn-primary w-100"]},["i",{"class":["fa fa-times pe-2"]}],"$Confirmation.No"]]]]]]],["div",{"_elem":["Notification"],"class":["notification-holder"],"style":["display: none;"]},["div",{"class":["notification-bg bg-light"]},["i",{"class":["fas ","$Notification.FaIcon"]}],"  ","$Notification.Message"]]];
    }


    constructor(defaultFieldValues = {})
    {
        js0.args(arguments, [ js0.RawObject, js0.Default ]);

        super(Messages.Content, defaultFieldValues);
    }

}


module.exports = Messages;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\spk-forms\Ext.js
jsLibs.exportModule('spk-forms', 'Ext', (require, module, exports) => { 'use strict';

const
    abTextParser = require('ab-text-parser'),
    js0 = require('js0'),
    spocky = require('spocky'),

    $layouts = require('./$layouts'),
    spkForms = require('.');
;

class Ext extends spocky.Ext
{

    constructor()
    { super();
        spkForms.extInitialized = true;
    }

    onParseLayoutNode(layoutNode)
    {
        this._onParseLayoutNode_Field(layoutNode);
        this._onParseLayoutNode_Message(layoutNode);
    }


    _getFieldInfo(layoutNode)
    {
        let dataTypes = [ 'input-type', 'label', 'placeholder', 'label-class', 
                'field-class' ];
        let data = {};

        for (let attrName in layoutNode.attribs) {
            data[attrName] = layoutNode.attribs[attrName]
                .join('')
                .replace(/"/g, '\\"')
                .replace(/\$/g, '\\$')
                .replace(/\?/g, '\\?');
        }

        return JSON.stringify(data);
    }

    _getFieldLayoutContent(fieldName)
    {
        let layoutName = `${fieldName}Field`;

        if (layoutName === 'DateTimeField')
            layoutName = 'DateField';

        if (!(layoutName in $layouts))
            throw new Error(`Field type '${fieldName}' does not exist.`);

        return $layouts[layoutName].Content;
    }

    _onParseLayoutNode_Field(layoutNode)
    {
        if (layoutNode.type !== 'spk-form-field')
            return;

        if (!('form' in layoutNode.attribs))    
            throw new Error(`No 'form' set for 'spk-form-field'.`);
        if (!('name' in layoutNode.attribs))    
            throw new Error(`No 'name' set for 'spk-form-field'.`);
        if (!('type' in layoutNode.attribs))
            throw new Error(`No 'type' set for 'spk-form-field' '${layoutNode.attribs.name[0]}.`);

        let formName = layoutNode.attribs.form[0];
        let fullFormName = 'spkForms_' + layoutNode.attribs.form[0];
        let fieldName = layoutNode.attribs.name[0];
        let fullFieldName = `spkForms_${formName}_Fields_${fieldName}`;
        let fieldInfo = this._getFieldInfo(layoutNode);

        let layoutContent = this._getFieldLayoutContent(layoutNode.attribs.type[0]);

        let replaceArr = [
            [ '{{formName}}', formName ],
            [ '{{fullFormName}}', fullFormName ],
            [ '{{fieldName}}', fieldName ],
            [ '{{fullFieldName}}', fullFieldName ],
            [ '{{fieldInfo}}', fieldInfo ],

            [ '{{showLabel}}', 'show-label' in layoutNode.attribs 
                    ? layoutNode.attribs['show-label'].join('') : '?(true)' ],
            [ '{{fieldLabel}}', 'label' in layoutNode.attribs ? 
                    layoutNode.attribs.label.join('') : '\'\'' ],
            [ '{{fieldPlaceholder}}', 'placeholder' in layoutNode.attribs ? 
                    layoutNode.attribs.placeholder.join('') : '' ],

            [ '{{labelClass}}', 'label-class' in layoutNode.attribs ? 
                    layoutNode.attribs['label-class'].join('') : '' ],
            [ '{{fieldClass}}', 'field-class' in layoutNode.attribs ? 
                    layoutNode.attribs['field-class'].join('') : '' ],
            [ '{{divClass}}', 'div-class' in layoutNode.attribs ? 
                    layoutNode.attribs['div-class'].join('') : '' ],

            [ '{{fieldRows}}', 'rows' in layoutNode.attribs ? 
                    layoutNode.attribs.rows.join('') : '3' ],
        ];

        /* Special */
        if (layoutNode.attribs.type[0] === 'Input') {
            replaceArr.push(
                [ '{{inputType}}', 'input-type' in layoutNode.attribs ? 
                        layoutNode.attribs['input-type'].join('') : 'text' ]
            );
        }

        spocky.Layout.Replace(layoutContent, replaceArr);

        layoutNode.content = [];
        for (let newLayoutNode of layoutContent)
            layoutNode.content.push(newLayoutNode);
    }

    _onParseLayoutNode_Message(layoutNode)
    {
        if (layoutNode.type !== 'spk-form-message')
            return;

        let layoutContent = $layouts.Message.Content;

        if (!('form' in layoutNode.attribs)) {
            console.warn(`No 'form' attribute in '${layoutNode.type}'.`);
            return;
        }

        let formName = layoutNode.attribs.form[0];
        let fullFormName = `spkForms_${formName}`;

        let replaceArr = [
            [ '{{formName}}', formName ],
            [ '{{fullFormName}}', fullFormName ],
        ];
        spocky.Layout.Replace(layoutContent, replaceArr);

        layoutNode.content = [];
        for (let newLayoutNode of layoutContent)
            layoutNode.content.push(newLayoutNode);
    }

}

module.exports = Ext;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\spk-forms\Form.js
jsLibs.exportModule('spk-forms', 'Form', (require, module, exports) => { 'use strict';

const
    js0 = require('js0'),
    spocky = require('spocky'),

    spkForms = require('.'),
    Field = require('./Field')
;

class Form
{

    get fields() {
        return this._fields;
    }

    get l() {
        console.warn(`'l() is deprecated. Use layout() instead.'`, new Error());

        return this._layout;
    }

    get layout() {
        return this._layout;
    }


    constructor(layout, formName)
    {
        js0.args(arguments, spocky.Layout, 'string');

        if (!spkForms.extInitialized)
            throw new Error('Ext not initialized.');

        this._layout = layout;
        this.formName = formName;
        this.fullFormName = `spkForms_${formName}`;

        this._fields = {};

        if (!('spk-field' in layout.$data)) {
            if (spocky.Debug)
                console.warn('No spk-fields in layout.', new Error());
            return;
        }

        for (let field of layout.$data['spk-field']) {
            let separatorIndex = field.indexOf(':');
            
            let formName = field.substring(0, separatorIndex);
            if (formName !== this.formName)
                continue;

            let fieldInfo = JSON.parse(field.substring(separatorIndex + 1));

            for (let attrName in fieldInfo) {
                fieldInfo[attrName] = fieldInfo[attrName]
                    .replace(/\\"/g, '"')
                    .replace(/\\\$/g, '$');
            }

            this._fields[fieldInfo.name] = new Field(layout, fieldInfo);
        }
    }

    clear()
    {
        for (let fieldName in this._fields)
            this._fields[fieldName].clear();

        this.clearValidator();
        this.clearMessage();
    }

    clearMessage()
    {
        let messageFound = false;
        if ('spk-form-message' in this._layout.$data) {
            if (this._layout.$data['spk-form-message'].includes(this.formName))
                messageFound = true;
        }
        if (!messageFound)
            return;

        this._layout.$fields = {
            [`${this.fullFormName}_Message_Class`]: '',
            [`${this.fullFormName}_Message`]: '',
            [`${this.fullFormName}_Message_Show`]: false,
        };
    }

    clearValidator()
    {
        for (let fieldName in this._fields)
            this._fields[fieldName].clearValidator();
    }

    getField(fieldName)
    {
        if (!(fieldName in this._fields))
            throw new Error(`Field '${fieldName}' does not exist.`);

        return this._fields[fieldName];
    }

    getFiles()
    {
        let values = {};

        for (let fieldName in this._fields) {
            if (this._fields[fieldName].info.type === 'Message')
                continue;
            if (this._fields[fieldName].info.type === 'Text')
                continue;

            let value = this._fields[fieldName].value;
            if (!(value instanceof File))
                continue;

            values[fieldName] = this._fields[fieldName].value;
        }

        return values;
    }

    getValues()
    {
        let values = {};

        for (let fieldName in this._fields) {
            if (this._fields[fieldName].info.type === 'Message')
                continue;
            if (this._fields[fieldName].info.type === 'Text')
                continue;

            let value = this._fields[fieldName].value;
            if (value instanceof File)
                continue;

            values[fieldName] = this._fields[fieldName].value;
        }

        return values;
    }

    setDisabled(disabled)
    {
        js0.args(arguments, 'boolean');

        for (let fieldName in this._fields)
            this._fields[fieldName].setDisabled(disabled);
    }

    setMessage(message, messageClass)
    {
        js0.args(arguments, 'string', 'string');

        let messageFound = false;
        if ('spk-form-message' in this.l.$data) {
            if (this.l.$data['spk-form-message'].includes(this.formName))
                messageFound = true;
        }
        if (!messageFound)
            throw new Error(`Message not found in form '${this.formName}'.`);

        this.l.$fields = {
            [`${this.fullFormName}_Message_Class`]: messageClass,
            [`${this.fullFormName}_Message`]: message,
            [`${this.fullFormName}_Message_Show`]: true,
        };
    }

    setMessage_Error(message)
    {
        this.setMessage(message, 'alert-danger');
    }

    setMessage_Success(message)
    {
        this.setMessage(message, 'alert-success');
    }

    setValidator(validatorInfo)
    {
        this.clearMessage();
        this.clearValidator();

        for (let fieldName in validatorInfo.fields) {
            if (!(fieldName in this._fields)) {
                if (spkForms.debug)
                    console.warn(`Field '${fieldName}' does not exist in form.`)
                continue;
            }

            this._fields[fieldName].setValidator(validatorInfo.fields[fieldName]);
        }

        if (validatorInfo.errors.length > 0) {
            this.setMessage_Error(validatorInfo.errors.join(' '));
        }
    }

    setValues(values, ignoreNotExisting = false)
    {
        js0.args(arguments, 'object', [ 'boolean', js0.Default ]);

        for (let fieldName in values) {
            if (!(fieldName in this._fields)) {
                if (spkForms.debug && !ignoreNotExisting) {
                    console.warn(`Field '${fieldName}' does not exist. Cannot set value.`, 
                            new Error());
                }

                continue;
            }

            this._fields[fieldName].value = values[fieldName];
        }
    }

}

module.exports = Form;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\spk-forms\index.js
jsLibs.exportModule('spk-forms', 'index', (require, module, exports) => { 'use strict';

const
    js0 = require('js0'),
    spocky = require('spocky'),

    $layouts = require('./$layouts')
;

class spkForms_Class
{

    get Ext() {
        return require('./Ext');
    }

    get Field() {
        return require('./Field');
    }

    get Form() {
        return require('./Form');
    }


    get debug() {
        return this._debug;
    }

    get lang() {
        return this._lang;
    }

    constructor()
    {
        this.extInitialized = false;
    }

    setDebug(debug)
    {
        js0.args(arguments, 'boolean');

        this._debug = debug;
    }

    setLang(lang)
    {
        js0.args(arguments, 'string');

        this._lang = lang;
    }

}
const spkForms = new spkForms_Class();



module.exports = spkForms;


 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\spk-forms\Field.js
jsLibs.exportModule('spk-forms', 'Field', (require, module, exports) => { 'use strict';

const
    abDate = require('ab-date'),
    js0 = require('js0'),

    spkForms = require('.')
;


class Field
{

    get elem() {
        js0.assert(`${this._fullName}_Field` in this._layout.$elems, 
                `Cannot find 'elem' in field layout.`);

        return this._layout.$elems[`${this._fullName}_Field`];
    }

    get fullName() {
        return this._fullName;
    }

    get info() {
        return this._info;
    }

    get value() {
        let type = this._info.type;

        /* Date Time */
        if (type === 'Checkbox') {
            return this.elem.checked ? true : false;
        } else if (type === 'Date') {
            let value = this.elem.value;

            return value === '' ? null : abDate.strToTime_Date_UTC(value);
        } else if (type === 'DateTime') {
            let value = this.elem.value;

            return value === '' ? null : abDate.strToTime_DateTime_UTC(value);
        } else if (type === 'Message') {
            throw new Error('Value of Message Field is not gettable.');
        } else if (type === 'Time') {
            let value = this.elem.value;

            return value === '' ? null : abDate.strToTime_Time_UTC(value);
        } else if (type === 'File') {
            let file = this.elem.files[0];
            return typeof file === 'undefined' ? null : file;
        } else if (type === 'Text')
            return null;
        else if (type === 'Radio') {
            let options = this._layout.$elems.$getAll(`${this._fullName}_Field`);

            for (let i = 0; i < options.length; i++) {
                if (options[i].checked)
                    return options[i].getAttribute('value');
            }

            return '';
        } else if (type === 'SelectMultiple') {
            let values = [];

            let options = this.elem.options;
            for (let i = 0; i < options.length; i++) {
                if (options[i].selected) {
                    values.push(options[i].value);
                }
            }

            return values;
        } else if (type === 'Input' && 
                this._info['input-type'].toLowerCase() === 'checkbox') {
            return this.elem.checked ? true : false;
        }

        return this.elem.value;
    }
    set value(value) {
        if (this._info.type === 'Checkbox') {
            this.elem.checked = value ? true : false;
            let event = new Event('change', { bubbles: true, cancelable: true });
            this.elem.dispatchEvent(event);
        } else if (this._info.type === 'Date' || this._info.type === 'DateTime' ||
                this._info.type === 'Time') {
            if (value === null)
                this.elem.value = '';
            else {
                let m = moment(value * 1000).utcOffset(0);
                $(this.elem).data('DateTimePicker').date(m);
            }
        } else if (this._info.type === 'Message') {
            /* Do nothing */
        } else if (this._info.type === 'File') {
            /* Do nothing. */
        } else if (this._info.type === 'Radio') {
            let options = this._layout.$elems.$getAll(`${this._fullName}_Field`);

            for (let i = 0; i < options.length; i++) {
                if (options[i].getAttribute('value') === String(value)) {
                    options[i].checked = true;
                    return;
                }
            }
        } else if (this._info.type === 'Input') {
            if (this._info['input-type'].toLowerCase() === 'checkbox') {
                this.elem.checked = value ? true : false;
                let event = new Event('change', { bubbles: true, cancelable: true });
                this.elem.dispatchEvent(event);
            } else
                this.elem.value = value;
        } else if (this._info.type === 'Select') {
            let selected = false;
            let options = this.elem.options;
            for (let i = 0; i < options.length; i++) {
                if (options[i].value === value + '') {
                    options[i].selected = true;

                    let event = new Event('change', { bubbles: true, cancelable: true });
                    this.elem.dispatchEvent(event);

                    selected = true;
                    break;
                }
            }

            if (!selected)
                console.warn('Cannot find option `' + value + '` for field `' +
                        this.fullName + '`.');
        } else if (this._info.type === 'SelectMultiple') { 
            if (!(value instanceof Array)) {
                console.warn(`SelectMultiple value '` + value + `' should be an Array.`);
                return;
            }

            for (let value_T of value) {
                let selected = false;
                let options = this.elem.options;
                for (let i = 0; i < options.length; i++) {
                    if (options[i].value === value_T + '') {
                        options[i].selected = true;

                        let event = new Event('change', { bubbles: true, 
                            cancelable: true });
                        this.elem.dispatchEvent(event);

                        selected = true;
                        break;
                    }
                }

                if (!selected)
                    console.warn('Cannot find option `' + value_T + '`.');
            }
        } else if (this._info.type === 'Text')
            this.elem.innerHTML = value;
        else
            this.elem.value = value;

        // if (this._private.valueFieldName !== null)
        //     this._private.mForm.$fields[this._private.valueFieldName] = this.value;
        // }
    }

    constructor(layout, fieldInfo)
    {
        this._layout = layout;
        this._info = fieldInfo;

        this._fullName = `spkForms_${fieldInfo.form}_Fields_${fieldInfo.name}`;

        let fields = {};
        fields[`${this._fullName}_Label`] = 'label' in this._info ? this._info.label : '';        

        this.init();

        this._layout.$fields = fields;
    }

    clear()
    {
        this.value = '';
        this.clearValidator();
    }

    clearValidator()
    {
        this._layout.$fields[`${this._fullName}_Validator`] = {
            errors: [],
            fieldClass: '',
            divClass: '',
        }
    }

    field(fieldName, ...args)
    {
        if (args.length === 0)
            return this._layout.$fields[`${this.fullName}_${fieldName}`];
        else
            this._layout.$fields[`${this.fullName}_${fieldName}`] = args[0];
    }

    getLayoutElem(elemName) {
        js0.args(arguments, 'string');
        return this._layout.$elems[`${this._fullName}_${elemName}`];
    }

    getLayoutField(fieldName) {
        js0.args(arguments, 'string');
        return this._layout.$fields[`${this._fullName}_${elemName}`];
    }

    init()
    {
        let onChange = (evt) => {
            this.clearValidator();
        };

        if (this._info.type === 'Checkbox') {
            this.elem.addEventListener('change', onChange);
            this.elem.addEventListener('keyup', onChange);
        } else if (this._info.type === 'Date' || this._info.type === 'DateTime' ||
                this._info.type === 'Time') {
            let format;
            if (this._info.type === 'Date')
                format = abDate.formats_Date;
            else if (this._info.type === 'DateTime')
                format = abDate.formats_DateTime;
            else if (this._info.type === 'Time')
                format = abDate.formats_Time;

            /* Initialize `date` field. */
            $(this.elem)
                .datetimepicker( {
                    format: format,
                    showTodayButton: this._info.type !== 'Time',
                    useCurrent: false,
                    locale: spkForms.lang,
                    ignoreReadonly: true,
                })
                .on('dp.show', (evt) => {
                    if($(this.elem).data("DateTimePicker").date() === null)
                        $(this.elem).data("DateTimePicker").date(moment());
                })
                .on('dp.hide', (evt) => {
                    this.elem.setAttribute('value', this.elem.value);
                    this.clearValidator();
                    this.elem.blur();
                });

            this._layout.$elems[`${this._fullName}_ClearCalendar`].addEventListener(
                    'click', (evt) => {
                evt.preventDefault();
                this.value = null;
            });
        } else if (this._info.type === 'File') {
            this.field('Accept', '');
            if ('accept' in this._info)
                this.field('Accept', this._info.accept);
        } else if (this._info.type === 'Input' || this._info.type === 'TextArea') {
            // this.value = '';

            this.elem.addEventListener('change', onChange);
            this.elem.addEventListener('keyup', onChange);

            // this.elem.setAttribute('value', '');
        } else if (this._info.type === 'Radio') {
            console.log(this.getLayoutElem('Field'));
            this.getLayoutElem('Field')((elem) => {
                elem.addEventListener('change', onChange);
            });
            // this._layout.$elems.each('field', function(elem) {
            //     elem.addEventListener('change', onChange);
            // });
        } else if (this._info.type === 'Select' || this._info.type === 'file') {
            this.elem.addEventListener('change', onChange);
        }
    }

    setDisabled(disabled)
    {
        js0.args(arguments, 'boolean');

        let elems = this._layout.$elems.$getAll(`${this._fullName}_Field`);

        for (let elem of elems) {
            if (disabled)
                elem.setAttribute('disabled', '');
            else
                elem.removeAttribute('disabled');
        }
    }

    setValidator(validator)
    {
        this._layout.$fields[`${this._fullName}_Validator`] = {
            errors: 'errors' in validator ? validator.errors : [],
            fieldClass: validator.valid ? '' : 'is-invalid',
            divClass: '',
        }
    }

}

module.exports = Field;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\spk-forms\$layouts\CheckboxField.js
jsLibs.exportModule('spk-forms', '$layouts/CheckboxField', (require, module, exports) => { 'use strict';

const
    js0 = require('js0'),
    spocky = require('spocky')
;

class CheckboxField extends spocky.Layout {

    static get Content() {
        return [["div",{"class":["form-check {{divClass}} {{fullFieldName}}_Validator.divClass"],"_data-spk-field":["{{formName}}:{{fieldInfo}}"]},["input",{"_elem":["{{fullFieldName}}_Field"],"type":["checkbox"],"id":["{{fullFieldName}}"],"name":["{{fieldName}}"],"class":["form-check-input ","${{fullFieldName}}_Validator.fieldClass"],"placeholder":["{{fieldPlaceholder}}"]}],["label",{"_show":["{{fullFieldName}}_Label"],"for":["{{fullFieldName}}"],"class":["form-check-label {{labelClass}}"]},["div",{"_repeat":["{{fullFieldName}}_Validator.errors:errorMessage"],"class":["invalid-feedback"]},"$errorMessage"],["span",{"_field":["?({{fieldLabel}})"]}]]]];
    }


    constructor(defaultFieldValues = {})
    {
        js0.args(arguments, [ js0.RawObject, js0.Default ]);

        super(CheckboxField.Content, defaultFieldValues);
    }

}


module.exports = CheckboxField;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\spk-forms\$layouts\DateField.js
jsLibs.exportModule('spk-forms', '$layouts/DateField', (require, module, exports) => { 'use strict';

const
    js0 = require('js0'),
    spocky = require('spocky')
;

class DateField extends spocky.Layout {

    static get Content() {
        return [["div",{"class":["{{divClass}} ","${{fullFieldName}}_Validator.divClass"],"_data-spk-field":["{{formName}}:{{fieldInfo}}"]},["label",{"_show":["{{fullFieldName}}_Label"],"for":["{{fieldName}}"],"class":["form-label {{labelClass}}"]},"{{fieldLabel}}"],["div",{"class":["{{fieldClass}}"]},["div",{"class":["input-group"]},["span",{"class":["input-group-text"]},["span",{"_elem":["{{fullFieldName}}_Calendar"],"class":["fa fa-calendar"]}]],["input",{"_elem":["{{fullFieldName}}_Field"],"type":["text"],"id":["{{fullFieldName}}"],"name":["{{fieldName}}"],"class":["form-control datetimepicker ","${{fullFieldName}}_Validator.fieldClass"],"placeholder":["{{fieldPlaceholder}}"],"readonly":["true"],"style":["cursor: default; background-color: #ffffff;"]}],["span",{"class":["input-group-text"]},["span",{"_elem":["{{fullFieldName}}_ClearCalendar"],"class":["fa fa-times"]}]],["div",{"_repeat":["{{fullFieldName}}_Validator.errors:errorMessage"],"class":["invalid-feedback"]},"$errorMessage"]]]]];
    }


    constructor(defaultFieldValues = {})
    {
        js0.args(arguments, [ js0.RawObject, js0.Default ]);

        super(DateField.Content, defaultFieldValues);
    }

}


module.exports = DateField;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\spk-forms\$layouts\FileField.js
jsLibs.exportModule('spk-forms', '$layouts/FileField', (require, module, exports) => { 'use strict';

const
    js0 = require('js0'),
    spocky = require('spocky')
;

class FileField extends spocky.Layout {

    static get Content() {
        return [["div",{"class":["{{divClass}} {{fullFieldName}}_Validator.divClass"],"_data-spk-field":["{{formName}}:{{fieldInfo}}"]},["label",{"_show":["{{fullFieldName}}_Label"],"for":["{{fullFieldName}}"],"class":["form-label {{labelClass}}"]},"{{fieldLabel}}"],["div",{"class":["{{field.fieldClass}}"]},["input",{"_elem":["{{fullFieldName}}_Field"],"type":["file"],"accept":["${{fullFieldName}}_Accept"],"id":["{{fullFieldName}}"],"name":["{{fieldName}}"],"class":["form-control ","${{fullFieldName}}_Validator.fieldClass"]}],["div",{"_repeat":["{{fullFieldName}}_Validator.errors:errorMessage"],"class":["invalid-feedback"]},"$errorMessage"]]]];
    }


    constructor(defaultFieldValues = {})
    {
        js0.args(arguments, [ js0.RawObject, js0.Default ]);

        super(FileField.Content, defaultFieldValues);
    }

}


module.exports = FileField;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\spk-forms\$layouts\Message.js
jsLibs.exportModule('spk-forms', '$layouts/Message', (require, module, exports) => { 'use strict';

const
    js0 = require('js0'),
    spocky = require('spocky')
;

class Message extends spocky.Layout {

    static get Content() {
        return [["div",{"_show":["{{fullFormName}}_Message_Show"],"_data-spk-form-message":["{{formName}}"],"class":["alert ","${{fullFormName}}_Message_Class"," {{divClass}}"]},"${{fullFormName}}_Message"]];
    }


    constructor(defaultFieldValues = {})
    {
        js0.args(arguments, [ js0.RawObject, js0.Default ]);

        super(Message.Content, defaultFieldValues);
    }

}


module.exports = Message;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\spk-forms\$layouts\InputField.js
jsLibs.exportModule('spk-forms', '$layouts/InputField', (require, module, exports) => { 'use strict';

const
    js0 = require('js0'),
    spocky = require('spocky')
;

class InputField extends spocky.Layout {

    static get Content() {
        return [["div",{"class":["{{divClass}} ","${{fullFieldName}}_Validator.divClass"],"_data-spk-field":["{{formName}}:{{fieldInfo}}"]},["label",{"_show":["?({{fieldLabel}} !== '')"],"for":["{{fullFieldName}}"],"class":["form-label {{labelClass}}"]},["span",{"_field":["?({{fieldLabel}})"]}]],["div",{"class":["{{fieldClass}}"]},["input",{"_elem":["{{fullFieldName}}_Field"],"type":["{{inputType}}"],"id":["{{fullFieldName}}"],"name":["{{fieldName}}"],"class":["form-control ","${{fullFieldName}}_Validator.fieldClass"],"placeholder":["{{fieldPlaceholder}}"],"autocomplete":["off"]}],["div",{"_repeat":["{{fullFieldName}}_Validator.errors:errorMessage"],"class":["invalid-feedback"]},"$errorMessage"]]]];
    }


    constructor(defaultFieldValues = {})
    {
        js0.args(arguments, [ js0.RawObject, js0.Default ]);

        super(InputField.Content, defaultFieldValues);
    }

}


module.exports = InputField;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\spk-forms\$layouts\HiddenField.js
jsLibs.exportModule('spk-forms', '$layouts/HiddenField', (require, module, exports) => { 'use strict';

const
    js0 = require('js0'),
    spocky = require('spocky')
;

class HiddenField extends spocky.Layout {

    static get Content() {
        return [["input",{"ab-elem":["field(field)"],"type":["hidden"],"id":["{{field.name}}"],"name":["{{field.name}}"],"class":["form-control"],"placeholder":["{{field.placeholder}}"]}]];
    }


    constructor(defaultFieldValues = {})
    {
        js0.args(arguments, [ js0.RawObject, js0.Default ]);

        super(HiddenField.Content, defaultFieldValues);
    }

}


module.exports = HiddenField;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\spk-forms\$layouts\SelectField.js
jsLibs.exportModule('spk-forms', '$layouts/SelectField', (require, module, exports) => { 'use strict';

const
    js0 = require('js0'),
    spocky = require('spocky')
;

class SelectField extends spocky.Layout {

    static get Content() {
        return [["div",{"class":["{{divClass}} ","${{fullFieldName}}_Validator.divClass"],"_data-spk-field":["{{formName}}:{{fieldInfo}}"]},["label",{"_show":["?({{fieldLabel}} !== '')"],"for":["{{fullFieldName}}"],"class":["form-label {{labelClass}}"]},["span",{"_field":["?({{fieldLabel}})"]}]],["div",{"class":["{{fieldClass}}"]},["select",{"_elem":["{{fullFieldName}}_Field"],"id":["{{fullFieldName}}"],"name":["{{fieldName}}"],"class":["form-control ","${{fullFieldName}}_Validator.fieldClass"],"style":["${{fullFieldName}}_Style"]},["option",{"_repeat":["{{fullFieldName}}_Options:option"],"_field":["option.title"],"value":["$option.value"],"class":["$option.class"],"style":["$option.style"]}]],["div",{"_repeat":["{{fullFieldName}}_Validator.errors:errorMessage"],"class":["invalid-feedback"]},"$errorMessage"]]]];
    }


    constructor(defaultFieldValues = {})
    {
        js0.args(arguments, [ js0.RawObject, js0.Default ]);

        super(SelectField.Content, defaultFieldValues);
    }

}


module.exports = SelectField;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\spk-forms\$layouts\TextField.js
jsLibs.exportModule('spk-forms', '$layouts/TextField', (require, module, exports) => { 'use strict';

const
    js0 = require('js0'),
    spocky = require('spocky')
;

class TextField extends spocky.Layout {

    static get Content() {
        return [["div",{"class":["{{divClass}} ","${{fullFieldName}}_Validator.divClass"],"_data-spk-field":["{{formName}}:{{fieldInfo}}"]},["label",{"_show":["?({{fieldLabel}} !== '')"],"for":["{{fullFieldName}}"],"class":["form-label {{labelClass}}"]},["span",{"_field":["?({{fieldLabel}})"]}]],["div",{"class":["textField {{fieldClass}}"]},["span",{"_elem":["{{fullFieldName}}_Field"]}],["div",{"_repeat":["{{fullFieldName}}_Validator.errors:errorMessage"],"class":["invalid-feedback"]},"$errorMessage"]]]];
    }


    constructor(defaultFieldValues = {})
    {
        js0.args(arguments, [ js0.RawObject, js0.Default ]);

        super(TextField.Content, defaultFieldValues);
    }

}


module.exports = TextField;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\spk-forms\$layouts\RadioField.js
jsLibs.exportModule('spk-forms', '$layouts/RadioField', (require, module, exports) => { 'use strict';

const
    js0 = require('js0'),
    spocky = require('spocky')
;

class RadioField extends spocky.Layout {

    static get Content() {
        return [["div",{"class":["{{divClass}} {{fullFieldName}}_Validator.divClass"],"_data-spk-field":["{{formName}}:{{fieldInfo}}"]},["label",{"_show":["?({{fieldLabel}} !== '')"],"for":["{{fullFieldName}}"],"class":["{{labelClass}}"]},["span",{"_field":["?({{fieldLabel}})"]}]],["div",{"class":["{{fieldClass}} col-form-label"]},["div",{"_repeat":["{{fullFieldName}}_Options:Option"],"class":["form-check"]},["input",{"_elem":["{{fullFieldName}}_Field"],"type":["radio"],"id":["{{fullFieldName}}_","${Option.value}"],"name":["{{fieldName}}"],"value":["$Option.value"],"class":["form-check-input ","${{fullFieldName}}_Validator.fieldClass"],"style":["${{fullFieldName}}_Style"]}],["label",{"for":["{{fullFieldName}}_","${Option.value}"],"class":["form-check-label"]}," ","${Option.title}"]],["div",{"_repeat":["{{fullFieldName}}_Validator.errors:errorMessage"],"class":["invalid-feedback"]},"$errorMessage"]]]];
    }


    constructor(defaultFieldValues = {})
    {
        js0.args(arguments, [ js0.RawObject, js0.Default ]);

        super(RadioField.Content, defaultFieldValues);
    }

}


module.exports = RadioField;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\spk-forms\$layouts\MessageField.js
jsLibs.exportModule('spk-forms', '$layouts/MessageField', (require, module, exports) => { 'use strict';

const
    js0 = require('js0'),
    spocky = require('spocky')
;

class MessageField extends spocky.Layout {

    static get Content() {
        return [["div",{"_data-spk-field":["{{formName}}:{{fieldInfo}}"],"_repeat":["{{fullFieldName}}_Validator.errors:errorMessage"],"class":["alert alert-danger {{divClass}}"]},"$errorMessage"]];
    }


    constructor(defaultFieldValues = {})
    {
        js0.args(arguments, [ js0.RawObject, js0.Default ]);

        super(MessageField.Content, defaultFieldValues);
    }

}


module.exports = MessageField;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\spk-forms\$layouts\index.js
jsLibs.exportModule('spk-forms', '$layouts/index', (require, module, exports) => { 'use strict';

const CheckboxField = require('./CheckboxField');
const DateField = require('./DateField');
const FileField = require('./FileField');
const HiddenField = require('./HiddenField');
const InputField = require('./InputField');
const Message = require('./Message');
const MessageField = require('./MessageField');
const RadioField = require('./RadioField');
const SelectField = require('./SelectField');
const SelectMultipleField = require('./SelectMultipleField');
const TextAreaField = require('./TextAreaField');
const TextField = require('./TextField');






module.exports.CheckboxField = CheckboxField;
module.exports.DateField = DateField;
module.exports.FileField = FileField;
module.exports.HiddenField = HiddenField;
module.exports.InputField = InputField;
module.exports.Message = Message;
module.exports.MessageField = MessageField;
module.exports.RadioField = RadioField;
module.exports.SelectField = SelectField;
module.exports.SelectMultipleField = SelectMultipleField;
module.exports.TextAreaField = TextAreaField;
module.exports.TextField = TextField;
 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\spk-forms\$layouts\SelectMultipleField.js
jsLibs.exportModule('spk-forms', '$layouts/SelectMultipleField', (require, module, exports) => { 'use strict';

const
    js0 = require('js0'),
    spocky = require('spocky')
;

class SelectMultipleField extends spocky.Layout {

    static get Content() {
        return [["div",{"class":["${{fullFieldName}}.divClass"," ","${{rowClass}}"," {{fullFieldName}}_Validator.divClass"],"_data-spk-field":["{{formName}}:{{fieldInfo}}"]},["label",{"_show":["{{fullFieldName}}_Label"],"for":["{{fullFieldName}}"],"class":["form-label {{labelClass}}}"]},"{{fieldLabel}}"],["div",{"class":["{{fieldClass}}"]},["select",{"_elem":["{{fullFieldName}}_Field"],"id":["{{fullFieldName}}"],"name":["{{fieldName}}"],"class":["form-control"],"style":["${{fullFieldName}}_Style"],"multiple":["1"]},["option",{"_repeat":["{{fullFieldName}}_Options:option"],"_field":["option.title"],"value":["$option.value"],"class":["$option.class"],"style":["$option.style"]}]],["div",{"_repeat":["{{fullFieldName}}_Validator.errors:errorMessage"],"class":["invalid-feedback"]},"$errorMessage"]]]];
    }


    constructor(defaultFieldValues = {})
    {
        js0.args(arguments, [ js0.RawObject, js0.Default ]);

        super(SelectMultipleField.Content, defaultFieldValues);
    }

}


module.exports = SelectMultipleField;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\spk-forms\$layouts\TextAreaField.js
jsLibs.exportModule('spk-forms', '$layouts/TextAreaField', (require, module, exports) => { 'use strict';

const
    js0 = require('js0'),
    spocky = require('spocky')
;

class TextAreaField extends spocky.Layout {

    static get Content() {
        return [["div",{"class":["{{divClass}} ","$validator.divClass"],"_data-spk-field":["{{formName}}:{{fieldInfo}}"]},["label",{"_show":["{{fullFieldName}}_Label"],"for":["{{fullFieldName}}"],"class":["form-label {{labelClass}}}"]},"{{fieldLabel}}"],["div",{"class":["{{fieldClass}}"]},["textarea",{"_elem":["{{fullFieldName}}_Field"],"id":["{{fullFieldName}}"],"name":["{{fieldName}}"],"placeholder":["{{fieldPlaceholder}}"],"class":["form-control ","${{fullFieldName}}_Validator.fieldClass"],"rows":["{{fieldRows}}"]}],["div",{"_repeat":["{{fullFieldName}}_Validator.errors:errorMessage"],"class":["invalid-feedback"]},"$errorMessage"]]]];
    }


    constructor(defaultFieldValues = {})
    {
        js0.args(arguments, [ js0.RawObject, js0.Default ]);

        super(TextAreaField.Content, defaultFieldValues);
    }

}


module.exports = TextAreaField;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\spk-file-upload\FileUpload.js
jsLibs.exportModule('spk-file-upload', 'FileUpload', (require, module, exports) => { 'use strict';

const
    js0 = require('js0'),
    spocky = require('spocky'),

    $layouts = require('./$layouts')
;

class FileUpload extends spocky.Module
{

    get files() {
        return this._files;
    }


    constructor(callback, extensions = '.*', multiple = false)
    { super();
        js0.args(arguments, 'function', [ 'string', js0.Default ], 
                [ 'boolean', js0.Default ]);

        this._callback = callback;
        this._extensions = extensions;
        this._multiple = multiple;

        this._files = [];

        this._createInput(callback);
    }

    upload()
    {
        let event = document.createEvent('MouseEvents');
        event.initEvent('click', true, true);
        this.l.$elems.fileInput.dispatchEvent(event);
    }

    
    _createInput()
    {
        this.l = new $layouts.Input();
        this.l.$fields.extensions = this._extensions;

        let el = this.l.$elems.fileInput;
        if (this._multiple)
            el.setAttribute('multiple', true);
        el.addEventListener('change', () => {
            this._files = el.files;
            this._callback(el.files);
            this._createInput();
        });
    }

}


module.exports = FileUpload;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\spk-file-upload\LiveUpload.js
jsLibs.exportModule('spk-file-upload', 'LiveUpload', (require, module, exports) => { 'use strict';

const
    js0 = require('js0'),
    spkFileUpload = require('spk-file-upload'),
    spocky = require('spocky'),

    $layouts = require('./$layouts')
;

let initialized = false;
function init() {
    if (initialized)
        return;
    initialized = true;
    
     /* Disable dragging for the whole document. */
     document.addEventListener('dragover', (evt) => {
        evt.stopPropagation();
        evt.preventDefault();
        evt.dataTransfer.dropEffect = 'copy';
    });
}


class LiveUpload extends spocky.Module
{

    constructor(title, displayType, listeners, exts = '*', texts = {})
    { super();
        js0.args(arguments, 'string', 'string', js0.RawObject, 
                [ 'string', js0.Default ], [ 'object', js0.Default ]);

        js0.typeE(listeners, js0.Preset({
            onCopy: 'function',
            onDelete: 'function',
            onInsert: 'function',
            onUpload: 'function',
        }));

        if (![ 'file', 'image' ].includes(displayType))
                throw new Error(`Unknown display type '${displayType}'.`);

        init();

        this._title = title;
        this._listeners = listeners;
        this._displayType = displayType;
        this._texts = texts;

        this.l = null;
        this.files = new Map();

        this._fileUpload = new spkFileUpload.FileUpload((files) => {
            this._listeners.onUpload(files);
                }, exts, true);

        this._createLayout();
        this._createElems();

        this.$view = this.l;
    }

    deleteAllFiles()
    {
        this.files = new Map();
        this.l.$fields.files = [];
    }

    deleteFile(fileId)
    {
        this.files.delete(fileId);
        this.l.$fields.files().$delete(fileId);
    }

    hideLoading()
    {
        this.l.$fields.loading = false;
    }

    refresh()
    {
        this.l.$fields.timestamp = Date.now();
    }

    setFile(fileInfo)
    {
        js0.args(arguments, js0.RawObject);

        console.log(fileInfo);

        js0.typeE(fileInfo, js0.Preset({
            id: [ 'number', 'string' ],
            title: 'string',
            uri: [ 'string', js0.Null ],
            imgUri: 'string',
        }));

        this.files.set(fileInfo.id, fileInfo);
        this.l.$fields.files(fileInfo.id, fileInfo);

        this.refresh();
    }

    showLoading()
    {
        this.l.$fields.loading = true;
    }


    _createElems()
    {
        this.l.$elems.upload.addEventListener('click', (evt) => {
            evt.preventDefault();
            this._fileUpload.upload();
        });

        /* Images */
        this.l.$elems.images_Insert_Text((elem, keys) => {
            elem.addEventListener('click', (evt) => {
                evt.preventDefault();
                this._listeners.onInsert(this.files.get(keys[0]));
            });
        });
        this.l.$elems.images_Insert_Image((elem, keys) => {
            elem.addEventListener('click', (evt) => {
                evt.preventDefault();

                this._listeners.onInsert(this.files.get(keys[0]));
            });
        });
        this.l.$elems.images_Copy((elem, keys) => {
            elem.addEventListener('click', (evt) => {
                evt.preventDefault();
                this._listeners.onCopy(this.files.get(keys[0]));
            });
        });
        this.l.$elems.images_Delete((elem, keys) => {
            elem.addEventListener('click', (evt) => {
                evt.preventDefault();
                this._listeners.onDelete(this.files.get(keys[0]));
            });
        });

        /* Files */
        this.l.$elems.files_Insert_Text((elem, keys) => {
            elem.addEventListener('click', (evt) => {
                evt.preventDefault();
                this._listeners.onInsert(this.files.get(keys[0]));
            });
        });
        this.l.$elems.files_Insert_Image((elem, keys) => {
            elem.addEventListener('click', (evt) => {
                evt.preventDefault();

                this._listeners.onInsert(this.files.get(keys[0]));
            });
        });
        this.l.$elems.files_Copy((elem, keys) => {
            elem.addEventListener('click', (evt) => {
                evt.preventDefault();
                this._listeners.onCopy(this.files.get(keys[0]));
            });
        });
        this.l.$elems.files_Delete((elem, keys) => {
            elem.addEventListener('click', (evt) => {
                evt.preventDefault();
                this._listeners.onDelete(this.files.get(keys[0]));
            });
        });

        this._createElems_Images();
    }

    _createElems_Images()
    {
        this.l.$elems.files.addEventListener('dragover', (evt) => {
            evt.stopPropagation();
            evt.preventDefault();
            evt.dataTransfer.dropEffect = 'copy';

            this.l.$fields.class = 'dragover';
        });

        this.l.$elems.files.addEventListener('dragleave', (evt) => {
            evt.stopPropagation();
            evt.preventDefault();

            this.l.$fields.class = '';
        });

        this.l.$elems.files.addEventListener('drop', (evt) => {
            evt.stopPropagation();
            evt.preventDefault();

            this.l.$fields.class = '';

            var files = evt.dataTransfer.files;
            this._listeners.onUpload(files);
        });
    }

    _createLayout()
    {
        this.l = new $layouts.Files();

        this.l.$fields = {
            title: this._title,
            type: {
                isFile: this._displayType === 'file',
                isImage: this._displayType === 'image',
            },
            text: (text) => {
                return text in this._texts ? this._texts[text] : `#${text}#`;
            },
        }

        this.l.$holders.fileUpload.$view = this._fileUpload;
    }

}

module.exports = LiveUpload;
exports = module.exports;




module.exports.init = init;
 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\spk-file-upload\index.js
jsLibs.exportModule('spk-file-upload', 'index', (require, module, exports) => { 'use strict';

const
    js0 = require('js0'),
    spocky = require('spocky'),

    $layouts = require('./$layouts')
;

const FileUpload = require('./FileUpload');
const LiveUpload = require('./LiveUpload');






module.exports.FileUpload = FileUpload;
module.exports.LiveUpload = LiveUpload;
 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\spk-file-upload\$layouts\Input.js
jsLibs.exportModule('spk-file-upload', '$layouts/Input', (require, module, exports) => { 'use strict';

const
    js0 = require('js0'),
    spocky = require('spocky')
;

class Input extends spocky.Layout {

    static get Content() {
        return [["div",{"style":["display: none;"]},["input",{"_elem":["fileInput"],"type":["file"],"accept":["$extensions"],"style":["display: none;"]}]]];
    }


    constructor(defaultFieldValues = {})
    {
        js0.args(arguments, [ js0.RawObject, js0.Default ]);

        super(Input.Content, defaultFieldValues);
    }

}


module.exports = Input;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\spk-file-upload\$layouts\index.js
jsLibs.exportModule('spk-file-upload', '$layouts/index', (require, module, exports) => { 'use strict';

const Files = require('./Files');
const Input = require('./Input');






module.exports.Files = Files;
module.exports.Input = Input;
 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\spk-file-upload\$layouts\Files.js
jsLibs.exportModule('spk-file-upload', '$layouts/Files', (require, module, exports) => { 'use strict';

const
    js0 = require('js0'),
    spocky = require('spocky')
;

class Files extends spocky.Layout {

    static get Content() {
        return [["div",{"class":["card"]},["div",{"class":["card-header"]},["div",{"class":["row"]},["div",{"class":["col"]},"$title"],["div",{"class":["col-auto"]},["button",{"_elem":["upload"],"class":["btn btn-primary btn-sm m-0 float-right"]},["i",{"class":["fas fa-file-upload"],"aria-hidden":["true"]}]," ","$text('Buttons_Upload')"]]]],["div",{"class":["card-body p-0"]},["div",{"class":["spk-e-images"]},["div",{"_show":["loading"],"class":["files-loader"]},["div",{"class":["spinner-border"],"role":["status"]},["span",{"class":["visually-hidden"]},"$text('Texts_Loading')"]]],["div",{"_elem":["files"],"class":["files-holder ","$class"]},["$",{"_hide":["loading"]},["div",{"_repeat":["files:file"],"_show":["type.isImage"],"class":["image-holder"]},["div",{"class":["image-displayer"],"style":["background-image: url('","${file.imgUri}","?t=","${timestamp}","');'"]},["a",{"_elem":["images_Insert_Image"],"href":[""]},["img",{"src":["/dev/node_modules/spk-file-upload/images/dummy.png"],"alt":[""]}]]],["div",{"class":["btn-group w-100"]},["a",{"_elem":["images_Insert_Text"],"class":["btn btn-theme-light btn-sm"],"href":[""]},["i",{"class":["fa fa-image"],"aria-hidden":["true"]}]],["a",{"_elem":["images_Copy"],"class":["btn btn-theme-light btn-sm"],"href":[""]},["i",{"class":["fa fa-link"],"aria-hidden":["true"]}]],["a",{"_elem":["images_Delete"],"class":["btn btn-theme-light btn-sm"],"href":[""]},["i",{"class":["fa fa-times text-danger"],"aria-hidden":["true"]}]]]],["div",{"class":["clearfix"]}],["div",{"_repeat":["files:file"],"_show":["type.isFile"],"class":["file-holder"]},["div",{"class":["alert alert-info"]},["div",{"class":["row file-details"]},["div",{"class":["col file-name"]},["a",{"_elem":["files_Insert_Image"],"href":[""]},["i",{"class":["far fa-file me-2"],"aria-hidden":["true"]}],"$file.title"]],["div",{"class":["col-auto"]},["div",{"class":["btn-group"]},["a",{"_elem":["files_Insert_Text"],"class":["btn btn-theme-light btn-sm"],"href":[""]},["i",{"class":["fas fa-arrow-down"],"aria-hidden":["true"]}]],["a",{"_elem":["files_Copy"],"_show":["notImplemented"],"class":["btn btn-theme-light btn-sm"],"href":[""]},["i",{"class":["fa fa-link"],"aria-hidden":["true"]}]],["a",{"_elem":["files_Delete"],"class":["btn btn-theme-light btn-sm"],"href":[""]},["i",{"class":["fa fa-times text-danger"],"aria-hidden":["true"]}]]]]]]]]]]]],["$",{"_holder":["fileUpload"]}]];
    }


    constructor(defaultFieldValues = {})
    {
        js0.args(arguments, [ js0.RawObject, js0.Default ]);

        super(Files.Content, defaultFieldValues);
    }

}


module.exports = Files;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\web-app\index.js
jsLibs.exportModule('web-app', 'index', (require, module, exports) => { 'use strict';

const
    abNative = require('ab-native'),

    js0 = require('js0'),

    WebAppActions = require('./WebAppActions')
    // NativeActions_Core = require('./NativeActions_Core')
;

class webApp_Class extends abNative.WebApp {

    get debug() {
        return this._debug;
    }


    constructor() {
        super();

        this._debug = false;
        this.actions = new WebAppActions(this, abNative_ApiUri + 'api/v1/core/');

        // this.addActionsSet('Core', new NativeActions_Core(this, '/api/v1/core/'));
    }

    setDebug(debug) {
        js0.args(arguments, 'boolean');

        this._debug = debug;
    }

}
const abNative_WebApp = new webApp_Class();



module.exports = abNative_WebApp;


 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\web-app\WebAppActions.js
jsLibs.exportModule('web-app', 'WebAppActions', (require, module, exports) => { 'use strict';

const
    abNative = require('ab-native'),
    js0 = require('js0'),
    webABApi = require('web-ab-api'),

    core = require('core')
;

class WebAppActions extends core.Actions
{

    constructor(webApp, apiUri) {
        js0.args(arguments, require('ab-native').WebApp, 'string');
        super();

        this.webApp = webApp;
        this._apiUri = apiUri;
    }

    async __init_Async() {
        let result = await webABApi.json_Async(this._apiUri + 'init', {});

        if (!result.isSuccess()) {
            if (webApp.debug)
                console.warn(result.data.data);

            throw new Error('Cannot initialize web app.');
        }

        return {
            appInfo: null,
            appVersion: '-',
            fields: result.data.fields,
            user: result.data.user,
            deviceInfo: result.data.deviceInfo,
        };
    }

    async __logIn_Async(login, password) {
        js0.args(arguments, 'string', 'string');

        let result = await webABApi.json_Async(this._apiUri + 'log-in', {
            login: login,
            password: password,
        });

        if (!result.isSuccess()) {
            if (this.webApp.debug) {
                console.warn('Result Message', result.message);
                console.warn('Result Data', result.data);
            }

            return {
                data: null,
                error: result.message,
            };
        }

        return {
            data: {
                appInfo: null,
                user: result.data.user,
            },
            error: null,
        };
    }

    async __logOut_Async() {
        js0.args(arguments);

        let result = await webABApi.json_Async(this._apiUri + 'log-out', {});

        if (!result.isSuccess()) {
            if (this.webApp.debug) {
                console.warn('Result Message', result.message);
                console.warn('Result Data', result.data.data);
            }

            return {
                success: false,
                error: result.message,
            };
        }

        return {
            success: true,
            error: null,
        };
    }

}

module.exports = WebAppActions;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\e-tasks\index.js
jsLibs.exportModule('e-tasks', 'index', (require, module, exports) => { 'use strict';

const
    webABApi = require('web-ab-api')
;


class eTasks_Class {

    constructor() {
        this.timeout = 1000;
    }

    start(api_uri, api_args, destroy_on_finish, fn) {
        let task_hash = null;

        let refresh = function(api_args) {
            api_args.task = {
                hash: task_hash,
                destroyOnFinish: destroy_on_finish
            };

            webABApi.json(api_uri, api_args, function(result) {
                let task = null;
                if (result.isSuccess()) {
                    task = result.data.task;
                    task_hash = task.hash;
                }

                if (!fn(task, result))
                    return false;

                setTimeout(function() {
                    refresh(api_args);
                });
            });
        };
        refresh(api_args);
    }

    // refresh(api_uri, task_hash, destroy_on_finish, fn)
    // {
    //     let check_task = function() {
    //         webABApi.json(api_uri, {
    //             task: {
    //                 hash: task_hash,
    //                 destroyOnFinish: destroy_on_finish
    //             }
    //         }, function(result) {
    //             if (result.isSuccess()) {
    //                 if (fn(result.data.task.finished, result.data.task.info, null))
    //                     setTimeout(check_task, this.timeout);
    //             } else {
    //                 console.warn('Error on task refresh.');
    //                 setTimeout(check_task, this.timeout);
    //             }
    //         });
    //     };

    //     setTimeout(check_task, this.timeout);
    // }

}
const eTasks = new eTasks_Class();



module.exports = eTasks;


 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\spocky\AppInstance.js
jsLibs.exportModule('spocky', 'AppInstance', (require, module, exports) => { 'use strict';

const 
    abNodes = require('ab-nodes'),
    js0 = require('js0'),

    Config = require('./Config'),
    ConfigInfo = require('./ConfigInfo'),
    Inits = require('./Inits'),
    Layout = require('./Layout'),
    Module = require('./Module'),
    PathInfo = require('./PathInfo')
;

class AppInstance
{

    constructor(inits)
    {
        js0.args(arguments, Inits);

        let config = new ConfigInfo();

        Object.defineProperties(this, {
            _config: { value: new ConfigInfo(), },
            _inits: { value: inits, },
            // _jsLibs: { value: new jsLibs_Class(), },
            _jsLibs: { value: jsLibs, },
        });

        /* Confit Init */
        let cfg = new Config(this._config);
        for (let configFn of this._inits.configs)
            configFn(this, cfg);

        /* App Inits */
        for (let initFn of this._inits.app)
            initFn(this);

        /* Containers Init */
        for (let [ containerId, containerInfo ] of this._config.containerInfos) {
            let rootNode = new abNodes.RootNode(containerInfo.htmlElement);
            
            let moduleArgs = [ null ];
            for (let arg of containerInfo.moduleArgs)
                moduleArgs.push(arg);
            let module = new (Function.prototype.bind.apply(
                    containerInfo.moduleClass, moduleArgs));            
            if (!(module instanceof Module))
                throw new Error(`Containers '${containerId}' class is not a Spocky module.`);

            rootNode.activate();
            module._$viewable.activate(rootNode);
        }
    }

    // $create(fullCreatePath)
    // {
    //     let createPathInfo = new PathInfo(fullCreatePath);

    //     let pkg = this.$import(createPathInfo.packagePath);

    //     return pkg.$create(createPathInfo.name);
    // }

}


module.exports = AppInstance;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\spocky\App.js
jsLibs.exportModule('spocky', 'App', (require, module, exports) => { 'use strict';

const 
    js0 = require('js0'),

    // test = require('test'),

    // Config = require('./instances/Config'),
    // Layout = require('./instances/Layout'),
    // Package = require('./instances/Package'),
    // Page = require('./instances/Page'),

    AppInstance = require('./AppInstance'),
    Inits = require('./Inits'),
    Layout = require('./Layout'),
    Module = require('./Module')
;

class App
{

    constructor()
    {
        this._initialized = false;
        this._inits = new Inits();
    }

    app(appInitFn)
    {
        js0.args(arguments, 'function');

        this._inits.app.push(appInitFn);

        return this;
    }

    config(configFn)
    {
        js0.args(arguments, 'function');

        if (this._initialized)
            throw new Error('App already initialized.');

        this._inits.configs.push(configFn);

        return this;
    }

    // ext(ext_initFn)
    // {
    //     js0.args(arguments, 'function');

    //     this._infos.appInits.push({
    //         initFn:ext_initFn,
    //     });
    // }

    init()
    {
        if (this._initialized)
            throw new Error('`spocky` already initialized.');
        this._initialized = true;

        /* Config */
        new AppInstance(this._inits);

        return this;
    }

    // layout(layoutPath, layoutInitFn)
    // {
    //     js0.args(arguments, 'string', 'function');

    //     if (this._initialized)
    //         throw new Error('Cannot define layout after initialization.');

    //     if (layoutPath in this._inits.layout)
    //         throw new Error(`Layout '${layoutPath}' already exists.`);

    //     this._inits.layout[layoutPath] = layoutInitFn;
    // }

    // package(packagePath, packageInitFn)
    // {
    //     js0.args(arguments, 'string', 'function');

    //     if (this._initialized)
    //         throw new Error('Cannot define package after initialization.');

    //     if (!this._inits.package.has(packagePath))
    //         this._inits.package.set(packagePath, []);

    //     this._inits.package.get(packagePath).push(packageInitFn);
    // }


    // _layout(layoutPath, layoutInitPath, raw)
    // {
    //     js0.args(arguments, 'string', 'function', 'boolean');

    //     if (this._initialized)
    //         throw new Error('Cannot define layout after initialization.');

    //     if (layoutPath in this._infos.layouts) {
    //         if (this._$debug)
    //             console.warn('Layout `' + layoutPath + '` already exists. Overwriting.');
    //     }

    //     this._infos.layouts[layoutPath] = {
    //         raw: raw,
    //         path: layoutPath,
    //         initFn: layoutInitPath,
    //     };
    // }

    // _parseUri(uri, push_state)
    // {
    //     let page_info = this._uri.parse(uri);
    //     if (page_info === null)
    //         throw new Error(`No page matches uri \`${uri}\`.`);

    //     this._setPage(page_info.name, page_info.args, push_state);
    // }

};


module.exports = App;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\spocky\Config.js
jsLibs.exportModule('spocky', 'Config', (require, module, exports) => { 'use strict';

const js0 = require('js0');

const ConfigInfo = require('../ConfigInfo');
const ContainerInfo = require('../ContainerInfo');
const Inits = require('../Inits');
const Module = require('../Module');


class Config
{

    constructor(configInfo)
    {
        js0.args(arguments, ConfigInfo);

        this._configInfo = configInfo;
    }

    container(htmlElementId, moduleClass, moduleArgs = [])
    {
        js0.args(arguments, 'string', 'function', [ Array, js0.Default ]);

        /* Validate HTML Element */
        let htmlElement = document.getElementById(htmlElementId);
        if (htmlElement === null)
            throw new Error(`\`HtmlElement\` with id \`${htmlElementId}\` does not exist.`);

        /* Create Container */
        let containerInfo = new ContainerInfo(htmlElementId, htmlElement,
                moduleClass, moduleArgs);

        // /* Validate Module Paths */
        // for (let modulePath of containerInfo.modulePath) {            
        //     if (!(path_configInfo.packagePath in this._infos.packages))
        //         throw new Error(`Module \`${path_configInfo.fullPath}\` package does not exist.`);
        // }

        this._configInfo.containerInfos.set(containerInfo.id, containerInfo);
        /* / Create Container */

        return this;
    }

}
module.exports = Config;






 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\spocky\Ext.js
jsLibs.exportModule('spocky', 'Ext', (require, module, exports) => { 'use strict';


class Ext
{

    constructor()
    {

    }

    onParseLayoutNode(layoutNode)
    {
        
    }

}

module.exports = Ext;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\spocky\ContainerInfo.js
jsLibs.exportModule('spocky', 'ContainerInfo', (require, module, exports) => { 'use strict';

const js0 = require('js0');

// const Module = require('../instances/Module');


class ContainerInfo
{

    constructor(containerId, htmlElement, moduleClass, moduleArgs)
    {
        js0.args(arguments, 'string', HTMLElement, 'function', Array);

        Object.defineProperties(this, {
            id: { value: containerId, },
            htmlElement: { value: htmlElement, },
            moduleClass: { value: moduleClass, },
            moduleArgs: { value: moduleArgs, },
        });
    }

}
module.exports = ContainerInfo;






 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\spocky\ConfigInfo.js
jsLibs.exportModule('spocky', 'ConfigInfo', (require, module, exports) => { 'use strict';

const js0 = require('js0');

const Config = require('./Config');
const Inits = require('./Inits');


class ConfigInfo {

    constructor()
    {
        Object.defineProperties(this, {
            containerInfos: { value: new Map(), },
        });
    }

}
module.exports = ConfigInfo;






 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\spocky\Inits.js
jsLibs.exportModule('spocky', 'Inits', (require, module, exports) => { 'use strict';


class Inits
{

    constructor()
    {
        Object.defineProperties(this, {
            app: { value: [] },
            configs: { value: [], writable: true, },
            ext: { value: new Map(), },
            layout: { value: new Map(), },
            package: { value: new Map(), },
        });
    }

}
module.exports = Inits;






 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\spocky\LayoutParser.Elems.js
jsLibs.exportModule('spocky', 'LayoutParser.Elems', (require, module, exports) => { 'use strict';

const
    js0 = require('js0')
;

class Elems {

    constructor() {
        this._elemInfos = {};
    }

    $exists(elemName) {
        js0.args(arguments, 'string');

        return elemName in this._elemInfos;
    }

    $get(elemName, keys = []) {
        js0.args(arguments, 'string', Array);

        if (!(elemName in this._elemInfos))
            throw new Error(`Elem '${elemName}' does not exist.`);

        return this._get(elemName, keys);
    }

    $getAll(elemName)
    {
        js0.args(arguments, 'string');

        let elems = [];
        let keysSets = this.$keys(elemName);
        for (let keys of keysSets)
            elems.push(this.$get(elemName, keys));

        return elems;
    }

    $index(elemName, keys)
    {
        js0.args(arguments, 'string', Array);

        let keySets = this.$keys();
        for (let i = 0; i < keySets.length; i++) {
            if (this._keysMatch(keySets[i], keys))
                return i;
        }

        return -1;
    }

    $keys(elemName) {
        js0.args(arguments, 'string');

        if (!this.$exists(elemName))
            throw new Error(`Elem '${elemName}' does not exist.`);

        let keys = [];
        for (let elemInfo of this._elemInfos[elemName]) {
            let keysArr = [];
            for (let key of elemInfo.keys)
                keysArr.push(key);
            keys.push(keysArr);
        }

        return keys;
    }

    _add(elemName, keys, elem) {
        this._elemInfos[elemName].push({
            elem: elem,
            keys: keys,
        });
    }

    _declare(elemName) {
        this._elemInfos[elemName] = [];
    }

    _get(elemName, keys) {
        for (let elemInfo of this._elemInfos[elemName]) {
            if (this._keysMatch(elemInfo.keys, keys))
                return elemInfo.elem;
        }

        throw new Error(`Elem '${elemName}' with keys '` + keys.join(', ') +
            `' does not exist.`);
    }

    _keysMatch(keysA, keysB) {
        if (keysA.length !== keysB.length)
            return false;

        for (let i = 0; i < keysA.length; i++) {
            if (keysA[i] !== keysB[i])
                return false;
        }

        return true;
    }

    _remove(elemName, keys) {
        if (!this.$exists(elemName))
            throw new Error(`Elem '${elemName}' does not exist.`);

        for (let i = 0; i < this._elemInfos[elemName].length; i++) {
            if (this._keysMatch(this._elemInfos[elemName][i].keys, keys)) {
                this._elemInfos[elemName].splice(i, 1);
                return;
            }
        }

        let keysStr = keys.join(', ');
        throw new Error(`Elem '${elemName}' with keys '${keysStr}' does not exist.`);
    }
}

module.exports = Elems;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\spocky\Layout.js
jsLibs.exportModule('spocky', 'Layout', (require, module, exports) => { 'use strict';

const 
    abTextParser = require('ab-text-parser'),
    js0 = require('js0'),

    LayoutParser = require('./LayoutParser'),
    Viewable = require('./Viewable')
;

class Layout
{

    static Replace(layoutContent, replaceArr)
    {
        js0.args(arguments, Array, Array);

        Layout._Replace_ReplaceInArray(layoutContent, replaceArr);
    }

    static _Replace_ReplaceInArray(array, replaceArr)
    {
        for (let i = 0; i < array.length; i++) {
            if (typeof array[i] === 'string') {
                let newString = array[i];
                for (let replace of replaceArr) {
                    newString = newString.replace(new RegExp(replace[0], 'g'), 
                            replace[1]);
                }
        
                let newStringArr = abTextParser.parse(newString);

                array.splice(i, 1);
                for (let j = 0; j < newStringArr.length; j++)
                    array.splice(i + j, 0, newStringArr[j]);
        
                i += newStringArr.length - 1;
            } else if (js0.type(array[i], Array))
                Layout._Replace_ReplaceInArray(array[i], replaceArr);
            else if (js0.type(array[i], js0.RawObject))
                Layout._Replace_ReplaceInObject(array[i], replaceArr);
        }
    }

    static _Replace_ReplaceInObject(object, replaceArr)
    {
        for (let key in object) {
            if (js0.type(object[key], 'string')) {
                let newString = object[key];
                for (let replace of replaceArr) {
                    newString = newString.replace(new RegExp(replace[0], 'g'), 
                            replace[1]);
                }

                object[key] = newString;
            } else if (js0.type(object[key], Array))
                Layout._Replace_ReplaceInArray(object[key], replaceArr);
            else if (js0.type(object[key], js0.RawObject))
                Layout._Replace_ReplaceInObject(object[key], replaceArr);
        }
    }


    constructor(layoutContent, defaultFieldValues = {})
    {
        js0.args(arguments, Array, [ js0.RawObject, js0.Default ]);
        js0.prop(this, Layout.Viewable, this);

        let layoutParser = new LayoutParser();
        for (let ext of Layout.Extensions)
            layoutParser.extend(ext);
        let layoutNode = layoutParser.parse(layoutContent);        

        this._fields = layoutParser.fields;
        this._$data = layoutParser.data;
        this._$elems = layoutParser.elems;
        this._$holders = layoutParser.holders;

        Object.defineProperties(this, {
            $fields: {
                get: () => {
                    return this._fields.$value;
                },
                set: (value) => {
                    this._fields.$value = value;
                },
            },

            $data: { value: this._$data, },
            $elems: { value: this._$elems, },
            $holders: { value: this._$holders, },

            _$layoutNode: { value: layoutNode, },

            _$listeners_OnDisplay: { value: [], },
        });

        layoutNode.addListener_OnDisplay((display) => {
            for (let listener of this._$listeners_OnDisplay)
                listener(display);
        });

        for (let fieldName in defaultFieldValues) {
            this.$fields[fieldName] = defaultFieldValues[fieldName];
        }
    }

    $onDisplay(listener)
    {
        if (this._$viewable.active)
            listener();
        this._$listeners_OnDisplay.push(listener);
    }

}
module.exports = Layout;


Object.defineProperties(Layout, {

    Extensions: { value: [], },

    Viewable: { value:
    class Layout_Viewable extends Viewable {

        constructor(layout)
        { super();
            this._layout = layout;
        }

        __activate(parentNode)
        {
            parentNode.pChildren.add(this._layout._$layoutNode);
            // console.log('Adding child:', this._layout._$layoutNode, 'to', parentNode);
            // this._layout._$layoutNode.activate();
        }

        __deactivate(parentNode)
        {
            parentNode.pChildren.remove(this._layout._$layoutNode);
            // this._layout._$layoutNode.deactivate();
        }

    }},

});






 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\spocky\Holder.js
jsLibs.exportModule('spocky', 'Holder', (require, module, exports) => { 'use strict';

const
    abLayouts = require('ab-layouts'),
    js0 = require('js0'),

    Layout = require('./Layout'),
    Module = require('./Module')
;

class Holder
{

    get $view() {
        if (this._view === null)
            return null;
        
        return this._view;
    }
    set $view(value) {
        if (!js0.type(value, [ require('./Layout'), require('./Module'), js0.Null ]))
            throw new Error(`'$view' must be 'Layout', 'Module' or 'Null'.`);

        if (this._$view === null)
            return;

        if (this._view !== null)
            this._view._$viewable.deactivate();

        this._view = value;
        if (this._view !== null)
            this._view._$viewable.activate(this._layoutNode);
    }


    constructor(layoutNode)
    {
        js0.args(arguments, abLayouts.LayoutNode);

        Object.defineProperties(this, {
            _layoutNode: { value: layoutNode, },
            _view: { value: null, writable: true, },
        });
    }

    // _$activate()
    // {
    //     if (this._view !== null)
    //         this._view._$viewable.activate(this._layoutNode);
    // }

}
module.exports = Holder;





 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\spocky\LayoutParser.FieldInfo.js
jsLibs.exportModule('spocky', 'LayoutParser.FieldInfo', (require, module, exports) => { 'use strict';

const
    abFields = require('ab-fields'),
    abStrings = require('ab-strings'),
    js0 = require('js0'),

    spocky = require('.')
;

class FieldInfo
{

    static get Types() {
        return Types;
    }


    constructor(fieldsHelper, repeatInfo, fieldPath, includesPrefix)
    {
        js0.args(arguments, require('./LayoutParser.FieldsHelper'), 
                require('./LayoutParser.RepeatInfo'), 
                'string', 'boolean');

        this.fieldsHelper = fieldsHelper;
        this.repeatInfo = repeatInfo;

        this.fieldDefinitions = [];

        this.repeatInfo = this.repeatInfo;

        this.type = null;
        /* Field */
        this.field_Path = null;
        this.field_Parts = null;
        this.field_Name = null;
        /* Field Fn */
        this.fieldFn_ArgFields = null;
        this.fieldFn_ArgFieldsStr = null;
        /* Expr */
        this.expr = null;
        this.expr_ArgFields = null;

        if (this.fieldsHelper.isExpression(fieldPath)) {
            this.type = Types.Expression;

            this.expr = fieldPath.substr(2, fieldPath.length - 3);
            this.expr_ArgFields = [];
            let re = new RegExp('\\${(' + this.fieldsHelper.regexpStrs_FieldName + ')}' +
                    '|' + '\\$(' + this.fieldsHelper.regexpStrs_FieldName + ')', 'gi');
            let matches = this.expr.matchAll(re);
            for (let match of matches) {
                let fieldMatch = null;
                if (typeof match[1] !== 'undefined') {
                    fieldMatch = match[1];
                } else {
                    fieldMatch = match[5];
                }

                let expr_ArgFieldInfo = this.fieldsHelper.def(repeatInfo, fieldMatch, 
                        false, abFields.VarDefinition);

                this.expr_ArgFields.push({
                    path: fieldMatch,
                    fieldInfo: expr_ArgFieldInfo,
                });
                
                for (let expr_ArgFieldInfo_FD of expr_ArgFieldInfo.fieldDefinitions)
                    this.fieldDefinitions.push(expr_ArgFieldInfo_FD);
            }
        } else if (this.fieldsHelper.isFieldName(fieldPath, includesPrefix)) {
            fieldPath = this.fieldsHelper.getFieldName(fieldPath, includesPrefix);

            let fieldMatch = this.fieldsHelper.matchField(fieldPath);
            if (typeof fieldMatch[3] === 'undefined') {
                this.type = Types.Field;
            } else {
                this.type = Types.Function;

                this.fieldFn_ArgFields = [];
                this.fieldFn_ArgStrs = fieldMatch[3].split(',');
                for (let argStr of this.fieldFn_ArgStrs) {
                    let re = new RegExp('\\$' + this.fieldsHelper.regexpStrs_FieldName, 'g');
                    let matches = argStr.matchAll(re);
                    for (let match of matches) {
                        let fieldFn_ArgFieldInfo = this.fieldsHelper.def(repeatInfo, match[1], 
                                false, abFields.VarDefinition);
        
                        this.fieldFn_ArgFields.push({
                            path: match[1],
                            fieldInfo: fieldFn_ArgFieldInfo,
                        });

                        for (let fieldFn_ArgFieldInfo_FD of fieldFn_ArgFieldInfo.fieldDefinitions)
                            this.fieldDefinitions.push(fieldFn_ArgFieldInfo_FD);
                    }
                }
            }

            this.field_Parts = fieldMatch[1];
            this.field_Parts = this.field_Parts.split('.');
            this.field_Name = this.field_Parts[this.field_Parts.length - 1];
        } else
            throw new Error(`Unknown 'FieldInfo' type of: ` + fieldPath);
    }

    getEval($evalStr, $argFields, $fields, $keys)
    {
        // return eval($evalStr);
        return Function('"use strict";return function($argFields, $fields, $keys) {' + 
                'return ' + $evalStr + '}')()($argFields, $fields, $keys);
    }

    getEvalStr(evalStr, argFields, fields, keys)
    {
        for (let argIndex = 0; argIndex < argFields.length; argIndex++) {
            let value = `$argFields[${argIndex}].fieldInfo.getValue($fields, $keys)`;
            evalStr = evalStr.replace(new RegExp('\\$\\{' + 
                    abStrings.escapeRegExpChars(argFields[argIndex].path) + '\\}' +
                    '([^a-zA-Z0-9]|$)', 'g'), value + '$1');
            evalStr = evalStr.replace(new RegExp('\\$' + 
                    abStrings.escapeRegExpChars(argFields[argIndex].path) + 
                    '([^a-zA-Z0-9]|$)', 'g'), value + '$1');
        }

        return evalStr.replace(/([^a-zA-Z0-9]|^)this([^a-zA-Z0-9]|$)/g, '$1undefined$2');
    }
    
    getValue(fields, keys, valueType)
    {
        if (this.type === Types.Field) {
            let field = this.getField(fields, keys);
            if (field === null)
                return undefined;

            return field.$value;
        } else if (this.type === Types.Function) {
            let field = this.getField(fields, keys);
            if (field === null)
                return undefined;
                
            let fnVal = field.$value;
            if (fnVal === null || typeof fnVal === 'undefined')
                return undefined;

            let argsArr = [];
            for (let argStr of this.fieldFn_ArgStrs) {
                // console.log(new Error());
                let evalStr = this.getEvalStr(argStr, this.fieldFn_ArgFields, 
                        fields, keys);
                try {
                    argsArr.push(this.getEval(evalStr, this.fieldFn_ArgFields, fields, keys));
                } catch (err) {
                    throw new Error(`Error evaluating function '$${this.field_Parts}(${argStr})` +  
                            err);
                }            
                
            }

            return fnVal.apply(null, argsArr);
            // let evalStr_Original = `(${fnVal})(${this.fieldFn_ArgFieldsStr})`;
            // let evalStr = this.getEvalStr(this.fieldFn_ArgFieldsStr,
            //         this.fieldFn_ArgFields, fields, keys);
            // evalStr = `(${fnVal})(${evalStr})`;

            // try {
            //     return this.getEval(evalStr);
            // } catch (err) {
            //     throw new Error(`Error evaluating function '$${this.field_Parts}:${evalStr_Original}': ` +  
            //             err);
            // }    
        } else if (this.type === Types.Expression) {
            let evalStr = this.getEvalStr(this.expr, this.expr_ArgFields, fields, keys);

            try {
                return this.getEval(evalStr, this.expr_ArgFields, fields, keys);
            } catch (err) {
                if (spocky.Debug)
                    console.error(evalStr);
                throw new Error(`Error evaluating expression "${this.expr}": ` + err);
            }
        } else
            throw new Error(`Unknown 'FieldInfo' type.`);
    }

    getField(fields, keys)
    {
        js0.args(arguments, [ abFields.ObjectField, js0.Null], Array);

        let rawParts = this.getRawParts(this.repeatInfo);
        // keys = this.repeatInfo.getKeys(this, keys);

        let keysOffset = 0;
        let field = fields;
        let fieldPath = '';
        let repeatsOffset = 0;
        for (let part of rawParts) {
            if (field instanceof abFields.ObjectField) {
                field = field.$get(part);
                fieldPath += (fieldPath !== '' ? '.' : '') + part;
            }

            while (field instanceof abFields.ListField) {
                let repeatFound = false;
                for (let i = repeatsOffset; i < this.repeatInfo.repeats.length; i++) {
                    if (fieldPath === this.repeatInfo.repeats[i].fieldInfo.getFullPath(
                            this.repeatInfo)) {
                        if (keys[i] === null || typeof keys[i] === 'undefined')
                            throw new Error('Instance keys to lists inconsistency.');

                        field = field.$get(keys[i]);
                        repeatsOffset = i + 1;
                        repeatFound = true;
                        break;
                    }
                }

                if (!repeatFound)
                    break;
                    // throw new Error('Instance keys to lists inconsistency.');
            }
        }

        return field;
    }

    getFullPath(repeatInfo)
    {
        let rawParts = this.getRawParts(repeatInfo);
        return rawParts.join('.');
    }

    getRawParts(repeatInfo)
    {
        let rawParts = this.field_Parts.slice();

        /* Get all raw parts. */
        for (let i = repeatInfo.repeats.length - 1; i >= 0; i--) {
            if (rawParts[0] !== repeatInfo.repeats[i].itemName)
                continue;

            rawParts.splice(0, 1);
            rawParts = repeatInfo.repeats[i].fieldInfo.field_Parts.concat(rawParts);
            // rawParts.splice(0, 0, repeatInfo.repeats[i].fieldInfo.parts);
        }

        return rawParts;
    }

}


class Types
{

    static get Field()      { return 1; }
    static get Function()   { return 2; }
    static get Expression() { return 3; }

}

class ValueTypes
{

    static get Bool()       { return 1; }
    static get Function()   { return 2; }
    static get List()       { return 3; }
    static get Object()     { return 4; }
    static get Text()       { return 5; }

}

module.exports = FieldInfo;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\spocky\LayoutParser.FieldsHelper.js
jsLibs.exportModule('spocky', 'LayoutParser.FieldsHelper', (require, module, exports) => { 'use strict';

const
    abFields = require('ab-fields'),
    js0 = require('js0'),

    FieldInfo = require('./LayoutParser.FieldInfo')
;

class FieldsHelper
{

    static get Types() {
        return Types;
    }


    constructor()
    {
        this._fieldDefinitions = abFields.define();
        this._fieldInfos = [];

        this.regexpStrs_Expression = '\\?\\(((\\s|\\S)+)\\)';
        this.regexpStrs_FieldName = '([a-zA-Z][a-zA-Z0-9._]*)+?(\\((.*?)\\))?';
    }

    def(repeatInfo, fieldPath, includesPrefix, requiredFieldDefinitionClass)
    {
        js0.args(arguments, require('./LayoutParser.RepeatInfo'), 'string',
                'boolean', 'function');

        let fieldInfo = new FieldInfo(this, repeatInfo, fieldPath, includesPrefix);

        if (fieldInfo.type === FieldInfo.Types.Field) {
            fieldInfo.fieldDefinitions.push(this._define(fieldInfo, repeatInfo, 
                    requiredFieldDefinitionClass));
        } else if (fieldInfo.type === FieldInfo.Types.Function) {
            fieldInfo.fieldDefinitions.push(this._define(fieldInfo, repeatInfo, 
                    requiredFieldDefinitionClass));
        } else if (fieldInfo.type === FieldInfo.Types.Expression) {
            
        }
        
        return fieldInfo;
    }

    getFieldName(fieldPath, includesPrefix)
    {
        js0.args(arguments, 'string', 'boolean');

        if (includesPrefix) {
            if (fieldPath[0] !== '$')
                return null;

            if (fieldPath[1] === '{') {
                if (fieldPath[fieldPath.length - 1] !== '}')
                    return null;

                return fieldPath.substring(2, fieldPath.length - 1);
            }

            return fieldPath.substring(1);
        }

        return fieldPath;
    }

    getType(fieldDefintion)
    {

    }

    getValue(fieldDefintion, value, keys)
    {
        let field = this.find(fieldDefintion);
        if (field === null)
            throw Error('Field not defined: ' + fieldDefintion);

        return typeof value === 'function' ? 
                eval(`value(${fieldInfo.args})`) : value;
    }

    find(fieldDefintion)
    {
        for (let field of this._fields) {
            if (field.definition === fieldDefintion)
                return field;
        }

        return null;
    }

    isFieldName(str, includesPrefix)
    {
        js0.args(arguments, 'string', 'boolean');

        if (includesPrefix) {
            if (str[0] !== '$')
                return false;

            if (str[1] === '{') {
                if (str[str.length - 1] !== '}')
                    return false;

                return str.substring(2, str.length - 1)
                        .match(new RegExp(
                        '^' + this.regexpStrs_FieldName + '$')) !== null;    
            }

            return str.substring(1).match(
                    new RegExp('^' + this.regexpStrs_FieldName + '$')) !== null;
        }

        return str.match(new RegExp('^' + this.regexpStrs_FieldName + '$')) !== null;
    }

    isExpression(str)
    {
        js0.args(arguments, 'string', [ 'boolean', js0.Default ]);

        return str.match(new RegExp('^' + this.regexpStrs_Expression + '$', 'm')) !== null;
    }

    isValidString(str, includesPrefix)
    {
        js0.args(arguments, 'string', 'boolean');

        return this.isFieldName(str, includesPrefix) || this.isExpression(str);
    }

    matchField(fieldPath)
    {
        js0.args(arguments, 'string');

        return fieldPath.match(this.regexpStrs_FieldName);
    }

    validateFieldName(fieldName, includesPrefix)
    {
        js0.args(arguments, 'string', 'boolean');

        if (!this.isFieldName(fieldName, includesPrefix))
            throw new Error(`'${fieldName}' is not a valid field name.`);
    }

    validateProperty(property, includesPrefix)
    {
        js0.args(arguments, 'string', 'boolean');

        if (!this.isValidString(property, includesPrefix))
            throw new Error(`'${property}' is not a valid property.`);
    }

    _add(fieldDefintion, fieldInfo)
    {
        js0.args(arguments, abFields.Definition);

        let field = this.find(fieldDefintion);

        if (field === null)
            field = new Field(fieldDefintion);
        
        this._fields.push(field);
    }

    _define(fieldInfo, repeatInfo, newFieldDefinitionClass)
    {
        let fd = this._fieldDefinitions;
        let repeatOffset = 0;

        /* Check if is list. */
        let firstPart = fieldInfo.field_Parts[0];
        let repeatFound = false;
        for (let i = repeatInfo.repeats.length - 1; i >= repeatOffset; i--) {
            if (firstPart !== repeatInfo.repeats[i].itemName)
                continue;
            repeatFound = true;

            fd = repeatInfo.repeats[i].fieldDefinition;
            if (fieldInfo.field_Parts.length === 1)
                return fd.item(newFieldDefinitionClass);
            
            fd = fd.item(abFields.ObjectDefinition);
        }

        for (let i = repeatFound ? 1 : 0; i < fieldInfo.field_Parts.length - 1; i++) {
            let part = fieldInfo.field_Parts[i];
            fd = fd.object(part);
        }

        let lastPart = fieldInfo.field_Parts[fieldInfo.field_Parts.length - 1];

        // let field = null;
        // let fieldExists = fd.exists(lastPart);

        // let fieldIsVar = fieldExists ? 
        //         (fd.get(lastPart) instanceof abFields.VarDefinition ? true : false) : 
        //         false;
        // fieldExists = false;
        // fieldIsVar = false;

        if (newFieldDefinitionClass === abFields.ObjectDefinition)
            return fd.object(lastPart, false);
        else if (newFieldDefinitionClass === abFields.ListDefinition)
            return fd.list(lastPart, false);
        else if (newFieldDefinitionClass === abFields.VarDefinition) {
            // if (fieldExists && !fieldIsVar)
            //     return fd.get(lastPart);

            return fd.var(lastPart);
        } else
           throw new Error(`Unknown 'newFieldDefinitionClass'.`);
    }

}


class Field
{

    constructor(fieldDefintion)
    {
        this.definition = fieldDefintion;
    }

}


class Types
{

    static get Var() { return 1; }
    static get Function() { return 2; }
    static get Expression() { return 3; }

}

module.exports = FieldsHelper;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\spocky\LayoutParser.Holders.js
jsLibs.exportModule('spocky', 'LayoutParser.Holders', (require, module, exports) => { 'use strict';

const
    js0 = require('js0')
;

class Holders
{

    constructor()
    {
        
    }

}

module.exports = Holders;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\spocky\LayoutParser.RepeatInfo.js
jsLibs.exportModule('spocky', 'LayoutParser.RepeatInfo', (require, module, exports) => { 'use strict';

const
    js0 = require('js0'),

    FieldInfo = require('./LayoutParser.FieldInfo')
;

class RepeatInfo
{

    constructor(elementsStack)
    {
        this.repeats = [];
        this.virtual = false;

        for (let i = 0; i < elementsStack.length; i++) {
            let element = elementsStack[i];

            if ('repeat' in element.info) {
                this.repeats.push(element.info.repeat);
                this.virtual = true;
            }
        }
    }

    // getKeys(fieldInfo, keys)
    // {
    //     let repeatKeys = [];
    //     for (let i = 0; i < this.repeats.length; i++)
    //         repeatKeys.push(null);

    //     let rawFieldParts = fieldInfo.getRawParts(this);
    //     let fullFieldPath = rawFieldParts.join('.');
    //     let keysIndex = keys.length - 1;
        
    //     for (let i = this.repeats.length - 1; i >= 0; i--) {
    //         let repeatFieldPath = this.repeats[i].fieldInfo
    //                 .getFullPath(this);
    //         if (fullFieldPath.indexOf(repeatFieldPath) === 0) {
    //             repeatKeys[i] = keys[keysIndex];
    //             keysIndex--;
    //             if (keysIndex < 0)
    //                 break;
    //             // fullFieldPath = fullFieldPath.substring(repeatFieldPath.length);
    //             // if (fullFieldPath[0] === '.')
    //             //     fullFieldPath = fullFieldPath.substring(1);
    //         }
    //     }
        
    //     return repeatKeys;
    // }

    getKeys(fieldInfos, keys)
    {
        let repeatKeys = [];
        for (let i = 0; i < this.repeats.length; i++)
            repeatKeys.push(null);

        if (keys.length === 0)
            return repeatKeys;

        let keysIndex = keys.length - 1;
        
        for (let i = this.repeats.length - 1; i >= 0; i--) {
            for (let fieldInfo of fieldInfos) {
                let rawFieldParts = fieldInfo.getRawParts(this);
                let fullFieldPath = rawFieldParts.join('.');
                
                let repeatFieldPath = this.repeats[i].fieldInfo
                        .getFullPath(this);
                if (fullFieldPath.indexOf(repeatFieldPath) === 0) {
                    repeatKeys[i] = keys[keysIndex];
                    keysIndex--;
                    if (keysIndex < 0)
                        break;
                    // fullFieldPath = fullFieldPath.substring(repeatFieldPath.length);
                    // if (fullFieldPath[0] === '.')
                    //     fullFieldPath = fullFieldPath.substring(1);
                }
            }

            if (keysIndex < 0)
                break;
        }
        
        return repeatKeys;
    }

}

module.exports = RepeatInfo;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\spocky\Module.js
jsLibs.exportModule('spocky', 'Module', (require, module, exports) => { 'use strict';

const
    abLayouts = require('ab-layouts'),
    abNodes = require('ab-nodes'),
    js0 = require('js0'),

    Layout = require('./Layout'),
    Viewable = require('./Viewable')
;

class Module
{

    get $name() {
        return this.constructor.name;
    }

    set $view(value) {
        if (!js0.type(value, [ require('./Layout'), require('./Module'), js0.Null ]))
            throw new Error(`'$view' must be 'Layout', 'Module' or 'Null'.`);

        if (this._$view === value)
            return;

        if (this._$view !== null)
            this._$view._$viewable.deactivate();

        this._$view = value;
        if (this._$view !== null && this._$parentNode !== null)
            this._$view._$viewable.activate(this._$parentNode);
    }


    constructor()
    {
        js0.prop(this, Module.Viewable, this);

        Object.defineProperties(this, {
            _$view: { value: null, writable: true, },
            _$parentNode: { value: null, writable: true, },

            _$listeners: { value: {
                onActivate: [],
                onDeactivate: [],
            }},
        });
    }

    $onActivate(listener)
    {
        this._$listeners.onActivate.push(listener);
    }

    $onDeactivate(listener)
    {
        this._$listeners.onDeactivate.push(listener);
    }

}
module.exports = Module;


Object.defineProperties(Module, {

    Viewable: { value:
    class Module_Viewable extends Viewable {

        constructor(module)
        { super()
            js0.args(arguments, Module);

            this._module = module;
            this._onDisplay = (displayed) => {
                for (let listener of this._module._$listeners.onDisplay)
                    listener(displayed);
            };
        }

        __activate(parentNode)
        {
            this._module._$parentNode = parentNode;
            // console.log(parentNode, 'Added listener.');

            if (this._module._$view === null) {
                // Do nothing.
            } else if (js0.type(this._module._$view, js0.Prop(Viewable)))
                this._module._$view._$viewable.activate(parentNode);
            else
                js0.assert(`Unknown view type.`);

            for (let listener of this._module._$listeners.onActivate)
                listener();
        }

        __deactivate(parentNode)
        {
            for (let listener of this._module._$listeners.onDeactivate)
                listener();

            if (this._module._$view === null)
                return;
            else if (js0.type(this._module._$view, js0.Prop(Viewable)))
                this._module._$view._$viewable.deactivate();
            else
                js0.assert(`Unknown view type.`);

            this._module._$parentNode = null;
        }

    }},

});





 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\spocky\PathInfo.js
jsLibs.exportModule('spocky', 'PathInfo', (require, module, exports) => { 'use strict';

class PathInfo {

    constructor(importPath)
    {
        let separatorIndex = importPath.lastIndexOf('.');
        let packagePath = importPath.substring(0, separatorIndex);
        let name = importPath.substring(separatorIndex + 1);

        Object.defineProperties(this, {
            path: { value: importPath, },
            name: { value: name, },
            packagePath: { value: packagePath, },
        });
    }

}
module.exports = PathInfo





 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\spocky\LayoutParser.js
jsLibs.exportModule('spocky', 'LayoutParser', (require, module, exports) => { 'use strict';

const
    abFields = require('ab-fields'),
    abLayouts = require('ab-layouts'),
    abNodes = require('ab-nodes'),
    js0 = require('js0'),

    spocky = require('.'),
    Holder = require('./Holder'),

    Elems = require('./LayoutParser.Elems'),
    FieldInfo = require('./LayoutParser.FieldInfo'),
    FieldsHelper =  require('./LayoutParser.FieldsHelper'),
    Holders = require('./LayoutParser.Holders'),
    RepeatInfo = require('./LayoutParser.RepeatInfo')
;

class LayoutParser extends abLayouts.Parser
{

    get data() {
        return this._data;
    }

    get elems() {
        return this._elems;
    }

    get fields() {
        return this._fields;
    }

    get holders() {
        return this._holders;
    }


    constructor()
    {
        super();

        this._fieldsHelper = new FieldsHelper();

        this._fields = null;        
        this._elems = new Elems();
        this._holders = new Holders();
        this._data = {};
    }


    _createContentElement(nodeInfo, elementsStack)
    {
        let node = this._createTextNode(nodeInfo.content, elementsStack);

        return new abLayouts.Parser.Element(node, node, null);
    }

    _createElement(nodeInfo, elementsStack)
    {
        let element = new abLayouts.Parser.Element(null, null, {});

        this._createElement_AddRepeat(nodeInfo, elementsStack, element);
        let tElementsStack = elementsStack.concat([ element ]);
        this._createElement_AddHide(nodeInfo, tElementsStack, element);
        this._createElement_AddShow(nodeInfo, tElementsStack, element);
        this._createElement_AddSingle(nodeInfo, tElementsStack, element);
        this._createElement_AddField(nodeInfo, tElementsStack, element);
        this._createElement_AddHolder(nodeInfo, tElementsStack, element);
        this._createElement_ParseElem(nodeInfo, tElementsStack, element);
        this._createElement_ParseData(nodeInfo, tElementsStack, element);

        return element;
    }

    _createElement_AddField(nodeInfo, elementsStack, element)
    {
        if (!('_field' in nodeInfo.attribs))
            return;
        if (nodeInfo.type === '$')
            throw new Error(`'_field' cannot be in virtual node.`);
        this._fieldsHelper.validateProperty(nodeInfo.attribs._field[0], false);

        let node = element.bottomNode;

        let repeatInfo = new RepeatInfo(elementsStack);
        let fieldInfo = this._fieldsHelper.def(repeatInfo, nodeInfo.attribs._field[0],
                false, abFields.VarDefinition);

        /* Default */
        node.innerHTML = fieldInfo.getValue(this._fields, []);

        /* Field Listeners */
        for (let fd of fieldInfo.fieldDefinitions) {
            fd.addListener({
                change: (value, keys) => {
                    this._runOnUIThread(() => {
                        let nodeInstances = this._getNodeInstances(repeatInfo, fieldInfo, 
                                node, keys);
                        for (let nodeInstance of nodeInstances) {
                            let instanceKeys = nodeInstance.pCopyable.getInstanceKeys();
                            nodeInstance.htmlElement.innerHTML = fieldInfo.getValue(
                                    this._fields, instanceKeys);
                        }
                    });
                },
            });
        }

        /* Virtual */
        if (repeatInfo.virtual) {
            node.pCopyable.onCreate((nodeInstance, instanceKeys) => {  
                /* Virtual Node */
                if (instanceKeys.length < repeatInfo.repeats.length)
                    return;

                let value = fieldInfo.getValue(this._fields, instanceKeys);

                this._runOnUIThread(() => {
                    let nodeInstances = node.pCopyable.getNodeCopies(instanceKeys);
                    for (let nodeInstance of nodeInstances)
                        nodeInstance.htmlElement.innerHTML = value;
                });
            });
        }
    }

    _createElement_AddHide(nodeInfo, elementsStack, element)
    {
        if (!('_hide' in nodeInfo.attribs))
            return;
            this._fieldsHelper.validateProperty(nodeInfo.attribs._hide[0], false);

        let node = new abNodes.HideNode();
        this._createElement_UpdateElement(element, node);

        let repeatInfo = new RepeatInfo(elementsStack);
        let fieldInfo = this._fieldsHelper.def(repeatInfo, nodeInfo.attribs._hide[0],
                false, abFields.VarDefinition);
    
        /* Default */
        node.hide = fieldInfo.getValue(this._fields, []) ? true : false;

        /* Field Listeners */
        for (let fd of fieldInfo.fieldDefinitions) {
            fd.addListener({
                change: (value, keys) => {
                    this._runOnUIThread(() => {
                        let nodeInstances = this._getNodeInstances(repeatInfo, fieldInfo, 
                                node, keys);
                        for (let nodeInstance of nodeInstances) {
                            let instanceKeys = nodeInstance.pCopyable.getInstanceKeys();
                            nodeInstance.hide = fieldInfo.getValue(
                                    this._fields, instanceKeys) ? true : false;
                        }
                    });
                },
            });
        }

        /* Virtual */
        if (repeatInfo.virtual) {
            node.pCopyable.onCreate((nodeInstance, instanceKeys) => {
                /* Virtual Node */
                if (instanceKeys.length < repeatInfo.repeats.length)
                    return;

                let value = fieldInfo.getValue(this._fields, instanceKeys);

                this._runOnUIThread(() => {
                    let nodeInstances = node.pCopyable.getNodeCopies(instanceKeys);
                    for (let nodeInstance of nodeInstances)
                        nodeInstance.hide = value ? true : false;
                });
            });
        }
    }

    _createElement_AddHolder(nodeInfo, elementsStack, element)
    {
        if (!('_holder' in nodeInfo.attribs))
            return;

        let node = new abLayouts.LayoutNode();
        this._createElement_UpdateElement(element, node);

        let repeatInfo = new RepeatInfo(elementsStack);

        if (repeatInfo.virtual) {
            element.info.holders_OnCreateFn = null;
            element.info.holders_OnDestroyFn = null;

            // this._elems._declare(elemName);
            node.pCopyable.onCreate((node) => {
                let keys = node.pCopyable.getInstanceKeys();
                
                /* Virtual Node */
                if (keys.length < repeatInfo.repeats.length)
                    return;

                // this._elems._add(elemName, keys, node.htmlElement);

                if (element.info.holders_OnCreateFn !== null) {
                    element.info.holders_OnCreateFn(new Holder(node), keys);
                }
            });
            node.pCopyable.onDestroy((node) => {
                let keys = node.pCopyable.getInstanceKeys();

                // this._elems._remove(elemName, keys);

                if (element.info.holders_OnDestroyFn !== null) {
                    element.info.holders_OnDestroyFn(keys);
                }
            });

            Object.defineProperty(this._holders, nodeInfo.attribs._holder, {
                get: () => {
                    return (onCreateFn) => {
                        element.info.holders_OnCreateFn = onCreateFn;

                        this._runOnUIThread(() => {
                            let nodeInstances = node.pCopyable.getNodeCopies();
                            for (let nodeInstance of nodeInstances) {
                                let instanceKeys = nodeInstance.pCopyable.getInstanceKeys();
                                onCreateFn(new Holder(nodeInstance), instanceKeys);
                            }
                        });
                    };
                }
            });
        } else {
            Object.defineProperty(this._holders, nodeInfo.attribs._holder, {
                value: new Holder(node), 
                enumerable: true,
            });
        }
    }

    _createElement_AddRepeat(nodeInfo, elementsStack, element)
    {
        if (!('_repeat' in nodeInfo.attribs))
            return;

        let repeatNameArr = nodeInfo.attribs._repeat[0].split(':');
        if (repeatNameArr.length !== 2)
            throw new Error('Repeat format must be `[fieldName]:[itemFieldName].');

        let fieldName = repeatNameArr[0];
        let itemName = repeatNameArr[1];

        this._fieldsHelper.validateFieldName(fieldName, false);
        this._fieldsHelper.validateFieldName(itemName, false);

        let node = new abNodes.RepeatNode();
        this._createElement_UpdateElement(element, node);

        let repeatInfo = new RepeatInfo(elementsStack);
        let fieldInfo = this._fieldsHelper.def(repeatInfo, fieldName,
                false, abFields.ListDefinition);

        let fd = fieldInfo.fieldDefinitions[0];

        element.info.repeat = {
            node: node,
            fieldInfo: fieldInfo,
            itemName: itemName,
            fieldDefinition: fd,
        };
        
        fd.addListener({
            add: (index, key, keys) => {
                this._runOnUIThread(() => {
                    let nodeInstances = this._getNodeInstances(repeatInfo, fieldInfo, 
                            node, keys);

                    for (let nodeInstance of nodeInstances)
                        nodeInstance.addAt(index, key);
                });
            },
            delete: (key, keys) => {
                this._runOnUIThread(() => {
                    let nodeInstances = this._getNodeInstances(repeatInfo, fieldInfo, 
                            node, keys);
                    for (let nodeInstance of nodeInstances)
                        nodeInstance.delete(key);
                });
            },
        });

        if (repeatInfo.virtual) {
            node.pCopyable.onCreate((nodeInstance, instanceKeys) => {
                /* Virtual Node */
                if (instanceKeys.length < repeatInfo.repeats.length)
                    return;

                let field = fieldInfo.getField(this._fields, instanceKeys);

                this._runOnUIThread(() => {
                    let nodeInstances = node.pCopyable.getNodeCopies(instanceKeys);
                    for (let nodeInstance of nodeInstances) {
                        for (let [ key, value ] of field)
                            nodeInstance.add(key);
                    }
                });
            });
        }

        // if ('_id' in nodeInfo.attribs)
        //     this._nodes.set(`${nodeInfo.attribs._id}.single`, node);
    }

    _createElement_AddShow(nodeInfo, elementsStack, element)
    {
        if (!('_show' in nodeInfo.attribs))
            return;
        this._fieldsHelper.validateProperty(nodeInfo.attribs._show[0], false);

        let node = new abNodes.ShowNode();
        this._createElement_UpdateElement(element, node);

        let repeatInfo = new RepeatInfo(elementsStack);
        let fieldInfo = this._fieldsHelper.def(repeatInfo, nodeInfo.attribs._show[0],
                false, abFields.VarDefinition);

        /* Default */
        node.show = fieldInfo.getValue(this._fields, []) ? true : false;

        /* Field Listeners */
        for (let fd of fieldInfo.fieldDefinitions) {
            fd.addListener({
                change: (value, keys) => {
                    this._runOnUIThread(() => {
                        let nodeInstances = this._getNodeInstances(repeatInfo, fieldInfo, 
                                node, keys);
                        for (let nodeInstance of nodeInstances) {
                            let instanceKeys = nodeInstance.pCopyable.getInstanceKeys();
                            nodeInstance.show = fieldInfo.getValue(
                                    this._fields, instanceKeys) ? true : false;
                        }
                    });
                },
            });
        }

        /* Virtual */
        if (repeatInfo.virtual) {
            node.pCopyable.onCreate((nodeInstance, instanceKeys) => {
                /* Virtual Node */
                if (instanceKeys.length < repeatInfo.repeats.length)
                    return;

                let value = fieldInfo.getValue(this._fields, instanceKeys);

                this._runOnUIThread(() => {
                    let nodeInstances = node.pCopyable.getNodeCopies(instanceKeys);
                    for (let nodeInstance of nodeInstances)
                        nodeInstance.show = value ? true : false;
                });
            });
        }
    }

    _createElement_AddSingle(nodeInfo, elementsStack, element)
    {
        if (nodeInfo.type === '$')
            return;

        let repeatInfo = new RepeatInfo(elementsStack);

        let node = new abNodes.SingleNode(nodeInfo.type);
        this._createElement_UpdateElement(element, node);

        this._createElement_AddSingle_ParseAttribs(repeatInfo, node, nodeInfo.attribs);
    }

    _createElement_AddSingle_ParseAttribs(repeatInfo, node, attribs)
    {
        for (let attribName in attribs) {
            // if (attribName[0] === '$')
            //     continue;

            let attribArr = attribs[attribName];
            let attribArr_FieldInfos = [];
            for (let attribPart of attribArr) {
                if (!this._fieldsHelper.isValidString(attribPart, true)) {
                    attribArr_FieldInfos.push(null);
                    continue;
                }

                let fieldInfo = this._fieldsHelper.def(repeatInfo, attribPart,
                        true, abFields.VarDefinition);
                attribArr_FieldInfos.push(fieldInfo);

                for (let fd of fieldInfo.fieldDefinitions) {
                    fd.addListener({
                        change: (value, keys) => {
                            this._runOnUIThread(() => {
                                let nodeInstances = this._getNodeInstances(repeatInfo, 
                                        fieldInfo, node, keys);
                                for (let nodeInstance of nodeInstances) {
                                    let instanceKeys = nodeInstance.pCopyable.getInstanceKeys();
                                    let attrib = this._createElement_AddSingle_GetAttrib(
                                            attribArr, attribArr_FieldInfos, instanceKeys);

                                    if (attribName in nodeInstance.htmlElement)
                                        nodeInstance.htmlElement[attribName] = attrib;
                                    else
                                        nodeInstance.htmlElement.setAttribute(attribName, attrib);
                                }
                            });
                        },
                    });
                }
            }

            /* Default */
            let attrib = this._createElement_AddSingle_GetAttrib(
                    attribArr, attribArr_FieldInfos, []);
            if (attribName in node.htmlElement)
                node.htmlElement[attribName] = attrib;
            else
                node.htmlElement.setAttribute(attribName, attrib);

            /* Virtual */
            if (repeatInfo.virtual) {
                node.pCopyable.onCreate((nodeInstance, instanceKeys) => {
                    /* Virtual Node */
                    if (instanceKeys.length < repeatInfo.repeats.length)
                        return;

                    let attrib = this._createElement_AddSingle_GetAttrib(
                            attribArr, attribArr_FieldInfos, instanceKeys);
                    if (attribName in nodeInstance.htmlElement)
                        nodeInstance.htmlElement[attribName] = attrib;
                    else
                        nodeInstance.htmlElement.setAttribute(attribName, attrib);
                });
            }
        }
    }

    _createElement_AddSingle_GetAttrib(attribArr, attribArr_FieldInfos, instanceKeys)
    {
        let attrib = '';
        for (let i = 0; i < attribArr.length; i++) {
            if (attribArr_FieldInfos[i] !== null) {
                attrib += attribArr_FieldInfos[i].getValue(this._fields, instanceKeys);
            } else
                attrib += attribArr[i];
        }

        return attrib;
    }

    _createElement_ParseData(nodeInfo, elementsStack, element)
    {
        for (let attribName in nodeInfo.attribs) {
            if (attribName.indexOf('_data-') !== 0)
                continue;

            let attribArr = nodeInfo.attribs[attribName];

            let dataName = attribName.substring(`_data-`.length);
            let data = attribArr[0].replace(/\\"/g, '"');
    
            if (!(dataName in this._data))
                this._data[dataName] = [];
    
            this._data[dataName].push(data);
        }
    }

    _createElement_ParseElem(nodeInfo, elementsStack, element)
    {
        if (!('_elem' in nodeInfo.attribs))
            return;

        let elemName = nodeInfo.attribs._elem[0];
        if (this._elems.$exists(elemName)) {
            if (spocky.Debug) {
                console.warn(`Element '${elemName}' already exist. Skipping in:`, 
                        nodeInfo, new Error());
            }

            return;
        }

        let node = element.bottomNode;

        let repeatInfo = new RepeatInfo(elementsStack);

        if (repeatInfo.virtual) {
            element.info.elems_OnCreateFn = null;
            element.info.elems_OnDestroyFn = null;

            this._elems._declare(elemName);
            node.pCopyable.onCreate((node) => {
                let keys = node.pCopyable.getInstanceKeys();

                /* Virtual Node */
                if (keys.length < repeatInfo.repeats.length)
                    return;

                this._elems._add(elemName, keys, node.htmlElement);

                if (element.info.elems_OnCreateFn !== null) {
                    element.info.elems_OnCreateFn(node.htmlElement, keys);
                }
            });
            node.pCopyable.onDestroy((node) => {
                let keys = node.pCopyable.getInstanceKeys();

                this._elems._remove(elemName, keys);

                if (element.info.elems_OnDestroyFn !== null) {
                    element.info.elems_OnDestroyFn(node.htmlElement, keys);
                }
            });

            Object.defineProperty(this._elems, nodeInfo.attribs._elem, {
                get: () => {
                    return (onCreateFn) => {
                        element.info.elems_OnCreateFn = onCreateFn;
                        
                        this._runOnUIThread(() => {
                            let nodeInstances = node.pCopyable.getNodeCopies();
                            for (let nodeInstance of nodeInstances) {
                                let instanceKeys = nodeInstance.pCopyable.getInstanceKeys();
                                onCreateFn(nodeInstance.htmlElement, instanceKeys);
                            }
                        });
                    };
                }
            });
        } else {
            this._elems._declare(elemName);
            this._elems._add(elemName, [], node.htmlElement);

            Object.defineProperty(this._elems, nodeInfo.attribs._elem, {
                get: () => {
                    return node.htmlElement;
                }
            });
        }
    }

    _createElement_UpdateElement(element, new_bottom_node)
    {
        if (element.topNode === null)
            element.topNode = new_bottom_node;
        if (element.bottomNode !== null)
            element.bottomNode.pChildren.add(new_bottom_node);
        element.bottomNode = new_bottom_node;
    }

    _createTextNode(nodeContent, elementsStack)
    {
        let node = null;

        if (this._fieldsHelper.isValidString(nodeContent, true)) {
            let repeatInfo = new RepeatInfo(elementsStack);
            let fieldInfo = this._fieldsHelper.def(repeatInfo, nodeContent,
                    true, abFields.VarDefinition);
            
            node = new abNodes.TextNode(fieldInfo.getValue(this._fields, []));

            for (let fd of fieldInfo.fieldDefinitions) {
                fd.addListener({
                    change: (value, keys) => {
                        this._runOnUIThread(() => {
                            let nodeInstances = this._getNodeInstances(repeatInfo, fieldInfo, 
                                    node, keys);

                            for (let nodeInstance of nodeInstances) {
                                nodeInstance.text = fieldInfo.getValue(this._fields, 
                                        nodeInstance.pCopyable.getInstanceKeys());
                            }
                        });
                    },
                });
            }

            if (repeatInfo.virtual) {
                node.pCopyable.onCreate((nodeInstance, instanceKeys) => {
                    /* Virtual Node */
                    if (instanceKeys.length < repeatInfo.repeats.length)
                        return;

                    let value = fieldInfo.getValue(this._fields, instanceKeys);

                    this._runOnUIThread(() => {
                        let nodeInstances = node.pCopyable.getNodeCopies(instanceKeys);
                        for (let nodeInstance of nodeInstances)
                            nodeInstance.text = value;
                    });
                });
            }
        } else
            node = new abNodes.TextNode(nodeContent);

        return node;
    }

    _getNodeInstances(repeatInfo, fieldInfo, node, keys)
    {
        if (repeatInfo.repeats.length === 0)
            return [ node ];

        let fieldInfos_Requested = [];

        /* Main Field */
        if (fieldInfo.type === FieldInfo.Types.Field || 
                fieldInfo.type === FieldInfo.Types.Function)
            fieldInfos_Requested.push(fieldInfo);
        
        /* Arg Fields */
        if (fieldInfo.type === FieldInfo.Types.Function) {
            for (let argField of fieldInfo.fieldFn_ArgFields)
                fieldInfos_Requested.push(argField.fieldInfo);
        }

        if (fieldInfo.type === FieldInfo.Types.Expression) {
            for (let argField of fieldInfo.expr_ArgFields)
                fieldInfos_Requested.push(argField.fieldInfo);
        }

        /* Node Copies */
        // console.log('###', fieldInfos_Requested);
        // let nodeCopies = [];
        // for (let fieldInfo_Requested of fieldInfos_Requested) {
        //     let repeatKeys = repeatInfo.getKeys(fieldInfo_Requested, keys);
        //     console.log('Here', repeatKeys);
        //     let nodeCopies_T = node.pCopyable.getNodeCopies(repeatKeys);
        //     console.log(nodeCopies_T);
        //     for (let nodeCopy_T of nodeCopies_T) {
        //         if (!nodeCopies.includes(nodeCopy_T))
        //             nodeCopies.push(nodeCopy_T);
        //     }
        // }

        let nodeCopies = [];
        let repeatKeys = repeatInfo.getKeys(fieldInfos_Requested, keys);
        let nodeCopies_T = node.pCopyable.getNodeCopies(repeatKeys);
        for (let nodeCopy_T of nodeCopies_T) {
            if (!nodeCopies.includes(nodeCopy_T))
                nodeCopies.push(nodeCopy_T);
        }

        return nodeCopies;
    }

    _isVirtual(elementsStack)
    {
        for (let i = 0; i < elementsStack.length; i++) {
            if ('repeat' in elementsStack[i].info)
                return true;
        }

        return false;
    }

    _runOnUIThread(fn)
    {
        fn();
        // setTimeout(fn, 10);
    }


    /* abLayouts.Parser Overrides */
    __afterParse()
    {
        this._fields = this._fieldsHelper._fieldDefinitions.create();
    }
    
    __createElement(nodeInfo, elementsStack)
    {
        if (nodeInfo.type === '_content')
            return this._createContentElement(nodeInfo, elementsStack);
        else
            return this._createElement(nodeInfo, elementsStack);
    }
    /* abLayouts.Parser Overrides */

}

module.exports = LayoutParser;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\spocky\Viewable.js
jsLibs.exportModule('spocky', 'Viewable', (require, module, exports) => { 'use strict';

const 
    abNodes = require('ab-nodes'),
    js0 = require('js0')
;

class Viewable
{

    static get Property() {
        return '_$viewable';
    }


    get active() {
        return this._active;
    }

    get displayed() {
        return this._displayed;
    }


    constructor()
    {
        Object.defineProperties(this, {
            _parentNode: { value: null, writable: true, },
            _active: { value: false, writable: true, },
            _displayed: { value: false, writable: true, },
        });
    }

    activate(parentNode)
    {
        js0.args(arguments, abNodes.Node);

        // setTimeout(() => {
            if (!js0.type(parentNode, js0.Prop(abNodes.Node.PChildren)))
                throw new Error(`'parentNode' does not have 'PChildren' property.`);

            if (this._parentNode !== null)
                this.deactivate();

            this._parentNode = parentNode;
            this.__activate(this._parentNode);
        // }, 10);

        this._active = true;
    }

    deactivate()
    {
        // setTimeout(() => {
            if (this._parentNode !== null) {
                this.__deactivate(this._parentNode);
                this._parentNode = null;
            }
        // }, 10);

        this._active = false;
    }

    
    // _setParentNode(parentNode) {
    //     js0.args(arguments, abNodes.Node);

    //     if (!js0.type(parentNode, js0.Prop(abNodes.Node.PChildren)))
    //         throw new Error(`'parentNode' does not have 'PChildren' property.`);

    //     if (this._parentNode !== null && this._active)
    //         this.deactivate();

    //     this._parentNode = parentNode;
    //     if (this._active)
    //         this.activate();
    // }


    __activate(parentNode) { js0.virtual(this); }
    __deactivate(parentNode) { js0.virtual(this); }

    // activate(parentNode)
    // {
    //     js0.args(arguments, abNodes.Node);
    //     if (!js0.type(parentNode, js0.Prop(abNodes.Node.PChildren)))
    //         throw new Error(`'parentNode' does not have 'PChildren' property.`);

    //     if (!this._parentNode !== null)
    //         this.deactivate();

    //     this._parentNode = parentNode;
    //     this._parentNode.pChildren.add(this.getNode());
    // }

    // deactivate(parentNode)
    // {
    //     if (this._parentNode !== null)
    //         this._parentNode.pChildren.remove(this.getNode());
    // }

    // getNode() { throw new js0.virtual(this); }

    // static Validate(object)
    // {
    //     if (typeof object !== '[object Object]')
    //         return false;
    //     if (!('viewable' in object))
    //         return false;
    //     if (!(object.viewable instanceof Viewable))
    //         return false;
    //
    //     return true;
    // }

}
module.exports = Viewable;






 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\spocky\index.js
jsLibs.exportModule('spocky', 'index', (require, module, exports) => { 'use strict';

const
    js0 = require('js0'),

    abFields = require('ab-fields'),
    abNodes = require('ab-nodes')
;

const App = require('./App');
const Ext = require('./Ext');
const Holder = require('./Holder');
const Layout = require('./Layout');
const Module = require('./Module');
const Viewable = require('./Viewable');


const exts = [];

function ext(spockyExt) {
    js0.args(arguments, Ext);

    Layout.Extensions.push((layoutNode) => {
        spockyExt.onParseLayoutNode(layoutNode);
    });
}


let Debug = false;
function setDebug(debug) {
    exports.Debug = debug;
    abFields.setDebug(debug);
    abNodes.setDebug(debug);
};





module.exports.App = App;
module.exports.Ext = Ext;
module.exports.Holder = Holder;
module.exports.Layout = Layout;
module.exports.Module = Module;
module.exports.Viewable = Viewable;
module.exports.ext = ext;
module.exports.Debug = Debug;
module.exports.setDebug = setDebug;
 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\ab-text-parser\Text.js
jsLibs.exportModule('ab-text-parser', 'Text', (require, module, exports) => { 'use strict';

const
    js0 = require('js0'),

    TextParser = require('./parsers/TextParser')
;

class Text
{

    constructor(content)
    {
        this.content = content;
        this.parsers = [
            new TextParser(this),
        ];

        this.parts = [];

        if (content !== '')
            this.parse();
    }

    addPart(part)
    {
        js0.args(arguments, 'string');

        this.parts.push(part);
    }

    error(message, line)
    {
        throw new Error('Line: ' + line + '. ' + message);
    }

    finishParser(parser)
    {
        js0.args(arguments, require('./Parser'));

        this.parsers.pop();
    }

    parse()
    {
        let i = 0;
        let line = 1;
        while(true) {
            let c = this.content[i];
            let step = 0;

            let activeParser = this.parsers[this.parsers.length - 1];
            step = activeParser.read(c, i, line);
            
            if (step === 0 && this.parsers[this.parsers.length - 1] === activeParser)
                throw new Error(`Parser '${activeParser.constructor.name}' with step 0 created infinite loop.`);

            i += step;
            if (c === '\n')
                line++;

            if (i >= this.content.length)
                break;
        }

        // if (this.parts.length > 1)
        //     throw new Error(`Part '${this.parts[this.elems.length - 1].name}' not closed.`);
    }

    startParser(parser)
    {
        js0.args(arguments, require('./Parser'));

        this.parsers.push(parser);
    }

}
module.exports = Text;





 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\ab-text-parser\Parser.js
jsLibs.exportModule('ab-text-parser', 'Parser', (require, module, exports) => { 'use strict';

const
    js0 = require('js0')
;

class Parser
{

    constructor(text)
    {
        js0.args(arguments, require('./Text'));

        this.text = text;
    }

    error(message, line)
    {
        throw new Error('Line: ' + line + '. ' + message);
    }

    finish()
    {
        this.text.finishParser(this);
    }

    read(c, i, line)
    {
        return this.__read(c, i, line);
    }


    __check(c, i, line) { js0.virtual(this); }
    __read(c, i, line) { js0.virtual(this); }

}
module.exports = Parser;





 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\ab-text-parser\index.js
jsLibs.exportModule('ab-text-parser', 'index', (require, module, exports) => { 'use strict';

class abTextParser_Class
{

    constructor()
    {

    }

    parse(text)
    {
        let
            Text = require('./Text')
        ;

        let t = new Text(text);

        return t.parts;
    }

}
module.exports = new abTextParser_Class();





 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\ab-text-parser\parsers\ExprParser.js
jsLibs.exportModule('ab-text-parser', 'parsers/ExprParser', (require, module, exports) => { 'use strict';

const
    js0 = require('js0'),

    Parser = require('../Parser')
;

class ExprParser extends Parser
{

    static IsStart(content, i)
    {
        if (content.length > i + 1) {
            if (content[i] !== '?')
                return 0;
            if (content[i + 1] !== '(')
                return 0;
            if (content[i - 1] === '\\')
                return 0;

            return 2;
        }

        return 0;
    }


    constructor(text, parser)
    {
        js0.args(arguments, require('../Text'), require('../Parser'));
        super(text);

        this.parentParser = parser;
        this.parentParser_Type = null;
        if (js0.type(parser, require('./TextParser')))
            this.parentParser_Type = 'text';
        else if (js0.type(parser, require('./AttribValueParser')))
            this.parentParser_Type = 'attrib'; 

        js0.assert(this.parentParser_Type !== null, 
                `Invalid parser type: ${parser.constructor.name}.`);

        this.quoteOpened = null;
        this.quotes = [ '"', '\'', '`' ];
        for (let quote in this.quotes_Opened)
            this.quotes.push(quote);

        this.bracketsOpened = 0;

        this.value = '';
    }

    __read(c, i, line)
    {
        let step;

        if (this.quoteOpened === null) {
            if (this.quotes.includes(c)) {
                this.quoteOpened = c;
                this.value += c;
                return 1;
            }
        } else {
            if (c === this.quoteOpened && this.text.content[i - 1] !== '\\') {
                this.quoteOpened = null;
                this.value += c;
                return 1;
            }
        }

        if (this.quoteOpened === null) {
            if (c === '(') {
                this.bracketsOpened++;
                this.value += c;
                return 1;
            }

            if (c === ')') {
                if (this.bracketsOpened > 0) {
                    this.bracketsOpened--;
                    this.value += c;
                    return 1;
                }

                if (this.parentParser_Type === 'text') {
                    this.text.addPart('?(' + this.value + ')');
                } else if (this.parentParser_Type === 'attrib') {
                    this.parentParser.attribParser.tagParser
                            .attribs[this.parentParser.attribParser.name].push(
                            '?(' + this.value + ')');
                }
                this.finish();
                return 1;
            }
        }

        this.value +=c;
        return 1;
    }

}
module.exports = ExprParser;





 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\ab-text-parser\parsers\FieldArgsParser.js
jsLibs.exportModule('ab-text-parser', 'parsers/FieldArgsParser', (require, module, exports) => { 'use strict';

const
    js0 = require('js0'),

    Parser = require('../Parser')
;

class FieldArgsParser extends Parser
{

    static IsStart(c, i, line) {
        return c === '(' ? 1 : 0;
    }


    constructor(text, fieldParser)
    {
        js0.args(arguments, require('../Text'), require('./FieldParser'));
        super(text);

        this.fieldParser = fieldParser;

        this.args = '';
    }

    __read(c, i, line)
    {
        let step;

        if (c === ')') {
            this.fieldParser.args = this.args;
            this.finish();

            if (i + 1 >= this.text.content.length && !this.fieldParser.escaped) {
                if (this.name !== '') {
                    this.fieldParser.finish();
                    this.fieldParser.addField();
                }
            }

            return 1;
        }

        this.args +=c;
        return 1;
    }

}
module.exports = FieldArgsParser;





 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\ab-text-parser\parsers\TextParser.js
jsLibs.exportModule('ab-text-parser', 'parsers/TextParser', (require, module, exports) => { 'use strict';

const
    js0 = require('js0'),

    Parser = require('../Parser'),

    ExprParser = require('./ExprParser'),
    FieldParser = require('./FieldParser')
;

class TextParser extends Parser
{

    static IsStart(c, i, line) {
        return c === '<' ? 1 : 0;
    }


    constructor(text)
    {
        js0.args(arguments, require('../Text'));
        super(text);

        this.value = null;
        // this._htmlEntities = new htmlEntities.AllHtmlEntities();
    }

    __read(c, i, line)
    {
        let step;

        // step = TagParser.IsStart(c);
        // if (step > 0) {
        //     if (this.value !== null && this.value !== '') {
        //         while ([ ' ', "\r", "\n" ].includes(this.value[this.value.length - 1]))
        //             this.value = this.value.substring(0, this.value.length - 1);
        //         if (this.value !== '') {
        //             this.text.addNode({
        //                 type: 'text',
        //                 value: this._decodeHtml(this.value),
        //             });
        //         }
        //     }
            
        //     this.finish();
        //     return 0;
        // }

        if (this.value === null) {
            if (c === ' ' || c === "\r" || c === "\n")
                return 1;

            this.value = '';
        }

        step = FieldParser.IsStart(this.text, c, i, line);
        if (step > 0) {
            if (this.value !== null && this.value !== '') {
                this.text.addPart(this.value);
            }
            this.value = '';

            this.text.startParser(new FieldParser(this.text, this));
            return step;
        }

        step = ExprParser.IsStart(this.text.content, i);
        if (step > 0) {
            if (this.value !== null && this.value !== '') {
                this.text.addPart(this.value);
            }
            this.value = '';

            this.text.startParser(new ExprParser(this.text, this));
            return step;
        }

        this.value += c;

        if (i + 1 >= this.text.content.length) {
            this.text.addPart(this.value);
            this.finish();
        }

        return 1;
    }


    _decodeHtml(str)
    {
        // return this._htmlEntities.decode(str);
    }

}
module.exports = TextParser;





 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\ab-text-parser\parsers\FieldParser.js
jsLibs.exportModule('ab-text-parser', 'parsers/FieldParser', (require, module, exports) => { 'use strict';

const
    js0 = require('js0'),

    Parser = require('../Parser'),

    FieldArgsParser = require('./FieldArgsParser')
;

class FieldParser extends Parser
{

    static IsStart(document, c, i, line) {
        if (c !== '$')
            return 0;

        if (i >= 1) {
            if (document.content[i - 1] === '\\')
                return 0;
        }

        return 1;
    }


    constructor(text, parser)
    {
        js0.args(arguments, require('../Text'), require('../Parser'));
        super(text);

        this.parentParser = parser;
        this.parentParser_Type = null;
        if (js0.type(parser, require('./TextParser')))
            this.parentParser_Type = 'text';
        else if (js0.type(parser, require('./AttribValueParser')))
            this.parentParser_Type = 'attrib'; 

        js0.assert(this.parentParser_Type !== null, 
                `Invalid parser type: ${parser.constructor.name}.`);

        this.name = '';
        this.args = null;
        this.bracketsOpened = 0;

        this.escaped = false;
    
        this.regexp = /[a-zA-Z0-9_.]/;
    }

    __read(c, i, line)
    {
        let step;

        if (this.name === '' && !this.escaped) {
            if (i + 2 < this.text.content.length) {
                if (this.text.content[i + 2] === '{') {
                    this.escaped = true;
                    return 1;
                }
            }

            if (i + 1 < this.text.content.length) {
                if (this.text.content[i + 1] === '{') {
                    this.bracketsOpened++;
                    this.name += '{';
                    return 1;
                }
            }

            if (c === '{') {
                this.escaped = true;
                return 1;
            }
        }

        if (c === '{') {
            this.bracketsOpened++;
            this.name += '{';
            return 1;
        }

        if (c === '}') {
            if (this.bracketsOpened > 0) {
                this.bracketsOpened--;
                this.name += '}';
                return 1;
            }
        }

        if (this.regexp.test(c)) {
            if (this.args !== null) {
                if (this.name !== '') {
                    this.addField();
                    this.finish();
                    return 0;
                }
            }

            this.name += c;

            if (i + 1 >= this.text.content.length && !this.escaped) {
                if (this.name !== '') {
                    this.addField();
                    this.finish();
                }
            }

            return 1;
        }

        if (this.name !== '') {
            if (c === '(') {
                this.text.startParser(new FieldArgsParser(this.text, this));
                return 1;
            }
        }

        if (this.escaped) {
            if (c !== '}')
                this.error('Wrong field name format.', line);

            this.addField();

            this.finish();
            return 1;
        }

        this.addField();

        this.finish();
        return 0;
    }

    addField()
    {
        if (this.parentParser_Type === 'text') {
            this.text.addPart(this._getField());
        } else if (this.parentParser_Type === 'attrib') {
            this.parentParser.attribParser.tagParser
                    .attribs[this.parentParser.attribParser.name].push(
                    this._getField());
        }
    }


    _getField()
    {
        return '$' + (this.escaped ? '{' : '') + this.name + 
                (this.args === null ? '' : '(' + this.args + ')') + 
                (this.escaped ? '}' : '');
    }

}
module.exports = FieldParser;





 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\ab-nodes\HtmlElement.js
jsLibs.exportModule('ab-nodes', 'HtmlElement', (require, module, exports) => { 'use strict';

const
    abNodes = require('.')
;


class HtmlElement
{

    static AddChild(parentHtmlElement, htmlElement, nextHtmlElement = null)
    {
        try {
            if (nextHtmlElement === null)
                parentHtmlElement.appendChild(htmlElement);
            else
                parentHtmlElement.insertBefore(htmlElement, nextHtmlElement);
        } catch (e) {
            if (abNodes.debug)
                console.warn(e);
        }
    }

    static ClearChildren(htmlElement)
    {
        while (htmlElement.firstChild)
            htmlElement.removeChild(htmlElement.firstChild);
    }

    static RemoveChild(parentHtmlElement, htmlElement)
    {
        try {
            parentHtmlElement.removeChild(htmlElement);
        } catch (e) {
            if (abNodes.debug)
                console.warn(e);
        }
    }

}

module.exports = HtmlElement;






 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\ab-nodes\Node.PChildren.js
jsLibs.exportModule('ab-nodes', 'Node.PChildren', (require, module, exports) => { 'use strict';

const Node = require('./Node')

const js0 = require('js0');


Object.defineProperty(Node, 'PChildren', { value:
class Node_PChildren {

    static get Property() { return 'pChildren'; }

    get length(){
        return this._children.length;
    }

    get node() {
        return this._node;
    }


    constructor(node)
    {
        js0.args(arguments, Node);

        this._node = node;
        this._children = [];
    }

    add(childNode, nextNode = null)
    {
        js0.args(arguments, Node, [ Node, js0.Default ]);

        let insertIndex = nextNode === null ?
                this._children.length : this._children.indexOf(nextNode);
        if (insertIndex === -1)
            new Error('`nextNode` does not exist in `childNode` parent.');

        childNode._parentNode = this._node;

        this._children.splice(insertIndex, 0, childNode);

        this.__onAddChild(childNode);
    }

    // addAt(index, childNode)
    // {
    //     js0.args(arguments, 'number', Node);

    //     if (index < 0)
    //         throw new Error(`Index '${index}' cannot be lower than 0.`);
    //     if (index > this._children.length)
    //         throw new Error(`Index '${index}' cannot be higher than children size '${this._children.length}'.`);
        
    //     childNode._parentNode = this._node;

    //     this._children.splice(index, 0, childNode);

    //     this.__onAddChild(childNode);
    // }

    createCopy(topNodeCopy, instanceKeys)
    {
        js0.args(arguments, Node, Array);
        js0.typeE(this._node, js0.Prop(Node.PCopyable));

        let nodeCopiesStack = [ topNodeCopy ];

        while(nodeCopiesStack.length > 0) {
            let nodeCopy = nodeCopiesStack.pop();
            let children = nodeCopy.pCopyable.getOriginalNode().pChildren;

            for (let i = 0; i < children.length; i++) {
                let childNodeCopy = children.get(i).pCopyable
                        .createCopy(instanceKeys, false);

                nodeCopy.pChildren.add(childNodeCopy);

                if (!js0.type(childNodeCopy, js0.Prop(Node.PChildren)))
                    continue;

                // /* Copy only first repeat node. */
                // console.log('Test', nodeCopy === top_node);
                if (js0.type(childNodeCopy, require('./nodes/RepeatNode')))
                    continue;

                nodeCopiesStack.push(childNodeCopy);
            }
        }
    }

    deleteCopies(topOriginalNode, instanceKeys)
    {
        js0.args(arguments, Node, Array);

        let originalNodesStack = [ topOriginalNode ];

        while(originalNodesStack.length > 0) {
            let originalNode = originalNodesStack.pop();
            let children = originalNode.pChildren;

            for (let i = 0; i < children.length; i++) {
                let childNode = children.get(i);

                childNode.pCopyable.deleteCopies(instanceKeys, false);

                if (!js0.type(childNode, js0.Prop(Node.PChildren)))
                    continue;

                originalNodesStack.push(childNode);
            }

            // nodeCopiesStack.shift();
            // children_stack.shift();
        }

        return topOriginalNode;
    }

    findNext(childNode)
    {
        let childNodeIndex = this._children.indexOf(childNode);
        js0.assert(childNodeIndex !== -1, '`childNode` not found.');

        if (childNodeIndex < this._children.length - 1)
            return this._children[childNodeIndex + 1];

        return null;
    }

    findNextHtmlElement(childNode)
    {
        let nextHtmlElement = null;
    
        // console.log('Test', this.node, childNode)

        let nextNode = this.findNext(childNode);
        if (nextNode !== null)
            nextHtmlElement = nextNode.firstHtmlElement;

        if (nextHtmlElement !== null)
            return nextHtmlElement;

        nextHtmlElement = this.__getNextHtmlElement();

        // js0.assert(typeof nextHtmlElement !== 'undefined', '???');
        // if (typeof nextHtmlElement === 'undefined')
        //     throw new Error();

        return nextHtmlElement;
    }

    // findNextHtmlElement(childNode)
    // {
    //     let nextHtmlElement = null;
     
    //     let startIndex = null;
    //     for (let i = 0; i < this._children.length; i++) {
    //         if (this._children[i] === childNode) {
    //             startIndex = i + 1;
    //             break;
    //         }
    //     }

    //     if (startIndex === null)
    //         throw new Error(`Node '${childNode}' is not a child of '${this._node}'.`);

    //     for (let i = startIndex; i < this._children.length; i++) {
    //         let nextNode = this._children[i];
    //         let nextHtmlElement = nextNode.__getFirstHtmlElement();
    //         if (!js0.type(nextHtmlElement, [ HTMLElement, Text, js0.Null ])) {
    //             throw new Error(`\`__getFirstHtmlElement\` in \`${this.constructor.name}\`` +
    //                     `does not return \`HTMLElement\`.`);
    //         }

    //         if (nextHtmlElement !== null)
    //             return nextHtmlElement;
            
    //             nextHtmlElement = this.__getNextHtmlElement();
    //         if (nextHtmlElement !== null)
    //             return nextHtmlElement;
    //     }

    //     return null;
    // }

    get(childNodeIndex)
    {
        return this._children[childNodeIndex];
    }

    remove(childNode)
    {
        js0.args(arguments, Node);

        for (let i = 0; i < this._children.length; i++) {
            if (this._children[i] === childNode) {
                childNode.refreshDisplayed(true);
                childNode.deactivate();
                this._children.splice(i, 1);
            }
        }
    }

    __getNext(childNode)
    {
        return this.findNext(childNode);
    }

    __getNextHtmlElement()
    {
        return null;
    }

    __onAddChild() { js0.virtual(this); }

}});
module.exports = Node.PChildren;






 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\ab-nodes\index.js
jsLibs.exportModule('ab-nodes', 'index', (require, module, exports) => { 'use strict';

const
    js0 = require('js0')
;

class abNodes_Class
{

    get HideNode() {
        return require('./nodes/HideNode');
    }

    get Node() {
        return require('./Node');
    }

    get RepeatNode() {
        return require('./nodes/RepeatNode');
    }

    get RootNode() {
        return require('./nodes/RootNode');
    }

    get ShowNode() {
        return require('./nodes/ShowNode');
    }

    get SingleNode() {
        return require('./nodes/SingleNode');
    }

    get TextNode() {
        return require('./nodes/TextNode');
    }


    get debug() {
        return this._debug;
    }
    

    constructor() {
        this._debug = false;
    }

    setDebug(debug)
    {
        js0.args(arguments, 'boolean');

        this._debug = debug;
    }

};
module.exports = new abNodes_Class();






 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\ab-nodes\Node.PCopyable.js
jsLibs.exportModule('ab-nodes', 'Node.PCopyable', (require, module, exports) => { 'use strict';

const Node = require('./Node');

const js0 = require('js0');


Object.defineProperty(Node, 'PCopyable', { value:
class Node_PCopyable {

    static get Property() { return 'pCopyable'; }


    get node() {
        return this._node;
    }

    get sourceNode() {
        return this._source;
    }


    constructor(node, args)
    {
        js0.args(arguments, Node, null);

        this._node = node;
        this.__args = args;

        this._copies = [];
        this._copies_ByInstanceKeys = {};

        this._source = null;
        this._instanceKeys = [];

        this._listeners_OnCreate = [];
        this._listeners_OnDestroy = [];
    }

    createCopy(instanceKeys, deepCopy = true)
    {
        js0.args(arguments, Array, [ 'boolean', js0.Default ]);
        js0.assert(this._source === null, 'Cannot create copy of a copy.');

        // console.log('CREATE NODE', this.node.constructor.name, instanceKeys);

        let nodeCopy = this.__createCopy(instanceKeys);
        nodeCopy.pCopyable._source = this.node;
        for (let instanceKey of instanceKeys)
            nodeCopy.pCopyable._instanceKeys.push(instanceKey);

        if (deepCopy && js0.type(this.node, js0.Prop(Node.PChildren)))
            this.node.pChildren.createCopy(nodeCopy, instanceKeys);

        this._copies_Add(instanceKeys, nodeCopy);
        // this._copies.push(nodeCopy);

        for (let listener of this._listeners_OnCreate)
            listener(nodeCopy, instanceKeys);

        return nodeCopy;
    }

    deleteCopies(instanceKeys, deepDelete = true)
    {
        js0.args(arguments, Array, [ 'boolean', js0.Default ]);
        js0.assert(this._source === null, 'Cannot create copy of a copy.');

        let nodeCopies = this._copies_Get(instanceKeys, true);
        for (let nodeCopy of nodeCopies) {
            for (let i = this._copies.length - 1; i >= 0; i--) {
                if (this._copies[i] !== nodeCopy)
                    continue;

                for (let listener_OnDestroy of this._listeners_OnDestroy)
                    listener_OnDestroy(nodeCopy, instanceKeys);

                this._copies.splice(i, 1);

                break;
            }    
        }

        if (deepDelete && js0.type(this.node, js0.Prop(Node.PChildren)))
            this.node.pChildren.deleteCopies(this.node, instanceKeys);
    }

    getInstanceKeys()
    {
        return this._instanceKeys.slice();
    }

    getNodeCopies(instanceKeys = null)
    {
        js0.args(arguments, [ Array, js0.Default ]);

        if (instanceKeys === null)
            return this._copies.slice();

        // console.log('QQQ', this._copies.length);

        return this._copies_Get(instanceKeys);

        // let nodeCopies = [];
        // for (let nodeCopy of this._copies) {
        //     // console.log('WTF?');
        //     // console.log('Bam', instanceKeys, nodeCopy.pCopyable._instanceKeys);
        //     if (nodeCopy.pCopyable.matchInstanceKeys(instanceKeys))
        //         nodeCopies.push(nodeCopy);
        // }

        // return nodeCopies;
    }

    getOriginalNode()
    {
        let sourceNode = this.node;
        while (sourceNode.pCopyable._source !== null)
            sourceNode = this._source;

        return sourceNode;
    }

    matchInstanceKeys(instanceKeys, exact = true)
    {
        js0.args(arguments, Array);

        if (this._source === null)
            throw new Error(`\`matchInstanceKeys\` on node that is not a copy.`);

        if (exact) {
            if (instanceKeys.length !== this._instanceKeys.length)
                return false;
        }

        for (let i = 0; i < instanceKeys.length; i++) {
            if (instanceKeys[i] === null)
                continue;

            if (instanceKeys[i] !== this._instanceKeys[i])
                return false;
        }

        return true;
    }

    onCreate(onCreateListener)
    {
        this._listeners_OnCreate.push(onCreateListener);
    }

    onDestroy(onDestroyListener)
    {
        this._listeners_OnDestroy.push(onDestroyListener);
    }


    _copies_Add(instanceKeys, nodeCopy)
    {
        let copies_Root = this._copies_GetRoot(this._copies_ByInstanceKeys,
                instanceKeys, true);

        if (!('_$nodes' in copies_Root))
            copies_Root._$nodes = [];

        copies_Root._$nodes.push(nodeCopy);
        this._copies.push(nodeCopy);
    }

    _copies_Get(instanceKeys, remove = false)
    {
        let copies_Root = this._copies_GetRoot(this._copies_ByInstanceKeys,
                instanceKeys, false);
        if (copies_Root === null)
            return [];

        if (!('_$nodes' in copies_Root))
            return [];

        if (remove) {
            let nodeCopies = copies_Root._$nodes;
            copies_Root._$nodes = [];
            return nodeCopies;
        } else
            return copies_Root._$nodes.slice();
    }

    _copies_GetRoot(copies_Current, instanceKeys, create)
    {
        for (let i = 0; i < instanceKeys.length; i++) {
            if (instanceKeys[i] === null) {
                let copies = {
                    _$nodes: [],
                };

                for (let instanceKey_T in copies_Current) {
                    let copies_New = this._copies_GetRoot(copies_Current[instanceKey_T],
                            instanceKeys.slice(1), create);
                    if (copies_New !== null) {
                        if ('_$nodes' in copies_New) {
                            copies._$nodes = copies._$nodes.concat(copies_New._$nodes);
                        }
                    }
                }

                return copies;
            }
            
            if (!(instanceKeys[i] in copies_Current)) {
                if (create)
                    copies_Current[instanceKeys[i]] = {};
                else
                    return null;
            }

            copies_Current = copies_Current[instanceKeys[i]];
        }

        return copies_Current;
    }

    // _copies_GetRoot(instanceKeys, create)
    // {
    //     let copies_Current = this._copies_ByInstanceKeys;

    //     for (let i = 0; i < instanceKeys.length; i++) {
    //         if (!(instanceKeys[i] in copies_Current)) {
    //             if (create)
    //                 copies_Current[instanceKeys[i]] = {};
    //             else
    //                 return null;
    //         }

    //         copies_Current = copies_Current[instanceKeys[i]];
    //     }

    //     return copies_Current;
    // }

    __addInstance(key, instanceNode)
    {
        js0.args(arguments, [ 'string', 'number' ],
                require('./nodes/RepeatNode').InstanceNode);

        this._instanceInfos.push({
            key: key,
            instanceNode: instanceNode
        });

        instanceNode.addNodeCopy(this.node);
    }

    // __setSourceNode(sourceNode)
    // {
    //     js0.args(arguments, Node);
    //
    //     this._source = sourceNode;
    // }

    __createCopy(instanceKeys) { js0.virtual(this); }

}});
module.exports = Node.PCopyable;






 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\ab-nodes\Node.js
jsLibs.exportModule('ab-nodes', 'Node', (require, module, exports) => { 'use strict';

const js0 = require('js0');


class Node
{

    get active() {
        return this._active;
    }

    get displayed() {
        return this._displayed;
    }

    get firstHtmlElement() {
        let firstHtmlElement = this.__getFirstHtmlElement();
        if (!js0.type(firstHtmlElement, [ HTMLElement, Text, js0.Null ])) {
            throw new Error(`\`__getFirstHtmlElement\` in \`${this.constructor.name}\`` +
                    `does not return \`HTMLElement\`.`);
        }

        if (firstHtmlElement !== null)
            return firstHtmlElement;

        if (this.hasParent) {
            let nextHtmlElement = this.parentNode.pChildren.findNextHtmlElement(this);
            if (nextHtmlElement === null)
                return null;

            return nextHtmlElement;
        }

        return null;;
    }

    get hasParent() {
        return this._parentNode !== null;
    }

    get htmlElement() {
        let htmlElement = this.__getHtmlElement();
        if (!js0.type(htmlElement, HTMLElement)) {
            throw new Error(`\`__getHtmlElement\` in \`${this.constructor.name}\`` +
                    `does not return \`HTMLElement\`.`);
        }

        return htmlElement;
    }

    get nextHtmlElement() {
        if (this.hasParent)
            return this.parentNode.pChildren.findNextHtmlElement(this)

        return null;
    }

    get nextNode() {
        return this.hasParent ? this.parentNode.pChildren.__getNext(this) : null;
    }

    get parentNode() {
        // if (this._parentNode === null)
        //     throw new Error('Parent node not set.');

        return this._parentNode;
    }


    constructor()
    {
        this._active = false;
        this._displayed = false;
        
        this._parentNode = null;

        this._listeners_OnDisplay = [];
    }

    activate()
    {
        if (this.active)
            return;
        this._active = true;

        this.__onActivate();
    }

    addListener_OnDisplay(listener)
    {
        this._listeners_OnDisplay.push(listener);
    }

    deactivate()
    {
        if (!this.active)
            return;
        this._active = false;

        this.__onDeactivate();
    }

    refreshDisplayed(refreshChildren = false)
    {
        let displayed = this.__isDisplayed();
        if (this._displayed === displayed)
            return;

        this._displayed = displayed;
        for (let listener of this._listeners_OnDisplay)
            listener(displayed);

        if (refreshChildren) {
            if (js0.type(this, js0.Prop(Node.PChildren))) {
                for (let i = 0; i < this.pChildren.length; i++)
                    this.pChildren.get(i).refreshDisplayed(true);
            }
        }
    }

    removeListener_OnDisplay(listener)
    {
        for (let i = this._listeners_OnDisplay.length - 1; i >= 0; i--) {
            if (this._listeners_OnDisplay[i] === listener)
                this._listeners_OnDisplay.splice(i, 1);
        }
    }


    __getHtmlElement() { js0.virtual(this); }
    __getFirstHtmlElement() { js0.virtual(this); }

    __isDisplayed() { js0.virtual(this); }

    __onActivate() { js0.virtual(this); }
    __onDeactivate() { js0.virtual(this); }

}
module.exports = Node;
require('./Node.PChildren');
require('./Node.PCopyable');






 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\ab-nodes\nodes\HideNode.js
jsLibs.exportModule('ab-nodes', 'nodes/HideNode', (require, module, exports) => { 'use strict';

const js0 = require('js0');

const Node = require('../Node');


class HideNode extends Node
{

    get hide() {
        return this._hide;
    }
    set hide(hideValue) {
        js0.args(arguments, 'boolean');

        if (hideValue === this._hide)
            return;
        this._hide = hideValue;

        if (!this.active)
            return;

        if (hideValue) {
            for (let i = 0; i < this.pChildren.length; i++)
                this.pChildren.get(i).deactivate();
            this.refreshDisplayed(true);
        } else {
            for (let i = 0; i < this.pChildren.length; i++)
                this.pChildren.get(i).activate();
            this.refreshDisplayed(true);
        }
    }


    constructor()
    { super();
        js0.prop(this, HideNode.PChildren, this);
        js0.prop(this, HideNode.PCopyable, this, arguments);

        this._hide = false;
    }


    /* Node */
    __isDisplayed()
    {
        if (!this.active || this.hide)
            return false;

        return this.parentNode.displayed;
    }

    __onActivate()
    {
        js0.assert(this.parentNode !== null, 'Parent node not set.');

        if (this.hide)
            return;

        for (let i = 0; i < this.pChildren.length; i++)
            this.pChildren.get(i).activate();
        this.refreshDisplayed(true);
    }

    __onDeactivate()
    {
        if (this.hide)
            return;

        this.refreshDisplayed(true);
        for (let i = this.pChildren.length - 1; i >= 0; i--)
            this.pChildren.get(i).deactivate();
    }

    __getHtmlElement()
    {
        js0.assert(this.parentNode !== null, 'Parent node not set.');

        return this.parentNode.htmlElement;
    }

    __getFirstHtmlElement()
    {
        for (let i = 0; i < this.pChildren.length; i++) {
            let childFirstHtmlElement = this.pChildren.get(i).firstHtmlElement;
            if (childFirstHtmlElement !== null)
                return childFirstHtmlElement;
        }

        return null;
    }
    /* / Node */

}
module.exports = HideNode;


Object.defineProperties(HideNode, {

    PChildren: { value:
    class HideNode_PChildren extends Node.PChildren
    {

        constructor(node)
        { super(node);

        }

        __onAddChild(childNode, nextNode)
        {
            // if (nextNode === null)
            //     childNode._nextNode = this._nextNode;

            if (this.node.active && !this.node.hide)
                childNode.activate();
        }

        __getNext(childNode)
        {
            let nextNode = this.findNext(childNode);
            if (nextNode !== null)
                return nextNode;

            return this.node.nextNode;
        }

        __getNextHtmlElement()
        {
            return this.node.nextHtmlElement;
        }

    }},

});


Object.defineProperties(HideNode, {

    PCopyable: { value:
    class HideNode_PCopyable extends Node.PCopyable {

        constructor(node, args)
        { super(node, args);

        }

        __createCopy(deepCopy, nodeInstances)
        {
            return new HideNode();
        }

    }},

});





 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\ab-nodes\nodes\RepeatNode.InstanceNode.js
jsLibs.exportModule('ab-nodes', 'nodes/RepeatNode.InstanceNode', (require, module, exports) => { 'use strict';

const RepeatNode = require('./RepeatNode');

const js0 = require('js0');

const Node = require('../Node');


Object.defineProperty(RepeatNode, 'InstanceNode', { value:
class RepeatNode_InstanceNode extends Node
{

    get key() {
        return this._key;
    }

    constructor(repeatNode, key)
    { super();
        js0.args(arguments, RepeatNode, [ 'number', 'string' ]);
        js0.prop(this, RepeatNode.InstanceNode.PChildren, this);
        // js0.prop(this, RepeatNode.InstanceNode.PCopyable, this);

        this._key = key;

        this._repeatNode = repeatNode;
        this._nodeCopies = [];
    }

    addNodeCopy(nodeCopy)
    {
        this._nodeCopies.push(nodeCopy);
    }


    /* Node */
    __isDisplayed()
    {
        return this._repeatNode.displayed && this.active;
    }

    __onActivate()
    {
        for (let i = 0; i < this.pChildren.length; i++)
            this.pChildren.get(i).activate();
    }

    __onDeactivate()
    {
        for (let i = 0; i < this.pChildren.length; i++)
            this.pChildren.get(i).deactivate();
    }

    __getHtmlElement()
    {
        return this._repeatNode.htmlElement;
    }

    __getFirstHtmlElement()
    {
        if (this.pChildren.length > 0)
            return this.pChildren.get(0).firstHtmlElement;

        return null;
    }
    /* / Node */

}, });
module.exports = RepeatNode.InstanceNode;


Object.defineProperties(RepeatNode.InstanceNode, {

    PChildren: { value:
    class RepeatNode_InstanceNode_PChildren extends Node.PChildren
    {

        constructor(node)
        { 
            super(node);
        }

        __onAddChild(childNode, nextNode)
        {
            if (this.node.active)
                childNode.activate();
        }

        __getNext(childNode)
        {
            let nextNode = this.findNext(childNode);
            if (nextNode !== null)
                return nextNode;

            let instanceIndex = this.node._repeatNode._instances.indexOf(
                    this.node);
            js0.assert(instanceIndex !== -1, 'Instance not in repeat node.');

            if (instanceIndex === this.node._repeatNode._instances.size - 1)
                return this.node._repeatNode.nextNode;

            return this.node._repeatNode._instances.getAt(instanceIndex + 1);
        }

        __getNextHtmlElement()
        {   
            /* Not Sure */
            if (!this.node._repeatNode.active)
                return this.node._repeatNode.nextHtmlElement;
            /* / Not Sure */

            let startIndex = this.node._repeatNode._instances.indexOf(this.node) + 1;
            for (let i = startIndex; i < this.node._repeatNode._instances.size; i++) {
                let instance = this.node._repeatNode._instances.getAt(i);
                if (instance.pChildren.length > 0)
                    return instance.pChildren.get(0).firstHtmlElement;
            }

            return this.node._repeatNode.nextHtmlElement;
        }

    }},


    // PCopyable: { value:
    // class RepeatNode_InstanceNode_PCopyable extends Node.PCopyable
    // {
    //
    //     __createCopy(instance_nodes)
    //     {
    //         throw new Error('To do.');
    //         // return new RepeatNode.InstanceNode(this.__args[0]);
    //     }
    //
    // }},

});






 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\ab-nodes\nodes\ShowNode.js
jsLibs.exportModule('ab-nodes', 'nodes/ShowNode', (require, module, exports) => { 'use strict';

const js0 = require('js0');

const Node = require('../Node');


class ShowNode extends Node
{

    get show() {
        return this._show;
    }
    set show(showValue) {
        js0.args(arguments, 'boolean');

        if (showValue === this._show)
            return;
        this._show = showValue;

        if (!this.active)
            return;

        if (showValue) {
            for (let i = 0; i < this.pChildren.length; i++)
                this.pChildren.get(i).activate();
            this.refreshDisplayed(true);
        } else {
            this.refreshDisplayed(true);
            for (let i = 0; i < this.pChildren.length; i++)
                this.pChildren.get(i).deactivate();
        }
    }


    constructor()
    { super();
        js0.prop(this, ShowNode.PChildren, this);
        js0.prop(this, ShowNode.PCopyable, this, arguments);

        this._show = false;
    }


    /* Node */
    __isDisplayed()
    {
        if (!this.active || !this.show)
            return false;

        return this.parentNode.displayed;
    }

    __onActivate()
    {
        js0.assert(this.parentNode !== null, 'Parent node not set.');

        if (!this.show)
            return;

        this.refreshDisplayed(true);
        for (let i = 0; i < this.pChildren.length; i++)
            this.pChildren.get(i).activate();
    }

    __onDeactivate()
    {
        if (!this.show)
            return;

        this.refreshDisplayed(true);
        for (let i = this.pChildren.length - 1; i >= 0; i--)
            this.pChildren.get(i).deactivate();
    }

    __getHtmlElement()
    {
        js0.assert(this.parentNode !== null, 'Parent node not set.');

        return this.parentNode.htmlElement;
    }

    __getFirstHtmlElement()
    {
        for (let i = 0; i < this.pChildren.length; i++) {
            let childFirstHtmlElement = this.pChildren.get(i).firstHtmlElement;
            if (childFirstHtmlElement !== null)
                return childFirstHtmlElement;
        }

        return null;
    }
    /* / Node */

}
module.exports = ShowNode;


Object.defineProperties(ShowNode, {

    PChildren: { value:
    class ShowNode_PChildren extends Node.PChildren
    {

        constructor(node)
        { super(node);

        }

        __onAddChild(childNode, nextNode)
        {
            // if (nextNode === null)
            //     childNode._nextNode = this._nextNode;

            if (this.node.active && this.node.show)
                childNode.activate();
        }

        __getNext(childNode)
        {
            let nextNode = this.findNext(childNode);
            if (nextNode !== null)
                return nextNode;

            return this.node.nextNode;
            // if (nextNode !== null)
            //     return nextNode;

            // console.log('Null!');
            // return null;
        }

        __getNextHtmlElement()
        {
            return this.node.nextHtmlElement;
        }

    }},

});


Object.defineProperties(ShowNode, {

    PCopyable: { value:
    class ShowNode_PCopyable extends Node.PCopyable {

        constructor(node, args)
        { super(node, args);

        }

        __createCopy(deepCopy, nodeInstances)
        {
            return new ShowNode();
        }

    }},

});





 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\ab-nodes\nodes\RootNode.js
jsLibs.exportModule('ab-nodes', 'nodes/RootNode', (require, module, exports) => { 'use strict';

const js0 = require('js0');

const HtmlElement = require('../HtmlElement');
const Node = require('../Node');


class RootNode extends Node
{

    constructor(htmlElement)
    { super();
        js0.args(arguments, HTMLElement);
        js0.prop(this, RootNode.PChildren, this);

        this._htmlElement = htmlElement;
    }


    /* Node.IListener */
    __getHtmlElement()
    {
        return this._htmlElement;
    }

    __getFirstHtmlElement()
    {
        return this._htmlElement;
    }

    __isDisplayed()
    {
        return this.active;
    }

    __onActivate()
    {
        HtmlElement.ClearChildren(this._htmlElement);

        for (let i = 0; i < this.pChildren.length; i++)
            this.pChildren.get(i).activate();
        this.refreshDisplayed(true);
    }

    __onDeactivate()
    {
        this.refreshDisplayed(true);
        for (let i = 0; i < this.pChildren.length; i++)
            this.pChildren.get(i).deactivate();
    }
    /* / Node.IListener */

}
module.exports = RootNode;


Object.defineProperties(RootNode, {

    PChildren: { value:
    class RootNode_PChildren extends Node.PChildren
    {

        constructor(node)
        {
            super(node);
        }

        __onAddChild(childNode)
        {
            if (this.node.active)
                childNode.activate();
        }

    }},

});






 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\ab-nodes\nodes\TextNode.js
jsLibs.exportModule('ab-nodes', 'nodes/TextNode', (require, module, exports) => { 'use strict';

const js0 = require('js0');

const HtmlElement = require('../HtmlElement');
const Node = require('../Node');


class TextNode extends Node
{

    get text() {
        return this._htmlElement.nodeValue;
    }
    set text(value) {
        this._htmlElement.nodeValue = value;
    }


    constructor(text)
    { super();
        js0.prop(this, TextNode.PCopyable, this, arguments);

        this._text = text;
        this._htmlElement = document.createTextNode(text);
    }


    /* Node */
    __isDisplayed()
    {
        if (!this.active)
            return false;

        return this.parentNode.displayed;
    }

    __onActivate()
    {
        js0.assert(this.parentNode !== null, 'Parent node not set.');

        HtmlElement.AddChild(this.parentNode.htmlElement, this._htmlElement,
                this.nextHtmlElement);
        this.refreshDisplayed(true);
    }

    __onDeactivate()
    {
        this.refreshDisplayed(true);
        HtmlElement.RemoveChild(this.parentNode.htmlElement, this._htmlElement);
    }

    __getHtmlElement()
    {
        return this._htmlElement;
    }

    __getFirstHtmlElement()
    {
        if (!this.active)
            return null;

        return this._htmlElement;
    }
    /* / Node */

}
module.exports = TextNode;


Object.defineProperties(TextNode, {

    PCopyable: { value:
    class TextNode_PCopyable extends Node.PCopyable
    {

        constructor(node, args)
        {
            super(node, args);
        }

        __createCopy() {
            return new TextNode(this.__args[0]);
        }

    }},

});






 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\ab-nodes\nodes\SingleNode.js
jsLibs.exportModule('ab-nodes', 'nodes/SingleNode', (require, module, exports) => { 'use strict';

const js0 = require('js0');

const HtmlElement = require('../HtmlElement');
const Node = require('../Node');


class SingleNode extends Node
{

    constructor(htmlElementType)
    { super();
        js0.args(arguments, 'string');
        js0.prop(this, SingleNode.PChildren, this);
        js0.prop(this, SingleNode.PCopyable, this, arguments);

        this._htmlElement = document.createElement(htmlElementType);
    }


    /* Node */
    __isDisplayed()
    {
        if (!this.active)
            return false;

        return this.parentNode.displayed;
    }

    __onActivate()
    {
        js0.assert(this.parentNode !== null, 'Parent node not set.');

        HtmlElement.AddChild(this.parentNode.htmlElement, this._htmlElement,
                this.nextHtmlElement);

        // for (let i = 0; i < this.pChildren.length; i++)
        //     this.pChildren.get(i).refreshDisplayed(true);
        this.refreshDisplayed(true);
    }

    __onDeactivate()
    {
        this.refreshDisplayed(true);
        // for (let i = this.pChildren.length - 1; i >= 0; i--)
        //     this.pChildren.get(i).refreshDisplayed(true);

        HtmlElement.RemoveChild(this.parentNode.htmlElement, this._htmlElement);
    }

    __getHtmlElement()
    {
        return this._htmlElement;
    }

    __getFirstHtmlElement()
    {
        if (!this.active)
            return null;

        return this._htmlElement;
    }
    /* / Node */

}
module.exports = SingleNode;


Object.defineProperties(SingleNode, {

    PChildren: { value:
    class SingleNode_PChildren extends Node.PChildren
    {

        constructor(node)
        {
            super(node);
        }

        __onAddChild(childNode, next_node)
        {
            childNode.activate();
        }

    }},


    PCopyable: { value:
    class SingleNode_PCopyable extends Node.PCopyable
    {

        constructor(node, args)
        {
            super(node, args);
        }

        __createCopy(deepCopy, nodeInstances)
        {
            return new SingleNode(this.__args[0]);
        }

    }},

});






 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\ab-nodes\nodes\RepeatNode.js
jsLibs.exportModule('ab-nodes', 'nodes/RepeatNode', (require, module, exports) => { 'use strict';

const js0 = require('js0');

const HtmlElement = require('../HtmlElement');
const Node = require('../Node');

const TextNode = require('./TextNode');


class RepeatNode extends Node
{

    constructor()
    { super();
        js0.prop(this, RepeatNode.PChildren, this);
        js0.prop(this, RepeatNode.PCopyable, this, arguments);

        this._instances = new js0.List();
    }

    add(key)
    {
        if (this._instances.has(key))
            throw new Error(`Instance with key \`${key}\` already exists.`);

        let instance = new RepeatNode.InstanceNode(this, key);

        this._instances.set(key, instance);
        let node_Original = this.pCopyable.getOriginalNode();

        let instanceKeys = this.pCopyable._instanceKeys.concat([ key ]);
        for (let i = 0; i < node_Original.pChildren.length; i++) {
            let newChildNode = node_Original.pChildren.get(i).pCopyable
                    .createCopy(instanceKeys);
            instance.pChildren.add(newChildNode);
        }
            
        if (this.active)
            instance.activate();
    }

    addAt(index, key)
    {
        if (this._instances.has(key))
            throw new Error(`Instance with key \`${key}\` already exists.`);
        if (index < 0)
            throw new Error(`Index '${index}' cannot be lower than 0.`);
        if (index > this._instances.size)
            throw new Error(`Index '${index}' cannot be higher than instances size '${this._instances.size}'.`);

        let instance = new RepeatNode.InstanceNode(this, key);

        this._instances.addAt(index, key, instance);
        let node_Original = this.pCopyable.getOriginalNode();

        let instanceKeys = this.pCopyable._instanceKeys.concat([ key ]);

        for (let i = 0; i < node_Original.pChildren.length; i++) {
            let newChildNode = node_Original.pChildren.get(i).pCopyable
                    .createCopy(instanceKeys);

            instance.pChildren.add(newChildNode);
        }

        if (this.active)
            instance.activate();
    }

    delete(key)
    {
        if (!this._instances.has(key))
            throw new Error(`Instance with key \`${key}\ does not exist.`);

        let instance = this._instances.get(key);
        this._instances.delete(key);

        let node_Original = this.pCopyable.getOriginalNode();
        let instanceKeys = this.pCopyable._instanceKeys.concat([ key ]);
        for (let i = 0; i < node_Original.pChildren.length; i++)
            node_Original.pChildren.get(i).pCopyable.deleteCopies(instanceKeys);
        //
        // for (let i = 0; i < node_Original.pChildren.length; i++) {
        //
        //     let newChildNode = node_Original.pChildren.get(i).pCopyable.createCopy(
        //             true, this.pCopyable._instanceKeys.concat([ key ]));
        //     instance.pChildren.add(newChildNode);
        // }

        if (this.active)
            instance.deactivate();
    }

    getInstanceNodeCopies(sourceNode, key)
    {
        js0.args(arguments, Node, [ 'string', 'number' ]);

        if (!this._instances.has(key))
            return null;

        let instance = this._instances.get(key);

        let nodeCopies = [];
        for (let nodeCopy of instance._nodeCopies) {
            if (nodeCopy.pCopyable.sourceNode === sourceNode)
                nodeCopies.push(nodeCopy);
        }

        return nodeCopies;
    }

    pop()
    {
        if (this._instances.size <= 0)
            throw new Error('Cannot `pop` on empty `RepeatNode`.');

        let key = Array.from(this._instances.keys)[this._instances.size - 1];
        let lastInstance = this._instances.get(key);

        if (this.active)
            lastInstance.deactivate();
    }

    push()
    {
        let index = 0;
        while(this._instances.has(index))
            index++;

        this.add(index);
    }


    /* Node */
    __isDisplayed()
    {
        if (!this.active)
            return false;

        return this.parentNode.displayed;
    }

    __onActivate()
    {
        js0.assert(this.parentNode !== null, 'Parent node not set.');

        for (let i = 0; i < this._instances.size; i++)
            this._instances.getAt(i).activate();
    }

    __onDeactivate()
    {
        for (let i = this._instances.size - 1; i >= 0; i--)
            this._instances.getAt(i).deactivate();
    }

    __getHtmlElement()
    {
        js0.assert(this.parentNode !== null, 'Parent node not set.');

        return this.parentNode.htmlElement;
    }

    __getFirstHtmlElement()
    {
        return this._instances.size === 0 ?
                null : this._instances.getAt(0).firstHtmlElement;
    }
    /* / Node */

}
module.exports = RepeatNode;


Object.defineProperties(RepeatNode, {

    PChildren: { value:
    class extends Node.PChildren {

        constructor(node)
        {
            super(node);
        }

        __onAddChild(childNode, nextNode)
        {
            js0.typeE(childNode, js0.Prop(Node.PCopyable));
            // js0.args(arguments, js0.Prop(Node.PCopyable), Node);
        }

        __getNext(childNode)
        {
            let nextNode = this.findNext(childNode);
            if (nextNode !== null)
                return nextNode;

            return this.nextNode;
        }

        __getNextHtmlElement()
        {
            if (this.node.hasParent)
                return this.node.parentNode.nextHtmlElement;

            return null;
        }

    }},


    PCopyable: { value:
    class RepeatNode_PCopyable extends Node.PCopyable
    {

        __createCopy(nodeInstance)
        {
            return new RepeatNode();
        }

    }},

});


require('./RepeatNode.InstanceNode');






 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\ab-nodes\nodes\VirtualNode.js
jsLibs.exportModule('ab-nodes', 'nodes/VirtualNode', (require, module, exports) => { 'use strict';

const abNodes = require('ab-nodes');
const js0 = require('js0');


class VirtualNode extends abNodes.Node
{

    constructor()
    { super();
        js0.prop(this, VirtualNode.PChildren, this);

        // this._idNodes = {};
    }

    // setIds(id_nodes)
    // {
    //     js0.argsE(arguments, 'object');
    //
    //     this._idNodes = id_nodes;
    // }


    /* Node */
    __isDisplayed()
    {
        return this.parentNode.displayed && this.active;
    }

    __onActivate()
    {
        for (let i = 0; i < this.pChildren.length; i++)
            this.pChildren.get(i).activate();
        this.refreshDisplayed(true);
    }

    __onDeactivate()
    {
        this.refreshDisplayed(true);
        for (let i = this.pChildren.length - 1; i >= 0; i--)
            this.pChildren.get(i).deactivate();
    }

    __getHtmlElement()
    {
        js0.assert(this.parentNode !== null, 'Parent node not set.');

        return this.parentNode.htmlElement;
    }

    __getFirstHtmlElement()
    {
        return this.pChildren.length === 0 ?
                null : this.pChildren.get(0).firstHtmlElement;
    }
    /* / Node */

}


Object.defineProperties(VirtualNode, {

    PChildren: { value:
    class VirtualNode_PChildren extends abNodes.Node.PChildren
    {

        constructor(node)
        {
            super(node);
        }
        
        __onAddChild(childNode, next_node)
        {
            if (next_node === null)
                childNode._nextNode = this._nextNode;

            if (this.node.active)
                childNode.activate();
        }

        __getNext(childNode)
        {
            let next_node = this.findNext(childNode);
            if (next_node !== null)
                return next_node;

            return this.node.nextNode;
        }

    }}

});


module.exports = VirtualNode;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\ab-layouts\LayoutNode.js
jsLibs.exportModule('ab-layouts', 'LayoutNode', (require, module, exports) => { 'use strict';

const abNodes = require('ab-nodes');
const js0 = require('js0');


class LayoutNode extends abNodes.Node
{

    constructor()
    { super();
        js0.prop(this, LayoutNode.PChildren, this);
        js0.prop(this, LayoutNode.PCopyable, this, arguments);

        // this._idNodes = {};
    }

    // setIds(id_nodes)
    // {
    //     js0.argsE(arguments, 'object');
    //
    //     this._idNodes = id_nodes;
    // }


    /* Node */
    __isDisplayed()
    {
        return this.parentNode.displayed && this.active;
    }

    __onActivate()
    {
        for (let i = 0; i < this.pChildren.length; i++)
            this.pChildren.get(i).activate();
        this.refreshDisplayed(true);
    }

    __onDeactivate()
    {
        this.refreshDisplayed(true);
        for (let i = this.pChildren.length - 1; i >= 0; i--)
            this.pChildren.get(i).deactivate();
    }

    __getHtmlElement()
    {
        js0.assert(this.parentNode !== null, 'Parent node not set.');

        return this.parentNode.htmlElement;
    }

    __getFirstHtmlElement()
    {
        return this.pChildren.length === 0 ?
                null : this.pChildren.get(0).firstHtmlElement;
    }
    /* / Node */

}
module.exports = LayoutNode;


Object.defineProperties(LayoutNode, {

    PChildren: { value:
    class LayoutNode_PChildren extends abNodes.Node.PChildren
    {

        constructor(node)
        {
            super(node);
        }
        
        __onAddChild(childNode, next_node)
        {
            if (next_node === null)
                childNode._nextNode = this._nextNode;

            if (this.node.active)
                childNode.activate();
        }

        __getNext(childNode)
        {
            let next_node = this.findNext(childNode);
            if (next_node !== null)
                return next_node;

            return this.node.nextNode;
        }

        __getNextHtmlElement()
        {
            return this.node.nextHtmlElement;
        }

    }},

    PCopyable: { value:
    class LayoutNode_PCopyable extends abNodes.Node.PCopyable
    {

        constructor(node, args)
        {
            super(node, args);
        }

        __createCopy(deepCopy, nodeInstances)
        {
            return new LayoutNode(this.__args[0]);
        }

    }},
});






 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\ab-layouts\index.js
jsLibs.exportModule('ab-layouts', 'index', (require, module, exports) => { 'use strict';

const LayoutNode = require('./LayoutNode');


class abLayouts_Class
{

    get LayoutNode() {
        return LayoutNode;
    }

    get Parser() {
        return require('./Parser');
    }

}
module.exports = new abLayouts_Class();






 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\ab-layouts\Parser.js
jsLibs.exportModule('ab-layouts', 'Parser', (require, module, exports) => { 'use strict';

const abNodes = require('ab-nodes');
const js0 = require('js0');

const LayoutNode = require('./LayoutNode');


class Parser
{

    get __elementsStack() {
        return this._elementsStack;
    }


    constructor(layoutContent)
    {
        this._elementsStack = null;
        this._extendFns = [];
    }

    extend(fn)
    {
        this._extendFns.push(fn);
    }

    parse(layoutContent)
    {
        js0.args(arguments, Array);

        this.__beforeParse();

        let layoutNode = new LayoutNode();

        let parentsStack = [{
            node: null,
            nodeContent: layoutContent,
            elements: [],
        }];

        while (parentsStack.length > 0) {
            let parent = parentsStack.pop();

            for (let i = 0; i < parent.nodeContent.length; i++) {
                let nodeInfo = this._parseNodeInfo(parent.nodeContent[i]);

                let element = this.__createElement(nodeInfo, parent.elements);
                if (!js0.type(element, Parser.Element)) {
                    throw new Error(`\`__createNode\` must return` +
                            ` \`abLayout.Parser.Element\` object.`);
                }

                // if ('_id' in nodeInfo.attribs) {
                //     if (nodeInfo.attribs._id in id_nodes) {
                //         console.warn('Node with id `' + nodeInfo.attribs._id +
                //                 '` already exists.');
                //     }
                //     // id_nodes[nodeInfo.attribs._id] = node;
                // }

                if (parent.node === null)
                    layoutNode.pChildren.add(element.topNode);
                else
                    parent.node.pChildren.add(element.topNode);

                if (nodeInfo.type === '_content')
                    continue;

                if (js0.type(element.bottomNode, js0.Prop(abNodes.Node.PChildren))) {
                    parentsStack.push({
                        node: element.bottomNode,
                        nodeContent: nodeInfo.content,
                        elements: parent.elements.concat([ element ]),
                    });
                }
            }

            // parentNodesStack.pop();
            // parent.nodeContentsStack.pop();
            // return;
        }

        // layoutNode.setIds(id_nodes);

        this.__afterParse();

        return layoutNode;
    }


    _execExtendFns(element)
    {
        for (let extendFn of this._extendFns)
            extendFn(element);
    }

    _parseNodeInfo(nodeInfo)
    {
        /* Validate */
        if (!js0.argsC(arguments, [ Array, 'string' ]) || nodeInfo === null) {
            console.error('Error info:', nodeInfo)
            throw new Error(`Node info must be an \`Array\` or \`string\`.`);
        }
        /* / Validate */
        if (nodeInfo instanceof Array) {
            if (!js0.type(nodeInfo[0], 'string')) {
                console.error('Error info:', nodeInfo);
                throw new Error('First element of node info array must be a string.');
            }

            let nodeType = nodeInfo[0];
            let nodeAttribs = {};
            let nodeContent = [];
            for (let i = 1; i < nodeInfo.length; i++) {
                /* Parse Args */
                if (js0.type(nodeInfo[i], js0.RawObject)) {
                    for (let attribName in nodeInfo[i]) {
                        let attribValue = nodeInfo[i][attribName];

                        if (!js0.type(attribValue, [ 'string', Array ]) ||
                                attribValue === null) {
                            console.error('Error info: ', nodeInfo[i]);
                            throw new Error(`Node attrib must be \`string\` or \`Array\`.`);
                        }

                        if (!(attribName in nodeAttribs))
                            nodeAttribs[attribName] = [];

                        if (js0.type(attribValue, 'string'))
                            nodeAttribs[attribName].push(attribValue);
                        else
                            nodeAttribs[attribName] = nodeAttribs[attribName]
                                    .concat(attribValue);
                    }
                /* Parse Node */
                } else
                    nodeContent.push(nodeInfo[i]);
            }

            let element = {
                type: nodeType,
                attribs: nodeAttribs,
                content: nodeContent,
            };

            this._execExtendFns(element);

            return element;
        } else {
            let element = {
                type: '_content',
                attribs: {},
                content: nodeInfo,
            }

            this._execExtendFns(element);

            return element;
        }

        // let nodeType = nodeInfo_keys[0];
        // let nodeContent = nodeInfo[nodeType];
        // this._validateNodeContent(nodeContent);
        //
        // let nodeAttribs = this._parseNodeAttrs(nodeType, nodeContent);
        // if (nodeAttribs !== null)
        //     nodeContent.splice(0, 1);
        //
    }

    _parseNodeAttrs(nodeType, nodeContent)
    {
        if (nodeContent === null)
            return null;
        if (nodeContent.length === 0)
            return null;
        if (Object.keys(nodeContent[0]).length === 0)
            return {};

        let attribs = null;
        for (let attribName in nodeContent[0]) {
            if (attribName[0] !== '_') {
                if (attribs !== null) {
                    console.error('Error info:', { nodeType:  nodeContent });
                    new Error('Only attribs are allowed in first content element.');
                }

                continue;
            }

            if (attribs === null)
                attribs = {};

            attribs[attribName] = nodeContent[0][attribName];
        }

        return attribs;
    }

    // _validateNodeContent(nodeType, nodeContent)
    // {
    //     if (nodeContent !== null) {
    //         if (!(nodeContent instanceof Array)) {
    //             console.error('Error info:', nodeType, nodeContent);
    //             throw new Error('Node content must be `null` or `Array`.');
    //         }
    //     }
    // }


    __afterParse()
    {

    }

    __beforeParse()
    {

    }


    __createElement(nodeInfo) { js0.virtual(this); }

}
module.exports = Parser;


Object.defineProperties(Parser, {

    Element: { value:
    class
    {

        constructor(topNode, bottomNode, info)
        {
            this.topNode = topNode;
            this.bottomNode = bottomNode;
            this.info = info;
        }

    }},

});






 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\ab-fields\index.js
jsLibs.exportModule('ab-fields', 'index', (require, module, exports) => { 'use strict';

const
    Definition = require('./definitions/Definition'),
    Field = require('./fields/Field'),


    ListDefinition = require('./definitions/ListDefinition'),
    ListField = require('./fields/ListField'),

    ObjectDefinition = require('./definitions/ObjectDefinition'),
    ObjectField = require('./fields/ObjectField'),

    VarDefinition = require('./definitions/VarDefinition'),
    VarField = require('./fields/VarField')
;

module.exports.debug = false;
function setDebug(debug) {
    module.exports.debug = debug;
}

function define() {
    return new ObjectDefinition();
}

module.exports.Definition = Definition;
module.exports.Field = Field;

module.exports.ListDefinition = ListDefinition;
module.exports.ListField = ListField;

module.exports.ObjectDefinition = ObjectDefinition;
module.exports.ObjectField = ObjectField;

module.exports.VarDefinition = VarDefinition;
module.exports.VarField = VarField;

module.exports.setDebug = setDebug;
module.exports.define = define;





 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\ab-fields\definitions\Definition.js
jsLibs.exportModule('ab-fields', 'definitions/Definition', (require, module, exports) => { 'use strict'

const
    js0 = require('js0')
;

class Definition
{

    get listeners() {
        return this._listeners;
    }


    constructor()
    {
        this._listeners = [];
    }

    addListener(listener)
    {
        js0.args(arguments, 'object');

        this._listeners.push(listener);
    }


    create(keys = [], root = null, fieldName = null) { js0.virtual(this); }

}
module.exports = Definition;





 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\ab-fields\definitions\ListDefinition.js
jsLibs.exportModule('ab-fields', 'definitions/ListDefinition', (require, module, exports) => { 'use strict';

const 
    js0 = require('js0'),

    ListField = require('../fields/ListField'),

    Definition = require('./Definition'),
    VarDefinition = require('./VarDefinition')
;

class ListDefinition extends Definition
{

    constructor()
    { super();
        this._itemDefinition = null;
    }

    item(itemDefinitionClass = null)
    {
        js0.args(arguments, [ js0.Default, 'function' ]);

        if (this._itemDefinition === null) {
            if (itemDefinitionClass === null)
                itemDefinitionClass = VarDefinition;
            
            this._itemDefinition = new itemDefinitionClass();
            return this._itemDefinition;
        }

        if (itemDefinitionClass !== null) {
            if (!(this._itemDefinition instanceof itemDefinitionClass)) {
                throw new Error(`List items definition class already declared as 
                        '${this._itemDefinition.constructor.name}'.`);
            }
        }

        return this._itemDefinition;
    }


    /* Definition Overrides */
    create(keys = [], root = null, fieldName = null)
    {
        js0.args(arguments, [ js0.Default, Array ], [ js0.Default, 'object' ], 
                [ js0.Default, 'string' ]);

        let field = new ListField(this, keys);

        if (root !== null && fieldName !== null) {
            Object.defineProperty(root, fieldName, {
                get: () => {
                    return field.$value;
                },
                set: (value) => {
                    field.$value = value;
                },
                enumerable: true,
            });
        }

        return field;
    }
    /* / Definition Overrides */

}
module.exports = ListDefinition;





 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\ab-fields\definitions\ObjectDefinition.js
jsLibs.exportModule('ab-fields', 'definitions/ObjectDefinition', (require, module, exports) => { 'use strict';

const 
    js0 = require('js0'),

    ObjectField = require('../fields/ObjectField'),

    Definition = require('./Definition'),
    ListDefinition = require('./ListDefinition'),
    VarDefinition = require('./VarDefinition')
;

class ObjectDefinition extends Definition
{

    get fields() {
        return this._fieldDefinitions;
    }


    constructor()
    { super();

        this._fieldDefinitions = {};
    }

    exists(fieldName)
    {
        return fieldName in this._fieldDefinitions;
    }

    get(fieldName)
    {
        if (!this.exists(fieldName))
            throw new Error(`Field definition '${fieldName}' does not exist.`);

        return this._fieldDefinitions[fieldName];
    }

    list(fieldName, overwrite = false)
    {
        js0.args(arguments, 'string', [ 'boolean', js0.Default ]);

        if (fieldName in this._fieldDefinitions) {
            let def = this._fieldDefinitions[fieldName];

            if (!overwrite) {
                if (!(def instanceof ListDefinition))
                    throw new Error(`Field '${fieldName}' already defined not as 'List'.`);

                return def;
            } else {
                if (def instanceof ListDefinition)
                    return def;
            }
        }

        let def = new ListDefinition();
        this._fieldDefinitions[fieldName] = def;

        return def;
    }

    object(fieldName, overwrite = false)
    {
        js0.args(arguments, 'string');

        if (fieldName in this._fieldDefinitions) {
            let def = this._fieldDefinitions[fieldName];

            if (!overwrite) {
                if (!(def instanceof ObjectDefinition))
                    throw new Error(`Field '${fieldName}' already defined not as 'Object'.`);
                return def;
            } else {
                if (def instanceof ObjectDefinition)
                    return def;
            }
        }

        let def = new ObjectDefinition();
        this._fieldDefinitions[fieldName] = def;

        return def;
    }

    var(fieldName, overwrite = false)
    {   
        js0.args(arguments, 'string');

        if (fieldName in this._fieldDefinitions) {
            let def = this._fieldDefinitions[fieldName];

            if (!overwrite) {
                if (!(def instanceof VarDefinition))
                    throw new Error(`Field '${fieldName}' already defined not as 'Var'.`);
                return def;
            } else {
                if (def instanceof VarDefinition)
                    return def;
            }
        }

        let def = new VarDefinition();
        this._fieldDefinitions[fieldName] = def;

        return def;
    }

    /* Definition Overrides */
    create(keys = [], root = null, fieldName = null)
    {
        js0.args(arguments, [ js0.Default, Array ], [ js0.Default, 'object' ], 
                [ js0.Default, 'string' ]);

        let field = new ObjectField(this, keys);

        if (root !== null && fieldName !== null) {
            Object.defineProperty(root, fieldName, {
                get: () => {
                    return field.$value;
                },
                set: (value) => {
                    try {
                        field.$value = value;   
                    } catch (err) {
                        console.error('ABFields Stack: ', fieldName);
                        throw err;
                    }
                },
                enumerable: true,
            });
        }

        return field;
    }
    /* / Definition Overrides */

}
module.exports = ObjectDefinition;





 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\ab-fields\definitions\VarDefinition.js
jsLibs.exportModule('ab-fields', 'definitions/VarDefinition', (require, module, exports) => { 'use strict';

const 
    js0 = require('js0'),

    VarField = require('../fields/VarField'),

    Definition = require('./Definition')
;

class VarDefinition extends Definition
{

    constructor()
    { super();

    }

    /* Definition Overrides */
    create(keys = [], root = null, fieldName = null)
    {
        js0.args(arguments, [ js0.Default, Array ], [ js0.Default, 'object' ], 
                [ js0.Default, 'string' ]);

        let field = new VarField(this, keys);

        if (root !== null && fieldName !== null) {
            Object.defineProperty(root, fieldName, {
                get: () => {
                    return field.$value;
                },
                set: (value) => {
                    field.$value = value;
                },
                enumerable: true,
            });
        }

        return field;
    }
    /* / Definition Overrides */

}
module.exports = VarDefinition;





 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\ab-fields\fields\Field.js
jsLibs.exportModule('ab-fields', 'fields/Field', (require, module, exports) => { 'use strict';

const
    js0 = require('js0'),

    Definition = require('../definitions/Definition')
;

class Field
{

    get $value() { js0.virtual(this); }
    set $value(value) { js0.virtual(this); }


    constructor(definition, keys)
    {
        js0.args(arguments, Definition, Array);

        this.__definition = definition;
        this.__keys = keys;
    }

}
module.exports = Field;





 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\ab-fields\fields\VarField.js
jsLibs.exportModule('ab-fields', 'fields/VarField', (require, module, exports) => { 'use strict';

const
    js0 = require('js0'),

    Field = require('./Field')
;

class VarField extends Field
{

    get $value() {
        return this._value;
    }
    set $value(value) {
        this._value = value;

        for (let listener of this.__definition.listeners) {
            if ('change' in listener)
                listener.change(value, this.__keys);
        }
    }

    constructor(definition, keys)
    { super(definition, keys);
        js0.args(arguments, require('../definitions/VarDefinition'), Array);

        this._value = undefined;
    }

}
module.exports = VarField;





 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\ab-fields\fields\ObjectField.js
jsLibs.exportModule('ab-fields', 'fields/ObjectField', (require, module, exports) => { 'use strict';

const 
    js0 = require('js0'),

    abFields = require('../.'),

    Field = require('./Field')
;

class ObjectField extends Field {

    get $value() {
        return this._root;
    }
    set $value(value) {
        js0.args(arguments, js0.RawObject);

        if (value === null) {
            for (let key in this._fields)
                this._fields[key].$value = null;

            return;
        }

        for (let key in value) {
            if (key in this._fields) {
                try {
                    this._fields[key].$value = value[key];
                } catch (err) {
                    console.error('ABFields Stack: ', key);
                    throw err;
                }
            } else if (abFields.Debug)
                console.warn(new Error(`Field '${key}' not defined in Object.`));
        }
    }


    constructor(definition, keys)
    { super(definition, keys);
        js0.args(arguments, require('../definitions/ObjectDefinition'), Array);

        this._root = {};
        this._fields = {};
        
        for (let fieldName in this.__definition.fields) {
            let fieldDef = this.__definition.fields[fieldName];
            let field = fieldDef.create(keys, this._root, fieldName);
            this._fields[fieldName] = field;
        }
    }   

    $delete(key)
    {
        js0.args(arguments, [ 'number', 'string' ]);

        if (!(key in this._fields))
            throw new Error(`Key '${key}' does not exist.`);

        delete fields[key];

        for (let listener of this._listeners) {
            if ('delete' in listener)
                listener.delete(key, this._parentFields._keys);
            if ('change' in listener)
                listener.change(value, this._parentFields._keys);
        }
    }

    $get(fieldName)
    {
        if (!this.$exists(fieldName))
            throw new Error(`Field '${fieldName}' does not exist in object.`);

        return this._fields[fieldName];
    }

    $exists(fieldName)
    {
        return fieldName in this._fields;
    }

}
module.exports = ObjectField;





 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\ab-fields\fields\ListField.js
jsLibs.exportModule('ab-fields', 'fields/ListField', (require, module, exports) => { 'use strict';

const 
    js0 = require('js0'),

    Field = require('./Field')
;

class ListField extends Field {

    get $size() {
        return this._items.size;
    }

    get $value() {
        let self = this;
        return function() {
            let hasKey = arguments.length > 0;
            let hasValue = arguments.length > 1;

            if (arguments.length > 0) {
                let key = arguments[0];
                if (!js0.type(key, [ 'number', 'string' ]))
                    throw new Error(`List 'key' must be a number or string.`);

                if (!self.$has(key))
                    self.$add(key);

                if (arguments.length > 1) {
                    self.$get(key).$value = arguments[1];
                    return undefined;
                }

                return self.$get(key).$value;
            }
            
            return self;
        }
    }
    set $value(value) {
        if (!js0.type(value, [ js0.Null, js0.Iterable ]))
            throw new Error('List value must be an iterable or null.');

        if (value === null)
            return;

        let oldKeys = this.$keys();

        if (value instanceof Array) {
            for (let key of oldKeys) {
                if (!Number.isInteger(key)) {
                    this.$delete(key);
                    continue;
                }

                if (key < 0 || key >= value.length)
                    this.$delete(key);
            }

            for (let i = 0; i < value.length; i++)
                this.$set(i, value[i]);
        } else {
            for (let key of oldKeys) {
                if (!value.has(key))
                    this.$delete(key);
            }
            
            for (let [ key, item ] of value)
                this.$set(key, item);
        }
    }

    constructor(definition, keys)
    { super(definition, keys);
        js0.args(arguments, require('../definitions/ListDefinition'), Array);

        this._root = {};
        this._items = new js0.List();
    }   

    [Symbol.iterator]()
    {
        return new ListField.Iterator(this);
    }

    $add(key, value = null)
    {
        js0.args(arguments, [ 'number', 'string' ], [ null, js0.Default ]);

        this.$addAt(this.$size, key, value);

        // if (this._items.has(key))
        //     throw new Error(`Key '${key}' already exists in list.`);

        // let keys = this.__keys.slice();
        // keys.push(key);

        // let itemField = this.__definition.item().create(keys);
        // this._items.set(key, itemField);

        // for (let listener of this.__definition.listeners) {
        //     if ('add' in listener)
        //         listener.add(key, this.__keys);
        // }

        // this.$get(key).$value = value;
    }

    $addAt(index, key, value = null)
    {
        js0.args(arguments, 'number', [ 'number', 'string' ], null);

        if (this._items.has(key))
            throw new Error(`Key '${key}' already exists in list.`);

        if (index < 0)
            throw new Error(`Index '${index}' cannot be lower than 0.`);
        if (index > this.$size)
            throw new Error(`Index '${index}' cannot be higher than list size '${this.$size}'.`);

        let keys = this.__keys.slice();
        keys.push(key);
        // keys.splice(index, 0, key);

        let itemField = this.__definition.item().create(keys);
        this._items.addAt(index, key, itemField);

        for (let listener of this.__definition.listeners) {
            if ('add' in listener)
                listener.add(index, key, this.__keys);
            if ('change' in listener)
                listener.change(value, this.__keys);
        }

        this.$get(key).$value = value;
    }

    $delete(key)
    {
        js0.args(arguments, [ 'number', 'string' ]);

        if (!this.$has(key))
            throw new Error(`Key '${key}' does not exist in 'ListField'.`);

        this._items.delete(key);

        for (let listener of this.__definition._listeners) {
            if ('delete' in listener)
                listener.delete(key, this.__keys);
            if ('change' in listener)
                listener.change(value, this.__keys);
        }
    }

    $deleteAt(index)
    {
        js0.args(arguments, [ 'number', ]);

        if (index < 0)
            throw new Error(`Index '${index}' cannot be lower than 0.`);

        if (index >= this.$size)
            throw new Error(`Index '${index}' is higher than list size '${this.$size}.`);

        let key = this._items.getKeyAt(index);
        this.$delete(key);
    }

    $get(key)
    {
        js0.args(arguments, [ 'number', 'string' ]);

        if (!(this._items.has(key)))
            throw new Error(`Item with key '${key}' does not exist in list.`);

        return this._items.get(key);
    }

    $has(key)
    {
        return this._items.has(key);
    }

    $index(key)
    {
        let keys = this.$keys();
        for (let i = 0; i < keys.length; i++) {
            if (keys[i] === key)
                return i;
        }

        return -1;
    }

    $keys()
    {
        return this._items.keys();
    }

    $push(value = null)
    {
        let index = 0;

        if (this._items.size > 0) {
            let lastKey = this._items.getKeyAt(this._items.size - 1);
            if (Number.isInteger(lastKey))
                index = lastKey + 1;
        }

        while (this.$has(index))
            index++;

        this.$add(index, value);
        this.$get(index).$value = value;
    }

    $set(key, value)
    {
        js0.args(arguments, [ 'number', 'string' ], null);

        if (!this.$has(key))
            this.$add(key, value);
        else
            this.$get(key).$value = value;
    }

}
module.exports = ListField;


Object.defineProperties(ListField, {

    Iterator: { value:
    class ListField_Iterator
    {

        constructor(listField)
        {
            this._list = listField;
            this._iterator = listField._items[Symbol.iterator]();
        }

        next()
        {
            let iteratorItem = this._iterator.next();

            if (iteratorItem.done)
                return { value: undefined, done: true, };

            return {
                value: [ iteratorItem.value[0], this._list.$get(iteratorItem.value[0]), ],
                done: false,
            };
        }

    }},

});





 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\ab-pager\Pager.js
jsLibs.exportModule('ab-pager', 'Pager', (require, module, exports) => { 'use strict';

const
    js0 = require('js0')
;

class Pager
{

    get base() {
        return this._base;
    }

    get current() {
        return this._currentPageInfo;
    }

    get pages() {
        return this._pages;
    }


    constructor(base = '/', useState = true)
    {
        this._initialized = false;

        this._base = base;
        this._useState = useState;
        this._pages = new Map();

        this._currentPage = null;
        this._currentPageInfo = null;

        this._listeners_OnPageChanged = [];
        this._listeners_OnPageSet = {};
        this._listeners_OnBeforePageSet = [];

        this._listeners_NotFound = null;
        this._listeners_OnBeforePopState = null;
    }

    addListener_OnBeforePageSet(listenerFn)
    {
        this._listeners_OnBeforePageSet.push(listenerFn);
    }

    addListener_OnPageChanged(listenerFn) {
        this._listeners_OnPageChanged.push(listenerFn);
    }

    clearPages()
    {
        this._pages.clear();

        return this;
    }

    getPage(pageName)
    {
        js0.args(arguments, 'string');

        if (!this._pages.has(pageName))
            throw new Error(`Page '${pageName}' does not exist.`);

        return this._pages.get(pageName);
    }

    getPageInfo_FromUri(uri)
    {
        if (this._pages.size === 0)
            throw new Error(`Cannot parse uri '${uri}'. No pages set.`);

        let base = this._base;
        base = base.substring(0, base.length);

        if (uri.indexOf(base) !== 0) {
            window.location = base;
            return null;
        }

        uri = uri.substring(base.length);
        
        let uriArr = uri.split('?');
        uri = uriArr[0];
        let search = uriArr.length === 1 ? '' : uriArr[1];

        let searchParams = {};
        let searchArr = search.split('&');
        for (let searchParam of searchArr) {
            let searchParamArr = searchParam.split('=');
            if (searchParamArr.length < 2)
                continue;
            
            searchParams[searchParamArr[0]] = searchParamArr[1];
        }

        let uriArray = uri.split('/');
        if (uriArray[uriArray.length - 1] === '')
            uriArray.pop();

        // if (uriArray.length === 0 && !page.extraArg)
        //     uriArray.push('');

        for (let [ pageName, page ] of this._pages) {
            let aliasArray = page.uri.split('/');
            if (aliasArray[aliasArray.length - 1] === '')
                aliasArray.pop();

            if (page.extraArg) {
                if (aliasArray.length > uriArray.length)
                    continue;
            } else {
                if (aliasArray.length !== uriArray.length)
                    continue;
            }

            let args = {};
            let uriMatched = true;

            for (let i = 0; i < aliasArray.length; i++) {
                if (uriArray[i] === '') {
                    uriMatched = aliasArray[i] === '';
                    break;
                }

                if (aliasArray[i][0] === ':') {
                    if (aliasArray[i][0] === 1) {
                        uriMatched = false;
                        break;
                    }

                    let uriArgInfo = this._getUriArgInfo(aliasArray[i]);

                    args[uriArgInfo.name] = decodeURIComponent(uriArray[i]);
                    continue;
                }

                if (aliasArray[i] !== uriArray[i]) {
                    uriMatched = false;
                    break;
                }
            }

            if (!uriMatched)
                continue;

            if (page.extraArg)
                args['*'] = uriArray.slice(aliasArray.length).join('/');

            return {
                name: page.name,
                args: args,
                searchParams: searchParams,
            };
        }

        return null;
    }

    getPageUri(pageName, args = {}, searchParams = {}, pathOnly = false)
    {
        js0.args(arguments, 'string', [ 'object', js0.Default ], 
                [ 'object', js0.Default ], [ 'boolean', js0.Default ]);

        let page = this.getPage(pageName);

        return this.parseUri(page.uri, args, searchParams, null, null, pathOnly);
    }

    hasPage(pageName)
    {
        js0.args(arguments, 'string');

        return this._pages.has(pageName);
    }

    init(setPage = true)
    {
        this._initialized = true;

        if (this._useState) {
            window.onpopstate = () => {
                let uri_PopState = window.location.pathname + 
                        window.location.search;
                if (this._listeners_OnBeforePopState !== null) {
                    if (!this._listeners_OnBeforePopState(uri_PopState))
                        return;
                }
                this._parseUri(uri_PopState, false);
            };
        }

        let uri = window.location.pathname + window.location.search;
        let pageInfo = this.getPageInfo_FromUri(uri);
        if (!setPage)
            return pageInfo;

        this._setPageInfo(pageInfo, false, uri);
    }

    notFound(notFoundListener)
    {
        js0.args(arguments, 'function');

        this._listeners_NotFound = notFoundListener;
    }

    page(name, uri, onPageSetListener = null)
    {
        js0.args(arguments, 'string', 'string', [ 'function', js0.Null ]);

        this._pages.set(name, new Pager.Page(name, uri, onPageSetListener));
        
        if (onPageSetListener !== null) {
            this._listeners_OnPageSet[name] = onPageSetListener;
            // this._listeners_OnPageChanged.push((page, sourcePageName) => {
            //     if (page.name === name)
            //         onPageSetListener(sourcePageName);
            // });
        }

        return this;
    }

    parseUri(uri, args = {}, searchParams = {}, args_Parsed = null, 
            searchParams_Parsed = null, pathOnly = false)
    {   
        let uriArr = uri.split('?');
        uri = uriArr[0];

        /* Uri Args */
        let uriArgs = uri === '' ? [] : uri.split('/');
        if (uriArgs[uriArgs.length - 1] === '')
            uriArgs.pop();

        let pUri = '';
        for (let i = 0; i < uriArgs.length; i++) {
            if (uriArgs[i][0] !== ':') {
                pUri += uriArgs[i] + '/';
                continue;
            }

            let argInfo = this._getUriArgInfo(uriArgs[i]);

            if (!(argInfo.name in args)) {
                if (argInfo.defaultValue === null)
                    throw new Error(`Uri arg '${argInfo.name}' not set.`);

                pUri += argInfo.defaultValue + '/';
                args[argInfo.name] = argInfo.defaultValue;

                if (args_Parsed !== null)
                    args_Parsed[argInfo.name] = String(args[argInfo.name]);

                continue;
            }

            pUri += encodeURIComponent(args[argInfo.name]) + '/';

            if (args_Parsed !== null)
                args_Parsed[argInfo.name] = String(args[argInfo.name]);
        }
        if ('*' in args) 
            pUri += args['*'];

        /* Search Params */
        let search = '';
        for (let searchParam_Name in searchParams) {
            search += (search === '' ? '?' : '&') + searchParam_Name + '=' +
                    searchParams[searchParam_Name];
        }

        pUri += search;

        if (pathOnly)
            return pUri;
        else
            return this._base + pUri;
    }

    parseUri_PathOnly(uri, args = {}, searchParams = {}, args_Parsed = null, 
        searchParams_Parsed = null)
    {   
        return this.parseUri(uri, args, searchParams, args_Parsed, 
                searchParams_Parsed, true);
    }

    removeListener_OnBeforePageSet(listenerFn)
    {
        for (let i = 0; i < this._listeners_OnBeforePageSet.length; i++) {
            if (this._listeners_OnBeforePageSet[i] === listenerFn) {
                this._listeners_OnBeforePageSet.splice(i, 1);
                return;
            }
        }

        throw new Error(`Listener function does not exist.`);
    }

    setPage(pageName, uriArgs = {}, searchParams = {}, pushState = true, 
            pageArgs = {}, skipOnPageChangedListener = false, 
            skipOnPageSetListener = false)
    {
        js0.args(arguments, 'string', [ js0.Default, 'object' ], 
                [ js0.Default, 'object' ], [ js0.Default, 'boolean' ], 
                [ js0.Default, js0.RawObject ], [ js0.Default, 'boolean' ],
                [ js0.Default, 'boolean' ]);

        if (!this._pages.has(pageName))
            throw new Error('Page `' + pageName + '` does not exist.`');

        for (let argName in uriArgs) {
            uriArgs[argName] = uriArgs[argName] === null ? 
                null : String(uriArgs[argName]);
        }

        let newPage = this._pages.get(pageName);
        let uriArgs_Parsed = {};
        let uri = this.parseUri(newPage.uri, uriArgs, searchParams, uriArgs_Parsed);
        uriArgs = uriArgs_Parsed;

        for (let listenerFn of this._listeners_OnBeforePageSet) {
            if (listenerFn(pageName, uriArgs, searchParams, pushState) === false)
                return;
        }

        let source = this._currentPage;
        this._currentPage = newPage;

        this._currentPageInfo = new Pager.PageInfo(pageName, uriArgs, searchParams);

        if (this._useState) {
            if (pushState)
                window.history.pushState({}, '', uri);
            else
                window.history.replaceState({}, '', uri);
        }

        // let currentPage = {
        //     name: this._currentPageInfo.name,
        //     args: this._currentPageInfo.args,
        //     searchParams: this._currentPageInfo.searchParams,
        // };

        if (!skipOnPageChangedListener) {
            for (let i = 0; i < this._listeners_OnPageChanged.length; i++)
                this._listeners_OnPageChanged[i](this._currentPageInfo, source);
        }

        if (!skipOnPageSetListener) {
            if (this._currentPageInfo.name in this._listeners_OnPageSet) {
                this._listeners_OnPageSet[this._currentPageInfo.name](
                        this._currentPageInfo, source, pageArgs);
            }
        }
    }

    setListener_OnBeforePopState(listenerFn) {
        this._listeners_OnBeforePopState = listenerFn;
    }

    setUri(uri, pushState = true)
    {
        this._parseUri(uri, pushState);
    }


    _getUriArgInfo(uriArg)
    {
        let argName = uriArg.substring(1);
        let argDefault = null;
        let argNameArray = argName.split('=');
        if (argNameArray.length > 1) {
            argName = argNameArray[0];
            argDefault = argNameArray[1];
        }

        return {
            name: argName,
            defaultValue: argDefault
        };
    }

    _parseUri(uri, pushState)
    {
        let pageInfo = this.getPageInfo_FromUri(uri);

        this._setPageInfo(pageInfo, pushState, uri);
    }

    _setPageInfo(pageInfo, pushState, uri)
    {
        js0.args(arguments, js0.RawObject, [ 'boolean', js0.Default ], 'string');

        if (pageInfo === null) {
            if (this._listeners_NotFound === null)
                throw new Error(`Cannot parse uri '${uri}'. No page found.`);
            else
                this._listeners_NotFound(uri, pushState);
        } else {
            this.setPage(pageInfo.name, pageInfo.args, pageInfo.searchParams, 
                    pushState);
        }
    }

}
module.exports = Pager;

Object.defineProperties(Pager, {
    
    Page: { value: 
    class Pager_Page {

        constructor(name, uri, onPageSetListener) {
            let extraArg = false;

            if (uri.indexOf('*') !== -1) {
                extraArg = true;

                if (uri.indexOf('*') !== uri.length - 1) 
                    throw new Error(`'*' must be the last character of uri.`);

                if (uri.indexOf('*') === uri.length - 1) {
                    if (uri.length === 1) {
                        uri = '';
                    } else {
                        if (uri.indexOf('/*') !== uri.length - 2)
                            throw new Error(`'*' must be a separate uri element.`);
                        uri = uri.substring(0, uri.length - 2);
                    }
                }
            }

            Object.defineProperties(this, {
                name: { value: name, },
                uri: { value: uri, },
                onPageSetListener: { value: onPageSetListener, },
                extraArg: { value: extraArg, },
            });
        }

    }},

    PageInfo: { value:
    class Pager_PageInfo {

        get args() {
            let argsR = {};
            for (let argName in this._args)
                argsR[argName] = this._args[argName];

            return argsR;
        }

        get name() {
            return this._name;
        }

        get searchParams() {
            let searchParamsR = {};
            for (let searchParamName in this._searchParams)
                searchParamsR[searchParamName] = this._searchParams[searchParamName];

            return searchParamsR;
        }


        constructor(pageName, args, searchParams)
        {
            this._name = pageName;
            this._args = args;
            this._searchParams = searchParams;
        }
        
    }},

});





 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\ab-pager\index.js
jsLibs.exportModule('ab-pager', 'index', (require, module, exports) => { 'use strict';

const
    Pager = require('./Pager')
;

class abPager_Class
{

    get Pager() {
        return Pager;
    }


    constructor()
    {
            
    }
    
}
module.exports = new abPager_Class();





 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\ab-native\ActionsSetDef.js
jsLibs.exportModule('ab-native', 'ActionsSetDef', (require, module, exports) => { 'use strict';

const
    js0 = require('js0'),

    abNative = require('.')
;

class ActionsSetDef
{

    constructor() {
        js0.args(arguments);

        this._actions_Native = {};
        this._actions_Web = {};
    }

    addNative(actionName, actionArgs, resultArgs) {
        js0.args(arguments, 'string', [ js0.RawObject, js0.Null ], 
                [ js0.RawObject, js0.Null ]);

        this._actions_Native[actionName] = {
            name: actionName,
            actionArgs: actionArgs,
            resultArgs: resultArgs,
        };

        return this;
    }

    addWeb(actionName, actionArgs, resultArgs, fn) {
        js0.args(arguments, 'string', [ js0.RawObject, js0.Null ], 
                [ js0.RawObject, js0.Null ], 'function');

        this._actions_Web[actionName] = {
            name: actionName,
            actionArgs: actionArgs,
            resultArgs: resultArgs,
            fn: fn,  
        };

        return this;
    }

    // callNative(actionsSetName, actionName, actionArgs = {}, callbackFn = null)
    // {
    //     abNative.callNative(actionsSetName, actionName, actionArgs, callbackFn);
    // }

    // callNative_Async(actionName, actionArgs = {})
    // {
    //     return new Promise((resolve, reject) => {
    //         try {
    //             this.callNative(actionName, actionArgs, (result) => {
    //                 resolve(result);
    //             });
    //         } catch (e) {
    //             reject(e);
    //         }
    //     });
    // }

    getNativeInfo(actionName) {
        if (!(actionName in this._actions_Native))
            throw new Error(`Action '${actionName}' does not exist.`);

        return this._actions_Native[actionName];
    }

    getWebInfo(actionName) {
        if (!(actionName in this._actions_Web))
            throw new Error(`Action '${actionName}' does not exist.`);

        return this._actions_Web[actionName];
    }

    hasNative(actionName) {
        return actionName in this._actions_Native;
    }

    // init()
    // {
    //     abNative.init(this);
    // }

}

module.exports = ActionsSetDef;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\ab-native\NativeActionsSet.js
jsLibs.exportModule('ab-native', 'NativeActionsSet', (require, module, exports) => { 'use strict';

const
    js0 = require('js0'),

    abNative = require('.')
;

class NativeActionsSet
{

    constructor(name, actionsSet) {
        js0.args(arguments, 'string', require('./ActionsSetDef'));

        this.name = name;
        this.actionsSet = actionsSet;
    }

    async callNative_Async(actionName, actionArgs = null) {
        return await abNative.callNative_Async(this.name, actionName, actionArgs);
    }

}

module.exports = NativeActionsSet;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\ab-native\NativeApp.js
jsLibs.exportModule('ab-native', 'NativeApp', (require, module, exports) => { 'use strict';

const
    js0 = require('js0'),

    abNative = require('.')
;

class NativeApp
{

    constructor() {
        
    }

    callNative(actionId, actionsSetName, actionInfo, args = null) {
        js0.args(arguments, 'int', 'string', js0.RawObject, [ js0.RawObject, 
                js0.Null, js0.Default ]);

        let errors = [];
        if (actionInfo.actionArgs === null) {
            if (args !== null) {
                console.error('Action takes no arguments.');
                throw new Error(`Wrong action '${actionsSetName}:${actionInfo.name}' args.`);
            }
        } else {
            if (args === null) {
                console.error('Action takes arguments, none given.');
                throw new Error(`Wrong action '${actionsSetName}:${actionInfo.name}' args.`);
            }

            if (!js0.type(args, js0.Preset(actionInfo.actionArgs), errors)) {
                console.error(errors);
                throw new Error(`Wrong action '${actionsSetName}:${actionInfo.name}' args.`);
            }
        }
        
        this.__callNative(actionId, actionsSetName, actionInfo.name, args);
    }

    callWeb(actionId, actionsSetName, actionName, actionArgs = null) {
        js0.args(arguments, 'int', 'string', 'string', [ js0.RawObject,
                js0.Null ]);

        let actionInfo = null;
        try {
            actionInfo = abNative.getActionsSet(actionsSetName)
                    .getWebInfo(actionName);
        } catch (err) {
            console.error(err);
            this.__onWebResult(actionId, null, err.toString());
            return;
        }

        if (actionInfo.actionArgs === null) {
            if (actionArgs !== null) {
                let errorMessage = `Wrong action '${actionsSetName}:${actionInfo.name}' args:` +
                        ' Action takes no arguments some given.';
                console.error(errorMessage);
                this.__onWebResult(actionId, null, errorMessage);
                return;
            }
        } else {
            let errors = [];
            if (!js0.type(actionArgs, js0.Preset(actionInfo.actionArgs), errors)) {
                let errorMessage = `Wrong action '${actionsSetName}:${actionInfo.name}'` +
                        ' args:';
                console.error(errorMessage, errors);
                this.__onWebResult(actionId, null, errorMessage +  '\r\n' +
                        errors.join('\r\n'));
                return;
            }
        }

        let fnResult = actionInfo.fn(actionArgs);
        if (js0.type(fnResult, Promise)) {
            fnResult
                .then((result) => {
                    this._callWeb_ParseResult(actionId, actionInfo, result);
                })
                .catch((err) => {
                    console.error(err);
                    this.__onWebResult(actionId, null, err.toString());
                });
        } else {
            try {
                this._callWeb_ParseResult(actionId, actionInfo, fnResult);
            } catch (err) {
                console.error(err);
                this.__onWebResult(actionId, null, err.toString());
                return;
            }
        }

        // this.__onWebResult(actionId, result);
    }

    init() {
        this.__init();
    }

    
    _callWeb_ParseResult(actionId, actionInfo, result) {
        let errors = [];
        if (actionInfo.resultArgs === null) {
            if (!js0.type(result, [ js0.Null, 'undefined' ]))
                throw new Error(`Wrong action '${actionInfo.name}' result. Expected: none.`);
            result = null;
        } else if (!js0.type(result, js0.Preset(actionInfo.resultArgs), errors)) {
            console.error(errors);
            throw new Error(`Wrong action '${actionInfo.name}' result. Expected: ` + 
                    actionInfo.resultArgs);
        }

        this.__onWebResult(actionId, result, null);
    }

    _getNextActionId() {
        return ++this.actionId_Last;
    }


    __callNative(actionId, actionsSetName, actionName, actionArgs) {
        js0.args(arguments, 'string', 'string', [ js0.RawObject, js0.Null ]);
        js0.virtual(this);
    }

    __init() {
        js0.virtual(this);
    }

    __onWebResult(actionId, result, error) {
        js0.args(arguments, 'int', [ js0.RawObject, js0.Null ], 
                [ 'string', js0.Null ]);
        js0.virtual(this);
    }

}

module.exports = NativeApp;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\ab-native\NativeApp_Android.js
jsLibs.exportModule('ab-native', 'NativeApp_Android', (require, module, exports) => { 'use strict';

const
    js0 = require('js0'),

    NativeApp = require('./NativeApp')
;

class NativeApp_Android extends NativeApp
{

    constructor() {
        super();
    }


    /* NativeApp */
    __callNative(actionId, actionsSetName, actionName, args) {
        js0.args(arguments, 'int', 'string', 'string', [ js0.RawObject, 
                js0.Null ] );
        
        if (typeof abNative_Android === 'undefined')
            throw new Error('Native module not initialized.');

        abNative_Android.callNative(actionId, actionsSetName, actionName, 
                args === null ? null : JSON.stringify(args));
    }

    __init() {
        if (typeof abNative_Android === 'undefined')
            throw new Error('Native module not initialized.');

        abNative_Android.webViewInitialized();
    }

    __onWebResult(actionId, result, error) {
        js0.args(arguments, 'int', [ js0.RawObject, js0.Null ],
                [ 'string', js0.Null ]);

        if (typeof abNative_Android === 'undefined')
            throw new Error('Native module not initialized.');

        console.log('Calling on web result', actionId, new Error());

        abNative_Android.onWebResult(actionId, result === null ? 
                null : JSON.stringify(result), error);
    }
    /* / NativeApp */

}

module.exports = NativeApp_Android;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\ab-native\WebApp.ActionsSet.js
jsLibs.exportModule('ab-native', 'WebApp.ActionsSet', (require, module, exports) => { 'use strict';

const
    js0 = require('js0')
;

'use strict';

class ActionsSet
{

    constructor(webApp) {
        js0.args(arguments, require('./WebApp'));

        this.webApp = webApp;

        this._actions_Native = {};
    }

    addNative(actionName, fn) {
        js0.args(arguments, 'string', 'function');

        this._actions_Native[actionName] = {
            fn: fn,
        };
    }

    callWeb(actionsSetName, actionName, args, callbackFn) {
        js0.args(arguments, 'string', js0.RawObject, callbackFn);

        this.webApp.callWeb(actionsSetName, actionName, args, callbackFn);
    }

    hasNative(actionName) {
        return actionName in this._actions_Native;
    }

    getNativeInfo(actionName) {
        if (!(actionName in this._actions_Native))
            abNative.errorNative(`Action '${actionName}' does not exist.`);

        return this._actions_Native[actionName];
    }

}

module.exports = ActionsSet;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\ab-native\NativeApp_Web.js
jsLibs.exportModule('ab-native', 'NativeApp_Web', (require, module, exports) => { 'use strict';

const
    js0 = require('js0'),

    NativeApp = require('./NativeApp')
;

class NativeApp_Web extends NativeApp 
{

    constructor() {
        super();
    }

    
    /* NativeApp */
    __callNative(actionId, actionsSetName, actionName, args) {
        js0.args(arguments, 'int', 'string', 'string', js0.RawObject);
        abNative_WebApp.callNative(actionId, actionsSetName, actionName, args);
    }

    __init() {
        
    }

    // __onWebResult(actionId, result)
    // {
    //     abNative_WebApp.onWebResult(actionId, result);
    // }
    /* / NativeApp */
}

module.exports = NativeApp_Web;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\ab-native\NativeApp_IOS.js
jsLibs.exportModule('ab-native', 'NativeApp_IOS', (require, module, exports) => { 'use strict';

const
    js0 = require('js0'),

    NativeApp = require('./NativeApp')
;

class NativeApp_IOS extends NativeApp
{

    constructor() {
        super();
    }


    /* NativeApp */
    __callNative(actionId, actionsSetName, actionName, actionArgs) {
        js0.args(arguments, 'int', 'string', 'string', 
                [ js0.RawObject, js0.Null] );
        
        window.webkit.messageHandlers.abNative_IOS.postMessage({
            messageType: 'callNative',
            actionId: actionId, 
            actionsSetName: actionsSetName, 
            actionName: actionName, 
            actionArgs: actionArgs,
        });
    }

    __init() {
        if (typeof window.webkit === 'undefined')
            throw new Error('Native module not initialized.');
        if (typeof window.webkit.messageHandlers === 'undefined')
            throw new Error('Native module not initialized.');
        if (typeof window.webkit.messageHandlers.abNative_IOS === 'undefined')
            throw new Error('Native module not initialized.');

        window.webkit.messageHandlers.abNative_IOS.postMessage({
            messageType: 'webViewInitialized'
        });
    }

    __onWebResult(actionId, result, error) {
        js0.args(arguments, 'int', [ js0.RawObject, js0.Null ], 
                [ 'string', js0.Null ]);

        window.webkit.messageHandlers.abNative_IOS.postMessage({
            messageType: 'onWebResult',
            actionId: actionId,
            result: result,
            error: error,
        });
    }
    /* / NativeApp */

}

module.exports = NativeApp_IOS;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\ab-native\WebApp.js
jsLibs.exportModule('ab-native', 'WebApp', (require, module, exports) => { 'use strict';

const
    js0 = require('js0'),

    ActionsSet = require('./WebApp.ActionsSet'),
    NativeActionsSet = require('./WebApp.NativeActionsSet')
;

class WebApp
{

    static get ActionsSet() {
        return ActionsSet;
    }


    constructor() {
        this._actionsSets = {};
        this._onResultListeners = {};

        this._actionId_Last = 0;
    }

    addActionsSet(actionsSetName, actionsSet) {
        js0.args(arguments, 'string', require('./WebApp.ActionsSet'));

        this._actionsSets[actionsSetName] = actionsSet;

        return new NativeActionsSet(actionsSetName, actionsSet);
    }

    callNative(actionId, actionsSetName, actionName, args, callbackFn) {
        let actionsSet = this.getActionsSet(actionsSetName);
        if (!actionsSet.hasNative(actionName))
            throw new Error(`Action '${actionName}' does not exist in Actions Set '${actionsSetName}'.`);
        let actionInfo = actionsSet.getNativeInfo(actionName);

        let result = actionInfo.fn(args);
        abNative.onNativeResult(actionId, result);
    }

    callWeb(actionsSetsName, actionName, args, callbackFn = null) {   
        let actionId = ++this._actionId_Last;
        this._onResultListeners[actionId] = callbackFn;
        abNative.callWeb(actionId, actionsSetsName, actionName, args);
    }

    createActionsSet(actionsSetName) {
        return new ActionsSet(this, actionsSetName);
    }

    getActionsSet(actionsSetName) {
        if (!(actionsSetName in this._actionsSets))
            throw new Error(`Actions Set '${actionsSetName}' does not exist.`);

        return this._actionsSets[actionsSetName];
    }

    onWebResult(actionId, result) {
        this._onResultListeners[actionId](result);
        delete this._onResultListeners[actionId];
    }

}

module.exports = WebApp;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\ab-native\index.js
jsLibs.exportModule('ab-native', 'index', (require, module, exports) => { 'use strict';

const
    js0 = require('js0')
;

class abNative_Class
{

    get ActionsSetDef() {
        return require('./ActionsSetDef');
    }

    get WebApp() {
        return require('./WebApp');
    }


    constructor() {
        this.nativeApp = null;

        this._actionsSets = {};
        this._initialized = false;

        this._actionId_Next = 0;
        this._onResultInfos = {};
    }

    addActionsSet(actionsSetName, actionsSet) {
        const 
            NativeActionsSet = require('./NativeActionsSet')
        ;

        js0.args(arguments, 'string', require('./ActionsSetDef'));

        if (this._initialized)
            throw new Error('Cannot add action set after initialization.');

        let nativeActionsSet = new NativeActionsSet(actionsSetName, actionsSet);

        this._actionsSets[actionsSetName] = actionsSet;

        return nativeActionsSet;
    }

    // createActionsSet(actionsSetName)
    // {
    //     js0.args(arguments, 'string');

    //     return new NativeActionsSet(name);
    // }

    callNative_Async(actionsSetName, actionName, args = null) {
        js0.args(arguments, 'string', 'string', [ js0.RawObject, js0.Default ], 
                [ 'function', js0.Null, js0.Default ]);

        if (!this._initialized)
            throw new Error(`'abNative' has not been initialized.`);
        return new Promise((resolve, reject) => {
            try {
                this._callNative(actionsSetName, actionName, args, (result) => {
                    resolve(result);
                }, (err) => {
                    reject(err);
                });
            } catch (err) {
                reject(err);
            }
        });
    }

    callWeb(actionId, actionsSetName, actionName, actionArgs) {
        js0.args(arguments, 'int', 'string', 'string', 
                [ js0.RawObject, js0.Null ]);

        if (this.nativeApp === null)
            throw new Error('Platform not set.');

        if (!this._initialized)
            throw new Error(`'abNative' has not been initialized.`);

        this.nativeApp.callWeb(actionId, actionsSetName, actionName, 
                actionArgs);
    }

    errorNative(message) {
        console.error('Native error:', message);
    }

    // getActionInfo(actionsSetName, actionName) {
    //     if (!(actionName in nativeActions.actions_Web))
    //         throw new Error(`Action '${actionsSetName}:${actionName}' does not exist.`);
    // }

    getActionsSet(actionsSetName) {
        if (!(actionsSetName in this._actionsSets))
            throw new Error(`Actions Set '${actionsSetName}' does not exist.`);

        return this._actionsSets[actionsSetName];
    }

    init(platform) {
        js0.args(arguments, js0.Enum([ 'web', 'android', 'ios' ]));

        if (this._initialized)
            throw new Error(`'abNative' was already initialized.`);
        this._initialized = true;

        if (platform === 'web')
            this.nativeApp = new (require('./NativeApp_Web'))();
        else if (platform === 'android')
            this.nativeApp = new (require('./NativeApp_Android'))();
        else if (platform === 'ios')
            this.nativeApp = new (require('./NativeApp_IOS'))();

        this.nativeApp.init();
    }

    onNativeResult(actionId, result, error) {
        if (!(actionId in this._onResultInfos))
            throw new Error(`Action '${actionId}' does not exist.`);

        let actionInfo = this._onResultInfos[actionId].actionInfo;

        if (error !== null)
            this._onResultInfos[actionId].onErrorFn(error);
        else { 
            if (actionInfo.resultArgs !== null) {
                let errors = [];
                if (!js0.type(result, js0.Preset(actionInfo.resultArgs), errors)) {
                    console.error('Result:', result);
                    console.error(errors);
                    this._onResultInfos[actionId].onErrorFn(
                            `Wrong action '${actionInfo.name}' result.`);
                    delete this._onResultInfos[actionId];
                    return;
                }
            }

            this._onResultInfos[actionId].onResultFn(result);
        }

        delete this._onResultInfos[actionId];

        // let parseResultFn = (result) => {
        //     console.log(actionInfo, result);
        //     if (actionInfo.resultArgs !== null) {
        //         let errors = [];
        //         if (!js0.type(result, js0.Preset(actionInfo.resultArgs), errors)) {
        //             console.error('Result:', result);
        //             console.error(errors);
        //             throw new Error(`Wrong action '${actionInfo.name}' result.`);
        //         }
        //     }
    
        //     if (this._onResultInfos[actionId].callbackFn !== null)
        //         this._onResultInfos[actionId].callbackFn(result);
        //     delete this._onResultInfos[actionId];
        // };

        // if (result instanceof Promise) {
        //     result
        //         .then((result) => {
        //             parseResultFn(result);
        //         })
        //         .catch((e) => {
        //             console.error('Cannot parse native result promise:');
        //             console.error(e);
        //         });
        // } else 
        //     parseResultFn(result);
    }

    // setPlatform(platform)
    // {
    //     js0.args(arguments, js0.Enum([ 'web', 'android', 'ios' ]));

    //     console.log('Platform set: ' + platform);

    //     this.init(platform);
    // }


    _callNative(actionsSetName, actionName, actionArgs, onResultFn, onErrorFn) {
        js0.args(arguments, 'string', 'string', [ js0.RawObject, 
                js0.Null ], 'function', 'function');

        if (this.nativeApp === null)
            throw new Error('Platform not set.');

        if (!this._initialized)
            throw new Error(`'abNative' has not been initialized.`);

        if (!this.getActionsSet(actionsSetName).hasNative(actionName)) {
            throw new Error(`Action '${actionName}' does not exist in Actions Set '${actionsSetName}'.`);
        }
        let actionInfo = this.getActionsSet(actionsSetName)
                .getNativeInfo(actionName);

        let actionId = this._actionId_Next;
        this._actionId_Next++;

        this._onResultInfos[actionId] = {
            actionInfo: actionInfo,
            onResultFn: onResultFn,
            onErrorFn: onErrorFn,
        };

        this.nativeApp.callNative(actionId, actionsSetName, actionInfo, 
                actionArgs);
    }

}
const abNative = new abNative_Class();



module.exports = abNative;


 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\ab-native\WebApp.NativeActionsSet.js
jsLibs.exportModule('ab-native', 'WebApp.NativeActionsSet', (require, module, exports) => { 'use strict';

const
    js0 = require('js0')
;

class NativeActionsSet
{

    constructor(actionsSetName, actionsSet) {
        js0.args(arguments, 'string', require('./WebApp.ActionsSet'));

        this.name = actionsSetName;
        this.actionsSet = actionsSet;
    }

    callWeb(actionName, args, callbackFn) {
        js0.args(arguments, 'string', js0.RawObject, callbackFn);

        this.webApp.callWeb(this.name, actionName, args, callbackFn);
    }

    callWeb_Async(actionName, args) {
        js0.args(arguments, 'string', js0.RawObject);

        return new Promise((resolve, reject) => {
            try {
                this.webApp.callWeb(this.name, actionName, args, (result) => {
                    resolve(result);
                });
            } catch (e) {
                reject(e);
            }
        });
    }

}

module.exports = NativeActionsSet;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\moment\index.js
jsLibs.exportModule('moment', 'index', (require, module, exports) => { 
module.exports = moment;





 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\ab-date\index.js
jsLibs.exportModule('ab-date', 'index', (require, module, exports) => { 'use strict';

const
    js0 = require('js0'),
    moment = require('moment')
;

// if (typeof moment === 'undefined') {
//     console.log('Here?');
//     const
//         moment = require('moment')
//     ;
//     console.log('A', moment);
// }
// console.log('B', moment);

class abDate_Class
{

    get utcOffset() {
        throw new Error(`'abDate.utcOffset' is deprecated.`);
    }


    constructor() {
        this.span_Minute = 60;
        this.span_Hour = 60 * 60;
        this.span_Day = 24 * 60 * 60;

        this.formats_Date = 'DD.MM.YYYY';
        this.formats_DateTime = 'DD.MM.YYYY HH:mm';
        this.formats_Time = 'HH:mm';

        this.setTimezone('UTC');
    }

    format(time, format, timezone = null) {
        js0.args(arguments, [ 'number', js0.Null ], 'string', [ 'string', js0.Null, 
                js0.Default ])
        
        if (time === null)
            return '-';

        return moment.tz(time * 1000, timezone === null ? 
            this._timezone : timezone).format(format);
    }

    format_Date(time, timezone = null) {
        js0.args(arguments, [ 'number', js0.Null ], [ 'string', js0.Null, js0.Default ]);

        return this.format(time, this.formats_Date, timezone);
    }

    format_Date_UTC(time) {
        return this.format_Date(time, 'UTC');
    }

    format_DateTime(time, timezone = null) {
        js0.args(arguments, 'number', [ 'string', js0.Null, js0.Default ]);

        return this.format(time, this.formats_DateTime, timezone);
    }

    format_DateTime_UTC(time) {
        return this.format_DateTime(time, 'UTC');
    }

    format_Time(time) {
        js0.args(arguments, 'number');

        return this.format(time, this.formats_Time, 'UTC');
    }

    format_UTC(time, format) {
        js0.args(arguments, 'number', 'string');

        return this.format(time, format, 'UTC');
    }

    getDate(time = null) {
        js0.args(arguments, [ 'number', js0.Null, js0.Default ]);

        if (time === null)
            return new Date();
            
        return new Date(time * 1000);
    }

    getDay(time = null) {
        js0.args(arguments, [ 'number', js0.Null, js0.Default ]);

        if (time === null)
            time = this.getTime();

        return this.getDay_UTC(time + this.getUTCOffset_Time(time)) - 
                this.getUTCOffset_Time(time);
    }

    getDay_UTC(time = null) {
        js0.args(arguments, [ 'number', js0.Null, js0.Default ]);

        if (time === null)
            time = this.getTime();

        // return Math.floor(time / this.span_Day) * this.span_Day;
        return time - time % this.span_Day;
    }

    getDayOfWeek(time = null) {
        js0.args(arguments, [ 'number', js0.Null, js0.Default ]);

        if (time === null)
            time = this.getTime();
        time += this.getUTCOffset_Time(time);

        return this.getDayOfWeek_UTC(time);
    }

    getDayOfWeek_UTC(time) {
        js0.args(arguments, [ 'number', js0.Null, js0.Default ]);

        let date = new Date(time * 1000);

        return date.getUTCDay();
    }

    getDayNr(time = null) {
        js0.args(arguments, [ 'number', js0.Null, js0.Default ]);

        if (time === null)
            time = this.getTime();
        time += this.getUTCOffset_Time(time);

        return this.getDayNr_UTC(time);
    }

    getDayNr_UTC(time = null) {
        js0.args(arguments, [ 'number', js0.Null, js0.Default ]);

        if (time === null)
            time = this.getTime();

        return this.getDate(time).getUTCDate() - 1;
    }

    getDaysCountInMonth(time = null) {
        js0.args(arguments, [ 'number', js0.Null, js0.Default ]);

        if (time === null)
            time = this.getTime();
        time += this.getUTCOffset_Time(time);

        return this.getDaysCountInMonth_UTC(time);
    }

    getDaysCountInMonth_UTC(time = null) {
        js0.args(arguments, [ 'number', js0.Null, js0.Default ]);

        if (time === null)
            time = abDate.getTime();

        let year = this.getYearNr_UTC(time);
        let month = this.getMonthNr_UTC(time);

        return (new Date(year, month + 1, 0)).getDate();

    }

    getMonth(time = null) {
        js0.args(arguments, [ 'number', js0.Null, js0.Default ]);

        return this.getDay(time) - this.getDayNr(time) * this.span_Day;
    }

    getMonth_UTC(time = null) {
        js0.args(arguments, [ 'number', js0.Null, js0.Default ]);

        return this.getDay_UTC(time) - this.getDayNr_UTC(time) * this.span_Day;
    }

    getMonthNr(time = null) {
        js0.args(arguments, [ 'number', js0.Null, js0.Default ]);

        if (time === null)
            time = this.getTime();
        time += this.getUTCOffset_Time(time);

        return this.getMonthNr_UTC(time);
    }
    
    getMonthNr_UTC(time = null) {
        js0.args(arguments, [ 'number', js0.Null, js0.Default ]);

        if (time === null)
            time = this.getTime();

        return this.getDate(time).getUTCMonth();
    }

    getTime(date = new Date()) {
        js0.args(arguments, [ Date, js0.Default ]);

        return Math.floor(date.getTime() / 1000);
    }

    getTime_Rel(time = null) {
        js0.args(arguments, [ 'number', js0.Default ]);

        if (time === null)
            time = this.getTime();

        return time - this.getUTCOffset_Time(time);
    }

    getUTCOffset(time = null) {
        js0.args(arguments, [ 'number', js0.Null, js0.Default ]);

        console.log(this._timezone);
        return moment.tz.zone(this._timezone).utcOffset(time === null ?
                this.getTime() : time) / 60;
    }

    getUTCOffset_Time(time = null) {
        js0.args(arguments, [ 'number', js0.Null, js0.Default ]);

        return this.getUTCOffset(time) * this.span_Hour;
    }

    getYearNr(time = null) {
        js0.args(arguments, [ 'number', js0.Null, js0.Default ]);

        if (time === null)
            time = this.getTime();
        time += this.getUTCOffset_Time(time);

        return this.getYearNr_UTC(time);
    }

    getYearNr_UTC(time = null) {
        js0.args(arguments, [ 'number', js0.Null, js0.Default ]);

        if (time === null)
            time = abDate.getTime();

        return this.getDate(time).getUTCFullYear();
    }

    setTimezone(timezone) {
        if (moment.tz.zone(timezone) === null)
            throw new Error(`Cannot find timezone: ${timezone}.`);
        
        this._timezone = timezone;
    }

    strToTime(str, timeFormat) {
        js0.args(arguments, 'string', 'string');

        console.log(moment.tz(str, timeFormat, this._timezone).isValid());
        return moment.tz(str, timeFormat, this._timezone).toDate()
                .getTime() / 1000;
    }

    strToTime_UTC(str, timeFormat) {
        js0.args(arguments, 'string', 'string');

        return moment.utc(str, timeFormat).toDate().getTime() / 1000;
    }

    strToTime_Date(str) {
        js0.args(arguments, 'string');

        if (str === '')
            return null;

        return this.strToTime(str, this.formats_Date);
    }

    strToTime_Date_UTC(str) {
        js0.args(arguments, 'string');

        if (str === '')
            return null;

        return this.strToTime_UTC(str, this.formats_Date);
    }

    strToTime_DateTime(str) {
        js0.args(arguments, 'string');

        if (str === '')
            return null;

        return this.strToTime(str, this.formats_DateTime);
    }

    strToTime_DateTime_UTC(str) {
        js0.args(arguments, 'string');

        if (str === '')
            return null;

        return this.strToTime_UTC(str, this.formats_DateTime);
    }

    strToTime_Time(str) {
        js0.args(arguments, 'string');

        if (str === '')
            return null;

        var timestamp = moment.utc(str, this.formats_Time)
                .toDate().getTime() / 1000;

        return timestamp % this.span_Day;
    }

}
module.exports = new abDate_Class();






 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\ab-data\DataStore.js
jsLibs.exportModule('ab-data', 'DataStore', (require, module, exports) => { 'use strict';

const
    js0 = require('js0'),

    abData = require('.'),
    Response = require('./Response')
;

class DataStore
{

    get device() {
        return this._requestProcessor.device;
    }

    get lastId() {
        return this._device.lastId;
    }

    get requestProcessor() {
        return this._requestProcessor;
    }

    get scheme() {
        return this._scheme;
    }


    constructor(requestProcessor) {
        js0.args(arguments, require('./RequestProcessor'));

        this._requestProcessor = requestProcessor;
        this._scheme = requestProcessor.scheme;
    }

    getT(tableName) {
        return this.getTable(tableName);
    }

    getTable(tableName) {
        js0.args(arguments, 'string');

        if (!(this._scheme.hasTable(tableName)))
            throw new Error(`Table '${tableName}' does not exist.`);

        return this._scheme.getTable(tableName);
    }

    nextId() {
        return this.device.nextId();
    }

    async request_Async(requestName, actionName, actionArgs, 
            transactionId = null) {
        js0.args(arguments, 'string', 'string', [ js0.RawObject, js0.Default ],
                [ 'int', js0.Null, js0.Default ]);

        try {
            this.scheme.validateRequest([ 'request', requestName, actionName, 
                    actionArgs ]);
        } catch (err) {
            if (abData.debug)
                console.error(err);

            return {
                actionErrors: {
                    request: err.toString(),
                },
                errorMessage: `Action '${requestName}:${actionName}' error.`,
                info: {},
                requestIds: [],
                results: {},
                type: Response.Types_ActionError,
            };
        }

        let response = await this._requestProcessor.processRequest_Async(
                requestName, actionName, actionArgs, transactionId);

        // this._validateResults([ result ]);

        return response;
    }

    async requestB_Async(requests, transactionId = null) {
        return await this.requestBatch_Async(requests, transactionId);
    }

    async requestBatch_Async(requests, transactionId = null) {
        js0.args(arguments, js0.ArrayItems(js0.PresetArray([ 'string', 'string', 
                'string', js0.RawObject ])), [ 'int', js0.Null, js0.Default ]);

        for (let request of requests) {
            try {
                this.scheme.validateRequest(request)
            } catch(err) {
                return {
                    actionErrors: {
                        [request[0]]: err.toString(),
                    },
                    errorMessage: `Action '${request[0]}:${request[1]}' error.`,
                    info: {},
                    requestIds: [],
                    results: {},
                    type: Response.Types_ActionError,
                };
            }
        }

        let response = await this._requestProcessor.processRequestBatch_Async(
                requests, transactionId);

        for (let request of requests)
            this.scheme.validateRequestResponse(response, request);

        return response;
    }

}
module.exports = DataStore;





 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\ab-data\DatabaseInfo.js
jsLibs.exportModule('ab-data', 'DatabaseInfo', (require, module, exports) => { 'use strict';

const
    // abMysql = require('ab-mysql'),
    js0 = require('js0'),

    FieldInfo = require('./FieldInfo'),
    TableInfo = require('./TableInfo')
;

class DatabaseInfo
{

    static Compare(scheme, dbInfo_Scheme, dbInfo_DB) {
        js0.args(arguments, require('./scheme/DataScheme'), DatabaseInfo,
                DatabaseInfo);

        let ignored_TableNames = scheme.getIgnored_TableNames();

        let actions = {
            tables: {
                delete: [],
                create: [],
                alter: [],
            },
        };

        for (let tableInfo_DB of dbInfo_DB.tableInfos) {
            if (ignored_TableNames.includes(tableInfo_DB.name))
                continue;

            let tableInfo_Scheme = dbInfo_Scheme.getTableInfo_ByName(tableInfo_DB.name);
            if (tableInfo_Scheme === null) {
                actions.tables.delete.push(tableInfo_DB);
                continue;
            }
        }

        for (let tableInfo_Scheme of dbInfo_Scheme.tableInfos) {
            let tableInfo_DB = dbInfo_DB.getTableInfo_ByName(tableInfo_Scheme.name);
            if (tableInfo_DB === null) {
                actions.tables.create.push(tableInfo_Scheme);
                continue;
            }

            if (ignored_TableNames.includes(tableInfo_DB.name))
                continue;

            let actions_Alter = DatabaseInfo.Compare_Tables(tableInfo_DB, 
                    tableInfo_Scheme);
            if (actions_Alter.delete.length > 0 || actions_Alter.create.length > 0 ||
                    actions_Alter.change.length > 0) {
                actions.tables.alter.push(actions_Alter);
            }

            if (actions_Alter.change.length > 0) {
                actions.tables.delete.push(tableInfo_DB);
                actions.tables.create.push(tableInfo_Scheme);

                actions_Alter.delete = [];
                actions_Alter.create = [];
                actions_Alter.change = [];
            }
        }

        return actions;
    }

    static Compare_Fields(fieldInfo_DB, fieldInfo_Conf) {
        // console.log('DB', fieldInfo_DB);
        // console.log('Info', fieldInfo_Conf);
        // console.log('###');

        if (fieldInfo_DB.name !== fieldInfo_Conf.name ||
                !fieldInfo_Conf.types.includes(fieldInfo_DB.types[0]) || 
                fieldInfo_DB.key !== fieldInfo_Conf.key ||
                fieldInfo_DB.notNull !== fieldInfo_Conf.notNull) {
            
            console.log('#');
            console.log('DB', fieldInfo_DB);
            console.log('Conf', fieldInfo_Conf);

            return true;
        }    

        return false;
    }

    static Compare_Tables(tableInfo_DB, tableInfo_Scheme) {
        let actions = {
            tableInfo: tableInfo_Scheme,
            delete: [],
            create: [],
            change: [],
        };

        for (let fieldInfo_DB of tableInfo_DB.fieldInfos) {
            let fieldInfo_Conf = tableInfo_Scheme.getFieldInfo_ByName(fieldInfo_DB.name);
            if (fieldInfo_Conf === null) {
                actions.delete.push(fieldInfo_DB);
                continue;
            }
        }

        for (let fieldInfo_Conf of tableInfo_Scheme.fieldInfos) {
            let fieldInfo_DB = tableInfo_DB.getFieldInfo_ByName(fieldInfo_Conf.name);
            if (fieldInfo_DB === null) {
                actions.create.push(fieldInfo_Conf);
                continue;
            }

            let actions_Fields = DatabaseInfo.Compare_Fields(fieldInfo_DB, 
                    fieldInfo_Conf);
            if (actions_Fields) {
                console.warn('Modyfing columns not implemented. Rebuilding table.');
                actions.change.push(fieldInfo_Conf);
            }
        }

        return actions;
    }

    // static Create_FromConfig(database)
    // {
    //     let databaseInfo = new DatabaseInfo();

    //     for (let table of database.tables) {
    //         let tableInfo = new TableInfo(table.name);
    //         for (let [ fieldName, field ] of table.columns) {
    //             let fieldInfo = new FieldInfo(
    //                 fieldName,
    //                 FieldInfo.GetType_FromField(field),
    //                 '',
    //                 field.properties.notNull,
    //             );
    //             tableInfo.addFieldInfo(fieldInfo);
    //         }
    //         databaseInfo.addTableInfo(tableInfo);
    //     }

    //     return databaseInfo;
    // }

    // static async CreateFrom_DB_Async(db)
    // {
    //     let results = null;

    //     let databaseInfo = new DatabaseInfo();

    //     results = await db.query_SelectAsync('SHOW TABLES;');
    //     for (let row of results) {
    //         let tableName = row[Object.keys(row)[0]];

    //         let tableInfo = new TableInfo(tableName);

    //         results = await db.query_SelectAsync(`DESC \`${tableInfo.name}\`;`);
    //         for (let row of results) {
    //             tableInfo.addFieldInfo(new FieldInfo(
    //                 row.Field,
    //                 row.Type,
    //                 row.Key,
    //                 row.Null,
    //             ));
    //         }

    //         databaseInfo.addTableInfo(tableInfo);
    //     }

        

    //     return databaseInfo;
    // }


    get tableInfos() {
        return this._tableInfos;
    }


    constructor() {
        this._tableInfos = [];
    }

    addTableInfo(tableInfo) {
        this._tableInfos.push(tableInfo);
    }

    // compare(dbInfo_Scheme, queries)
    // {
    //     for (let tableInfo of this.tableInfos) {
    //         let tableInfo_Scheme = dbInfo_Scheme.getTableInfo_ByName(tableInfo.name);
    //         if (tableInfo_Scheme === null) {
    //             // console.log('Table', tableInfo.name, 'DELETE');
    //             continue;
    //         }
    //     }

    //     for (let tableInfo_Scheme of dbInfo_Scheme.tableInfos) {
    //         let tableInfo = this.getTableInfo_ByName(tableInfo_Scheme.name);
    //         if (tableInfo === null) {
    //             // console.log('Table', tableInfo_Scheme.name, 'CREATE');
    //             queries.create.push(tableInfo_Scheme.getQuery_Create());
    //             continue;
    //         }

    //         this.compare_Tables(tableInfo, tableInfo_Scheme);
    //     }

    // }

    // compare_Fields(fieldInfo, fieldInfo_Conf)
    // {
    //     // console.log(fieldInfo.name, fieldInfo.type === fieldInfo_Conf.type,
    //     //         fieldInfo.key === fieldInfo_Conf.key, 
    //     //         fieldInfo.notNull === fieldInfo_Conf.notNull);
    // }

    // compare_Tables(tableInfo, tableInfo_Scheme, queries)
    // {
    //     // console.log('Comparing', tableInfo.name);

    //     let actions = false;

    //     for (let fieldInfo of tableInfo.fieldInfos) {
    //         let fieldInfo_Conf = tableInfo_Scheme.getFieldInfo_ByName(fieldInfo.name);
    //         if (fieldInfo_Conf === null) {
    //             actions = true;
    //             // console.log('Field', fieldInfo.name, 'DELETE');
    //             continue;
    //         }
    //     }

    //     for (let fieldInfo_Conf of tableInfo_Scheme.fieldInfos) {
    //         let fieldInfo = tableInfo.getFieldInfo_ByName(fieldInfo_Conf.name);
    //         if (fieldInfo === null) {
    //             actions = true
    //             // console.log('Field', fieldInfo_Conf.name, 'CREATE');
    //             continue;
    //         }

    //         this.compare_Fields(fieldInfo, fieldInfo_Conf);
    //     }

    //     if (actions === true) 
    //         queries.delete.push(tableInfo_Scheme.getQuery_Delete());
    //         queries.create.push(tableInfo_Scheme.getQuery_Create());
    //     }
    // }

    getTableInfo_ByName(tableName) {
        for (let tableInfo of this.tableInfos) {
            if (tableInfo.name.toLowerCase() === tableName.toLowerCase())
                return tableInfo;
        }

        return null;
    }

}
module.exports = DatabaseInfo;





 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\ab-data\Device.js
jsLibs.exportModule('ab-data', 'Device', (require, module, exports) => { 'use strict';

const
    js0 = require('js0')
;

class Device
{

    static get Devices_Offset() {
        return 100000000;
    }


    static GetIdInfo(id) {
        js0.args(arguments, 'number');

        let deviceId = Math.floor(id / Device.Devices_Offset);

        return {
            id: id,
            deviceId: deviceId,
            itemId: id - deviceId * Device.Devices_Offset,
        };
    }


    get declaredItemIds() {
        return this._itemIds_Declared;
    }

    get hash() {
        return this._hash;
    }

    get id() {
        return this._id;
    }

    get lastItemId() {
        return this._lastItemId;
    }

    get lastUpdate() {
        return this._lastUpdate;
    }


    constructor(deviceId, deviceHash, lastUpdate, lastItemId, declaredItemIds = []) {
        js0.args(arguments, js0.Long, 'string', js0.Long, [ js0.Long, js0.Null ],
                [ Array, js0.Default() ]);

        this._id = deviceId;
        this._hash = deviceHash;
        this._lastItemId = lastItemId;
        this._lastUpdate = lastUpdate;

        this._itemIds_Declared = declaredItemIds;

        this._locks = [];
        this._locks_Next = 0;
    }

    isNewId(id) {
        js0.args(arguments, 'number');

        let idInfo = Device.GetIdInfo(id);

        if (this._isNewId_Device(idInfo))
            return true;

        // if (this._isNewId_SystemDevice(idInfo))
        //     return true;

        return false;
    }

    lock() {
        this._locks.push(this._locks_Next++);
    }

    nextId() {
        let nextId = this._id * Device.Devices_Offset + (++this._lastItemId);
        this._itemIds_Declared.push(this._lastItemId);

        return nextId;
    }

    // setDeclaredItemIds(declaredItemIds)
    // {
    //     js0.args(arguments, Array);

    //     this._itemIds_Declared = declaredItemIds;
    // }

    setLastUpdate(lastUpdate) {
        js0.args(arguments, js0.Long);

        this._lastUpdate = lastUpdate;
    }

    unlock(lock) {
        js0.args(arguments, 'int');

        for (let i = 0; i < this._locks.length; i++) {
            if (this._locks[i] === lock) {
                this._locks.splice(i, 1);
                return;
            }
        }

        throw new Error(`Lock '${lock}' does not exist.`);
    }

    update(lastUpdate, lastItemId) {
        js0.args(arguments, js0.Long, js0.Long);

        this._lastUpdate = lastUpdate;
        this._lastItemId = lastItemId;
    }

    
    _checkLock() {
        if (this._locks.length > 0) 
            throw new Error('Device locked.');
    }

    _isNewId_Device(idInfo) {
        if (idInfo['deviceId'] !== this._id)
            return false;

        if (idInfo['itemId'] <= this._itemIds_Last)
            return false;

        if (this._itemIds_Declared.includes(idInfo['itemId']))
            return true;

        return false;
    }

}
module.exports = Device;





 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\ab-data\FieldInfo.js
jsLibs.exportModule('ab-data', 'FieldInfo', (require, module, exports) => { 'use strict';

const
    js0 = require('js0')
;

class FieldInfo
{

    static GetType_FromField(field) {
        js0.args(arguments, require('./fields/ABDField'));

        if (field instanceof require('./fields/ABDAutoIncrementId'))
            return [ 'integer primary key', 'integer' ];
        else if (field instanceof require('./fields/ABDBool'))
            return [ 'tinyint(1)' ];
        // else if (field instanceof require('./fields/ABDDouble'))
        //     return `double`;
        else if (field instanceof require('./fields/ABDFloat'))
            return [ `float` ];
        else if (field instanceof require('./fields/ABDId'))
            return [ `bigint`, `bigint(20)` ];
        else if (field instanceof require('./fields/ABDInt'))
            return [ `int`, `int(11)` ];
        else if (field instanceof require('./fields/ABDJSON'))
            return [ `mediumtext` ];
        else if (field instanceof require('./fields/ABDLong'))
            return [ `bigint` ];
        else if (field instanceof require('./fields/ABDString'))
            return [ `varchar(${field.size})` ];
        else if (field instanceof require('./fields/ABDText')) {
            let dbType = null;
            if (field.type === 'tiny')
                dbType = 'tinytext';
            else if (field.type === 'regular')
                dbType = 'text';
            else if (field.type = 'medium')
                dbType = 'mediumtext';
            else
                throw new Error(`Unknown field type '${field.type}'.`);
          
            return [ dbType ];
        } else if (field instanceof require('./fields/ABDTime'))
            return [ `bigint` ];

        throw new Error(`Unknown FieldInfo type of field '${field.constructor.name}'.`);
    }


    constructor(name, field, types, key, notNull) {
        js0.args(arguments, 'string', [ require('./fields/ABDField'), js0.Null ], 
                js0.ArrayItems('string'), 'string', 'boolean');

        let types_Parsed = [];
        for (let type of types)
            types_Parsed.push(type.toLowerCase());

        this.name = name;
        this.field = field;
        this.types = types_Parsed;
        this.key = '';
        this.notNull = notNull;
    }

    getQuery_Column() {
        let hasDefault = false;

        return `${this.name} ${this.types[0]} ` + (this.notNull ? 'NOT NULL' : 'NULL');
    }

}
module.exports = FieldInfo;





 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\ab-data\RTable.js
jsLibs.exportModule('ab-data', 'RTable', (require, module, exports) => { 'use strict';

const
    js0 = require('js0'),
    
    fields = require('./fields'),
    helper = require('./helper'),

    Table = require('./Table'),
    TableRequestDef = require('./scheme/TableRequestDef')
;

class RTable extends Table
{

    constructor(id, name, alias, columns) {   
        js0.args(arguments, 'int', 'string', 'string', Array);

        if (name[0] !== '_') {
            columns = [
                [ '_Id', fields.Id({ notNull: true, }) ],
                [ '_Modified_DateTime', fields.Long({ notNull: false, }) ],
                // [ '_Modified_DeviceId', fields.Long({}) ],
            ].concat(columns);
        }

        super(id, name, alias, columns);

        this.setPKs([ '_Id' ]);

        // this.addIndex('_Modified_DateTime', '_Modified_DateTime DESC');
    }

}
module.exports = RTable;





 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\ab-data\RequestProcessor.js
jsLibs.exportModule('ab-data', 'RequestProcessor', (require, module, exports) => { 'use strict';

const
    js0 = require('js0')
;

class RequestProcessor
{

    get device() {
        return this._device;
    }

    get scheme() {
        return this._scheme;
    }


    constructor(dataScheme, device) {
        js0.args(arguments, require('./scheme/DataScheme'), require('./Device'));

        this._scheme = dataScheme;
        this._device = device;

        this._processingQueue = [];
        this._nextProcessingId = 0;
    }

    async processRequest_Async(requestName, actionName, actionArgs, 
            transactionId = null) {
        js0.args(arguments, 'string', 'string', js0.RawObject, [ 'int', 
                js0.Null, js0.Default ]);

        let response = await this.processRequestBatch_Async([
            [ 'request', requestName, actionName, actionArgs, this.scheme.version ],
        ]);

        if (response === null)
            return null;

        return response;
    }

    async processRequestBatch_Async(requests, transactionId = null) { 
        js0.args(arguments, Array, [ 'int', js0.Null, js0.Default ]);

        let processingId = this._nextProcessingId;
        this._nextProcessingId++;

        this._processingQueue.push({
            processingId: processingId,
            requests: requests,
            transactionId: transactionId,
        });

        let response = await this._processRequestBatchHelper_Async(processingId, 
                requests, transactionId)

        // let response = await this.__processRequestBatch_Async(requests, 
        //         transactionId);

        js0.typeE(response, require('./Response'));

        return response;
    }


   _processRequestBatchHelper_Async(processingId, requests, transactionId) {
        return new Promise((resolve, reject) => {
            if (this._processingQueue[0].processingId === processingId) {
                this.__processRequestBatch_Async(requests, transactionId)
                        .then((response) => {
                    this._processingQueue.splice(0, 1);
                    resolve(response);
                });
                return;
            }

            setTimeout(() => {
                resolve(this._processRequestBatchHelper_Async(processingId,
                        requests, transactionId));
            }, 50);
        });
    }


    async __processRequestBatch_Async(requests, transactioId) { js0.virtual(this); }

}
module.exports = RequestProcessor;





 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\ab-data\Response.js
jsLibs.exportModule('ab-data', 'Response', (require, module, exports) => { 'use strict';

const
    js0 = require('js0')
;

class Response
{

    static get ResultTypes_Success() {
        return 0;
    }

    static get ResultTypes_Failure() {
        return 1;
    }

    static get ResultTypes_Error() {
        return 2;
    }

    static get Types_Success() {
        return 0;
    }

    static get Types_ResultFailure() {
        return 1;
    }

    static get Types_ResultError() {
        return 2;
    }

    static get Types_ActionError() {
        return 3;
    }

    static get Types_Error() {
        return 4;
    }


    constructor() {
        this.actionErrors = {};
        this.type = Response.Types_Success;
        this.errorMessage = null;
        this.info = {};
        this.results = {};
        this.requestIds = [];
    }

    parseRawObject(response) {
        js0.args(arguments, js0.RawObject);

        this.actionErrors = response.actionErrors;
        this.type = response.type;
        this.errorMessage = response.errorMessage;
        this.info = response.info;
        this.results = response.results;
        this.requestIds = response.requestIds;
    }

}
module.exports = Response;

module.exports = Response;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\ab-data\RequestProcessor_Web.js
jsLibs.exportModule('ab-data', 'RequestProcessor_Web', (require, module, exports) => { 'use strict';

const
    js0 = require('js0'),
    webABApi = require('web-ab-api'),

    Response = require('./Response'),
    RequestProcessor = require('./RequestProcessor'),

    abData = require('.')
;

class RequestProcessor_Web extends RequestProcessor
{

    constructor(dataScheme, device, apiUri) {
        super(dataScheme, device);
        js0.args(arguments, require('./scheme/DataScheme'), require('./Device'),
                'string');

        this._apiUri = apiUri;
    }

    async __processRequestBatch_Async(requests, transactionId) {
        js0.args(arguments, Array, [ js0.Null, js0.Default ]);

        let response = new Response();

        let result = await webABApi.json_Async(this._apiUri + 'request', { 
            deviceInfo: {
                deviceId: this.device.id,
                deviceHash: this.device.hash,
                declaredItemIds: this.device.declaredItemIds,
            },
            requests: requests,
            args: {},
        });

        response.info = {
            webResult: result,
        };

        if (!result.isSuccess()) {
            if (abData.debug) {
                console.error('Request error: ' + result.message);
                console.warn(result.data.data);
            }

            response.type = Response.Types_Error;
            response.error = result.message;

            return response;
        }

        response.parseRawObject(result.data.response);

        for (let request of requests) {
            if (!(request[0] in response.results))
                continue;
            let result = response.results[request[0]];
            if (result === null)
                continue;
            if (result._type > 0)
                continue;

            this._scheme.validateResult(request, result);
        }

        return response;
    }

}
module.exports = RequestProcessor_Web;





 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\ab-data\Validator.js
jsLibs.exportModule('ab-data', 'Validator', (require, module, exports) => { 'use strict';

const
    js0 = require('js0')
;

class Validator
{

    constructor() {
        this._info =  {
            'valid': true,
            'fields': {},
            'state': '',
            'errors': [],
        };
    }

    addField(fieldName, fieldValue) {
        js0.args(arguments, 'string', null);

        this._fields_Add(fieldName, fieldValue);
    }

    addFieldValidator(fieldName, fieldValidator) {
        js0.args(arguments, 'string', require('./validators/ABDFieldValidator'));

        if (!this.hasField(fieldName))
            throw new Error(`Field '${fieldName}' does not exist.`);

        fieldValidator.validate(this, fieldName, this._info.fields[fieldName].value);
    }

    getFieldInfo(fieldName) {
        js0.args(arguments, 'string');

        if (!fieldName in this._info['fields'])
            throw new Error(`Field '${fieldName}' does not exist.`);

        return this._info['fields'][fieldName];
    }

    getInfo() {
        return this._info;
    }

    error(message) {
        js0.args(arguments, 'string');

        this._info['valid'] = false;
        this._info['errors'].push(message);
    }

    fieldError(fieldName, message) {
        js0.args(arguments, 'string', 'string');

        let field = this._fields_Get(fieldName);

        this._info['valid'] = false;
        this._info['state'] = 'error';

        field['valid'] = false;
        field['errors'].push(message);
    }

    hasField(fieldName) {
        js0.args(arguments, 'string');

        return fieldName in this._info['fields'];
    }

    isFieldValid(fieldName) {
        js0.args(arguments, 'string');

        return this.getFieldInfo(fieldName).valid;
    }

    isValid() {
        return this._info['valid'];
    }


    _fields_Add(fieldName, fieldValue) {
        js0.args(arguments, 'string', null);

        this._info['fields'][fieldName] = {
            'valid': true,
            'value': fieldValue,
            'state': '',
            'errors': [],
            'warnings': [],
            'successes': [],
        };

        return this._info['fields'][fieldName];
    }

    _fields_Get(fieldName) {
        if (!this.hasField(fieldName))
            throw new Error(`Field '${fieldName}' does not exist.`);

        return this._info.fields[fieldName];
    }

    // _fields_Exists(fieldName)
    // {
    //     return fieldName in this._info['fields'];
    // }

}
module.exports = Validator;





 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\ab-data\SelectColumnType.js
jsLibs.exportModule('ab-data', 'SelectColumnType', (require, module, exports) => { 'use strict';

class SelectColumnType {

    static get Bool() { return 0; }
    static get Float() { return 1; }
    static get Int() { return 2; }
    static get Long() { return 3; }
    static get JSON() { return 4; }
    static get String() { return 5; }

}
module.exports = SelectColumnType;





 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\ab-data\TableInfo.js
jsLibs.exportModule('ab-data', 'TableInfo', (require, module, exports) => { 'use strict';

const
    js0 = require('js0')
;

class TableInfo
{

    get autoIncrement() {
        return this._autoIncrement;
    }

    get fieldInfos() {
        return this._fieldInfos;
    }

    get name() {
        return this._name;
    }

    get pks() {
        return this._primaryKeys;
    }


    constructor(name) {
        js0.args(arguments, 'string');

        this._name = name;
        this._fieldInfos = [];
        this._autoIncrement = null;
        this._primaryKeys = null;
        this._charset = 'utf8';
        this._collation = 'utf8_general_ci';
    }

    addFieldInfo(fieldInfo) {
        js0.args(arguments, require('./FieldInfo'));

        this._fieldInfos.push(fieldInfo);
    }

    addIndex(indexName, columns) {
        throw new Error('Not implemented.');
    }

    getFieldInfo_ByName(fieldName) {
        for (let fieldInfo of this.fieldInfos) {
            if (fieldInfo.name === fieldName)
                return fieldInfo;
        }

        return null;
    }

    getQuery_Create() {
        let query = `CREATE TABLE ${this.name} (`;
        let fields = [];

        for (let fieldInfo of this.fieldInfos) {
            fields.push(`${fieldInfo.name} ${fieldInfo.types[0]} ` + 
                    (fieldInfo.notNull ? 'NOT NULL' : 'NULL'));
        }

        query += fields.join(', ');

        if (this._primaryKeys !== null)
            query += `, PRIMARY KEY (` + this._primaryKeys.join(',') + `)`;
        
        query += `)`;

        return query;
    }

    setAutoIncrement(columnName) {
        js0.args(arguments, [ 'string', js0.Null ]);

        this._autoIncrement = columnName;
        this._primaryKeys = null;

        return this;
    }

    setPKs(pks) {
        js0.args(arguments, [ Array, js0.Null ]);

        this._autoIncrement = null;
        this._primaryKeys = pks;

        return this;
    }

}
module.exports = TableInfo;





 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\ab-data\helper.js
jsLibs.exportModule('ab-data', 'helper', (require, module, exports) => { 'use strict';

const
    js0 = require('js0')
;

module.exports.escapeString = function(str) {
    return str.replace(/\'/g, '\'\'');
};

module.exports.unescapeString = function(str) {
    return str;
};

module.exports.quote = function(str) {
    return str
        .replace(/\\/g, "\\\\")
        .replace(/\'/g, "\\\'")
        .replace(/\"/g, "\\\"")
        .replace(/\n/g, "\\\n")
        .replace(/\r/g, "\\\r")
        .replace(/\x00/g, "\\\x00")
        .replace(/\x1a/g, "\\\x1a");
};





 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\ab-data\RequestProcessor_Native.js
jsLibs.exportModule('ab-data', 'RequestProcessor_Native', (require, module, exports) => { 'use strict';

const
    abLock = require('ab-lock'),
    js0 = require('js0'),
    webABApi = require('web-ab-api'),

    abData = require('.'),
    NativeDataStore = require('./native/NativeDataStore'),
    Response = require('./Response'),
    RequestProcessor = require('./RequestProcessor')
;

class RequestProcessor_Native extends RequestProcessor
{

    get db() {
        return this._db;
    }


    constructor(dataScheme, device, db) {
        js0.args(arguments, require('./scheme/DataScheme'), 
                require('./native/NativeDevice'), require('./native/Database'));

        super(dataScheme, device);

        this._scheme = dataScheme;
        this._device = device;
        this._db = db;

        this._requests = {};
    }

    getRequest(requestName) {
        js0.args(arguments, 'string');

        if (!this.hasRequest(requestName))
            throw new Error(`Request '${requestName}' does not exist.`);

        return this._requests[requestName];
    }

    hasRequest(requestName) {
        js0.args(arguments, 'string');

        return requestName in this._requests;
    }

    async __processRequestBatch_Async(requests, transactionId = null) {
        js0.args(arguments, Array, [ 'int', js0.Null, js0.Default ]);

        let response = new Response();

        let success = true;
        let localTransaction = false;

        try {
            if (transactionId === null) {
                transactionId = await this._db.transaction_Start_Async();
                localTransaction = true;
            }

            let requests_W = [];
            for (let request of requests) {
                let requestId = request[0];
                let requestName = request[1];
                let actionName = request[2];
                let actionArgs = request[3];

                response.results[requestId] = null;
                response.requestIds.push(requestId);
                response.actionErrors[requestId] = null;

                let result = null;
                try {
                    result = await this.getRequest(requestName)
                            .executeAction_Async(this._device, actionName, 
                            actionArgs, transactionId);

                    this._scheme.validateResult(request, result);
                } catch (e) {
                    if (abData.debug)
                        console.error(e);

                    success = false;

                    response.type = abData.Response.Types_ActionError;
                    if (abData.debug) {
                        response.errorMessage = `Action Error: ` +
                                `'${requestName}:${actionName}' -> ${e.message}`;
                    } else
                        response.errorMessage = e.message;
                    response.actionErrors[requestId] = e.message;

                    break;
                }

                if (!('_type' in result)) {
                    success = false;

                    response.type = Response.Types_ActionError;
                    response.errorMessage = `No '_type' in action result: ` +
                            `'${requestName}:${actionName}'`;
                    response.actionErrors[requestId] = 
                            `No '_type' in action result.`;

                    break;
                }

                response.results[requestId] = result;

                if (result._type >= 2) {
                    success = false;

                    response.type = Response.Types_ResultError;
                    response.errorMessage = `Result Error: ` +
                            `'${requestName}:${actionName}'.`;

                    break;
                }

                if (result._type === 1) {
                    success = false;

                    response.type = Response.Types_ResultFailure;
                    response.errorMessage = `Result Failure: ` +
                            `'${requestName}:${actionName}'.`;

                    break;
                }

                if (this._scheme.getRequestDef(requestName)
                        .getActionDef(actionName).type === 'w') {
                    requests_W.push([ requestName, actionName, actionArgs ]);
                }
            }

            if (success && requests_W.length > 0)
                success = await this._db.addDBRequests_Async(requests_W);

            if (success)
                await this._updateDeviceInfo_Async(transactionId);
        } catch (e) {
            if (abData.debug)
                console.error(e);

            response.type = Response.Types_Error;
            response.errorMessage = e.message;
        }

        try {
            if (localTransaction)
                await this._db.transaction_Finish_Async(success, transactionId);
        } catch (e) {
            if (success) {
                response.success = false;

                response.type = Response.Types_Error;
                response.errorMessage = 'Cannot commit request processor transaction: ' +
                        e.message;

                return response;
            }
        }

        response.success = success;

        return response;
    }

    setR(requestName, request) {
        return this.setRequest(requestName, request);
    }

    setRequest(requestName, request) {
        js0.args(arguments, 'string', require('./native/Request'));

        if (requestName in this._requests)
            throw new Error(`Request '${requestName}' already exists.`);

        this._requests[requestName] = request;

        return this;
    }

    async _updateDeviceInfo_Async(transactionId = null) {
        js0.args(arguments, [ 'int', js0.Null, js0.Default ]);

        let localTransaction = false;
        if (transactionId === null) {
            transactionId = await this._db.transaction_Start_Async();
            localTransaction = true;
        }

        let lastDeclaredItemId = this.device.lastItemId;
        // for (let itemId_Declared of this.device.declaredItemIds) {
        //     if (itemId_Declared > lastDeclaredItemId)
        //         lastDeclaredItemId = itemId_Declared;
        // }

        let deviceInfo = await NativeDataStore.GetDeviceInfo_Async(this._db, 
                transactionId);
        let declaredItemIds = deviceInfo.declaredItemIds;
        for (let itemId of this.device.declaredItemIds) {
            if (!declaredItemIds.includes(itemId))
                declaredItemIds.push(itemId);
        }

        await NativeDataStore.SetDeviceInfo_Async(this._db, 
                this.device.id, this.device.hash, lastDeclaredItemId, 
                this.device.lastUpdate, declaredItemIds, transactionId);

        if (localTransaction)
            await this._db.transaction_Finish_Async(true, transactionId);
    }

}
module.exports = RequestProcessor_Native;





 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\ab-data\Table.js
jsLibs.exportModule('ab-data', 'Table', (require, module, exports) => { 'use strict';

const
    js0 = require('js0'),
    
    fields = require('./fields'),
    helper = require('./helper'),

    TableRequestDef = require('./scheme/TableRequestDef')
;

let insertsTime = 0;
let insertsCount = 0;

class Table
{

    static get MaxUpdateRows() {
        return 100;
    }

    static get MaxInsertRows() {
        return 10000;
    }

    get alias() {
        return this._alias;
    }

    get columns() {
        return this._columns;
    }

    get name() {
        return this._name;
    }

    get pks() {
        return this._primaryKeys;
    }

    get properties() {
        return this._properties;
    }

    constructor(id, name, alias, columns) {   
        js0.args(arguments, 'int', 'string', 'string', Array);

        this._id = id;
        this._name = name;
        this._alias = alias;
        this._primaryKeys = null;
        this._autoIncrement = null;
        this._columns = null;
        this._rowParser = null;
        this._columnValidators = {};

        this._columns = new js0.List();
        for (let column of columns) {
            let name = column[0];
            let field = column[1];
            let fieldValidatorInfo = column.length > 2 ? column[2] : {};

            this._columns.set(name, {
                field: field,
                fieldValidator: field.getFieldValidator(fieldValidatorInfo),
                index: this._columns.size,
                select: name,
            });
        }
    }

    addColumnValidator(columnName, fieldValidator) {
        js0.args(arguments, 'string', require('./validators/ABDFieldValidator'));

        if (!this.hasColumn(columnName))
            throw new Error(`Column '${columnName}' does not exist.`);

        if (!(columnName in this._columnValidators))
            this._columnValidators[columnName] = [];

        this._columnValidators[columnName].push(fieldValidator);

        return this;
    }

    async delete_Async(db, args = {}, transactionId = null) {
        js0.args(arguments, require('./native/Database'), [ js0.RawObject,
                js0.Default ], [ 'int', js0.Null, js0.Default ]);
        js0.typeE(args, js0.Preset(TableRequestDef.Args_Select()));

        let tableName_DB = helper.quote(this.name);
        let query = `DELETE FROM ${tableName_DB}`;

        if (args.where !== null) {
            let where_Str = this.getQuery_Conditions(args.where);
            if (where_Str !== '')
                query += ' WHERE ' + where_Str;
        }

        await db.query_Execute_Async(query, transactionId);
    }

    getColumn(columnName) {
        if (!this._columns.has(columnName))
            throw new Error(`Column '${columnName}' does not exist.`);

        return this._columns.get(columnName);
    }

    getColumn_Field(columnName) {
        return this.getColumn(columnName).field;
    }

    getColumnIndex(columnName) {
        js0.args(arguments, 'string');

        return this.getColumn(columnName).index;
    }

    getColumnNames() {
        return this._columns.keys();
        // let columnNames = [];
        // for (let column of this._columns)
        //     columnNames.push(column.name);

        // return columnNames;
    }

    getSelectColumnInfo(columnName) {
        js0.args(arguments, 'string');

        let column = this.getColumn(columnName);

        return [ column.select, column.field ];
    }

    getTableId() {
        return this._id;
    }

    getTableName() {
        return this._name;
    }

    getValidatorInfos() {
        let validatorInfo = {};
        for (let [ columnName, column ] of this._columns) {
            validatorInfo[columnName] = {
                field: {
                    type: column.fieldValidator.getType(),
                    args: column.fieldValidator.args,
                },
                validators: [],
            };

            if (columnName in this._columnValidators) {
                for (let columnValidator of this._columnValidators[columnName]) {
                    validatorInfo[columnName].validators.push({
                        type: columnValidator.getType(),
                        args: columnValidator.args,
                    });
                }
            }
        }

        return validatorInfo;
    }

    getQuery_Conditions(columnValues, selectColumns = null) {
        js0.args(arguments, Array, [ js0.Iterable(js0.PresetArray([ 'string', 
                js0.PresetArray([ 'string', fields.ABDField ]) ])), js0.Null, 
                js0.Default ]);

        if (selectColumns === null) {
            selectColumns = new js0.List();
            for (let [ columnName, column ] of this.columns) {
                selectColumns.set(columnName, 
                        [ column.select, column.field ]);
            }
        }

        return this._getQuery_Conditions_Helper(columnValues, 'AND',
                selectColumns);
    }
    
    hasColumn(columnName) {
        return this._columns.has(columnName);
    }

    async insert_Async(db, rows, transactionId = null, 
            ignoreNotExistingColumns = false, orReplace = false) {
        js0.args(arguments, require('./native/Database'), js0.ArrayItems(
                js0.RawObject), [ 'int', js0.Null, js0.Default ], [ 'boolean', 
                js0.Default ], [ 'boolean', js0.Default ]);

        return await this._insert_Base_Async(db, rows, null, null, 
            transactionId, ignoreNotExistingColumns, orReplace)
    }

    async insert_NoAssoc_Async(db, rows, columnNames, transactionId = null, 
            ignoreNotExistingColumns = false, orReplace = false) {
        js0.args(arguments, require('./native/Database'), js0.ArrayItems(
                Array), js0.ArrayItems('string'), [ 'int', js0.Null, js0.Default ], [ 'boolean', 
                js0.Default ], [ 'boolean', js0.Default ]);

        return await this._insert_Base_Async(db, null, rows, columnNames, 
                transactionId, ignoreNotExistingColumns, orReplace);
    }

    async row_Async(db, args = {}, transactionId = null) {
        js0.args(arguments, require('./native/Database'), [ js0.RawObject,
                js0.Default ], [ 'int', js0.Null, js0.Default ]);
        js0.typeE(args, js0.Preset(TableRequestDef.Args_Select()));

        args.limit = [ 0, 1 ];

        let rows_DB = await this.select_Async(db, args, transactionId);

        if (rows_DB.length === 0)
            return null;

        return rows_DB[0];
    }

    async select_Async(db, args = {}, transactionId = null) {
        js0.args(arguments, require('./native/Database'), [ js0.RawObject, 
                js0.Default ], [ 'int', js0.Null, js0.Default ]);

        js0.typeE(args, js0.Preset(TableRequestDef.Args_Select()));

        if (args.selectColumns === null) {
            args.selectColumns = new js0.List();
            for (let [ columnName, column ] of this.columns) {
                if (args.selectColumnNames !== null) {
                    if (!args.selectColumnNames.includes(columnName))
                        continue;
                }
                args.selectColumns.set(columnName, 
                        [ column.select, column.field ]);
            }
        }
        let selectColumns_Select_Arr = [];
        let selectColumns_Types = [];
        for (let [ columnName, selectColumnInfo ] of args.selectColumns) {
            selectColumns_Select_Arr.push(
                    `${selectColumnInfo[0]} AS ${columnName}`);
            selectColumns_Types.push(selectColumnInfo[1].getSelectType());
        }

        let tableName_DB = helper.quote(this.name);
        let query = `SELECT ` + selectColumns_Select_Arr.join(',') + 
                ` FROM ${tableName_DB}`;

        if (args.where !== null) {
            let where_Str = this.getQuery_Conditions(args.where);
            if (where_Str !== '')
                query += ' WHERE ' + where_Str;
        }

        if (args.groupBy !== null)
            query += ` GROUP BY ` + args.groupBy.join(',');

        let query_OrderBy = '';
        if (args.query_OrderBy !== null)
            query_OrderBy = ` ORDER BY ${args.query_OrderBy}`;
        if (args.orderBy.length > 0) {
            let orderBy_Arr = [];
            for (let orderBy of args.orderBy) {
                let column_Field = this.getColumn_Field(orderBy[0]);
                let columnName = helper.quote(orderBy[0]);
                orderBy_Arr.push(columnName + (orderBy[1] ? ' DESC' : ''));
            }

            if (query_OrderBy === '')
                query_OrderBy += ' ORDER BY ';
            else
                query_OrderBy += ',';
            query_OrderBy += orderBy_Arr.join(',');
        }
        query += query_OrderBy;

        if (args.limit !== null)
            query += ` LIMIT ${args.limit[0]}, ${args.limit[1]}`;

        let rows_DB = await db.query_Select_Async(query, selectColumns_Types, 
                transactionId);

        let rows = [];
        for (let result_Row of rows_DB) {
            let row = null;
            if (args.assoc) {
                row = {};
                for (let i = 0; i < args.selectColumns.size; i++) {
                    row[args.selectColumns.getKeyAt(i)] = 
                            args.selectColumns.getAt(i)[1].unescape(result_Row[i]);
                }
            } else {
                row = [];
                for (let i = 0; i < args.selectColumns.size; i++) {
                    row.push(args.selectColumns.getAt(i)[1].unescape(
                            result_Row[i]));
                }
            }

            rows.push(row);
        }

        if (args.join.length > 0) {
            rows = await this._join_Async(db, rows, args.join, args.assoc, 
                transactionId);
        }

        return rows;
    }

    async select_ByPKs_Async(db, keySets, args = {}, transactionId = null) {
        js0.args(arguments, require('./native/Database'), 
                js0.ArrayItems(Array), [ js0.RawObject, js0.Default ],
                [ 'int', js0.Null, js0.Default ]);

        js0.typeE(args, js0.Preset(TableRequestDef.Args_Select()));

        args.where = [ 'OR', [] ];
        for (let keys of keySets) {
            if (keys.length !== this.pks.length) {
                throw new Error('Keys do not match primary keys: ' + 
                        keys.join(', ') + ` != ` + this.pks.join(', '));
            }

            let keyPair_Where = [ 'AND', [] ];
            for (let i = 0; i < keys.length; i++)
                keyPair_Where[1].push([ this.pks[i], '=', keys[i] ]);
                
            args.where[1].push(keyPair_Where);
        }

        return await this.select_Async(db, args, transactionId);
    }

    setAutoIncrement(columnName) {
        js0.args(arguments, 'string');

        if (!this.hasColumn(columnName))
            throw new Error(`Auto increment column '${columnName}' does not exist.`);
        if (!(this.getColumn(columnName).field instanceof fields.ABDAutoIncrementId)) {
            throw new Error(`Auto increment column '${columnName}'` +
                    ` must be of type ABDAutoIncrementId.`);
        }

        this._autoIncrement = columnName;
        this._primaryKeys = null;

        return this;
    }

    setPKs(primaryKeys) {
        js0.args(arguments, js0.ArrayItems('string'));

        for (let columnName of primaryKeys) {
            if (!this.hasColumn(columnName))
                throw new Error(`Primary key column '${columnName}' does not exist.`);
        }

        this._autoIncrement = null;
        this._primaryKeys = primaryKeys;

        return this;
    }

    setRowParser(parserFn) {
        js0.args(arguments, 'function');

        this._rowParser = parserFn;
    }

    // async update_Async(db, rows, transactionId = null, 
    //     ignoreNotExistingColumns = false) {
    //     js0.args(arguments, require('./native/Database'), js0.ArrayItems(
    //             js0.RawObject), [ 'int', js0.Null, js0.Default ], [ 'boolean', 
    //             js0.Default ]);

    //     return await this._insert_Base_Async(db, rows, null, null, 
    //             transactionId, ignoreNotExistingColumns, true);
    // }

    // async update_NoAssoc_Async(db, rows, columnNames, transactionId = null, 
    //         ignoreNotExistingColumns = false) {
    //     js0.args(arguments, require('./native/Database'), js0.ArrayItems(
    //             Array), js0.ArrayItems('string'), [ 'int', js0.Null, 
    //             js0.Default ], [ 'boolean', js0.Default ]);

    //     return await this._insert_Base_Async(db, null, rows, columnNames, 
    //             transactionId, ignoreNotExistingColumns, true);
    // }

    async update_Async(db, rows, transactionId = null, 
            ignoreNotExistingColumns = false) {
        js0.args(arguments, require('./native/Database'), js0.ArrayItems(
                js0.RawObject), [ 'int', js0.Null, js0.Default ], [ 'boolean', 
                js0.Default ]);

        if (rows.length === 0)
            return;

        let pks = this.pks;
        let pks_Included = true;
        if (this._autoIncrement)
            pks_Included = false;
        else {
            for (let pk of pks) {
                if (!(pk in rows[0]))
                    throw new Error(`Primary Key '${pk}' doesn not exist in row.`);
            }
        }

        let columns = {};
        for (let columnName in rows[0]) {
            if (!ignoreNotExistingColumns) {
                columns[columnName] = this.getColumn(columnName, true);
            } else {
                if (this.hasColumn(columnName, true))
                    columns[columnName] = this.getColumn(columnName, true);
            }
        }

        let localTransaction = false;
        if (transactionId === null) {
            transactionId = await db.transaction_Start_Async();
            localTransaction = true;
        }

        let rows_All = rows;
        for (let i = 0; i < rows_All.length; i += Table.MaxUpdateRows) {
            let rows = rows_All.slice(i, Math.min(i + Table.MaxUpdateRows, 
                    rows_All.length));

            let rows_WithNullPKs = [];
            let rows_WithNullPKs_Indexes = [];
            let rows_WithPKs = [];
            let rows_WithPKs_Indexes = [];

            for (let i = 0; i < rows.length; i++) {
                let row = rows[i];

                if (Object.keys(columns).length !== Object.keys(row).length) {
                    console.error(rows);
                    throw new Error(`Wrong columns number in row ${i}` +
                            ` (inconsistency with first row).`);
                }

                for (let columnName in columns) {
                    if (!(columnName in row)) {
                        throw new Error(`Inconsistent/unknown column` +
                                ` '${columnName}' in row ${i}.`);
                    }
                }

                let isNew = true;
                for (let pk in pks) {
                    if (row[pk] !== null) {
                        isNew = false;
                        break;
                    }
                }

                if (isNew) {
                    rows_WithNullPKs.push(row);
                    rows_WithNullPKs_Indexes.push(i);
                } else {
                    rows_WithPKs.push(row);
                    rows_WithPKs_Indexes.push(i);
                }
            }

            let rows_PKs_ToCheck = [];
            for (let row of rows_WithPKs) {
                let row_PKs = [];
                for (let pk of pks)
                    row_PKs.push(row[pk]);
                rows_PKs_ToCheck.push(row_PKs);
            }

            let rows_Insert = [];
            let rows_Insert_Indexes = [];
            let rows_Update = [];
            let rows_Update_Indexes = [];

            let rows_Existing = pks_Included ? await this.select_ByPKs_Async(db,
                    rows_PKs_ToCheck, {
                selectColumnNames: this.pks,
            }, transactionId) : [];

            for (let i = 0; i < rows_WithPKs.length; i++) {
                let row_WithPKs = rows_WithPKs[i];
                let match = false;
                for (let row_Existing of rows_Existing) {
                    match = true;
                    for (let pk of pks) {
                        if (columns[pk].field.parse(row_WithPKs[pk]) !== 
                                row_Existing[pk]) {
                            match = false;
                            break;
                        }
                    }

                    if (match)
                        break;
                }

                if (match) {
                    rows_Update.push(row_WithPKs);
                    rows_Update_Indexes.push(rows_WithPKs_Indexes[i]);
                } else {
                    rows_Insert.push(row_WithPKs);
                    rows_Insert_Indexes.push(rows_WithPKs_Indexes[i]);
                }
            }

            for (let i = 0; i < rows_WithNullPKs.length; i++) {
                let row_WithNullPKs = rows_WithNullPKs[i];
                rows_Insert.push(row_WithNullPKs);
                rows_Insert_Indexes.push(rows_WithNullPKs[i]);
            }

            /* DB */
            let tableName_DB = helper.quote(this.name);

            /* Update */
            if (rows_Update.length > 0 && (Object.keys(rows[0]).length > pks.length)) {
                let update_ColumnQueries_Arr = [];
                for (let columnName in columns) {
                    if (pks.includes(columnName))
                        continue;

                    let columnName_DB = helper.quote(columnName);
                    let update_ColumnQuery = `${columnName_DB}=(CASE`;
                    for (let i = 0; i < rows_Update.length; i++) {
                        let row = rows_Update[i];
                        update_ColumnQuery += " WHEN ";
                        let pks_Match_Arr = [];
                        try {
                            for (let pk of pks) {
                                pks_Match_Arr.push(helper.quote(pk) + '=' + 
                                        columns[pk].field.escape(row[pk]));
                            }
                            update_ColumnQuery += '(' + pks_Match_Arr.join(' AND ') + ')';
                            update_ColumnQuery += ' THEN ' +  
                                    columns[columnName].field.escape(row[columnName]);
                        } catch (e) {
                            console.error(e);
                            throw new Error('Error thrown parsing column' +
                                 ` '${columnName}' in row '${rows_Update_Indexes[i]}' -> ` + 
                                 e.toString());
                        }
                    }
                    update_ColumnQuery += ' END)';
                    update_ColumnQueries_Arr.push(update_ColumnQuery);
                }

                let update_Where_Arr = [];
                for (let i = 0; i < rows_Update.length; i++) {
                    let row = rows_Update[i];
                    let pks_Match_Arr = [];
                    for (let pk of pks) {
                        try {
                            pks_Match_Arr.push(helper.quote(pk) + '=' + 
                                    columns[pk].field.escape(row[pk]));
                        } catch (e) {
                            console.error(e);
                            throw new Error('Error thrown parsing column' +
                                ` '${pk}' in row '${rows_Update_Indexes[i]}' -> ` + 
                                e.toString());
                        }
                    }
                    update_Where_Arr.push('(' + pks_Match_Arr.join(' AND ') + ')');
                }

                let update_Query = `UPDATE ${tableName_DB} SET ` +  
                        update_ColumnQueries_Arr.join(',') + ` WHERE ` + 
                        update_Where_Arr.join(' OR ');

                await db.query_Execute_Async(update_Query, transactionId);
            }

            /* Insert */
            if (rows_Insert.length > 0) {
                let valuesArr_DB = [];
                for (let i = 0; i < rows_Insert.length; i++) {
                    let row = rows_Insert[i];
                    let row_DB = [];
                    for (let columnName in columns) {
                        let column = columns[columnName];
                        try {
                            row_DB.push(column.field.escape(row[columnName]));
                        } catch (e) {
                            console.error(e);
                            throw new Error('Error thrown parsing column' +
                                ` '${columnName}' in row '${rows_Insert_Indexes[i]}' -> ` + 
                                e.toString());
                        }
                        
                    }

                    valuesArr_DB.push('(' + row_DB.join(',') + ')');
                }

                /* Column Names */
                let columnNames_DB = [];
                for (let columnName in columns)
                    columnNames_DB.push(helper.quote(columnName));
                let columnNames_DB_Str = columnNames_DB.join(',');

                /* Values */
                let values_DB = valuesArr_DB.join(',');

                let insert_Query = `INSERT INTO ${tableName_DB} (${columnNames_DB_Str})` +
                        ` VALUES ${values_DB}`;

                await db.query_Execute_Async(insert_Query, transactionId);
            }
        }

        /* Commit */
        if (localTransaction)
            await db.transaction_Finish_Async(true, transactionId);
    }

    updateWhere() {
        throw new Error('Not implemented yet.');
    }

    // async updateRequests_Async(db, action, rows)
    // {
    //     js0.args(arguments, null, Array);

    //     let query = `INSERT INTO ${tableName_DB} (${columnNames_DB_Str})` +
    //             ` VALUES ${values_DB_Str}`
    // }

    validateColumn(validator, validatorFieldName, columnName, value) {
        js0.args(arguments, require('./Validator'), 'string', 'string', null);

        validator.addField(validatorFieldName, value);

        let column = this.getColumn(columnName);
        // let column_ValidatorField = column.field.getFieldValidator(
        //         column.fieldValidatorInfo);

        validator.addFieldValidator(validatorFieldName, column.fieldValidator);
        if (columnName in this._columnValidators) {
            for (let fieldValidator of this._columnValidators[columnName])
                validator.addFieldValidator(validatorFieldName, fieldValidator);
        }
    }

    validateRow(validator, row, columns = null) {
        js0.args(arguments, require('./Validator'), js0.RawObject,
                [ js0.Null, js0.RawObject, js0.Default() ]);

        if (columns === null) {
            columns = {};
            for (let [ columnName, column ] of this.columns)
                columns[columnName] = columnName;
        }

        for (let columnName in columns) {
            if (!(columnName in row))
                throw new Error(`Column '${columnName}' not set in row.`);
            if (typeof row[columnName] === 'undefined')
                throw new Error(`Column '${columnName}' is 'undefined' in row.`);

            this.validateColumn(validator, columns[columnName], columnName,
                    row[columnName]);
        }
    }

    validateRow_Default(validator, row, ignoreColumns = []) {
        js0.args(arguments, require('./Validator'), js0.RawObject,
                [ Array, js0.Default() ]);

        let columns = {};
        for (let [ columnName, column ] of this.columns) {
            if (columnName === '_Modified_DateTime')
                continue;

            if (!ignoreColumns.includes(columnName))
                columns[columnName] = columnName;
        }

        this.validateRow(validator, row, columns);
    }

    validateRow_Default_Columns(validator, row, columnNames = []) {
        js0.args(arguments, require('./Validator'), js0.RawObject,
                [ Array, js0.Default() ]);

        let columns = {};
        for (let columnName of columnNames) {
            if (!this.hasColumn(columnName))
                throw new Error(`Column '${columnName}' does not exist.`);

            columns[columnName] = columnName;
        }

        this.validateRow(validator, row, columns);
    }


    _getQuery_Conditions_Helper(columnValues, logicOperator, selectColumns) {
        js0.args(arguments, Array, [ 'string', js0.Null ], [ js0.Iterable(
            js0.PresetArray([ 'string', js0.PresetArray([ 'string', 
            fields.ABDField ]) ])), js0.Null, js0.Default(null) ]);

        if (columnValues.length === 0)
            return '';

        let type = this._getQuery_Conditions_Helper_GetType(columnValues);

        if (type === 'conjuctionArray') {
            return this._getQuery_Conditions_Helper(columnValues[1],
                    columnValues[0], selectColumns);
        }

        if (type === 'conjuction') {
            if (logicOperator === null)
                logicOperator = 'AND';
                
            let args = [];
            for (let columnCondition of columnValues) {
                let columnCondition_Str = this._getQuery_Conditions_Helper(
                        columnCondition, null, selectColumns);
                if (columnCondition_Str !== '')
                    args.push('(' + columnCondition_Str + ')');
            }

            return args.join(` ${logicOperator} `)
        }

        if (type === 'condition') {
            let columnName = columnValues[0];
            let sign = columnValues[1];
            let value = columnValues[2];

            if (!selectColumns.has(columnName)) {
                throw new Error(`Column '${columnName}' does not exist in` +
                        ` 'selectColumns' for where condition.`);
            }

            let columnField = selectColumns.get(columnName)[1];

            // let columnName_DB = tableOnly ? Database.Quote(columnName) :
            //         this.getColumn(columnName).expression;
            let columnName_DB = helper.quote(columnName);

            let value_DB = null;
            if (sign === null) {
                value_DB = value;
                sign = '';
            } else {
                if (typeof value === 'undefined') {
                    throw new Error(`Value of '${columnName}' in query` +
                        ` conditions cannot be 'undefined'.`);
                } else if (value === null) {
                    if (sign === '=')
                        value_DB = 'IS NULL';
                    else if (sign === '<>')
                        value_DB = 'IS NOT NULL';
                    else
                        throw new Error(`Unknown '${sign}' and 'null' conjuction.`);

                    sign = '';
                } else {
                    try {
                        if (js0.type(value, Array))
                            value_DB = ' ' + columnField.escapeArray(value);
                        else
                            value_DB = ' ' + columnField.escape(value);
                    } catch (e) {
                        console.error('Cannot parse query condition:', 
                            columnValues);
                        throw Error('Cannot parse query condition -> ' + 
                                e.toString());
                    }
                }
            }

            return `${columnName_DB} ${sign}${value_DB}`;
        }

        throw new Error(`Unknown 'columnValues' type.`);
    }

    _getQuery_Conditions_Helper_GetType(columnValues) {
        if (columnValues.length === 2) {
            if (columnValues[0] === 'OR' || columnValues[0] === 'AND') {
                if (columnValues[1] instanceof Array)
                    return 'conjuctionArray';
            }
        }

        let isConjuction = true;
        for (let columnValue of columnValues) {
            if (!(columnValue instanceof Array))
                isConjuction = false;
        }
        if (isConjuction)
            return 'conjuction';

        if (columnValues.length === 3) 
            return 'condition';

        console.error('Condition column values:', columnValues);
        throw new Error('Wrong condition format.');
    }

    async _insert_Base_Async(db, assoc_Rows, noAssoc_Rows, noAssoc_ColumnNames, 
            transactionId = null, ignoreNotExistingColumns = false, orReplace) {
        js0.args(arguments, require('./native/Database'), [ js0.ArrayItems(
            js0.RawObject), js0.Null ], [ js0.ArrayItems(Array), js0.Null ], [ js0.ArrayItems('string'), js0.Null ], 
            [ 'int', js0.Null ], 'boolean', 'boolean');
        let maxRows = orReplace ? Table.MaxUpdateRows : Table.MaxInsertRows;

        let colRefs = null
        let columnNames = null;
        
        if (assoc_Rows !== null) {
            if (assoc_Rows.length === 0)
                return;

            columnNames = Object.keys(assoc_Rows[0]);
        } else {
            if (noAssoc_Rows.length === 0)
                return;

            colRefs = {};
            columnNames = noAssoc_ColumnNames;
            for (let i = 0; i < columnNames.length; i++)
                colRefs[columnNames[i]] = i;
        }

        let pks = this.pks;
        for (let pk of pks) {
            if (!(columnNames.includes(pk)))
                throw new Error(`Primary Key '${pk}' doesn not exist in row.`);
        }

        let columns = {};
        for (let columnName of columnNames) {
            if (!ignoreNotExistingColumns) {
                columns[columnName] = this.getColumn(columnName, true);
            } else {
                if (this.hasColumn(columnName, true))
                    columns[columnName] = this.getColumn(columnName, true);
            }
        }

        let localTransaction = false;
        if (transactionId === null) {
            transactionId = await db.transaction_Start_Async();
            localTransaction = true;
        }

        let tableName_DB = helper.quote(this.name);

        /* Insert */
        let rows_All = assoc_Rows === null ? noAssoc_Rows : assoc_Rows;
        for (let i = 0; i < rows_All.length; i += maxRows) {
            // let rows_Insert = rows_All.slice(i, Math.min(i + Table.MaxInsertRows, 
            //         rows_All.length));
            let lastInsert = Math.min(i + maxRows, rows_All.length);
            let valuesArr_DB = [];
            for (let j = i; j < lastInsert; j++) {
                let row = rows_All[j];

                if (assoc_Rows !== null) {
                    if (columnNames.length !== Object.keys(row).length) {
                        console.error(rows_All);
                        throw new Error(`Wrong columns number in row ${j}` +
                                ` (inconsistency with first row).`);
                    }

                    for (let columnName in columns) {
                        if (!(columnName in row)) {
                            throw new Error(`Inconsistent/unknown column` +
                                    ` '${columnName}' in row ${j}.`);
                        }
                    }
                }

                let row_DB = [];
                for (let columnName in columns) {
                    let column = columns[columnName];
                    try {
                        row_DB.push(column.field.escape(assoc_Rows === null ?
                                row[colRefs[columnName]] : row[columnName]));
                    } catch (e) {
                        console.error(e);
                        throw new Error('Error thrown parsing column' +
                            ` '${columnName}' in row '${j}' -> ` + 
                            e.toString());
                    }
                    
                }

                valuesArr_DB.push('(' + row_DB.join(',') + ')');
            }

            /* Column Names */
            let columnNames_DB = [];
            for (let columnName in columns)
                columnNames_DB.push(helper.quote(columnName));
            let columnNames_DB_Str = columnNames_DB.join(',');

            /* Values */
            let values_DB = valuesArr_DB.join(',');

            let insert_Query = 'INSERT' +
                    (orReplace ? ' OR REPLACE' : '') +
                    ` INTO ${tableName_DB} (${columnNames_DB_Str})` +
                    ` VALUES ${values_DB}`;

            let t1 = (new Date()).getTime();
            await db.query_Execute_Async(insert_Query, transactionId);
            insertsTime += (new Date()).getTime() - t1;
            insertsCount++;
            console.log('InsertsTime_Avg', (insertsTime / insertsCount) / 1000.0);
        }

        /* Commit */
        if (localTransaction)
            await db.transaction_Finish_Async(true, transactionId);
    }

    async _join_Async(db, rows, joinArgs, assoc, transactionId) {
        js0.args(arguments, require('../native/Database'), Array, 
                TableRequestDef.Args_Select().join, 'boolean', 
                [ 'int', js0.Null ]);

        let rows_Joined = [];
        for (let row of rows)
            rows_Joined.push(row);

        for (let joinIndex = 0; joinIndex < joinArgs.length; joinIndex++) {
            let join = joinArgs[joinIndex];
            let table = join.table;

            if (join.selectColumns === null) {
                join.selectColumns = new js0.List();
                for (let columnName of table.getColumnNames()) {
                    join.selectColumns.set(columnName, 
                            table.getSelectColumnInfo(columnName));
                }
            }

            for (let on of join.on) {
                if (!this.hasColumn(on[1])) {
                    /* Check joined tables for column. */
                    let columnExists = false;
                    for (let i = 0; i < joinIndex; i++) {
                        if (on[1].indexOf(joinArgs[i].prefix) !== 0)
                            continue;

                        if (joinArgs[i].table.hasColumn(on[1].substring(
                                    joinArgs[i].prefix.length))) {
                            columnExists = true;
                            break;
                        }                       
                    }

                    if (!columnExists) {
                        throw new Error(`Join column '${on[1]}' from base table ` +
                                `'${this.getTableName()}' does not exist.`);
                    }
                }

                let joinTableHasColumn = false;
                for (let selectColumn of join.selectColumns) {
                    if (selectColumn[0] === on[0]) {
                        joinTableHasColumn = true;
                        break;
                    }
                }

                if (!joinTableHasColumn) {
                    throw new Error(`Join column '${on[0]}' from join table ` +
                            `'${table.getTableName()}' does not exist in 'selectColumns'.`);
                }
            }

            if (rows.length === 0) 
                continue;

            // let join_Rows = null;

            let on_ColValues = {};
            for (let on of join.on)
                on_ColValues[on[0]] = [];

            for (let row of rows) {
                for (let on of join.on) {
                    if (assoc)
                        on_ColValues[on[0]].push(row[on[1]]);
                    else
                        on_ColValues[on[0]].push(row[this.getColumnIndex(on[1])]);
                }
            }

            let where = [ join.where ];
            for (let on of join.on) {
                if (on_ColValues[on[0]].length > 0) {
                    where.push(
                        [ on[0], 'IN', on_ColValues[on[0]] ],
                    );
                }
            }

            let join_Rows = await table.select_Async(db, {
                assoc: assoc,
                selectColumns: join.selectColumns, 
                selectColumnNames: join.selectColumnNames,
                where: where,
                orderBy: join.orderBy,
                limit: null,
                groupBy: join.groupBy,
                join: [],
            }, transactionId);

            let rows_Joined_New = [];
            for (let row of rows_Joined) {
                let join_Row_Matched = null;
                for (let join_Row of join_Rows) {
                    let joinFound = true;
                    for (let on of join.on) {
                        if (assoc) {
                            if (row[on[1]] !== join_Row[on[0]]) {
                                joinFound = false;
                                break;
                            }
                        } else {
                            if (row[this.getColumnIndex(on[1])] !== 
                                    join_Row[table.getColumnIndex(on[0])]) {
                                joinFound = false;
                                break;
                            }
                        }
                    }

                    if (joinFound) {
                        join_Row_Matched = join_Row;
                        break;
                    }
                }

                if (join.type === 'inner' && join_Row_Matched === null)
                    continue;

                rows_Joined_New.push(row);

                for (let columnName of join.selectColumns.getKeys()) {
                    if (assoc) {
                        row[join['prefix'] + columnName] = join_Row_Matched === null ?
                                null : join_Row_Matched[columnName];
                    } else
                        row.push(join_Row_Matched === null ?
                                null : join_Row_Matched[
                                table.getColumnIndex(columnName)]);
                }
            }

            rows_Joined = rows_Joined_New;
        }

        return rows_Joined;
    }

}
module.exports = Table;





 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\ab-data\scheme\TableRequestDef.js
jsLibs.exportModule('ab-data', 'scheme/TableRequestDef', (require, module, exports) => { 'use strict';

const
    js0 = require('js0'),

    ABDField = require('../fields/ABDField'),
    RequestDef = require('./RequestDef')
;

class TableRequestDef extends RequestDef
{

    static Args_Delete() {
        return {
            where: [ Array, js0.Default([]) ],
        };
    }

    static Args_Select() {
        return {
            assoc: [ 'boolean', js0.Default(true) ],
            selectColumns: [ js0.Iterable(js0.PresetArray(
                    [ 'string', js0.PresetArray([ 'string', ABDField ]) ])), 
                    js0.Null, js0.Default(null) ],
            selectColumnNames: [ js0.ArrayItems('string'), js0.Null, js0.Default(null) ],
            where: [ Array, js0.Default([]) ],
            orderBy: [ js0.Iterable(js0.PresetArray([ 'string', 'boolean' ])), 
                    js0.Default([]) ],
            groupBy: [ js0.Iterable('string'), js0.Null, js0.Default(null) ],
            limit: [ js0.PresetArray([ js0.Int, js0.Int ]), js0.Null, 
                    js0.Default(null) ],
            join: [ js0.Iterable(js0.Preset({
                selectColumns: [ js0.Iterable(js0.PresetArray(
                        [ 'string', js0.PresetArray([ 'string', ABDField ]) ])), 
                        js0.Null, js0.Default(null) ],
                selectColumnNames: [ js0.ArrayItems('string'), js0.Null, js0.Default(null) ],
                type: [ js0.Enum([ 'left', 'inner' ]), js0.Default('left') ],
                prefix: 'string',
                table: require('../Table'),
                on: js0.Iterable(js0.PresetArray([ 'string', 'string' ])),
                where: [ Array, js0.Default([]) ],
                orderBy: [ js0.Iterable(js0.PresetArray([ 'string', 'boolean' ])), 
                        js0.Default([]) ],
                groupBy: [ js0.Iterable('string'), js0.Null, js0.Default(null) ],
                    })), js0.Default([]) ],
                query_OrderBy: [ 'string', js0.Null, js0.Default(null) ],
                // query_Where: [ 'string', js0.Null, js0.Default(null) ],
        };
    }


    constructor() {
        super();
        js0.args(arguments);
   
        this
            .defA('delete', 'w', {
                where: js0.ArrayItems(Array),
            }, {
                success: 'boolean',
                error: [ 'string', js0.Null ],
            })
            .defA('row', 'r',
                TableRequestDef.Args_Select(), {
                row: [ Array, js0.Null ],
                
                success: 'boolean',
                error: [ 'string', js0.Null ],
            })
            .defA('select', 'r',
                TableRequestDef.Args_Select(), {
                rows: [ Array, js0.Null ],

                success: 'boolean',
                error: [ 'string', js0.Null ],
            })
            .defA('set', 'w', {
                row: js0.RawObject,
            }, {
                success: 'boolean',
                error: [ 'string', js0.Null ],
            })
            .defA('update', 'w', {
                rows: js0.ArrayItems(js0.RawObject),
                keys: [ '_Id' ],
            }, {
                success: 'boolean',
                error: [ 'string', js0.Null ],
            });
    }

}
module.exports = TableRequestDef;





 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\ab-data\test.js
jsLibs.exportModule('ab-data', 'test', (require, module, exports) => { 'use strict';

const
    abData = require('.'),

    f = abData.fields,
    s = abData.scheme
;


let tSys_Bulls = new abData.Table('Sys_Bulls', 's_b', [
    [ 'Client__Id', f.Id({ notNull: false, }) ],

    [ 'Name', f.String(64, { notNull: true, }), {
        required: false,
    }],
    [ 'FullName', f.String(64, { notNull: true, }), {
        required: false,
    }],
    [ 'Nr', f.String(20, { notNull: true, }), {
        required: true,
        regexp: [ '^[A-Z0-9]{0,14}$', 'AB123456789012' ],
    }],
    [ 'ManufacturerNr', f.String(9, { notNull: true, }), {
        required: false,
    }],
    [ 'Race', f.String(2, { notNull: true, }), {
        required: false,
    }],

    [ 'Added_Date', f.DateTime({ notNull: true, }) ],
    [ 'Added_User__Id', f.Long({ notNull: true, }) ],
    [ 'Added_Identificator', f.String(64, { notNull: true, }) ],
]);

let v = new abData.Validator();

// tSys_Bulls.validateColumn(v, 'Nr', 'Nr', 'AB123456789012');
tSys_Bulls.validateRow(v, {
    'Nr': 'AB123456789012',
}, {
    'Nr': 'Nr',
});

if (!v.isValid()) {
    for (let fieldName in v.getInfo().fields) {
        if (!v.getInfo().fields.valid)
            console.log(fieldName, v.getInfo().fields[fieldName].errors);
    }
} else
    console.log('Valid!');


// let v = new abData.Validator();

// v.addField('test1', 'My test string');
// v.addFieldValidator('test1', abData.validators.String());

// v.addField('test2', '5');
// v.addFieldValidator('test2', abData.validators.Int({
//     minValue: 1,
//     maxValue: 10,
// }));

// console.log(v.isValid());

// if (!v.isValid()) {
//     console.log(v.getInfo().fields['test1'].errors);
//     console.log(v.getInfo().fields['test2'].errors);
// }

// console.log(v.getInfo());





 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\ab-data\index.js
jsLibs.exportModule('ab-data', 'index', (require, module, exports) => { 'use strict';

const
    js0 = require('js0'),

    DatabaseInfo = require('./DatabaseInfo')
;

class abData_Class
{

    get debug() {
        return this._debug
    }

    get fields() {
        return require('./fields');
    }

    get native() {
        return require('./native');
    }

    get scheme() {
        return require('./scheme');
    }

    get validators() {
        return require('./validators');
    }

    get Device() {
        return require('./Device');
    }

    get DataStore() {
        return require('./DataStore');
    }

    get DatabaseInfo() {
        return require('./DatabaseInfo');
    }

    get Field() {
        return require('./fields/Field');
    }

    get FieldInfo() {
        return require('./FieldInfo');
    }

    get Response() {
        return require('./Response');
    }

    get RequestProcessor() {
        return require('./RequestProcessor');
    }

    get RequestProcessor_Native() {
        return require('./RequestProcessor_Native');
    }

    get RequestProcessor_Web() {
        return require('./RequestProcessor_Web');
    }

    get RTable() {
        return require('./RTable');
    }

    get SelectColumnType() {
        return require('./SelectColumnType');
    }

    get Table() {
        return require('./Table');
    }

    get TableInfo() {
        return require('./TableInfo');
    }

    get Validator() {
        return require('./Validator');
    }


    constructor() {
        this._debug = false;
    }

    error(errorTitle, error) {
        if (!this.debug)
            return;

        console.error(errorTitle, error);
    }

    setDebug(debug) {
        js0.args(arguments, 'boolean');
        this._debug = debug;
    }

}
module.exports = new abData_Class();





 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\ab-data\scheme\DataScheme.js
jsLibs.exportModule('ab-data', 'scheme/DataScheme', (require, module, exports) => { 'use strict';

const
    js0 = require('js0'),

    DatabaseInfo = require('../DatabaseInfo'),
    FieldInfo = require('../FieldInfo'),
    TableInfo = require('../TableInfo')
;

class DataScheme
{

    get tableNames() {
        return this._tables.keys();
    }

    get version() {
        return this._version;
    }


    constructor(version) {
        js0.args(arguments, 'int');

        this._version = version;
        this._requests = new Map();
        this._tables = new Map();

        this._ignored_TableNames = [];
    }

    createDatabaseInfo() {
        let databaseInfo = new DatabaseInfo();

        for (let [ tableName, table ] of this._tables) {
            let tableInfo = new TableInfo(table.name);
            for (let [ fieldName, column ] of table.columns) {
                let field = column.field;
                let fieldInfo = new FieldInfo(
                    fieldName,
                    field,
                    FieldInfo.GetType_FromField(field),
                    '',
                    field.properties.notNull
                );
                tableInfo.addFieldInfo(fieldInfo);
            }

            tableInfo.setPKs(table.pks);

            databaseInfo.addTableInfo(tableInfo);
        }

        return databaseInfo;
    }

    defR(requestName, requestDef) {
        this.defRequest(requestName, requestDef);

        return this;
    }

    defRequest(requestName, requestDef) {
        js0.args(arguments, 'string', require('./RequestDef'));

        if (this._requests.has(requestName))
            throw new Error(`Request '${requestName}' already exists.`);

        this._requests.set(requestName, requestDef);

        return this;
    }

    defT(table) {
        this.defTable(table);

        return this;
    }

    defTable(table) {
        js0.args(arguments, require('../Table'));

        this._validateTableId(table.getTableId());

        if (this._tables.has(table.name))
            throw new Error(`Table '${tableName}' already exists.`);

        this._tables.set(table.name, table);

        return this;
    }

    getIgnored_TableNames() {
        return this._ignored_TableNames;
    }

    getRequestDef(requestName) {
        if (!this.hasRequestDef(requestName))
            throw new Error(`RequestDef '${requestName}' does not exist.`);

        return this._requests.get(requestName);
    }

    getT(tableName) {
        return this.getTable(tableName);
    }

    getTable(tableName) {
        js0.args(arguments, 'string');

        if (!(this._tables.has(tableName)))
            throw new Error(`Table '${tableName}' does not exist.`);

        return this._tables.get(tableName);
    }

    getTable_ById(tableId) {
        for (let [ tableName, table ] of this._tables) {
            if (table.getTableId() === tableId)
                return table;
        }

        throw new Error(`Table with id '${tableId}' does not exist.`);
    }

    getTableIds() {
        let tableIds = {};
        for (let tableName of this.tableNames) {
            let table = this.getTable(tableName);
            tableIds[tableName] = table.getTableId();
        }

        return tableIds;
    }

    getValidatorInfos() {
        let validatorInfos = {};
        for (let tableName of this.tableNames) {
            let table = this.getTable(tableName);
            validatorInfos[tableName] = table.getValidatorInfos();
        }

        return validatorInfos;
    }
    
    hasTable(tableName) {
        js0.args(arguments, 'string');

        return this._tables.has(tableName);
    }

    hasTable_ById(tableId) {
        js0.args(arguments, 'int');

        for (let [ tableName, table ] of this._tables) {
            if (table.getTableId() === tableId)
                return true;
        }

        return false;
    }

    hasRequestDef(requestName) {
        return this._requests.has(requestName);
    }

    ignoreT(tableNames) {   
        js0.args(arguments, js0.Iterable('string'));

        this._ignored_TableNames = tableNames;

        return this;
    }  
    
    validateResponse(response, request) {
        if (response === null)
            return;

        let requestId = request[0];
        let requestName = request[1];
        let actionName = request[2];
        let actionArgs = request[3];

        let requestDef = this.getRequestDef(requestName);
        let actionDef = requestDef.getActionDef(actionName);

        if (!(requestId in response))
            throw new Error(`Result '${requestId}' not found in response.`);

        let errors = [];
        if (!js0.type(response[requestId], js0.Preset(actionDef.resultDef), errors)) {
            console.error(`Result errors:`, errors);
            throw new Error(`Request action '${requestName}:${actionName}' result error.`);
        }
    }

    validateResult(request, result) {
        let requestId = request[0];
        let requestName = request[1];
        let actionName = request[2];
        let actionArgs = request[3];

        let requestDef = this.getRequestDef(requestName);
        let actionDef = requestDef.getActionDef(actionName);

        if (!js0.type(result, js0.RawObject)) {
            console.error(`'${requestName}:${actionName}' result:`, result);
            throw new Error(`Result of '${requestName}:${actionName}' must be a 'RawObject'.`);
        }

        let errors = [];
        if (!js0.type(result, js0.Preset(actionDef.resultDef), errors)) {
            console.error(`'${requestName}:${actionName}' result:`, result);
            console.error(`Result errors:`, errors);``
            throw new Error(`Request action '${requestName}:${actionName}' result error.`);
        }
    }

    validateRequest(request) {
        let requestId = request[0];
        let requestName = request[1];
        let actionName = request[2];
        let actionArgs = request[3];

        if (!this.hasRequestDef(requestName))
            throw new Error(`Request '${requestName}' not defined.`);
        
        let requestDef = this.getRequestDef(requestName);

        if (!requestDef.hasActionDef(actionName))
            throw new Error(`Action '${requestName}:${actionName}' not defined.`);

        let actionDef = requestDef.getActionDef(actionName);
        let errors = [];
        if (!js0.type(actionArgs, js0.Preset(actionDef.argsDef), errors)) {
            console.error(`Args errors:`, errors);
            throw new Error(`Request action '${requestName}:${actionName}' args error.`);
        }
    }


    _validateTableId(tableId) {
        for (let [ tableName, table ] of this._tables) {
            if (table.getTableId() === tableId)
                throw new Error(`Table with id '${tableId}' already exists ('${tableName}')`);
        }
    }

}
module.exports = DataScheme;





 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\ab-data\native\ABDDatabaseError.js
jsLibs.exportModule('ab-data', 'native/ABDDatabaseError', (require, module, exports) => { 'use strict';

class ABDDatabaseError extends Error
{
    constructor(message) {
        super(message);

        this.name = 'ABDDatabaseError';
    }
    
}
module.exports = ABDDatabaseError;





 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\ab-data\scheme\RequestDef.js
jsLibs.exportModule('ab-data', 'scheme/RequestDef', (require, module, exports) => { 'use strict';

const
    js0 = require('js0')
;

class RequestDef
{

    static ExtendDef(def, extDef) {
        js0.args(arguments, js0.RawObject, js0.RawObject);

        let newDef = {};

        for (let argName in def)
            newDef[argName] = def[argName];

        for (let argName in extDef)
            newDef[argName] = extDef;

        return newDef;
    }

    constructor() {
        this._actionDefs = {};
    }

    defA(actionName, actionType, argsDef, resultDef) {
        this.defAction(actionName, actionType, argsDef, resultDef);

        return this;
    }

    defAction(actionName, actionType, argsDef, resultDef) {
        js0.args(arguments, 'string', js0.Enum([ 'r', 'w' ]), 
                js0.RawObject, js0.RawObject);

        resultDef._type = 'int';
        resultDef._message = 'string';

        // if (actionType === 'w') {
            // if (!('success' in resultDef))
            //     throw new Error(`No 'success' in action result definition.`);

            // if (resultDef.success !== 'boolean')
            //     throw new Error(`'success' part in action result must be a 'boolean'.`);
        // }

        this._actionDefs[actionName] = {
            type: actionType,
            argsDef: argsDef,
            resultDef: resultDef,
        };

        return this;
    }

    getADef(actionName) {
        return this.getActionDef(actionName);
    }

    getActionDef(actionName) {
        js0.args(arguments, 'string');

        if (!(actionName in this._actionDefs))
            throw new Error(`Action '${actionName}' does not exist.`);

        return this._actionDefs[actionName];
    }

    hasActionDef(actionName) {
        return actionName in this._actionDefs;
    }

    undefA(actionName) {
        this.undefAction(actionName);

        return this;
    }

    undefAction(actionName) {
        js0.args(arguments, 'string');

        if (!(actionName in this._actionDefs))
            throw new Error(`Action '${actionName}' does not exist.`);

        delete this._actionDefs[actionName];

        return this;
    }

}
module.exports = RequestDef;





 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\ab-data\scheme\index.js
jsLibs.exportModule('ab-data', 'scheme/index', (require, module, exports) => { 'use strict';


module.exports.DataScheme = require('./DataScheme');
module.exports.RequestDef = require('./RequestDef');
module.exports.TableRequestDef = require('./TableRequestDef');





 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\ab-data\native\Database_WithCurrentTransaction.js
jsLibs.exportModule('ab-data', 'native/Database_WithCurrentTransaction', (require, module, exports) => { 'use strict';

const
    abLock = require('ab-lock'),
    abNative = require('ab-native'),
    js0 = require('js0'),

    abData = require('..'),
    helper = require('../helper'),

    DatabaseInfo = require('../DatabaseInfo'),
    FieldInfo = require('../FieldInfo'),
    TableInfo = require('../TableInfo'),

    ABDDatabaseError = require('./ABDDatabaseError')
;

class Database
{

    static EscapeString(str) {
        return helper.escapeString(str);
    }

    static UnescapeString(str) {
        return helper.unescapeString(str);
    }

    static Quote(str) {
        return helper.quote(str);
    }


    get initialized() {
        return this._initialized;
    }

    constructor() {
        this._initialized = false;
        this._lastError = null;

        this._transaction_CurrentId = null;

        let nad = new abNative.ActionsSetDef()
            .addNative('GetAffectedRows', {

            }, {
                affectedRows: [ 'int', js0.Null ],
            })
            .addNative('GetTableNames', {

            }, {
                tableNames: js0.Iterable('string'),
                error: [ 'string', js0.Null ],
            })
            .addNative('GetTableColumnInfos', {
                tableName: [ 'string' ],
            }, {
                columnInfos: js0.Iterable(null),
                error: [ 'string', js0.Null ],
            })
            .addNative('Transaction_Finish', {
                commit: 'boolean',
                transactionId: 'int',
            }, {
                error: [ 'string', js0.Null ],
            })
            .addNative('Transaction_IsAutocommit', {
             
            }, {
                result: 'boolean',
                error: [ 'string', js0.Null ],
            })
            .addNative('Transaction_Start', {}, {
                transactionId: [ 'int', js0.Null ],
                error: [ 'string', js0.Null ],
            })
            .addNative('Query_Execute', {
                query: 'string',
                transactionId: [ js0.Null, 'int', ],
            }, {
                error: [ 'string', js0.Null ],
            })
            .addNative('Query_Select', {
                query: 'string',
                columnTypes: js0.Iterable('int'),
                transactionId: [ js0.Null, 'int', ],
            }, {
                rows: [ Array, js0.Null ],
                error: [ 'string', js0.Null ],
            });
        this.nativeActions = abNative.addActionsSet('ABDatabase', nad);
    }

    

    // async clearDBRequests_Async(requestIds)
    // {
    //     js0.args(arguments, Array);

    //     await this.query_Execute_Async(
    //             `DELETE FROM _ABData_DBRequests ` +
    //             ` WHERE Id IN (` + requestIds.join(',') + `)`);
    // }

    // async deleteDBRequests_ByIds_Async(ids)
    // {
    //     js0.args(arguments, js0.ArrayItems('number'));

    //     await this.query_Execute_Async(
    //             `DELETE FROM _ABData_DBRequests` +
    //             ` WHERE Id IN (` + ids.join(',') + `)`);
    // }

    // async getDBRequests_ByType_Async(requestName, actionName)
    // {
    //     js0.args(arguments, 'string', 'string');

    //     let rows = await this.query_Select_Async(
    //             `SELECT Id, RequestName, ActionName, ActionArgs` +
    //             ` FROM _ABData_DBRequests` +
    //             ` WHERE RequestName = '${requestName}' AND ActionName = '${actionName}'` +
    //             ` ORDER BY Id`,
    //             [ 'Long', 'String', 'String', 'String' ]);

    //     for (let row of rows)
    //         row[3] = JSON.parse(row[3]);

    //     return rows;
    // }

    // async getDBRequests_ForSync_Async()
    // {
    //     let rows = await this.query_Select_Async(
    //             `SELECT Id, RequestName, ActionName, ActionArgs` +
    //             ` FROM _ABData_DBRequests ORDER BY Id`, 
    //             [ 'Long', 'String', 'String', 'String' ]);

    //     for (let row of rows)
    //         row[3] = JSON.parse(row[3]);

    //     return rows;
    // }

    // async getVersion_Async()
    // {
    //     let version = null;
    //     try {
    //         let version_Rows = await this.query_Select_Async(
    //                 `SELECT Name, Data FROM _ABData_Settings WHERE Name = 'version'`, 
    //                 [ 'String', 'String' ]);
    //         if (version_Rows.length !== 0)
    //             version = JSON.parse(version_Rows[0][1])['value'];
    //     } catch (e) {
    //         if (e instanceof ABDDatabaseError) {
    //             // Table does not exist.
    //         } else 
    //             throw e;
    //     }

    //     return version;
    // }

    async checkInit_Async() {
        if (!this._initialized)
            throw new Error('Database not initialized.');
    }

    async createDatabaseInfo_Async(transactionId = null) {
        js0.args(arguments, [ 'int', js0.Null, js0.Default(null) ]);

        await this.checkInit_Async();

        let databaseInfo = new DatabaseInfo();

        let tableNames = (await this.nativeActions.callNative_Async('GetTableNames'))
                .tableNames;
        for (let tableName of tableNames) {
            let tableInfo = new TableInfo(tableName);

            let result = await this.nativeActions.callNative_Async(
                    'GetTableColumnInfos', {
                tableName: tableName,
            });
            for (let columnInfo of result.columnInfos) {
                tableInfo.addFieldInfo(new FieldInfo(
                    columnInfo.name,
                    null,
                    [ columnInfo.type ],
                    '',
                    columnInfo.notNull,
                ));
            }

            databaseInfo.addTableInfo(tableInfo);
        }
        
        return databaseInfo;
    }

    getLastError() {
        return this._lastError;
    }

    async init_Async() {
        if (this._initialized)
            throw new Error('Database already initialized.');

        let isAutocommit_Result = await this.nativeActions.callNative_Async(
                'Transaction_IsAutocommit', {});

        if (!isAutocommit_Result.result)
            throw new Error('Transaction in progress. Cannot initialize Database.');

        this._initialized = true;
    }

    async transaction_Finish_Async(commit) {
        js0.args(arguments, 'boolean');

        await this.checkInit_Async();

        let result = await this.nativeActions.callNative_Async(
                'Transaction_Finish', 
                { transactionId: this._transaction_CurrentId, commit: commit });

        this._transaction_CurrentId = null;

        if (result.error !== null)
            throw new ABDDatabaseError(result.error);
    }   

    async transaction_IsAutocommit_Async() {
        await this.checkInit_Async();

        let result = await this.nativeActions.callNative_Async(
                'Transaction_IsAutocommit', {});
        return result.result;
    }

    async transaction_Start_Async() {
        await this.checkInit_Async();

        let result = await this.nativeActions.callNative_Async(
                'Transaction_Start', {});

        if (result.error !== null)
            throw new ABDDatabaseError(result.error);

        this._transaction_CurrentId = result.transactionId;
    }   

    async transaction_StartLocal_Async() {
        await this.checkInit_Async();

        let localTransaction = false;
        await abLock.sync(this, async () => {
            if (await this.transaction_IsAutocommit_Async()) {
                localTransaction = true;
                await this.transaction_Start_Async();
            }
        });

        return localTransaction;
    }

    async query_Execute_Async(query) {
        await this.checkInit_Async();

        let result = await this.nativeActions.callNative_Async('Query_Execute', 
                { query: query, transactionId: this._transaction_CurrentId, });

        if (result.error !== null)
            throw new ABDDatabaseError(result.error);
    }   

    async query_Select_Async(query, columnTypes) {
        await this.checkInit_Async();

        let result = await this.nativeActions.callNative_Async('Query_Select', 
                { query: query, columnTypes: columnTypes, 
                transactionId: this._transaction_CurrentId, });

        if (result.rows === null)
            throw new ABDDatabaseError(result.error);

        return result.rows;
    }

}
module.exports = Database;





 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\ab-data\native\Database.js
jsLibs.exportModule('ab-data', 'native/Database', (require, module, exports) => { 'use strict';

const
    abLock = require('ab-lock'),
    abNative = require('ab-native'),
    js0 = require('js0'),

    abData = require('..'),
    helper = require('../helper'),

    DatabaseInfo = require('../DatabaseInfo'),
    FieldInfo = require('../FieldInfo'),
    TableInfo = require('../TableInfo'),

    ABDDatabaseError = require('./ABDDatabaseError')
;

class Database
{

    static EscapeString(str) {
        return helper.escapeString(str);
    }

    static UnescapeString(str) {
        return helper.unescapeString(str);
    }

    static Quote(str) {
        return helper.quote(str);
    }


    get initialized() {
        return this._initialized;
    }

    constructor() {
        this._initialized = true;
        this._lastError = null;

        let nad = new abNative.ActionsSetDef()
            // .addNative('GetAffectedRows', {

            // }, {
            //     affectedRows: [ 'int', js0.Null ],
            // })
            .addNative('GetTableColumnInfos', {
                tableName: [ 'string' ],
                transactionId: [ 'int', js0.Null ],
            }, {
                columnInfos: js0.Iterable(null),
            })
            .addNative('GetTableNames', {
                transactionId: [ 'int', js0.Null ],
            }, {
                tableNames: js0.Iterable('string'),
            })
            .addNative('Transaction_Finish', {
                commit: 'boolean',
                transactionId: 'int',
            }, null)
            .addNative('Transaction_IsAutocommit', null, {
                transactionId: [ 'int', js0.Null ],
            })
            .addNative('Transaction_Start', null, {
                transactionId: [ 'int', js0.Null ],
            })
            .addNative('Query_Execute', {
                query: 'string',
                transactionId: [ js0.Null, 'int', ],
            }, null)
            .addNative('Query_Select', {
                query: 'string',
                columnTypes: js0.Iterable('int'),
                transactionId: [ js0.Null, 'int', ],
            }, {
                rows: [ Array, js0.Null ],
            });
        this.nativeActions = abNative.addActionsSet('ABDatabase', nad);
    }

    

    // async clearDBRequests_Async(requestIds)
    // {
    //     js0.args(arguments, Array);

    //     await this.query_Execute_Async(
    //             `DELETE FROM _ABData_DBRequests ` +
    //             ` WHERE Id IN (` + requestIds.join(',') + `)`);
    // }

    // async deleteDBRequests_ByIds_Async(ids)
    // {
    //     js0.args(arguments, js0.ArrayItems('number'));

    //     await this.query_Execute_Async(
    //             `DELETE FROM _ABData_DBRequests` +
    //             ` WHERE Id IN (` + ids.join(',') + `)`);
    // }

    // async getDBRequests_ByType_Async(requestName, actionName)
    // {
    //     js0.args(arguments, 'string', 'string');

    //     let rows = await this.query_Select_Async(
    //             `SELECT Id, RequestName, ActionName, ActionArgs` +
    //             ` FROM _ABData_DBRequests` +
    //             ` WHERE RequestName = '${requestName}' AND ActionName = '${actionName}'` +
    //             ` ORDER BY Id`,
    //             [ 'Long', 'String', 'String', 'String' ]);

    //     for (let row of rows)
    //         row[3] = JSON.parse(row[3]);

    //     return rows;
    // }

    // async getDBRequests_ForSync_Async()
    // {
    //     let rows = await this.query_Select_Async(
    //             `SELECT Id, RequestName, ActionName, ActionArgs` +
    //             ` FROM _ABData_DBRequests ORDER BY Id`, 
    //             [ 'Long', 'String', 'String', 'String' ]);

    //     for (let row of rows)
    //         row[3] = JSON.parse(row[3]);

    //     return rows;
    // }

    // async getVersion_Async()
    // {
    //     let version = null;
    //     try {
    //         let version_Rows = await this.query_Select_Async(
    //                 `SELECT Name, Data FROM _ABData_Settings WHERE Name = 'version'`, 
    //                 [ 'String', 'String' ]);
    //         if (version_Rows.length !== 0)
    //             version = JSON.parse(version_Rows[0][1])['value'];
    //     } catch (e) {
    //         if (e instanceof ABDDatabaseError) {
    //             // Table does not exist.
    //         } else 
    //             throw e;
    //     }

    //     return version;
    // }

    async checkInit_Async() {
        if (!this._initialized)
            throw new Error('Database not initialized.');
    }

    async createDatabaseInfo_Async(transactionId = null) {
        js0.args(arguments, [ 'int', js0.Null, js0.Default ]);
        
        await this.checkInit_Async();

        let databaseInfo = new DatabaseInfo();

        let tableNames = (await this.nativeActions.callNative_Async(
                'GetTableNames', { transactionId: transactionId }))
                .tableNames;
        for (let tableName of tableNames) {
            let tableInfo = new TableInfo(tableName);

            let result = await this.nativeActions.callNative_Async(
                    'GetTableColumnInfos', {
                transactionId: transactionId,
                tableName: tableName,
            });
            for (let columnInfo of result.columnInfos) {
                tableInfo.addFieldInfo(new FieldInfo(
                    columnInfo.name,
                    null,
                    [ columnInfo.type ],
                    '',
                    columnInfo.notNull,
                ));
            }

            databaseInfo.addTableInfo(tableInfo);
        }
        
        return databaseInfo;
    }

    getLastError() {
        return this._lastError;
    }

    // async init_Async()
    // {
    //     if (this._initialized)
    //         throw new Error('Database already initialized.');

    //     let isAutocommit_Result = await this.nativeActions.callNative_Async(
    //             'Transaction_IsAutocommit', {});

    //     if (isAutocommit_Result.transactionId !== null)
    //         throw new Error('Transaction in progress. Cannot initialize Database.');

    //     this._initialized = true;
    // }

    async transaction_Finish_Async(commit, transactionId) {
        js0.args(arguments, 'boolean', 'int');

        if (abData.debug)
            console.log('Debug: Transaction Finish', transactionId, new Error());

        await this.checkInit_Async();

        try {
            await this.nativeActions.callNative_Async(
                    'Transaction_Finish', 
                    { transactionId: transactionId, commit: commit });
        } catch (e) {
            throw new ABDDatabaseError(e);
        }
    }   

    async transaction_IsAutocommit_Async() {
        js0.args(arguments);

        await this.checkInit_Async();

        let result;
        try {
            result = await this.nativeActions.callNative_Async(
                    'Transaction_IsAutocommit');
        } catch (e) {
            throw new ABDDatabaseError(e);
        }

        return result.transactionId;
    }

    async transaction_Start_Async() {
        js0.args(arguments);

        if (abData.debug)
            console.log('Debug: Transaction Start', new Error());

        await this.checkInit_Async();

        let result;
        try {
            result = await this.nativeActions.callNative_Async(
                    'Transaction_Start')
        } catch (e) {
            throw new ABDDatabaseError(e);
        }

        if (abData.debug)
            console.log('Debug: Transaction Id', result.transactionId);

        return result.transactionId;
    }   

    // async transaction_StartLocal_Async()
    // {
    //     await this.checkInit_Async();

    //     let localTransaction = false;
    //     await abLock.sync(this, async () => {
    //         if (await this.transaction_IsAutocommit_Async()) {
    //             localTransaction = true;
    //             await this.transaction_Start_Async();
    //         }
    //     });

    //     return localTransaction;
    // }

    async query_Execute_Async(query, transactionId = null) {
        js0.args(arguments, 'string', [ 'int', js0.Null, js0.Default ]);

        if (abData.debug)
            console.log('Debug: Query Execute -> ', query, new Error());

        await this.checkInit_Async();

        try {
            await this.nativeActions.callNative_Async('Query_Execute', 
                    { query: query, transactionId: transactionId, });
        } catch (e) {
            throw new ABDDatabaseError(e);
        }
    }   

    async query_Select_Async(query, columnTypes, transactionId = null) {
        js0.args(arguments, 'string', js0.Iterable('int'), [ 'int', 
                js0.Null, js0.Default ]);

        if (abData.debug)
            console.log('Debug: Query Execute -> ', query, new Error());

        await this.checkInit_Async();

        let result;
        try {
            result = await this.nativeActions.callNative_Async('Query_Select', 
                    { query: query, columnTypes: columnTypes, 
                    transactionId: transactionId, });
        } catch (e) {
            throw new ABDDatabaseError(e);
        }

        return result.rows;
    }

}
module.exports = Database;





 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\ab-data\native\NativeDataStore.js
jsLibs.exportModule('ab-data', 'native/NativeDataStore', (require, module, exports) => { 'use strict';

const
    abData = require('ab-data'),
    js0 = require('js0'),
    webABApi = require('web-ab-api'),

    DataStore = require('../DataStore'),
    DatabaseInfo = require('../DatabaseInfo'),
    Response = require('../Response'),
    SelectColumnType = require('../SelectColumnType'),

    Database = require('./Database')
;

class NativeDataStore extends DataStore
{

    static async GetDeviceInfo_Async(db, transactionId = null) {
        js0.args(arguments, abData.native.Database, [ 'int', js0.Null, 
                js0.Default ]);

        let rows = await db.query_Select_Async(
                `SELECT Name, Data FROM _ABData_Settings WHERE Name = 'deviceInfo'`, 
                [ SelectColumnType.String, SelectColumnType.String ], 
                transactionId);

        if (rows.length === 0)
            return null;

        let deviceInfo = JSON.parse(rows[0][1])['value'];
        
        return deviceInfo;
    }

    static async GetDBSchemeVersion_Async(db, transactionId = null) {
        js0.args(arguments, abData.native.Database, [ 'int', js0.Null,
                js0.Default ]);
        let version = null;
        try {
            let version_Rows = await db.query_Select_Async(
                    `SELECT Name, Data FROM _ABData_Settings WHERE Name = 'version'`, 
                    [ SelectColumnType.String, SelectColumnType.String ], 
                    transactionId);
            if (version_Rows.length !== 0) {
                try {
                    version = JSON.parse(version_Rows[0][1])['value'];
                } catch (e) {
                    if (abData.debug)
                        console.log(GetDBSchemeVersion, e);
                    
                    if (e.name === 'SyntaxError')
                        throw new Error("Cannot parse DB scheme version.");
                }
            }
        } catch (e) {
            if (abData.debug)
                console.log('GetDBSchemeVersion', e);

            if (e instanceof require('./ABDDatabaseError')) {
                return -1;
            } else 
                throw e;
        }

        return version;
    }

    static async InitDeviceInfo_Async(db, transactionId = null) {
        js0.args(arguments, abData.native.Database, [ 'int', js0.Null, 
                js0.Default ]);

        let deviceInfo = await NativeDataStore.GetDeviceInfo_Async(db, 
                transactionId);
        if (deviceInfo === null)
            return null;

        deviceInfo.declaredItemIds = [];
        deviceInfo.usedItemIds = [];
        
        return deviceInfo;
    }

    static async ResetDeviceLastUpdate_Async(db, transactionId = null) {
        js0.args(arguments, abData.native.Database, [ 'int', js0.Null, 
                js0.Default ]);

        let localTransaction = false;
        if (transactionId === null) {
            transactionId = await db.transaction_Start_Async();
            localTransaction = true;
        }

        let deviceInfo = await NativeDataStore.GetDeviceInfo_Async(db, 
                transactionId);
        if (deviceInfo === null)
            return;

        deviceInfo.lastUpdate = null;
        await NativeDataStore.SetDeviceInfo_Async(db, deviceInfo.deviceId,
                deviceInfo.deviceHash, deviceInfo.lastItemId, 
                deviceInfo.lastUpdate, deviceInfo.declaredItemIds, 
                transactionId);

        if (localTransaction)
            await db.transaction_Finish_Async(true, transactionId);
    }

    static async SetDeviceInfo_Async(db, deviceId, deviceHash, lastItemId, 
            lastUpdate, declaredItemIds, transactionId = null) {
        js0.args(arguments, abData.native.Database, js0.Long, 'string', js0.Long, 
                [ js0.Long, js0.Null ], Array, [ 'int', js0.Null, js0.Default ]);

        let localTransaction = false;
        if (transactionId === null) {
            transactionId = await db.transaction_Start_Async();
            localTransaction = true;
        }

        let deviceInfo_Old = await NativeDataStore.GetDeviceInfo_Async(db, 
                transactionId);
        let deviceInfo = {
            deviceId: deviceId,
            deviceHash: deviceHash,
            lastItemId: lastItemId,
            lastUpdate: lastUpdate,
            declaredItemIds: declaredItemIds,
        };
        let deviceInfo_JSON_Str = abData.native.Database.EscapeString(
                JSON.stringify({ value: deviceInfo, }));
            
        if (deviceInfo_Old === null) {
            await db.query_Execute_Async(
                `INSERT INTO _ABData_Settings (Name, Data)` + 
                ` VALUES('deviceInfo', '${deviceInfo_JSON_Str}')`, transactionId);
        } else {
            await db.query_Execute_Async(
                `UPDATE _ABData_Settings` + 
                ` SET Name = 'deviceInfo', Data = '${deviceInfo_JSON_Str}'` + 
                ` WHERE Name = 'deviceInfo'`, transactionId);
        }

        if (localTransaction)
            await db.transaction_Finish_Async(true, transactionId);
    }

    static async SetDBSchemeVersion_Async(db, version, transactionId = null) {
        js0.args(arguments, abData.native.Database, 'int', [ 'int', js0.Null, 
                js0.Default ]);

        let localTransaction = false;
        if (transactionId === null) {
            transactionId = await db.transaction_Start_Async();
            localTransaction = true;
        }

        let version_Old = await NativeDataStore.GetDBSchemeVersion_Async(db, 
                transactionId);

        let version_JSON_Str = JSON.stringify({ value: version, });
        if (version_Old === null) {
            await db.query_Execute_Async(
                    `INSERT INTO _ABData_Settings (Name, Data)` + 
                    ` VALUES('version', '${version_JSON_Str}')`, transactionId);
        } else {
            await db.query_Execute_Async(
                    `UPDATE _ABData_Settings` + 
                    ` SET Name = 'version', Data = '${version_JSON_Str}'` + 
                    ` WHERE Name = 'version'`, transactionId);
        }

        if (localTransaction)
            await db.transaction_Finish_Async(true, transactionId);

        return version;
    }

    static async UpdateDBScheme_Async(db, scheme, transactionId = null) {
        js0.args(arguments, require('./Database'), 
                require('../scheme/DataScheme'), [ 'int', js0.Null, 
                js0.Default ]);

        let localTransaction = false;
        if (transactionId === null) {
            transactionId = await db.transaction_Start_Async();
            localTransaction = true;
        }

        let dbInfo_Scheme = scheme.createDatabaseInfo();
        let dbInfo_DB = await db.createDatabaseInfo_Async(transactionId);

        let actions = DatabaseInfo.Compare(scheme, dbInfo_Scheme, dbInfo_DB);

        for (let tableInfo of actions.tables.delete) {
            let query = `DROP TABLE ${tableInfo.name}`;
            await db.query_Execute_Async(query, transactionId);
        }

        for (let tableInfo of actions.tables.create) {
            let query = tableInfo.getQuery_Create();

            console.log(query);
            await db.query_Execute_Async(query, transactionId);
        }

        for (let alterInfo of actions.tables.alter) {
            for (let fieldInfo of alterInfo.delete) {
                let query_Alter = `ALTER TABLE ${alterInfo.tableInfo.name}` +
                        ` DROP COLUMN \`${fieldInfo.name}\``;
                let result = await db.query_Execute_Async(query_Alter, 
                        transactionId);
            }
            
            for (let fieldInfo of alterInfo.create) {
                let query_Alter = `ALTER TABLE ${alterInfo.tableInfo.name}` +
                        ` ADD COLUMN ` + fieldInfo.getQuery_Column();
                // let query_Clean = null;

                if (fieldInfo.notNull) {
                    query_Alter += ' DEFAULT ' + fieldInfo.field.escape(
                            fieldInfo.field.defaultValue);
                    // query_Clean = `ALTER TABLE ${alterInfo.tableInfo.name}` +
                    //         ` ALTER COLUMN ` + fieldInfo.name + 
                    //         ` DROP DEFAULT`;
                }
                
                console.log(query_Alter);
                // console.log(query_Clean);

                let result = await db.query_Execute_Async(query_Alter, 
                        transactionId);
                // if (query_Clean !== null)
                //     result = await this.query_Execute_Async(query_Clean);
            }

            console.log(`Altered: ${alterInfo.tableInfo.name}`);
            if (alterInfo.delete.length > 0) {
               console.log('  deleted:');
                for (let fieldInfo of alterInfo.delete)
                   console.log(`    - ${fieldInfo.name}`);
            }
            if (alterInfo.create.length > 0) {
               console.log('  created:');
                for (let fieldInfo of alterInfo.create)
                   console.log(`    - ${fieldInfo.name}`);
            }
        }

        await NativeDataStore.SetDBSchemeVersion_Async(db, scheme.version, 
                transactionId);

        if (localTransaction)
            await db.transaction_Finish_Async(true, transactionId);

        return actions;
    }


    get scheme() {
        return this._scheme;
    }

    get db() {
        return this._db;
    }

    get device() {
        return this._device;
    }


    constructor(requestProcessor, apiUri) {
        js0.args(arguments, require('../RequestProcessor_Native'), 'string');

        super(requestProcessor);

        this._scheme = requestProcessor.scheme;
        this._db = requestProcessor.db;
        this._device = requestProcessor.device;

        this._apiUri = apiUri;

        this._requests = {};
        this._listeners_OnDBSync = [];
    }

    async addDeviceDeletedRows_Async(rDeviceDeletedRows, transactionId = null) {
        js0.args(arguments, Array, [ 'int', js0.Null ]);

        await this._scheme.getTable('_ABData_DeviceDeletedRows').update_Async(
                this._db, rDeviceDeletedRows, transactionId);
    }

    async addDBRequest_Async(requestName, actionName, actionArgs, 
            transactionId = null) {
        js0.args(arguments, 'string', 'string', js0.RawObject, [ 'int', 
                js0.Null, js0.Default ]);

        let localTransaction = false;
        if (transactionId === null) {
            transactionId = await this.db.transaction_Start_Async();
            localTransaction = true;
        }

        let nextRequestId = 1;
        let nextRequestId_Rows = await this.db.query_Select_Async(
                `SELECT Name, Data FROM _ABData_Settings WHERE Name = 'nextRequestId'`, 
                [ SelectColumnType.String, SelectColumnType.String ], 
                transactionId);
        if (nextRequestId_Rows.length !== 0)
            nextRequestId = JSON.parse(nextRequestId_Rows[0][1])['value'];

        let query = `INSERT INTO _ABData_DBRequests ` +
                `(Id, RequestName, ActionName, ActionArgs, SchemeVersion)` +
                ` VALUES `;

        query += `(`;
        query += ++nextRequestId + `,`;
        query += `'` + requestName + `',`;
        query += `'` + actionName + `',`;
        query += `'` + Database.EscapeString(JSON.stringify(actionArgs)) + `',`;
        query += this.scheme.version;
        query += `)`;

        await this.db.query_Execute_Async(query, transactionId);

        let nextRequestId_JSON_Str = JSON.stringify({ value: nextRequestId });
        if (nextRequestId_Rows.length === 0) {
            await this.db.query_Execute_Async(
                    `INSERT INTO _ABData_Settings (Name, Data)` + 
                    ` VALUES('nextRequestId', '${nextRequestId_JSON_Str}')`,
                    transactionId);
        } else {
            await this.db.query_Execute_Async(
                    `UPDATE _ABData_Settings` + 
                    ` SET Name = 'nextRequestId', Data = '${nextRequestId_JSON_Str}'` + 
                    ` WHERE Name = 'nextRequestId'`, transactionId);
        }

        if (localTransaction)
            await this.db.transaction_Finish_Async(true, transactionId);
    }

    addListener_OnDBSync(listener) {
        js0.args(arguments, 'function');

        this._listeners_OnDBSync.push(listener);
    }

    async clearData_Async(transactionId = null) {
        js0.args(arguments, [ 'int', js0.Null, js0.Default ]);

        let localTransaction = false;
        if (transactionId === null) {
            transactionId = await db.transaction_Start_Async();
            localTransaction = true;
        }

        await NativeDataStore.ResetDeviceLastUpdate_Async(this.db, transactionId);
        await this.clearDBRequests_Async(transactionId);
        await this.clearDeviceDeletedRows_Async(transactionId);

        if (localTransaction)
            await this.db.transaction_Finish_Async(true, transactionId);
    }

    async clearDeviceDeletedRows_Async(transactionId = null) {
        js0.args(arguments, [ 'int', js0.Null, js0.Default ]);

        await this._scheme.getTable('_ABData_DeviceDeletedRows').delete_Async(
                this._db, {}, transactionId);
    }

    async clearDBRequests_Async(transactionId = null) {
        js0.args(arguments, [ 'int', js0.Null, js0.Default ]);

        await this.scheme.getT('_ABData_DBRequests').delete_Async(this.db, {}, 
                transactionId);
    }

    async deleteDBRequests_ByIds_Async(requestIds, transactionId = null) {
        js0.args(arguments, js0.ArrayItems('number'), [ 'int', js0.Null, 
                js0.Default ]);

        await this.db.query_Execute_Async(
                `DELETE FROM _ABData_DBRequests` +
                ` WHERE Id IN (` + requestIds.join(',') + `)`, transactionId);
    }

    async getDeviceDeletedRows_Async(transactionId = null) {
        js0.args(arguments, [ 'int', js0.Null, js0.Default ]);

        let rows = await this.db.query_Select_Async(
                `SELECT TableId, RowId FROM _ABData_DeviceDeletedRows`,
                [ SelectColumnType.Int, SelectColumnType.Long ], 
                transactionId);

        return rows;
    }

    async getDeviceInfo_Async(transactionId = null) {
        js0.args(arguments, [ 'int', js0.Null, js0.Default ]);

        let tSettings = this.scheme.getTable('_ABData_Settings');
        let rDeviceInfo = await tSettings.row_Async(this.db, { where: 
                [ 'Name', '=', 'deviceInfo' ] }, transactionId);

        return rDeviceInfo === null ? null : rDeviceInfo.Data;
    }

    async getDBRequests_ByType_Async(requestName, actionName, 
            transactionId = null) {
        js0.args(arguments, 'string', 'string', [ 'int', js0.Null, js0.Default ]);

        let rows = await this.db.query_Select_Async(
                `SELECT Id, RequestName, ActionName, ActionArgs` +
                ` FROM _ABData_DBRequests` +
                ` WHERE RequestName = '${requestName}' AND ActionName = '${actionName}'` +
                ` ORDER BY Id`,
                [ SelectColumnType.Long, SelectColumnType.Int, 
                SelectColumnType.String, SelectColumnType.String, 
                SelectColumnType.String ], transactionId);

        let rows_Parsed = [];
        for (let row of rows) {
            rows_Parsed.push({
                Id: row[0],
                RequestName: row[1],
                ActionName: row[2],
                ActionArgs: JSON.parse(row[3]),
            });
        }

        return rows_Parsed;
    }

    async getDBRequests_ForSync_Async(transactionId = null) {
        js0.args(arguments, [ 'int', js0.Null, js0.Default ]);

        let rows = await this.db.query_Select_Async(
                `SELECT Id, RequestName, ActionName, ActionArgs, SchemeVersion` +
                ` FROM _ABData_DBRequests ORDER BY Id`, 
                [ SelectColumnType.Long, SelectColumnType.String,
                SelectColumnType.String, SelectColumnType.String,
                SelectColumnType.Int ], transactionId);

        for (let row of rows)
            row[3] = JSON.parse(row[3]);

        return rows;
    }

    getRequest(requestName) {
        js0.args(arguments, 'string');

        if (!this.hasRequest(requestName))
            throw new Error(`Request '${requestName}' does not exist.`);

        return this._requests[requestName];
    }

    hasRequest(requestName) {
        js0.args(arguments, 'string');

        return requestName in this._requests;
    }

    async notifyDataClear_Async(args, deviceInfo) {
        js0.args(arguments, js0.RawObject, js0.RawObject);
        
        let result = await webABApi.json_Async(this._apiUri + 
                'notify-data-clear', { 
            args: args,
            deviceInfo: {
                deviceId: deviceInfo.deviceId,
                deviceHash: deviceInfo.deviceHash,
                lastUpdate: deviceInfo.lastUpdate,
                declaredItemIds: deviceInfo.declaredItemIds,
            },
            schemeVersion: this.scheme.version,
        });

        if (!result.isSuccess()) {
            throw new Error('Cannot send data clear notification: ' + 
                result.message);
        }
    }

    async syncDB_Async(args, clearDataFn, transactionId = null) {
        js0.args(arguments, js0.RawObject, [ 'function', js0.Null ], 
                [ 'int', js0.Null, js0.Default ]);

        let localTransaction = false;
        if (transactionId === null) {
            transactionId = await this.db.transaction_Start_Async();
            localTransaction = true;
        }

        let deviceInfo = await NativeDataStore.GetDeviceInfo_Async(this.db, 
                    transactionId);
        let rDBRequests = await this.getDBRequests_ForSync_Async(transactionId);
        let rDeviceDeletedRows = await this.getDeviceDeletedRows_Async(
                transactionId);

        await this.clearDeviceDeletedRows_Async(transactionId);
            
        let response = new Response();

        let dbSync_RequestsTime = 0;
        let dbSync_ServerTime = 0;
        let dbSync_InsertsTime = 0;
        let t1 = (new Date()).getTime();
        let result = await webABApi.json_Async(this._apiUri + 'sync-db', { 
            args: args,
            deviceInfo: {
                deviceId: deviceInfo.deviceId,
                deviceHash: deviceInfo.deviceHash,
                lastUpdate: deviceInfo.lastUpdate,
                declaredItemIds: deviceInfo.declaredItemIds,
            },
            rDBRequests: rDBRequests,
            rDeviceDeletedRows: rDeviceDeletedRows,
            schemeVersion: this.scheme.version,
        });
        dbSync_ServerTime += result.data.timeSpan;
        dbSync_RequestsTime += (new Date()).getTime() - t1;

        if (abData.debug)
            console.log('Debug', result);

        response.info = {
            webResult: result,
        };

        if (!result.isSuccess()) {
            if (abData.debug) {
                console.error('Request error: ' + result.message);
                console.error(result);
            }

            response.type = Response.Types_Error;
            response.errorMessage = result.message;
            if (result.result === webABApi.Result.ErrorResults_CannotParseJSON)
                response.errorMessage += ' -> ' + result.data.data;

            if (localTransaction)
                await this.db.transaction_Finish_Async(false, transactionId);

            return response;
        }

        response.parseRawObject(result.data.response);

        if (response.type !== Response.Types_Success) {
            if (abData.debug) {
                console.error('Request error: ' + response.message);
                console.error(response);
            }

            if (localTransaction)
                await this.db.transaction_Finish_Async(false, transactionId);

            return response;
        }

        /* Clear Data If Requested */
        if (result.data.clearData) {
            if (clearDataFn === null) {
                throw new Error(
                        'Clear data requested, but clearDataFn not provided.');
            }
            
            try {
                await clearDataFn(transactionId);
                await this.notifyDataClear_Async(args, deviceInfo);
            } catch (e) {
                console.error(e);

                response.type = Response.Types_Error;
                response.errorMessage = 'Cannot clear data from request -> ' + 
                        e.message;
                if (localTransaction)
                    await this.db.transaction_Finish_Async(false, transactionId);

                return response;
            }
        }

        /* Process Update Data - Deletes */
        try {
            let rDeviceDeletedRows_New = [];

            for (let tableId in result.data.updateData.delete) {
                if (!this.scheme.hasTable_ById(parseInt(tableId)))
                    continue;

                await this.scheme.getTable_ById(parseInt(tableId)).delete_Async(this.db, {
                    where: [
                        [ '_Id', 'IN', result.data.updateData.delete[tableId] ],
                    ],
                }, transactionId);

                for (let rowId of result.data.updateData.delete[parseInt(tableId)]) {
                    rDeviceDeletedRows_New.push({
                        TableId: parseInt(tableId),
                        RowId: rowId,
                    });
                }
            }

            await this.addDeviceDeletedRows_Async(rDeviceDeletedRows_New, 
                    transactionId);
        } catch (e) {
            if (abData.debug)
                console.error(e);

            response.type = Response.Types_Error;
            response.errorMessage = 'Cannot process update data deletes: ' + 
                    e.message;

            if (localTransaction)
                await this.db.transaction_Finish_Async(false, transactionId);

            return response;
        }

        /* Clear DB Requests */
        try {
            let dbRequestIds = [];
            for (let rDBRequest of rDBRequests)
                dbRequestIds.push(rDBRequest[0]);

            await this.deleteDBRequests_ByIds_Async(dbRequestIds, transactionId);

            this.device.update(result.data.deviceInfo.lastUpdate,
                    result.data.deviceInfo.lastItemId);

            await NativeDataStore.SetDeviceInfo_Async(this.db, this.device.id, 
                    this.device.hash, this.device.lastItemId, 
                    this.device.lastUpdate, [], transactionId);
        } catch (e) {
            if (abData.debug)
                console.error(e);

            response.type = Response.Types_Error;
            response.errorMessage = 'Cannot clear database requests.' + 
                    e.message;

            if (localTransaction)
                await this.db.transaction_Finish_Async(false, transactionId);

            return response;
        }

        /* Process Update Data - Updates */
        t1 = (new Date()).getTime();
        try {
            for (let tableName in result.data.updateData.update) {
                if (!this.scheme.hasTable(tableName))
                    continue;

                let update_TableColumns = result.data.updateData
                        .update_ColumnNames[tableName];
                let update_Rows = result.data.updateData
                        .update[tableName];

                await this.scheme.getTable(tableName).insert_NoAssoc_Async(
                        this.db, update_Rows, update_TableColumns, 
                        transactionId, false, deviceInfo.lastUpdate !== null);

                /* Assoc */
                // if (deviceInfo.lastUpdate === null) {
                //     await this.scheme.getTable(tableName).insert_Async(this.db,
                //             result.data.updateData.update[tableName], 
                //             transactionId);
                // } else {
                //     await this.scheme.getTable(tableName).update_Async(this.db,
                //             result.data.updateData.update[tableName], 
                //             transactionId);
                // }
                /* / Assoc */
            }
        } catch (e) {
            if (abData.debug)
                console.error(e);

            response.type = Response.Types_Error;
            response.errorMessage = 'Cannot process update data updates: ' + 
                    e.message;

            if (localTransaction)
                await this.db.transaction_Finish_Async(false, transactionId);

            return response;
        }
        dbSync_InsertsTime = (new Date()).getTime() - t1;

        /* Get update data from data infos */
        let dataInfos = result.data.dataInfos;
        let dataInfos_RequestsTime = 0;
        let dataInfos_RequestsCount = 0;
        let dataInfos_InsertsTime = 0;
        let dataInfos_ServerTime = 0;
        let dataInfos_InsertsCount = 0;
        while (dataInfos.length > 0) {
            let t1 = (new Date()).getTime();
            let result_DataInfos = await webABApi.json_Async(this._apiUri + 
                    'sync-db_get-update-data', { 
                args: args,
                deviceInfo: {
                    deviceId: deviceInfo.deviceId,
                    deviceHash: deviceInfo.deviceHash,
                    lastUpdate: deviceInfo.lastUpdate,
                    declaredItemIds: deviceInfo.declaredItemIds,
                },
                dataInfos: dataInfos,
                schemeVersion: this.scheme.version,
            });
            dataInfos_ServerTime += result_DataInfos.data.timeSpan;
            dataInfos_RequestsTime += (new Date()).getTime() - t1;
            dataInfos_RequestsCount++;

            if (abData.debug)
                console.log('Debug', result_DataInfos);

            if (!result_DataInfos.isSuccess()) {
                if (abData.debug) {
                    console.error('Request error: ' + result_DataInfos.message);
                    console.error(result_DataInfos);
                }
    
                response.type = Response.Types_Error;
                response.errorMessage = result_DataInfos.message;

                if (localTransaction)
                    await this.db.transaction_Finish_Async(false, transactionId);
    
                return response;
            }

            try {
                for (let tableName in result_DataInfos.data.updateData.update) {
                    if (!this.scheme.hasTable(tableName))
                        continue;

                    let update_ColumnNames = result_DataInfos.data.updateData
                            .update_ColumnNames[tableName];
                    let update_Rows = result_DataInfos
                            .data.updateData.update[tableName];

                    await this.scheme.getTable(tableName).insert_NoAssoc_Async(
                            this.db, update_Rows, update_ColumnNames,
                            transactionId, false, deviceInfo.lastUpdate !== null);

                    dataInfos_InsertsTime += (new Date()).getTime() - t1;
                    dataInfos_InsertsCount++;

                    /* Assoc */
                    // if (deviceInfo.lastUpdate === null) {
                    //     await this.scheme.getTable(tableName).insert_Async(this.db,
                    //         result_DataInfos.data.updateData.update[tableName], 
                    //         transactionId);
                    // } else {
                    //     await this.scheme.getTable(tableName).update_Async(this.db,
                    //             result_DataInfos.data.updateData.update[tableName], 
                    //             transactionId);
                    // }
                    /* / Assoc */
                }
            } catch (e) {
                if (abData.debug)
                    console.error(e);
    
                response.type = Response.Types_Error;
                response.errorMessage = 'Cannot process update data updates: ' + 
                        e.message;
    
                if (localTransaction)
                    await this.db.transaction_Finish_Async(false, transactionId);
    
                return response;
            }

            dataInfos = result_DataInfos.data.dataInfos;
        }

        console.log('DBSync RequestTime', Math.round((dbSync_RequestsTime
                - dbSync_ServerTime) / 1000.0));
        console.log('DBSync ServerTime', Math.round(dbSync_ServerTime / 1000.0));
        console.log('DBSync InsertsTime', Math.round(dbSync_InsertsTime / 1000.0));

        console.log('DataInfos RequestsTime', Math.round((dataInfos_RequestsTime
                - dataInfos_ServerTime) / 1000.0));
        console.log('DataInfos_RequestsCount', dataInfos_RequestsCount);
        console.log('DataInfos ServerTime', Math.round(dataInfos_ServerTime / 1000.0));
        console.log('DataInfos InsertsTime', Math.round(dataInfos_InsertsTime / 1000.0));
        console.log('DataInfos_InsertsCount', dataInfos_InsertsCount);

        /* Process listeners */
        try {
            for (let listener of this._listeners_OnDBSync) {
                if (!(await listener(result, transactionId))) {
                    response.type = Response.Types_Error;
                    response.errorMessage = 'DB Sync listener failure.';

                    if (localTransaction) {
                        await this.db.transaction_Finish_Async(false, 
                                transactionId);
                    }

                    return response;
                }
            }
        } catch (e) {
            if (abData.debug)
                console.error(e);

            response.type = Response.Types_Error;
            response.errorMessage = 'Cannot process db sync listeners: ' + 
                    e.message;

            if (localTransaction)
                await this.db.transaction_Finish_Async(false, transactionId);

            return response;
        }

        if (localTransaction)
            await this.db.transaction_Finish_Async(true, transactionId);

        return response;
    }

    async updateDBRequest_Async(requestId, requestName, actionName, actionArgs,
            transactionId = null) {
        js0.args(arguments, [ 'number', js0.Null ], 'string', 'string', 
                js0.RawObject, [ 'int', js0.Null, js0.Default ]);

        if (requestId === null) { 
            await this.addDBRequest_Async(requestName, actionName, actionArgs, 
                    transactionId);
            return;
        }

        let localTransaction = false;
        if (transactionId === null) {
            transactionId = await db.transaction_Start_Async();
            localTransaction = true;
        }

        let rows = await this.db.query_Select_Async('SELECT Id FROM _ABData_DBRequests',
                [ SelectColumnType.Long ], transactionId);
        if (rows.length === 0)
            throw new Error(`DB Request with id '${requestId}' does not exist.`);

        let query = `UPDATE _ABData_DBRequests SET `;
        query += `RequestName = '${requestName}', `;        
        query += `ActionName = '${actionName}', `;
        query += `ActionArgs = '` + Database.EscapeString(JSON.stringify(actionArgs)) + `', `;
        query += `SchemeVersion = ${this.scheme.version}`;

        query += ` WHERE Id = ${requestId}`;

        await this.db.query_Execute_Async(query, transactionId);

        if (localTransaction)
            await this.db.transaction_Finish_Async(true, transactionId);
    }

    // async updateDeviceInfo_Async()
    // {
    //     js0.args(arguments);

    //     let localTransaction = await db.transaction_StartLocal_Async();

    //     let lastDeclaredItemId = this.device.lastItemId;
    //     // for (let itemId_Declared of this.device.declaredItemIds) {
    //     //     if (itemId_Declared > lastDeclaredItemId)
    //     //         lastDeclaredItemId = itemId_Declared;
    //     // }

    //     let deviceInfo = await this.getDeviceInfo_Async();
    //     if (deviceInfo === null) {
    //         if (localTransaction)
    //             await this.db.transaction_Finish_Async(false);
                
    //         return;
    //     }

    //     let declaredItemIds = deviceInfo.declaredItemIds;
    //     for (let itemId of this.device.declaredItemIds) {
    //         if (!declaredItemIds.includes(itemId))
    //             declaredItemIds.push(itemId);
    //     }

    //     await this.setDeviceInfo_Async( 
    //             device.id, device.hash, lastDeclaredItemId, 
    //             device.lastUpdate, declaredItemIds);

    //     if (localTransaction)
    //         await this.db.transaction_Finish_Async(true);
    // }


    async _syncDB_GetUpdateData_Async(args, transactionId = null) {

    }

}
module.exports = NativeDataStore;





 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\ab-data\native\TableRequest.js
jsLibs.exportModule('ab-data', 'native/TableRequest', (require, module, exports) => { 'use strict';

const
    abData = require('ab-data'),
    js0 = require('js0'),

    TableRequestDef = require('../scheme/TableRequestDef'),

    Request = require('./Request')
;

class TableRequest extends Request
{

    static async Delete_Async(device, db, table, args, transactionId = null) {
        js0.args(arguments, require('./NativeDevice'), require('./Database'), 
                require('../Table'), js0.RawObject, [ 'int', js0.Null, 
                js0.Default ]);
        js0.typeE(args, js0.Preset(TableRequestDef.Args_Select()));

        await table.delete_Async(db, args, transactionId);
    }

    static async Update_Async(device, db, table, rows, transactionId = null) {
        js0.args(arguments, require('./NativeDevice'), require('./Database'), 
                require('../Table'), Array, [ 'int', js0.Null, js0.Default ]);

        for (let row of rows) {
            if (!('_Id' in row))
                continue;

            row['_Modified_DateTime'] = null;

            if (device.isNewId(row._Id))
                device.useId(row._Id);
        }

        await table.update_Async(db, rows, transactionId);
    }


    constructor(db, table) {
        js0.args(arguments, require('./Database'), require('../Table'));
        super();

        this._db = db;
        this._table = table;

        this.setA('delete', async (args) => {
            return await this._action_Delete_Async(args);
        });
        this.setA('row', async (args) => {
            return await this._action_Row_Async(args);
        });
        this.setA('select', async (args) => {
            return this._action_Select_Async(args);
        });
        this.setA('set', async (args) => {
            return await this._action_Set_Async(args);
        });
        this.setA('update', async (args) => {
            return await this._action_Update_Async(args);
        });
    }

    async _action_Delete_Async(args) {
        let result = {
            success: (await this._table.delete_Async(this._db, {
                where: args.where,
            })).success,
            error: null,
        };  

        if (!result.success) {
            result.error = spocky.Debug ?
                    this._db.getError() :
                    'Cannot delete rows.';
        }

        return result;
    }

    async _action_Row_Async(args) {
        js0.args(arguments, js0.Preset({
            columns: null,
            limit: [ js0.Null, js0.PresetArray([ 'int', 'int' ]), js0.Default(null) ],
            where: [ Array, js0.Default([]) ],
        }));

        args.limit = [ 0, 1 ];

        let result = await this._table.select_Async(this._db, args);

        let row = null;
        if (result.rows !== null) {
            if (result.rows.length > 0)
                row = result.rows[0];
        }

        return {
            success: result.error === null,
            row: row,
            error: result.error,
        };
    }

    async _action_Select_Async(args) {
        js0.args(arguments, js0.Preset(TableRequestDef.Args_Select()));

        let result = await this._table.select_Async(this._db, args);

        return {
            success: result.error === null,
            rows: result.rows,
            error: result.error,
        };
    }

    async _action_Update_Async(args) {
        if (args.rows.length === 0) {
            return {
                success: true,
                error: null,
            };
        }

        let pk = this._table.primaryKey;

        let columnNames = [];
        let row_0 = args.rows[0];
        for (let columnName in row_0)
            columnNames.push(columnName);

        if (!(columnNames.includes(pk)))
            throw new Error(`No Primary Key '${pk}' column.`);

        let rows = [];
        for (let i = 0; i < args.rows.length; i++) {
            let row = args.rows[i];
            if (Object.keys(row).length !== columnNames.length)
                throw new Error(`Columns inconsistency with first row in row '${i}'.`);

            for (let i = 0; i < columnNames.length; i++) {
                if (!(columnNames[i] in row)) {
                    throw new Error(`Column inconsistency with first row.` +
                            ` No column '${columnNames[i]}' in row '${i}'.`)
                };
            }

            if (this._table._columns.has('_Modified_DateTime'))
                row._Modified_DateTime = null;

            rows.push(row);
        }

        let update_Result = await this._table.update_Async(this._db, rows);

        let result = {
            success: update_Result.success,
            error: abData.debug ?
                    update_Result.error :
                    null,
        };

        return result;
    }

}
module.exports = TableRequest;





 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\ab-data\native\Request.js
jsLibs.exportModule('ab-data', 'native/Request', (require, module, exports) => { 'use strict';

const
    js0 = require('js0')
;

class Request
{

    constructor() {
        this._actions = {};
    }

    async executeAction_Async(device, actionName, actionArgs, transactionId) {
        js0.args(arguments, require('../Device'), 'string', js0.RawObject,
                [ 'int', js0.Null ]);

        if (!(actionName in this._actions))
            throw new Error(`Action '${actionName}' does not exists.`);

        let actionInfo = this._actions[actionName];
        if (actionInfo.type === 'w') {
            throw new Error('Test');
        }

        return await this._actions[actionName]['fn'](device, actionArgs, 
                transactionId);
    }

    setA(actionName, actionFn) {
        this.setAction(actionName, actionFn);
    }

    setAction(actionName, actionFn) {
        js0.args(arguments, 'string', 'function');

        if (actionName in this._actions)
            throw new Error(`Action '${actionName}' already exists.`);

        this._actions[actionName] = {
            fn: actionFn,
        };
    }

}
module.exports = Request;





 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\ab-data\native\NativeDevice.js
jsLibs.exportModule('ab-data', 'native/NativeDevice', (require, module, exports) => { 'use strict';

const
    js0 = require('js0'),

    Device = require('../Device')
;

class NativeDevice extends Device
{

    constructor(deviceId, deviceHash, lastUpdate, lastItemId, declaredItemIds = []) {
        super(deviceId, deviceHash, lastUpdate, lastItemId, declaredItemIds);

        this._itemIds_Used = [];
    }

    isNewId(id) {
        js0.args(arguments, 'number');

        if (super.isNewId(id)) {
            let idInfo = Device.GetIdInfo(id);
            return !this._itemIds_Used.includes(idInfo['itemId']);
        }

        return false;
    }

    useId(id) {
        js0.args(arguments, js0.Long);

        let idInfo = Device.GetIdInfo(id);

        if (!this._isNewId_Device(idInfo))
            throw new Error(`'_Id' '${id}' is not a new id.`);

        this._itemIds_Used.push(idInfo['itemId']);
    }

}
module.exports = NativeDevice;





 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\ab-data\native\Wrapper.js
jsLibs.exportModule('ab-data', 'native/Wrapper', (require, module, exports) => { 'use strict';

const
    js0 = require('js0')
;

class Wrapper
{

    constructor(dataStore, db) {
        js0.args(arguments, require('../DataStore'), require('./Database'));

        this.dataStore = dataStore;
        this.db = db;

        let nad = new abNative.ActionsSetDef()
            .addWeb('Table_Delete', {
                tableName: 'string',
                where: Array,
                transactionId: [ 'int', js0.Null ],
            }, {
                error: [ js0.Null, 'string' ],
            }, async (args) => {
                if (!this.db.initialized)
                    await this.db.init_Async();
                
                try {
                    let table = this.dataStore.getTable(args.tableName);
                    await table.delete_Async(this.dataStore.db, 
                            { where: args.where }, args.transactionId);

                    return {
                        error: null,
                    };
                } catch (e) {
                    console.error('ABData Wrapper', e);

                    return {
                        error: e.message,
                    }
                }
            })
            .addWeb('Table_Select', {
                tableName: 'string',
                args: js0.RawObject,
                transactionId: [ 'int', js0.Null ],
            }, {
                rows: [ js0.Null, Array ],
                error: [ js0.Null, 'string' ],
            }, async (args) => {
                if (!this.db.initialized)
                    await this.db.init_Async();
                
                try {
                    let table = this.dataStore.getTable(args.tableName);
                    let rows = await table.select_Async(this.dataStore.db,
                            args.args, args.transactionId);

                    return {
                        rows: rows,
                        error: null,
                    };
                } catch (e) {
                    console.error('ABData Wrapper', e);

                    return {
                        rows: null,
                        error: e.message,
                    }
                }
            })
            .addWeb('Table_Update', {
                tableName: 'string',
                rows: js0.ArrayItems(js0.RawObject),
                transactionId: [ 'int', js0.Null ],
            }, {
                error: [ js0.Null, 'string' ],
            }, async (args) => {
                if (!this.db.initialized)
                    await this.db.init_Async();
                
                try {
                    let table = this.dataStore.getTable(args.tableName);
                    await table.update_Async(this.dataStore.db, args.rows, 
                            args.transactionId);

                    return {
                        error: null,
                    };
                } catch (e) {
                    console.error('ABData Wrapper', e);

                    return {
                        error: e.message,
                    }
                }
            });
        
        this.nativeActions = abNative.addActionsSet('ABData', nad);
    }

}

module.exports = Wrapper;
exports = module.exports;




 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\ab-data\native\index.js
jsLibs.exportModule('ab-data', 'native/index', (require, module, exports) => { 'use strict';

module.exports.Database = require('./Database');
module.exports.NativeDataStore = require('./NativeDataStore');
module.exports.NativeDevice = require('./NativeDevice');
module.exports.Request = require('./Request');
module.exports.TableRequest = require('./TableRequest');
module.exports.Wrapper = require('./Wrapper');





 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\ab-data\fields\ABDAutoIncrementId.js
jsLibs.exportModule('ab-data', 'fields/ABDAutoIncrementId', (require, module, exports) => { 'use strict';

const 
    js0 = require('js0'),

    ABDField = require('./ABDField'),

    ABDIntValidator = require('../validators/ABDIntValidator'),
    SelectColumnType = require('../SelectColumnType')
;


class ABDAutoIncrementId extends ABDField
{

    constructor(properties = {}) {
        js0.args(arguments, [ js0.RawObject, js0.Default ]);
        super([], properties);
    }

    getSelectType() {
        return SelectColumnType.Int;
    }

    getType() {
        return 'AutoIncrementId';
    }


    __getDefaultValue() {
        return 0;
    }

    __getFieldValidator(fieldValidatorInfo) {
        return new ABDIntValidator(fieldValidatorInfo);
    }

    __escape(value) {
        js0.args(arguments, 'number');

        return String(Math.round(value));
    }

    __parse(value) {
        js0.args(arguments, 'number');

        return Math.round(value);
    }

    __unescape(value) {
        js0.args(arguments, null);
            
        return parseInt(value);
    }

}
module.exports = ABDAutoIncrementId;






 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\ab-data\fields\ABDBool.js
jsLibs.exportModule('ab-data', 'fields/ABDBool', (require, module, exports) => { 'use strict';

const 
    js0 = require('js0'),
    
    ABDField = require('./ABDField'),

    ABDBoolValidator = require('../validators/ABDBoolValidator'),
    SelectColumnType = require('../SelectColumnType')
;


class ABDBool extends ABDField
{

    constructor(properties) {
        super([], properties);
    }

    getSelectType() {
        return SelectColumnType.Bool;
    }

    getType() {
        return 'Bool';
    }


    __getDefaultValue() {
        return false;
    }

    __getFieldValidator(fieldValidatorInfo) {
        return new ABDBoolValidator(fieldValidatorInfo);
    }

    __getValidatorType() {
        return 'bool';
    }

    __escape(value) {
        js0.args(arguments, 'boolean');

        if (this.__parse(value))
            return '1';

        return '0';
    }

    __parse(value) {
        js0.args(arguments, 'boolean');

        if (value)
            return true;

        return false;
    }

    __unescape(value) {
        js0.args(arguments, 'boolean');

        return value ? true : false;
    }

}
module.exports = ABDBool;






 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\ab-data\fields\ABDData.js
jsLibs.exportModule('ab-data', 'fields/ABDData', (require, module, exports) => { 'use strict';

const ABDField = require('./ABDField');


class ABDData extends ABDField
{

    constructor(properties) {
        super([], properties);
    }

}
module.exports = ABDData;






 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\ab-data\fields\ABDArray.js
jsLibs.exportModule('ab-data', 'fields/ABDArray', (require, module, exports) => { 'use strict';

const 
    js0 = require('js0'),

    ABDField = require('./ABDField')
;


class ABDArray extends ABDField {

    constructor(properties) {
        super([], properties);
    }

    
    __parse(value) {
        js0.args(arguments, Array);

        return value;
    }

}
module.exports = ABDArray;






 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\ab-data\fields\ABDField.js
jsLibs.exportModule('ab-data', 'fields/ABDField', (require, module, exports) => { 'use strict';

const
    js0 = require('js0')
;

class ABDField
{

    get args() {
        return this._args;
    }

    get defaultValue() {
        return this._properties.defaultValue === js0.NotSet ? 
                (this._properties.notNull ? this.__getDefaultValue() : null) :
                this._properties.defaultValue;
    }

    get properties() {
        return this._properties;
    }


    constructor(args, properties) {
        js0.args(arguments, Array, js0.RawObject);
        js0.typeE(properties, js0.Preset({
            notNull: [ 'boolean', js0.Default(false) ],
            defaultValue: [ null, js0.Default(js0.NotSet) ],
        }));

        this._args = args;
        this._properties = properties;
    }

    escape(value) {
        js0.args(arguments, null);

        if (value === null)
            return 'NULL';

        return js0.rtn('string', this.__escape(value));
    }

    escapeArray(arr) {
        js0.args(arguments, Array);

        let arr_Escaped = [];
        for (let val of arr)
            arr_Escaped.push(this.escape(val));

        return '(' + arr_Escaped.join(',') + ')';
    }

    getFieldValidator(fieldValidatorInfo) {
        js0.args(arguments, js0.RawObject);

        if (!('notNull' in fieldValidatorInfo))
            fieldValidatorInfo['notNull'] = this.properties['notNull'];

        return js0.rtn(require('../validators/ABDFieldValidator'),
                this.__getFieldValidator(fieldValidatorInfo));
    }

    parse(value) {
        if (value === null)
            return null;

        return this.__parse(value);
    }

    unescape(value) {
        if (value === null)
            return null;

        return this.__unescape(value);
    }


    __unescape(value) { 
        return value;
    }


    getSelectType() { js0.virtual(this); }
    // getType() { js0.virtual(this); }

    __getDefaultValue() { js0.virtual(this); }
    __getFieldValidator(fieldValidatorInfo) { js0.virtual(this); }
    __escape(value) { js0.virtual(this); }
    __parse(value) { js0.virtual(this); }

}
module.exports = ABDField;






 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\ab-data\fields\ABDFloat.js
jsLibs.exportModule('ab-data', 'fields/ABDFloat', (require, module, exports) => { 'use strict';

const 
    js0 = require('js0'),
    
    ABDField = require('./ABDField'),

    ABDFloatValidator = require('../validators/ABDFloatValidator'),
    SelectColumnType = require('../SelectColumnType')
;

class ABDFloat extends ABDField
{

    constructor(properties) {
        super([], properties);
    }

    getSelectType() {
        return SelectColumnType.Float;
    }

    getType() {
        return 'Float';
    }


    __getFieldValidator(fieldValidatorInfo) {
        return new ABDFloatValidator(fieldValidatorInfo);
    }

    __escape(value) {
        js0.args(arguments, 'number');

        return String(this.__parse(value));
    }

    __parse(value) {
        js0.args(arguments, 'number');

        return value;
    }

    __unescape(value) {
        return parseFloat(value);
    }

}
module.exports = ABDFloat;





 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\ab-data\fields\ABDJSON.js
jsLibs.exportModule('ab-data', 'fields/ABDJSON', (require, module, exports) => { 'use strict';

const 
    js0 = require('js0'),
    
    ABDField = require('./ABDField'),

    ABDJSONValidator = require('../validators/ABDJSONValidator'),
    SelectColumnType = require('../SelectColumnType'),

    helper = require('../helper')
;

class ABDJSON extends ABDField
{

    get size() {
        return this._size;
    }

    constructor(properties = {}) {
        js0.args(arguments, [ js0.RawObject, js0.Default ]);
        super([], properties);
    }

    getSelectType() {
        return SelectColumnType.JSON;
    }

    getType() {
        return 'JSON';
    }


    __getDefaultValue() {
        return null;
    }

    __getFieldValidator(fieldValidatorInfo) {
        return new ABDJSONValidator(fieldValidatorInfo);
    }

    __escape(value) {
        js0.args(arguments, js0.RawObject);

        return `'` + this.__parse(value) + `'`;
    }

    __parse(value) {
        js0.args(arguments, js0.RawObject);

        let jsonValue = value.value;

        return helper.escapeString(JSON.stringify({ value: jsonValue, }));
    }

    __unescape(value) {
        return value;
    }

}
module.exports = ABDJSON;





 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\ab-data\fields\ABDId.js
jsLibs.exportModule('ab-data', 'fields/ABDId', (require, module, exports) => { 'use strict';

const 
    js0 = require('js0'),

    ABDField = require('./ABDField'),

    ABDLongValidator = require('../validators/ABDLongValidator'),
    SelectColumnType = require('../SelectColumnType')
;

class ABDId extends ABDField
{

    constructor(properties = {}) {
        js0.args(arguments, [ js0.RawObject, js0.Default ]);
        super([], properties);
    }
    
    getSelectType() {
        return SelectColumnType.Long;
    }

    getType() {
        return 'Id';
    }


    __getDefaultValue() {
        return 0;
    }

    __getFieldValidator(fieldValidatorInfo) {
        return new ABDLongValidator(fieldValidatorInfo);
    }

    __escape(value) {
        js0.args(arguments, js0.Long);

        return String(this.__parse(value));
    }

    __parse(value) {
        js0.args(arguments, js0.Long);

        return value;
    }

    __unescape(value) {
        return Number(value);
    }

}
module.exports = ABDId;






 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\ab-data\fields\ABDObject.js
jsLibs.exportModule('ab-data', 'fields/ABDObject', (require, module, exports) => { 'use strict';

const js0 = require('js0');

const ABDField = require('./ABDField');
const ABDLong = require('./ABDLong');


class ABDObject extends ABDField
{

    get fields() {
        return this._fields;
    }

    get name() {
        return this._name;
    }

    get objectStructs() {
        return this._objectStructs;
    }

    constructor(properties = {}) {
        super([], properties);

        this._initialized = false;
        this._name = null;

        this._fields = new js0.List();
        this._objectStructs = new js0.List();
    }

    addObjectStruct(objectStructName, objectField) {
        this._objectStructs.set(objectStructName, objectField);
    }

    initialize(name) {
        if (this._initialized)
            return;
        this._initialized = true;

        this._name = name;

        let fields = this.properties.$;
        fields.Id = new ABDLong();
        
        for (let fieldName in fields) {
            let field = fields[fieldName];

            if (!(field instanceof ABDField))
                throw new Error(`Object fields must be instancec of 'ABDField'.`);

            this._fields.set(fieldName, field);
        }
    }

    // setName(name)
    // {
    //     this._name = name;
    // }

}
module.exports = ABDObject;






 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\ab-data\fields\ABDLong.js
jsLibs.exportModule('ab-data', 'fields/ABDLong', (require, module, exports) => { 'use strict';

const 
    js0 = require('js0'),
    
    ABDField = require('./ABDField'),

    ABDLongValidator = require('../validators/ABDLongValidator'),
    SelectColumnType = require('../SelectColumnType')
;

class ABDLong extends ABDField
{

    constructor(properties = {}) {
        js0.args(arguments, [ js0.RawObject, js0.Default ]);
        super([], properties);
    }

    getSelectType() {
        return SelectColumnType.Long;
    }

    getType() {
        return 'Long';
    }


    __getDefaultValue() {
        return 0;
    }

    __getFieldValidator(fieldValidatorInfo) {
        return new ABDLongValidator(fieldValidatorInfo);
    }

    __escape(value) {
        js0.args(arguments, js0.Long);

        return String(value);
    }

    __parse(value) {
        js0.args(arguments, js0.Long);

        return value;
    }

    __unescape(value) {
        return Number(value);
    }

}
module.exports = ABDLong;






 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\ab-data\fields\ABDInt.js
jsLibs.exportModule('ab-data', 'fields/ABDInt', (require, module, exports) => { 'use strict';

const 
    js0 = require('js0'),

    ABDField = require('./ABDField'),

    ABDIntValidator = require('../validators/ABDIntValidator'),
    SelectColumnType = require('../SelectColumnType')
;


class ABDInt extends ABDField
{

    constructor(properties = {}) {
        js0.args(arguments, [ js0.RawObject, js0.Default ]);
        super([], properties);
    }

    getSelectType() {
        return SelectColumnType.Int;
    }

    getType() {
        return 'Int';
    }


    __getDefaultValue() {
        return 0;
    }

    __getFieldValidator(fieldValidatorInfo) {
        return new ABDIntValidator(fieldValidatorInfo);
    }

    __escape(value) {
        js0.args(arguments, 'number');

        return String(this.__parse(value));
    }

    __parse(value) {
        js0.args(arguments, 'number');

        return Math.round(value);
    }

    __unescape(value) {
        js0.args(arguments, null);
            
        return parseInt(value);
    }

}
module.exports = ABDInt;






 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\ab-data\fields\ABDText.js
jsLibs.exportModule('ab-data', 'fields/ABDText', (require, module, exports) => { 'use strict';

const 
    js0 = require('js0'),
    
    ABDField = require('./ABDField'),

    ABDStringValidator = require('../validators/ABDStringValidator'),
    SelectColumnType = require('../SelectColumnType'),

    helper = require('../helper')
;

class ABDString extends ABDField
{

    get type() {
        return this._type;
    }

    get _typeSizes() {
        return {
            tiny:       256,
            regular:    65535,
            medium:     16777215,
        };
    }

    constructor(type, properties = {}) {
        js0.args(arguments, js0.Enum([ 'tiny', 'regular', 'medium' ]), 
                [ js0.RawObject, js0.Default ]);

        super([ type ], properties);

        this._type = type;
    }

    getSelectType() {
        return SelectColumnType.String;
    }

    getType() {
        return 'Text';
    }


    __getDefaultValue() {
        return '';
    }

    __getFieldValidator(fieldValidatorInfo) {
        if (!('maxLength' in fieldValidatorInfo))
            fieldValidatorInfo['maxLength'] = this._typeSizes[this.type];

        return new ABDStringValidator(fieldValidatorInfo);
    }

    __escape(value) {
        js0.args(arguments, 'string');

        return `'` + this.__parse(value) + `'`;
    }

    __parse(value) {
        js0.args(arguments, 'string');

        return helper.escapeString(value);
    }

    __unescape(value) {
        return value;
    }

}
module.exports = ABDString;






 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\ab-data\fields\ABDTime.js
jsLibs.exportModule('ab-data', 'fields/ABDTime', (require, module, exports) => { 'use strict';

const 
    js0 = require('js0'),
    
    ABDField = require('./ABDField'),

    ABDTimeValidator = require('../validators/ABDTimeValidator'),
    SelectColumnType = require('../SelectColumnType')
;

class ABDTime extends ABDField {

    constructor(properties = {}) {
        js0.args(arguments, [ js0.RawObject, js0.Default ]);
        super([], properties);
    }

    getSelectType() {
        return SelectColumnType.Long;
    }

    getType() {
        return 'Time';
    }


    __getDefaultValue() {
        return 0;
    }

    __getFieldValidator(fieldValidatorInfo) {
        return new ABDTimeValidator(fieldValidatorInfo);
    }

    __escape(value) {
        js0.args(arguments, 'number');

        return String(this.__parse(value));
    }

    __parse(value) {
        js0.args(arguments, 'number');

        return value;
    }

    __unescape(value) {
        return Number(value);
    }

}
module.exports = ABDTime;






 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\ab-data\fields\ABDString.js
jsLibs.exportModule('ab-data', 'fields/ABDString', (require, module, exports) => { 'use strict';

const 
    js0 = require('js0'),
    
    ABDField = require('./ABDField'),

    ABDStringValidator = require('../validators/ABDStringValidator'),
    SelectColumnType = require('../SelectColumnType'),

    helper = require('../helper')
;

class ABDString extends ABDField
{

    get size() {
        return this._size;
    }

    constructor(size, properties = {}) {
        js0.args(arguments, js0.Int, [ js0.RawObject, js0.Default ]);

        super([ size ], properties);

        this._size = size;
    }

    getSelectType() {
        return SelectColumnType.String;
    }

    getType() {
        return 'String';
    }


    __getDefaultValue() {
        return '';
    }

    __getFieldValidator(fieldValidatorInfo) {
        if (!('maxLength' in fieldValidatorInfo))
            fieldValidatorInfo['maxLength'] = this.size;

        return new ABDStringValidator(fieldValidatorInfo);
    }

    __escape(value) {
        js0.args(arguments, 'string');

        return `'` + this.__parse(value) + `'`;
    }

    __parse(value) {
        js0.args(arguments, 'string');

        return helper.escapeString(value);
    }

    __unescape(value) {
        return value;
    }

}
module.exports = ABDString;






 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\ab-data\fields\index.js
jsLibs.exportModule('ab-data', 'fields/index', (require, module, exports) => { 'use strict';

const 
    ABDArray = require('./ABDArray'),
    ABDAutoIncrementId = require('./ABDAutoIncrementId'),
    ABDBool = require('./ABDBool'), 
    ABDData = require('./ABDData'),
    // ABDDate = require('./ABDDate'),
    // ABDDateTime = require('./ABDDateTime'),
    // ABDDouble = require('./ABDDouble'),
    ABDFloat = require('./ABDFloat'),
    ABDId = require('./ABDId'),
    ABDInt = require('./ABDInt'),
    ABDJSON = require('./ABDJSON'),
    ABDLong = require('./ABDLong'),
    // ABDObject = require('./ABDObject'),
    ABDString = require('./ABDString'),
    ABDText = require('./ABDText'),
    ABDTime = require('./ABDTime')
;


class fields_Class
{

    // get ABDArray() { return ABDArray; };
    get ABDAutoIncrementId() { return ABDAutoIncrementId; };
    get ABDBool() { return ABDBool; };
    // get ABDDate() { return ABDDate; }
    // get ABDDateTime() { return ABDDateTime; }
    // get ABDData() { return ABDData; };
    // get ABDDouble() { return ABDDouble; };
    get ABDFloat() { return ABDFloat; };
    get ABDInt() { return ABDInt; };
    get ABDJSON() { return ABDJSON; };
    get ABDLong() { return ABDLong; };
    // get ABDObject() { return ABDObject; };
    get ABDString() { return ABDString; };
    get ABDTime() { return ABDTime; };
    get ABDText() { return ABDText; };


    // Array(properties = {})
    // {
    //     return new ABDArray(properties);
    // }

    AutoIncrementId(properties = {}) {
        return new ABDAutoIncrementId(properties);
    }

    Bool(properties = {})  {
        return new ABDBool(properties);
    }

    // Data(properties = {}) 
    // {
    //     return new ABDData(properties);
    // }

    // Date(properties = {}) 
    // {
    //     return new ABDDate(properties);
    // }

    // DateTime(properties = {}) 
    // {
    //     return new ABDDateTime(properties);
    // }

    // Double(properties = {})
    // {
    //     return new ABDDouble(properties);
    // }

    Float(properties = {}) {
        return new ABDFloat(properties);
    }

    Id(properties = {}) {
        return new ABDId(properties);
    }

    Int(properties = {}) {
        return new ABDInt(properties);
    }

    JSON(properties = {}) {
        return new ABDJSON(properties);
    }

    Long(properties = {}) {
        return new ABDLong(properties);
    }

    // Object(properties = {})
    // {
    //     return new ABDObject(properties);
    // }

    String(size, properties = {}) {
        return new ABDString(size, properties);
    }

    Time(properties = {}) {
        return new ABDTime(properties);
    }

    Text(type, properties = {}) {
        return new ABDText(type, properties);
    }

}
module.exports = new fields_Class();






 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\ab-data\validators\ABDBoolValidator.js
jsLibs.exportModule('ab-data', 'validators/ABDBoolValidator', (require, module, exports) => { 'use strict';

const
    abStrings = require('ab-strings'),
    abText = require('ab-text'),
    js0 = require('js0'),

    ABDFieldValidator = require('./ABDFieldValidator')
;

class ABDBoolValidator extends ABDFieldValidator
{

    constructor(args) {
        js0.args(arguments, js0.RawObject)
        js0.typeE(args, js0.Preset({
            'notNull': [ 'boolean', js0.Default(true) ],
            'required': [ 'boolean', js0.Default(true) ],
        }));

        super(args);
    }

    getType() {
        return 'Bool';
    }


    __validate(validator, fieldName, value) {
        if (!value) {
            if (this.args['required'])
                validator.fieldError(fieldName, abText.$('abData.NotChecked'));
        }
    }

}
module.exports = ABDBoolValidator;





 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\ab-data\validators\ABDEmailValidator.js
jsLibs.exportModule('ab-data', 'validators/ABDEmailValidator', (require, module, exports) => { 'use strict';

const
    abStrings = require('ab-strings'),
    abText = require('ab-text'),
    js0 = require('js0'),

    ABDFieldValidator = require('./ABDFieldValidator')
;

class ABDStringValidator extends ABDFieldValidator
{

    constructor(args) {
        js0.args(arguments, js0.RawObject);
        js0.typeE(args, js0.Preset({
            'notNull': [ 'boolean', js0.Default(true) ],
            'required': [ 'boolean', js0.Default(true) ],
        }));

        super(args);
    }

    getType() {
        return 'Email';
    }


    __validate(validator, fieldName, value) {
        if (value === '') {
            if (this.args['required'])
                validator.fieldError(fieldName, abText.$('abData.NotSet'));

            return;
        } 

        let re = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;
        if (!re.test(String(value).toLowerCase()))
            validator.fieldError(fieldName, abText.$('abData.NotSet'));
    }

}
module.exports = ABDStringValidator;





 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\ab-data\validators\ABDIntValidator.js
jsLibs.exportModule('ab-data', 'validators/ABDIntValidator', (require, module, exports) => { 'use strict';

const
    abStrings = require('ab-strings'),
    abText = require('ab-text'),
    js0 = require('js0'),

    ABDFieldValidator = require('./ABDFieldValidator')
;

class ABDIntValidator extends ABDFieldValidator
{

    constructor(args) {
        js0.args(arguments, js0.RawObject)
        js0.typeE(args, js0.Preset({
            'notNull': [ 'boolean', js0.Default(true) ],
            'required': [ 'boolean', js0.Default(true) ],
            'minValue': [ js0.Int, js0.Null, js0.Default(null) ],
            'maxValue': [ js0.Int, js0.Null, js0.Default(null) ],
        }));

        super(args);
    }

    getType() {
        return 'Int';
    }


    __validate(validator, fieldName, value) {
        if (value === '') {
            if (this.args['required'])
                validator.fieldError(fieldName, abText.$('abData.NotSet'));

            return;
        }

        if (!this.args['required'] && value === '')
            return;

        if (isNaN(value))
            validator.fieldError(fieldName, abText.$('abData.Int_NotANumber'));
        else {
            let number = Number(value);
            if (!Number.isInteger(number))
                validator.fieldError(fieldName, abText.$('abData.Int_NotAnInt'));
            else {
                if (this.args['minValue'] !== null) {
                    if (number < this.args['minValue']) {
                        validator.fieldError(fieldName, abText.$(
                                'abData.Int_BelowMin',  { minValue: this.args['minValue'] }));
                    }
                }

                if (this.args['maxValue']) {
                    if (number > this.args['maxValue']) {
                        validator.fieldError(fieldName, abText.$(
                                'abData.Int_AboveMax', { maxValue: this.args['maxValue'] }));
                    }
                }
            }
        }
    }

}
module.exports = ABDIntValidator;





 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\ab-data\validators\ABDFloatValidator.js
jsLibs.exportModule('ab-data', 'validators/ABDFloatValidator', (require, module, exports) => { 'use strict';

const
    abStrings = require('ab-strings'),
    abText = require('ab-text'),
    js0 = require('js0'),

    ABDFieldValidator = require('./ABDFieldValidator')
;

class ABDFloatValidator extends ABDFieldValidator
{

    constructor(args) {
        js0.args(arguments, js0.RawObject);
        js0.typeE(args, js0.Preset({
            'notNull': [ 'boolean', js0.Default(true) ],
            'required': [ 'boolean', js0.Default(true) ],
            'minValue': [ 'number', js0.Null, js0.Default(null) ],
            'maxValue': [ 'number', js0.Null, js0.Default(null) ],
        }));

        super(args);
    }

    getType() {
        return 'Float';
    }


    __validate(validator, fieldName, value) {
        if (value === '') {
            if (this.args['required'])
                this.fieldError(validator, fieldName, abText.$('abData.NotSet'));

            return;
        }

        if (!this.args['required'] && value === '')
            return;

        if (isNaN(value))
            validator.fieldError(fieldName, abText.$('abData.Int_NotANumber'));
        else {
            let number = Number(value);
            if (this.args['minValue'] !== null) {
                if (number < this.args['minValue']) {
                    validator.fieldError(fieldName, abText.$(
                            'abData.Int_BelowMin',  { minValue: this.args['minValue'] }));
                }
            }

            if (this.args['maxValue']) {
                if (number > this.args['maxValue']) {
                    validator.fieldError(fieldName, abText.$(
                            'abData.Int_AboveMax', { maxValue: this.args['maxValue'] }));
                }
            }
        }
    }

}
module.exports = ABDFloatValidator;





 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\ab-data\validators\ABDFieldValidator.js
jsLibs.exportModule('ab-data', 'validators/ABDFieldValidator', (require, module, exports) => { 'use strict';

const
    abText = require('ab-text'),
    js0 = require('js0')
;

class ABDFieldValidator
{

    get args() {
        return this._args;
    }


    constructor(args) {
        js0.args(arguments, js0.RawObject);

        this._args = args;
    }

    getType() {
        js0.virtual(this);
    }

    validate(validator, fieldName, value) {
        js0.args(arguments, require('../Validator'), 'string', null);

        if (value === null) {
            if (this.args['notNull']) {
                if (this.args['required'])
                    validator.fieldError(fieldName, abText.$('abData.NotSet'));
                else
                    validator.fieldError(fieldName, abText.$('abData.NotNull'));
            }
        } else
            this.__validate(validator, fieldName, value);
    }


    __validate(value) { js0.virtual(this); }

}
module.exports = ABDFieldValidator;





 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\ab-data\validators\ABDLongValidator.js
jsLibs.exportModule('ab-data', 'validators/ABDLongValidator', (require, module, exports) => { 'use strict';

const
    abStrings = require('ab-strings'),
    abText = require('ab-text'),
    js0 = require('js0'),

    ABDFieldValidator = require('./ABDFieldValidator')
;

class ABDLongValidator extends ABDFieldValidator
{

    constructor(args) {
        js0.args(arguments, js0.RawObject);
        js0.typeE(args, js0.Preset({
            'notNull': [ 'boolean', js0.Default(true) ],
            'required': [ 'boolean', js0.Default(true) ],
            'minValue': [ js0.Int, js0.Null, js0.Default(null) ],
            'maxValue': [ js0.Int, js0.Null, js0.Default(null) ],
        }));

        super(args);
    }

    getType() {
        return 'Long';
    }


    __validate(validator, fieldName, value) {
        if (value === '') {
            if (this.args['required'])
                validator.fieldError(fieldName, abText.$('abData.NotSet'));

            return;
        }

        if (!this.args['required'] && value === '')
            return;

        if (isNaN(value))
            validator.fieldError(fieldName, abText.$('abData.Int_NotANumber'));
        else {
            let number = Number(value);            
            if (number % 1 !== 0)
                validator.fieldError(fieldName, abText.$('abData.Int_NotAnInt'));
            else {
                if (this.args['minValue'] !== null) {
                    if (number < this.args['minValue']) {
                        validator.fieldError(fieldName, abText.$(
                                'abData.Int_BelowMin',  { minValue: this.args['minValue'] }));
                    }
                }

                if (this.args['maxValue']) {
                    if (number > this.args['maxValue']) {
                        validator.fieldError(fieldName, abText.$(
                                'abData.Int_AboveMax', { maxValue: this.args['maxValue'] }));
                    }
                }
            }
        }
    }

}
module.exports = ABDLongValidator;





 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\ab-data\validators\ABDJSONValidator.js
jsLibs.exportModule('ab-data', 'validators/ABDJSONValidator', (require, module, exports) => { 'use strict';

const
    abStrings = require('ab-strings'),
    abText = require('ab-text'),
    js0 = require('js0'),

    ABDFieldValidator = require('./ABDFieldValidator')
;

class ABDJSONValidator extends ABDFieldValidator
{

    constructor(args) {
        js0.args(arguments, js0.RawObject);
        js0.typeE(args, js0.Preset({
            'notNull': [ 'boolean', js0.Default(true) ],
        }));

        super(args);
    }

    getType() {
        return 'JSON';
    }


    __validate(validator, fieldName, value) {
        if (!js0.typeE(value, js0.Preset({
            value: null,
                }))) {
            validator.fieldError(fieldName, abText.$(
                    'abData.Errors_WrongJSONFieldFormat'));
        }
    }

}
module.exports = ABDJSONValidator;





 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\ab-data\validators\ABDTimeValidator.js
jsLibs.exportModule('ab-data', 'validators/ABDTimeValidator', (require, module, exports) => { 'use strict';

const
    abStrings = require('ab-strings'),
    abText = require('ab-text'),
    js0 = require('js0'),

    ABDFieldValidator = require('./ABDFieldValidator')
;

class ABDTimeValidator extends ABDFieldValidator
{

    constructor(args) {
        js0.args(arguments, js0.RawObject);
        js0.typeE(args, js0.Preset({
            'notNull': [ 'boolean', js0.Default(true) ],
            'type': [ js0.Enum([ 'dateTime', 'date', 'time' ]), 
                    js0.Default('dateTime') ],
            'required': [ 'boolean', js0.Default(true) ],
            'minTime': [ js0.Long, js0.Null, js0.Default(null) ],
            'maxTime': [ js0.Long, js0.Null, js0.Default(null) ],
        }));

        super(args);
    }

    getType() {
        return 'Time';
    }


    __validate(validator, fieldName, value) {
        if (value === null) {
            if (this.args['required'])
                validator.fieldError(fieldName, abText.$('abData.NotSet'));
            else
                return;
        } else {
            if (isNaN(value)) {
                validator.fieldError(fieldName, abText.$('abData.Date_WrongFormat'));
                return;
            }

            value = Number.parseInt(value);

            if (this.args['minDate'] !== null) {
                if (value < this.args['minDate']) {
                    validator.fieldError(fieldName, abText.$('abData.Date_BelowMinDate',
                            abDate.format_DateTime(abText.$('abData.Date_Format'), 
                            this.args['minDate'])));
                }
            }

            if (this.args['maxDate'] !== null) {
                if (value > this.args['maxDate']) {
                    validator.fieldError(fieldName, abText.$('abData.Date_AboveMaxDate', { 
                        maxDate: abDate.format_DateTime(abText.$(
                                'abData.Format_DateTime'), this.args['maxDate']),
                    }));
                }
            }
        }
    }

}
module.exports = ABDTimeValidator;





 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\ab-data\validators\ABDStringValidator.js
jsLibs.exportModule('ab-data', 'validators/ABDStringValidator', (require, module, exports) => { 'use strict';

const
    abStrings = require('ab-strings'),
    abText = require('ab-text'),
    js0 = require('js0'),

    ABDFieldValidator = require('./ABDFieldValidator')
;

class ABDStringValidator extends ABDFieldValidator
{

    constructor(args) {
        js0.args(arguments, js0.RawObject);
        js0.typeE(args, js0.Preset({
            'notNull': [ 'boolean', js0.Default(true) ],
            'required': [ 'boolean', js0.Default(true) ],
            'minLength': [ js0.Int, js0.Null, js0.Default(null) ],
            'maxLength': [ js0.Int, js0.Null, js0.Default(null) ],
            'regexp': [ js0.PresetArray([ 'string', 'string' ]), js0.Null, 
                    js0.Default(null) ],
            'trim': [ 'boolean', js0.Default(false) ],
            'chars': [ 'string', js0.Default(abStrings.getCharsRegExp_Basic()) ],
        }));

        super(args);
    }

    getType() {
        return 'String';
    }


    __validate(validator, fieldName, value) {
        if (this.args['trim'])
            value = value.trim();

        if (value === '') {
            if (this.args['required'])
                validator.fieldError(fieldName, abText.$('abData.NotSet'));

            return;
        } else {
            if (this.args['minLength'] !== null) {
                if (value.length < this.args['minLength']) {
                    validator.fieldError(fieldName, abText.$(
                            'abData.Errors_BelowMinLength', 
                            { minLength: this.args['minLength'] }));
                }
            }

            if (this.args['maxLength'] !== null) {
                if (this.args['maxLength'] > 0) {
                    if (value.length > this.args['maxLength']) {
                        validator.fieldError(fieldName, abText.$(
                                'abData.Errors_AboveMaxLength', 
                                { maxLength: this.args['maxLength'] }));
                    }
                }
            }

            if (this.args['regexp'] !== null) {
                // regexp = str_replace('#', '\\#', this.args['regexp'][0]);
                let regexp = this.args['regexp'][0];

                if (!(new RegExp(`${regexp}`)).test(value)) {
                    validator.fieldError(fieldName, abText.$('abData.Errors_WrongFormat',
                        { format: this.args['regexp'][1] }));
                }
            }

            if (this.args['chars'] !== null) {
                let chars_Escaped =  this.args['chars']; //abStrings.escapeRegExpChars(this.args['chars']);
                // value = ' hello ';
                // echo '#' . chars . '#' . value . '#';

                if (!(new RegExp(`^[${chars_Escaped}]*$`)).test(value)) {
                    let notAllowedChars = [];
                    let re = new RegExp(`[^${chars_Escaped}]`, 'g');

                    while (true) {
                        let match = re.exec(value);
                        if (!match)
                            break;

                        notAllowedChars.push(match[0]);
                    }

                    let notAllowedChars_Str = notAllowedChars.join(', ');

                    // not_allowed_chars = str_replace('\\\\', '&#92;', not_allowed_chars);
                    // not_allowed_chars = str_replace('\\', '', not_allowed_chars);
                    // not_allowed_chars = str_replace('&#92;', '\\', not_allowed_chars);

                    validator.fieldError(fieldName, abText.$(
                            'abData.Errors_NotAllowedCharacters',
                            { notAllowedChars: notAllowedChars_Str }));
                }
            }
        }
    }

}
module.exports = ABDStringValidator;





 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\ab-data\validators\index.js
jsLibs.exportModule('ab-data', 'validators/index', (require, module, exports) => { 'use strict';

// const 
// ;


class validators_Class
{

    get ABDBoolValidator() { return require('./ABDBoolValidator'); }
    get ABDEmailValidator() { return require('./ABDEmailValidator'); };
    get ABDIntValidator() { return require('./ABDIntValidator'); };    
    get ABDJSONValidator() { return require('./ABDJSONValidator'); };
    get ABDFloatValidator() { return require('./ABDFloatValidator'); };
    get ABDLongValidator() { return require('./ABDLongValidator'); };
    get ABDStringValidator() { return require('./ABDStringValidator'); };


    Bool(args = {}) {
        return new this.ABDBoolValidator(args);
    }

    Email(args = {}) {
        return new this.ABDEmailValidator(args);
    }

    Int(args = {}) {
        return new this.ABDIntValidator(args);
    }

    JSON(args = {}) {
        return new this.ABDJSONValidator(args);
    }

    Float(args = {}) {
        return new this.ABDFloatValidator(args);
    }

    Long(args = {}) {
        return new this.ABDLongValidator(args);
    }

    String(args = {}) {
        return new this.ABDStringValidator(args);
    }

}
module.exports = new validators_Class();






 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\web-ab-api\index.js
jsLibs.exportModule('web-ab-api', 'index', (require, module, exports) => { 'use strict';

const 
    js0 = require('js0'),

    Result = require('./Result')
;


class abApi_Class
{

    get Result() {
        return Result;
    }

    get debug() {
        return this._debug;
    }

    get requestTimeout() {
        return this._requestTimeout;
    }

    constructor() {
        this._debug = false;
        this._requestTimeout = 0;
    }

    json(uri, json, fn, timeout = null)  {
        js0.args(arguments, 'string', js0.RawObject, 'function', 
                [ 'int', js0.Null, js0.Default ]);

        var json_string = JSON.stringify(json);
        if (json_string === null)
            throw new Error('Cannot parse json.');

        this.post(uri, { json: json_string }, fn, timeout);
    }

    async json_Async(uri, json, timeout = null) {
        js0.args(arguments, 'string', js0.RawObject, [ 'int', js0.Null, js0.Default ]);

        return new Promise((resolve, reject) => {
            this.json(uri, json, (result) => {
                resolve(result);
            }, timeout);
        });
    }

    post(uri, fields, fn, timeout = null) {
        js0.args(arguments, 'string', js0.RawObject, 'function', 
                [ 'int', js0.Null, js0.Default ]);

        timeout = timeout === null ? this.requestTimeout : timeout;

        var form_data = new FormData();
        for (var field_name in fields)
            form_data.append(field_name, fields[field_name]);

        var request = new XMLHttpRequest();
        request.open('POST', uri, true);
        request.timeout = timeout;
        request.onerror = (evt) => {
            console.log(evt);
            let result = Result.Error(request, 
                    `Http request error.`, 
                    Result.ErrorResults_Other);
            fn(result);
        };
        request.ontimeout = () => {
            let result = Result.Error(request, 
                   `Http request error: connection timeout`, 
                    Result.ErrorResults_HttpTimeoutError);
            fn(result);
        };
        request.onload = () => {
            if (request.status >= 200 && request.status < 400) {
                var result = Result.Parse(request, request.responseText, uri, 
                        this.debug);

                if (this.debug)
                    console.log('webABApi', uri, fields, result);

                fn(result);
            } else {
                let result = Result.Error(request,
                        `Http request error: ${request.status} -> ` +
                        request.responseText, 
                        Result.ErrorResults_HttpRequestError);
                
                fn(result);
            }
        };
        request.send(form_data);
    }

    setDebug(debug) {
        js0.args(arguments, 'boolean');
        this._debug = debug;
    }

    setRequestTimeout(timeout) {
        js0.args(arguments, 'int');
        this._requestTimeout = timeout;

        console.log(this._requestTimeout);
    }

    upload(uri, json, files, fn, timeout = null) {
        var fields = {};
        for (var file_name in files) {
            if (files[file_name] === null) {
                json[file_name] = null;
            } else {
                fields[file_name] = files[file_name];
            }
        }

        var json_string = JSON.stringify(json);
        if (json_string === null)
            throw new Error('Cannot parse json.');
        fields.json = json_string;

        this.post(uri, fields, fn, timeout);
    }

    async upload_Async(uri, json, files, timeout = null) {
        js0.args(arguments, 'string', js0.RawObject, [ 'int', js0.Null, js0.Default ]);

        return new Promise((resolve, reject) => {
            this.upload(uri, json, files, (result) => {
                resolve(result);
            }, timeout);
        });
    }

}
module.exports = new abApi_Class();





 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\web-ab-api\Result.js
jsLibs.exportModule('web-ab-api', 'Result', (require, module, exports) => { 'use strict';


class Result
{

    static get ErrorResults_Other() {
        return 2;
    }

    static get ErrorResults_HttpRequestError() {
        return 3;
    }

    static get ErrorResults_HttpTimeoutError() {
        return 4;
    }

    static get ErrorResults_CannotParseJSON() {
        return 5;
    }

    static get ErrorResults_WrongResultFormat() {
        return 6;
    }
    

    static Error(request, message, errorResultId = 2) {
        var result = new Result(request);
        result.result = errorResultId;
        result.message = message;
        result.data = {};

        return result;
    }

    static Parse(request, dataString, uri, debug = false) {
        var data = null;
        try {
            data = JSON.parse(dataString);
        } catch (err) {
            // data = null;
        }

        if (data === null) {
            var result = Result.Error(request,
                    'Cannot parse json data from: ' + uri,
                    Result.ErrorResults_CannotParseJSON);
            result.data.data = dataString;

            if (debug)
                console.error(dataString);

            return result;
        }

        if (typeof data !== 'object') {
            var result = Result.Error(request,
                    'Cannot parse json data from: ' + uri,
                    Result.ErrorResults_CannotParseJSON);
            result.data.data = dataString;

            if (debug)
                console.error(dataString);

            return result;
        }

        var result = new Result(request);

        if (!('result' in data)) {
            result.result = Result.ErrorResults_WrongResultFormat;
            result.message = 'No result info in json data.';
        } else {
            result.result = data.result;
            if ('message' in data)
                result.message = data.message;
            result.data = data;
        }

        return result;
    }


    constructor(request) {
        this._request = request;
        this.result = -1;
        this.message = '';
        this.data = null;
    }

    getResult() {
        return this.result;
    }

    isSuccess() {
        return this.result === 0;
    }

    isFailure() {
        return this.result === 1;
    }

    isError() {
        return this.result >= 2;
    }
    
};
module.exports = Result;





 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\js0\Delay.js
jsLibs.exportModule('js0', 'Delay', (require, module, exports) => { 'use strict';

const
    js0 = require('.')
;

class Delay
{

    constructor() {
        this._delays = [];
    }

    delay(identification, alias, fn, time) {
        js0.args(arguments, null, 'string', 'function');

        let delay = this._getDelay(identification, alias);
        if (delay === null) {
            delay = {
                identificator: identificator,
                alias: alias,
                timeout: null,
            };
        } else
            clearTimeout(delay.timeout);

        delay.timeout = setTimeout(() => {
            fn();
            this._removeDelay(identificator, alias);
        }, time);
    }


    _getDelay(identificator, alias) {
        for (let delay of this._delays) {
            if (delay.identificator !== identificator)
                continue;
            if (delay.alias !== alias)
                continue;

            return delay;
        }

        return null;
    }

    _removeDelay(identificator, alias) {
        for (let i = 0; i < this._delays.length; i++) {
            let delay = this._delays[i];
            if (delay.identificator !== identificator)
                continue;
            if (delay.alias !== alias)
                continue;

            this._delays.splice(i, 1);
            return;
        }
    }

}
module.exports = Delay;





 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\js0\Info.js
jsLibs.exportModule('js0', 'Info', (require, module, exports) => { // 'use strict';

// let js0 = require('.');


// class Info
// {

//     construct(class_object)
//     {
//         this._object = class_object;

//         this._abstractClassInterfaces = [];

//         this._implemented = [];
//     }

//     abstract(class_object, interface_class)
//     {
//         js0.args(arguments, 'object', js0.Interface);

//         this._abstractClassInterfaces.push(interface_class);
//     }

//     implements(class_objects)
//     {

//     }

// }
// module.exports = Info;






 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\js0\TimeSpan.js
jsLibs.exportModule('js0', 'TimeSpan', (require, module, exports) => { 'use strict';

class TimeSpan
{

    static GetInstance(instanceAlias) {
        if (!(instanceAlias in TimeSpan.Instances))
            throw new Error(`TimeSpan instance '${instanceAlias}' does not exist.`);

        return TimeSpan.Instances[instanceAlias];
    }

    static MarkStart(instanceAlias, markAlias) {
        if (!(instanceAlias in TimeSpan.Instances))
            TimeSpan.Instances[instanceAlias] = new TimeSpan();
        let instance = TimeSpan.Instances[instanceAlias];

        return instance.markStart(markAlias);
    }


    constructor() {
        this._start = (new Date()).getTime();
        this._marks = [];
    }

    getDiffs() {
        let diffs = [];
        for (let mark of this._marks) {
            diffs.push([ mark.alias, mark.timeEnd === null ? null : 
                    mark.timeEnd - mark.timeStart ]);
        }

        return diffs;
    }

    markStart(markAlias) {
        this._marks.push({
            alias: markAlias,
            timeStart: (new Date()).getTime(),
            timeEnd: null,
        });

        return new TimeSpan_Mark(this, this._marks.length - 1);
    }

}
TimeSpan.Instances = {};

class TimeSpan_Mark
{
    
    constructor(instance, index) {
        this._instance = instance;
        this._index = index;
    }

    end() {
        this._instance._marks[this._index].timeEnd = (new Date()).getTime();
    }

}

module.exports = TimeSpan;





 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\js0\List.js
jsLibs.exportModule('js0', 'List', (require, module, exports) => { 'use strict';

const js0 = require('.');


class List
{

    get size() {
        return this._values.length;
    }


    constructor(iterable = null) {
        js0.args(arguments, [ js0.Iterable, js0.Default ]);

        this._keys = [];
        this._values = [];

        if (iterable !== null) {
            for (let item of iterable) {
                if (item instanceof Array) {
                    if (item.length === 2) {
                        this.set(item[0], item[1]);
                        continue;
                    }
                }

                this.add(item);
            }
        }
    }

    [Symbol.iterator]() {
        return new List.Iterator(this);
    }

    add(...values) {
        let index = 0;
        for (let value of values) {
            while(this._keys.includes(index))
                index++;

            this.set(index, value);
        }
    }

    addAll(values) {
        js0.args(arguments, js0.Iterable);

        let index = 0;
        for (let value of values) {
            while(this._keys.includes(index))
                index++;

            this.set(index, value);
        }
    }

    addAt(index, key, value) {
        if (index < 0 || index > this._values.length)
            throw new Error(`Index \`${index}\` does not exist in \`List\`.`);

        if (this._values.length === index) {
            this._keys.push(key);
            this._values.push(value);
        } else {
            this._keys.splice(index, 0, key);
            this._values.splice(index, 0, value);
        }

    }

    delete(key) {
        let index = this._getIndexE(key);
        this.deleteAt(index);
    }

    deleteAt(index) {
        this._keys.splice(index, 1);
        this._values.splice(index, 1);
    }

    get(key) {
        let index = this._getIndexE(key);

        return this._values[index];
    }

    getAt(index) {
        if (index < 0 || index >= this._values.length)
            throw new Error(`Index \`${index}\` does not exist in \`List\`.`);

        return this._values[index];
    }

    getKeyAt(index) {
        if (index < 0 || index >= this._values.length)
            throw new Error(`Index \`${index}\` does not exist in \`List\`.`);

        return this._keys[index];
    }

    getKeys() {
        return this._keys.slice();
    }

    getValues() {
        return this._values.slice();
    }

    has(key) {
        return this._keys.includes(key);
    }

    includes(value) {
        return this._values.includes(value);
    }

    indexOf(value) {
        return this._values.indexOf(value);
    }

    keys() {
        return this._keys.slice();
    }

    remove(value) {
        for (let i = this.size - 1; i >= 0; i--) {
            if (this.getAt(i) === value) {
                this.deleteAt(i);
                return;
            }
        }     

        throw new Error(`Value '${value}' does not exist in List.`);
    }

    set(key, value) {
        let index = this._keys.indexOf(key);
        if (index === -1)
            index = this._values.length;

        this.setAt(index, key, value);
    }

    setAt(index, key, value) {
        if (index < 0 || index > this._values.length)
            throw new Error(`Index \`${index}\` does not exist in \`List\`.`);

        if (index === this._values.length) {
            this._keys.push(key);
            this._values.push(value);
        } else {
            this._keys[index] = key;
            this._values[index] = value;
        }
    }

    slice() {

    }

    sort(compareFn) {
        let newKeys = this._keys.slice();
        newKeys.sort((aKey, bKey) => {
            return compareFn({ key: aKey, value: this.get(aKey) },
                    { key: bKey, value: this.get(bKey) });
        });

        let newValues = [];
        for (let i = 0; i < this.size; i++)
            newValues.push(this.get(newKeys[i]));

        this._keys = newKeys;
        this._values = newValues;
    }

    values() {
        return this._values.slice();
    }


    _getIndexE(key) {
        let index = this._keys.indexOf(key);
        if (index === -1)
            throw new Error(`Key \`${key}\` does not exist in \`List\`.`);

        return index;
    }

}
module.exports = List;


Object.defineProperties(List, {

    Iterator: { value:
    class List_Iterator {

        constructor(list)
        {
            this._list = list;
            this._iterator = list._keys[Symbol.iterator]();
        }

        next()
        {
            let keyItem = this._iterator.next();

            if (keyItem.done)
                return { value: undefined, done: true, };

            return {
                value: [ keyItem.value, this._list.get(keyItem.value), ],
                done: false,
            };
        }

    }},

});






 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\js0\index.js
jsLibs.exportModule('js0', 'index', (require, module, exports) => { 'use strict';


class js0_Class
{

    get List() {
        return require('./List');
    }

    get TimeSpan() {
        return require('./TimeSpan');
    }


    constructor() {
        
    }

    args(args, ...types) {
        if (types[types.length - 1] === this.ExtraArgs) 
            types.pop();
        else {
            if (args.length > types.length) {
                console.warn(new Error());
                throw new Error('Too many arguments in function.');
            }
        }

        for (let i = 0; i < types.length; i++) {
            try {
                let errors = [];
                if (!this.type(args[i], types[i], errors, true)) {
                    console.error(`Error: Argument ${i} -> `, errors);
                    console.warn(new Error());
                    throw new this.TypeError('Wrong argument type.');
                }
            } catch (e) {
                throw new Error(`Error thrown for argument ${i} -> ` + 
                        e.message);
            }
        }
    }

    argsC(args, ...types) {
        for (let i = 0; i < types.length; i++) {
            if (!this.type(args[i], types[i]))
                return false;
        }

        return true;
    }

    assert(value, message = '') {
        if (!value) {
            console.warn(new Error());
            throw new this.AssertionError(message);
        }
    }

    copyArray(arr) {
        this.args(arguments, Array);

        let valueTypes = [
            'undefined',
            'boolean',
            'number',
            'string',
        ];

        let arr_New = new Array();
        for (let val of arr) {
            // if (this.type(val, valueTypes)) {
            //     arr_New.push(val);
            //     continue;
            // }

            if (this.type(val, js0.Null)) {
                arr.push(null);
                continue;
            }

            if (this.type(val, this.RawObject)) {
                arr_New.push(this.copyRawObject(val));
                continue;
            }

            if (this.type(val, Array)) {
                arr_New.push(this.copyArray(val));
                continue;
            }

            arr_New.push(val);
        }

        return arr_New;
    }

    copyRawObject(obj) {
        this.args(arguments, js0.RawObject);

        // let valueTypes = [
        //     'undefined',
        //     'boolean',
        //     'number',
        //     'string',
        // ];

        let obj_New = {};
        for (let prop in obj) {
            // if (this.type(obj[prop], valueTypes)) {
            //     obj_New[prop] = obj;
            //     continue;
            // }
            if (this.type(obj[prop], js0.Null)) {
                obj_New[prop] = null;
                continue;
            }

            if (this.type(obj[prop], js0.RawObject)) {
                obj_New[prop] = this.copyRawObject(obj[prop]);
                continue;
            }

            if (this.type(obj[prop], Array)) {
                obj_New[prop] = this.copyArray(obj[prop]);
                continue;
            }

            obj_New[prop] = obj[prop];
        }

        return obj_New;
    }

    def(object, propertyInfos) {
        js0.args(arguments, 'object', js0.ObjectItems(
            js0.ArrayItems([ null, null ]),
        ));

        for (let propertyName in propertyInfos) {
            let propertyInfo = propertyInfos[propertyName];

            let propertyType = propertyInfo[0];
            let propertyValue = propertyInfo[1];

            this.typeE(propertyValue, propertyType);
            
            Object.defineProperty(object, propertyName, {
                get() {
                    return propertyValue;
                },
                set(value) {
                    js0.typeE(value, propertyType);
                    propertyValue = value;
                },
            });
        }
    }

    // implement(mainObject, propClass, ...propArgs)
    // {
    //     this.prop(mainObject, propClass, ...propArgs);
    // }

    // implements(object, propClass)
    // {
    //     return this.type(object, this.Prop(propClass));
    // }

    prop(mainObject, propClass, ...propArgs) {
        this.args(arguments, 'object', 'function', js0.ExtraArgs);

        if (!('Property' in propClass)) {
            console.warn(new Error());
            throw new Error(`\`${propClass}\` is not a \`Property\` ` +
                    `(no \`Property\` in object prototype).`);
        }
        if (typeof propClass.Property !== 'string') {
            console.warn(new Error());
            throw new Error(`\`${propClass}\` is not a \`Property\` ` +
                    `(\`Property\` is not a string).`);
        }

        propArgs.splice(0, 0, null);
        let prop = new (Function.prototype.bind.apply(propClass, propArgs))();
        Object.defineProperty(mainObject, propClass.Property, {
            get: () => { return prop; },
        });
    }

    implements(mainObject, ...interfaceClasses) {

    }

    rtn(valueType, value = this.NotSet) {
        if (value === this.NotSet) {
            return (value) => {
                this.typeE(value, valueType);
                return value;
            };
        }

        this.typeE(value, valueType);
        return value;
    }

    type(value, valueType, errors = [], args = false) {
        if (valueType === null) {
            if (typeof value === 'undefined') {
                errors.push('Arg not set.');
                return false;
            }

            return true;
        }

        let typeofValue = typeof value;

        /* Special Types */
        // if (valueType === this.ArrayItems) {
        //     if (value === null || typeof value !== 'object') {                
        //         errors.push(`\`${value}\` is not an instance of \`Array\`.`);
        //         return false;
        //     }

        //     if (!(value instanceof Array)) {
        //         errors.push(`\`${value}\` is not an instance of \`Array\`.`);
        //         return false;
        //     }

        //     return true;
        if (valueType === this.Default) {
            if (typeof value === 'undefined')
                return true;

            return false;
        } else if (valueType === this.Int) {
            return this.type(value, 'int', errors);
        } else if (valueType === this.Iterable) {
            if (value === null || typeof value !== 'object') {                
                errors.push(`\`${value}\` is not \`Iterable\`.`);
                return false;
            }

            if (typeof value[Symbol.iterator] !== 'function') {
                errors.push(`\`${value}\` is not \`Iterable\`.`);
                return false;
            }

            return true;
        } else if (valueType === this.Long) {
            return this.type(value, 'bigint', errors);
        } else if (valueType === this.Object) {
            return this.type(value, 'object', errors);
        } else if (valueType === this.RawObject) {
            if (value === null)
                return true;

            if (typeofValue === 'undefined') {
                errors.push(`'${value}' is not an RawObject.`);
                return false;
            }

            // if (!(typeof value !== 'object')) {
            //     console.log(typeof value);
            //     errors.push(`'${value}' is not an RawObject.`);
            //     return false;
            // }

            if (Object.getPrototypeOf(value) !== Object.prototype) {
                errors.push(`'${value}' is not an RawObject.`);
                return false;
            }

            return true;
        } else if (valueType === this.NotNull) {
            if (value === null) {
                errors.push(`\`${value}\` cannot be \`null\`.`);
                return false;
            }

            return true;
        } else if (valueType === this.Null) {
            if (value === null)
                return true;

            return false;
        } else if (valueType instanceof this.ArrayItems_Type) {
            if (!this.type(value, Array)) {
                errors.push(`Value must be an instance of Array. Found: ${typeofValue}.`);
                return false;
            }

            let valid = true;
            let i = 0;
            for (let itemValue of value) {
                let itemErrors = [];
                if (!this.type(itemValue, valueType.itemType, itemErrors)) {
                    let itemKey = value.keys()[i];
                    valid = false;
                    errors.push(`Item '${i}' errors: ` + itemErrors.join(', '));
                }
                i++;
            }

            return valid;
        } else if (valueType instanceof this.Enum_Type) {
            for (let value_Enum of valueType.values) {
                if (value === value_Enum)
                    return true;
            }

            errors.push(`Enum value '${value}' not found in '` + 
                    valueType.values.join(', ') + `'.`);
            return false;
        } else if (valueType instanceof this.Default_Type) {
            return false;
        } else if (valueType instanceof this.Iterable_Type) {
            if (!this.type(value, this.Iterable)) {
                errors.push(`Preset must be Iterable. Found: ${typeofValue}.`);
                return false;
            }

            let valid = true;
            for (let i = 0; i < value.length; i++) {
                let itemValue = value[i];
                let itemErrors = [];
                if (!this.type(itemValue, valueType.itemType, itemErrors)) {
                    valid = false;
                    errors.push(`Item '${i}' errors: ` + itemErrors.join(', '));
                }
            }

            return valid;
        } else if (valueType instanceof this.ObjectItems_Type) {
            if (!this.type(value, this.RawObject)) {
                errors.push(`Value must be an instance of RawObject. Found: ${typeofValue}.`);
                return false;
            }

            let valid = true;
            for (let itemKey in value) {
                let itemValue = value[itemKey];
                let itemErrors = [];
                if (!this.type(itemValue, valueType.itemType, itemErrors)) {
                    valid = false;
                    errors.push(`Item '${itemKey}' errors: ` + itemErrors.join(', '));
                }
            }

            return valid;
        } else if (valueType instanceof this.Preset_Type) {
            if (args) {
                console.warn(new Error());
                throw new Error('Preset type cannot be used in function arguments.');
            }

            if (typeofValue === 'undefined' && typeof 
                    valueType.defaultValue !== 'undefined') {
                value = valueType.defaultValue;
                typeofValue = typeof value;
            }

            if (value === null) {
                errors.push(`Preset cannot be null.`);
                return false;
            }

            if (typeofValue !== 'object') {
                errors.push(`Preset must be an object. Found: ${typeofValue}.`);
                return false;
            }

            let valid = true;

            for (let key in value) {
                if (!(key in valueType.presets)) {
                    errors.push(`Unknown key \`${key}\`.`);
                    valid = false;
                }
            }

            for (let key in valueType.presets) {
                let newErrors = [];
                
                if (typeof value[key] === 'undefined') {
                    if (valueType.presets[key] instanceof Array) {
                        for (let propValueType of valueType.presets[key]) {
                            if (propValueType instanceof this.Default_Type)
                                value[key] = propValueType.defaultValue;
                        }
                    }
                } 

                if (this.type(value[key], valueType.presets[key], newErrors))
                    continue;

                for (let newError of newErrors)
                    errors.push(`${key} -> ${newError}`);

                valid = false;
            }

            // console.log('WTF', value, valid, errors);

            return valid;
        } else if (valueType instanceof this.PresetArray_Type) {
            if (typeofValue === 'undefined' && typeof 
                    valueType.defaultValue !== 'undefined') {
                value = valueType.defaultValue;
                typeofValue = typeof value;
            }

            if (value === null) {
                errors.push(`Preset cannot be null.`);
                return false;
            }

            if (!(value instanceof Array)) {
                errors.push(`PresetArray must be an array. Found: ${typeofValue}.`);
                return false;
            }

            let valid = true;
            
            if (value.length !== valueType.presets.length) {
                errors.push(`Wrong PresetArray length. Required: '${valueType.presets.length}'.`);
                    valid = false;
            }

            for (let i = 0; i < valueType.presets.length; i++) {
                let newErrors = [];
                
                if (typeof value[i] === 'undefined') {
                    if (valueType.presets[i] instanceof Array) {
                        for (let propValueType of valueType.presets[i]) {
                            if (propValueType instanceof this.Default_Type)
                                value[i] = propValueType.defaultValue;
                        }
                    }
                } 

                if (this.type(value[i], valueType.presets[i], newErrors))
                    continue;

                for (let newError of newErrors)
                    errors.push(`${i} -> ${newError}`);

                valid = false;
            }

            return valid;
        } else if (valueType instanceof this.Prop_Type) {
            let propClass = valueType._propClass;
            if (typeof value !== 'object') {
                errors.push(`\`${value}\` does not implement \`${propClass}\` ` +
                        ` (not an object).`);
                return false;
            }

            if (!(propClass.Property in value)) {
                errors.push(`\`${value}\` does not implement \`${propClass}\` ` +
                        ` (property not in object).`);
                return false;
            }

            if (!(value[propClass.Property] instanceof propClass)) {
                errors.push(`\`${value}\` does not implement \`${propClass}\`. ` +
                        ` (wrong property type).`);
                return false;
            }

            return true;
        } else if (valueType === this.PropClass) {
            if (typeof value !== 'function') {
                errors.push(`\`${value}\` is not a \`Property\`.`);
                return false;
            }

            if (!('Property' in value)) {
                errors.push(`\`${value}\` is not a \`Property\`.`);
                return false;
            }

            return true;
        }
        //  else if (valueType instanceof this.Object_Type) {
        //     if (!this.type(value, this.Object)) {
        //         errors.push(`Preset must be an Object. Found: ${typeofValue}.`);
        //         return false;
        //     }

        //     let valid = true;
        //     for (let itemKey in value) {
        //         let itemErrors = [];
        //         if (!this.type(value[itemKey], valueType.itemType, itemErrors)) {
        //             valid = false;
        //             errors.push(`Item '${itemKey}' errors: ` + itemErrors.join(', '));
        //         }
        //     }

        //     return valid;
        // } else if (valueType instanceof this.RawObject_Type) {
        //     if (!this.type(value, this.RawObject)) {
        //         errors.push(`Preset must be a RawObject. Found: ${typeofValue}.`);
        //         return false;
        //     }

        //     let valid = true;
        //     for (let itemKey in value) {
        //         let itemErrors = [];
        //         if (!this.type(value[itemKey], valueType.itemType, itemErrors)) {
        //             valid = false;
        //             errors.push(`Item '${itemKey}' errors: ` + itemErrors.join(', '));
        //         }
        //     }

        //     return valid;
        // }
        /* / Special Types */

        let typeofValueType = typeof valueType;

        /* Basic Types */
        if (typeofValueType === 'string') {
            let result = true;
            if (this.Types_Basic.has(valueType)) {
                result = typeof value === valueType;
            } else if (this.Types_Extended.has(valueType)) {
                switch(valueType) {
                    case 'bool':
                        result = typeofValueType === 'boolean';
                    case 'int':
                        result = Number.isInteger(value);
                        break;
                    case 'finite':
                        result = Number.isFinite(value);
                        break;
                    case 'nan':
                        result = Number.isNaN(value);
                        break;
                }
            } else {
                errors.push(`Unknown type '${valueType}'.`);
                return false;
            }

            if (!result) {
                let typeof_value = typeof value;
                let value_Str = String(value);
                errors.push(`Variable \`${value_Str}\` of type \`${typeof_value}\`` +
                    ` should be of type \`${valueType}\`.`);
                return false;
            }

            return true;
        }

        if (typeofValueType === 'object') {
            /* Multiple Types */
            if (valueType instanceof Array) {
                if (value === null) {
                    for (let i = 0; i < valueType.length; i++) {
                        if (valueType[i] === this.NotNull) {
                            errors.push(`\`${value}\` cannot be \`null\`.`);
                            return false;
                        }
                    }
                }

                for (let i = 0; i < valueType.length; i++) {
                    if (this.type(value, valueType[i], errors))
                        return true;
                }

                return false;
            }

            console.warn(new Error());
            console.warn('Value type: ', valueType);
            throw new Error(`Unknown 'valueType': ${typeofValueType}`);
        }

        if (typeofValueType === 'function') {
            // /* Property */
            // if ('Property' in valueType) {
            //     if (!this.implements(value, valueType)) {
            //
            //         errors.push(`Variable does not implement property
            //                 \`${valueType.constructor}\`.`);
            //         return false;
            //     }
            //
            //     return true;
            // }

            /* Class */
            if (!(value instanceof valueType)) {
                let valueStr = String(value);
                errors.push(`Variable \`${valueStr}\` is not an instance of` +
                        ` \`${valueType.name}\`.`);
                return false;
            }

            return true;
        }

        if (typeofValueType === 'symbol') {
            if (value !== valueType) {
                let value_Str = String(value);
                let valueType_Str = String(valueType);
                errors.push(`Variable '${value_Str}' is not ${valueType_Str}.`);
                return false;
            }

            return true;
        }

        console.warn(new Error());
        throw new Error(`Unknown 'valueType': ${typeofValueType}`);
    }

    typeE(value, valueType) {
        let errors = [];
        if (this.type(value, valueType, errors))
            return;

        console.error('Error:', errors);
        console.warn(new Error());
        throw new this.TypeError('Wrong variable type.');
    }

    virtual(object = null) {
        if (object === null) {
            console.warn(new Error());
            throw new this.NotImplementedError();
        }

        console.warn(new Error());
        throw new this.NotImplementedError(`Method not implemented in:` +
                ` \`${object.constructor.name}\`.`);
    }

}
const js0 = js0_Class.prototype;

Object.defineProperties(js0_Class.prototype, {

    /* Errors */
    AssertionError: { value:
    class js0_AssertionError extends Error {
        constructor(...args)
        {
            super(...args);
        }

    }},

    NotImplementedError: { value:
    class js0_NotImplementedError extends Error {

        constructor(...args)
        {
            super(...args);
        }

    }},


    TypeError: { value:
    class js0_TypeError extends Error {

        constructor(...args)
        {
            super(...args);

            // let stack = this.stack;
            // let stack_array = stack.split('\n');
            // stack_array.splice(1, 3);
            // this.stack = stack_array.join('\n');
        }

    }},
    /* / Errors */

    /* Types */
    Types_Basic: { value:
    new Set([
        'undefined',
        // 'object', /* null */
        'boolean',
        'number',
        'string',
        'symbol',
        'function',
        'object'
    ])},

    Types_Extended: { value:
    new Set([
        'bigint',
        'bool',
        'finite',
        'int',
        'nan'
    ])},

    /* Types Special */
    ArrayItems: { value: (itemType) => {
        return new js0.ArrayItems_Type(itemType);
    }},
    Default: { value: (defaultValue) => {
        return new js0.Default_Type(defaultValue);
    }},
    Enum: { value: (values) => {
        return new js0.Enum_Type(values);
    }},
    ExtraArgs: { value: Symbol('js0_ExtraArgs'), },
    Int: { value: Symbol('js0_Int'), },
    Iterable: { value: (itemType) => {
        return new js0.Iterable_Type(itemType);
    }},
    Long: { value: Symbol('js0_Long'), },
    NotNull: { value: Symbol('js0_NotNull'), },
    NotSet: { value: Symbol('js0_NotSet'), },
    Null: { value: Symbol('js0_Null'), },
    Preset: { value: (presets) => {
        return new js0.Preset_Type(presets);
    }},
    PresetArray: { value: (presets) => {
        return new js0.PresetArray_Type(presets);
    }},
    Prop: { value: (property) => {
        return new js0.Prop_Type(property);
    }},
    PropClass: { value: Symbol('js0_PropClass'), },
    Object: { value: Symbol('js0_Object'), },
    ObjectItems: { value: (itemType) => {
        return new js0.ObjectItems_Type(itemType);
    }},
    RawObject: { value: Symbol('js0_RawObject'), },

    And_Type: { value:
    class js0_And_Type  {
        constructor(valueTypes)
        {
            js0.args(arguments, js0.PropClass);

            Object.defineProperties(this, {
                _valueTypes: { value: valueTypes, },
            });
        }

    }},

    ArrayItems_Type: { value:
    class js0_ArrayItems_Type {

        constructor(itemType)
        {
            this.itemType = itemType;
        }

    }},

    Default_Type: { value:
    class js0_Default_Type {

        constructor(defaultValue = undefined)
        {
            this.defaultValue = defaultValue;
        }

    }},

    Enum_Type: { value:
        class js0_Enum_Type {
    
            constructor(values = [])
            {
                if (!(values instanceof Array)) {
                    console.warn(new Error());
                    throw new Error(`'js0.Enum' values must be an Array.`);
                }

                this.values = values;
            }
    
        }},

    Iterable_Type: { value:
    class js0_Iterable_Type {

        constructor(itemType)
        {
            this.itemType = itemType;
        }

    }},

    ObjectItems_Type: { value:
    class js0_ObjectItems_Type {

        constructor(itemType)
        {
            this.itemType = itemType;
        }

    }},

    // Or_Type: { value:
    // class js0_Or_Type
    // {
    //     constructor(propClass)
    //     {
    //         js0.argsE(arguments, js0.PropClass);
    //
    //         Object.defineProperties(this, {
    //             _propClass: { value: propClass, },
    //         });
    //     }
    // }},

    Preset_Type: { value:
    class js0_Preset_Type {
        
        constructor(presets)
        {
            js0.args(arguments, js0.RawObject);

            this.presets = presets;
            // this.defaultValue = defaultValue;
        }

    }},

    PresetArray_Type: { value:
    class js0_PresetArray_Type {
        
        constructor(presets)
        {
            js0.args(arguments, Array);

            this.presets = presets;
        }

    }},

    Prop_Type: { value:
    class js0_Prop_Type {

        constructor(propClass)
        {
            js0.args(arguments, js0.PropClass);

            Object.defineProperties(this, {
                _propClass: { value: propClass, },
            });
        }

    }},

    // Object_Type: { value:
    // class js0_Object_Type {

    //     constructor(itemType)
    //     {
    //         this.itemType = itemType;
    //     }

    // }},

    // RawObject_Type: { value:
    // class js0_RawObject_Type {

    //     constructor(itemType)
    //     {
    //         this.itemType = itemType;
    //     }

    // }},
    /* / Types */

});


module.exports = new js0_Class();






 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\ab-text\index.js
jsLibs.exportModule('ab-text', 'index', (require, module, exports) => { 'use strict'

const
    js0 = require('js0')
;

class abText_Class
{

    constructor() {
        this._texts = {};
        this._langAlias = null;
    }

    $(text, args = null) {
        js0.args(arguments, 'string', [ js0.Null, js0.RawObject, 
                js0.Default ]);

        if (this._langAlias === null) {
            console.warn('Lang alias not set.');
            return this.get(this._langAlias, text, args);
        }

        return this.get(this._langAlias, text, args);
    }

    add(langPrefix, texts) {
        js0.args(arguments, 'string', js0.RawObject);

        let langPrefix_Arr = langPrefix.split('.');
        let langAlias = langPrefix_Arr[0];
        let textPrefix_Arr = langPrefix_Arr.slice(1);
        let textPrefix = textPrefix_Arr.join('.');
        if (textPrefix !== '') {
            textPrefix += '.';
        }

        if (!(langAlias in this._texts)) {
            this._texts[langAlias] = {};
        }

        for (let text in texts) {
            this._texts[langAlias][textPrefix + text] = texts[text];
        }

        return this;
    }

    get(langAlias, text, args = null) {
        js0.args(arguments, [ js0.Null, 'string' ], 'string', [ js0.Null, 
                js0.RawObject, js0.Default ]);

        let translation = null;

        if (langAlias in this._texts) {
            if (text in this._texts[langAlias])
                translation = this._texts[langAlias][text];
        }

        if (translation === null) {
            if (args === null) {
                return `#${text}#`;
            } else if (Object.keys(args).length === 0) {
                return `#${text}#`;
            } else {
                let args_Arr = [];
                for (let argName in args) {
                    args_Arr.push(`${argName} => ${args[argName]}`);
                }
                return '#' + text + '(' + args_Arr.join(', ') + ')';
            }
        }

        for (let argName in args) {
            translation = translation.replace(new RegExp(`{${argName}}`, 'gm'), 
                    args[argName]);
        }

        return translation;
    }

    setLang(langAlias) {
        this._langAlias = langAlias;
    }

}
module.exports = new abText_Class();





 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\ab-strings\index.js
jsLibs.exportModule('ab-strings', 'index', (require, module, exports) => { 'use strict';

const
    js0 = require('js0')
;

class abStrings_Class
{

    escapeHtml(html) {
        return html
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/"/g, "&quot;")
            .replace(/'/g, "&#039;");
    }

    escapeLangChars(string) {
        let replaceFrom = [ 'ą', 'ć', 'ę', 'ł', 'ń', 'ó', 'ś', 'ź', 'ż',
                'Ą', 'Ć', 'Ę', 'Ł', 'Ń', 'Ó', 'Ś', 'Ź', 'Ż' ];
        let replaceTo = [ 'a', 'c', 'e', 'l', 'n', 'o', 's', 'z', 'z',
                'A', 'C', 'E', 'L', 'N', 'O', 'S', 'Z', 'Z' ];
    
        let regexp = new RegExp(replaceFrom.join('|'), 'g');
    
        return string.replace(regexp, (match) => {
            return replaceTo[replaceFrom.indexOf(match)];
        });
    }
    
    escapeToAllowedChars(string, allowedCharacters) {
        let regexp = new RegExp(`[^${allowedCharacters}]`, 'g');

        return string.replace(regexp, '');
    }

    escapeRegExpChars(string) {
        return string.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
    }

    getCharsRegExp(types = [], extra = '', langs = null) {
        for (let type of types) {
            if (!types.includes(type))
                throw new Error(`Unknown chars type '${type}'.`);
        }

        let chars = '';

        if (types.includes('digits'))
            chars += '0-9';
        if (types.includes('letters'))
            chars += 'a-zA-Z' + this.getLangsSpecialCharacters();
        if (types.includes('special')) {
            chars += ' `!@#%&_=/<>:;",\'' +
                '\\\\' + '\\^' + '\\$' + '\\.' + '\\[' + '\\]' + '\\|' +
                '\\(' + '\\)' + '\\?' + '\\*' + '\\+' + '\\{' + '\\}' +
                '\\-';
        }

        return chars + this.escapeRegExpChars(extra);
    }

    getCharsRegExp_Basic(extra = '') {
        return this.getCharsRegExp([ 'digits', 'letters', 'special' ], extra);
    }

    getLangsSpecialCharacters(langs = null) {
        if (langs === null)
            langs = [ 'pl' ];

        let chars = '';
        if (langs.includes('pl'))
            chars += 'ąćęłńóśźż' + 'ĄĆĘŁŃÓŚŹŻ';

        return chars;
    }

    pad(str, pad, size) {
        js0.args(arguments, 'string', 'string', js0.Int);

        str = str + ``;
        while (str.length < size) 
            str = pad + str;
        return str.substr(0, size);
    }
    
    removeDoubles(string, char) {
        let regexp = new RegExp(`${char}${char}`, 'g');
        while (string.match(regexp))
            string = string.replace(regexp, char);

        return string;
    }

}
module.exports = new abStrings_Class();





 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\ab-lock\index.js
jsLibs.exportModule('ab-lock', 'index', (require, module, exports) => { 'use strict';

const
    js0 = require('js0'),

    Lock = require('./Lock')
;

class abLock_Class
{

    constructor() {
        this._lock = new Lock();
    }

    async sync(obj, fn) {
        js0.args(arguments, null, 'function');

        await this._lock.sync(obj, fn);
    }

}
module.exports = new abLock_Class();





 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\ab-lock\Lock.js
jsLibs.exportModule('ab-lock', 'Lock', (require, module, exports) => { 'use strict';

const 
    js0 = require('js0')
;

class Lock
{

    constructor() {
        this._queue = [];
    }

    async sync(obj, fn) {
        js0.args(arguments, null, 'function');

        let subqueue = this._getSubqueue(obj);
        if (subqueue === null)
            subqueue = this._createQueue(obj);

        subqueue.push(fn);
        
        if (subqueue.length === 1)
            await this._executeNextFn(obj);
    }


    _createQueue(obj) {
        let subqueue = [];
        this._queue.push([ obj, subqueue ]);

        return subqueue;
    }

    _getSubqueue(obj) {
        for (let subqueue of this._queue) {
            if (subqueue[0] === obj)
                return subqueue[1];
        }

        return null;
    }

    async _executeNextFn(obj) {
        let subqueue = this._getSubqueue(obj);
        if (subqueue.length === 0)
            return;

        let fn = subqueue[0];
        subqueue.shift();

        await fn();
        this._executeNextFn(obj);
    }

}
module.exports = Lock;





 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\web\website_tmp\ab-web\web\js-libs\ab-cookies\index.js
jsLibs.exportModule('ab-cookies', 'index', (require, module, exports) => { 'use strict';

const
    js0 = require('js0')
;

class abCookies_Class
{

    delete(name)
    {

    }

    exists(name)
    {
        return this.getString(name) !== null;
    }

    get(name, defaultValue = undefined)
    {   
        let cookieStr = this.getString(name);
        if (cookieStr === null) {
            if (typeof defaultValue !== undefined)
                return defaultValue;

            throw new Error(`Cookie '${name}' does not exist.`)
        }
        try {
            let cookieJSON = JSON.parse(decodeURIComponent(cookieStr));

            return cookieJSON.value;
        } catch (err) {
            console.error(err);
            throw new Error('AB Cookie not properly formatted.');
        }
    }

    getString(name)
    {
        var cookieName = name + "=";
        var cookieStrsArr = document.cookie.split(';');
        for (let cookieStr of cookieStrsArr) {
            while (cookieStr.charAt(0) === ' ')
                cookieStr = cookieStr.substring(1);
            if (cookieStr.indexOf(name) !== 0)
                continue;

            return cookieStr.substring(name.length + 1, cookieStr.length);
        }

        return null;
    }

    set(name, value, settings = {})
    {
        js0.args(arguments, 'string', null, [ js0.RawObject, js0.Default ]);

        js0.typeE(settings, js0.Preset({
            expires: [ 'number', js0.Null, js0.Default(null), ],
            domain: [ 'string', js0.Null, js0.Default(null), ],
            path: [ 'string', js0.Default('/'), ],
        }));

        let cookieStr = '';
        /* Value */
        cookieStr += name + '=' + encodeURIComponent(JSON.stringify({ value: value })) + '; ';
        /* Path */
        cookieStr += `path=` + settings.path + '; ';
        /* Expires */
        if (settings.expires !== null) {
            let expiresTime = Math.round((new Date()).getTime() / 1000) + settings.expires;
            cookieStr += 'expires=' + (new Date(expiresTime * 1000)).toUTCString() + '; ';
        }
        /* Domain */
        if (settings.domain !== null) {
            cookieStr += 'domain=' + settings.domain + '; ';
        }

        document.cookie = cookieStr;
    }

}
const abCookies = new abCookies_Class();



module.exports = abCookies;


 });

// File: C:\SfTd\AllBlue\Clients\MilkyGen\git\mgen_assoc\core\core\js\ab-native_website_rel.js

const abWeb_BuildType = 'rel';

const abNative_Base = '/';
const abNative_Platform = 'web';

const abNative_ApiUri = 'https://e-milkygen.milkygen.pl/';
